/* Life Harbor - pincode water quality data
   Format: "PINCODE":[HARDNESS, TDS, IRON, "AREA"]   (-1 = no reading)
   Source: CGWB / India-WRIS groundwater monitoring, 2015-2024.
   Upload this file to your theme under Assets. Do not rename it. */
window.LHW_DATA = {
"110001":[271,1138,0.22,"New Delhi GPO, New Delhi"],
"110002":[286,1160,0.41,"Indraprastha, Central"],
"110003":[256,1054,0.17,"Lodi Road, South"],
"110004":[278,1107,0.21,"Rashtrapati Bhawan, New Delhi"],
"110005":[268,1126,0.19,"Desh Bandhu Gupta Road, Central"],
"110006":[278,1084,0.27,"Delhi GPO, North"],
"110007":[265,1061,0.23,"Rana Pratap Bagh, North"],
"110008":[260,1150,0.16,"Patel Nagar East, West"],
"110009":[268,1053,0.19,"GTB Nagar, North"],
"110010":[250,1467,0.13,"Aps Colony, New Delhi"],
"110011":[268,1148,0.2,"Nirman Bhawan, New Delhi"],
"110012":[250,1155,0.14,"Inderpuri, West"],
"110013":[260,1084,0.16,"Dargah Sharif, South East"],
"110014":[261,1031,0.16,"Jeevan Nagar, South"],
"110015":[260,1473,0.15,"Ramesh Nagar, West"],
"110016":[260,1215,0.12,"Technology Bhawan, South"],
"110017":[261,1057,0.13,"MMTCSTC Colony, South"],
"110018":[246,1628,0.13,"Chaukhandi, West"],
"110019":[268,917,0.15,"Kalkaji, South"],
"110020":[271,913,0.15,"Tehkhand, South"],
"110021":[248,1176,0.17,"Chanakya Puri, New Delhi"],
"110022":[246,1137,0.16,"R K Puram Sect1, New Delhi"],
"110023":[256,1084,0.16,"Sarojini Nagar, New Delhi"],
"110024":[261,1047,0.16,"Amar Colony, South East"],
"110025":[271,929,0.16,"Jamia Nagar, South East"],
"110026":[250,1442,0.15,"Punjabi Bagh, West"],
"110027":[260,1536,0.13,"Rajouri Market, West"],
"110028":[250,1311,0.15,"Naraina Industrial Estate, New Delhi"],
"110029":[260,1087,0.15,"Safdarjung Enclave, South"],
"110030":[250,1023,0.08,"Gadaipur, South"],
"110031":[271,998,0.28,"Gandhi Nagar Bazar, Shahdara"],
"110032":[278,1039,0.24,"Rohtash Nagar, Shahdara"],
"110033":[273,1358,0.24,"Bhalaswa, North"],
"110034":[244,1563,0.14,"Saraswati Vihar, North West"],
"110035":[250,1370,0.16,"Rampura, North West"],
"110036":[286,1442,0.19,"Hiranki, North"],
"110037":[260,1532,0.1,"Mahipalpur, New Delhi"],
"110038":[250,1459,0.1,"Rajokari, New Delhi"],
"110039":[420,1930,0.17,"Jat Khore, North"],
"110040":[325,1389,0.22,"Lampur, North"],
"110041":[274,2135,0.05,"Nilothi, West"],
"110042":[257,1323,0.15,"Siraspur, North"],
"110043":[323,2634,0.09,"Khaira, West"],
"110044":[271,898,0.13,"Village Tugalkabad, South"],
"110045":[250,1821,0.11,"Dabri, South West"],
"110046":[250,1538,0.12,"Sagarpur, New Delhi"],
"110047":[246,991,0.06,"Mandi, South"],
"110048":[265,963,0.14,"Greater Kailash, South"],
"110049":[260,1077,0.15,"Sahpurjat, South"],
"110051":[278,998,0.23,"Krishna Nagar, Shahdara"],
"110052":[266,1274,0.17,"Ashok Vihar, North"],
"110053":[285,930,0.27,"New Usmanpur, North East"],
"110054":[265,928,0.19,"Civil Lines SO North Delhi, Central"],
"110055":[265,1096,0.22,"SRT NAGAR EXTENSION COUNTER, Central"],
"110056":[255,1652,0.12,"Shakur Basti Depot, North West"],
"110057":[250,1291,0.16,"Vasant Vihar2, New Delhi"],
"110058":[241,1471,0.08,"Janakpuri A 3, West"],
"110059":[250,1920,0.07,"Hastal Village, West"],
"110060":[265,1122,0.18,"Rajender Nagar, Central"],
"110061":[250,2099,0.1,"Shahbad Mohammadpur, New Delhi"],
"110062":[271,1016,0.13,"Dr Ambedkar Nagar SO South Delhi, South"],
"110063":[255,1621,0.12,"Jawala Heri, West"],
"110064":[246,1519,0.12,"Hari Nagar BE Block, West"],
"110065":[271,1013,0.16,"East Of Kailash PhaseI, South East"],
"110066":[256,1128,0.16,"R K Puram West, New Delhi"],
"110067":[250,1111,0.15,"Munirka, New Delhi"],
"110068":[260,1021,0.08,"Maidan Garhi, South"],
"110069":[278,1131,0.22,"Union Public Service Commission, New Delhi"],
"110070":[244,1100,0.09,"Masood Pur, New Delhi"],
"110071":[323,2976,0.12,"Kangan Heri, South West"],
"110072":[220,287,0.0,"Jharoda Kalan, South West"],
"110073":[298,2866,0.14,"Galib Pur, South West"],
"110074":[260,1024,0.07,"BHATI VILLAGE, South"],
"110075":[287,2069,0.09,"Amberhai, South West"],
"110076":[285,936,0.16,"Madanpur Khadar, South"],
"110077":[248,1910,0.1,"Bagdola, New Delhi"],
"110078":[287,2116,0.08,"Kakrola, South West"],
"110080":[260,905,0.14,"Deoli, South"],
"110081":[274,2160,0.05,"Chand Pur, North West"],
"110082":[286,1405,0.13,"Khera Khurd, North"],
"110083":[247,1658,0.07,"Mangolpuri I Block, North West"],
"110084":[287,903,0.16,"Jagatpur, North"],
"110085":[242,1497,0.13,"Rithala, North West"],
"110086":[260,1716,0.07,"Budh Vihar, North West"],
"110087":[244,1697,0.08,"Peeragarhi, West"],
"110088":[255,1289,0.17,"Shalamar, North"],
"110089":[244,1358,0.13,"Rohini Sector 15, North West"],
"110090":[268,927,0.25,"Khajoori Khas, North East"],
"110091":[265,848,0.17,"Kalyanpuri, East"],
"110092":[271,1022,0.22,"Shakarpur, East"],
"110093":[268,916,0.26,"Mandoli Saboli, North East"],
"110094":[268,927,0.25,"Johripur, North East"],
"110095":[265,917,0.22,"Jhilmil, Shahdara"],
"110096":[263,830,0.18,"Ghazipur, East"],
"110097":[250,1583,0.1,"Kapashera, South West"],
"110099":[274,1744,0.06,"ROHINI SECTOR 23, North West"],
"110102":[268,1091,0.21,"NDC ND, New Delhi"],
"110106":[268,1001,0.29,"DELHI GPO NDC, North"],
"110110":[244,1537,0.08,"Nodal Delivery Centre(Parcel) Rohini, North West"],
"110119":[268,919,0.15,"KALKAJI NDC, South East"],
"110124":[261,1040,0.16,"LAJPAT NAGAR NDC, South"],
"110151":[278,969,0.23,"KRISHNA NAGAR NDC, Shahdara"],
"110195":[268,944,0.22,"JHILMIL NDC, Shahdara"],
"121001":[472,1711,0.01,"Faridabad NIT, Faridabad"],
"121002":[384,1641,0.03,"Bhaskola, Faridabad"],
"121003":[350,1200,0.04,"Tilpat, Faridabad"],
"121004":[588,2425,0.0,"Baroli, Faridabad"],
"121005":[412,1595,0.01,"Faridabad Sector 22, Faridabad"],
"121006":[521,1818,0.01,"Faridabad Sector 9, Faridabad"],
"121007":[402,1700,0.02,"Faridabad Sector 15, Faridabad"],
"121008":[393,1615,0.02,"Faridabad Sector 29, Faridabad"],
"121009":[287,894,0.07,"Surajkund Faridabad, Faridabad"],
"121010":[216,694,-1,"Nhpc Colony Faridabad, Faridabad"],
"121012":[393,1615,0.02,"Sector21D, Faridabad"],
"121013":[393,1615,0.02,"Sec91, Faridabad"],
"121014":[363,997,0.0,"Greater Faridabad PO, Faridabad"],
"121015":[536,1962,0.01,"Sector55 PO, Faridabad"],
"121101":[414,1596,0.0,"Bhainsrawali, Faridabad"],
"121102":[472,1431,0.0,"Aharwan, Palwal"],
"121103":[472,1838,0.0,"Kondal, Palwal"],
"121105":[376,1769,0.0,"Dighot, Palwal"],
"121106":[582,1930,0.0,"Banchari, Palwal"],
"121107":[330,1440,0.0,"Tappa Bilochpur, Palwal"],
"121999":[393,1615,0.02,"Faridabad Sector 29, Faridabad"],
"122001":[248,1758,0.05,"Gurgaon, Gurugram"],
"122002":[251,1312,0.06,"DLF QE, Gurugram"],
"122003":[226,1240,0.04,"Gwal Pahari, Gurugram"],
"122004":[270,1817,0.06,"Sikohpur, Gurugram"],
"122005":[248,1640,0.1,"Air Force, Gurugram"],
"122006":[298,2359,0.06,"Gurgaon Village, Gurugram"],
"122007":[287,1686,0.05,"Industrial Estate SO Gurgaon, Gurugram"],
"122008":[287,1686,0.05,"DLF PhII, Gurugram"],
"122009":[272,1089,0.0,"Galleria DLFIV, Gurugram"],
"122010":[251,1312,0.06,"DLF PhIII, Gurugram"],
"122011":[287,1686,0.05,"Gurgaon Sector 56, Gurugram"],
"122012":[270,1817,0.06,"Vatika India Sec 82, Gurugram"],
"122015":[251,1730,0.08,"Palam Road, Gurugram"],
"122016":[246,1500,0.1,"Industrial Complex Dundahera, Gurugram"],
"122017":[287,1686,0.05,"Palam Vihar SO Gurgaon, Gurugram"],
"122018":[287,1686,0.05,"D Block South City II Gurgaon, Gurugram"],
"122051":[196,695,0.0,"Kasan, Gurugram"],
"122052":[201,726,0.0,"IMT Manesar, Gurugram"],
"122098":[185,1035,0.02,"CRPF Kadarpur, Gurugram"],
"122101":[185,1035,0.02,"Kadarpur, Gurugram"],
"122102":[243,868,0.0,"Raisina, Gurugram"],
"122103":[412,1177,0.0,"Chapera, Nuh"],
"122104":[408,1597,0.35,"Agon, Nuh"],
"122105":[270,949,0.0,"Baghanki, Nuh"],
"122107":[470,1889,0.07,"Ferozepur Namak, Nuh"],
"122108":[856,1481,0.1,"Mandikhera, Nuh"],
"122413":[199,376,-1,"Moklawas, Gurugram"],
"122414":[250,973,0.0,"Inchhapuri, Gurugram"],
"122502":[353,1429,0.0,"Jasat, Gurugram"],
"122503":[262,882,0.0,"Jamalpur, Gurugram"],
"122504":[249,1512,0.08,"Noorgarh, Gurugram"],
"122505":[270,1445,0.04,"Bhangrola, Gurugram"],
"122506":[270,1887,0.05,"Sultanpur, Gurugram"],
"122508":[800,1952,0.02,"Pingwan, Nuh"],
"122998":[251,1313,0.06,"DLF QE, Gurugram"],
"122999":[246,1499,0.1,"Industrial Complex Dundahera, Gurugram"],
"123001":[242,2384,0.24,"Narnaul, Mahendragarh"],
"123021":[248,1045,0.17,"Bhocharia, Mahendragarh"],
"123023":[391,1315,0.18,"Nangal Dargu, Mahendragarh"],
"123024":[390,1674,0.08,"Barda, Mahendragarh"],
"123027":[292,985,0.01,"Nautana, Mahendragarh"],
"123028":[290,1191,0.0,"Daroli Ahir, Mahendragarh"],
"123029":[228,1229,0.0,"Khatod, Mahendragarh"],
"123031":[228,1294,0.0,"Central University Haryana Mohindergarh, Mahendragarh"],
"123034":[222,1008,0.0,"Jhagroli, Mahendragarh"],
"123035":[530,1674,0.01,"Guraora, Rewari"],
"123101":[280,490,0.05,"Basbatori, Rewari"],
"123102":[233,572,0.0,"Gothra, Rewari"],
"123103":[233,563,0.0,"Dhawana, Rewari"],
"123106":[270,929,0.07,"Kharkhara, Rewari"],
"123110":[280,610,-1,"Industrial Area Dharuhera, Rewari"],
"123301":[310,1764,0.0,"Rattanthal, Rewari"],
"123302":[332,1562,0.01,"Bhakli, Rewari"],
"123303":[355,1318,0.01,"Lilodh, Rewari"],
"123304":[310,1193,0.0,"Lookhi, Rewari"],
"123401":[232,677,0.07,"Boria Kamalpur, Rewari"],
"123411":[182,644,0.0,"Baldhan Kalan, Rewari"],
"123412":[432,1148,0.0,"Badhrana, Rewari"],
"123501":[394,1081,0.09,"Baghthala, Rewari"],
"124001":[308,857,0.07,"Rohtak, Rohtak"],
"124010":[308,1013,0.34,"Bhali Anandpur, Rohtak"],
"124021":[362,1454,0.02,"Bhambhewa, Jhajjar"],
"124022":[281,1221,0.34,"Basana, Rohtak"],
"124102":[452,2542,0.16,"Madana Kalan, Jhajjar"],
"124103":[380,1090,0.52,"Gurukul Jhajjar, Jhajjar"],
"124104":[329,1005,0.26,"Jahangirpur, Jhajjar"],
"124105":[818,2723,0.18,"Sondhi, Jhajjar"],
"124106":[500,1335,3.37,"Jharli, Jhajjar"],
"124107":[471,1457,0.1,"Dhandlan, Jhajjar"],
"124108":[500,1335,3.37,"Khudan, Jhajjar"],
"124109":[376,1341,0.05,"Bilochpura, Jhajjar"],
"124111":[500,1335,3.37,"Girawar, Rohtak"],
"124112":[469,1409,0.92,"Sisarkhas, Rohtak"],
"124113":[380,994,0.48,"Katesra, Rohtak"],
"124141":[328,921,0.07,"Power Plant Jharli, Jhajjar"],
"124142":[390,1917,0.03,"Khanpur Khurd, Jhajjar"],
"124146":[281,1221,0.34,"Bhurawas, Jhajjar"],
"124201":[460,1263,2.22,"Baghpur, Jhajjar"],
"124202":[469,1374,3.81,"Pilana, Rohtak"],
"124303":[469,1410,3.57,"Ghillaur Kalan, Rohtak"],
"124401":[380,1134,1.92,"Dhamar, Rohtak"],
"124404":[435,2072,0.1,"Samchana, Rohtak"],
"124406":[308,982,1.44,"Morekheri, Rohtak"],
"124411":[362,1454,0.02,"Patwapur, Rohtak"],
"124412":[416,1050,1.6,"Chimni, Jhajjar"],
"124501":[281,1722,0.32,"Atail, Rohtak"],
"124504":[281,1257,0.33,"Chudani, Jhajjar"],
"124505":[396,1719,0.14,"Jakhauda, Jhajjar"],
"124506":[385,2520,0.07,"Tandaheri, Jhajjar"],
"124507":[385,2614,0.08,"Bahadurgarh, Jhajjar"],
"124508":[485,2549,0.09,"Lowa Kalan, Jhajjar"],
"124513":[790,1623,0.08,"Nindana, Rohtak"],
"124514":[500,1335,3.37,"Nandal, Rohtak"],
"124515":[251,733,0.0,"MET Dadri Toe, Rohtak"],
"125001":[552,3232,0.02,"Hisar, Hisar"],
"125004":[382,909,0.01,"Neoli Kalan, Hisar"],
"125005":[420,3065,0.04,"Mirzapur, Hisar"],
"125006":[530,1581,0.05,"Ladwa, Hisar"],
"125007":[603,1468,0.02,"Gawar, Hisar"],
"125011":[606,2349,0.02,"CSF Hisar, Hisar"],
"125033":[485,711,0.04,"Dhanderi, Hisar"],
"125037":[418,770,0.02,"Muzadpur, Hisar"],
"125038":[445,1563,0.03,"Sulchani, Hisar"],
"125039":[330,1142,0.01,"Haibatpur, Hisar"],
"125042":[235,1425,0.27,"Kharbala, Hisar"],
"125044":[420,2104,0.05,"Bhagana, Hisar"],
"125047":[375,730,0.09,"Gorakhpur, Fatehabad"],
"125048":[327,725,0.0,"Khara Kheri, Fatehabad"],
"125049":[606,1862,0.02,"Datta, Hisar"],
"125050":[382,909,0.01,"Dhani Majra, Fatehabad"],
"125051":[357,561,0.01,"Badalgarh, Fatehabad"],
"125052":[240,1100,0.06,"Kohli, Hisar"],
"125053":[282,603,0.02,"Kirdhan, Fatehabad"],
"125054":[245,796,0.05,"Mauju Khera, Sirsa"],
"125055":[446,1350,0.13,"Sirsa, Sirsa"],
"125056":[446,1350,0.13,"JCD Vidyapeeth Sirsa, Sirsa"],
"125058":[300,912,0.05,"Mochiwali, Sirsa"],
"125060":[272,1130,0.18,"PANIHARI, Sirsa"],
"125061":[324,608,0.13,"Nagpur S.O., Hisar"],
"125075":[250,687,0.04,"Dudianwali, Sirsa"],
"125076":[215,864,0.02,"Kharian, Sirsa"],
"125077":[366,979,0.02,"Paniwala Mota, Sirsa"],
"125078":[182,777,0.21,"Nagoki, Sirsa"],
"125101":[200,789,0.03,"Asa Khera, Sirsa"],
"125102":[180,438,0.02,"Mamera Kalan, Sirsa"],
"125103":[430,2284,0.04,"Banwala, Sirsa"],
"125104":[251,1152,0.03,"Chatha, Sirsa"],
"125106":[311,697,0.02,"Akanwali, Fatehabad"],
"125110":[290,560,0.03,"Ludesar, Sirsa"],
"125111":[685,2204,0.02,"Chandrawal, Fatehabad"],
"125112":[510,986,0.02,"Dahman, Fatehabad"],
"125113":[558,1526,0.06,"Hassangarh, Hisar"],
"125120":[329,1043,0.03,"Nangla, Fatehabad"],
"125121":[238,655,0.99,"Biana Khera, Hisar"],
"125133":[208,1071,0.04,"Sidhani, Fatehabad"],
"125201":[290,1221,0.04,"Gadrana, Sirsa"],
"126101":[701,1136,0.14,"Hathwala, Jind"],
"126102":[388,835,0.06,"Jind, Jind"],
"126110":[243,860,0.05,"Baniya Khera, Jind"],
"126111":[295,770,0.09,"Pegan, Jind"],
"126112":[298,750,0.02,"Dharamgarh, Jind"],
"126113":[246,854,0.07,"Assan, Jind"],
"126114":[438,765,0.06,"Buana, Jind"],
"126115":[462,1243,0.04,"Barsola, Jind"],
"126116":[438,750,0.06,"Dhakal, Jind"],
"126125":[320,1035,0.05,"Thua, Jind"],
"126152":[438,765,0.06,"Sainthali, Jind"],
"127021":[639,1152,0.32,"Bhiwani, Bhiwani"],
"127022":[370,1004,0.07,"Makrana, Charki Dadri"],
"127025":[530,1195,0.06,"Malkosh, Charki Dadri"],
"127026":[380,1232,0.02,"Tiwala, Charki Dadri"],
"127027":[922,1933,1.07,"Rewari Khera, Bhiwani"],
"127028":[453,1395,0.14,"Matani, Bhiwani"],
"127029":[512,1297,0.12,"Chandawas, Bhiwani"],
"127030":[639,1285,0.13,"Dhabdhani, Bhiwani"],
"127031":[651,2193,1.6,"Badesera, Bhiwani"],
"127032":[540,1535,0.18,"Baliali, Bhiwani"],
"127035":[424,793,0.03,"Paposa, Bhiwani"],
"127040":[528,982,0.07,"Dadam, Bhiwani"],
"127041":[672,1781,0.99,"Siwana, Bhiwani"],
"127042":[535,1191,0.12,"Misri, Charki Dadri"],
"127043":[389,1131,0.03,"Jhully, Bhiwani"],
"127045":[355,1734,0.01,"Barwa, Bhiwani"],
"127046":[388,1211,0.03,"Gurera, Bhiwani"],
"127111":[646,1478,0.56,"Biran, Bhiwani"],
"127114":[540,1118,0.09,"Kalinga, Bhiwani"],
"127201":[302,1295,0.14,"Barwas, Bhiwani"],
"127306":[565,2841,0.07,"Imlota, Charki Dadri"],
"127307":[540,1389,1.44,"Bigowa, Charki Dadri"],
"127308":[289,1114,0.05,"Arya Nagar, Charki Dadri"],
"127309":[530,1519,0.07,"Dhareru, Bhiwani"],
"127310":[258,1108,0.04,"Pichopa Kalan, Charki Dadri"],
"127311":[540,1501,0.34,"Dhirana, Bhiwani"],
"127312":[125,733,0.0,"Badrai, Charki Dadri"],
"131001":[480,1335,0.88,"Sonipat, Sonipat"],
"131021":[480,1095,0.39,"Deepalpur, Sonipat"],
"131022":[216,449,0.52,"Tihar Bagru, Sonipat"],
"131023":[390,1201,0.25,"Aterna, Sonipat"],
"131024":[390,1188,0.21,"Karewari, Sonipat"],
"131027":[336,1078,0.23,"Jainpur, Sonipat"],
"131028":[390,1201,0.25,"Janti Kalan, Sonipat"],
"131029":[430,998,0.25,"Pritampura, Sonipat"],
"131030":[350,1339,0.04,"TDI City Kundli, Sonipat"],
"131039":[480,1009,0.25,"Kurar Brahimpur, Sonipat"],
"131101":[310,959,0.15,"Bali Qutubpur, Sonipat"],
"131102":[413,927,0.22,"Pugthala, Sonipat"],
"131103":[428,1347,0.25,"Chhetra Bhahadurpur, Sonipat"],
"131301":[320,1587,0.22,"Chhichrana, Sonipat"],
"131302":[319,1228,0.13,"Gangana, Sonipat"],
"131304":[310,871,0.06,"Dhanana Ahladpur, Sonipat"],
"131305":[308,1190,0.13,"Khanpur Kalan, Sonipat"],
"131306":[322,1354,0.17,"Shamri, Sonipat"],
"131402":[511,2172,0.17,"Gopalpur, Sonipat"],
"131403":[483,1391,0.43,"Badhana, Sonipat"],
"131408":[460,1446,0.14,"Guhna, Sonipat"],
"131409":[274,485,0.02,"Anwali, Sonipat"],
"132001":[224,442,0.02,"Karnal, Karnal"],
"132022":[188,392,0.02,"Khirajpur, Karnal"],
"132023":[224,438,0.02,"Bara Gaon, Karnal"],
"132024":[279,770,0.03,"Amupur, Karnal"],
"132035":[280,675,0.01,"Munak, Karnal"],
"132036":[278,676,0.01,"Chirao, Karnal"],
"132037":[279,770,0.03,"Barauta, Karnal"],
"132039":[344,801,0.02,"Bandarala, Karnal"],
"132040":[298,982,0.01,"Munak, Karnal"],
"132041":[438,765,0.06,"Hanori, Karnal"],
"132046":[340,748,0.03,"Thari, Karnal"],
"132054":[188,378,0.04,"Kalri Jagir, Karnal"],
"132101":[236,741,0.08,"Karhans, Panipat"],
"132102":[238,533,0.04,"Gandhi Samarak Nidhi, Panipat"],
"132103":[270,763,0.03,"Panipat, Panipat"],
"132104":[240,754,0.03,"Ugra Kheri, Panipat"],
"132105":[279,732,0.02,"Assan Kalan, Panipat"],
"132106":[270,732,0.04,"Binjhol, Panipat"],
"132107":[438,765,0.06,"Pardhana, Panipat"],
"132108":[255,798,0.04,"Dadola, Panipat"],
"132113":[344,853,0.06,"Adyana, Panipat"],
"132114":[438,765,0.06,"Bastara, Karnal"],
"132115":[272,753,0.03,"Raksera, Panipat"],
"132116":[340,748,0.03,"Ramana Ramani, Karnal"],
"132117":[279,770,0.03,"Arjheri, Karnal"],
"132122":[438,765,0.06,"Khojkipur, Panipat"],
"132140":[266,830,0.01,"Dadlana, Panipat"],
"132145":[366,1306,0.06,"Dahar, Panipat"],
"132157":[279,770,0.03,"Karsa Dod, Karnal"],
"133001":[236,750,0.08,"Ambala G.P.O., Ambala"],
"133004":[192,661,0.07,"Dukheri, Ambala"],
"133005":[255,813,0.15,"Sarsehri, Ambala"],
"133006":[220,707,0.1,"Brahman Majra, Ambala"],
"133008":[186,493,0.02,"Durana, Ambala"],
"133010":[193,392,0.13,"Kalarehri, Ambala"],
"133101":[236,750,0.08,"Keshopur Samalkha, Ambala"],
"133102":[190,453,0.08,"Chudiala, Ambala"],
"133103":[200,424,0.11,"Jagdholi, Yamunanagar"],
"133104":[220,535,0.13,"Mehmoodpur, Ambala"],
"133201":[193,388,0.12,"Holi, Ambala"],
"133202":[200,345,0.11,"Alipur Jahangir, Ambala"],
"133203":[154,393,0.13,"Sohana, Ambala"],
"133204":[258,812,0.29,"Mehmoodpur, Yamunanagar"],
"133205":[187,380,0.04,"Kaserla Kalan, Ambala"],
"133206":[157,343,0.18,"Sardaheri, Ambala"],
"133207":[193,394,0.12,"M.M.E.Complex Mulana, Ambala"],
"133301":[164,325,0.16,"B.C.W. Suraj Pur, Panchkula"],
"133302":[258,815,0.29,"Kharanwali, Panchkula"],
"134003":[258,776,0.27,"Ambala City, Ambala"],
"134005":[258,780,0.27,"Jandli, Ambala"],
"134007":[258,870,0.3,"Dhankaur, Ambala"],
"134008":[258,815,0.29,"Ballana, Ambala"],
"134101":[164,322,0.2,"H.M.T.Pinjore, Panchkula"],
"134102":[180,346,0.12,"Damaloan, Panchkula"],
"134103":[198,610,0.07,"I.T.B.P. Bhanu, Panchkula"],
"134104":[164,320,0.29,"C.R.P.F. Pinjore, Panchkula"],
"134105":[258,780,0.27,"Amravati Enclave, Panchkula"],
"134107":[184,401,0.11,"Chandi Mandir Cantt, Panchkula"],
"134108":[191,458,0.07,"G.K. Panchkula, Panchkula"],
"134109":[191,490,0.08,"Devi Nagar, Panchkula"],
"134112":[194,555,0.09,"Panchkula Sector 12, Panchkula"],
"134113":[180,551,0.1,"Industrial Estate Panchkula, Panchkula"],
"134114":[184,467,0.11,"Mansa Devi Sec 5, Panchkula"],
"134116":[198,641,0.08,"Sector 26 Panchkula, Panchkula"],
"134117":[198,583,0.1,"Sector 20 Panchkula, Panchkula"],
"134118":[355,1057,0.02,"Kot, Panchkula"],
"134201":[220,681,0.09,"Patwi, Ambala"],
"134202":[193,635,0.09,"Korwakhurd, Ambala"],
"134203":[250,973,0.11,"Ambli, Ambala"],
"134204":[195,604,0.06,"Baladwala, Yamunanagar"],
"134205":[258,815,0.29,"Mandhana, Panchkula"],
"134999":[186,540,0.1,"Industrial Estate Panchkula, Panchkula"],
"135001":[157,249,0.06,"Yamunanagar, Yamunanagar"],
"135002":[258,815,0.29,"Damla, Yamunanagar"],
"135003":[166,300,0.14,"Bherthal, Yamunanagar"],
"135004":[167,259,0.06,"Khera Khurd, Yamunanagar"],
"135021":[258,815,0.29,"Bakarwala, Yamunanagar"],
"135101":[175,357,0.19,"Fatehpur, Yamunanagar"],
"135102":[258,812,0.29,"Basatianwala, Yamunanagar"],
"135103":[157,281,0.23,"Kot Kalsia, Yamunanagar"],
"135106":[157,258,0.13,"Kalesar, Yamunanagar"],
"135133":[168,326,0.04,"Bapa, Yamunanagar"],
"136020":[204,478,0.01,"Pabnawa, Kaithal"],
"136021":[174,420,0.0,"Ahun, Kaithal"],
"136026":[224,694,0.01,"Deeg, Kaithal"],
"136027":[334,1200,0.01,"Budha Khera, Kaithal"],
"136030":[176,471,0.01,"Seonsar, Kurukshetra"],
"136033":[334,1200,0.01,"Ladana Chaku, Kaithal"],
"136034":[334,1200,0.01,"Badsui, Kaithal"],
"136035":[228,715,0.01,"Agondh, Kaithal"],
"136038":[241,521,0.01,"Amin, Kurukshetra"],
"136042":[218,628,0.01,"Mundri, Kaithal"],
"136043":[273,986,0.12,"Karora, Kaithal"],
"136044":[250,1012,0.17,"Mandwal, Kaithal"],
"136117":[540,2647,0.67,"Kailram, Kaithal"],
"136118":[160,321,1.71,"Kurukshetra, Kurukshetra"],
"136119":[160,320,1.57,"Dhurala, Kurukshetra"],
"136128":[174,415,0.01,"Diwana, Kurukshetra"],
"136129":[133,400,0.02,"Chammu Kalan, Kurukshetra"],
"136130":[160,313,3.68,"Ajrana Kalan, Kurukshetra"],
"136131":[160,313,3.68,"Bodla, Kurukshetra"],
"136132":[174,350,0.02,"Barout, Kurukshetra"],
"136134":[160,316,1.08,"Mohri, Kurukshetra"],
"136135":[160,313,3.68,"Kharindwa, Kurukshetra"],
"136136":[142,445,0.03,"Mandheri, Kurukshetra"],
"136156":[174,342,0.02,"Bhagwanpur, Kurukshetra"],
"140001":[200,419,0.98,"Ropar, Rupnagar"],
"140101":[186,529,0.69,"Bhamnara, Rupnagar"],
"140102":[207,405,0.88,"Samana Kalan, Rupnagar"],
"140103":[207,405,0.88,"Allahpur, S.A.S Nagar"],
"140108":[186,529,0.69,"Purkhali, Rupnagar"],
"140109":[207,431,0.98,"Kubaheri, S.A.S Nagar"],
"140110":[186,529,0.69,"Hoshiarpur Taqipur, S.A.S Nagar"],
"140111":[214,465,0.44,"Bazidpur, Rupnagar"],
"140112":[207,405,0.88,"Katlaur, Rupnagar"],
"140113":[207,405,0.88,"Lodhi Majra, Rupnagar"],
"140114":[207,405,0.88,"Bharatgarh Canal Colony, Rupnagar"],
"140115":[212,457,0.07,"Massewal, Rupnagar"],
"140116":[207,405,0.88,"Jhinjari, Rupnagar"],
"140117":[207,405,0.88,"Jatauli, Rupnagar"],
"140118":[198,459,0.77,"Agampur, Rupnagar"],
"140119":[186,529,0.69,"Bajrur, Rupnagar"],
"140123":[207,405,0.88,"Mangewal, Rupnagar"],
"140124":[186,529,0.69,"Nangal Nikku, Rupnagar"],
"140125":[186,529,0.69,"Bandelhari, Rupnagar"],
"140126":[207,405,0.88,"Mojowal, Rupnagar"],
"140127":[207,405,0.88,"Bhallan, Rupnagar"],
"140128":[207,405,0.88,"Katta Sabour, Rupnagar"],
"140133":[207,405,0.88,"Kalitran, Rupnagar"],
"140201":[186,529,0.69,"Bhankarpur, S.A.S Nagar"],
"140301":[207,405,0.88,"Palheri, S.A.S Nagar"],
"140306":[186,529,0.69,"Dharamgarh, S.A.S Nagar"],
"140307":[207,405,0.88,"Chudiala Sudan, S.A.S Nagar"],
"140308":[186,529,0.69,"Kumbra, S.A.S Nagar"],
"140401":[234,734,0.87,"Rajpura, Patiala"],
"140402":[231,717,0.97,"Chamaru, Patiala"],
"140405":[195,420,0.28,"Bhamarsibuland, Fatehgarh Sahib"],
"140406":[206,460,0.22,"Harlalpur, Fatehgarh Sahib"],
"140407":[215,473,0.21,"Fatehgarh Sahib, Fatehgarh Sahib"],
"140408":[218,507,0.81,"Balhari Kalan, Fatehgarh Sahib"],
"140412":[214,473,0.07,"Badwala, Fatehgarh Sahib"],
"140413":[207,405,0.88,"Bassian Brahman, S.A.S Nagar"],
"140417":[234,751,1.01,"Sandharsi, Patiala"],
"140501":[186,529,0.69,"Handesera, S.A.S Nagar"],
"140506":[186,529,0.69,"Dappar, S.A.S Nagar"],
"140507":[186,529,0.69,"Kuranwala, S.A.S Nagar"],
"140601":[234,743,0.72,"Jhansla, Patiala"],
"140602":[186,647,1.01,"Buras, Fatehgarh Sahib"],
"140603":[186,529,0.69,"Dayalpur Sodhian, S.A.S Nagar"],
"140604":[179,636,0.08,"Baltana, S.A.S Nagar"],
"140701":[259,844,0.59,"Harpalpur, Patiala"],
"140702":[238,1045,0.47,"Marru, Patiala"],
"140802":[218,457,0.06,"Amrala, Fatehgarh Sahib"],
"140901":[186,529,0.69,"Jayanti Devi, S.A.S Nagar"],
"141001":[235,393,0.04,"Ludhiana, Ludhiana"],
"141002":[177,371,0.05,"Model Town Ludhiana, Ludhiana"],
"141003":[230,403,0.05,"Shimlapuri, Ludhiana"],
"141004":[211,363,0.05,"PAU, Ludhiana"],
"141006":[230,465,0.08,"Gne College, Ludhiana"],
"141007":[232,481,0.04,"Boothgarh, Ludhiana"],
"141008":[235,414,0.04,"Baggakhurd, Ludhiana"],
"141010":[232,425,0.05,"Jamalpur Awana, Ludhiana"],
"141011":[235,394,0.04,"Nodal Delivery Centre Ludhiana, Ludhiana"],
"141012":[168,391,0.05,"New Rajguru Nagar, Ludhiana"],
"141013":[177,422,0.08,"Basant Avenue, Ludhiana"],
"141014":[232,471,0.04,"Daba Road, Ludhiana"],
"141015":[232,445,0.04,"Karyana Kalan, Ludhiana"],
"141016":[232,495,0.07,"Lohora, Ludhiana"],
"141101":[185,451,0.03,"Dhatt, Ludhiana"],
"141102":[186,406,0.05,"Gahaur, Ludhiana"],
"141103":[185,486,0.07,"Khandur, Ludhiana"],
"141104":[164,266,0.01,"Ghuman, Ludhiana"],
"141105":[201,434,0.03,"Sahauli, Ludhiana"],
"141106":[201,456,0.03,"Halwara Aerodrome, Ludhiana"],
"141107":[201,372,0.03,"Attiana, Ludhiana"],
"141108":[218,475,0.05,"Leel, Ludhiana"],
"141109":[222,440,0.01,"Bhaini Baringa, Ludhiana"],
"141110":[300,567,-1,"Bhatta Dhahan, Ludhiana"],
"141112":[283,567,0.18,"Budhewal, Ludhiana"],
"141113":[278,884,0.42,"Kot Gangu Rai, Ludhiana"],
"141114":[233,513,0.21,"Bondli, Ludhiana"],
"141115":[223,674,0.14,"Hambowal, Ludhiana"],
"141116":[194,411,0.04,"Jassowal, Ludhiana"],
"141117":[290,665,0.24,"Kalahar, Ludhiana"],
"141118":[184,659,0.13,"Lehra, Ludhiana"],
"141119":[290,513,0.14,"Ramgarh Sardaran, Ludhiana"],
"141120":[287,568,0.21,"Tibba, Ludhiana"],
"141121":[207,523,0.52,"Chhourian, Ludhiana"],
"141122":[201,509,0.03,"Sangowal, Ludhiana"],
"141123":[177,418,0.07,"Sahibana, Ludhiana"],
"141125":[154,334,0.04,"Sihala, Ludhiana"],
"141126":[273,623,0.22,"Panjeta, Ludhiana"],
"141127":[272,580,0.19,"Chhounta, Ludhiana"],
"141201":[184,655,0.13,"Kila Raipur, Ludhiana"],
"141202":[168,510,0.08,"Chaminda, Ludhiana"],
"141203":[168,587,0.12,"Mehma Singh Wala, Ludhiana"],
"141204":[220,611,0.16,"Chhapar, Ludhiana"],
"141205":[210,524,0.09,"Rachhine, Ludhiana"],
"141206":[290,592,0.17,"Khanpur, Ludhiana"],
"141401":[213,458,0.3,"Khanna, Ludhiana"],
"141411":[215,406,0.27,"Hargana, Fatehgarh Sahib"],
"141412":[282,507,0.17,"Ghungrali Rajputan, Ludhiana"],
"141413":[160,656,0.02,"Nizampur, Ludhiana"],
"141414":[248,516,0.17,"Rajewal, Ludhiana"],
"141415":[249,442,0.08,"Bharthala Randhawa, Ludhiana"],
"141416":[296,572,0.26,"Barmalipur, Ludhiana"],
"141417":[218,464,0.29,"Lalori Kalan, Ludhiana"],
"141418":[230,492,0.08,"Kubba, Ludhiana"],
"141419":[293,552,0.21,"Ghaloti, Ludhiana"],
"141421":[287,559,0.19,"Doburji, Ludhiana"],
"141422":[185,497,0.03,"Raqba, Ludhiana"],
"141801":[211,517,0.18,"Chari, Fatehgarh Sahib"],
"142001":[160,632,0.13,"Moga, Moga"],
"142002":[191,617,0.1,"Chand Nau, Moga"],
"142003":[191,617,0.1,"Dhalleke, Moga"],
"142011":[190,639,2.4,"Mehron, Moga"],
"142021":[194,451,0.07,"Pamali, Ludhiana"],
"142022":[221,1197,0.05,"Dev Nagar, Ludhiana"],
"142023":[240,655,19.5,"Jassowal Kalan, Ludhiana"],
"142024":[267,615,8.2,"Barsal, Ludhiana"],
"142025":[295,665,0.03,"Bhundri, Ludhiana"],
"142026":[298,545,15.77,"Jagraon, Ludhiana"],
"142027":[186,377,0.04,"Malakpur, Ludhiana"],
"142029":[186,440,0.08,"Dhaipai, Ludhiana"],
"142030":[201,533,12.33,"Roomi, Ludhiana"],
"142031":[218,484,2.8,"Lakha, Ludhiana"],
"142032":[225,472,0.01,"Nathowal, Ludhiana"],
"142033":[295,547,2.59,"Gidderwindi, Ludhiana"],
"142034":[231,481,9.08,"Bhamipura, Ludhiana"],
"142035":[237,562,6.34,"Rasulpur, Ludhiana"],
"142036":[238,522,5.82,"Nanaksar, Ludhiana"],
"142037":[204,587,3.3,"Bir Raoke, Moga"],
"142038":[160,654,0.02,"Budh Singh Wala, Moga"],
"142039":[160,632,0.13,"Bhagike, Moga"],
"142040":[248,569,0.36,"Mallianwala, Moga"],
"142041":[238,495,0.15,"Kokri Wehniwal, Moga"],
"142042":[210,493,0.12,"Kaila, Moga"],
"142043":[208,486,0.12,"Fateh Garh Panjtoor, Moga"],
"142044":[314,456,1.0,"Pir Mohamad, Firozepur"],
"142045":[250,783,0.05,"Kishan Garh, Moga"],
"142046":[243,682,0.05,"Khai, Moga"],
"142047":[223,717,0.02,"Dhandian, Firozepur"],
"142048":[172,1846,0.01,"Dadahur, Moga"],
"142049":[197,711,0.09,"Lande, Moga"],
"142050":[131,794,0.02,"Kassoana, Firozepur"],
"142052":[238,635,4.98,"Machhi Bugra, Firozepur"],
"142053":[235,589,3.84,"Ajitwal, Moga"],
"142054":[241,537,2.72,"Kokri Heron, Moga"],
"142055":[190,647,0.05,"Saidoke, Moga"],
"142056":[234,668,0.05,"Ranian, Moga"],
"142057":[243,618,0.01,"Maur Nau Abad, Moga"],
"142058":[244,543,2.32,"Chak Kannian Kalan, Moga"],
"142060":[160,972,0.01,"Gill, Firozepur"],
"143001":[216,370,0.01,"Amritsar GPO, Amritsar"],
"143002":[221,360,0.01,"Khalsa College, Amritsar"],
"143004":[216,369,0.01,"Nodal Delivery Centre Amritsar, Amritsar"],
"143005":[219,329,0.0,"Guru Nanak Dev University, Amritsar"],
"143006":[216,331,0.01,"Gandhi Bazar SO Amritsar, Amritsar"],
"143008":[224,415,0.03,"Dist Jail, Amritsar"],
"143009":[216,360,0.02,"Bohru, Amritsar"],
"143022":[215,299,0.02,"Rataul, Amritsar"],
"143101":[233,533,0.04,"Bagga, Amritsar"],
"143102":[216,628,0.05,"Dhariwal Kaler, Amritsar"],
"143103":[166,452,0.1,"Kamalpur, Amritsar"],
"143105":[220,345,0.01,"Basarke Gillan, Amritsar"],
"143107":[224,561,0.11,"Ladhewal, Amritsar"],
"143108":[235,642,0.15,"Mohawa, Amritsar"],
"143109":[219,834,0.03,"Saurian, Amritsar"],
"143111":[216,428,0.1,"Bhorchi Rajputana, Amritsar"],
"143112":[213,486,0.02,"Uppal, Amritsar"],
"143113":[218,392,0.08,"Nangal Dial Singh, Amritsar"],
"143114":[232,-1,0.2,"Mehta, Amritsar"],
"143115":[206,424,0.03,"Dharar, Amritsar"],
"143116":[216,333,0.16,"Kot Khera, Amritsar"],
"143117":[202,361,0.03,"Bharowal, Tarn Taran"],
"143118":[162,451,0.02,"Pindian, Tarn Taran"],
"143119":[220,280,0.23,"Uddoke, Amritsar"],
"143149":[210,452,0.04,"Tangra, Amritsar"],
"143201":[244,402,0.15,"Bhalojla, Amritsar"],
"143202":[234,317,0.16,"Bhalaipur Purban, Amritsar"],
"143203":[232,290,0.35,"Jamalpur, Amritsar"],
"143204":[244,380,0.31,"Bal Sarai, Amritsar"],
"143205":[232,312,0.29,"Ghagar Bhana, Amritsar"],
"143301":[212,442,0.01,"Kot Dharam Chand Kalan, Tarn Taran"],
"143302":[192,592,0.06,"Musse, Tarn Taran"],
"143303":[171,525,0.03,"Bainka, Tarn Taran"],
"143304":[195,425,0.54,"Bhai Ladhu, Tarn Taran"],
"143305":[171,703,0.09,"Basarke, Tarn Taran"],
"143401":[190,266,0.03,"Tarn Taran, Tarn Taran"],
"143402":[190,263,0.03,"Manochahal, Tarn Taran"],
"143406":[202,374,0.03,"Pakhoke, Tarn Taran"],
"143407":[174,443,0.02,"Behal, Tarn Taran"],
"143408":[161,415,0.25,"Dhundhai Wala, Tarn Taran"],
"143409":[192,389,0.29,"Warrian, Tarn Taran"],
"143410":[184,396,0.76,"Sohawa, Tarn Taran"],
"143411":[210,425,0.03,"Lalpura, Tarn Taran"],
"143412":[220,377,1.56,"Ratta Gudda, Tarn Taran"],
"143413":[207,363,0.02,"Manawala Khurd, Amritsar"],
"143414":[218,582,0.09,"Naushhra Dhalla, Tarn Taran"],
"143415":[195,401,0.62,"Jaura, Tarn Taran"],
"143416":[195,442,0.92,"Bahmniwala, Tarn Taran"],
"143419":[188,664,0.08,"Amarkot, Tarn Taran"],
"143422":[162,413,0.02,"Dhunda, Tarn Taran"],
"143501":[215,324,0.02,"Vallah, Amritsar"],
"143502":[207,404,0.16,"Jethuwal, Amritsar"],
"143504":[206,366,0.2,"Bhilowal, Amritsar"],
"143505":[231,329,0.16,"Batala, Gurdaspur"],
"143506":[220,-1,0.2,"Massania, Gurdaspur"],
"143507":[203,428,0.18,"Hardo Jhande, Gurdaspur"],
"143511":[203,383,0.08,"Athwal, Gurdaspur"],
"143512":[191,370,0.29,"Fattupur, Gurdaspur"],
"143513":[192,405,0.25,"Bhole Ke, Gurdaspur"],
"143514":[220,264,0.3,"Padhe, Gurdaspur"],
"143515":[241,286,0.21,"Cheema Khudi, Gurdaspur"],
"143516":[216,222,0.02,"Dhandal, Gurdaspur"],
"143517":[215,339,0.12,"Bhaini Mian Khan, Gurdaspur"],
"143518":[262,-1,0.03,"Dehriwal, Gurdaspur"],
"143519":[276,-1,0.04,"Kaler Kalan, Gurdaspur"],
"143520":[226,399,0.73,"Gaznipur e, Gurdaspur"],
"143521":[292,504,0.31,"Gurdaspur, Gurdaspur"],
"143525":[230,312,1.65,"Jhabkra, Gurdaspur"],
"143526":[191,419,1.42,"Magar Mudian, Gurdaspur"],
"143527":[237,243,0.02,"Bharath, Gurdaspur"],
"143528":[248,317,0.03,"Kala Bala e, Gurdaspur"],
"143529":[277,398,0.05,"Babri, Gurdaspur"],
"143530":[273,521,0.1,"Khojepur, Gurdaspur"],
"143531":[291,474,0.33,"Bhatoya, Gurdaspur"],
"143532":[292,424,0.71,"Bharath, Gurdaspur"],
"143533":[223,406,0.06,"Bianpure, Gurdaspur"],
"143534":[230,349,0.19,"Sahaura Khurd, Pathankot"],
"143601":[182,447,0.26,"Budha Theh, Amritsar"],
"143602":[182,418,0.2,"Hardorwal, Gurdaspur"],
"143603":[166,390,0.08,"Dahoorian, Amritsar"],
"143604":[180,291,0.81,"Khushalpur, Gurdaspur"],
"143605":[182,363,0.19,"Dharowali, Gurdaspur"],
"143606":[182,520,0.13,"Madhu Chhanga, Amritsar"],
"144001":[233,330,0.02,"Jalandhar City, Jalandhar"],
"144002":[209,333,0.02,"Dhaliwal, Jalandhar"],
"144003":[209,324,0.02,"Tower Town Colony, Jalandhar"],
"144005":[228,369,0.03,"Jalandhar Cantt, Jalandhar"],
"144006":[228,353,0.03,"BSF Campus, Jalandhar"],
"144007":[228,373,0.03,"Ladhewali, Jalandhar"],
"144008":[228,340,0.02,"Lidhran, Jalandhar"],
"144009":[228,374,0.03,"Regional Campus GNDU, Jalandhar"],
"144010":[229,389,0.03,"Dhanowali, Jalandhar"],
"144020":[224,390,0.02,"Qadian Wali, Jalandhar"],
"144021":[228,345,0.02,"Nagra SO Jalandhar, Jalandhar"],
"144022":[209,330,0.02,"Urban Estate SO Jalandhar, Jalandhar"],
"144023":[233,379,0.03,"Dakoha, Jalandhar"],
"144024":[236,430,0.02,"Khusropur, Jalandhar"],
"144025":[253,453,0.04,"Hazara, Jalandhar"],
"144026":[243,379,0.03,"Khambra, Jalandhar"],
"144027":[233,353,0.02,"REC Jalandhar, Jalandhar"],
"144028":[209,330,0.02,"Lallian, Jalandhar"],
"144029":[256,539,0.02,"Sheikhupur, Jalandhar"],
"144030":[159,400,0.05,"Kalra, Jalandhar"],
"144031":[241,275,0.18,"RURKA KALAN, Jalandhar"],
"144032":[226,452,0.02,"Daduwal, Jalandhar"],
"144033":[158,397,0.03,"Chak Vendal, Jalandhar"],
"144034":[238,474,0.02,"Pabwan, Jalandhar"],
"144035":[159,397,0.05,"Kang Arryan, Jalandhar"],
"144036":[238,474,0.02,"Mowai, Jalandhar"],
"144037":[237,495,0.01,"Nagra, Jalandhar"],
"144039":[201,373,0.01,"Chuheki, Jalandhar"],
"144040":[200,425,0.02,"Bhullar, Jalandhar"],
"144041":[196,424,0.04,"Akbarpur Kalan, Jalandhar"],
"144042":[158,397,0.03,"Chak Kalan, Jalandhar"],
"144043":[238,474,0.02,"Tahli, Jalandhar"],
"144044":[158,397,0.03,"Bath Kalan, Jalandhar"],
"144101":[243,410,0.04,"Kotli Than Singh, Jalandhar"],
"144102":[166,372,0.01,"Chuharwali, Jalandhar"],
"144103":[158,418,0.04,"Kandola, Jalandhar"],
"144104":[158,413,0.04,"Daroli Khurd, Jalandhar"],
"144105":[201,359,0.01,"Dadupur Garoa, Hoshiarpur"],
"144106":[158,484,0.03,"Jalbhe, Jalandhar"],
"144201":[233,330,0.02,"Binpalke, Jalandhar"],
"144202":[165,419,0.02,"Jalalpur, Hoshiarpur"],
"144204":[233,424,0.04,"Kurala Kalan, Hoshiarpur"],
"144205":[208,325,0.11,"Dasuya, Hoshiarpur"],
"144206":[244,384,0.17,"Kukanet, Hoshiarpur"],
"144207":[198,315,0.11,"Chathial Khurd, Hoshiarpur"],
"144208":[237,477,0.01,"Sataur, Hoshiarpur"],
"144209":[220,416,1.36,"Dandoh, Hoshiarpur"],
"144210":[158,412,0.03,"Chak Ladhian, Hoshiarpur"],
"144211":[178,329,0.02,"Hoshiarpur Kalota, Hoshiarpur"],
"144212":[178,232,0.01,"Kandhala Sheikhan, Hoshiarpur"],
"144213":[179,286,0.03,"Fatehpur Bhattlan, Hoshiarpur"],
"144214":[218,539,0.06,"Baja Chak, Hoshiarpur"],
"144216":[222,447,0.02,"Rajwal, Hoshiarpur"],
"144221":[218,336,0.05,"Seeprian, Hoshiarpur"],
"144222":[237,-1,0.02,"Handwal, Hoshiarpur"],
"144223":[172,367,0.37,"Behlakhan, Hoshiarpur"],
"144224":[249,505,0.02,"Bhater, Hoshiarpur"],
"144301":[233,415,0.04,"Naugajja, Jalandhar"],
"144302":[210,372,0.03,"Dolike Sunderpur, Jalandhar"],
"144303":[233,415,0.04,"Jallowal, Jalandhar"],
"144305":[168,430,0.02,"Safdarpur, Hoshiarpur"],
"144306":[229,329,0.41,"Behbalmanj, Hoshiarpur"],
"144311":[232,303,0.35,"Rorkee, Jalandhar"],
"144401":[238,479,0.03,"Phagwara, Kapurthala"],
"144402":[238,477,0.03,"Sangatpur, Kapurthala"],
"144403":[239,417,0.04,"Barn, Kapurthala"],
"144404":[160,386,0.04,"Phuglana, Hoshiarpur"],
"144405":[193,385,0.05,"Mayopatti, Kapurthala"],
"144406":[229,479,0.05,"Dihana, Hoshiarpur"],
"144407":[160,418,0.04,"Rehana Jattan, Kapurthala"],
"144408":[168,373,0.04,"PANCHHAT, Kapurthala"],
"144409":[238,566,0.01,"Paddi Jagir, Jalandhar"],
"144410":[238,477,0.03,"Kadiana, Jalandhar"],
"144411":[238,478,0.02,"Chiheru, Kapurthala"],
"144415":[200,363,0.02,"Lassara, Shahid Bhagat Singh Nagar"],
"144416":[249,550,0.02,"Massani, Jalandhar"],
"144417":[270,567,0.02,"Phambra, Shahid Bhagat Singh Nagar"],
"144418":[249,539,0.02,"Chak Desraj, Jalandhar"],
"144419":[238,569,0.02,"Thalla, Jalandhar"],
"144421":[270,514,0.02,"Ghataron, Shahid Bhagat Singh Nagar"],
"144422":[253,526,0.02,"Bhakhlaur, Shahid Bhagat Singh Nagar"],
"144501":[238,502,0.03,"Jasso Mazara, Shahid Bhagat Singh Nagar"],
"144502":[249,506,0.02,"Dhandwar, Jalandhar"],
"144503":[216,440,0.03,"Katarian, Shahid Bhagat Singh Nagar"],
"144504":[249,499,0.02,"Chak Ramu, Shahid Bhagat Singh Nagar"],
"144505":[222,438,0.02,"Baharowal, Shahid Bhagat Singh Nagar"],
"144506":[230,419,0.02,"Sujjon, Shahid Bhagat Singh Nagar"],
"144507":[255,526,0.02,"Hakimpur, Shahid Bhagat Singh Nagar"],
"144508":[228,371,0.03,"Malpur, Shahid Bhagat Singh Nagar"],
"144509":[246,502,0.02,"Lakhpur, Shahid Bhagat Singh Nagar"],
"144510":[240,389,0.01,"Paddi Matwali, Shahid Bhagat Singh Nagar"],
"144511":[259,594,0.15,"Majara Nau Abad, Shahid Bhagat Singh Nagar"],
"144512":[230,462,0.02,"Mangowal, Shahid Bhagat Singh Nagar"],
"144513":[250,493,0.02,"Kamam, Shahid Bhagat Singh Nagar"],
"144514":[214,446,0.02,"Barnala Kalan, Shahid Bhagat Singh Nagar"],
"144515":[207,415,0.04,"Dhangerpur, Shahid Bhagat Singh Nagar"],
"144516":[214,404,0.02,"Sanawa, Shahid Bhagat Singh Nagar"],
"144517":[220,593,0.02,"Kahlon, Shahid Bhagat Singh Nagar"],
"144518":[270,542,0.02,"Bazidpur, Shahid Bhagat Singh Nagar"],
"144519":[210,435,0.04,"Thinda, Hoshiarpur"],
"144520":[193,422,0.04,"Aiman Jattan, Hoshiarpur"],
"144521":[238,523,0.02,"Mehatpur Oladini, Shahid Bhagat Singh Nagar"],
"144522":[226,443,0.04,"Banah, Shahid Bhagat Singh Nagar"],
"144523":[243,418,0.04,"Kalewal, Hoshiarpur"],
"144524":[238,471,0.05,"Chandpur Rurki, Shahid Bhagat Singh Nagar"],
"144525":[249,533,0.02,"Makhoopur, Shahid Bhagat Singh Nagar"],
"144526":[238,499,0.03,"Chinkoa, Shahid Bhagat Singh Nagar"],
"144527":[220,409,1.25,"Denowal Kalan, Hoshiarpur"],
"144528":[223,370,0.02,"Padrana, Hoshiarpur"],
"144529":[233,445,0.04,"Jassowal, Hoshiarpur"],
"144530":[168,370,0.02,"Lalwan, Hoshiarpur"],
"144531":[177,391,0.01,"Kitna, Hoshiarpur"],
"144532":[233,467,0.04,"Panam, Hoshiarpur"],
"144533":[168,338,0.02,"Rel, Shahid Bhagat Singh Nagar"],
"144601":[166,278,0.01,"Kapurthala, Kapurthala"],
"144602":[165,274,0.01,"RAIL COACH FACTORY KAPURTHALA, Kapurthala"],
"144603":[166,290,0.01,"Wadala Kalan, Kapurthala"],
"144606":[165,255,0.01,"Khiranwali, Kapurthala"],
"144620":[166,279,0.01,"Dadwindi, Kapurthala"],
"144621":[230,362,0.14,"Bariar, Kapurthala"],
"144622":[244,455,0.02,"Alampur Bhakha, Kapurthala"],
"144623":[166,296,0.01,"Talwandi Saleem, Jalandhar"],
"144624":[250,416,0.19,"Raipur Arryan, Kapurthala"],
"144625":[200,401,0.03,"Sandhu Chatha, Kapurthala"],
"144626":[162,355,0.01,"Sherpur Dona, Kapurthala"],
"144628":[167,309,0.01,"Nasirpur, Kapurthala"],
"144629":[237,461,0.01,"Bara Jodh Singh, Jalandhar"],
"144630":[202,435,0.01,"Gohir, Jalandhar"],
"144631":[237,337,0.24,"Miani Bhagopurian, Kapurthala"],
"144632":[238,486,0.02,"Mehli, Shahid Bhagat Singh Nagar"],
"144633":[230,466,0.02,"Dhanipind, Jalandhar"],
"144701":[201,458,0.05,"Nihaluwal, Jalandhar"],
"144702":[210,453,0.04,"Sindher, Jalandhar"],
"144703":[187,310,0.11,"Sadiqpur, Jalandhar"],
"144801":[166,279,0.01,"Mustafapur, Jalandhar"],
"144802":[167,325,0.01,"Muddowal, Kapurthala"],
"144803":[253,457,0.03,"Kudowal, Jalandhar"],
"144804":[236,400,0.16,"Dhaliwal Bet, Kapurthala"],
"144805":[166,283,0.01,"Kahlwan, Jalandhar"],
"144806":[238,338,0.02,"Khusropur, Jalandhar"],
"144819":[244,372,0.22,"Raipur Pir Bux Wala, Kapurthala"],
"145001":[170,254,0.03,"Chakkar, Pathankot"],
"145002":[197,290,0.02,"Jugial Road Dharkalan, Gurdaspur"],
"145022":[208,348,0.02,"Lehroon, Pathankot"],
"145023":[170,253,0.27,"Ferozepur Kalan, Pathankot"],
"145024":[175,239,0.39,"Tharial, Pathankot"],
"145025":[190,289,0.23,"Bharoli, Pathankot"],
"145026":[220,346,0.63,"Datial, Pathankot"],
"145027":[186,279,1.04,"Janial, Pathankot"],
"145029":[167,208,0.02,"Kot, Pathankot"],
"145101":[214,378,0.06,"Ghiala, Pathankot"],
"146001":[191,292,0.02,"Hoshiarpur, Hoshiarpur"],
"146021":[196,331,0.01,"Bassi Gulam Hussain, Hoshiarpur"],
"146022":[178,400,0.01,"Fatehgarh Niara, Hoshiarpur"],
"146023":[201,361,0.01,"Nangal Shahidan, Hoshiarpur"],
"146024":[265,469,0.02,"Bhagowal, Hoshiarpur"],
"146101":[158,382,0.04,"Nangal Khurd, Hoshiarpur"],
"146102":[158,379,0.04,"Bahadarpur Bahian, Hoshiarpur"],
"146103":[166,229,0.01,"Jangliana, Hoshiarpur"],
"146104":[249,531,0.02,"Sasoli, Hoshiarpur"],
"146105":[233,426,0.02,"Bahowal, Hoshiarpur"],
"146106":[212,410,0.02,"Khera, Hoshiarpur"],
"146107":[193,388,0.05,"Hakumatpur, Hoshiarpur"],
"146108":[166,289,0.01,"Laksian, Hoshiarpur"],
"146109":[201,372,0.02,"Gandhowal, Hoshiarpur"],
"146110":[158,392,0.04,"Chak Sadu, Hoshiarpur"],
"146111":[247,417,0.16,"Ajram, Hoshiarpur"],
"146112":[158,371,0.05,"Bhungarani, Hoshiarpur"],
"146113":[158,344,0.02,"Dhade Fateh Singh, Hoshiarpur"],
"146114":[167,393,0.01,"Khanpur, Hoshiarpur"],
"146115":[237,500,0.02,"Kalubahar, Hoshiarpur"],
"146116":[180,347,0.01,"Sarhala Mundian, Hoshiarpur"],
"147001":[220,555,0.02,"Patiala, Patiala"],
"147002":[259,759,0.02,"Urban Estate, Patiala"],
"147003":[259,771,0.02,"D C W, Patiala"],
"147004":[246,748,0.02,"Mullepur, Patiala"],
"147005":[230,715,0.02,"Kalyan, Patiala"],
"147006":[225,604,0.02,"Lang, Patiala"],
"147007":[259,619,0.07,"Dakala, Patiala"],
"147008":[238,734,0.03,"Nodal Delivery Center (Parcel) Patiala, Patiala"],
"147021":[259,875,0.08,"Chappar, Patiala"],
"147101":[196,587,0.03,"Balbera, Patiala"],
"147102":[250,603,0.02,"Badshahpur, Patiala"],
"147103":[259,814,0.13,"Bhankher, Patiala"],
"147104":[190,416,0.24,"Roorki, Fatehgarh Sahib"],
"147105":[305,519,0.03,"Arno, Patiala"],
"147111":[227,632,0.1,"Gharam, Patiala"],
"147201":[218,441,0.02,"Ajnoda Kalan, Patiala"],
"147202":[187,399,0.26,"Agol, Patiala"],
"147203":[214,464,0.37,"Tibbi, Fatehgarh Sahib"],
"147301":[214,444,0.33,"Kumbh, Fatehgarh Sahib"],
"148001":[218,508,0.03,"Sangrur, Sangrur"],
"148002":[202,572,0.02,"Kular Khurd, Sangrur"],
"148017":[215,491,0.18,"Mehsampur, Sangrur"],
"148018":[212,458,0.13,"Bhatian Khurd, Malerkotla"],
"148019":[300,586,0.02,"Kup Kalan, Malerkotla"],
"148020":[231,510,0.19,"Fatehgarh Panjgrian, Sangrur"],
"148021":[242,545,0.13,"Nathu Majra, Malerkotla"],
"148022":[246,486,0.03,"Chaunda, Malerkotla"],
"148023":[278,565,0.03,"Sangala, Malerkotla"],
"148024":[231,491,0.1,"Badshahpur, Sangrur"],
"148025":[228,506,0.3,"Bajwa, Sangrur"],
"148026":[189,443,0.14,"Alloarakh, Sangrur"],
"148027":[363,693,0.04,"Mandvi, Sangrur"],
"148028":[242,519,0.03,"Dharamgarh, Sangrur"],
"148029":[218,562,0.03,"Shahpur kalan, Sangrur"],
"148030":[231,850,0.04,"Lad Banjara, Sangrur"],
"148031":[218,1115,0.04,"Chotian, Sangrur"],
"148033":[221,1082,0.06,"Dehla, Sangrur"],
"148034":[200,558,0.06,"Benra, Sangrur"],
"148035":[241,512,0.02,"Sulargharat, Sangrur"],
"148100":[225,539,0.05,"Bihla, Barnala"],
"148101":[200,653,0.02,"Raisar, Barnala"],
"148102":[204,642,0.07,"Jangiana, Barnala"],
"148103":[208,522,0.15,"Pakhoke, Barnala"],
"148104":[230,525,0.01,"Chhiniwal Kalan, Barnala"],
"148105":[138,637,0.01,"Bhathlan, Barnala"],
"148106":[199,721,0.02,"Sahoke, Sangrur"],
"148107":[188,769,0.02,"Dhaula, Barnala"],
"148108":[240,797,0.02,"Pakho Kalan, Barnala"],
"148109":[215,510,0.18,"Nangal Thulewal, Barnala"],
"151001":[367,1093,0.11,"Bathinda, Bathinda"],
"151002":[367,810,0.08,"Deon, Bathinda"],
"151003":[290,547,0.09,"Nfl Bathinda, Bathinda"],
"151004":[367,1160,0.11,"Bathinda Cantt, Bathinda"],
"151005":[394,1262,0.38,"Bir Behman, Bathinda"],
"151006":[367,1088,0.11,"NDC Bathinda, Bathinda"],
"151007":[352,1500,0.25,"Bhisiana, Bathinda"],
"151101":[333,1204,0.11,"Bhucho Khurd, Bathinda"],
"151102":[162,1063,0.07,"Nathpura, Bathinda"],
"151103":[201,853,0.04,"Ballian Wali, Bathinda"],
"151104":[204,897,0.04,"Alike, Bathinda"],
"151105":[240,926,0.05,"Bhaini Kani, Bathinda"],
"151106":[169,895,0.06,"Gumti Kalan, Bathinda"],
"151108":[168,903,0.06,"Kaur Singh Wala, Bathinda"],
"151111":[264,861,0.06,"Lehra Bega, Bathinda"],
"151201":[323,991,0.26,"Ganga, Bathinda"],
"151202":[338,1563,0.19,"Chaina, Faridkot"],
"151203":[270,1303,0.03,"Faridkot, Faridkot"],
"151204":[240,1174,0.02,"Dhilwan Kalan, Faridkot"],
"151205":[197,1343,0.02,"Romana Ajit Singh, Faridkot"],
"151206":[226,1255,0.03,"Kotha Guru, Bathinda"],
"151207":[229,953,0.02,"Jiwanwala, Faridkot"],
"151208":[226,1056,0.01,"Bambhia Bhai Ka, Moga"],
"151209":[255,1262,0.02,"Machaki Mal Singh, Faridkot"],
"151210":[229,1133,0.03,"Mohlan, Sri Muktsar Sahib"],
"151211":[366,1223,0.36,"Haku Wala, Sri Muktsar Sahib"],
"151212":[323,1382,0.17,"Bihle Wala, Faridkot"],
"151213":[281,1260,0.04,"Kammiana, Faridkot"],
"151214":[270,2208,0.05,"Bhagthala Kalan, Faridkot"],
"151301":[344,1189,0.1,"Bangi Rughu, Bathinda"],
"151302":[250,747,0.26,"Behman Jassa Singh Wala, Bathinda"],
"151401":[251,971,0.38,"Dunne Wala, Bathinda"],
"151501":[249,1390,0.11,"Gobindpura, Mansa"],
"151502":[242,1662,0.28,"Borewal, Mansa"],
"151503":[266,967,0.19,"Saidewala, Mansa"],
"151504":[206,472,0.85,"Hiron Kalan, Mansa"],
"151505":[390,926,0.13,"Gehley, Mansa"],
"151506":[259,1146,0.18,"Kusla, Mansa"],
"151507":[245,1585,0.1,"Jhanda Khurd, Mansa"],
"151508":[231,746,0.38,"Khokhar Kalan, Mansa"],
"151509":[288,1022,0.14,"Jodhpur Pakhar, Bathinda"],
"151510":[206,670,0.37,"Aklia, Mansa"],
"151511":[410,1547,0.13,"Tung Wali, Bathinda"],
"152001":[235,1372,0.02,"Ferozepur, Firozepur"],
"152002":[212,973,0.04,"Jhok Tehal Singh, Firozepur"],
"152003":[213,979,0.04,"Dhira Patra, Firozepur"],
"152004":[322,1664,0.05,"Bazidpur, Firozepur"],
"152005":[226,1642,0.03,"Khosa Dal Singh, Firozepur"],
"152020":[305,1972,0.01,"Behak, Fazilka"],
"152021":[179,1385,0.01,"Malluwalia Wala, Firozepur"],
"152022":[234,1150,0.02,"Sharienwala, Firozepur"],
"152023":[236,548,0.02,"Chhanga Khurd, Firozepur"],
"152024":[376,1685,0.01,"Bahamni Wala, Fazilka"],
"152025":[460,2149,0.03,"Khokhar, Sri Muktsar Sahib"],
"152026":[383,730,0.07,"Jhabel Wali, Sri Muktsar Sahib"],
"152028":[131,777,0.02,"Khosa Randhir, Moga"],
"152031":[639,2409,0.1,"Kauni, Sri Muktsar Sahib"],
"152032":[231,887,0.12,"Bam, Sri Muktsar Sahib"],
"152033":[221,820,0.04,"Ratta Khera, Fazilka"],
"152101":[774,2144,0.08,"Channu, Sri Muktsar Sahib"],
"152107":[478,1501,0.09,"Malout Village, Sri Muktsar Sahib"],
"152112":[313,1418,0.13,"Khunan Kalan, Sri Muktsar Sahib"],
"152113":[296,1688,0.07,"Bhitti Wala, Sri Muktsar Sahib"],
"152114":[353,2094,0.08,"Mahuana, Sri Muktsar Sahib"],
"152115":[210,2088,0.05,"Dabwali Dhab, Sri Muktsar Sahib"],
"152116":[520,3700,0.11,"Burj Mohar, Fazilka"],
"152117":[300,1619,0.06,"Chanan Khera, Fazilka"],
"152118":[160,975,0.01,"Khuban, Fazilka"],
"152121":[320,775,0.06,"Mamu Khera, Fazilka"],
"152122":[491,1362,0.07,"Bazidpur Kattianwali, Fazilka"],
"152123":[310,1479,0.01,"Hasta Kalan, Fazilka"],
"152124":[428,1580,0.18,"Dabwala Kalan, Fazilka"],
"152128":[394,1372,0.06,"Diwan Khera, Fazilka"],
"152132":[685,2484,0.36,"Gumjal, Fazilka"],
"160001":[179,343,0.14,"Khuda Ali Sher, Chandigarh"],
"160002":[179,510,0.08,"Hallomajra, Chandigarh"],
"160003":[174,610,0.09,"Behlana, Chandigarh"],
"160004":[179,725,0.12,"Airforce Highground, Chandigarh"],
"160006":[152,358,0.08,"NDC Chandigarh, Chandigarh"],
"160009":[179,345,0.15,"Sector 9 Chandigarh, Chandigarh"],
"160011":[169,336,0.12,"Sector 11 Chandigarh, Chandigarh"],
"160012":[159,337,0.03,"Engg College, Chandigarh"],
"160014":[186,529,0.69,"Tira, Chandigarh"],
"160015":[144,349,0.04,"Sector 15 Chandigarh, Chandigarh"],
"160017":[152,358,0.08,"Chandigarh GPO, Chandigarh"],
"160018":[159,343,0.07,"Sector 18 Chandigarh, Chandigarh"],
"160019":[179,327,0.14,"Raj Bhawan SO Chandigarh, Chandigarh"],
"160020":[152,358,0.08,"Sector 20 Chandigarh, Chandigarh"],
"160022":[144,371,0.09,"Sector 35 Chandigarh, Chandigarh"],
"160023":[152,371,0.08,"Sector 23 Chandigarh, Chandigarh"],
"160025":[185,463,0.06,"Maloya Colony, Chandigarh"],
"160030":[159,347,0.08,"Sector 29 Chandigarh, Chandigarh"],
"160036":[144,409,0.12,"Sector 40 Chandigarh, Chandigarh"],
"160043":[144,404,0.12,"Sector43 Chandigarh, Chandigarh"],
"160047":[179,558,0.1,"Burail, Chandigarh"],
"160055":[174,463,0.09,"Balongi, S.A.S Nagar"],
"160059":[160,628,0.12,"Chandigarh Sector 60, S.A.S Nagar"],
"160062":[160,616,0.09,"Chandigarh Sector 67, S.A.S Nagar"],
"160101":[174,530,0.09,"Kishangarh, Chandigarh"],
"160102":[174,584,0.09,"Raipur Kalan, Chandigarh"],
"160103":[186,529,0.69,"Naya Gaon SO Mohali, S.A.S Nagar"],
"160104":[186,529,0.69,"Dhakaoli, S.A.S Nagar"],
"171001":[237,413,0.03,"Shimla GPO, Shimla"],
"171002":[237,412,0.03,"Shimla East, Shimla"],
"171005":[244,535,-1,"Chaili, Shimla"],
"171006":[181,278,0.39,"Malyana, Shimla"],
"171008":[236,416,0.03,"Jutogh, Shimla"],
"171009":[179,284,0.04,"Rajhana, Shimla"],
"171010":[237,412,0.03,"Tara Devi, Shimla"],
"171011":[191,307,0.34,"Badehari, Shimla"],
"171015":[243,443,0.04,"Baldeyan, Shimla"],
"171018":[230,462,-1,"Majhiwar, Shimla"],
"171019":[236,417,0.03,"Gadheri, Shimla"],
"171102":[186,279,0.25,"Danoghat, Solan"],
"171203":[198,295,0.35,"Ghasani, Shimla"],
"171204":[236,417,0.03,"Galeha, Shimla"],
"171205":[237,412,0.03,"Dhar, Shimla"],
"171209":[248,470,-1,"Majhar, Shimla"],
"171210":[209,363,-1,"Bharanu, Shimla"],
"171214":[236,519,-1,"Thana, Shimla"],
"171218":[188,300,0.4,"Junga, Shimla"],
"171219":[173,261,0.03,"Anandpur, Shimla"],
"171226":[198,295,0.35,"Deothi Manjghaon, Shimla"],
"171301":[244,535,-1,"Juni, Shimla"],
"172002":[177,301,-1,"Sarahan, Kullu"],
"172023":[177,301,-1,"Jadoli, Kullu"],
"172025":[177,301,-1,"Kandagai, Kullu"],
"172026":[177,301,-1,"Kandugad, Kullu"],
"172032":[177,301,-1,"Ladhagi, Kullu"],
"172033":[177,301,-1,"Tandi, Kullu"],
"173001":[259,932,-1,"Nahan, Sirmaur"],
"173021":[148,237,-1,"Kotribyas, Sirmaur"],
"173022":[199,471,-1,"Bharog Baneri, Sirmaur"],
"173023":[199,471,-1,"Lanapalar, Sirmaur"],
"173024":[190,289,0.44,"Bagpashog, Sirmaur"],
"173025":[149,327,-1,"Bhagani, Sirmaur"],
"173026":[189,1004,-1,"Kw Bhood, Sirmaur"],
"173027":[190,289,0.44,"Gawali, Sirmaur"],
"173029":[152,228,-1,"Jamna, Sirmaur"],
"173030":[310,732,0.01,"Bramapapri, Sirmaur"],
"173031":[201,479,-1,"Girinagar, Sirmaur"],
"173032":[190,289,0.44,"Charna, Sirmaur"],
"173033":[190,284,0.43,"Sharia, Sirmaur"],
"173101":[190,289,0.44,"Chhapang, Sirmaur"],
"173104":[295,793,-1,"Kuffar Kiara, Sirmaur"],
"173201":[170,270,0.23,"Garkhal, Solan"],
"173202":[180,278,0.29,"Sanawar, Solan"],
"173204":[170,268,0.22,"Kasauli RI, Solan"],
"173205":[186,279,0.25,"Karuana, Solan"],
"173206":[186,279,0.25,"Bharti, Solan"],
"173207":[186,279,0.25,"Jubla, Solan"],
"173208":[186,279,0.25,"Shalaghat, Solan"],
"173209":[186,279,0.25,"Jabli, Solan"],
"173210":[195,300,0.23,"Dagshai, Solan"],
"173211":[185,279,0.25,"Barog RS, Solan"],
"173212":[186,279,0.25,"Solan, Solan"],
"173213":[185,279,0.25,"Basal, Solan"],
"173214":[190,287,0.25,"Salogra, Solan"],
"173215":[186,279,0.25,"Kawarag, Solan"],
"173217":[230,337,0.06,"Hinner, Solan"],
"173218":[186,279,0.25,"Badhalag, Solan"],
"173220":[191,320,0.39,"Pratha, Solan"],
"173221":[186,279,0.25,"Bhumati, Solan"],
"173222":[145,218,-1,"Mamlig, Solan"],
"173223":[190,289,0.44,"Drabla, Sirmaur"],
"173225":[186,279,0.25,"Kot, Solan"],
"173229":[194,300,0.22,"Bohli, Solan"],
"173230":[197,294,0.35,"Nauni, Solan"],
"173233":[186,279,0.25,"Bandh Bhaguri, Solan"],
"173234":[230,337,0.06,"Kaithlighat, Solan"],
"173235":[186,279,0.25,"Bhararighat, Solan"],
"173236":[214,363,0.18,"Kuthar, Solan"],
"173237":[201,389,0.01,"Panjhera, Solan"],
"174001":[195,307,-1,"Bilaspur Bilaspur HP, Bilaspur"],
"174002":[307,514,0.48,"Kaulan Wala Toba, Bilaspur"],
"174003":[281,666,-1,"Majhwar, Bilaspur"],
"174004":[194,371,-1,"Malyaur, Bilaspur"],
"174005":[249,430,-1,"Raghunath Pura, Bilaspur"],
"174011":[205,338,-1,"Tanbol, Bilaspur"],
"174012":[268,673,-1,"Dhoun Kothi, Bilaspur"],
"174013":[290,692,-1,"Nanawan, Bilaspur"],
"174015":[204,430,0.1,"Lakhnoo, Bilaspur"],
"174017":[232,428,0.01,"Dhani Pukher, Bilaspur"],
"174021":[255,662,-1,"Bhager, Bilaspur"],
"174023":[203,384,-1,"Dangar, Bilaspur"],
"174024":[275,591,-1,"Rishikesh, Bilaspur"],
"174026":[280,665,-1,"Tantha, Bilaspur"],
"174027":[238,565,-1,"Bhapral, Bilaspur"],
"174028":[267,612,-1,"Kot, Bilaspur"],
"174029":[292,547,0.07,"Baragoan, Bilaspur"],
"174030":[222,376,0.07,"Gangloh, Bilaspur"],
"174031":[248,453,0.11,"Balghar, Bilaspur"],
"174032":[259,389,-1,"Dagsech, Bilaspur"],
"174033":[180,288,-1,"Makri, Bilaspur"],
"174034":[231,431,0.01,"Dahad, Bilaspur"],
"174035":[257,458,0.07,"Bharoli Kalan, Bilaspur"],
"174036":[268,674,-1,"Bauhat Kasol, Bilaspur"],
"174101":[185,279,0.25,"Kundlu, Solan"],
"174102":[186,279,0.25,"Doli, Solan"],
"174103":[170,268,0.22,"Mandhala, Solan"],
"174201":[239,359,0.16,"Bhakra, Bilaspur"],
"174301":[209,357,0.19,"Ajauli, Una"],
"174302":[169,352,-1,"Batuhi, Una"],
"174303":[170,387,-1,"Una, Una"],
"174304":[195,371,-1,"Loharda, Hamirpur"],
"174305":[204,407,-1,"Barsar, Hamirpur"],
"174306":[200,368,0.03,"Tabba Behdala, Una"],
"174307":[168,286,-1,"Thathoon, Una"],
"174308":[176,352,-1,"Chamiari, Una"],
"174309":[222,419,-1,"Nara, Hamirpur"],
"174310":[204,458,0.06,"Janali, Bilaspur"],
"174311":[195,320,-1,"Karer, Hamirpur"],
"174312":[168,282,-1,"Batarli Upperli, Hamirpur"],
"174314":[169,332,-1,"Bhalaun, Una"],
"174315":[200,355,0.2,"Charatghar, Una"],
"174316":[170,329,-1,"Diara, Una"],
"174317":[170,372,-1,"Bhadsali, Una"],
"174319":[146,206,0.01,"Ganu, Una"],
"174320":[174,291,-1,"Talmehra, Una"],
"174321":[178,381,-1,"Khurwain, Una"],
"174405":[168,270,-1,"Gahli Kohlwin, Hamirpur"],
"174503":[189,352,0.01,"Polian Beet, Una"],
"174505":[195,293,-1,"Changar, Hamirpur"],
"174507":[214,332,0.17,"Bathu, Una"],
"175001":[242,500,-1,"Mandi, Mandi"],
"175002":[242,586,-1,"Jugahan, Mandi"],
"175003":[242,504,-1,"Khadyad, Mandi"],
"175004":[242,504,-1,"Tikri Sidhwani, Mandi"],
"175005":[242,504,-1,"Katindi, Mandi"],
"175006":[242,504,-1,"Kummi, Mandi"],
"175007":[242,504,-1,"Hari Behna, Mandi"],
"175008":[242,720,-1,"Sadhyani, Mandi"],
"175009":[242,501,-1,"Alsindi, Mandi"],
"175010":[242,504,-1,"Kanda Churag, Mandi"],
"175011":[230,509,-1,"Kaw, Mandi"],
"175012":[234,436,-1,"Kunnu, Mandi"],
"175013":[242,504,-1,"Baragraon, Kangra"],
"175014":[242,504,-1,"Jhamerh, Mandi"],
"175015":[242,504,-1,"Balhjoli, Mandi"],
"175016":[104,155,-1,"Balhkwar, Mandi"],
"175017":[290,691,-1,"Batwara, Mandi"],
"175018":[242,504,-1,"Chambi, Mandi"],
"175019":[242,604,-1,"Sunder Nagar Township, Mandi"],
"175020":[155,231,-1,"Harabagh, Mandi"],
"175021":[242,504,-1,"Gutkar, Mandi"],
"175022":[230,509,-1,"Kelodhar, Mandi"],
"175023":[242,615,-1,"Ghambhar Khad, Mandi"],
"175024":[261,591,-1,"Khalardu, Mandi"],
"175025":[257,665,-1,"Gharwasra, Mandi"],
"175026":[163,203,-1,"Nalyana, Mandi"],
"175027":[242,636,-1,"Brikhmani, Mandi"],
"175028":[242,588,-1,"Shala, Mandi"],
"175029":[242,545,-1,"Bara, Mandi"],
"175030":[270,631,-1,"Baroti, Mandi"],
"175031":[275,612,-1,"Movi Devi Galoo, Mandi"],
"175032":[242,504,-1,"Ahju, Mandi"],
"175033":[242,504,-1,"Bahnu, Mandi"],
"175034":[265,621,-1,"Bachwan, Mandi"],
"175035":[226,375,-1,"Thanashiva, Mandi"],
"175036":[242,715,-1,"Dasehra, Mandi"],
"175037":[275,591,-1,"Sadhot, Mandi"],
"175038":[380,1062,-1,"Seri Kothi, Mandi"],
"175039":[261,585,-1,"Jahal, Mandi"],
"175040":[242,504,-1,"Kot BO Dharampur, Mandi"],
"175042":[261,597,-1,"Basantpur, Mandi"],
"175045":[298,697,-1,"Silhanu, Mandi"],
"175046":[231,514,-1,"Thanda Pani, Mandi"],
"175047":[277,610,-1,"Chathri, Mandi"],
"175048":[242,504,-1,"Cheuni, Mandi"],
"175049":[242,504,-1,"Gehra, Mandi"],
"175050":[261,589,-1,"Binga, Mandi"],
"175051":[106,156,-1,"Seoh, Mandi"],
"175052":[257,535,-1,"Baryara, Mandi"],
"175075":[225,451,-1,"Kamand, Mandi"],
"175101":[371,846,-1,"Kullu, Kullu"],
"175102":[282,587,-1,"Dugilag, Kullu"],
"175103":[298,640,-1,"Palchan, Kullu"],
"175104":[312,679,-1,"Archandi, Kullu"],
"175105":[258,517,-1,"Kasladi, Kullu"],
"175106":[153,192,-1,"Ghaniar, Mandi"],
"175121":[242,504,-1,"Panarsa, Mandi"],
"175123":[176,266,-1,"Bachoot, Kullu"],
"175124":[249,539,-1,"Deori, Mandi"],
"175125":[158,365,-1,"Chheur, Kullu"],
"175126":[158,369,-1,"Mohal, Kullu"],
"175128":[297,631,-1,"Bandrole, Kullu"],
"175129":[309,670,-1,"Baragaon, Kullu"],
"175130":[306,663,-1,"Raman, Kullu"],
"175131":[262,527,-1,"Bran, Kullu"],
"175134":[153,192,-1,"Bajahara, Kullu"],
"175136":[418,982,-1,"Karjan, Kullu"],
"175138":[322,705,-1,"Neoli, Kullu"],
"175141":[207,363,-1,"Dyar, Kullu"],
"175143":[261,526,-1,"Prini, Kullu"],
"176001":[150,280,-1,"Kangra, Kangra"],
"176002":[150,259,-1,"Tanda, Kangra"],
"176021":[185,488,-1,"Dhasoli, Kangra"],
"176022":[245,457,-1,"Gadrana, Kangra"],
"176023":[202,419,-1,"Har, Kangra"],
"176025":[166,243,0.01,"Polian, Kangra"],
"176026":[150,238,-1,"Dadoli, Kangra"],
"176027":[218,359,-1,"Katholi, Kangra"],
"176028":[138,236,-1,"Kherian, Kangra"],
"176029":[150,223,-1,"Gheen, Kangra"],
"176030":[157,278,-1,"Nahlian, Kangra"],
"176031":[166,330,-1,"Baggi, Kangra"],
"176032":[157,319,-1,"Majhin, Kangra"],
"176033":[157,246,-1,"Bilaspur, Kangra"],
"176036":[174,319,-1,"Digger, Kangra"],
"176037":[142,232,-1,"Balol, Kangra"],
"176038":[149,200,0.01,"Jalari, Kangra"],
"176039":[219,389,0.07,"Phagoti, Hamirpur"],
"176040":[175,298,-1,"Dhangota, Hamirpur"],
"176041":[184,332,-1,"Jhiralari, Hamirpur"],
"176042":[190,361,-1,"Dain, Hamirpur"],
"176043":[197,353,-1,"Khuthrin, Hamirpur"],
"176044":[264,617,-1,"Karohta, Hamirpur"],
"176045":[211,456,-1,"Jakhyol, Hamirpur"],
"176047":[157,288,-1,"Jalot, Kangra"],
"176048":[262,602,-1,"Kakrot, Hamirpur"],
"176049":[186,342,-1,"Sathwin, Hamirpur"],
"176051":[202,314,-1,"Dahab, Kangra"],
"176052":[200,251,-1,"Kardiana, Kangra"],
"176053":[190,456,-1,"Gadroli, Kangra"],
"176054":[157,252,-1,"Jassai, Kangra"],
"176055":[222,445,-1,"Barikalan, Kangra"],
"176056":[157,274,-1,"Dhaloon, Kangra"],
"176057":[178,250,-1,"Dari, Kangra"],
"176058":[158,234,0.9,"Bahadpur, Kangra"],
"176059":[155,227,-1,"Hangloh, Kangra"],
"176060":[178,250,-1,"Ghaneta, Kangra"],
"176061":[90,217,-1,"Palampur, Kangra"],
"176062":[90,228,-1,"Auc Palampur, Kangra"],
"176063":[120,172,-1,"Rajot, Kangra"],
"176064":[204,395,0.37,"Pharer, Kangra"],
"176065":[138,221,-1,"Gadiara, Kangra"],
"176066":[174,300,-1,"Ghallour, Kangra"],
"176067":[105,194,-1,"Patti, Kangra"],
"176071":[120,186,-1,"Drug, Kangra"],
"176073":[142,228,-1,"Paplah, Kangra"],
"176075":[148,255,-1,"Duhak, Kangra"],
"176076":[120,176,-1,"Majhera, Kangra"],
"176077":[115,179,-1,"Gunehar, Kangra"],
"176081":[120,166,-1,"Jhikli Bheth, Kangra"],
"176082":[143,242,-1,"Balakrupi, Kangra"],
"176083":[120,203,-1,"Boda Lower, Kangra"],
"176084":[142,219,-1,"Gharana, Kangra"],
"176085":[120,209,-1,"Nanaon, Kangra"],
"176086":[129,190,-1,"Baidapatt, Kangra"],
"176087":[105,175,-1,"Thandole, Kangra"],
"176088":[117,177,-1,"Bhirri, Kangra"],
"176089":[118,178,-1,"Maila, Kangra"],
"176090":[107,157,-1,"Cholangarh, Mandi"],
"176091":[119,178,-1,"Haler, Kangra"],
"176092":[120,173,-1,"Boda Lauhanti, Kangra"],
"176093":[120,179,-1,"Kona, Kangra"],
"176094":[120,171,-1,"Ashapuri, Kangra"],
"176095":[119,176,-1,"Karanghat, Kangra"],
"176096":[128,209,-1,"Maharajnagar, Kangra"],
"176097":[141,233,-1,"Barram Khurd, Kangra"],
"176098":[161,274,-1,"Bhatwan, Kangra"],
"176101":[137,218,-1,"Bhadrol, Kangra"],
"176102":[120,214,-1,"Saloh, Kangra"],
"176103":[120,186,-1,"Tatehal, Kangra"],
"176107":[153,254,-1,"Bachhwai, Kangra"],
"176108":[157,255,-1,"Karot, Hamirpur"],
"176109":[140,232,-1,"Kheri, Hamirpur"],
"176110":[154,254,-1,"Bir Bagehra, Hamirpur"],
"176111":[162,240,-1,"Jol Lambri, Hamirpur"],
"176115":[120,170,-1,"Haded, Kangra"],
"176125":[120,166,-1,"Dhanag, Kangra"],
"176128":[116,177,-1,"Gawal, Kangra"],
"176200":[240,371,-1,"Hatli Jamwala, Kangra"],
"176201":[190,292,0.01,"Rit Lower, Kangra"],
"176202":[208,362,0.02,"Gahin Lagore, Kangra"],
"176203":[230,366,0.02,"Chowki, Kangra"],
"176204":[242,341,-1,"Balakh, Kangra"],
"176205":[216,360,-1,"Bahi Pathiar, Kangra"],
"176206":[230,362,-1,"Bhalli, Kangra"],
"176207":[230,383,-1,"Bilana, Chamba"],
"176208":[226,358,-1,"Nerti, Kangra"],
"176209":[200,269,-1,"Bandi, Kangra"],
"176210":[240,457,-1,"Manai, Kangra"],
"176211":[219,358,0.02,"Khawara, Kangra"],
"176214":[206,303,-1,"Bassi, Kangra"],
"176215":[206,272,-1,"Dharamsala, Kangra"],
"176216":[212,341,-1,"Bhagsu Nath, Kangra"],
"176217":[226,366,-1,"Dodhamb, Kangra"],
"176218":[200,264,-1,"Khaniara, Kangra"],
"176225":[220,412,-1,"Soldha, Kangra"],
"176301":[220,377,0.02,"Balera, Chamba"],
"176302":[222,363,0.02,"Ghatasnipul, Chamba"],
"176303":[218,411,0.02,"Garh, Chamba"],
"176304":[218,411,0.02,"Dalhousie, Chamba"],
"176305":[218,411,0.02,"Dalhousie cantt, Chamba"],
"176306":[210,376,0.02,"Sherpur, Chamba"],
"176307":[225,389,0.01,"Kirri, Chamba"],
"176308":[219,469,0.01,"Simni, Chamba"],
"176309":[218,341,-1,"Ulansa, Chamba"],
"176310":[218,418,0.02,"Chamba, Chamba"],
"176311":[230,394,-1,"Churi, Chamba"],
"176312":[204,379,0.19,"Athedgwalu, Chamba"],
"176313":[225,368,0.02,"Awan, Chamba"],
"176314":[218,418,0.02,"Basodhan, Chamba"],
"176315":[164,231,-1,"Pranghala, Chamba"],
"176316":[250,628,-1,"Ail, Chamba"],
"176317":[204,378,0.2,"Surangani, Chamba"],
"176318":[218,418,0.02,"Rajera, Chamba"],
"176319":[226,370,0.19,"Jhullara, Chamba"],
"176320":[203,377,0.2,"Bhandal, Chamba"],
"176321":[219,469,0.01,"Deola, Chamba"],
"176323":[250,628,-1,"Karel Punto, Chamba"],
"176324":[237,409,-1,"Chhatrari, Chamba"],
"176325":[219,469,0.01,"Baggi Kanged, Chamba"],
"176326":[160,235,-1,"Nayagram, Chamba"],
"176330":[203,376,0.21,"Badka, Chamba"],
"176401":[229,353,0.07,"Surarwan, Kangra"],
"176402":[190,347,0.03,"Dah, Kangra"],
"176403":[197,290,0.03,"Chhanni, Kangra"],
"176501":[151,206,0.27,"Amroh, Kangra"],
"176502":[160,256,-1,"Bari, Kangra"],
"176601":[189,369,-1,"Biderwal, Una"],
"177001":[175,298,-1,"Hamirpur HO HP Circle, Hamirpur"],
"177005":[175,298,-1,"NIT Hamirpur, Hamirpur"],
"177006":[216,335,0.01,"Mansai, Hamirpur"],
"177007":[157,210,-1,"Ree, Hamirpur"],
"177020":[172,298,-1,"Amroh, Hamirpur"],
"177021":[181,295,-1,"Bagwara, Hamirpur"],
"177022":[150,191,-1,"Banalag, Hamirpur"],
"177023":[180,290,-1,"Barara, Hamirpur"],
"177024":[259,590,-1,"Chanruhi, Hamirpur"],
"177025":[182,299,-1,"Dho, Hamirpur"],
"177026":[168,281,-1,"Balh Uttap, Hamirpur"],
"177027":[180,312,-1,"Sarahkar, Hamirpur"],
"177028":[136,172,-1,"Bauru, Hamirpur"],
"177029":[178,313,-1,"Bharthian, Hamirpur"],
"177031":[269,617,-1,"Chulhari, Una"],
"177033":[166,300,-1,"Kohla, Hamirpur"],
"177034":[166,275,-1,"Nihari, Kangra"],
"177038":[166,268,-1,"Majhiar, Hamirpur"],
"177039":[168,319,-1,"Bhindla, Una"],
"177040":[162,206,-1,"Badehra, Hamirpur"],
"177041":[157,251,-1,"Gwal Pathar, Hamirpur"],
"177042":[157,270,-1,"Batran, Hamirpur"],
"177043":[175,279,-1,"Bharoli Jadid, Kangra"],
"177044":[161,256,-1,"Choru, Hamirpur"],
"177045":[154,263,-1,"Putrial, Hamirpur"],
"177048":[162,234,-1,"Booni Nohngi, Hamirpur"],
"177101":[157,328,-1,"Dehra, Kangra"],
"177103":[174,302,-1,"Bagli, Kangra"],
"177104":[174,304,-1,"Nalsuha, Kangra"],
"177105":[154,237,0.01,"Beh, Kangra"],
"177106":[174,303,-1,"Gurnwar, Kangra"],
"177107":[174,294,-1,"Lag Baliana, Kangra"],
"177108":[174,287,-1,"Maira Bani, Kangra"],
"177109":[175,287,-1,"Kinoo, Una"],
"177110":[153,227,0.01,"Sawana, Kangra"],
"177111":[151,231,0.01,"Behar Kuthera, Kangra"],
"177112":[149,218,0.01,"Bathra, Kangra"],
"177113":[120,266,-1,"Jambal, Kangra"],
"177114":[157,269,-1,"Paisa, Kangra"],
"177117":[157,290,-1,"Karyara, Kangra"],
"177118":[265,623,-1,"Lagmanwin, Hamirpur"],
"177119":[222,388,-1,"Ghumarli, Hamirpur"],
"177201":[165,267,0.02,"Kaloh, Una"],
"177202":[158,252,0.03,"Mubarikpur, Una"],
"177203":[171,287,0.03,"Daloh, Una"],
"177204":[151,204,0.01,"Bhadarkali, Una"],
"177205":[222,448,-1,"Ambota, Una"],
"177206":[169,282,0.02,"Kuthera Jaswalan, Una"],
"177207":[169,387,-1,"Khad, Una"],
"177208":[170,350,-1,"Guglehar, Una"],
"177209":[181,371,-1,"Kanger, Una"],
"177210":[171,266,-1,"Polian Purohitan, Una"],
"177211":[171,298,0.03,"Takarala, Una"],
"177212":[172,349,-1,"Nangal Jarialan, Una"],
"177213":[170,325,-1,"Kadh, Una"],
"177219":[160,245,0.03,"Kuneran, Una"],
"177220":[189,366,-1,"Baliwal, Una"],
"177301":[157,263,-1,"Jhalan, Hamirpur"],
"177401":[182,326,-1,"Dhanwin, Hamirpur"],
"177501":[193,332,-1,"Thathwani, Hamirpur"],
"177601":[215,478,-1,"Badhani, Hamirpur"],
"180001":[285,478,1.5,"Jammu, Jammu"],
"180002":[280,453,1.43,"Gho Manhasan, Jammu"],
"180003":[232,421,0.67,"Mandal, Jammu"],
"180004":[275,476,1.15,"Gandhinagar, Jammu"],
"180005":[280,466,1.56,"Karan Nagar SO Jammu, Jammu"],
"180006":[285,501,1.36,"New University Campus, Jammu"],
"180007":[160,853,0.14,"Janipur High Court, Jammu"],
"180009":[285,516,0.84,"SKUASTCHATHA, Jammu"],
"180010":[275,485,0.88,"Kalu Chak, Jammu"],
"180011":[269,480,0.75,"Sunjwan, Jammu"],
"180012":[275,502,1.23,"Meghdoot Bhawan, Jammu"],
"180013":[234,445,1.7,"Roopnagar Jammu Tawi, Jammu"],
"180015":[275,485,1.0,"Chani Himat, Jammu"],
"180016":[285,480,1.49,"Vinaik Bazar, Jammu"],
"180017":[234,471,1.47,"Aitham, Jammu"],
"180018":[265,411,1.92,"Udheywala, Jammu"],
"180019":[280,421,1.67,"Sidhra Housing colony, Jammu"],
"180020":[275,492,1.07,"TRIKUTA NAGAR, Jammu"],
"181008":[285,471,1.16,"Raipur Satwari, Jammu"],
"181101":[275,523,0.67,"Khour Devian, Jammu"],
"181102":[290,572,0.68,"Agra Chak, Jammu"],
"181111":[300,640,1.19,"Goondla, Jammu"],
"181121":[280,449,1.63,"AGOffice, Jammu"],
"181122":[211,388,1.24,"Ranjan, Jammu"],
"181123":[232,429,1.76,"Raipur, Jammu"],
"181124":[244,431,1.95,"Bsf Camp Paloura, Jammu"],
"181131":[290,666,1.68,"Adlehar, Jammu"],
"181132":[294,599,0.48,"Deoli, Jammu"],
"181133":[280,494,0.57,"Birpur, Samba"],
"181134":[250,434,0.26,"AIIMS Vijaypur, Jammu"],
"181141":[260,562,0.39,"Abtal, Samba"],
"181143":[260,464,0.28,"Rahya, Samba"],
"181145":[250,444,0.46,"Khara Madana, Samba"],
"181152":[280,502,1.18,"Bathindi, Jammu"],
"181201":[200,355,0.76,"Lehar, Jammu"],
"181202":[200,270,1.02,"Devipur, Jammu"],
"181203":[208,258,1.02,"Hamirpur Sidhar, Jammu"],
"181204":[206,254,1.1,"Kot Maira, Jammu"],
"181205":[207,268,-1,"Muthi, Jammu"],
"181206":[230,406,1.58,"Halqa, Jammu"],
"181207":[206,290,1.07,"Gura Manhasan, Jammu"],
"181208":[211,401,1.16,"Bawa Talab, Jammu"],
"181221":[228,493,3.04,"JKotli, Jammu"],
"181224":[247,448,0.76,"Kanyala, Jammu"],
"182101":[213,462,1.25,"Udhampur, Udhampur"],
"182104":[210,568,1.03,"PTC Udhampur, Udhampur"],
"182121":[204,317,0.42,"Barola, Udhampur"],
"182122":[230,508,0.9,"Bland, Udhampur"],
"182124":[199,363,1.37,"Hartrian, Udhampur"],
"182125":[267,695,2.48,"Galiote, Udhampur"],
"182126":[217,610,1.19,"Bhatiari, Udhampur"],
"182127":[217,610,1.19,"Khoon, Udhampur"],
"182128":[204,392,1.52,"Jakhed, Udhampur"],
"182129":[241,502,1.77,"Bhart, Doda"],
"182130":[241,502,1.77,"Sharanwan, Udhampur"],
"182131":[241,502,1.77,"Tipri, Doda"],
"182132":[241,502,1.77,"Kither, Kishtwar"],
"182133":[241,502,1.77,"Sukhnai, Kishtwar"],
"182134":[241,502,1.77,"Gumri, Kishtwar"],
"182135":[241,502,1.77,"Rinaie, Kishtwar"],
"182136":[241,502,1.77,"Deherna, Kishtwar"],
"182137":[241,502,1.77,"Kadail, Kishtwar"],
"182138":[241,502,1.77,"Palali, Kishtwar"],
"182139":[241,502,1.77,"Garh Padder, Kishtwar"],
"182140":[241,502,1.77,"Kaban, Kishtwar"],
"182141":[253,591,0.64,"Bain, Udhampur"],
"182142":[253,592,0.64,"Ishtahari, Udhampur"],
"182143":[253,592,0.64,"Ranka, Doda"],
"182144":[241,509,1.73,"Dalwah, Ramban"],
"182145":[205,383,1.32,"Alambas, Ramban"],
"182146":[240,506,1.3,"Mahu, Ramban"],
"182147":[249,408,0.09,"Dhandal, Doda"],
"182148":[258,664,0.82,"Neera, Ramban"],
"182161":[189,359,0.79,"Bapp, Udhampur"],
"182201":[254,340,1.46,"Dhara, Doda"],
"182202":[254,340,1.46,"Bhagwa, Doda"],
"182203":[285,547,0.0,"Inharrah, Doda"],
"182204":[195,310,1.11,"Gulabgarh, Kishtwar"],
"182205":[296,445,1.74,"Aftee, Kishtwar"],
"182206":[249,326,1.43,"Dul Hasti Project, Kishtwar"],
"182207":[265,357,1.49,"GANDOH, Doda"],
"182221":[254,340,1.46,"Kursari, Doda"],
"182222":[216,324,0.98,"Chanichinta, Doda"],
"182301":[204,317,0.42,"Adhkawari, Reasi"],
"182311":[262,353,1.92,"Bagdar SERI, Reasi"],
"182312":[297,547,1.91,"Salal, Reasi"],
"182313":[204,317,0.42,"Jij, Reasi"],
"182315":[204,317,0.42,"Gulabgarh, Reasi"],
"182320":[228,563,1.55,"Kakriyal, Reasi"],
"184101":[186,278,1.55,"Kathua, Kathua"],
"184102":[181,263,1.26,"Jarai, Kathua"],
"184104":[188,256,1.1,"Changran, Kathua"],
"184120":[262,543,0.33,"Sanjwan, Samba"],
"184121":[242,399,0.48,"Goran, Samba"],
"184141":[228,391,0.57,"Naran, Kathua"],
"184142":[217,366,0.85,"Gurah Mundian, Kathua"],
"184143":[175,235,1.03,"Rajbagh, Kathua"],
"184144":[192,309,0.92,"Chadwal, Kathua"],
"184145":[157,584,0.04,"Chiliari, Kathua"],
"184148":[368,814,2.1,"Babia, Kathua"],
"184151":[186,233,1.05,"Saidpur, Kathua"],
"184152":[181,219,0.31,"Mah, Kathua"],
"184201":[179,309,0.11,"Banjal, Kathua"],
"184202":[163,261,0.9,"Banhore, Kathua"],
"184203":[170,259,1.69,"Dharalta, Kathua"],
"184204":[170,327,0.84,"Baggan, Kathua"],
"184205":[223,319,0.87,"Babey, Udhampur"],
"184206":[184,329,0.41,"Daggar, Kathua"],
"184210":[217,453,0.44,"UCHAPIND, Kathua"],
"185101":[218,409,0.01,"Shahpur, Poonch"],
"185102":[167,597,0.06,"Arai, Poonch"],
"185121":[239,496,1.25,"Bhata Dhurian, Poonch"],
"185131":[205,213,2.1,"Rajouri, Rajouri"],
"185132":[205,213,2.1,"Swari, Rajouri"],
"185133":[163,243,0.0,"Fatehpur, Rajouri"],
"185135":[205,311,1.3,"Raikban, Rajouri"],
"185152":[174,314,0.54,"Chani, Rajouri"],
"185153":[221,322,0.71,"Bhajwal, Rajouri"],
"185154":[211,357,1.24,"Sadhoti, Reasi"],
"185155":[228,308,0.04,"Jhanger, Rajouri"],
"185156":[300,1675,0.02,"Tilla Tanda, Rajouri"],
"185201":[214,300,0.46,"Khersoo, Rajouri"],
"185202":[174,294,0.43,"Dali, Rajouri"],
"185203":[230,508,0.9,"Allya, Reasi"],
"185211":[140,182,0.0,"Dharana, Poonch"],
"185233":[263,438,1.44,"Shergarhi, Rajouri"],
"185234":[205,213,2.09,"Kotdhara, Rajouri"],
"190001":[225,325,0.03,"Srinagar GPO, Srinagar"],
"190002":[225,324,0.03,"Fateh Kadal, Srinagar"],
"190003":[225,327,0.02,"Nandpora, Srinagar"],
"190004":[222,309,0.05,"Batwara, Srinagar"],
"190005":[222,294,0.06,"Sanat Nagar, Srinagar"],
"190006":[220,306,0.01,"Pandech, Srinagar"],
"190007":[225,308,0.06,"Sk Airport, Budgam"],
"190008":[225,323,0.03,"Jawahar Nagar, Srinagar"],
"190009":[225,322,0.03,"Central Market, Srinagar"],
"190010":[225,323,0.03,"Court Road, Srinagar"],
"190011":[220,319,0.02,"Anchar, Srinagar"],
"190012":[192,356,0.02,"Zainakote, Srinagar"],
"190014":[225,314,0.05,"Hyderpora, Budgam"],
"190015":[222,299,0.06,"A K Pora, Budgam"],
"190017":[163,318,0.03,"Paipora, Srinagar"],
"190018":[220,322,0.02,"Sebdan, Budgam"],
"190019":[222,284,0.07,"Kralpora, Budgam"],
"190020":[219,308,0.02,"Buchpora, Srinagar"],
"190021":[225,311,0.05,"Humhama, Budgam"],
"190023":[225,323,0.03,"Lal Bazar, Srinagar"],
"190024":[220,310,0.01,"Zakoora, Srinagar"],
"190025":[222,303,0.05,"Skuast, Srinagar"],
"190099":[225,328,0.02,"Nodal Delivery Center Srinagar, Srinagar"],
"191101":[144,311,0.04,"Khanmouh, Srinagar"],
"191102":[222,283,0.14,"Wuyan, Pulwama"],
"191103":[185,232,0.14,"Ludhoo, Pulwama"],
"191111":[187,299,0.06,"Arath, Budgam"],
"191112":[187,246,0.11,"Keller Mastpora, Shopian"],
"191113":[222,282,0.08,"Bogam Batapora, Budgam"],
"191121":[222,294,0.06,"New Theed, Srinagar"],
"191131":[169,322,0.17,"Qasbalar, Ganderbal"],
"191132":[222,282,0.08,"Rangreth, Budgam"],
"191201":[226,291,0.05,"Haripora, Ganderbal"],
"191202":[222,270,0.09,"Gund, Ganderbal"],
"192101":[194,676,0.05,"Anantnag, Anantnag"],
"192121":[144,315,0.04,"Konibal, Pulwama"],
"192122":[155,255,0.3,"Lathpora, Pulwama"],
"192123":[430,1811,0.67,"Aripal, Pulwama"],
"192124":[188,786,0.05,"Naina, Anantnag"],
"192125":[178,332,0.25,"Nambal, Anantnag"],
"192126":[188,605,0.13,"Mandlan, Anantnag"],
"192129":[195,690,0.05,"Salia, Anantnag"],
"192201":[192,559,0.05,"Akingam, Anantnag"],
"192202":[125,333,0.04,"Ahalangodol, Anantnag"],
"192210":[196,633,0.05,"Gosanigund, Anantnag"],
"192211":[216,244,0.05,"Hiller Shahabad, Anantnag"],
"192212":[216,243,0.05,"Nowgam, Anantnag"],
"192221":[176,766,0.05,"Brinal Lammer, Anantnag"],
"192231":[125,344,0.04,"Arrah, Kulgam"],
"192232":[182,906,0.05,"Reban Gund, Shopian"],
"192233":[169,850,0.05,"Chemmar, Kulgam"],
"192301":[135,755,0.14,"Karimabad, Pulwama"],
"192302":[160,831,0.14,"Ahagam, Pulwama"],
"192303":[100,1741,-1,"Ramnagri, Shopian"],
"192304":[180,362,0.14,"Ratnipora, Pulwama"],
"192305":[165,870,0.1,"Litter, Pulwama"],
"192401":[203,498,0.05,"Dhawtoo, Anantnag"],
"193101":[256,321,0.23,"Baramulla, Baramulla"],
"193103":[239,324,0.25,"Delina, Baramulla"],
"193108":[180,321,0.21,"Athoora, Baramulla"],
"193109":[239,324,0.26,"NOWPORA JAGIR, Baramulla"],
"193121":[144,325,0.07,"Hanjiwera, Baramulla"],
"193122":[260,361,0.48,"Chandanwari, Baramulla"],
"193123":[255,321,0.23,"Parampilla, Baramulla"],
"193201":[260,327,0.15,"Harwan, Baramulla"],
"193221":[277,334,0.16,"Kandi Khaas, Kupwara"],
"193222":[238,394,0.33,"Batpora, Kupwara"],
"193223":[163,325,0.03,"Maidanpora, Kupwara"],
"193224":[260,322,0.37,"Budnambal, Kupwara"],
"193225":[239,302,0.48,"Nachian, Kupwara"],
"193301":[260,340,0.29,"Binner, Baramulla"],
"193302":[287,382,0.17,"Nowgam, Kupwara"],
"193303":[227,314,0.18,"Chatoosa, Baramulla"],
"193306":[160,793,0.14,"Drabgam, Pulwama"],
"193401":[125,344,0.04,"Gund Khaja Kasim, Budgam"],
"193402":[144,341,0.06,"Babareshi, Baramulla"],
"193403":[259,362,0.48,"Gulmarg, Baramulla"],
"193404":[160,316,0.15,"Devpora Dardpora, Baramulla"],
"193411":[186,643,0.17,"Chanthan Checkpora, Budgam"],
"193501":[204,318,0.1,"Amchikundal, Bandipora"],
"193502":[309,378,0.09,"Ajas, Bandipora"],
"193503":[253,299,-1,"Gujran, Bandipora"],
"193504":[203,313,0.1,"Sadarkoot Bala, Bandipora"],
"193505":[276,331,0.08,"Putushy, Bandipora"],
"201001":[265,716,0.0,"Ghaziabad, Ghaziabad"],
"201002":[242,775,0.0,"Rajapur, Ghaziabad"],
"201003":[320,787,0.22,"Atore Nangla, Ghaziabad"],
"201004":[265,890,0.0,"Hindon Air Field, Ghaziabad"],
"201005":[285,842,0.26,"Pasonda, Ghaziabad"],
"201006":[265,884,0.23,"Bhopura, Ghaziabad"],
"201007":[271,821,0.27,"Mohan Nagar, Ghaziabad"],
"201008":[271,784,0.08,"Salarpur Kalan, Gautam Buddha Nagar"],
"201009":[248,766,0.02,"Chhapraula, Gautam Buddha Nagar"],
"201010":[271,890,0.22,"Hasanpur Bhowapur, Ghaziabad"],
"201011":[268,941,0.22,"Chandra Nagar, Ghaziabad"],
"201012":[271,886,0.22,"Vasundhra, Ghaziabad"],
"201013":[240,642,0.0,"Govindpuram, Ghaziabad"],
"201014":[285,889,0.22,"Shipra Sun City, Ghaziabad"],
"201015":[185,512,-1,"Adhyatmik Nagar, Ghaziabad"],
"201016":[265,770,0.02,"Crossings Republik, Ghaziabad"],
"201017":[265,904,0.0,"Raj Nagar Extension, Ghaziabad"],
"201018":[248,762,0.02,"Model Town, Ghaziabad"],
"201019":[265,809,0.02,"Vaishali, Ghaziabad"],
"201020":[265,842,0.18,"Khora, Ghaziabad"],
"201021":[265,855,0.19,"Abhay Khand 03, Ghaziabad"],
"201102":[271,693,0.28,"Badshahpur Siroli, Ghaziabad"],
"201103":[286,938,0.21,"Meerpur Hindu, Ghaziabad"],
"201201":[250,640,-1,"Churiyala, Ghaziabad"],
"201204":[230,494,-1,"Khindora, Ghaziabad"],
"201206":[253,665,0.0,"Jalalabad, Ghaziabad"],
"201301":[318,632,0.0,"Noida, Gautam Buddha Nagar"],
"201302":[265,868,0.16,"NDC Noida, Gautam Buddha Nagar"],
"201303":[212,545,0.0,"Sec41 Noida, Gautam Buddha Nagar"],
"201304":[271,794,0.08,"Gejha, Gautam Buddha Nagar"],
"201305":[265,683,0.07,"Nagla Charandas, Gautam Buddha Nagar"],
"201306":[290,726,0.1,"Kulesra, Gautam Buddha Nagar"],
"201307":[287,852,0.18,"Sarfabad, Gautam Buddha Nagar"],
"201309":[240,454,0.0,"Chhajarsi, Gautam Buddha Nagar"],
"201310":[330,1082,0.05,"Sakipur, Gautam Buddha Nagar"],
"201311":[268,714,0.08,"Pali, Gautam Buddha Nagar"],
"201312":[362,1123,0.0,"Kasna, Gautam Buddha Nagar"],
"201313":[288,937,0.15,"Amity university, Gautam Buddha Nagar"],
"201314":[245,672,0.0,"Kot, Gautam Buddha Nagar"],
"201315":[362,1115,0.0,"Gurjinder Vihar, Gautam Buddha Nagar"],
"201316":[278,791,0.07,"Sec 122 Noida, Gautam Buddha Nagar"],
"201317":[287,860,0.09,"Sec 128 Noida, Gautam Buddha Nagar"],
"201318":[265,809,0.02,"Sec 01 Greater Noida, Gautam Buddha Nagar"],
"201319":[263,688,0.06,"Nagla Charandas, Gautam Buddha Nagar"],
"201320":[265,658,0.07,"Sec 122 Noida, Gautam Buddha Nagar"],
"202001":[333,956,-1,"Aligarh, Aligarh"],
"202002":[255,644,-1,"Mehrawal, Aligarh"],
"202121":[241,511,-1,"Ladhaua, Aligarh"],
"202122":[255,563,-1,"Bahadurpur Kota, Aligarh"],
"202123":[463,2134,-1,"Manti Basai, Aligarh"],
"202124":[460,984,-1,"Hastpur Chandfari, Aligarh"],
"202125":[250,774,-1,"Bhavigarh, Aligarh"],
"202126":[255,548,-1,"Baraula, Aligarh"],
"202127":[250,507,-1,"Talib Nagar, Aligarh"],
"202128":[256,609,0.0,"Changeri, Aligarh"],
"202129":[244,530,0.0,"Bhilet Ramnagar, Aligarh"],
"202130":[266,571,0.0,"Habibganj, Aligarh"],
"202131":[330,616,0.0,"Badesara, Aligarh"],
"202132":[360,1043,-1,"Ogipur, Aligarh"],
"202133":[267,543,0.0,"Haranpur Kalan, Aligarh"],
"202134":[238,502,-1,"Kanobi, Aligarh"],
"202135":[490,1731,-1,"Aidalpur, Aligarh"],
"202136":[250,516,-1,"Mohrena, Aligarh"],
"202137":[333,1271,0.0,"Hetalpur, Aligarh"],
"202138":[463,1701,-1,"Jarara, Aligarh"],
"202139":[230,1064,-1,"Chandaiya, Hathras"],
"202140":[476,1045,-1,"Kesopur jofari, Aligarh"],
"202141":[454,1763,-1,"Karanpur, Aligarh"],
"202142":[463,1419,-1,"Karanpur, Aligarh"],
"202143":[290,792,-1,"Madhaula, Aligarh"],
"202145":[500,1815,-1,"Gorai, Aligarh"],
"202146":[260,701,-1,"Mangalayatan University, Aligarh"],
"202150":[325,1000,-1,"Malikpura, Aligarh"],
"202155":[456,1774,-1,"Jalalpur, Aligarh"],
"202165":[274,1015,0.0,"Siarol, Aligarh"],
"202170":[304,703,-1,"Kathera, Aligarh"],
"202280":[287,525,0.0,"Izzatpur, Aligarh"],
"202281":[215,407,0.0,"Bembirpur, Aligarh"],
"202282":[260,554,0.0,"Jamuna, Aligarh"],
"203001":[258,451,-1,"Bulandshahr, Bulandshahr"],
"203002":[236,488,-1,"Dhamraoli, Bulandshahr"],
"203129":[210,543,-1,"Gangawaly, Bulandshahr"],
"203131":[200,644,-1,"Dinoul, Bulandshahr"],
"203132":[277,605,-1,"Bhadaura Kamalpur, Bulandshahr"],
"203135":[288,958,0.0,"Kanigarhi, Gautam Buddha Nagar"],
"203141":[292,861,-1,"Bhaipur, Gautam Buddha Nagar"],
"203150":[203,696,-1,"Manglore, Bulandshahr"],
"203155":[281,857,0.0,"Neemka, Gautam Buddha Nagar"],
"203201":[262,1083,0.0,"Parsol, Gautam Buddha Nagar"],
"203202":[270,913,-1,"Astauly, Gautam Buddha Nagar"],
"203203":[299,757,0.0,"Biraundi Tajpur, Gautam Buddha Nagar"],
"203205":[256,630,-1,"Prangarh, Bulandshahr"],
"203206":[256,635,-1,"Til BegumPur, Bulandshahr"],
"203207":[224,651,0.08,"Achheja, Gautam Buddha Nagar"],
"203209":[312,925,0.0,"Tirthaly, Gautam Buddha Nagar"],
"203389":[215,425,0.0,"Belon, Bulandshahr"],
"203390":[215,492,-1,"Bhargava Pharmecy, Bulandshahr"],
"203391":[250,601,-1,"Andhiyar, Bulandshahr"],
"203392":[198,339,-1,"Chehla, Bulandshahr"],
"203393":[202,406,-1,"Karanbash, Bulandshahr"],
"203394":[210,787,-1,"Chandauk, Bulandshahr"],
"203395":[200,623,-1,"Kailawan, Bulandshahr"],
"203396":[200,321,-1,"Lalner, Bulandshahr"],
"203397":[215,359,-1,"Biroura, Bulandshahr"],
"203398":[250,389,-1,"Ahar, Bulandshahr"],
"203399":[260,482,0.0,"Dharakpur, Bulandshahr"],
"203401":[220,408,-1,"Paswasara, Bulandshahr"],
"203402":[200,496,-1,"Benipur, Bulandshahr"],
"203403":[235,403,-1,"Bharkau, Bulandshahr"],
"203405":[220,425,-1,"Chathera, Bulandshahr"],
"203407":[212,447,-1,"Shekhpur Gadwa, Bulandshahr"],
"203408":[222,506,-1,"Banboai, Bulandshahr"],
"203409":[220,421,-1,"Birouli, Bulandshahr"],
"203411":[200,447,-1,"Barkatpur, Bulandshahr"],
"203412":[240,510,-1,"Baddha Bazidpur, Bulandshahr"],
"203413":[263,437,-1,"Agauta, Bulandshahr"],
"204101":[435,1425,-1,"Ahen, Hathras"],
"204102":[350,950,-1,"Dhatroi, Hathras"],
"204211":[238,591,-1,"Ganthri Shahpur, Hathras"],
"204212":[188,538,-1,"Band Abdulhamipur, Hathras"],
"204213":[520,2092,-1,"Asroi, Hathras"],
"204214":[169,433,-1,"Mendamai, Hathras"],
"204215":[169,302,-1,"Bamnoi, Hathras"],
"204216":[350,1108,-1,"Rudayan, Hathras"],
"204217":[350,1096,-1,"Mendu, Aligarh"],
"205001":[278,609,0.0,"Mainpuri, Mainpuri"],
"205119":[229,568,-1,"Darwah, Mainpuri"],
"205121":[400,708,0.0,"Azmabad Araon, Mainpuri"],
"205247":[322,485,0.0,"Ratanpur Bara, Mainpuri"],
"205261":[334,589,0.0,"Dalupur, Mainpuri"],
"205262":[280,405,0.0,"Aghar, Mainpuri"],
"205263":[364,1663,1.14,"Madhan, Mainpuri"],
"205264":[270,646,0.0,"Andani, Mainpuri"],
"205265":[152,661,-1,"Belahar, Mainpuri"],
"205267":[354,920,-1,"Balarpur, Mainpuri"],
"205268":[405,1990,1.14,"Mohabbatpur, Mainpuri"],
"205301":[281,509,0.0,"MUDAI, Mainpuri"],
"205303":[392,1876,1.14,"Maholi Shamserganj, Mainpuri"],
"205304":[356,918,-1,"Mudausi, Mainpuri"],
"206001":[280,543,-1,"Etawah, Etawah"],
"206002":[280,531,-1,"Adhiyapur, Etawah"],
"206003":[280,545,-1,"Manikpur Bissu, Etawah"],
"206120":[225,491,-1,"Bojha, Etawah"],
"206121":[220,457,-1,"Badera, Auraiya"],
"206122":[323,750,-1,"Auraiya, Auraiya"],
"206123":[224,621,-1,"Beena, Etawah"],
"206124":[228,508,-1,"Gulabpura, Etawah"],
"206125":[225,479,-1,"Bindwa Kalan, Etawah"],
"206126":[250,513,-1,"Baisolighat, Etawah"],
"206127":[230,465,-1,"Chandpura, Etawah"],
"206128":[225,464,-1,"Puraoli, Etawah"],
"206129":[281,583,-1,"Bhikhepur, Auraiya"],
"206130":[213,483,-1,"Larkhaur, Etawah"],
"206131":[305,639,0.0,"Bahuri, Etawah"],
"206241":[205,440,-1,"Baghaipur, Auraiya"],
"206242":[238,534,-1,"Merhi Dudhi, Etawah"],
"206243":[298,606,-1,"Kaithawa, Auraiya"],
"206244":[295,579,-1,"Sondhemau, Auraiya"],
"206245":[225,493,-1,"Bibamau, Etawah"],
"206246":[288,552,-1,"Belhupur, Auraiya"],
"206247":[285,567,-1,"Bhagya Nagar, Auraiya"],
"206248":[298,608,-1,"Gapchariapur, Auraiya"],
"206249":[280,580,-1,"Barahar, Auraiya"],
"206250":[280,562,-1,"Rajuamau, Auraiya"],
"206251":[275,582,-1,"Gailly, Auraiya"],
"206252":[265,603,-1,"Barauna Kalan, Auraiya"],
"206253":[252,521,-1,"Chakwa Bujurg, Etawah"],
"206255":[283,571,-1,"Piprauli Shiv, Auraiya"],
"207001":[210,504,-1,"Etah, Etah"],
"207002":[220,488,-1,"Rajpur, Etah"],
"207003":[210,539,0.0,"Barauli, Etah"],
"207120":[230,575,-1,"Bhadwas, Etah"],
"207121":[198,554,-1,"Ishara Purbi, Etah"],
"207122":[252,550,-1,"Gahaitoo, Etah"],
"207123":[215,380,-1,"Mahdava, Kasganj"],
"207124":[238,428,-1,"Kinawa, Kasganj"],
"207125":[195,390,-1,"Achalpur, Etah"],
"207241":[190,307,0.0,"Partappur, Etah"],
"207242":[195,318,0.0,"Karampur, Kasganj"],
"207243":[228,463,-1,"Aurangabad, Kasganj"],
"207244":[220,479,-1,"Bijora, Etah"],
"207245":[178,297,-1,"Amirasa, Kasganj"],
"207246":[190,509,0.0,"Aun, Kasganj"],
"207247":[175,376,-1,"Junedpur, Etah"],
"207248":[240,585,0.0,"Kasela, Etah"],
"207249":[230,398,-1,"Barahpur, Etah"],
"207250":[271,572,-1,"Alipur, Etah"],
"207301":[364,921,-1,"Jalukhera, Etah"],
"207302":[342,1288,-1,"Badhawali, Etah"],
"207401":[215,357,-1,"Kutukpur Kaseri, Etah"],
"207402":[170,451,-1,"Baznagar, Kasganj"],
"207403":[275,583,-1,"Salempur Bebe, Kasganj"],
"208001":[230,513,-1,"Kanpur, Fatehpur"],
"208002":[230,530,-1,"Nawabganj, Kanpur Nagar"],
"208003":[230,522,-1,"Chauki Jarib, Kanpur Nagar"],
"208004":[230,509,-1,"Kanpur Cantt, Kanpur Nagar"],
"208005":[262,503,-1,"Hns Nagar, Kanpur Nagar"],
"208006":[261,497,-1,"Govind Nagar West, Kanpur Nagar"],
"208007":[266,502,-1,"Krishna Nagar SO Kanpur Nagar, Kanpur Nagar"],
"208008":[266,500,-1,"Chakeri Aerodrum, Kanpur Nagar"],
"208009":[269,515,-1,"Armapore, Kanpur Nagar"],
"208010":[263,489,-1,"J K Puri, Kanpur Nagar"],
"208011":[277,515,-1,"Anand Nagar SO Kanpur Nagar, Kanpur Nagar"],
"208012":[262,501,-1,"D O Oil Mill, Kanpur Nagar"],
"208013":[230,509,-1,"Shyam Nagar SO Kanpur Nagar, Kanpur Nagar"],
"208014":[264,498,-1,"Juhi Colony, Kanpur Nagar"],
"208015":[264,496,-1,"New Pac Lines, Kanpur Nagar"],
"208016":[250,582,-1,"Iit, Kanpur Nagar"],
"208017":[272,526,-1,"Kheora, Kanpur Nagar"],
"208019":[263,505,-1,"Rawatpur, Kanpur Nagar"],
"208020":[267,512,-1,"Panki Ganga Ganj, Kanpur Nagar"],
"208021":[294,566,-1,"Sanigawan, Kanpur Nagar"],
"208022":[262,499,-1,"Ratan Lal Nagar, Kanpur Nagar"],
"208023":[275,513,-1,"T P Nagar, Kanpur Nagar"],
"208024":[250,578,-1,"Bima Vihar, Kanpur Nagar"],
"208025":[267,512,-1,"Saketpuri, Kanpur Nagar"],
"208026":[230,509,-1,"Indira Nagar SO Kanpur Nagar, Kanpur Nagar"],
"208027":[278,516,-1,"Barra, Kanpur Nagar"],
"208028":[270,446,-1,"NDC Kanpur, Kanpur Nagar"],
"209101":[450,1573,-1,"Bhuganiyapur, Kanpur Dehat"],
"209111":[692,1306,-1,"Bhognipur, Kanpur Dehat"],
"209112":[1068,1703,-1,"Shekhpur, Kanpur Dehat"],
"209115":[285,796,-1,"Rasdhan, Kanpur Dehat"],
"209121":[450,1190,-1,"Duwari, Kanpur Dehat"],
"209125":[300,662,-1,"Arsun Bangar, Kanpur Dehat"],
"209202":[220,394,-1,"Aurotahar Pur, Kanpur Nagar"],
"209203":[270,497,-1,"Gabdaha, Kanpur Nagar"],
"209204":[205,604,-1,"Aonaha, Kanpur Dehat"],
"209205":[250,648,-1,"Bhausana, Kanpur Nagar"],
"209206":[340,543,-1,"Gujela, Kanpur Nagar"],
"209208":[529,979,-1,"Bamhrauli, Kanpur Dehat"],
"209209":[345,880,-1,"Pasikhera, Kanpur Nagar"],
"209210":[250,543,-1,"Radhan EUP5857, Kanpur Nagar"],
"209214":[370,613,-1,"Chhatarpur, Kanpur Nagar"],
"209217":[260,514,-1,"Pem, Kanpur Nagar"],
"209301":[244,803,-1,"Baalai Bujurg, Kanpur Dehat"],
"209302":[224,415,-1,"Ban, Kanpur Dehat"],
"209303":[385,1256,-1,"Roshanmau EUP6054, Kanpur Dehat"],
"209304":[310,479,-1,"Fatehpur Roshnai, Kanpur Nagar"],
"209305":[265,613,-1,"Bhimsen, Kanpur Nagar"],
"209306":[254,475,-1,"Jot, Kanpur Dehat"],
"209307":[303,735,-1,"Kodwa, Kanpur Dehat"],
"209308":[345,527,-1,"Raipur, Kanpur Nagar"],
"209310":[244,601,-1,"Khanpur, Kanpur Dehat"],
"209311":[370,1264,-1,"Girsi, Kanpur Nagar"],
"209312":[385,1341,-1,"Girdau, Kanpur Dehat"],
"209401":[298,573,0.0,"Amour, Kanpur Nagar"],
"209402":[331,617,-1,"Bhadrsa, Kanpur Nagar"],
"209501":[280,867,-1,"Babna, Farrukhabad"],
"209502":[280,867,-1,"Barkhera, Farrukhabad"],
"209503":[566,2244,-1,"Kisrauli, Farrukhabad"],
"209504":[280,867,-1,"Harsinghpur Goa, Farrukhabad"],
"209505":[250,603,-1,"Sikanderpur Khas, Farrukhabad"],
"209601":[225,372,-1,"Fatehgarh, Farrukhabad"],
"209602":[241,-1,0.0,"Singanpur, Farrukhabad"],
"209621":[151,630,-1,"Kankapur, Farrukhabad"],
"209622":[260,711,-1,"Harsinghpur, Farrukhabad"],
"209625":[250,584,-1,"Kila, Farrukhabad"],
"209651":[245,510,-1,"Maudha, Farrukhabad"],
"209652":[460,804,-1,"Merapur, Farrukhabad"],
"209720":[246,527,-1,"Asaltabad, Kannauj"],
"209721":[246,539,-1,"Akbarpur, Kannauj"],
"209722":[178,450,-1,"Dundwabuzurg, Kannauj"],
"209723":[212,404,-1,"Agaus, Kannauj"],
"209724":[250,836,-1,"Kadhar, Farrukhabad"],
"209725":[530,1390,-1,"Chhipatti, Kannauj"],
"209726":[278,476,-1,"Makrand Nagar, Kannauj"],
"209727":[409,1023,-1,"Gangemau, Kannauj"],
"209728":[280,819,-1,"Chapunna, Kannauj"],
"209729":[230,416,-1,"Bibia Jalalpur, Kannauj"],
"209731":[212,404,-1,"Salempur, Kannauj"],
"209732":[192,455,-1,"Behrin, Kannauj"],
"209733":[205,817,-1,"Fatehpur, Kannauj"],
"209734":[409,1023,-1,"Bhadausi, Kannauj"],
"209735":[252,835,-1,"Rohili, Kannauj"],
"209736":[192,454,-1,"Binaura Rampur, Kannauj"],
"209738":[250,622,-1,"Deodha, Kannauj"],
"209739":[208,447,-1,"Jhasi, Farrukhabad"],
"209743":[178,450,-1,"Sahaspur, Farrukhabad"],
"209745":[280,867,-1,"Chilsara, Farrukhabad"],
"209747":[255,741,-1,"Dadauna, Kannauj"],
"209749":[250,651,-1,"Bhojpur, Farrukhabad"],
"209801":[255,516,-1,"Unnao, Unnao"],
"209821":[225,470,-1,"Sagoli, Unnao"],
"209825":[221,536,-1,"Banigaon, Unnao"],
"209827":[205,414,-1,"Aon, Unnao"],
"209831":[230,557,-1,"Chandpur Jhalaei, Unnao"],
"209841":[190,324,-1,"NEOTANI, Unnao"],
"209859":[246,832,-1,"Katehru, Unnao"],
"209860":[220,470,-1,"Badarka, Unnao"],
"209861":[230,483,-1,"Majra Piper Khera, Unnao"],
"209862":[240,487,-1,"Sahjani, Unnao"],
"209863":[216,533,-1,"Alipur, Unnao"],
"209864":[180,726,-1,"Mahesh Khera, Unnao"],
"209865":[195,358,-1,"Behta Bhawani, Unnao"],
"209866":[180,645,0.0,"Mankapur, Unnao"],
"209867":[195,547,-1,"Dhamni Khera, Unnao"],
"209868":[206,337,-1,"Argoopur, Unnao"],
"209869":[199,331,-1,"Ballapur, Unnao"],
"209870":[205,327,-1,"Kodra, Unnao"],
"209871":[249,419,-1,"Fatehpur Chaurasi, Unnao"],
"209881":[205,360,-1,"Samadpur Hardas, Unnao"],
"210001":[305,-1,0.0,"Banda, Banda"],
"210120":[269,515,0.0,"Katrawal, Banda"],
"210121":[145,368,-1,"Badagaon, Banda"],
"210122":[198,454,0.0,"Oran, Banda"],
"210123":[160,404,-1,"Dighwat, Banda"],
"210125":[252,667,-1,"Bira, Banda"],
"210126":[233,482,0.0,"Mawaighat, Banda"],
"210128":[160,381,-1,"Jauharpur, Banda"],
"210129":[380,669,0.0,"Baheri, Banda"],
"210201":[299,602,-1,"Oraha, Banda"],
"210202":[377,639,0.0,"Mahuta, Banda"],
"210203":[223,554,-1,"Bachhaundha, Banda"],
"210204":[448,752,0.0,"Jankikund, Chitrakoot"],
"210205":[438,771,-1,"Ragauli, Chitrakoot"],
"210206":[438,848,-1,"Beohara, Chitrakoot"],
"210207":[351,694,-1,"Bardwara, Chitrakoot"],
"210208":[277,523,0.0,"Garchappa, Chitrakoot"],
"210209":[215,422,-1,"Baria, Chitrakoot"],
"210301":[188,321,0.0,"Hamirpur, Hamirpur"],
"210341":[310,1745,-1,"Patyara, Hamirpur"],
"210421":[351,572,0.0,"Anghaura, Mahoba"],
"210422":[402,750,-1,"Bira, Hamirpur"],
"210423":[249,595,0.0,"Beri, Mahoba"],
"210424":[383,501,0.0,"Bila Dakhin, Mahoba"],
"210425":[380,603,0.0,"Ainchana, Mahoba"],
"210426":[185,565,-1,"Mudhari, Mahoba"],
"210427":[428,680,0.0,"Bilbai, Mahoba"],
"210428":[202,746,-1,"Tolarawat, Hamirpur"],
"210429":[189,446,0.0,"Bharwara, Mahoba"],
"210430":[313,683,-1,"Barauli Kharka, Hamirpur"],
"210431":[202,833,-1,"Kaitha, Hamirpur"],
"210432":[380,691,-1,"Neoli Bansa, Hamirpur"],
"210433":[404,700,0.0,"Bhandra, Mahoba"],
"210501":[289,969,0.0,"Swasa Bujurg, Hamirpur"],
"210502":[234,874,0.0,"Birkhera, Hamirpur"],
"210504":[344,1029,0.0,"Chhirka, Mahoba"],
"210505":[198,381,0.0,"Bhauli, Hamirpur"],
"210506":[409,700,-1,"Imiliya, Hamirpur"],
"210507":[310,1982,-1,"Bhamai, Hamirpur"],
"211001":[223,406,0.0,"PRAYAGRAJ HPO, Prayagraj"],
"211002":[220,383,0.0,"Prayagraj Kty., Prayagraj"],
"211003":[223,407,0.0,"Attarsuiya, Prayagraj"],
"211004":[220,415,0.0,"M L N EnggColl, Prayagraj"],
"211005":[210,363,0.0,"Prayagraj Fort, Prayagraj"],
"211006":[222,404,0.0,"Nirala Chowk, Prayagraj"],
"211007":[223,408,0.0,"Mohabbatganj Uparhar, Prayagraj"],
"211008":[230,393,-1,"Nibi, Prayagraj"],
"211010":[223,407,0.0,"Khandesara, Prayagraj"],
"211011":[224,402,0.0,"Sulem Sarai, Prayagraj"],
"211012":[244,435,0.0,"Jalalpur Ghosi, Prayagraj"],
"211013":[212,428,0.0,"Jagdishpur, Prayagraj"],
"211014":[219,415,0.0,"C D A P, Prayagraj"],
"211015":[225,404,0.0,"Subedarganj, Prayagraj"],
"211016":[223,410,0.0,"G T B Nagar, Prayagraj"],
"211017":[223,400,0.0,"Prayagraj High Court, Prayagraj"],
"211018":[223,399,0.0,"Public Service Commission, Prayagraj"],
"211019":[223,413,0.0,"Chhibaiya, Prayagraj"],
"211020":[210,362,0.0,"Jhunsi South PO Kumbh Mela, Prayagraj"],
"211021":[235,399,-1,"Rajarshi Tondon Open University, Prayagraj"],
"211022":[225,464,-1,"CRPF Group Center Ismailganj, Prayagraj"],
"211023":[223,400,0.0,"Prayagraj NDC, Prayagraj"],
"212104":[223,407,0.0,"Daswar, Prayagraj"],
"212105":[240,429,-1,"Chheoki, Prayagraj"],
"212106":[223,408,0.0,"Belsara, Prayagraj"],
"212107":[255,469,-1,"Dhara, Prayagraj"],
"212108":[255,465,-1,"Lakhnauti, Prayagraj"],
"212109":[223,400,0.0,"Baharia Bazar, Prayagraj"],
"212110":[170,319,-1,"Chhapar, Prayagraj"],
"212111":[255,469,-1,"Balapur, Prayagraj"],
"212201":[245,434,0.0,"Balak Mau, Kaushambi"],
"212202":[260,436,0.0,"Chalauli, Kaushambi"],
"212203":[222,487,-1,"Beruwa, Kaushambi"],
"212204":[223,400,0.0,"Shahjadpur ED, Kaushambi"],
"212205":[250,451,-1,"Aureni, Kaushambi"],
"212206":[224,401,0.0,"Raxwara, Kaushambi"],
"212207":[255,469,-1,"Naugira, Kaushambi"],
"212208":[210,381,-1,"Pura Mufti ED, Prayagraj"],
"212212":[257,435,0.0,"Manauri AF, Prayagraj"],
"212213":[223,400,0.0,"Alam Chand, Kaushambi"],
"212214":[223,408,0.0,"Andhawan, Kaushambi"],
"212216":[290,509,0.0,"Basuhar, Kaushambi"],
"212217":[223,407,0.0,"Bhadehri, Kaushambi"],
"212218":[260,462,0.0,"Newada, Kaushambi"],
"212301":[223,408,0.0,"Pathra, Prayagraj"],
"212302":[223,407,0.0,"Belhat, Prayagraj"],
"212303":[255,456,-1,"Achhola, Prayagraj"],
"212305":[240,401,-1,"Chowki, Prayagraj"],
"212306":[213,431,0.0,"Chiraon, Prayagraj"],
"212307":[223,400,0.0,"Deeha, Prayagraj"],
"212308":[280,488,-1,"NTPC Kohdar Meja, Prayagraj"],
"212401":[253,550,0.0,"Kishundaspur, Jaunpur"],
"212402":[262,502,-1,"Bahadurgarh Arwasi, Prayagraj"],
"212404":[231,493,0.0,"Babuganj, Prayagraj"],
"212405":[223,407,0.0,"Bhogwara, Prayagraj"],
"212502":[223,406,0.0,"Badagaon, Prayagraj"],
"212503":[210,414,-1,"Barai Harakh, Prayagraj"],
"212507":[223,400,0.0,"Newada, Prayagraj"],
"212601":[180,262,0.0,"Fatehpur, Fatehpur"],
"212620":[220,352,-1,"Ainjhi, Fatehpur"],
"212621":[281,480,0.0,"Budhramau, Fatehpur"],
"212622":[200,319,0.0,"Manda Sarai, Fatehpur"],
"212631":[220,428,0.0,"Kaunh, Fatehpur"],
"212635":[251,612,0.0,"Mandraon, Fatehpur"],
"212641":[375,572,0.0,"Belain, Fatehpur"],
"212645":[271,1254,0.0,"Bilanda, Fatehpur"],
"212650":[280,365,0.0,"Nizamuddinpur, Fatehpur"],
"212651":[180,265,0.0,"Chitishapur, Fatehpur"],
"212652":[268,422,-1,"Kaseruwa, Fatehpur"],
"212653":[268,426,-1,"MPGaunti, Fatehpur"],
"212654":[237,370,0.0,"Kishandaspur, Fatehpur"],
"212655":[265,384,-1,"Budwan, Fatehpur"],
"212656":[180,373,-1,"Baraipur, Fatehpur"],
"212657":[322,816,0.0,"Basant Khera, Fatehpur"],
"212658":[220,381,0.0,"Ekdala, Fatehpur"],
"212659":[225,573,-1,"Alampur, Fatehpur"],
"212661":[375,588,-1,"Gauri, Fatehpur"],
"212663":[340,719,0.0,"Datauli, Fatehpur"],
"212664":[269,1145,0.0,"Chakhendi, Fatehpur"],
"212665":[251,757,0.0,"Korsam, Fatehpur"],
"221001":[192,-1,0.0,"Varanasi, Varanasi"],
"221002":[260,-1,0.0,"Varanasi Cantt, Varanasi"],
"221003":[205,-1,0.0,"Chamaon, Varanasi"],
"221004":[270,-1,0.0,"DLW, Varanasi"],
"221005":[192,-1,0.0,"Sunderpur, Varanasi"],
"221006":[215,-1,0.0,"Pure Raghunathpur, Varanasi"],
"221007":[205,-1,0.0,"Konia, Varanasi"],
"221008":[192,-1,0.0,"Kateshar, Varanasi"],
"221009":[255,457,-1,"Sahupuri, Chandauli"],
"221010":[226,-1,0.0,"Aurangabad SO Varanasi, Varanasi"],
"221011":[280,-1,0.0,"Kurahuwan, Varanasi"],
"221012":[190,-1,0.0,"Awadhoot Bhagwan Ram Kusth Seva Ashram, Varanasi"],
"221101":[198,-1,0.0,"Amarpatti, Varanasi"],
"221103":[260,-1,0.0,"Manduadih, Varanasi"],
"221104":[198,-1,0.0,"Luthakalan, Varanasi"],
"221105":[215,-1,0.0,"Birapatti, Varanasi"],
"221106":[280,-1,0.0,"Kandawa, Varanasi"],
"221107":[300,-1,0.0,"Koruta Bazar, Varanasi"],
"221108":[280,-1,0.0,"Rohana, Varanasi"],
"221109":[260,-1,0.0,"Jayapur SO Varanasi, Varanasi"],
"221110":[192,-1,0.0,"Basant Nagar, Chandauli"],
"221111":[198,-1,0.0,"Danganj Bazar, Varanasi"],
"221112":[198,-1,0.0,"Bariyasanpur, Varanasi"],
"221115":[260,-1,0.0,"Marufpur, Chandauli"],
"221116":[198,-1,0.0,"Srikanthpur, Varanasi"],
"221201":[215,-1,0.0,"Akorha, Varanasi"],
"221202":[205,-1,0.0,"Shivrampur, Varanasi"],
"221204":[215,-1,0.0,"Basani, Varanasi"],
"221206":[168,-1,0.0,"Jhanjhaur, Varanasi"],
"221207":[183,-1,0.0,"Nayepur Chaumuhani, Varanasi"],
"221208":[160,-1,0.0,"Marui, Varanasi"],
"221301":[200,250,0.0,"Ghosiya, Bhadohi"],
"221302":[205,-1,0.0,"Harshosh, Varanasi"],
"221303":[200,287,0.0,"Amilaur, Bhadohi"],
"221304":[190,433,0.0,"Chakkisundas, Bhadohi"],
"221305":[190,-1,0.0,"Marui, Varanasi"],
"221306":[186,-1,0.0,"Pakhawaiya, Bhadohi"],
"221307":[270,-1,0.0,"Mankaiya, Varanasi"],
"221308":[455,556,0.0,"Rohi, Bhadohi"],
"221309":[390,456,0.0,"Berawa Paharpur, Bhadohi"],
"221310":[520,-1,0.0,"Baragaon, Bhadohi"],
"221311":[280,-1,0.0,"Birbhanpur, Varanasi"],
"221313":[280,-1,0.0,"Khochawan, Varanasi"],
"221314":[212,-1,0.0,"Saripur, Bhadohi"],
"221401":[200,325,0.0,"Raya, Bhadohi"],
"221402":[190,-1,0.0,"Darunaha, Bhadohi"],
"221403":[260,-1,0.0,"Banakat, Varanasi"],
"221404":[232,-1,0.0,"Bhikharirampur, Bhadohi"],
"221405":[260,-1,0.0,"Hariharpur, Varanasi"],
"221406":[200,412,0.0,"Ajaipur, Bhadohi"],
"221407":[192,-1,0.0,"NDC Varanasi, Varanasi"],
"221409":[284,-1,0.0,"Kukarauthi, Bhadohi"],
"221502":[223,407,0.0,"Mahajna, Prayagraj"],
"221503":[223,400,0.0,"Beerapur, Prayagraj"],
"221505":[223,400,0.0,"Hetapur, Prayagraj"],
"221507":[210,382,0.0,"Babhan Kuiyan, Prayagraj"],
"221508":[210,377,0.0,"Dhokari, Prayagraj"],
"221601":[230,370,-1,"Molnapur, Mau"],
"221602":[240,390,-1,"Lakhnaur, Mau"],
"221603":[225,407,-1,"Bhairopur, Mau"],
"221701":[260,424,-1,"Hajauli, Ballia"],
"221705":[280,601,-1,"Gahana, Mau"],
"221706":[280,665,-1,"Chhichore, Mau"],
"221709":[260,442,-1,"Birpura, Ballia"],
"221711":[275,591,-1,"Kodai, Ballia"],
"221712":[270,571,-1,"RASRA, Ballia"],
"221713":[230,504,-1,"Daulatpur, Ballia"],
"221715":[220,331,-1,"Sarya Dihu Bhagat, Ballia"],
"221716":[265,496,-1,"Jajauli No2, Ballia"],
"221717":[200,336,-1,"Deokali, Ballia"],
"221718":[280,-1,0.0,"Palia Khas, Ballia"],
"222001":[181,276,0.0,"Jaunpur, Jaunpur"],
"222002":[180,256,0.0,"Dharmapur, Jaunpur"],
"222003":[200,350,0.0,"Basaratpur, Jaunpur"],
"222004":[180,278,0.0,"MALHANI BAZAR, Jaunpur"],
"222101":[238,308,0.0,"Dhaurua, Ambedkar Nagar"],
"222105":[182,229,0.0,"Poly, Jaunpur"],
"222109":[196,316,0.0,"Barpur, Jaunpur"],
"222125":[225,455,-1,"Kuhi Kalan, Jaunpur"],
"222126":[135,194,0.0,"Meerapur Kewal, Jaunpur"],
"222127":[260,272,0.0,"Kanhabanshipur, Jaunpur"],
"222128":[273,-1,0.0,"Nonari, Jaunpur"],
"222129":[288,302,0.0,"Bhaisa, Jaunpur"],
"222131":[280,296,0.0,"Shahpur, Jaunpur"],
"222132":[248,467,-1,"Masida, Jaunpur"],
"222133":[266,397,0.0,"Aara, Jaunpur"],
"222135":[205,244,0.0,"Samadhganj, Jaunpur"],
"222136":[196,464,0.0,"Asbaranpur, Jaunpur"],
"222137":[225,475,-1,"Damodara, Jaunpur"],
"222138":[182,-1,0.0,"Gopipur, Jaunpur"],
"222139":[217,362,0.0,"Arand, Jaunpur"],
"222141":[263,-1,0.0,"Agraura, Jaunpur"],
"222142":[283,368,0.0,"Belhari, Jaunpur"],
"222143":[250,374,0.0,"Karaura, Jaunpur"],
"222144":[228,541,-1,"Gonapar, Jaunpur"],
"222145":[196,316,0.0,"Barji, Jaunpur"],
"222146":[285,472,0.0,"Kanuani, Jaunpur"],
"222148":[282,330,0.0,"Koilari, Jaunpur"],
"222149":[283,319,0.0,"Kachhawan, Jaunpur"],
"222161":[327,492,0.0,"Belgahan, Jaunpur"],
"222162":[200,350,0.0,"Alamganj, Jaunpur"],
"222165":[182,196,0.0,"Bhiduna, Jaunpur"],
"222170":[178,247,0.0,"Beerampur, Jaunpur"],
"222175":[182,261,0.0,"Nakahara, Jaunpur"],
"222180":[284,345,0.0,"Zamaitha, Jaunpur"],
"222181":[215,-1,0.0,"Sohani, Jaunpur"],
"222201":[274,433,0.0,"Bhilampur, Jaunpur"],
"222202":[160,304,0.0,"Bhikhpur, Jaunpur"],
"222203":[309,522,0.0,"BHadkin, Jaunpur"],
"222204":[158,284,0.0,"Tikara, Jaunpur"],
"222205":[186,-1,0.0,"SULTANPUR, Jaunpur"],
"222301":[255,-1,0.0,"Malhipur, Sultanpur"],
"222302":[268,283,0.0,"Budhapur, Sultanpur"],
"222303":[250,-1,0.0,"Kothara Khurd, Sultanpur"],
"223101":[132,216,0.0,"Chhatai Kala, Jaunpur"],
"223102":[274,-1,0.0,"Pataila, Jaunpur"],
"223103":[205,702,0.0,"Latifpur, Jaunpur"],
"223104":[205,452,0.0,"Dihiya, Jaunpur"],
"223105":[151,159,0.0,"Gangauli, Jaunpur"],
"223221":[230,431,-1,"Bilari, Azamgarh"],
"223222":[280,450,-1,"Godhana, Azamgarh"],
"223223":[291,392,0.0,"Lohara, Azamgarh"],
"223224":[181,283,0.0,"Chitara Mahamud Pur, Azamgarh"],
"223225":[223,398,-1,"Naharpur, Azamgarh"],
"223226":[130,-1,0.0,"Chhittepur, Azamgarh"],
"223227":[284,326,0.0,"Ambarpur, Azamgarh"],
"224001":[192,235,0.0,"Faizabad, Ayodhya"],
"224116":[302,-1,0.0,"Jarail Kalan, Ayodhya"],
"224117":[280,-1,0.0,"Manjanpur, Ayodhya"],
"224118":[250,-1,0.0,"Bihara, Ayodhya"],
"224119":[240,-1,0.0,"Jakhauli, Ayodhya"],
"224120":[266,-1,0.0,"Aihar, Ayodhya"],
"224121":[276,-1,0.0,"Gaddopur, Ayodhya"],
"224122":[277,402,0.0,"Akbarpur, Ambedkar Nagar"],
"224123":[221,286,0.0,"Gurukul, Ayodhya"],
"224125":[295,453,0.0,"Mundehra, Ambedkar Nagar"],
"224126":[284,324,0.0,"Gondwa, Ayodhya"],
"224127":[250,250,0.0,"Gothwara, Ayodhya"],
"224129":[232,-1,0.0,"Kaurahi, Ambedkar Nagar"],
"224132":[267,374,0.0,"Bangaon, Ambedkar Nagar"],
"224133":[232,258,0.0,"Jyoti Sadan, Ayodhya"],
"224135":[238,290,0.0,"Dadera, Ayodhya"],
"224137":[215,353,-1,"Ahirauli Ranimau, Ambedkar Nagar"],
"224139":[210,306,0.0,"Deeh Bhilon, Ambedkar Nagar"],
"224141":[267,349,0.0,"Asgawan, Ambedkar Nagar"],
"224143":[210,213,0.0,"Makrahi, Ambedkar Nagar"],
"224145":[295,528,-1,"Bharsari, Ambedkar Nagar"],
"224146":[284,333,0.0,"Husainpur, Ambedkar Nagar"],
"224147":[246,304,0.0,"Akhtara Narainpur, Ambedkar Nagar"],
"224149":[302,401,0.0,"Arai, Ambedkar Nagar"],
"224151":[269,407,0.0,"Khajawan, Ambedkar Nagar"],
"224152":[266,355,0.0,"Benipur, Ambedkar Nagar"],
"224153":[278,-1,0.0,"Palpur, Ayodhya"],
"224155":[250,-1,0.0,"Tandwa Maulai, Ambedkar Nagar"],
"224157":[259,375,0.0,"Ahirauli, Ambedkar Nagar"],
"224158":[267,-1,0.0,"Palia Jagmohan Singh, Ayodhya"],
"224159":[260,371,0.0,"Dhaurua, Ambedkar Nagar"],
"224161":[248,312,0.0,"Benawa, Ayodhya"],
"224164":[288,-1,0.0,"Tendha Khurd, Ayodhya"],
"224168":[271,354,0.0,"Baramadpur Jariyari, Ambedkar Nagar"],
"224171":[234,268,0.0,"Deogarh, Ayodhya"],
"224172":[253,284,0.0,"Anjana, Firozabad"],
"224176":[193,334,-1,"Bankata Bujurg, Ambedkar Nagar"],
"224181":[226,-1,0.0,"Amadarveshpur, Ambedkar Nagar"],
"224182":[279,329,0.0,"Barwa, Ayodhya"],
"224183":[263,316,0.0,"Lawaiya Pratappur, Ambedkar Nagar"],
"224186":[270,324,0.0,"Larpur, Ambedkar Nagar"],
"224188":[271,293,0.0,"Bhitaura, Ayodhya"],
"224189":[256,-1,0.0,"Ismail Nagar Singra, Ayodhya"],
"224190":[276,416,0.0,"Asopur, Ambedkar Nagar"],
"224195":[262,279,0.0,"Ghuritikar, Ayodhya"],
"224201":[240,264,0.0,"Kondri, Ayodhya"],
"224202":[242,267,0.0,"Raithua, Ayodhya"],
"224203":[259,-1,0.0,"Beni Gaddopur, Ayodhya"],
"224204":[266,-1,0.0,"Ballipur, Ayodhya"],
"224205":[253,271,0.0,"Banghusara, Ayodhya"],
"224206":[280,-1,0.0,"Basantpur, Ambedkar Nagar"],
"224207":[193,238,0.0,"Jalapur Bhaggoo, Ayodhya"],
"224208":[283,-1,0.0,"Adilpur, Ayodhya"],
"224209":[260,-1,0.0,"Hathigo, Ayodhya"],
"224210":[267,317,0.0,"Daudpur, Ambedkar Nagar"],
"224225":[286,-1,0.0,"Hardoiya, Ayodhya"],
"224227":[276,404,0.0,"Maharajganj, Ambedkar Nagar"],
"224228":[284,-1,0.0,"Kahuwa, Ayodhya"],
"224229":[285,-1,0.0,"Birauli, Ayodhya"],
"224230":[278,456,0.0,"Baragaon Brahimpur, Ambedkar Nagar"],
"224231":[254,301,0.0,"Jaitoopur, Ambedkar Nagar"],
"224232":[284,452,0.0,"Hakeem Pur, Ambedkar Nagar"],
"224234":[267,340,0.0,"Mahuwari, Ambedkar Nagar"],
"224235":[283,341,0.0,"Lorpur, Ambedkar Nagar"],
"224238":[288,468,0.0,"Vidhut Nagar, Ambedkar Nagar"],
"224239":[231,264,0.0,"Indaipur, Ambedkar Nagar"],
"224284":[273,-1,0.0,"Astikaan, Ayodhya"],
"225001":[228,-1,0.0,"Barabanki, Barabanki"],
"225003":[233,-1,0.0,"Madhopur, Barabanki"],
"225119":[238,292,0.0,"Dayalpur, Barabanki"],
"225120":[255,255,0.0,"Bibipur Garh, Barabanki"],
"225121":[228,-1,0.0,"Neoli, Barabanki"],
"225122":[229,-1,0.0,"Sarai Parsanda, Barabanki"],
"225123":[228,-1,0.0,"Para Khandauli, Barabanki"],
"225124":[238,-1,0.0,"Bhikhara, Barabanki"],
"225125":[250,-1,0.0,"Gerawan, Barabanki"],
"225126":[215,234,0.0,"Jaurass, Barabanki"],
"225201":[220,-1,0.0,"Banarki, Barabanki"],
"225202":[232,279,0.0,"Sirauli Kalan, Barabanki"],
"225203":[228,-1,0.0,"Darhara, Barabanki"],
"225204":[228,-1,0.0,"Bindaura, Barabanki"],
"225205":[230,-1,0.0,"Amoli Kalan, Barabanki"],
"225206":[235,-1,0.0,"Pyarepur, Barabanki"],
"225207":[220,-1,0.0,"Danapur Shukla, Barabanki"],
"225208":[220,-1,0.0,"Baburiha, Barabanki"],
"225301":[221,-1,0.0,"Baburi Gaon, Barabanki"],
"225302":[245,-1,0.0,"Barhaidih Maholia, Barabanki"],
"225303":[220,-1,0.0,"Basauli, Barabanki"],
"225304":[250,379,0.0,"Kandarwal, Barabanki"],
"225305":[228,-1,0.0,"Basara, Barabanki"],
"225306":[230,269,0.0,"Khinjhana, Barabanki"],
"225401":[240,-1,0.0,"Puredalai, Barabanki"],
"225403":[248,-1,0.0,"Imliha, Barabanki"],
"225404":[240,-1,0.0,"Neoli Danapur, Barabanki"],
"225405":[240,-1,0.0,"Jariyari, Barabanki"],
"225409":[240,-1,0.0,"Ashrafpur, Barabanki"],
"225412":[233,-1,0.0,"Lachhbar Bajaha, Barabanki"],
"225413":[240,258,0.0,"Uchita, Barabanki"],
"225414":[233,-1,0.0,"Barain, Barabanki"],
"225415":[300,337,0.0,"Kotwa Dham, Barabanki"],
"225416":[220,-1,0.0,"Jarauli, Barabanki"],
"226001":[263,-1,0.0,"Lucknow GPO, Lucknow"],
"226002":[248,-1,0.0,"Bijnaur, Lucknow"],
"226003":[241,-1,0.0,"Lucknow Chowk, Lucknow"],
"226004":[263,-1,0.0,"Blunt Square, Lucknow"],
"226005":[263,-1,0.0,"Alambagh, Lucknow"],
"226006":[220,-1,0.0,"H E School, Lucknow"],
"226007":[220,-1,0.0,"NADWA, Lucknow"],
"226008":[259,292,0.0,"Sadrauna, Lucknow"],
"226009":[263,-1,0.0,"AMAUSI AD, Lucknow"],
"226010":[269,-1,0.0,"Maleshemau, Lucknow"],
"226011":[237,-1,0.0,"MANAK NAGAR, Lucknow"],
"226012":[263,-1,0.0,"Ashiana Colony, Lucknow"],
"226013":[263,-1,0.0,"Diguria, Lucknow"],
"226014":[290,367,0.0,"Sgpgi, Lucknow"],
"226015":[253,-1,0.0,"Cimap, Lucknow"],
"226016":[260,-1,0.0,"Narain Nagar, Lucknow"],
"226017":[246,266,0.0,"Alamnagar, Lucknow"],
"226018":[263,-1,0.0,"Aminabad Park, Lucknow"],
"226019":[251,-1,0.0,"Industria Area Chinhat, Lucknow"],
"226020":[241,-1,0.0,"Triveni Nagar, Lucknow"],
"226021":[263,-1,0.0,"Madiyaon, Lucknow"],
"226022":[249,-1,0.0,"Kalyanpur SO Lucknow, Lucknow"],
"226023":[263,-1,0.0,"32 Bn PAC SO Lucknow, Lucknow"],
"226024":[241,-1,0.0,"Aliganj, Lucknow"],
"226025":[272,300,0.0,"B R A University, Lucknow"],
"226026":[252,-1,0.0,"BASHA, Lucknow"],
"226027":[249,-1,0.0,"UPG Camp, Lucknow"],
"226028":[269,-1,0.0,"Rasoolpur Saadat, Lucknow"],
"226029":[223,-1,0.0,"Vrindavan Colony, Lucknow"],
"226030":[223,-1,0.0,"Sushant Golf City, Lucknow"],
"226031":[263,-1,0.0,"Jankipuram Extension, Lucknow"],
"226101":[263,-1,0.0,"Gohramau, Lucknow"],
"226102":[265,-1,0.0,"Bhadwana, Lucknow"],
"226103":[250,302,0.0,"Daulatpur, Lucknow"],
"226104":[241,-1,0.0,"Baddaiyan, Lucknow"],
"226201":[195,-1,0.0,"ASTI, Lucknow"],
"226202":[198,-1,0.0,"Kathwara, Lucknow"],
"226203":[273,349,0.0,"Amaniganj, Lucknow"],
"226301":[256,308,0.0,"Deoti, Lucknow"],
"226302":[223,-1,0.0,"Dayalpur, Lucknow"],
"226303":[250,-1,0.0,"Adampur Janubi, Lucknow"],
"226401":[220,986,0.0,"Ain, Lucknow"],
"226501":[239,-1,0.0,"Rasoolpur Tikaniamau, Lucknow"],
"227304":[285,632,0.0,"Kaithapur, Sultanpur"],
"227405":[297,388,0.0,"Amethi, Amethi"],
"227406":[265,397,0.0,"Bhawapur, Amethi"],
"227407":[232,487,0.0,"Misrauli, Amethi"],
"227408":[275,381,0.0,"Sanaha, Amethi"],
"227409":[280,-1,0.0,"Arjunpur, Amethi"],
"227411":[290,291,0.0,"Kauhar, Amethi"],
"227412":[276,388,0.0,"Pashchim Duara, Amethi"],
"227413":[295,550,0.0,"Deoraha, Amethi"],
"227801":[290,457,0.0,"Balbhadrapur, Amethi"],
"227805":[290,308,0.0,"Bela Pashchim, Sultanpur"],
"227806":[297,388,0.0,"Gaura Loharia, Sultanpur"],
"227807":[291,310,0.0,"Bisara Pashchim, Amethi"],
"227808":[320,425,0.0,"Bandhua Kalan, Sultanpur"],
"227809":[286,293,0.0,"Saresar, Amethi"],
"227811":[297,388,0.0,"Mardanpur, Amethi"],
"227812":[279,-1,0.0,"Baranpur, Sultanpur"],
"227813":[290,291,0.0,"Sadipur, Amethi"],
"227814":[254,265,0.0,"Baqghauna, Sultanpur"],
"227815":[285,-1,0.0,"Jarai Kalan, Sultanpur"],
"227816":[285,-1,0.0,"Kankupur, Amethi"],
"227817":[277,-1,0.0,"Jagdishpur Industrial Area, Amethi"],
"228001":[285,637,0.0,"Sultanpur Avadh, Sultanpur"],
"228118":[320,440,0.0,"Angnakol, Sultanpur"],
"228119":[291,308,0.0,"Misrauli, Sultanpur"],
"228120":[250,298,0.0,"Kaithwara, Sultanpur"],
"228121":[260,-1,0.0,"Bingi, Sultanpur"],
"228125":[250,262,0.0,"Inayatpur, Sultanpur"],
"228131":[281,-1,0.0,"Dhanaupur, Sultanpur"],
"228132":[285,639,0.0,"Ahda, Sultanpur"],
"228133":[260,389,0.0,"Basupur, Sultanpur"],
"228141":[263,398,0.0,"Purushottampur, Sultanpur"],
"228142":[255,330,0.0,"Chorma, Sultanpur"],
"228145":[250,304,0.0,"Musatafabad Saraiya, Sultanpur"],
"228151":[248,-1,0.0,"Bariauna, Sultanpur"],
"228155":[276,-1,0.0,"Bansi, Sultanpur"],
"228159":[285,557,0.0,"Dehli Mubarakpur, Sultanpur"],
"228161":[270,453,-1,"Amari, Sultanpur"],
"228171":[260,-1,0.0,"Alimuddinpur, Sultanpur"],
"228172":[260,-1,0.0,"RUPAIPUR, Sultanpur"],
"229001":[250,336,0.0,"Raebarely, Rae Bareli"],
"229010":[277,-1,0.0,"Maliak Mau Aima, Rae Bareli"],
"229103":[261,534,0.0,"Alipur, Rae Bareli"],
"229120":[250,363,0.0,"Rail Coach Factory LalganjRaebareli, Rae Bareli"],
"229121":[270,360,0.0,"Ataura Bujurg, Rae Bareli"],
"229122":[238,396,0.0,"Sahjaura, Rae Bareli"],
"229123":[228,-1,0.0,"Majhigawan, Rae Bareli"],
"229124":[277,-1,0.0,"Jaudaha, Rae Bareli"],
"229125":[244,294,0.0,"Barraua, Rae Bareli"],
"229126":[293,-1,0.0,"Khekharua, Amethi"],
"229127":[231,410,0.0,"Nain, Rae Bareli"],
"229128":[302,-1,0.0,"Khurehti, Rae Bareli"],
"229129":[258,715,0.0,"Asharasidpur, Rae Bareli"],
"229130":[250,340,0.0,"Korihar, Rae Bareli"],
"229135":[300,-1,0.0,"Panhauna, Amethi"],
"229201":[250,-1,0.0,"Pahuri, Rae Bareli"],
"229202":[340,560,-1,"Kodra, Rae Bareli"],
"229203":[245,349,-1,"Bahai, Rae Bareli"],
"229204":[221,388,0.0,"Alawalpur, Rae Bareli"],
"229205":[228,414,0.0,"Khanapur Khusti, Rae Bareli"],
"229206":[234,410,0.0,"Lalganj Raebareli, Rae Bareli"],
"229207":[256,378,0.0,"Kalyan Pur Bainti, Rae Bareli"],
"229208":[295,541,0.0,"Barha, Rae Bareli"],
"229209":[236,576,0.0,"Sheopuri, Rae Bareli"],
"229210":[250,326,0.0,"Ranapur Pahrauli, Rae Bareli"],
"229211":[169,236,0.0,"Mahraniganj, Rae Bareli"],
"229212":[243,731,0.0,"Gajpati Khera, Rae Bareli"],
"229215":[294,545,0.0,"Dudhwan, Rae Bareli"],
"229216":[180,297,0.0,"Musapur, Rae Bareli"],
"229301":[248,310,0.0,"Asahanjagatpur, Rae Bareli"],
"229302":[310,558,-1,"Pothai, Rae Bareli"],
"229303":[229,368,-1,"Chauhania, Rae Bareli"],
"229304":[300,-1,0.0,"Sarain Mahesha, Amethi"],
"229305":[282,-1,0.0,"Babhanpur, Rae Bareli"],
"229306":[275,-1,0.0,"Amawan, Rae Bareli"],
"229307":[344,626,0.0,"Alampur, Rae Bareli"],
"229308":[260,849,0.93,"Dahigawan, Rae Bareli"],
"229309":[303,-1,0.0,"Ahuri, Amethi"],
"229310":[250,-1,0.0,"Jagdishpur, Rae Bareli"],
"229311":[241,260,0.0,"Bahadur Nagar, Rae Bareli"],
"229316":[291,710,0.0,"Burdhanpur, Rae Bareli"],
"229401":[250,355,0.0,"Gularhia MajDhuta, Rae Bareli"],
"229402":[253,-1,0.0,"Ram Garh Tikaria, Rae Bareli"],
"229404":[270,366,0.0,"Sawaiya Hasan, Rae Bareli"],
"229405":[287,571,-1,"Bhuemau, Rae Bareli"],
"229406":[226,481,-1,"Khurrampur, Rae Bareli"],
"229408":[234,424,0.0,"Jhonkwara, Pratapgarh"],
"229410":[384,656,0.07,"Bhatni, Pratapgarh"],
"229411":[262,451,0.0,"Aladadpur, Prayagraj"],
"229412":[223,400,0.0,"Bajha Mazra Lohia Nagar, Prayagraj"],
"229413":[248,618,-1,"Rampur Kotwa, Prayagraj"],
"229801":[290,-1,0.0,"Banbharia, Amethi"],
"229802":[254,311,0.0,"Lauli, Amethi"],
"230001":[225,484,-1,"Pratapgarh, Pratapgarh"],
"230002":[225,351,0.03,"Dherehana, Pratapgarh"],
"230121":[222,428,0.01,"Binaika, Pratapgarh"],
"230124":[245,528,0.01,"Dahi, Pratapgarh"],
"230125":[222,386,0.01,"Rajapur, Pratapgarh"],
"230126":[210,436,0.0,"Pure Noti, Pratapgarh"],
"230127":[224,430,0.02,"Premdhar Patti, Pratapgarh"],
"230128":[224,431,0.02,"Bhikhapur Kanidih, Pratapgarh"],
"230129":[288,842,0.68,"Chakwarh, Pratapgarh"],
"230130":[188,424,-1,"Laxmanpur, Pratapgarh"],
"230131":[259,474,0.43,"Rajgarh, Pratapgarh"],
"230132":[225,361,0.0,"Ajhara, Pratapgarh"],
"230133":[228,455,-1,"Besar, Pratapgarh"],
"230134":[230,543,0.07,"Gajariya, Pratapgarh"],
"230135":[234,394,0.01,"Dhandhar, Pratapgarh"],
"230136":[225,361,0.0,"Harakhpur Kotwa, Pratapgarh"],
"230137":[195,352,0.02,"Kataiya, Pratapgarh"],
"230138":[225,361,0.0,"Manapur, Pratapgarh"],
"230139":[225,361,0.0,"Ranki, Pratapgarh"],
"230141":[209,597,0.04,"Dhangarh, Pratapgarh"],
"230142":[230,519,0.12,"Ishanpur, Pratapgarh"],
"230143":[268,897,0.04,"Bhawaniganj Kota, Pratapgarh"],
"230144":[225,443,-1,"Pandwasi, Pratapgarh"],
"230201":[225,361,0.0,"Budhapur, Pratapgarh"],
"230202":[206,361,0.01,"Radhauli, Pratapgarh"],
"230204":[225,361,0.0,"Aindha, Pratapgarh"],
"230301":[256,433,0.0,"Amapur Berra, Pratapgarh"],
"230302":[282,504,1.0,"Birapur, Pratapgarh"],
"230304":[235,411,0.01,"Adharganj, Pratapgarh"],
"230306":[285,527,0.02,"Kailidih, Pratapgarh"],
"230401":[206,358,0.01,"Katari, Pratapgarh"],
"230402":[230,515,0.13,"Baishpur, Pratapgarh"],
"230403":[230,519,0.12,"Sadar Bazar, Pratapgarh"],
"230404":[265,463,0.0,"Sarai Raja, Pratapgarh"],
"230405":[256,443,0.0,"Utras, Pratapgarh"],
"230501":[185,354,0.03,"Umari, Pratapgarh"],
"230502":[225,361,0.0,"Biharganj, Pratapgarh"],
"230503":[235,392,0.01,"Gaura Dand, Pratapgarh"],
"231001":[182,-1,0.0,"Mirzapur, Mirzapur"],
"231205":[240,-1,0.0,"Jugail, Sonbhadra"],
"231206":[240,-1,0.0,"Cherui, Sonbhadra"],
"231207":[215,-1,0.0,"Gurmura, Sonbhadra"],
"231208":[204,-1,0.0,"Hathwani, Sonbhadra"],
"231209":[175,194,0.0,"Gurma Markundi, Sonbhadra"],
"231210":[200,-1,0.0,"Baghaura, Mirzapur"],
"231211":[233,-1,0.0,"Babura Kala, Mirzapur"],
"231212":[223,-1,0.0,"Ghaghara, Sonbhadra"],
"231213":[177,227,0.0,"Banki, Sonbhadra"],
"231215":[220,-1,0.0,"Shahganj, Sonbhadra"],
"231216":[232,-1,0.0,"Robertsganj, Sonbhadra"],
"231217":[269,-1,0.0,"Belhatthi, Sonbhadra"],
"231218":[310,533,0.0,"Khajura, Sonbhadra"],
"231219":[230,-1,0.0,"Parsoi, Sonbhadra"],
"231220":[554,904,0.0,"Beena Project, Sonbhadra"],
"231221":[263,-1,0.0,"Banvasi Seva Ashram, Sonbhadra"],
"231222":[326,546,0.0,"Dharsari, Sonbhadra"],
"231223":[215,-1,0.0,"Sirsoti, Sonbhadra"],
"231224":[180,550,0.0,"Rehta, Sonbhadra"],
"231225":[355,-1,0.0,"Radhore, Sonbhadra"],
"231226":[175,194,0.0,"Kachnarwa, Sonbhadra"],
"231301":[191,-1,0.0,"Ekali, Mirzapur"],
"231302":[184,-1,0.0,"Gothaura, Mirzapur"],
"231303":[152,-1,0.0,"Nadini, Mirzapur"],
"231304":[190,-1,0.0,"Bharehata, Mirzapur"],
"231305":[250,551,-1,"Devaria, Mirzapur"],
"231306":[211,-1,0.0,"Domanpur, Mirzapur"],
"231307":[176,-1,0.0,"Amoi, Mirzapur"],
"231309":[144,-1,0.0,"Padaria Kala, Mirzapur"],
"231311":[229,-1,0.0,"Chunar Cement Factory, Mirzapur"],
"231312":[182,-1,0.0,"Balliparwa, Mirzapur"],
"231313":[243,-1,0.0,"Gogaon, Mirzapur"],
"231314":[190,-1,0.0,"Nigatpur, Mirzapur"],
"231501":[212,-1,0.0,"Jalalpur, Mirzapur"],
"232101":[190,-1,0.0,"MAVAIKALA, Chandauli"],
"232102":[192,-1,0.0,"Dharde, Chandauli"],
"232103":[190,-1,0.0,"Bentairi, Chandauli"],
"232104":[140,-1,0.0,"Barthara Kalan, Chandauli"],
"232105":[192,-1,0.0,"Torwan, Chandauli"],
"232106":[158,-1,0.0,"Kadirabad, Chandauli"],
"232107":[190,-1,0.0,"Ballipur, Chandauli"],
"232108":[192,-1,0.0,"Dighwat, Chandauli"],
"232109":[192,-1,0.0,"Amilai, Chandauli"],
"232110":[198,-1,0.0,"Adsand, Chandauli"],
"232111":[255,434,-1,"Jhumaria, Chandauli"],
"232114":[192,-1,0.0,"Chahania S.O., Varanasi"],
"232115":[315,378,0.0,"Majidaha, Chandauli"],
"232118":[190,-1,0.0,"Karnaul, Chandauli"],
"232120":[190,-1,0.0,"Janso Ki Marai, Chandauli"],
"232325":[250,621,-1,"BARA, Ghazipur"],
"232326":[205,379,-1,"Dewaitha, Ghazipur"],
"232327":[250,539,-1,"Bhataura, Ghazipur"],
"232328":[245,355,-1,"Pakari, Ghazipur"],
"232329":[272,451,-1,"Darauli, Ghazipur"],
"232330":[222,363,-1,"Dhanarhi, Ghazipur"],
"232331":[272,448,-1,"Baruin, Ghazipur"],
"232332":[250,483,-1,"Garua Maksudpur, Ghazipur"],
"232333":[240,370,-1,"Amaura, Ghazipur"],
"232336":[250,454,-1,"Andharipur Sonwal, Ghazipur"],
"232339":[240,352,-1,"Basuka, Ghazipur"],
"232340":[250,621,-1,"Jeevpur, Ghazipur"],
"232341":[250,487,-1,"SUHWAL, Ghazipur"],
"233001":[245,671,-1,"Ghazipur, Ghazipur"],
"233002":[264,636,-1,"Akarmpur Banjaripur, Ghazipur"],
"233221":[408,784,0.0,"Ameda, Ghazipur"],
"233222":[295,560,-1,"Dahendu, Ghazipur"],
"233223":[250,621,-1,"Amehta, Ghazipur"],
"233224":[280,436,0.0,"Mainpur, Ghazipur"],
"233225":[205,379,-1,"Gondaur, Ghazipur"],
"233226":[230,620,-1,"Bhojapur, Ghazipur"],
"233227":[245,508,-1,"Machhati, Ghazipur"],
"233228":[250,490,-1,"Patar, Ghazipur"],
"233229":[295,560,-1,"Kamupur, Ghazipur"],
"233230":[320,611,-1,"Khetabpur, Ghazipur"],
"233231":[240,500,-1,"Kathar, Ghazipur"],
"233232":[250,330,0.0,"Puraina, Ghazipur"],
"233233":[310,636,-1,"Deoria, Ghazipur"],
"233234":[390,880,0.24,"Sherpur Kalan, Ghazipur"],
"233300":[240,415,-1,"Dharmagatpur, Ghazipur"],
"233301":[250,621,-1,"Parasa, Ghazipur"],
"233302":[245,489,-1,"Belsari, Ghazipur"],
"233303":[258,552,-1,"Bauri, Ghazipur"],
"233304":[250,561,0.0,"Kaneri, Ghazipur"],
"233305":[240,500,-1,"Belwa Urf Rasulpur, Ghazipur"],
"233306":[320,611,0.0,"Jewal, Ghazipur"],
"233307":[190,-1,0.0,"Khidirganj, Ghazipur"],
"233310":[244,492,-1,"Bajidpur, Ghazipur"],
"233311":[250,554,0.0,"Barhat, Ghazipur"],
"241001":[205,364,-1,"Hardoi, Hardoi"],
"241121":[205,358,0.0,"Kalika, Hardoi"],
"241122":[200,353,0.0,"Faridapur, Hardoi"],
"241123":[240,526,-1,"Babarpur, Hardoi"],
"241124":[240,415,-1,"Anjhi R S, Hardoi"],
"241125":[255,423,-1,"Majhila, Hardoi"],
"241126":[230,319,-1,"Barwa Sarsand, Hardoi"],
"241127":[230,403,-1,"Sandila I Estate, Hardoi"],
"241201":[202,314,-1,"Gauri Dayampur, Hardoi"],
"241202":[266,456,0.0,"Bhatpur, Hardoi"],
"241203":[183,358,-1,"Atsaliya, Hardoi"],
"241204":[183,356,-1,"Chhanoiya, Hardoi"],
"241301":[210,374,-1,"Noorpur Hathaura, Hardoi"],
"241302":[202,321,-1,"Gauntra, Hardoi"],
"241303":[206,373,-1,"Babatmau, Hardoi"],
"241304":[197,335,0.0,"Chathia, Hardoi"],
"241305":[230,394,-1,"Subhan Khera, Hardoi"],
"241401":[202,381,-1,"Naseoli Gopal, Hardoi"],
"241402":[170,619,-1,"Baran, Hardoi"],
"241403":[170,339,-1,"Kuchila, Hardoi"],
"241404":[260,430,-1,"Hariharpur, Hardoi"],
"241405":[205,457,-1,"Kurseli, Hardoi"],
"241406":[290,458,-1,"Bijgawan, Hardoi"],
"241407":[190,436,-1,"Alam Nagar, Hardoi"],
"242001":[192,361,-1,"Shahjahanpur, Shahjahanpur"],
"242021":[130,339,-1,"Mehua Hasanganj, Sambhal"],
"242042":[192,361,-1,"Azmatpur, Shahjahanpur"],
"242127":[192,361,-1,"Kilapur, Shahjahanpur"],
"242220":[192,361,-1,"Raghunathpur, Shahjahanpur"],
"242221":[192,361,-1,"Bangaon, Shahjahanpur"],
"242223":[192,361,-1,"Babakkarpur, Shahjahanpur"],
"242226":[192,361,-1,"Azizganj, Shahjahanpur"],
"242301":[192,361,-1,"Baisaribaisra, Shahjahanpur"],
"242303":[192,361,-1,"Awa, Shahjahanpur"],
"242305":[192,361,-1,"Jalalpur, Shahjahanpur"],
"242306":[192,361,-1,"Bankagaon, Shahjahanpur"],
"242307":[192,361,-1,"Dhakiaragha, Shahjahanpur"],
"242401":[192,361,-1,"Ayun, Shahjahanpur"],
"242405":[192,361,-1,"Chandpur, Shahjahanpur"],
"242406":[192,361,-1,"Pasgawan, Shahjahanpur"],
"242407":[192,361,-1,"Bharribasantpur, Shahjahanpur"],
"243001":[195,348,-1,"Bareilly, Bareilly"],
"243002":[153,351,0.0,"Rithora, Bareilly"],
"243003":[150,339,-1,"Shehdana Colony, Bareilly"],
"243004":[184,340,0.0,"Haraulia, Bareilly"],
"243005":[150,331,0.0,"Old City, Bareilly"],
"243006":[198,334,-1,"Mahanagar, Bareilly"],
"243122":[175,333,-1,"Biharman Nagla, Bareilly"],
"243123":[140,295,-1,"Bithri Chainpur, Bareilly"],
"243126":[140,312,-1,"DOHRIYA, Bareilly"],
"243201":[138,328,-1,"Dunda Sumali, Bareilly"],
"243202":[150,339,-1,"Bhairpura, Bareilly"],
"243203":[140,301,-1,"Mundia Jagir, Bareilly"],
"243301":[158,342,-1,"Digoi, Bareilly"],
"243302":[140,294,-1,"Gaini, Bareilly"],
"243303":[150,317,-1,"Baragoan, Bareilly"],
"243401":[150,349,-1,"Sirohi, Bareilly"],
"243402":[130,309,-1,"Himmatpur, Bareilly"],
"243403":[135,360,0.0,"Malgoan, Bareilly"],
"243407":[129,262,-1,"Baraur, Bareilly"],
"243501":[126,336,0.0,"Aundh, Bareilly"],
"243502":[100,314,-1,"Ghunsa, Bareilly"],
"243503":[150,299,0.0,"Dhakni Rajpuri, Bareilly"],
"243504":[140,325,-1,"Behroli, Bareilly"],
"243505":[160,319,-1,"Balli, Bareilly"],
"243506":[150,337,-1,"Jaraul, Bareilly"],
"243601":[315,720,-1,"Budaun, Budaun"],
"243630":[150,346,0.0,"Jhuksa, Budaun"],
"243631":[210,465,-1,"Abhigaon, Budaun"],
"243632":[280,587,-1,"Gangoli, Budaun"],
"243633":[200,442,-1,"Nagarjhoona, Budaun"],
"243634":[158,385,0.0,"Beor, Budaun"],
"243635":[210,368,-1,"Ghilaur, Budaun"],
"243636":[269,607,-1,"Dehemu, Budaun"],
"243637":[250,613,-1,"Mohammad Ganj, Budaun"],
"243638":[130,236,-1,"Mithanpur, Sambhal"],
"243639":[315,708,-1,"Butla Daulat, Budaun"],
"243641":[210,468,-1,"Bhundi, Budaun"],
"243720":[236,445,-1,"Hatsa, Budaun"],
"243722":[259,463,0.0,"Bandarai, Sambhal"],
"243723":[197,400,-1,"Beor Kasimabad, Budaun"],
"243724":[210,426,-1,"Chani, Budaun"],
"243725":[170,399,-1,"Katgaon, Budaun"],
"243726":[210,444,-1,"Beoli, Budaun"],
"243727":[240,437,-1,"Gawan, Sambhal"],
"243751":[202,428,-1,"Dinaura, Sambhal"],
"244001":[213,350,-1,"Moradabad, Moradabad"],
"244102":[245,381,-1,"Deorhi Urf Hadipur, Amroha"],
"244103":[156,320,-1,"Majhola SO Moradabad, Moradabad"],
"244104":[212,350,0.0,"Kankar Khera, Moradabad"],
"244105":[212,352,-1,"Mahlakpur Nizampur, Moradabad"],
"244221":[230,575,-1,"Amroha, Amroha"],
"244222":[230,509,-1,"Didauli, Amroha"],
"244223":[330,536,-1,"Bhartiya Gram, Amroha"],
"244225":[330,536,-1,"Chakanwala, Amroha"],
"244231":[330,366,0.0,"Chuchelakalan, Amroha"],
"244235":[330,536,-1,"Kankather, Amroha"],
"244236":[230,574,-1,"Chand Nagar, Amroha"],
"244241":[330,536,-1,"Yaqubpur, Amroha"],
"244242":[230,574,-1,"Chakooni, Amroha"],
"244245":[230,552,-1,"Kundan Nagar, Amroha"],
"244251":[330,536,-1,"Awalpur, Amroha"],
"244255":[230,574,-1,"Adampur, Amroha"],
"244301":[156,320,-1,"Gurer, Sambhal"],
"244302":[155,319,-1,"Bhawanipur, Sambhal"],
"244303":[267,489,0.0,"Amawati Qutubpur, Sambhal"],
"244304":[230,575,-1,"Dulapur Urf Darapur, Sambhal"],
"244401":[156,320,-1,"Sadarpur, Amroha"],
"244402":[200,322,-1,"Bhagatpur Tanda, Moradabad"],
"244410":[205,407,-1,"Alpur Maithra, Sambhal"],
"244411":[219,373,-1,"Chandrapur Kalan, Moradabad"],
"244412":[155,318,-1,"Chandausi RS, Sambhal"],
"244413":[300,436,-1,"Hathipur Chandoi, Moradabad"],
"244414":[156,320,-1,"Afjalpur Darauli, Sambhal"],
"244415":[198,329,-1,"Narainpur, Moradabad"],
"244501":[194,355,-1,"Bibra Khurd, Amroha"],
"244504":[219,373,-1,"Fatehpur Vishnoi, Moradabad"],
"244601":[160,404,-1,"Bahadur Nagar, Moradabad"],
"244602":[155,408,-1,"Rajupur Kalan, Moradabad"],
"244701":[190,330,-1,"Jiwai Kadim, Rampur"],
"244712":[194,395,-1,"Dharampur, Udam Singh Nagar"],
"244713":[194,336,-1,"Chaukhandi, Udam Singh Nagar"],
"244715":[200,286,-1,"Devayal, Almora"],
"244716":[229,345,-1,"Anandnagar, Nainital"],
"244717":[174,311,-1,"SM Nadehi, Udam Singh Nagar"],
"244720":[230,386,-1,"SULTANPUR PATTI, Udam Singh Nagar"],
"244901":[209,345,0.0,"Rampur, Rampur"],
"244921":[187,322,-1,"Hamidabad, Rampur"],
"244922":[190,330,-1,"Bara Gaon, Rampur"],
"244923":[187,322,-1,"Chandain, Rampur"],
"244924":[190,330,-1,"Bhagwant Nagar, Udam Singh Nagar"],
"244925":[185,335,0.0,"Dhanupura, Rampur"],
"244926":[201,344,0.0,"Modipur, Rampur"],
"244927":[190,330,-1,"Ahmad Nagar Kalan, Rampur"],
"244928":[187,322,-1,"Kemri SO Rampur, Rampur"],
"245101":[200,487,-1,"New Hapur, Hapur"],
"245201":[200,549,-1,"Bankhanda, Hapur"],
"245205":[260,563,-1,"Garh Bridge Halt, Hapur"],
"245206":[200,833,-1,"Chandsara, Meerut"],
"245207":[205,565,-1,"Phuldehra, Hapur"],
"245208":[285,532,-1,"Alam Nagar, Hapur"],
"245301":[188,529,-1,"Parpa, Hapur"],
"245304":[190,534,-1,"Samaipur, Ghaziabad"],
"246001":[152,205,0.0,"Pauri, Pauri Garhwal"],
"246113":[263,430,0.0,"Falda, Pauri Garhwal"],
"246121":[265,365,-1,"Khera, Pauri Garhwal"],
"246123":[176,318,-1,"Buransi, Pauri Garhwal"],
"246124":[306,519,-1,"Rajbat, Pauri Garhwal"],
"246125":[175,318,-1,"Rampur Chatti, Pauri Garhwal"],
"246127":[303,507,-1,"Hanumanti, Pauri Garhwal"],
"246128":[205,291,-1,"Pulyasu, Pauri Garhwal"],
"246129":[179,321,-1,"Kandai, Pauri Garhwal"],
"246130":[175,318,-1,"Banani, Pauri Garhwal"],
"246131":[270,470,-1,"Bachali, Pauri Garhwal"],
"246142":[170,324,0.0,"Kalagarh, Pauri Garhwal"],
"246144":[256,427,-1,"Paranda, Pauri Garhwal"],
"246146":[152,205,0.0,"Tairi, Pauri Garhwal"],
"246147":[235,328,-1,"Pokhri Chalansyun, Pauri Garhwal"],
"246148":[312,639,-1,"Dhandkur, Pauri Garhwal"],
"246149":[265,461,-1,"Kotdwara, Pauri Garhwal"],
"246150":[250,410,-1,"Padampur Sukhro, Pauri Garhwal"],
"246155":[265,365,-1,"Lansdowne, Pauri Garhwal"],
"246159":[152,205,0.0,"Gaind, Pauri Garhwal"],
"246161":[186,296,-1,"Taria, Pauri Garhwal"],
"246162":[208,352,-1,"Chamnao, Pauri Garhwal"],
"246163":[266,437,0.0,"Siron, Pauri Garhwal"],
"246164":[188,367,-1,"Champeshwar, Pauri Garhwal"],
"246165":[308,526,-1,"Uragi, Pauri Garhwal"],
"246166":[269,445,0.0,"Pali, Pauri Garhwal"],
"246167":[267,466,-1,"DOVAL, Pauri Garhwal"],
"246169":[235,328,-1,"Kolakhal, Pauri Garhwal"],
"246171":[155,342,-1,"Maiki Marhi, Rudra Prayag"],
"246172":[270,445,0.0,"Kulhar, Pauri Garhwal"],
"246173":[263,432,0.0,"Gend, Pauri Garhwal"],
"246174":[235,328,-1,"Kaliyasaur, Pauri Garhwal"],
"246175":[265,434,0.0,"Gadhkot, Pauri Garhwal"],
"246176":[272,451,0.0,"Agrora, Pauri Garhwal"],
"246177":[179,321,-1,"Saindhar, Pauri Garhwal"],
"246178":[235,328,-1,"Srikot, Pauri Garhwal"],
"246179":[216,327,-1,"Chaukuri, Pauri Garhwal"],
"246193":[265,365,-1,"Mandoli Malli, Pauri Garhwal"],
"246194":[127,183,0.0,"Kholachauri, Pauri Garhwal"],
"246275":[250,410,-1,"Gadkharak Malla, Pauri Garhwal"],
"246276":[250,410,-1,"Baundar Khutinga, Pauri Garhwal"],
"246277":[180,307,-1,"Devlad, Pauri Garhwal"],
"246278":[179,321,-1,"Lachhi, Pauri Garhwal"],
"246279":[154,260,-1,"Khirarikhal, Pauri Garhwal"],
"246285":[175,319,-1,"Bagwari, Pauri Garhwal"],
"246424":[158,296,-1,"Bhimtalla, Chamoli"],
"246426":[174,317,-1,"Maikot, Chamoli"],
"246427":[115,210,-1,"Beradhar, Chamoli"],
"246428":[170,316,-1,"Rohira, Chamoli"],
"246429":[158,297,-1,"Duwa, Chamoli"],
"246431":[161,321,-1,"Koonigarh Bichali, Chamoli"],
"246435":[158,297,-1,"Bangali, Chamoli"],
"246440":[174,317,-1,"Kirsal, Chamoli"],
"246441":[116,210,-1,"Chiringa, Chamoli"],
"246444":[172,316,-1,"Chaundali, Chamoli"],
"246446":[158,297,-1,"Dhunglwali, Chamoli"],
"246449":[158,297,-1,"Mokh, Chamoli"],
"246453":[155,342,-1,"Chopta, Chamoli"],
"246455":[173,316,-1,"Chaliyapani, Chamoli"],
"246473":[155,342,-1,"Bhikona, Chamoli"],
"246474":[173,316,-1,"Kedarukhal, Chamoli"],
"246481":[158,346,-1,"Gairbaram, Chamoli"],
"246482":[136,253,-1,"Tungeshwar, Chamoli"],
"246486":[158,309,-1,"Lambagar, Chamoli"],
"246487":[173,317,-1,"Bainoli, Chamoli"],
"246488":[172,316,-1,"Kalusain, Chamoli"],
"246701":[316,584,-1,"Bijnor, Bijnor"],
"246721":[270,819,-1,"Bahadarpur Sherfuddin, Bijnor"],
"246722":[320,671,0.19,"Qadrabad, Bijnor"],
"246723":[213,1575,-1,"Khirni Barkatpur, Bijnor"],
"246724":[152,297,-1,"Barkhera, Bijnor"],
"246725":[178,271,0.0,"Ajdev Khanpur, Bijnor"],
"246726":[152,240,-1,"Amhera, Bijnor"],
"246727":[320,671,0.19,"Bishanpur, Bijnor"],
"246728":[200,303,-1,"Chowkpuri, Bijnor"],
"246729":[192,264,-1,"Sisauna, Bijnor"],
"246731":[190,359,-1,"Bahupura, Bijnor"],
"246732":[178,347,-1,"Sofatpur, Bijnor"],
"246733":[320,671,0.19,"Akhera, Bijnor"],
"246734":[320,671,0.19,"Khaspura, Bijnor"],
"246735":[320,671,0.19,"Sabdalpur, Bijnor"],
"246736":[208,314,0.0,"Rasoolpur Nagla, Bijnor"],
"246737":[320,595,-1,"Rahu Nagli, Bijnor"],
"246745":[320,671,0.19,"Kiwar, Bijnor"],
"246746":[320,671,0.19,"Daultabad, Bijnor"],
"246747":[320,671,0.19,"Shahnagar Kurali, Bijnor"],
"246749":[150,304,-1,"Bijauri, Bijnor"],
"246761":[320,671,0.19,"Dhampur, Aligarh"],
"246762":[320,671,0.19,"Bhagwanpur, Bijnor"],
"246763":[165,335,-1,"Jhakaki, Bijnor"],
"246764":[172,300,-1,"Barooki, Bijnor"],
"247001":[201,339,-1,"Saharanpur, Saharanpur"],
"247002":[240,348,-1,"PTC, Saharanpur"],
"247120":[247,402,-1,"Punwarka, Saharanpur"],
"247121":[216,473,0.01,"Bhuradev, Saharanpur"],
"247122":[159,615,0.0,"Badshahi Bagh, Saharanpur"],
"247129":[289,450,-1,"Kaluwala Jahanpur, Saharanpur"],
"247231":[240,309,0.02,"Budhakhera, Saharanpur"],
"247232":[240,418,0.05,"Chauri, Saharanpur"],
"247340":[292,678,-1,"Dhaiki, Saharanpur"],
"247341":[163,417,0.02,"Jharwan, Saharanpur"],
"247342":[245,609,0.04,"Aghiana, Saharanpur"],
"247343":[210,360,-1,"Titron, Saharanpur"],
"247451":[205,575,-1,"Sona Arjunpur, Saharanpur"],
"247452":[205,391,-1,"Khudana, Saharanpur"],
"247453":[205,427,-1,"Mora, Saharanpur"],
"247551":[172,265,-1,"Bachiti, Saharanpur"],
"247552":[225,436,-1,"Biharigarh, Saharanpur"],
"247554":[199,348,-1,"Babupur, Saharanpur"],
"247656":[230,425,-1,"Mundlana, Haridwar"],
"247658":[276,549,0.0,"Sultanpur, Haridwar"],
"247661":[248,523,-1,"Hallumajra, Haridwar"],
"247662":[236,455,-1,"Biharigarh, Saharanpur"],
"247663":[255,550,-1,"Khanpur, Haridwar"],
"247664":[180,417,-1,"Toda Kalyanpur, Haridwar"],
"247665":[200,431,-1,"Majhaul, Haridwar"],
"247666":[210,412,-1,"Dandhera, Haridwar"],
"247667":[215,487,-1,"Roorkee, Haridwar"],
"247668":[215,492,-1,"Bhalswagaj, Haridwar"],
"247669":[224,409,-1,"Harora, Saharanpur"],
"247670":[180,395,-1,"Nagla Salaru, Haridwar"],
"247671":[230,506,-1,"Maharajpur Kalan, Haridwar"],
"247771":[190,519,-1,"Nala, Shamli"],
"247772":[180,327,-1,"Balwa Kheri, Muzaffarnagar"],
"247773":[190,434,0.01,"Gogwan, Shamli"],
"247774":[190,502,0.02,"Khurgaon Issopur, Shamli"],
"247775":[190,524,-1,"Jasala, Shamli"],
"247776":[190,324,-1,"Balwa, Shamli"],
"247777":[180,330,-1,"Hind, Shamli"],
"247778":[210,420,0.02,"Garhi Abdulha Khan, Shamli"],
"248001":[262,834,0.0,"Dehradun GPO, Dehradun"],
"248002":[260,660,0.0,"Mohbewala, Dehradun"],
"248003":[260,651,0.0,"Dehradun Cantt, Dehradun"],
"248005":[260,1205,0.0,"Harawala, Dehradun"],
"248006":[260,588,0.0,"Newforest, Dehradun"],
"248007":[260,414,0.0,"Ambiwala, Dehradun"],
"248008":[281,1339,0.0,"Nakronda, Dehradun"],
"248009":[260,837,0.0,"Bhagwantpur, Dehradun"],
"248011":[148,306,0.0,"Selaqui, Dehradun"],
"248012":[260,977,0.0,"Doon University, Dehradun"],
"248013":[260,878,0.0,"Sarona, Dehradun"],
"248014":[260,926,0.0,"Shamshergarh, Dehradun"],
"248015":[260,1082,0.0,"Sudhowala, Dehradun"],
"248016":[260,1140,0.0,"Bichli Jolly, Dehradun"],
"248018":[262,783,0.0,"Mehunwala, Dehradun"],
"248019":[260,1153,0.0,"Balawala, Dehradun"],
"248020":[260,873,0.0,"Dehradun GPO, Dehradun"],
"248121":[340,881,0.03,"Banjarawala, Dehradun"],
"248122":[257,674,0.0,"Barlowganj, Dehradun"],
"248123":[440,806,-1,"Bhandrauli, Dehradun"],
"248124":[366,858,0.0,"Myunda, Dehradun"],
"248125":[150,640,0.0,"Ambari, Dehradun"],
"248140":[260,951,0.0,"Badonwala, Dehradun"],
"248142":[155,643,0.0,"Kulhal, Dehradun"],
"248143":[232,593,0.0,"Dharkot, Dehradun"],
"248145":[232,592,0.0,"Dandi, Dehradun"],
"248146":[260,623,0.0,"Seemadwar, Dehradun"],
"248158":[202,594,0.0,"Badho, Dehradun"],
"248159":[254,303,0.0,"Chhibroo, Dehradun"],
"248165":[210,581,-1,"Dimau, Dehradun"],
"248171":[260,679,0.0,"Kanwali, Dehradun"],
"248179":[257,897,0.0,"Jharipani, Dehradun"],
"248195":[262,824,0.0,"IPE, Dehradun"],
"248196":[257,707,0.0,"Bullard, Dehradun"],
"248197":[135,377,0.0,"Barwa, Dehradun"],
"248198":[160,589,0.0,"WhtI, Dehradun"],
"248199":[160,738,-1,"Atal, Dehradun"],
"249001":[258,566,-1,"Tehri, Tehri Garhwal"],
"249121":[300,622,0.0,"Gomukh, Tehri Garhwal"],
"249122":[289,544,0.0,"Durogi, Tehri Garhwal"],
"249123":[301,626,0.0,"Radhudhar, Tehri Garhwal"],
"249124":[289,1264,-1,"Bhagirathipuram, Tehri Garhwal"],
"249125":[230,535,-1,"Bhaatgaon, Tehri Garhwal"],
"249126":[150,205,0.0,"Souru, Tehri Garhwal"],
"249127":[283,663,0.0,"Chherabdhar, Tehri Garhwal"],
"249128":[272,756,-1,"Dhatmeer, Uttar Kashi"],
"249130":[289,1263,-1,"Jaulangi, Tehri Garhwal"],
"249131":[70,115,-1,"Kandikhal, Tehri Garhwal"],
"249132":[228,509,-1,"Siyansu, Tehri Garhwal"],
"249135":[233,555,-1,"Malla, Uttar Kashi"],
"249137":[152,190,0.0,"Munikireti, Tehri Garhwal"],
"249141":[272,756,-1,"Gadoli, Uttar Kashi"],
"249145":[70,115,-1,"Jad Gaon, Tehri Garhwal"],
"249146":[152,205,0.0,"Jakholi, Tehri Garhwal"],
"249151":[251,650,-1,"Bhatwaridhanari, Uttar Kashi"],
"249152":[258,595,-1,"Patara, Uttar Kashi"],
"249155":[196,445,-1,"Dewath, Tehri Garhwal"],
"249161":[152,205,0.0,"Dhari Dhundsir, Tehri Garhwal"],
"249165":[229,527,-1,"Kandiyalgaon, Tehri Garhwal"],
"249171":[272,756,-1,"Gaatu, Uttar Kashi"],
"249175":[287,606,0.0,"Dyuli, Tehri Garhwal"],
"249180":[265,752,0.0,"Chuliyani, Tehri Garhwal"],
"249181":[187,400,0.0,"Barkot, Tehri Garhwal"],
"249185":[238,502,0.0,"Hudoli, Uttar Kashi"],
"249186":[273,569,0.0,"Mogi, Tehri Garhwal"],
"249192":[153,214,0.0,"Banskatal, Tehri Garhwal"],
"249193":[238,578,-1,"Bonga, Uttar Kashi"],
"249194":[233,554,-1,"Maneri, Uttar Kashi"],
"249196":[258,481,-1,"Dichli, Uttar Kashi"],
"249199":[70,115,-1,"Lamkot, Tehri Garhwal"],
"249201":[190,323,0.0,"Railway Road Rishikesh, Dehradun"],
"249202":[190,634,0.0,"Nirmal Block, Dehradun"],
"249203":[190,583,0.0,"Pashulok, Dehradun"],
"249204":[190,640,0.0,"Khadri Khadakmaf, Dehradun"],
"249205":[190,1592,0.0,"Haripur Kalan, Dehradun"],
"249206":[276,549,0.0,"Chiddarwala, Dehradun"],
"249301":[285,668,0.0,"Kulasu, Pauri Garhwal"],
"249302":[241,528,0.0,"Laxmanjhula B, Pauri Garhwal"],
"249304":[264,609,0.0,"Maral, Pauri Garhwal"],
"249306":[190,955,0.0,"Ganga Bhogpur, Pauri Garhwal"],
"249401":[218,926,-1,"Haridwar, Haridwar"],
"249402":[216,495,-1,"Garhmirpur, Haridwar"],
"249403":[249,733,-1,"SectorIII BHEL, Haridwar"],
"249404":[280,787,-1,"Sarai, Haridwar"],
"249405":[218,532,-1,"Daulatpur, Haridwar"],
"249407":[213,1523,-1,"Arya Nagar SO Haridwar, Haridwar"],
"249408":[218,602,-1,"Missarpur, Haridwar"],
"249410":[295,1141,-1,"Sadhubela Bhupatwala, Haridwar"],
"249411":[232,1092,0.0,"Shantikunj, Haridwar"],
"249412":[218,498,-1,"Navoday Nagar, Haridwar"],
"250001":[278,603,-1,"Meerut Cantt, Meerut"],
"250002":[248,605,-1,"Meerut City, Meerut"],
"250003":[278,611,-1,"Meerut Kutchery, Meerut"],
"250004":[245,580,-1,"Datawali, Meerut"],
"250005":[248,545,-1,"MIET, Meerut"],
"250101":[286,771,0.01,"Fakharpur, Baghpat"],
"250103":[250,584,-1,"Bhoor Baral, Meerut"],
"250104":[210,376,-1,"Shafibad Loti, Meerut"],
"250106":[210,359,-1,"Hasanpur Kalan, Meerut"],
"250110":[270,516,-1,"Dulhera, Meerut"],
"250205":[250,511,-1,"Kanshi, Meerut"],
"250221":[280,517,-1,"Daurala Gaon, Meerut"],
"250222":[228,472,-1,"Mahal, Meerut"],
"250223":[280,466,-1,"Dadri, Meerut"],
"250341":[260,553,-1,"Bhalsona, Meerut"],
"250342":[270,532,-1,"Jhitkari, Meerut"],
"250344":[260,494,-1,"Panchli Buzurg, Meerut"],
"250345":[273,647,-1,"Bijwara, Baghpat"],
"250401":[200,330,-1,"Akbarpur Sadat, Meerut"],
"250402":[200,337,-1,"Sathla, Meerut"],
"250404":[248,351,-1,"Doodhli, Meerut"],
"250406":[210,325,-1,"Ahmedpuri, Meerut"],
"250501":[250,409,-1,"Nek, Meerut"],
"250502":[272,557,-1,"Dalampur, Meerut"],
"250601":[412,931,0.05,"Sujra, Baghpat"],
"250606":[307,713,-1,"Budhsaini, Baghpat"],
"250609":[400,1019,0.31,"Ahera, Baghpat"],
"250611":[215,531,0.13,"Baraut, Baghpat"],
"250615":[412,981,-1,"Khatta Prahladpur, Baghpat"],
"250617":[178,629,0.03,"Badarkha, Meerut"],
"250619":[428,930,0.12,"Faizpur Ninana, Baghpat"],
"250620":[216,528,0.06,"Bijrol, Baghpat"],
"250621":[232,546,0.07,"Jalalpur, Baghpat"],
"250622":[227,519,-1,"Bharal, Baghpat"],
"250623":[215,536,-1,"Budhpur, Baghpat"],
"250625":[205,514,-1,"Gangnauli, Baghpat"],
"250626":[270,631,-1,"Mukri, Meerut"],
"251001":[172,247,-1,"Muzaffarnagar, Muzaffarnagar"],
"251002":[207,467,-1,"Ratheri, Muzaffarnagar"],
"251003":[175,324,-1,"Jaroda, Muzaffarnagar"],
"251201":[229,347,-1,"Chand Samad, Muzaffarnagar"],
"251202":[172,277,-1,"Rampur, Muzaffarnagar"],
"251203":[200,379,-1,"Jeewana, Muzaffarnagar"],
"251301":[175,281,-1,"Jasoi, Muzaffarnagar"],
"251305":[175,278,-1,"Gogwan Jalalpur, Shamli"],
"251306":[172,265,-1,"Budina Khurd, Muzaffarnagar"],
"251307":[202,328,-1,"Chhapar, Muzaffarnagar"],
"251308":[371,740,-1,"Jat Mujhera, Muzaffarnagar"],
"251309":[209,430,-1,"Dabheri Rasulpur, Muzaffarnagar"],
"251310":[361,742,-1,"Gadhla, Muzaffarnagar"],
"251311":[172,290,-1,"Dadherukalan, Muzaffarnagar"],
"251314":[220,365,-1,"Dhansari, Muzaffarnagar"],
"251315":[227,360,-1,"Kutubpur, Muzaffarnagar"],
"251316":[340,655,-1,"Behupura, Muzaffarnagar"],
"251318":[216,398,-1,"Dhindawali, Muzaffarnagar"],
"251319":[175,299,-1,"Bhanera Jat, Shamli"],
"251320":[231,363,-1,"Siali, Muzaffarnagar"],
"251327":[232,762,-1,"Hari Nagar, Muzaffarnagar"],
"261001":[270,694,-1,"Sitapur, Sitapur"],
"261121":[250,434,0.0,"Dateli, Sitapur"],
"261125":[270,551,-1,"Bizwar, Sitapur"],
"261131":[270,501,-1,"Ashrafpur, Sitapur"],
"261135":[245,386,-1,"Akbarpur, Sitapur"],
"261136":[270,464,0.0,"Lalpur, Sitapur"],
"261141":[230,381,-1,"Baragaon, Sitapur"],
"261145":[260,551,-1,"Belwa Baharurpur, Sitapur"],
"261151":[230,371,-1,"Bargawan, Sitapur"],
"261201":[250,851,-1,"Hasnapur, Sitapur"],
"261202":[250,434,0.0,"Bhainsaha, Sitapur"],
"261203":[225,311,-1,"Baghain, Sitapur"],
"261204":[207,343,0.0,"Bahadurganj, Sitapur"],
"261205":[250,845,-1,"Bambhanawan, Sitapur"],
"261206":[260,465,0.0,"Bambhaur, Sitapur"],
"261207":[212,324,-1,"Kasraila Bazar, Sitapur"],
"261208":[250,844,-1,"Behta Pakauri, Sitapur"],
"261301":[278,538,-1,"Dahawa, Sitapur"],
"261302":[285,664,-1,"Makhuwapur, Sitapur"],
"261303":[285,671,-1,"Gandhauli, Sitapur"],
"261304":[285,621,-1,"Atariya, Sitapur"],
"261401":[240,422,-1,"Akbapur, Sitapur"],
"261402":[240,422,-1,"Bhithauli Chitrakoot, Sitapur"],
"261403":[210,355,-1,"Korauna, Sitapur"],
"261404":[270,552,-1,"Sakrara, Sitapur"],
"261405":[240,445,-1,"Amtamau, Sitapur"],
"261501":[320,569,-1,"Alipur, Kheri"],
"261502":[240,569,-1,"Badalipur, Kheri"],
"261505":[224,354,-1,"Barbar, Kheri"],
"261506":[318,490,-1,"Daudpur, Kheri"],
"262001":[168,286,0.0,"Pilibhit, Pilibhit"],
"262121":[169,288,0.0,"Banskhera, Pilibhit"],
"262122":[130,244,-1,"Abhaipur, Pilibhit"],
"262123":[192,361,-1,"Goradhanenega, Pilibhit"],
"262124":[130,238,-1,"Jamunia, Pilibhit"],
"262201":[175,262,-1,"Amrita, Pilibhit"],
"262202":[169,288,0.0,"Bhaden Kanja, Pilibhit"],
"262203":[192,288,-1,"Khajuria Pachpera, Pilibhit"],
"262302":[194,288,-1,"Hardaspur, Pilibhit"],
"262305":[228,368,-1,"Pandari, Pilibhit"],
"262308":[245,437,-1,"Gaujhariya, Udam Singh Nagar"],
"262309":[224,365,-1,"Tanakpur, Champawat"],
"262310":[222,351,-1,"Banbassa Canal, Champawat"],
"262311":[172,409,-1,"Sarasaria, Udam Singh Nagar"],
"262401":[403,910,-1,"Bannakhera, Udam Singh Nagar"],
"262402":[208,342,-1,"Lalkua, Nainital"],
"262405":[172,397,-1,"Nakulia, Udam Singh Nagar"],
"262406":[151,305,-1,"Attangachandpur, Bareilly"],
"262522":[331,906,-1,"Chahaj, Pithoragarh"],
"262523":[242,361,-1,"Bhudam, Champawat"],
"262524":[239,377,-1,"Chilkote, Champawat"],
"262525":[233,347,-1,"Chanda Regru, Champawat"],
"262526":[130,245,-1,"Jhulaghat, Pithoragarh"],
"262527":[214,335,-1,"Bisrari, Champawat"],
"262528":[228,339,-1,"Chauramehta, Champawat"],
"262529":[242,362,-1,"Toli, Pithoragarh"],
"262531":[333,917,-1,"Chankana, Pithoragarh"],
"262532":[335,922,-1,"Bankote, Pithoragarh"],
"262533":[333,921,-1,"Kotgari Ghanjri, Pithoragarh"],
"262534":[332,911,-1,"Koteshwar, Pithoragarh"],
"262541":[333,912,-1,"Bishonakhan, Pithoragarh"],
"262561":[238,377,-1,"Sango, Champawat"],
"262572":[335,927,-1,"Tarigaon, Pithoragarh"],
"262580":[182,278,-1,"Dholigaon, Champawat"],
"262701":[320,458,-1,"Kheri, Kheri"],
"262702":[305,440,-1,"Gopalapur, Kheri"],
"262721":[258,452,-1,"Ambarsot, Kheri"],
"262722":[240,497,-1,"Ludhauni, Kheri"],
"262723":[278,493,-1,"Amethi, Kheri"],
"262724":[270,410,-1,"Ghurghutta Bujurg, Kheri"],
"262725":[305,432,-1,"Khanpur Gurela, Kheri"],
"262726":[319,495,-1,"Badagaon, Kheri"],
"262727":[235,393,-1,"Birampur, Kheri"],
"262728":[345,572,-1,"Atkohana, Kheri"],
"262801":[317,521,0.0,"Pahar Nagar, Kheri"],
"262802":[266,429,0.0,"Bakkhari, Kheri"],
"262803":[309,493,0.0,"Tharvaranpur, Kheri"],
"262804":[188,292,-1,"Ajehra, Kheri"],
"262805":[235,419,-1,"Kotwa, Kheri"],
"262901":[257,412,0.0,"Nauser Gularia, Kheri"],
"262902":[322,491,-1,"Ataria, Kheri"],
"262903":[320,461,-1,"Rakehati, Kheri"],
"262904":[130,244,-1,"Bhanpuri, Kheri"],
"262905":[320,461,-1,"Sinhauna, Kheri"],
"262906":[320,461,-1,"Raipur, Kheri"],
"262907":[320,461,-1,"Dareri, Kheri"],
"262908":[380,576,-1,"Bhoora, Kheri"],
"263001":[198,426,-1,"Nainital, Nainital"],
"263126":[225,359,-1,"Amritpur, Nainital"],
"263127":[224,731,-1,"Gethia, Nainital"],
"263128":[225,511,-1,"Bel, Nainital"],
"263132":[198,404,-1,"Mehragaon, Nainital"],
"263134":[135,209,-1,"Sethi Belgaon, Nainital"],
"263135":[135,181,-1,"Dhaniakote, Nainital"],
"263136":[225,425,-1,"Padampuri, Nainital"],
"263137":[183,360,-1,"Sargakhet, Nainital"],
"263138":[110,198,-1,"Dhyari, Nainital"],
"263139":[222,414,-1,"Haldwani, Nainital"],
"263140":[330,676,-1,"Dhamola, Nainital"],
"263141":[222,415,-1,"Kathghariya, Nainital"],
"263142":[210,343,-1,"Halduchaur, Nainital"],
"263145":[206,302,-1,"Haldi Udham Singh Nagar, Udam Singh Nagar"],
"263148":[177,277,-1,"Bagwara, Udam Singh Nagar"],
"263149":[250,395,-1,"DF Nagla, Udam Singh Nagar"],
"263150":[254,401,-1,"Kelakhera, Udam Singh Nagar"],
"263151":[188,396,-1,"Shaktifarm, Udam Singh Nagar"],
"263152":[300,425,-1,"Jhagarpuri, Udam Singh Nagar"],
"263153":[207,305,-1,"Bhurarani, Udam Singh Nagar"],
"263156":[198,431,-1,"Ghorakhal, Nainital"],
"263157":[201,294,-1,"Adhora, Nainital"],
"263158":[190,217,-1,"Nathuwakhan, Nainital"],
"263159":[330,400,-1,"Patalia, Nainital"],
"263160":[254,382,-1,"Majra Anand Singh, Udam Singh Nagar"],
"263601":[238,551,-1,"Almora, Almora"],
"263619":[248,591,-1,"Chaura, Bageshwar"],
"263620":[47,595,-1,"Kausani Estate, Bageshwar"],
"263621":[284,727,-1,"Binta, Almora"],
"263622":[170,260,-1,"Dhura, Almora"],
"263623":[170,260,-1,"Gunaditya, Almora"],
"263624":[238,551,-1,"Jamrari, Almora"],
"263625":[160,244,-1,"Anuli, Almora"],
"263626":[161,282,-1,"Bhabu, Almora"],
"263628":[348,966,-1,"Ason Mallakote, Bageshwar"],
"263629":[153,698,-1,"Lweshal, Almora"],
"263630":[260,1437,-1,"Janoti Palari, Bageshwar"],
"263631":[384,1091,-1,"Kapoori, Bageshwar"],
"263632":[372,1060,-1,"Daula, Bageshwar"],
"263633":[333,927,-1,"Bhanar, Bageshwar"],
"263634":[333,927,-1,"Kafali, Bageshwar"],
"263635":[47,962,-1,"Kotiyura, Bageshwar"],
"263636":[153,2732,-1,"Bhagtola ED, Almora"],
"263637":[153,2721,-1,"Bhoolgaon, Almora"],
"263638":[110,1666,-1,"Pokhari, Almora"],
"263639":[153,830,-1,"Naughar Estate, Bageshwar"],
"263640":[385,1092,-1,"Jhankra, Bageshwar"],
"263641":[47,962,-1,"Anna, Bageshwar"],
"263642":[377,1076,-1,"Amsarkote, Bageshwar"],
"263643":[190,238,-1,"Deolikhan, Almora"],
"263645":[170,217,-1,"Ranikhet, Almora"],
"263646":[170,217,-1,"Kotuli Malli, Almora"],
"263651":[135,209,-1,"Chaubattia, Almora"],
"263652":[170,217,-1,"Dwarson, Almora"],
"263653":[170,217,-1,"Asgoli ED, Almora"],
"263655":[110,1129,-1,"Rikhe, Almora"],
"263656":[161,293,-1,"Jaurasi, Almora"],
"263658":[161,293,-1,"Jharkote, Almora"],
"263659":[170,217,-1,"Munani, Almora"],
"263660":[170,217,-1,"Timtha, Almora"],
"263661":[188,330,-1,"Basai, Almora"],
"263663":[170,218,-1,"Billekh, Almora"],
"263664":[170,217,-1,"Sagneti, Almora"],
"263665":[274,648,-1,"Bawari Kichar, Almora"],
"263667":[170,217,-1,"Dabhra, Almora"],
"263676":[170,239,-1,"Chamkana, Almora"],
"263678":[238,551,-1,"Suri, Almora"],
"263679":[333,927,-1,"Gasi, Bageshwar"],
"263680":[170,217,-1,"Kotagiwai, Almora"],
"271001":[322,820,-1,"Gonda, Gonda"],
"271002":[326,758,-1,"Pandri Kirpal, Gonda"],
"271003":[322,818,-1,"Chandawatpur, Gonda"],
"271122":[250,408,-1,"Bhairampur, Gonda"],
"271123":[370,868,-1,"Bhgahar Buland, Gonda"],
"271124":[270,407,-1,"Achalpur, Gonda"],
"271125":[250,655,-1,"Durgodwa, Gonda"],
"271126":[230,622,-1,"Haldhar Mau, Gonda"],
"271129":[250,351,-1,"Karnipur Deeh, Gonda"],
"271201":[355,480,-1,"Balrampur, Balrampur"],
"271202":[300,474,-1,"Ayah, Gonda"],
"271203":[320,877,-1,"Ganeshpur, Balrampur"],
"271204":[267,432,-1,"Bishunpur Bel Bharia, Gonda"],
"271205":[411,878,-1,"Lai Budwa, Balrampur"],
"271206":[550,1227,-1,"Bhathar, Balrampur"],
"271207":[336,648,-1,"Bardaulia, Balrampur"],
"271208":[515,-1,-1,"Dharampur, Balrampur"],
"271209":[222,380,-1,"Janki Nagar, Gonda"],
"271210":[320,927,-1,"Bakaulirajpur, Balrampur"],
"271215":[550,1026,-1,"Bargadha Sohna, Balrampur"],
"271301":[270,559,-1,"Sumeripur, Gonda"],
"271302":[270,419,-1,"Andhiyari, Gonda"],
"271303":[247,393,-1,"Khargupur, Gonda"],
"271304":[243,379,-1,"Nawabganj S F, Gonda"],
"271305":[260,463,-1,"Ailanpur Grant, Gonda"],
"271306":[278,477,-1,"Datauli, Balrampur"],
"271307":[250,425,-1,"Lokiya Tahir, Balrampur"],
"271308":[260,417,-1,"Iti Mankapur, Gonda"],
"271309":[275,471,-1,"Bhopat Pur, Gonda"],
"271310":[250,367,-1,"Dumaria Deeh, Gonda"],
"271311":[360,659,-1,"Bhabhuwa Kot, Gonda"],
"271312":[294,460,-1,"Chandradeep Ghat, Gonda"],
"271313":[267,419,-1,"Mahrajganj Grant, Gonda"],
"271319":[190,303,-1,"Khadauwan, Gonda"],
"271401":[275,508,-1,"Barsada Ram Singh, Gonda"],
"271402":[311,467,0.0,"Barauli, Gonda"],
"271403":[290,503,-1,"Amdahi, Gonda"],
"271502":[230,657,-1,"Malauna, Gonda"],
"271503":[288,537,-1,"Ahiya Chet, Gonda"],
"271504":[320,465,-1,"Aata, Gonda"],
"271601":[350,786,-1,"Deoria Alawal, Gonda"],
"271602":[340,668,-1,"Dutt Nagar, Gonda"],
"271603":[272,672,-1,"Debari Kalan, Gonda"],
"271604":[333,558,-1,"Bhairampur, Balrampur"],
"271607":[300,857,-1,"Deoria Rani Jot, Balrampur"],
"271609":[345,642,-1,"Fakirapur, Balrampur"],
"271801":[300,517,-1,"Bahraich, Bahraich"],
"271802":[300,497,-1,"Chaukgoi, Bahraich"],
"271803":[271,422,-1,"Amrahwa, Shravasti"],
"271804":[265,409,-1,"Dikuali, Shravasti"],
"271805":[234,353,-1,"Mahdeiya, Shravasti"],
"271806":[311,516,-1,"Belwa Padum, Bahraich"],
"271821":[300,505,-1,"Puraina, Bahraich"],
"271824":[323,540,-1,"Mahsi, Bahraich"],
"271825":[330,584,-1,"Gadamar Kuurd, Bahraich"],
"271830":[234,549,-1,"Baibahi, Bahraich"],
"271831":[259,438,-1,"Ekgharwa, Shravasti"],
"271835":[222,328,-1,"Jaichandpur, Shravasti"],
"271840":[258,449,-1,"Bachkahwa, Shravasti"],
"271841":[222,511,-1,"Bichhiya, Bahraich"],
"271845":[225,345,-1,"Balapur, Shravasti"],
"271851":[248,634,-1,"Kewalpur, Bahraich"],
"271855":[253,764,-1,"Dharampur, Bahraich"],
"271861":[316,575,-1,"Bankatwa, Balrampur"],
"271865":[221,494,-1,"Amwa Pokhar, Bahraich"],
"271870":[281,436,-1,"Hariharpur, Bahraich"],
"271871":[330,517,-1,"Kashijot, Bahraich"],
"271872":[366,644,-1,"Bhaggarwa, Bahraich"],
"271875":[239,428,-1,"Raipur, Bahraich"],
"271881":[222,511,-1,"Madhavpur Nidaona, Bahraich"],
"271882":[262,441,-1,"Bulbul Newaj, Bahraich"],
"271901":[265,510,0.0,"Bhartha, Bahraich"],
"271902":[310,647,-1,"Bamiyari, Bahraich"],
"271903":[319,510,-1,"Goraihia, Bahraich"],
"271904":[280,646,-1,"Badhauli, Bahraich"],
"272001":[239,371,-1,"Basti, Basti"],
"272002":[270,412,-1,"Dudhaura, Basti"],
"272123":[229,302,0.0,"Bharwalia, Basti"],
"272124":[250,352,-1,"Rampur, Basti"],
"272125":[251,370,0.0,"Burhi Belhar, Sant Kabeer Nagar"],
"272126":[260,389,0.0,"Hatwa, Sant Kabeer Nagar"],
"272127":[290,505,-1,"Dhirauli Babu, Basti"],
"272128":[250,430,-1,"Nande Kuwan, Basti"],
"272129":[235,358,-1,"Malauli Gosain, Basti"],
"272130":[250,370,-1,"Bhainsaha, Basti"],
"272131":[250,563,-1,"Dubaulia, Basti"],
"272148":[281,488,-1,"Ghosiyari Bzr, Siddharth Nagar"],
"272150":[280,428,-1,"Ambari, Basti"],
"272151":[284,469,-1,"Dindai, Siddharth Nagar"],
"272152":[310,625,-1,"Deokali, Siddharth Nagar"],
"272153":[310,523,-1,"Ajgara, Siddharth Nagar"],
"272154":[255,461,-1,"Banauli, Sant Kabeer Nagar"],
"272155":[250,369,-1,"Bhadawal, Basti"],
"272161":[250,-1,0.0,"Mahuwadabar, Basti"],
"272162":[270,399,-1,"Chaparaghat, Sant Kabeer Nagar"],
"272163":[264,448,-1,"Ainpur, Basti"],
"272164":[190,290,0.0,"Tumpar, Sant Kabeer Nagar"],
"272165":[190,278,-1,"Bhainsa Khoont, Sant Kabeer Nagar"],
"272171":[210,315,-1,"Rautapar, Basti"],
"272172":[175,289,-1,"Lutuhi, Sant Kabeer Nagar"],
"272173":[197,313,0.0,"Asharfa Bad, Sant Kabeer Nagar"],
"272175":[194,244,0.0,"Chakdahi, Sant Kabeer Nagar"],
"272176":[255,461,-1,"Kali Jagdishpur, Sant Kabeer Nagar"],
"272177":[270,310,-1,"Khairati, Basti"],
"272178":[210,343,-1,"Ahra, Basti"],
"272181":[225,423,-1,"Hundrakunwar, Basti"],
"272182":[274,455,-1,"Sansarpur, Basti"],
"272189":[285,457,-1,"Quadirabad, Siddharth Nagar"],
"272190":[270,392,-1,"Amrauli Sumali, Basti"],
"272191":[285,453,-1,"Amauna Pandey, Siddharth Nagar"],
"272192":[210,332,-1,"Bhojwar, Siddharth Nagar"],
"272193":[302,451,-1,"Chaukhara, Siddharth Nagar"],
"272194":[250,352,-1,"Amarediha, Basti"],
"272195":[320,460,0.0,"Shankarpur, Siddharth Nagar"],
"272199":[232,316,0.0,"Baur Byas, Sant Kabeer Nagar"],
"272201":[280,521,-1,"Audahi Kalan, Siddharth Nagar"],
"272202":[290,476,-1,"Alidapur, Siddharth Nagar"],
"272203":[255,435,-1,"Birdpur No13, Siddharth Nagar"],
"272204":[272,473,-1,"Chilihia, Siddharth Nagar"],
"272205":[410,857,-1,"Antari Bazar, Siddharth Nagar"],
"272206":[290,477,-1,"Beltikar, Siddharth Nagar"],
"272207":[255,429,-1,"SIDDHARTH NAGAR, Siddharth Nagar"],
"272208":[250,399,-1,"Tandia Bazar, Siddharth Nagar"],
"272270":[256,456,-1,"Kotia Urf Sekhui, Sant Kabeer Nagar"],
"272271":[219,342,-1,"Bisauwa, Sant Kabeer Nagar"],
"272301":[300,484,-1,"Chilma Bazar, Basti"],
"272302":[275,524,-1,"Lakhanahat, Basti"],
"273001":[230,369,-1,"Gorakhpur, Gorakhpur"],
"273002":[190,320,-1,"Baraipur, Gorakhpur"],
"273003":[218,339,-1,"Arogyamandir, Gorakhpur"],
"273004":[218,337,-1,"Basharatpur, Gorakhpur"],
"273005":[219,369,-1,"Rajghat, Gorakhpur"],
"273006":[219,349,-1,"Gita Vatika, Gorakhpur"],
"273007":[218,349,-1,"Lachchipur, Gorakhpur"],
"273008":[230,371,-1,"Kunraghat, Gorakhpur"],
"273009":[230,370,-1,"Gorakhpur University, Gorakhpur"],
"273010":[219,357,-1,"Jungle Chauri, Gorakhpur"],
"273011":[218,338,-1,"Basharatpur, Gorakhpur"],
"273012":[230,363,-1,"GR Railway Station, Gorakhpur"],
"273013":[217,328,-1,"Chargawan, Gorakhpur"],
"273014":[219,356,-1,"Jungle Laxmipur, Gorakhpur"],
"273015":[219,363,-1,"Dohariya Bazar, Gorakhpur"],
"273016":[240,385,-1,"Chapiya, Gorakhpur"],
"273017":[240,392,-1,"Siddharth Enclave, Gorakhpur"],
"273151":[190,268,-1,"Basantpur, Maharajganj"],
"273152":[200,296,-1,"Parasurampur, Gorakhpur"],
"273155":[170,226,-1,"Karimnagar, Gorakhpur"],
"273157":[225,353,-1,"Banjaria Sonbarsa, Maharajganj"],
"273158":[192,283,-1,"Bhaurabari, Gorakhpur"],
"273161":[189,289,-1,"Mahdewa, Maharajganj"],
"273162":[176,296,-1,"Khlikgarh, Maharajganj"],
"273163":[210,305,-1,"Badhra Mahant, Maharajganj"],
"273164":[302,578,-1,"Adda Bazar, Maharajganj"],
"273165":[208,326,-1,"Domara, Maharajganj"],
"273201":[200,297,-1,"Bishwanathpur, Gorakhpur"],
"273202":[190,303,-1,"Amahia, Gorakhpur"],
"273203":[190,296,-1,"Jungle Rasoolpur, Gorakhpur"],
"273207":[190,378,-1,"Jamuie Pandit, Maharajganj"],
"273209":[270,337,-1,"Dhuriapar, Gorakhpur"],
"273211":[190,342,-1,"Badhyapar, Gorakhpur"],
"273212":[200,424,-1,"Bargahan, Gorakhpur"],
"273213":[260,399,-1,"Patakhuli, Gorakhpur"],
"273301":[181,261,-1,"Harpurtiwari, Maharajganj"],
"273302":[186,357,-1,"Balua, Maharajganj"],
"273303":[186,405,-1,"Maharajganj, Maharajganj"],
"273304":[224,400,-1,"Baithwalia, Maharajganj"],
"273305":[284,513,-1,"Dangrupur, Maharajganj"],
"273306":[170,249,-1,"Jungle Dumri No1, Gorakhpur"],
"273308":[310,597,-1,"Bhagwanpur Bazar, Maharajganj"],
"273309":[244,390,-1,"Raj mandir Kala, Maharajganj"],
"273310":[168,233,-1,"Baidabazar, Maharajganj"],
"273311":[287,521,-1,"Gadaura, Maharajganj"],
"273312":[234,452,-1,"CHOWK BAZAR, Maharajganj"],
"273401":[219,410,-1,"Bagaghadha, Gorakhpur"],
"273402":[215,367,-1,"Bimuti, Gorakhpur"],
"273403":[174,361,-1,"Bhita, Gorakhpur"],
"273404":[240,406,-1,"Mokarimpur, Gorakhpur"],
"273405":[195,298,-1,"Kuin Bazar, Gorakhpur"],
"273406":[280,421,-1,"Barni Gopalpur, Gorakhpur"],
"273407":[234,385,-1,"Biraikhurd, Gorakhpur"],
"273408":[210,343,-1,"Chilwa, Gorakhpur"],
"273409":[230,410,-1,"Harpur, Gorakhpur"],
"273411":[190,344,-1,"Rajgarh, Gorakhpur"],
"273412":[230,344,0.0,"Baraipar, Gorakhpur"],
"273413":[195,257,-1,"Belipar, Gorakhpur"],
"274001":[240,381,-1,"Deoria, Deoria"],
"274149":[230,399,-1,"Lehani, Kushi Nagar"],
"274182":[260,725,-1,"Karmtar Sher Khan, Deoria"],
"274201":[230,399,-1,"Bardgonia, Deoria"],
"274202":[276,468,-1,"Chariayan Buzurg, Deoria"],
"274203":[230,399,-1,"Bhaisahi Bazar, Kushi Nagar"],
"274204":[230,399,-1,"Bardihadal, Deoria"],
"274205":[160,225,-1,"Khareshar, Deoria"],
"274206":[230,399,-1,"Bhatni Dadan, Deoria"],
"274207":[185,316,-1,"Chilua, Kushi Nagar"],
"274208":[230,399,-1,"Ekauna, Deoria"],
"274301":[230,399,-1,"Baulia, Kushi Nagar"],
"274302":[233,450,-1,"Amawa Digar, Kushi Nagar"],
"274303":[198,287,-1,"Basdila Pandey, Kushi Nagar"],
"274304":[244,427,-1,"Padrauna, Kushi Nagar"],
"274305":[215,358,-1,"Pakariyar Bazar, Kushi Nagar"],
"274306":[230,399,-1,"Chakhani Bhumihari Patti, Kushi Nagar"],
"274307":[210,326,-1,"Katai Bharpurwa, Kushi Nagar"],
"274308":[210,326,-1,"Khesiya, Kushi Nagar"],
"274309":[210,326,-1,"Sarya, Kushi Nagar"],
"274401":[230,399,-1,"Pipra Kanak, Kushi Nagar"],
"274402":[230,399,-1,"Dhuria Khas, Kushi Nagar"],
"274403":[240,381,-1,"KUSHINAGAR, Kushi Nagar"],
"274404":[229,450,-1,"Rampur Mahuabari, Deoria"],
"274405":[185,278,-1,"Ametahi, Deoria"],
"274406":[290,392,-1,"Piparaghat, Kushi Nagar"],
"274407":[230,399,-1,"Bagahi, Kushi Nagar"],
"274408":[185,278,-1,"Bajaratar Mahuawa, Deoria"],
"274409":[202,472,-1,"Ahiraulidan, Kushi Nagar"],
"274501":[229,541,-1,"Baikunthpur, Deoria"],
"274502":[165,250,-1,"Babhnauli Pandey, Deoria"],
"274505":[165,276,-1,"Malkauli, Deoria"],
"274506":[168,276,-1,"Mahuja, Deoria"],
"274508":[165,256,-1,"Ajana, Deoria"],
"274509":[168,267,-1,"Chordiha, Deoria"],
"274601":[230,459,-1,"Barakagaon, Deoria"],
"274602":[200,280,-1,"Deosia, Deoria"],
"274603":[239,374,-1,"Bishunpura Dewar, Deoria"],
"274604":[220,348,-1,"Dhaula Pandit, Deoria"],
"274701":[168,267,-1,"Dumari, Deoria"],
"274702":[185,287,-1,"Bahiari Baghel, Deoria"],
"274703":[230,374,-1,"Ratsia, Deoria"],
"274704":[185,287,-1,"Balua, Deoria"],
"274705":[200,288,-1,"Balua Afgan, Deoria"],
"274801":[195,301,-1,"Rampur Jungle, Kushi Nagar"],
"274802":[247,1676,0.08,"Bhaisaha, Kushi Nagar"],
"274806":[230,399,-1,"GIEstate, Deoria"],
"274807":[221,418,-1,"Piperpanti, Deoria"],
"274808":[168,267,-1,"Chero, Deoria"],
"275101":[190,394,-1,"Mau, Mau"],
"275102":[280,476,-1,"Adari, Mau"],
"275103":[190,400,-1,"Bagali Pijra, Mau"],
"275105":[200,418,-1,"Kalyanpur, Mau"],
"275201":[250,621,-1,"Pali, Ghazipur"],
"275202":[255,502,-1,"Jalalabad, Ghazipur"],
"275203":[240,475,-1,"Jalalpurdhani, Ghazipur"],
"275204":[250,461,-1,"Mirpur, Ghazipur"],
"275205":[250,500,-1,"Guraini, Ghazipur"],
"275301":[265,582,-1,"Katirahi Bugurg, Mau"],
"275302":[230,431,-1,"Fateh Pur Tal Naraja, Mau"],
"275303":[210,308,-1,"Mohammadabad Sipah, Mau"],
"275304":[255,524,-1,"Jamdih, Mau"],
"275305":[200,565,-1,"Bhela Bandh, Mau"],
"275306":[231,685,-1,"Bandi Ghat, Mau"],
"275307":[192,-1,0.0,"Majhwara, Mau"],
"276001":[280,403,-1,"Azamgarh, Azamgarh"],
"276121":[240,385,-1,"Gaddopur, Azamgarh"],
"276122":[508,660,0.0,"Chan Patti, Azamgarh"],
"276123":[300,720,0.0,"Bibipur, Azamgarh"],
"276124":[215,432,-1,"Jagdishpur, Azamgarh"],
"276125":[300,720,0.0,"Patkhauli, Azamgarh"],
"276126":[248,480,-1,"Aira Bujurg, Azamgarh"],
"276127":[686,1634,-1,"Ramgarh, Azamgarh"],
"276128":[300,720,0.0,"Sewata, Azamgarh"],
"276129":[280,450,-1,"Karami, Mau"],
"276131":[240,438,-1,"Dharwara, Azamgarh"],
"276135":[300,720,0.0,"Jolhapur, Azamgarh"],
"276136":[430,1151,0.24,"Dighwania Kaji, Azamgarh"],
"276137":[300,720,0.0,"Dewara Jadid I, Azamgarh"],
"276138":[205,376,-1,"Berama, Azamgarh"],
"276139":[374,610,0.0,"Araji Amani, Azamgarh"],
"276140":[300,720,0.0,"Chaklal Chand, Azamgarh"],
"276141":[349,606,0.0,"Badasara Aima, Azamgarh"],
"276142":[300,720,0.0,"Amari, Azamgarh"],
"276143":[270,429,-1,"Balaipur, Azamgarh"],
"276201":[300,720,0.0,"Bahadur Pur, Azamgarh"],
"276202":[300,720,0.0,"Bhopalpur, Azamgarh"],
"276203":[300,720,0.0,"Nehula, Azamgarh"],
"276204":[300,720,0.0,"Babu Ki Khajuri, Azamgarh"],
"276205":[300,720,0.0,"Bisham, Azamgarh"],
"276206":[205,395,-1,"Mohanath, Azamgarh"],
"276207":[300,720,0.0,"Koilari, Azamgarh"],
"276208":[300,720,0.0,"Khutia, Azamgarh"],
"276288":[275,406,-1,"Bhani Pur, Azamgarh"],
"276301":[300,720,0.0,"Bargahan, Azamgarh"],
"276302":[300,720,0.0,"Dayalpur, Azamgarh"],
"276303":[300,720,0.0,"Kammar Pur, Azamgarh"],
"276304":[200,364,-1,"Loniadeeh, Azamgarh"],
"276305":[275,409,-1,"Rajapur Sikaraur, Azamgarh"],
"276306":[186,348,-1,"Rasoolpur, Mau"],
"276402":[181,283,0.0,"Nagpur, Mau"],
"276403":[382,660,0.0,"Bandikala, Mau"],
"276404":[250,394,-1,"Bind Mathia, Azamgarh"],
"276405":[212,385,-1,"Dewal Ashram, Mau"],
"276406":[280,395,-1,"Bamhaur, Azamgarh"],
"277001":[219,530,-1,"BALLIA, Ballia"],
"277121":[250,407,-1,"Balesara, Ballia"],
"277123":[240,402,-1,"Janaupur, Ballia"],
"277124":[250,572,-1,"Ukachhi, Ballia"],
"277201":[272,451,-1,"Pandey Pur, Ballia"],
"277202":[260,678,-1,"Deodih, Ballia"],
"277203":[230,482,-1,"Amghat, Ballia"],
"277204":[245,439,-1,"Dokati, Ballia"],
"277205":[272,503,-1,"Gangapur, Ballia"],
"277207":[270,744,-1,"Bahadura, Ballia"],
"277208":[272,442,-1,"Chakia, Ballia"],
"277209":[264,466,-1,"Bhojchapra, Ballia"],
"277210":[260,492,-1,"Kewara, Ballia"],
"277211":[260,499,-1,"Bigahi, Ballia"],
"277213":[270,768,-1,"Halpur, Ballia"],
"277214":[245,459,-1,"Laxman Chapra, Ballia"],
"277216":[264,437,-1,"Bahuara, Ballia"],
"277219":[285,644,-1,"Kirtupur, Ballia"],
"277301":[230,513,-1,"Kummhaila, Ballia"],
"277302":[240,589,-1,"Hathaunj, Ballia"],
"277303":[230,404,-1,"Chetankishor, Ballia"],
"277304":[250,556,-1,"Bharakhara, Ballia"],
"277401":[210,444,-1,"Repura, Ballia"],
"277402":[260,427,-1,"Babubel, Ballia"],
"277403":[262,460,-1,"Belahari, Ballia"],
"277501":[350,595,-1,"Kotwa Narayenpur, Ballia"],
"277502":[222,516,-1,"Chaura, Ballia"],
"277503":[230,504,-1,"Singhpur, Ballia"],
"277504":[310,596,-1,"Piprakala, Ballia"],
"277506":[210,702,-1,"Thamhanpura, Ballia"],
"281001":[1071,1498,0.0,"Mathura, Mathura"],
"281003":[744,1795,0.0,"Prem Nagar, Mathura"],
"281004":[817,1656,0.0,"Bati, Mathura"],
"281005":[817,1656,0.0,"Barari, Mathura"],
"281006":[817,1656,0.0,"Aurangabad, Mathura"],
"281104":[432,1668,0.0,"Rasgaon, Hathras"],
"281121":[817,1656,0.0,"Brij Academy, Mathura"],
"281122":[817,1656,0.0,"Bhaderua, Mathura"],
"281123":[817,1656,0.0,"Bachagaon, Mathura"],
"281201":[817,1656,0.0,"Chandpur Kalan, Mathura"],
"281202":[817,1656,0.0,"Arrua, Mathura"],
"281203":[817,1656,0.0,"Musmuna, Mathura"],
"281204":[817,1656,0.0,"Barhaun, Mathura"],
"281205":[817,1656,0.0,"Bhidoni, Mathura"],
"281206":[817,1656,0.0,"Gudera, Mathura"],
"281301":[817,1656,0.0,"Avairani, Mathura"],
"281302":[432,1668,0.0,"Baramai, Hathras"],
"281303":[681,1776,0.0,"Gokul, Mathura"],
"281305":[817,1656,0.0,"Hayatpur, Mathura"],
"281306":[370,1175,-1,"Edalpur, Hathras"],
"281307":[432,1668,0.0,"Khonda, Hathras"],
"281308":[817,1539,0.0,"Nasirpur, Mathura"],
"281401":[817,1656,0.0,"Bishambhara, Mathura"],
"281403":[817,1656,0.0,"Kamar, Mathura"],
"281404":[817,1656,0.0,"Agaryala, Mathura"],
"281405":[817,1656,0.0,"Kamai, Mathura"],
"281406":[817,1656,0.0,"Sehi, Mathura"],
"281501":[817,1656,0.0,"Jikhangaon, Mathura"],
"281502":[817,1656,0.0,"Palson, Mathura"],
"281504":[817,1656,0.0,"Ral, Mathura"],
"282001":[520,2009,-1,"Agra, Agra"],
"282002":[635,2239,-1,"Billoch Pura, Agra"],
"282003":[635,2221,-1,"Agra Fort, Agra"],
"282004":[635,2198,-1,"Agra University, Agra"],
"282005":[635,2167,-1,"Jaganpur, Agra"],
"282006":[555,2191,0.0,"Chhalesar, Agra"],
"282007":[635,2312,-1,"Arsena, Agra"],
"282008":[592,2230,-1,"IAF, Agra"],
"282009":[516,1954,-1,"Sultan Pura, Agra"],
"282010":[539,1821,0.67,"Bhogipura, Agra"],
"283101":[681,2441,0.18,"Biara, Agra"],
"283102":[838,2451,0.2,"Berichahar, Agra"],
"283103":[326,606,0.0,"Kurri Kuppa, Firozabad"],
"283104":[380,883,0.0,"Kwari, Agra"],
"283105":[950,2754,-1,"Daoli, Agra"],
"283110":[552,2201,0.36,"Gurki Mandi, Agra"],
"283111":[255,1377,1.14,"Arnota, Agra"],
"283112":[315,1046,0.63,"Rahlai, Agra"],
"283113":[251,470,0.0,"Holipura, Agra"],
"283114":[290,622,0.0,"Nadgawan, Agra"],
"283115":[348,2220,0.68,"Tantpur, Agra"],
"283119":[950,2751,-1,"Garh Mukha, Agra"],
"283121":[352,2945,1.26,"Bhilawali, Agra"],
"283122":[950,2530,-1,"Baseri Chahar, Agra"],
"283123":[278,653,0.36,"Karkoli, Agra"],
"283124":[352,1498,0.2,"Dankasha, Agra"],
"283125":[313,1085,0.71,"Garhi Lal Kalan, Agra"],
"283126":[635,1884,0.0,"Baman, Agra"],
"283130":[371,613,-1,"Kharit, Firozabad"],
"283135":[459,810,0.0,"Thanumai, Firozabad"],
"283136":[380,697,0.0,"Milawali, Firozabad"],
"283141":[530,872,0.0,"Asua, Firozabad"],
"283142":[324,531,0.0,"Kharaua, Firozabad"],
"283145":[308,602,0.0,"Kanwara, Firozabad"],
"283151":[354,611,0.0,"A G M Bhawali, Firozabad"],
"283152":[399,732,0.0,"Bhagner, Firozabad"],
"283201":[425,1904,-1,"Aharan, Agra"],
"283202":[386,2143,0.0,"Bhagupur, Agra"],
"283203":[319,470,0.0,"Firozabad, Firozabad"],
"283204":[295,314,0.0,"Gwari Nagla Singhi, Firozabad"],
"283205":[152,630,-1,"Collectorate firozabad, Firozabad"],
"283206":[110,665,-1,"Bartara, Firozabad"],
"283207":[245,372,0.0,"Konder, Firozabad"],
"284001":[316,528,0.0,"JHANSI, Jhansi"],
"284002":[339,567,0.0,"Boodha, Jhansi"],
"284003":[328,555,0.0,"Lalkurti Bazar, Jhansi"],
"284120":[317,528,0.0,"Khailar, Jhansi"],
"284121":[238,409,-1,"Garhmau, Jhansi"],
"284122":[250,466,-1,"Alapur, Lalitpur"],
"284123":[335,-1,0.0,"Bachhraoni, Lalitpur"],
"284124":[239,452,0.0,"Sirsi, Lalitpur"],
"284125":[335,-1,0.0,"Lakeviewcamp, Lalitpur"],
"284126":[263,457,0.0,"Bhuchera, Lalitpur"],
"284127":[334,554,0.0,"Simraha, Jhansi"],
"284128":[450,569,0.0,"Kochha Bhanwar, Jhansi"],
"284135":[334,558,0.0,"Hasari, Jhansi"],
"284136":[394,692,0.0,"Bangawan Kalan, Lalitpur"],
"284201":[424,648,0.0,"Taindol, Jhansi"],
"284202":[855,984,-1,"Kuretha, Jhansi"],
"284203":[411,937,-1,"Simardha, Jhansi"],
"284204":[203,547,0.0,"Barauri, Jhansi"],
"284205":[216,482,0.0,"Ghurat, Jhansi"],
"284206":[449,1071,-1,"Dhurwai, Jhansi"],
"284301":[238,334,-1,"Bajhera, Jhansi"],
"284302":[694,1613,-1,"Bilati Karke, Jhansi"],
"284303":[446,923,0.0,"Atariya, Jhansi"],
"284304":[368,732,0.0,"Chheonta, Jhansi"],
"284305":[322,552,0.0,"Parichha Thermal Power Project, Jhansi"],
"284306":[473,1067,0.0,"Amgaon, Jhansi"],
"284401":[310,-1,0.0,"Burhpura, Jhansi"],
"284402":[335,-1,0.0,"Paah, Lalitpur"],
"284403":[330,501,0.0,"LALITPUR, Lalitpur"],
"284404":[291,592,0.0,"Gidwaha, Lalitpur"],
"284405":[291,491,0.0,"Kakrauwa, Lalitpur"],
"284406":[354,648,0.0,"Arjunkhiriya, Lalitpur"],
"284419":[331,567,0.0,"Pali Pahari, Jhansi"],
"284501":[215,420,-1,"Deori, Lalitpur"],
"285001":[268,607,-1,"ORAI, Jalaun"],
"285121":[162,755,0.0,"Garherna, Jalaun"],
"285122":[508,853,-1,"Bandhauli, Jalaun"],
"285123":[169,539,-1,"Atra Kalan, Jalaun"],
"285124":[164,448,-1,"Bilond, Jalaun"],
"285125":[276,502,-1,"Gora Rathor, Jalaun"],
"285126":[129,629,0.0,"Dhamna, Jalaun"],
"285127":[168,657,0.0,"Pachokhara, Jalaun"],
"285128":[180,470,-1,"Gora Bhoopka, Jalaun"],
"285129":[146,441,-1,"Ajeetapur, Jalaun"],
"285130":[227,513,-1,"Abhedepur, Jalaun"],
"285201":[542,1125,-1,"Bharsoonda, Jalaun"],
"285202":[213,489,-1,"Itaura, Jalaun"],
"285203":[190,511,-1,"Babina, Jalaun"],
"285204":[230,899,-1,"Mainupur, Jalaun"],
"285205":[277,625,-1,"Bhend, Jalaun"],
"285206":[238,640,0.0,"Gaindoli, Jalaun"],
"285223":[497,1026,-1,"Binaura, Jalaun"],
"301001":[750,1485,0.26,"Alwar, Alwar"],
"301018":[585,1975,0.19,"Sheetal, Alwar"],
"301019":[253,537,0.07,"Shahdod, Alwar"],
"301020":[260,968,0.14,"Dooghera, Alwar"],
"301021":[520,2300,0.15,"Deenar, Alwar"],
"301022":[553,770,0.21,"Bhandrol, Alwar"],
"301023":[462,1436,0.22,"Rata Khurd, Alwar"],
"301024":[285,726,0.53,"Basaijogian, Alwar"],
"301025":[542,2091,0.22,"Rasgaon, Alwar"],
"301026":[585,2262,0.27,"Indpura, Alwar"],
"301027":[325,620,0.15,"Jhiri, Alwar"],
"301028":[698,1905,0.24,"Shahdoli, Alwar"],
"301030":[672,1762,0.24,"Bhageet, Alwar"],
"301035":[320,3573,1.34,"Adoli, Alwar"],
"301401":[215,797,0.09,"A.G.Dadhiya, Alwar"],
"301402":[325,1181,0.67,"Bhupsera, Alwar"],
"301403":[210,819,0.15,"Jatiyana, Alwar"],
"301404":[270,1152,0.22,"Mator, Alwar"],
"301405":[316,1163,0.36,"Baghora, Alwar"],
"301406":[230,516,0.36,"Beejwar, Alwar"],
"301407":[370,1420,0.19,"Gopipura, Alwar"],
"301408":[388,636,1.63,"Moonpur, Alwar"],
"301409":[334,969,1.27,"Karanpura, Alwar"],
"301410":[315,622,0.15,"Dariba Project, Alwar"],
"301411":[411,1320,0.56,"Bilaspur, Alwar"],
"301412":[392,1358,0.21,"Alanpur, Alwar"],
"301413":[310,1205,0.25,"Todanagar, Alwar"],
"301414":[330,578,0.39,"Bahali, Alwar"],
"301415":[330,779,1.62,"Bighota, Alwar"],
"301416":[752,1510,0.26,"Rampur S.O (Alwar), Alwar"],
"301427":[305,1005,0.15,"Peepli, Alwar"],
"301604":[620,2806,0.17,"Phari, Alwar"],
"301701":[260,898,0.13,"Bahror, Alwar"],
"301702":[330,896,0.68,"Bhagana, Alwar"],
"301703":[260,1231,0.19,"Doomroli, Alwar"],
"301704":[248,882,0.08,"Giglana, Alwar"],
"301705":[220,1278,0.14,"Naghori, Alwar"],
"301706":[455,967,0.07,"Gugalkota, Alwar"],
"301707":[290,766,0.99,"Chauharpur, Alwar"],
"301708":[560,715,0.0,"Santo, Alwar"],
"301709":[260,1083,0.15,"Basai, Alwar"],
"301713":[260,1149,0.18,"Khohrana, Alwar"],
"301714":[260,1022,0.14,"Sanoli, Alwar"],
"302001":[250,940,0.32,"Jaipur G.P.O., Jaipur"],
"302002":[275,995,0.44,"Govind Nagar S.O (Jaipur), Jaipur"],
"302003":[275,1006,0.46,"Krishi Upaj Mandi, Jaipur"],
"302004":[275,959,0.47,"Jawahar Nagar, Jaipur"],
"302005":[275,903,0.34,"N.C.R.Building, Jaipur"],
"302006":[275,913,0.31,"P.W.D.Office, Jaipur"],
"302012":[190,1891,0.07,"Neendar Banar, Jaipur"],
"302013":[300,1619,0.1,"Akhepura, Jaipur"],
"302015":[260,720,0.42,"Tonk Road, Jaipur"],
"302016":[250,956,0.24,"Shastri Nagar, Jaipur"],
"302017":[290,905,0.55,"Dantli, Jaipur"],
"302018":[290,694,0.65,"Durgapura, Jaipur"],
"302019":[190,719,0.18,"Shyam Nagar S.O (Jaipur), Jaipur"],
"302020":[220,660,0.37,"S.F.S.Mansarovar, Jaipur"],
"302021":[300,749,0.22,"Vaishali Nagar, Jaipur"],
"302022":[220,1778,0.25,"Goner, Jaipur"],
"302026":[220,1056,0.2,"Jaisinghpura Bas, Jaipur"],
"302027":[275,1242,1.93,"Indergarh, Jaipur"],
"302028":[300,1282,1.52,"Nangal Soosawatan, Jaipur"],
"302029":[290,1139,0.45,"Dadiya, Jaipur"],
"302031":[383,1393,0.41,"Luniawas, Jaipur"],
"302033":[220,789,0.47,"Pratap Nagar Housing Board, Jaipur"],
"302034":[190,719,0.18,"Panchyawala, Jaipur"],
"302037":[190,719,0.18,"Mahindra World City S.O (Jaipur), Jaipur"],
"302038":[275,1463,1.82,"Dhand, Jaipur"],
"302039":[275,1501,0.21,"Amba Bari, Jaipur"],
"302041":[260,818,0.21,"Dhankya, Jaipur"],
"302042":[158,1458,0.07,"Bad Ke Balaji, Jaipur"],
"302044":[132,868,0.09,"Govindpura S.O., Jaipur"],
"302046":[250,923,0.31,"Bhanpur kalan, Jaipur"],
"302047":[290,741,0.5,"NDC Mansarowar, Jaipur"],
"302048":[598,1847,0.02,"Sun City, Jaipur"],
"302049":[250,932,0.32,"NDC Jaipur GPO, Jaipur"],
"303001":[488,660,0.68,"Dangaarwara, Jaipur"],
"303002":[318,1571,1.96,"Labana, Jaipur"],
"303003":[480,767,0.26,"Bhamod, Jaipur"],
"303004":[335,1295,0.53,"Dhigariya, Dausa"],
"303005":[307,1619,0.25,"Mandi, Jaipur"],
"303006":[360,1985,0.43,"Bichi, Jaipur"],
"303007":[480,2516,0.35,"Ajairajpura, Jaipur"],
"303008":[470,1868,0.56,"Nanan, Jaipur"],
"303009":[620,2529,0.62,"Dhamana, Jaipur"],
"303012":[250,819,1.62,"Faliawas, Jaipur"],
"303102":[190,1460,0.28,"Beelwadi, Jaipur"],
"303103":[370,2078,0.3,"Shahpura, Jaipur"],
"303104":[190,719,0.18,"Chandwaji, Jaipur"],
"303105":[274,864,0.42,"Banethi, Jaipur"],
"303106":[220,589,0.57,"Fatehpura Khurd, Jaipur"],
"303107":[260,1388,0.5,"Bhuri Baraja, Jaipur"],
"303108":[325,2254,0.58,"Gonera, Jaipur"],
"303109":[300,1040,1.68,"Mahangi, Jaipur"],
"303110":[284,908,1.04,"Bhalloji, Jaipur"],
"303119":[170,461,0.06,"Antela, Jaipur"],
"303120":[290,1255,0.58,"Dantala Meena, Jaipur"],
"303121":[190,719,0.18,"NIMS University, Jaipur"],
"303122":[190,719,0.18,"Vedaant Gyan Valley, Jaipur"],
"303123":[415,1243,0.31,"Karansar, Jaipur"],
"303124":[598,1963,0.03,"Murlipura, Jaipur"],
"303301":[324,1539,0.42,"Mohanpura, Jaipur"],
"303302":[480,2577,0.87,"Anantpura, Dausa"],
"303303":[350,2170,0.39,"Dausa, Dausa"],
"303304":[240,697,1.04,"Bane Ka Barkhera, Dausa"],
"303305":[207,518,0.55,"Badwa, Jaipur"],
"303313":[311,1023,0.97,"Ananantwada, Dausa"],
"303315":[330,817,1.78,"Aliapara, Dausa"],
"303323":[235,483,0.0,"Chandera, Dausa"],
"303325":[405,2451,0.29,"Badoli, Dausa"],
"303326":[415,1243,0.31,"Bhandari, Dausa"],
"303327":[405,1832,0.43,"Keshrisinghpura, Dausa"],
"303328":[266,1948,0.59,"Manda Bhim Singh, Jaipur"],
"303329":[150,1293,0.4,"A C Jobner, Jaipur"],
"303338":[302,2445,0.55,"Akoda, Jaipur"],
"303348":[223,957,0.66,"Gidhani, Jaipur"],
"303501":[260,1018,0.51,"Behrawanda, Dausa"],
"303502":[265,503,0.36,"Denda Basedi, Dausa"],
"303503":[301,1276,0.84,"Daulatpura, Dausa"],
"303504":[325,779,0.18,"Binori, Dausa"],
"303505":[405,1726,0.22,"Dob, Dausa"],
"303506":[290,1255,0.58,"Mundghisya, Dausa"],
"303507":[290,1255,0.58,"Bishanpura, Dausa"],
"303508":[480,2577,0.87,"Heengwa, Dausa"],
"303509":[270,781,1.15,"Chandera, Dausa"],
"303510":[290,1255,0.58,"Amrabad, Dausa"],
"303511":[380,1240,0.66,"Indawa, Dausa"],
"303601":[420,1337,0.12,"Radawas, Jaipur"],
"303602":[480,2577,0.87,"Luniawas, Jaipur"],
"303603":[320,2161,1.26,"Bagawas, Jaipur"],
"303604":[480,2577,0.87,"Sambhar Lake, Jaipur"],
"303701":[430,2631,0.08,"Punana, Jaipur"],
"303702":[290,1255,0.58,"Tankarda, Jaipur"],
"303704":[404,3840,0.16,"Anantpura, Jaipur"],
"303706":[90,782,0.44,"Bassi Naga, Jaipur"],
"303712":[290,1255,0.58,"Anantpura, Jaipur"],
"303801":[425,2608,0.61,"Pratapura, Jaipur"],
"303803":[385,1761,0.05,"Bilanderpur, Jaipur"],
"303804":[290,1255,0.58,"Dhanota, Jaipur"],
"303805":[210,2143,0.35,"Chonp, Jaipur"],
"303806":[210,1222,0.47,"Gulab Bari, Jaipur"],
"303807":[251,912,0.44,"Hathnoda, Jaipur"],
"303901":[392,2276,0.28,"Akodiya, Jaipur"],
"303903":[360,2400,0.05,"Khajalpura, Jaipur"],
"303904":[230,1393,0.27,"Heerapura, Jaipur"],
"303905":[360,1895,0.41,"Mohanpura, Jaipur"],
"303908":[415,1445,0.54,"Roopa Hedi Kalan, Jaipur"],
"304001":[268,1298,0.24,"Tonk Raj, Tonk"],
"304021":[350,1279,0.78,"Chainpuria, Tonk"],
"304022":[353,1475,0.73,"Palai, Tonk"],
"304023":[290,1073,0.06,"Choru, Tonk"],
"304024":[315,1373,0.12,"Bosariya, Tonk"],
"304025":[374,1901,0.17,"Bahad, Tonk"],
"304026":[460,1478,0.22,"Gurai, Tonk"],
"304501":[228,1325,0.23,"Chandsen, Tonk"],
"304502":[273,1186,0.41,"Awara, Tonk"],
"304503":[301,1042,0.89,"Antoli, Tonk"],
"304504":[300,1559,0.32,"Bheepur, Tonk"],
"304505":[513,1541,0.18,"Baori, Tonk"],
"304507":[255,1183,0.36,"Thanwala, Tonk"],
"304801":[270,1382,0.31,"Sandera, Tonk"],
"304802":[315,1423,0.24,"Banthali, Tonk"],
"304803":[470,1713,0.1,"Chandli, Tonk"],
"304804":[230,1289,0.06,"Botunda, Tonk"],
"305001":[390,2038,1.09,"Ajmer, Ajmer"],
"305002":[290,1267,1.45,"Makhupura, Ajmer"],
"305003":[400,1842,1.37,"Dorai, Ajmer"],
"305004":[277,1149,1.17,"Chorsiawas, Ajmer"],
"305005":[303,1166,1.22,"Ajaiser, Ajmer"],
"305006":[294,1196,1.22,"NODAL DELIVERY CENTRE, Ajmer"],
"305007":[386,2053,1.03,"Gc Road Ajmer, Ajmer"],
"305009":[273,1546,0.62,"Mds University Ajmer, Ajmer"],
"305012":[380,1800,1.04,"Hatundi, Ajmer"],
"305021":[505,1967,0.68,"Kanwalai, Ajmer"],
"305022":[283,1257,1.27,"Bhagwan Pura, Ajmer"],
"305023":[401,2321,0.66,"Googhra, Ajmer"],
"305024":[378,2177,0.71,"Nareli, Ajmer"],
"305025":[290,4375,0.27,"Kana Kheri, Ajmer"],
"305026":[459,1497,0.66,"Netiyas, Nagaur"],
"305201":[359,1152,0.52,"Leswa, Ajmer"],
"305202":[420,1076,0.61,"Rudlai, Ajmer"],
"305203":[292,1043,0.87,"Arjunpura, Ajmer"],
"305204":[230,1093,0.89,"Budhwara, Ajmer"],
"305205":[290,1232,1.25,"Kotaj, Ajmer"],
"305206":[285,1121,1.1,"Bhaonta, Ajmer"],
"305207":[317,1160,0.85,"Alipura, Ajmer"],
"305401":[430,1071,0.86,"Baghsuri, Ajmer"],
"305402":[380,2247,0.38,"Bahera, Mulugu"],
"305403":[390,2590,0.65,"Jadana, Ajmer"],
"305404":[535,1589,0.7,"Sanpla, Ajmer"],
"305405":[535,1466,0.67,"Bhimrawas, Ajmer"],
"305406":[426,1747,0.57,"Lasadia, Ajmer"],
"305407":[343,1199,0.33,"Ghatiyali, Ajmer"],
"305408":[435,2406,0.77,"Bogla, Ajmer"],
"305412":[345,1450,0.62,"Barol, Ajmer"],
"305415":[461,1483,0.47,"Karonj, Ajmer"],
"305601":[345,1450,0.62,"Nasirabad, Ajmer"],
"305621":[216,762,0.6,"Chhachhundra, Ajmer"],
"305622":[216,763,0.59,"Khayda, Ajmer"],
"305623":[450,1312,0.72,"Harrajpura, Ajmer"],
"305624":[230,1066,0.68,"Ratakot, Ajmer"],
"305625":[480,2565,0.81,"Hanutia, Ajmer"],
"305627":[345,1450,0.62,"Jotayan, Ajmer"],
"305628":[216,760,0.6,"Surkhand, Ajmer"],
"305629":[230,1702,1.26,"Gudha Khurd, Ajmer"],
"305630":[216,720,0.68,"Begliawas, Ajmer"],
"305631":[450,1466,1.2,"Jeewana, Ajmer"],
"305801":[549,2509,0.5,"Madanganj Kishangarh, Ajmer"],
"305802":[530,3153,0.36,"Udaipur Kalan, Ajmer"],
"305811":[481,774,0.48,"Babaicha, Ajmer"],
"305812":[354,768,0.48,"Chhota Naraina, Ajmer"],
"305813":[402,1490,1.0,"Dang, Ajmer"],
"305814":[776,-1,0.52,"Nawa, Ajmer"],
"305815":[566,765,0.49,"Pinglod, Ajmer"],
"305816":[323,831,0.6,"Patan, Ajmer"],
"305817":[328,761,0.5,"Central University of Rajasthan, Ajmer"],
"305819":[225,840,0.74,"Amarpura, Ajmer"],
"305901":[540,1636,2.12,"Beawar (Raj), Ajmer"],
"305921":[323,1174,0.31,"Dansaria, Rajsamand"],
"305922":[290,1110,1.34,"Bar Kochara, Ajmer"],
"305923":[295,1000,0.67,"Rawatmal, Ajmer"],
"305924":[300,861,0.68,"Malto Ki Ber, Ajmer"],
"305925":[391,1526,2.51,"Kalinjer, Ajmer"],
"305926":[314,892,0.37,"Bamanheda, Ajmer"],
"305927":[450,1655,3.43,"Durgawas, Ajmer"],
"306001":[342,2214,0.23,"Marwar Jn., Pali"],
"306021":[350,2080,0.27,"Deoli Auwa, Pali"],
"306022":[354,921,1.32,"Bhagora, Pali"],
"306023":[367,1223,1.7,"Chokariya, Pali"],
"306101":[849,2280,0.68,"Kurki, Pali"],
"306102":[849,2280,0.68,"Amarpura, Pali"],
"306103":[350,2080,0.27,"Bornadi, Pali"],
"306104":[426,2574,0.19,"Chopra, Pali"],
"306105":[849,2228,0.59,"Bagri Kalaliya, Pali"],
"306114":[347,2136,0.25,"Piplad, Pali"],
"306115":[265,740,0.66,"Lapod, Pali"],
"306116":[314,765,0.27,"Falna Village, Pali"],
"306119":[507,1943,0.26,"Jawali, Pali"],
"306126":[460,1812,0.22,"Bera, Pali"],
"306301":[293,1827,0.19,"Falka Kalan, Pali"],
"306302":[225,2744,0.29,"Deoria, Pali"],
"306303":[225,2747,0.29,"Mohrai, Pali"],
"306304":[849,2280,0.68,"Haripur, Pali"],
"306305":[528,2189,0.49,"Nimbera Kalan, Pali"],
"306306":[500,1865,0.24,"Chanddawal R.S., Pali"],
"306307":[615,2199,0.39,"Bansiya, Pali"],
"306308":[277,2130,0.21,"Digarna, Pali"],
"306401":[520,2389,0.31,"Pali Marwar, Pali"],
"306421":[744,2600,0.46,"Bayad, Pali"],
"306422":[734,2270,0.34,"Dhola, Pali"],
"306501":[482,2354,0.27,"Dhamli, Pali"],
"306502":[250,860,1.23,"Bagol, Pali"],
"306503":[875,2528,0.37,"Banta Town, Pali"],
"306504":[709,1390,0.49,"Bheemana, Pali"],
"306601":[320,1256,0.2,"Dadai, Pali"],
"306602":[482,2031,0.24,"Bhawnagar, Pali"],
"306603":[250,828,1.39,"Dhalop, Pali"],
"306604":[214,922,0.19,"Sanwalta, Pali"],
"306701":[302,645,0.41,"Dantiwara, Pali"],
"306702":[250,828,1.39,"Ranakpur, Pali"],
"306703":[250,826,1.39,"Ana, Pali"],
"306704":[248,717,0.22,"Dudapura, Pali"],
"306705":[245,629,0.28,"Lalrai, Pali"],
"306706":[312,821,0.25,"Barwa, Pali"],
"306707":[302,654,0.39,"Padarla, Pali"],
"306708":[400,1081,0.16,"Koselao, Pali"],
"306709":[248,700,0.2,"Rabriyawas, Pali"],
"306901":[325,1092,0.3,"Khiwandi, Pali"],
"306902":[325,1312,0.21,"Kanpura, Pali"],
"306912":[325,1310,0.21,"Balana, Pali"],
"307001":[337,1126,0.46,"Sirohi, Sirohi"],
"307019":[678,1382,0.37,"Basantgarh, Sirohi"],
"307022":[654,1278,0.51,"Telpur, Sirohi"],
"307023":[645,1362,0.44,"Ishra, Sirohi"],
"307024":[671,1476,0.27,"Valoriya, Sirohi"],
"307025":[351,863,0.19,"Barli, Udaipur"],
"307026":[280,932,0.21,"Chandela, Sirohi"],
"307027":[351,1487,0.24,"Kesharpura, Sirohi"],
"307028":[450,1181,0.25,"Jogapura, Sirohi"],
"307029":[1074,3348,0.26,"Badanwari, Jalore"],
"307030":[740,2990,0.16,"Agawari, Jalore"],
"307031":[649,1359,0.53,"Amli, Sirohi"],
"307032":[441,1033,0.43,"Jayadara, Sirohi"],
"307043":[252,1441,0.33,"Morli, Sirohi"],
"307501":[315,758,1.01,"Shergaon, Sirohi"],
"307510":[350,851,0.63,"Amthala, Sirohi"],
"307511":[380,939,0.54,"Dak, Sirohi"],
"307512":[400,1088,0.34,"Nimbaj, Sirohi"],
"307513":[351,1186,0.22,"Raipur, Sirohi"],
"307514":[389,1068,0.39,"Bhatana, Sirohi"],
"307515":[342,871,0.43,"Rajikawas, Jalore"],
"307801":[252,1291,0.6,"Deldar B.O., Sirohi"],
"307802":[430,1575,0.37,"Jela, Sirohi"],
"307803":[430,2475,0.38,"Punakkalan, Jalore"],
"311001":[348,1044,0.61,"Bhilwara, Bhilwara"],
"311011":[355,1024,0.62,"Lasadiya, Bhilwara"],
"311021":[235,1332,0.68,"Gageda, Bhilwara"],
"311022":[698,1493,1.01,"Agucha, Bhilwara"],
"311023":[595,1421,0.94,"Dhanop, Bhilwara"],
"311024":[280,931,1.34,"Dholi, Bhilwara"],
"311025":[332,930,0.86,"Amli, Bhilwara"],
"311026":[150,564,0.39,"Bheemdiyas, Bhilwara"],
"311030":[478,1240,1.26,"Barantia, Bhilwara"],
"311201":[355,1343,0.43,"Amarwasi, Bhilwara"],
"311202":[270,1033,0.45,"Bavri, Bhilwara"],
"311203":[357,1231,0.45,"Ullela, Bhilwara"],
"311204":[280,1169,1.24,"Barsani, Bhilwara"],
"311301":[288,823,0.21,"Barana, Bhilwara"],
"311302":[347,1234,0.79,"Bhadsi, Bhilwara"],
"311401":[340,746,0.63,"Bara Mahuwa, Bhilwara"],
"311402":[520,784,0.49,"Adsipura, Bhilwara"],
"311403":[344,821,0.3,"Bhadu, Bhilwara"],
"311404":[337,1388,0.41,"Amli Kalan, Bhilwara"],
"311407":[351,1185,0.48,"Kanechan Khurd, Bhilwara"],
"311408":[340,918,1.02,"Munshi, Bhilwara"],
"311601":[270,690,0.84,"Dhakarkhedi, Bhilwara"],
"311602":[260,583,0.33,"Chand Ji Ki Kheri, Bhilwara"],
"311603":[388,1131,1.29,"Akola, Bhilwara"],
"311604":[260,469,0.59,"Genoli, Bhilwara"],
"311605":[271,775,0.39,"Dhamnia, Bhilwara"],
"311606":[278,611,0.45,"Bikaran, Bhilwara"],
"311801":[275,807,0.3,"Bharak, Bhilwara"],
"311802":[365,714,0.32,"Atun, Bhilwara"],
"311803":[285,875,0.21,"Umari, Bhilwara"],
"311804":[340,1038,0.47,"Dhuwala, Bhilwara"],
"311805":[220,693,0.09,"Deoria, Bhilwara"],
"311806":[310,875,0.39,"Kangani, Bhilwara"],
"312001":[250,694,0.09,"Chittorgarh, Chittorgarh"],
"312021":[260,694,0.08,"Barodia, Chittorgarh"],
"312022":[316,622,0.1,"Kherpura, Chittorgarh"],
"312023":[356,628,0.22,"Deopura, Chittorgarh"],
"312024":[530,1072,0.18,"Morwan, Chittorgarh"],
"312025":[250,696,0.1,"Netawal garh pachhali, Chittorgarh"],
"312027":[371,996,0.4,"Akola Kalan, Chittorgarh"],
"312201":[380,871,0.21,"Odund, Chittorgarh"],
"312202":[500,1062,0.69,"Babarana, Chittorgarh"],
"312203":[439,1178,0.68,"Adana, Chittorgarh"],
"312204":[570,1131,0.64,"Bhoopal Nagar, Chittorgarh"],
"312205":[465,1192,0.46,"Chorwadi, Chittorgarh"],
"312206":[345,896,0.52,"Nevaria, Chittorgarh"],
"312207":[260,989,0.23,"Banakiyakalan, Chittorgarh"],
"312401":[215,619,0.46,"Mahuda, Chittorgarh"],
"312402":[312,928,0.31,"Badwai, Chittorgarh"],
"312403":[190,662,0.65,"Manpura Jagir, Chittorgarh"],
"312404":[212,760,0.48,"Karsana, Chittorgarh"],
"312601":[272,492,0.0,"Badolighata, Chittorgarh"],
"312602":[423,915,0.37,"Bhalundi, Chittorgarh"],
"312603":[301,824,0.35,"Bhanuja, Chittorgarh"],
"312604":[350,656,0.48,"Peelikheda, Pratapgarh"],
"312605":[330,684,0.29,"Achalpur, Pratapgarh"],
"312606":[343,713,0.0,"Sarsi, Chittorgarh"],
"312612":[302,752,0.14,"Jalampura, Chittorgarh"],
"312613":[322,791,0.13,"Kannoj, Chittorgarh"],
"312614":[248,557,0.56,"Mandla Charan, Chittorgarh"],
"312615":[180,589,0.29,"Achalawada, Pratapgarh"],
"312616":[330,641,0.26,"Bori, Pratapgarh"],
"312617":[424,1383,0.49,"Kailash Nagar, Chittorgarh"],
"312619":[274,606,0.15,"Banslai, Pratapgarh"],
"312620":[278,590,0.01,"Arnia Joshi, Chittorgarh"],
"312622":[324,764,0.15,"Adityapuram, Chittorgarh"],
"312623":[320,845,0.42,"Sakriya, Pratapgarh"],
"312624":[170,469,0.61,"Banghati, Pratapgarh"],
"312625":[220,508,0.79,"Dantalia, Pratapgarh"],
"312626":[380,630,1.42,"Bharkundi, Pratapgarh"],
"312627":[360,744,0.19,"Sadi, Chittorgarh"],
"312628":[304,492,0.26,"Nakor, Pratapgarh"],
"312629":[260,660,0.38,"SUHAGPURA D, Chittorgarh"],
"312901":[250,718,0.09,"Bolon Ka Sanwata, Chittorgarh"],
"313001":[380,945,0.18,"Dhinkli, Udaipur"],
"313002":[380,1054,0.17,"Udaipur H Magri, Udaipur"],
"313003":[400,985,0.15,"Bhoiyon Ki Pancholi, Udaipur"],
"313004":[380,895,0.18,"Udaipur, Udaipur"],
"313011":[360,677,0.19,"Barda, Udaipur"],
"313022":[420,995,0.31,"Daroli, Udaipur"],
"313024":[360,879,0.14,"Bhalon Ka Guda, Udaipur"],
"313026":[335,778,0.16,"Godasar, Udaipur"],
"313027":[310,693,0.4,"Isarwas Dangiyan, Udaipur"],
"313031":[380,718,0.18,"Alsigarh, Udaipur"],
"313038":[310,807,0.43,"Dholgiri Ka Khera, Udaipur"],
"313201":[288,1203,0.14,"Ghasa, Udaipur"],
"313202":[280,789,2.28,"Bilota, Rajsamand"],
"313203":[609,1391,0.21,"Bhimal, Udaipur"],
"313204":[518,1278,0.19,"Jawad, Udaipur"],
"313205":[467,1215,0.37,"Intali, Udaipur"],
"313206":[454,1182,0.43,"Jewana, Udaipur"],
"313207":[389,1017,0.91,"Pachhamata, Rajsamand"],
"313211":[410,1045,0.43,"Charana, Rajsamand"],
"313301":[418,992,0.77,"Bagol, Rajsamand"],
"313321":[290,668,0.17,"Bhensa Kamed, Rajsamand"],
"313322":[365,832,2.11,"Balicha, Rajsamand"],
"313323":[460,1296,0.43,"Maja, Rajsamand"],
"313324":[505,1587,0.42,"Kankroli, Rajsamand"],
"313325":[290,629,0.16,"Kuncholi, Rajsamand"],
"313327":[190,1331,0.53,"Jhor, Rajsamand"],
"313328":[317,1051,0.92,"Jitawas, Rajsamand"],
"313329":[410,988,1.13,"Banerian, Rajsamand"],
"313330":[770,1747,0.11,"Panotia, Rajsamand"],
"313331":[370,1178,1.71,"Anjana, Rajsamand"],
"313332":[330,1242,0.32,"Khakharmala, Rajsamand"],
"313333":[290,470,0.68,"Rinchhed, Rajsamand"],
"313334":[429,1358,0.3,"Aidana, Rajsamand"],
"313341":[332,848,1.41,"Kachhabali, Rajsamand"],
"313342":[500,1457,0.52,"Bhatoli, Rajsamand"],
"313601":[575,1022,0.43,"Balathal, Udaipur"],
"313602":[340,501,0.46,"Kharsan, Udaipur"],
"313603":[370,975,0.22,"Bansada, Udaipur"],
"313604":[260,816,0.32,"Akola, Udaipur"],
"313701":[280,652,0.98,"Daiya, Udaipur"],
"313702":[275,655,0.08,"Godana, Udaipur"],
"313703":[365,810,0.32,"Bemla, Udaipur"],
"313704":[333,686,0.54,"B K Kalwana, Udaipur"],
"313705":[380,635,0.83,"Bagdunda, Udaipur"],
"313706":[405,937,0.44,"Ballabh, Udaipur"],
"313708":[380,691,0.89,"Jhadoli, Udaipur"],
"313801":[295,567,0.16,"Sarupal, Udaipur"],
"313802":[301,701,0.25,"Bhudar, Udaipur"],
"313803":[360,618,0.18,"Bayri, Udaipur"],
"313804":[295,646,0.15,"Balicha, Udaipur"],
"313805":[329,871,0.37,"Kunda, Udaipur"],
"313806":[331,887,0.35,"Kalyanpur, Udaipur"],
"313901":[333,678,0.2,"Deopura, Udaipur"],
"313902":[283,613,0.16,"Kejad, Udaipur"],
"313903":[318,829,0.16,"Medi Dhani, Udaipur"],
"313904":[283,654,0.21,"Nathara, Udaipur"],
"313905":[300,597,0.11,"Dhingri, Udaipur"],
"313906":[356,667,0.05,"Gejvi, Udaipur"],
"314001":[270,734,0.61,"Dungarpur, Dungarpur"],
"314011":[238,652,0.37,"Gamdi Deval, Dungarpur"],
"314021":[310,530,0.53,"Parda Itiwar, Dungarpur"],
"314022":[306,578,1.22,"Biloora, Dungarpur"],
"314023":[332,580,0.92,"Bhasore, Dungarpur"],
"314024":[300,635,0.88,"Oad, Dungarpur"],
"314025":[300,721,0.65,"Ara, Dungarpur"],
"314026":[268,564,1.0,"Silohi, Dungarpur"],
"314027":[250,663,0.5,"Ambada, Dungarpur"],
"314028":[298,639,0.2,"Mandav, Dungarpur"],
"314029":[288,696,0.24,"Beejawara, Dungarpur"],
"314030":[230,528,0.2,"Bawadi, Dungarpur"],
"314031":[280,753,0.84,"Bageri, Dungarpur"],
"314032":[320,658,1.31,"Padardi Badi, Dungarpur"],
"314034":[345,627,0.12,"Bhojato Ka Oda, Dungarpur"],
"314035":[268,517,0.91,"Bhamai, Dungarpur"],
"314036":[348,630,1.5,"Dowda, Dungarpur"],
"314037":[273,523,0.98,"Balota, Dungarpur"],
"314038":[320,502,1.77,"Bhiyodi, Dungarpur"],
"314401":[290,646,0.51,"Parda Mehton ka, Dungarpur"],
"314402":[275,584,0.81,"Bansia, Dungarpur"],
"314403":[270,564,0.75,"Badi Likhi, Dungarpur"],
"314404":[256,560,0.59,"Ghata, Dungarpur"],
"314406":[293,617,1.1,"Bankra, Dungarpur"],
"314801":[235,591,0.19,"Chundawada, Dungarpur"],
"314804":[270,655,0.56,"Sabli, Dungarpur"],
"321001":[675,1024,0.27,"Bharatpur, Bharatpur"],
"321021":[735,1914,0.57,"Phulwara, Bharatpur"],
"321022":[530,2062,0.1,"Anand Dadri, Bharatpur"],
"321023":[647,1966,0.09,"Badipur, Bharatpur"],
"321024":[680,3515,0.06,"Berru, Bharatpur"],
"321025":[1110,2342,0.53,"Santruk, Bharatpur"],
"321026":[960,2113,0.54,"Dehra, Bharatpur"],
"321028":[440,2715,0.38,"Barkheda, Bharatpur"],
"321201":[856,2464,0.5,"Dhanwara, Bharatpur"],
"321202":[1110,1984,0.58,"Tamrer, Bharatpur"],
"321203":[528,922,0.48,"Deeg, Bharatpur"],
"321204":[715,4360,0.08,"Bodoli Dahar, Bharatpur"],
"321205":[620,3191,0.12,"Dundawal, Bharatpur"],
"321206":[445,1051,0.41,"Jatoli Thoon, Bharatpur"],
"321301":[420,1325,0.71,"Bareh Mafi, Bharatpur"],
"321302":[700,2323,1.25,"Nekpur, Bharatpur"],
"321303":[700,3192,1.01,"Uncha Gaom, Bharatpur"],
"321401":[265,605,0.25,"Bidiyari, Bharatpur"],
"321402":[340,876,0.56,"Baroda, Bharatpur"],
"321403":[360,1338,0.46,"Dana Khedli, Bharatpur"],
"321404":[400,1769,0.55,"Chenkora, Bharatpur"],
"321405":[260,781,0.46,"Garhi Bajna, Bharatpur"],
"321406":[335,1618,0.16,"Nayagaom Khalsa, Bharatpur"],
"321407":[320,1795,0.12,"Mudia Sadh, Bharatpur"],
"321408":[325,1397,0.03,"Hishamada, Bharatpur"],
"321409":[330,1415,0.18,"Ghatri, Bharatpur"],
"321410":[260,536,0.29,"Sadpura, Bharatpur"],
"321411":[319,1013,0.22,"Gajipur, Bharatpur"],
"321601":[370,3001,0.03,"Kherli Gujar, Bharatpur"],
"321602":[825,3530,0.02,"Gangrauli, Bharatpur"],
"321605":[320,3228,1.14,"Isrota, Alwar"],
"321606":[245,2303,1.15,"Daroda, Alwar"],
"321607":[370,2938,0.68,"Hasanpur, Alwar"],
"321608":[340,1620,0.65,"Pali, Dausa"],
"321609":[310,1464,1.16,"Garh Himmat Singh, Dausa"],
"321610":[339,1375,0.18,"Bhajeda, Karauli"],
"321611":[340,1439,0.19,"Bonl, Karauli"],
"321612":[450,1422,0.27,"Gazipura, Dausa"],
"321613":[290,1255,0.58,"Pakhar, Dausa"],
"321614":[580,2781,0.05,"Nayabas, Bharatpur"],
"321615":[245,1997,0.11,"Naroli, Bharatpur"],
"321633":[400,1855,0.24,"Devli, Alwar"],
"321642":[410,3229,0.03,"Bhutoli, Bharatpur"],
"322001":[408,845,0.44,"Sawaimadhopur, Sawai Madhopur"],
"322021":[345,854,0.44,"Alanpur, Sawai Madhopur"],
"322023":[239,1492,0.86,"Bans Torda, Sawai Madhopur"],
"322024":[220,1574,0.9,"Gambhira, Sawai Madhopur"],
"322025":[492,835,0.14,"Barnawada, Sawai Madhopur"],
"322026":[290,796,0.6,"Lahsoda, Sawai Madhopur"],
"322027":[475,1117,0.51,"Karmoda, Sawai Madhopur"],
"322028":[220,1452,0.9,"Behted, Sawai Madhopur"],
"322029":[475,949,0.19,"Chharoda, Sawai Madhopur"],
"322030":[215,1283,0.98,"Galad Kalan, Sawai Madhopur"],
"322033":[336,982,0.43,"Hadoti, Karauli"],
"322034":[366,1236,0.69,"Makholi, Sawai Madhopur"],
"322201":[538,1371,0.11,"Gangapur, Sawai Madhopur"],
"322202":[245,934,0.2,"Chuli, Sawai Madhopur"],
"322203":[240,597,0.36,"Chauragon, Karauli"],
"322204":[490,2532,0.2,"Kunjela, Karauli"],
"322205":[395,1772,0.35,"Khandeep, Sawai Madhopur"],
"322211":[522,2796,0.2,"Kakrala, Sawai Madhopur"],
"322212":[300,1574,0.35,"Amavragarh, Sawai Madhopur"],
"322213":[270,998,1.14,"Kamalpura, Karauli"],
"322214":[300,1785,0.13,"Dabar, Sawai Madhopur"],
"322215":[570,2480,0.22,"Kema, Karauli"],
"322216":[508,1846,0.42,"Badagaon, Karauli"],
"322218":[290,572,0.17,"Bajna, Karauli"],
"322219":[200,852,0.2,"Baroli, Sawai Madhopur"],
"322220":[395,1396,0.59,"Maheswa, Karauli"],
"322230":[395,1744,0.31,"Hindaun, Karauli"],
"322234":[260,976,0.26,"Gavda Meena, Karauli"],
"322236":[400,1683,0.34,"Jagar, Karauli"],
"322238":[360,1551,0.38,"Kudhawal, Karauli"],
"322240":[380,1228,0.27,"Bada Bujurg, Dausa"],
"322241":[260,603,0.39,"Ata, Karauli"],
"322242":[328,1116,0.53,"Chhabar, Karauli"],
"322243":[280,558,0.13,"Karsai, Karauli"],
"322249":[270,547,0.54,"Khoobnagar, Karauli"],
"322251":[309,543,0.9,"Ninder, Karauli"],
"322252":[357,1511,0.22,"Dhanda, Karauli"],
"322254":[450,1691,0.19,"Jagdishpura, Karauli"],
"322255":[280,746,0.19,"Bariya, Karauli"],
"322701":[375,1175,0.54,"Jhopra, Sawai Madhopur"],
"322702":[320,1010,0.16,"Bagina, Sawai Madhopur"],
"322703":[257,1231,0.52,"Ancher, Sawai Madhopur"],
"322704":[316,1299,0.76,"Mahapura, Sawai Madhopur"],
"323001":[301,753,0.35,"Bundi, Bundi"],
"323021":[330,762,0.07,"Alphanagar, Bundi"],
"323022":[300,599,0.11,"Dabi, Bundi"],
"323023":[354,936,0.28,"Chatarganj, Bundi"],
"323024":[319,557,0.24,"Abar, Bundi"],
"323025":[267,1408,0.25,"Vijaygarh, Bundi"],
"323026":[454,1486,0.14,"Bhawanipura, Bundi"],
"323301":[255,1759,0.44,"Arnetha, Bundi"],
"323303":[550,1243,0.58,"Anushakti, Chittorgarh"],
"323304":[368,783,0.0,"Sripura, Chittorgarh"],
"323305":[250,694,0.09,"Rawatbhatta Bazar, Chittorgarh"],
"323307":[220,452,0.13,"Barodia, Chittorgarh"],
"323601":[302,1981,0.23,"Kesoraipatan, Bundi"],
"323602":[255,1311,1.04,"Karwala, Bundi"],
"323603":[545,1241,0.31,"Utharana, Bundi"],
"323613":[220,845,0.46,"Mohanpura, Bundi"],
"323614":[290,1175,0.05,"Balban, Bundi"],
"323615":[255,1843,0.05,"Lakheri Gaon, Bundi"],
"323616":[390,996,0.25,"Kaithuda, Bundi"],
"323801":[566,1631,0.35,"Phuleta, Bundi"],
"323802":[348,929,0.14,"Morsan, Bundi"],
"323803":[330,958,0.31,"Ajeta, Bundi"],
"324001":[310,935,0.29,"Kota, Kota"],
"324002":[310,1030,0.22,"Sogaria, Kota"],
"324003":[310,671,0.37,"Industerial Estate Kota, Kota"],
"324004":[310,696,0.29,"Udyog Puri Kota, Kota"],
"324005":[270,631,0.4,"I.P.I.A. KOTA S.O., Kota"],
"324006":[320,609,0.46,"Subzi Mandi Kota, Kota"],
"324007":[320,610,0.43,"New Grain Mandi Kota, Kota"],
"324008":[330,779,0.33,"Nanta, Kota"],
"324009":[245,573,0.14,"Dadabari Kota, Kota"],
"324010":[275,525,0.2,"Jaspura, Kota"],
"325001":[292,715,0.22,"Dhoti, Kota"],
"325003":[230,547,0.22,"Bhanwaria, Kota"],
"325004":[390,1171,0.78,"Binayaka, Kota"],
"325009":[438,1069,1.03,"Jorawarpura, Kota"],
"325201":[380,1632,0.04,"Dungarja, Kota"],
"325202":[340,771,0.04,"Palaitha, Baran"],
"325203":[340,846,0.05,"Choma Malian, Kota"],
"325204":[295,1161,0.24,"Budha Deet, Kota"],
"325205":[360,2073,0.13,"Barana, Baran"],
"325206":[450,1219,0.39,"Badgaon, Baran"],
"325207":[408,1244,0.92,"Bamla, Baran"],
"325208":[340,740,0.05,"Sarola, Kota"],
"325209":[459,1210,0.15,"Badwa, Baran"],
"325214":[390,1118,0.92,"Ayani, Kota"],
"325215":[454,1047,0.54,"Bamori Kalan, Baran"],
"325216":[315,578,0.15,"Chhinod, Baran"],
"325217":[271,445,1.26,"Bamangaon, Baran"],
"325218":[397,1036,0.35,"Chardana, Baran"],
"325219":[408,836,0.33,"Mawasa, Baran"],
"325220":[422,746,0.13,"Bapcha, Baran"],
"325221":[398,703,0.35,"Ajnawar, Baran"],
"325222":[390,1023,0.5,"Koyala, Baran"],
"325223":[376,873,1.07,"Bhensara, Baran"],
"325224":[313,519,0.18,"Chhaatarganj, Baran"],
"325601":[345,749,0.09,"Hingi, Kota"],
"325602":[238,544,0.28,"Dhulet, Kota"],
"326001":[290,1050,0.27,"Jhalawar, Jhalawar"],
"326021":[275,799,0.25,"Dungargaon, Jhalawar"],
"326022":[485,825,0.18,"Agaria, Jhalawar"],
"326023":[300,694,0.33,"Bhanwarsa, Jhalawar"],
"326033":[390,736,0.46,"Gehu Khedi, Jhalawar"],
"326034":[486,899,0.07,"Odiya Khedi, Jhalawar"],
"326035":[363,815,0.55,"Bareda, Jhalawar"],
"326036":[434,813,0.32,"Banore, Jhalawar"],
"326037":[330,544,0.1,"Chandpura Bheelan, Jhalawar"],
"326038":[328,811,2.7,"Akodiya, Jhalawar"],
"326039":[320,528,0.24,"Asalpur, Jhalawar"],
"326501":[280,724,0.47,"Khod, Jhalawar"],
"326502":[292,764,0.17,"Sulia, Jhalawar"],
"326512":[451,966,0.07,"Maralwada, Jhalawar"],
"326513":[432,880,0.15,"Sirpoi, Jhalawar"],
"326514":[310,735,0.1,"Harnawda, Jhalawar"],
"326515":[347,723,0.07,"Bardia Veer Ji, Jhalawar"],
"326516":[310,698,0.12,"Rojhana, Jhalawar"],
"326517":[273,850,0.36,"Kheemuch, Kota"],
"326518":[242,559,0.25,"Deoli, Kota"],
"326519":[262,663,0.33,"Julmi, Kota"],
"326520":[252,529,0.16,"Barodia Kalan, Kota"],
"326529":[246,568,0.12,"Richhadia, Kota"],
"326530":[273,813,0.34,"Salawad Khurd, Kota"],
"327001":[258,610,0.49,"Banswara, Banswara"],
"327021":[343,728,0.33,"Bhimpur, Banswara"],
"327022":[290,749,1.64,"Berwa, Banswara"],
"327023":[290,633,0.25,"Devda, Banswara"],
"327024":[285,628,0.7,"Partapur, Banswara"],
"327025":[265,515,5.4,"Bachadiya, Banswara"],
"327026":[295,526,0.93,"Badgun, Banswara"],
"327027":[352,521,0.33,"Dungar, Banswara"],
"327031":[248,563,1.33,"Badliya, Banswara"],
"327032":[270,586,1.1,"Bassi Badi, Banswara"],
"327034":[275,664,1.27,"Amja, Banswara"],
"327601":[292,540,0.21,"Chordi, Banswara"],
"327602":[318,556,0.4,"Kesharwadi, Banswara"],
"327603":[300,568,0.41,"Naugama, Banswara"],
"327604":[310,608,0.48,"Bodigama, Banswara"],
"327605":[320,753,1.13,"Akhebhanji Ka Gara, Banswara"],
"327606":[317,557,0.49,"Peeplod, Banswara"],
"327801":[200,334,0.21,"Badi Sarwa, Banswara"],
"328001":[309,964,0.04,"Dholpur, Dholpur"],
"328021":[327,753,1.27,"Dhanora, Dholpur"],
"328022":[348,1505,0.7,"Bharli, Dholpur"],
"328023":[356,1943,1.56,"Maloni Panwar, Dholpur"],
"328024":[306,1515,0.9,"Bintipura, Dholpur"],
"328025":[420,1786,1.12,"Hathbai, Dholpur"],
"328026":[341,1080,0.57,"Madanpur, Dholpur"],
"328027":[422,1412,0.93,"Kanasil, Dholpur"],
"328028":[310,832,1.21,"Basainadang, Dholpur"],
"328029":[280,2619,1.62,"Lalpur Rehsena, Dholpur"],
"328030":[335,1006,0.06,"Basai Samanta, Dholpur"],
"328031":[339,665,0.36,"Angai, Dholpur"],
"328041":[344,985,0.68,"Gadhi Sukkha, Dholpur"],
"331001":[382,1940,0.24,"Churu, Churu"],
"331021":[645,3036,0.34,"Dhani D.S.Pura, Churu"],
"331022":[348,2130,0.18,"Ratangarh, Churu"],
"331023":[200,1732,0.05,"Chubakia Tal, Churu"],
"331024":[482,2513,0.83,"Neemakidhani, Sikar"],
"331025":[265,1078,2.95,"Bas Ghasiram, Jhunjhunu"],
"331026":[269,1077,1.45,"Jabasar, Jhunjhunu"],
"331027":[260,1876,3.92,"Gangiasar, Jhunjhunu"],
"331028":[284,1342,1.51,"Niradhana, Jhunjhunu"],
"331029":[175,590,0.07,"Hadyal Village, Churu"],
"331031":[245,1181,0.15,"Molisar, Churu"],
"331301":[515,3086,0.45,"Bewar, Churu"],
"331302":[629,3203,0.39,"Raiyatunda, Churu"],
"331303":[337,2053,0.8,"Lilawati, Churu"],
"331304":[347,1660,0.02,"Allayala, Churu"],
"331305":[345,2568,0.41,"Bhamreed, Churu"],
"331402":[337,2019,0.12,"Jaisinghsar, Churu"],
"331403":[135,1415,0.08,"Adsisar, Churu"],
"331411":[310,1161,0.08,"Jaitsisar, Churu"],
"331501":[429,1447,0.12,"Dariba, Churu"],
"331502":[513,2156,0.12,"Dewani, Churu"],
"331503":[525,2102,0.11,"Balera, Churu"],
"331504":[645,2951,0.38,"Ajeetsar, Churu"],
"331505":[645,2997,0.38,"Absar, Churu"],
"331506":[314,1634,0.11,"Charia, Churu"],
"331507":[658,2227,0.14,"Jindrasar, Churu"],
"331517":[538,1701,0.2,"Amarsar, Churu"],
"331518":[645,2997,0.38,"Badsar, Churu"],
"331701":[241,1105,0.01,"Bhimsana, Churu"],
"331801":[153,693,0.54,"Surjansar, Bikaner"],
"331802":[342,2065,0.12,"Binadesar, Churu"],
"331803":[289,928,0.7,"Bana, Bikaner"],
"331811":[451,1215,0.43,"Jodhasar, Bikaner"],
"332001":[200,733,0.24,"Sikar, Sikar"],
"332002":[160,977,0.07,"Nagwa, Sikar"],
"332003":[220,723,0.34,"NDC Sikar, Sikar"],
"332021":[240,753,0.44,"Nani, Sikar"],
"332023":[160,1110,0.04,"Mundawara, Sikar"],
"332024":[190,694,0.25,"Tarpura, Sikar"],
"332025":[195,1285,0.05,"Bhirana, Sikar"],
"332026":[195,1478,0.13,"Tunwa, Sikar"],
"332027":[240,495,0.33,"Purohitkabas, Sikar"],
"332028":[180,1434,0.08,"Bhilunda, Sikar"],
"332029":[210,1499,0.14,"Sutod, Sikar"],
"332030":[173,1192,0.08,"Mordunga, Sikar"],
"332031":[150,741,0.16,"Dharamshala, Sikar"],
"332041":[180,811,0.18,"Pardoli Badi, Sikar"],
"332042":[145,929,0.08,"Bhuwala, Sikar"],
"332301":[282,1573,0.07,"Birania, Sikar"],
"332302":[520,2540,0.15,"Ramshisar, Sikar"],
"332303":[254,1294,0.14,"Almas, Sikar"],
"332304":[355,2429,0.15,"Hudera, Sikar"],
"332305":[263,1541,0.15,"Balod Bhakaran, Sikar"],
"332307":[255,1894,2.79,"Thimoli, Sikar"],
"332311":[200,1292,0.22,"Bairas, Sikar"],
"332312":[200,1312,0.28,"Bhojasar, Sikar"],
"332315":[125,761,0.36,"Jasrasar, Sikar"],
"332316":[150,963,0.09,"Panlawa, Sikar"],
"332317":[200,1402,0.19,"Badusar, Sikar"],
"332318":[235,1461,0.1,"Juliasar, Sikar"],
"332401":[120,1140,0.05,"Disnau, Sikar"],
"332402":[255,881,0.25,"Abhaipura, Sikar"],
"332403":[220,537,0.62,"Goriyan, Sikar"],
"332404":[258,1155,0.33,"Kotri Dhayalan, Sikar"],
"332405":[220,795,0.4,"Sangarwa, Sikar"],
"332406":[182,779,0.27,"Dudhwa, Sikar"],
"332411":[260,1297,0.27,"Malikpur, Sikar"],
"332601":[255,1100,0.28,"Jalund, Sikar"],
"332602":[255,991,0.25,"Lamiya, Sikar"],
"332603":[385,2171,0.41,"Arnia, Sikar"],
"332701":[420,1078,0.15,"Ajmeri, Sikar"],
"332702":[263,1140,0.2,"Motlawas, Sikar"],
"332703":[304,1287,0.39,"Dholasari, Sikar"],
"332705":[529,2082,0.24,"Dariba, Sikar"],
"332706":[630,2343,0.22,"Narsinghpuri, Sikar"],
"332707":[321,1007,0.12,"Sanwalpura Shekhawatan, Sikar"],
"332708":[470,2017,0.31,"Kanwat RS, Sikar"],
"332709":[443,1754,0.22,"Dhani Guman Singh, Sikar"],
"332710":[333,1472,0.48,"Koolie, Sikar"],
"332711":[796,2507,0.44,"Jillo, Sikar"],
"332712":[385,1132,0.18,"Footala, Sikar"],
"332713":[709,2490,0.35,"Napawali, Sikar"],
"332714":[746,3211,0.34,"Govindpura, Sikar"],
"332715":[378,1435,0.28,"Srimadhopur, Sikar"],
"332716":[547,1724,0.33,"Dalelpura, Jhunjhunu"],
"332718":[852,2281,0.27,"Ballupura, Sikar"],
"332719":[315,1099,0.18,"Kalyanpura, Sikar"],
"332721":[341,1146,0.33,"Fatehpura, Sikar"],
"332722":[374,1514,0.25,"Shola, Sikar"],
"332742":[475,2307,0.73,"Kankra, Sikar"],
"332746":[574,1995,0.23,"Gorir, Jhunjhunu"],
"333001":[220,949,0.22,"Jhunjhunu, Jhunjhunu"],
"333010":[265,1691,1.99,"Shekhasar, Jhunjhunu"],
"333011":[250,1451,2.4,"Hansasari, Jhunjhunu"],
"333012":[240,1099,0.04,"Hukampura, Jhunjhunu"],
"333020":[328,1099,0.19,"Nangli Saledi Singh, Jhunjhunu"],
"333021":[200,1212,0.04,"Bajawa, Jhunjhunu"],
"333022":[257,922,0.04,"Bar Ki Dhani, Jhunjhunu"],
"333023":[220,1033,0.12,"Bakhatawarpura, Jhunjhunu"],
"333024":[200,843,0.12,"Bharunda Kalan, Jhunjhunu"],
"333025":[243,1137,0.04,"Jakhora, Jhunjhunu"],
"333026":[240,1006,1.45,"Chirawa, Jhunjhunu"],
"333027":[240,988,1.14,"Heerawaa, Jhunjhunu"],
"333028":[200,1061,0.1,"Kishorpura, Jhunjhunu"],
"333029":[265,1176,1.05,"Pilod, Jhunjhunu"],
"333030":[305,1130,1.05,"Jeeni, Jhunjhunu"],
"333031":[320,1140,0.65,"Chhapara, Jhunjhunu"],
"333032":[233,919,0.11,"Signore, Jhunjhunu"],
"333033":[413,1652,0.12,"Dhulwa, Jhunjhunu"],
"333034":[448,1860,0.0,"Bhuriwas, Jhunjhunu"],
"333035":[235,895,3.17,"Deoroad, Jhunjhunu"],
"333036":[758,2283,0.36,"Mehara Jatuwas, Jhunjhunu"],
"333041":[250,1309,0.29,"Bharu, Jhunjhunu"],
"333042":[190,880,0.05,"Barwasi, Jhunjhunu"],
"333053":[349,899,0.14,"Khoh, Jhunjhunu"],
"333055":[397,961,0.18,"Gadala Kalkan, Jhunjhunu"],
"333302":[455,1325,0.12,"Jahaz, Jhunjhunu"],
"333303":[281,851,0.32,"Lohargal, Jhunjhunu"],
"333304":[150,688,0.03,"Birol, Jhunjhunu"],
"333305":[240,919,0.03,"Chhau, Jhunjhunu"],
"333307":[304,927,0.12,"Inderpura, Jhunjhunu"],
"333308":[150,684,0.03,"Dhamora, Jhunjhunu"],
"333501":[672,1779,0.47,"Gadrata, Jhunjhunu"],
"333502":[512,1969,0.09,"Kalakhari, Jhunjhunu"],
"333503":[631,1240,0.55,"Tyonda, Jhunjhunu"],
"333504":[575,1808,0.29,"Manota Kalan, Jhunjhunu"],
"333514":[365,1153,0.23,"Teelawali, Jhunjhunu"],
"333515":[700,3008,0.0,"Nihaloth, Jhunjhunu"],
"333516":[564,1905,0.22,"Moi Purani, Jhunjhunu"],
"333517":[290,1266,0.03,"Kidwana, Jhunjhunu"],
"333701":[250,1392,0.18,"Phooskhani, Jhunjhunu"],
"333702":[230,1195,0.13,"Dundlod, Jhunjhunu"],
"333704":[255,1494,1.0,"Sigra, Jhunjhunu"],
"333705":[240,1253,0.17,"Balaria, Jhunjhunu"],
"333707":[250,1173,0.2,"Delsar Kaklan, Jhunjhunu"],
"333801":[614,2017,0.32,"Bagoli, Jhunjhunu"],
"334001":[922,2151,0.7,"Bikaner, Bikaner"],
"334002":[822,1972,0.45,"NDC BIKANER, Raipur"],
"334003":[822,1972,0.45,"Pawanpuri S.O (Bikaner), Bikaner"],
"334004":[921,2153,0.7,"Bangalanagar, Bikaner"],
"334006":[863,2701,0.7,"Bichhwal Ind.Area, Bikaner"],
"334021":[463,1369,3.11,"Sadolai, Bikaner"],
"334022":[820,1601,0.47,"Bambloo, Bikaner"],
"334023":[140,1925,0.6,"Chak 8 Kyd, Bikaner"],
"334024":[459,2598,-1,"Prithviraj Ka Bera, Bikaner"],
"334025":[280,869,0.66,"Utmamdesar, Bikaner"],
"334201":[249,576,0.16,"Gusainsar, Bikaner"],
"334202":[188,645,0.16,"Badhnu, Bikaner"],
"334302":[280,1352,0.26,"Bithnok, Bikaner"],
"334303":[488,1827,0.37,"Nokhara, Bikaner"],
"334305":[285,1567,0.65,"Bhaluri, Bikaner"],
"334401":[801,2045,-1,"Gangashahar, Bikaner"],
"334402":[500,1089,0.16,"Ambasar, Bikaner"],
"334403":[777,2023,-1,"Bhinasar, Bikaner"],
"334601":[180,773,0.14,"Sodhwali, Bikaner"],
"334602":[425,2833,0.12,"Kujti, Bikaner"],
"334603":[807,2160,0.31,"Hansera, Bikaner"],
"334604":[140,1089,0.92,"Jaitpur, Bikaner"],
"334801":[624,1576,0.15,"Bhamatsar, Bikaner"],
"334802":[124,374,1.03,"Kakra, Bikaner"],
"334803":[920,2558,0.15,"Beekasar, Bikaner"],
"334804":[300,1892,0.16,"Dhingsari, Bikaner"],
"334808":[129,605,0.41,"Pahalwan Ka Bera, Bikaner"],
"335001":[409,854,0.63,"Sriganganagar, Ganganagar"],
"335002":[180,1428,0.54,"Dharmsinghwala, Ganganagar"],
"335021":[159,869,0.22,"39 Ps, Ganganagar"],
"335022":[230,791,0.31,"Chak 3h Choti, Ganganagar"],
"335024":[220,367,0.12,"15 Ff, Ganganagar"],
"335025":[180,619,0.2,"10 Tkw, Ganganagar"],
"335027":[221,304,0.29,"Dhanoor, Ganganagar"],
"335037":[320,1366,0.24,"Sardarpura Jiwan, Ganganagar"],
"335038":[170,227,0.35,"Matili Rathan, Ganganagar"],
"335039":[215,791,0.51,"16ps, Ganganagar"],
"335040":[240,369,0.24,"Dharinganwali, Ganganagar"],
"335041":[160,287,0.1,"5nn, Ganganagar"],
"335042":[160,301,0.09,"BINJHBAILA S.O., Ganganagar"],
"335051":[363,875,0.65,"Bagicha, Ganganagar"],
"335061":[225,1488,0.79,"1 Ps, Ganganagar"],
"335062":[443,1286,0.45,"Alipura, Ganganagar"],
"335063":[180,604,0.05,"Amarpura Jalukhat, Hanumangarh"],
"335064":[295,1403,0.26,"Kheruwala, Hanumangarh"],
"335065":[225,823,0.69,"Daulatpura, Hanumangarh"],
"335073":[325,481,0.24,"Baringa, Ganganagar"],
"335501":[235,1005,0.27,"Ajitpura, Hanumangarh"],
"335502":[376,1460,0.29,"Dungarana, Hanumangarh"],
"335503":[440,678,0.0,"Jogiwala, Hanumangarh"],
"335504":[291,721,0.33,"Dhilki, Hanumangarh"],
"335511":[440,1969,0.15,"Garhichhani, Hanumangarh"],
"335512":[228,1427,0.25,"Hanumangarh Jn., Hanumangarh"],
"335513":[228,916,0.52,"Jhamber, Hanumangarh"],
"335521":[730,1525,0.12,"Baramsar, Hanumangarh"],
"335522":[442,1206,0.11,"Jhedasar, Hanumangarh"],
"335523":[190,478,0.1,"Dhansia, Hanumangarh"],
"335524":[155,540,0.26,"Chahuwali, Hanumangarh"],
"335525":[214,766,0.61,"Silwala Kalan, Hanumangarh"],
"335526":[240,1272,1.39,"Masani, Hanumangarh"],
"335701":[476,1516,0.06,"90 Gb, Ganganagar"],
"335702":[270,694,0.48,"Sarupsar, Ganganagar"],
"335703":[391,1365,0.02,"15blda, Ganganagar"],
"335704":[230,567,0.17,"25 Gb, Ganganagar"],
"335707":[444,978,0.62,"2 Rkma, Ganganagar"],
"335708":[301,1181,0.26,"Khobar, Ganganagar"],
"335711":[444,978,0.62,"7 Gd, Ganganagar"],
"335801":[230,721,1.74,"Kamana, Hanumangarh"],
"335802":[170,516,0.12,"Amarsinghwala, Hanumangarh"],
"335803":[540,1821,2.22,"Ahmedpura, Hanumangarh"],
"335804":[225,631,0.2,"Badopal, Ganganagar"],
"335805":[253,859,0.22,"1O Spd, Ganganagar"],
"335901":[474,1476,0.08,"Dullapur Kerri, Ganganagar"],
"341001":[240,2455,0.28,"Nagaur, Nagaur"],
"341002":[274,2141,0.19,"Bhadana, Nagaur"],
"341003":[249,1565,0.38,"Alai, Nagaur"],
"341020":[489,2238,0.62,"Bhundel, Nagaur"],
"341021":[322,2514,0.54,"Raidhanu, Nagaur"],
"341022":[350,2694,0.2,"Jhareli, Nagaur"],
"341023":[510,2816,0.21,"Khinyala, Nagaur"],
"341024":[336,2825,0.41,"Arwar, Nagaur"],
"341025":[328,3041,0.4,"Daru, Nagaur"],
"341026":[328,3041,0.4,"Inana, Nagaur"],
"341027":[347,2822,0.28,"Didiyakallan, Nagaur"],
"341028":[528,2319,-1,"Bhatnokha, Nagaur"],
"341029":[140,289,1.03,"Pipasar, Nagaur"],
"341030":[405,2084,0.26,"Ubasi, Nagaur"],
"341031":[325,2140,0.13,"Bherunda, Nagaur"],
"341301":[493,1528,0.16,"Chuwa, Nagaur"],
"341302":[200,2861,0.2,"Badabara, Nagaur"],
"341303":[400,2586,0.31,"Didwana, Nagaur"],
"341304":[710,2406,0.16,"Dabari, Nagaur"],
"341305":[540,3209,0.48,"Agoonta, Nagaur"],
"341306":[560,3282,0.17,"Dujar, Nagaur"],
"341307":[400,2617,0.31,"Sardi, Nagaur"],
"341309":[400,2617,0.31,"Barangana, Nagaur"],
"341316":[525,2251,0.3,"Baldu, Nagaur"],
"341317":[589,2796,0.34,"Genana, Nagaur"],
"341318":[680,4120,0.34,"Kuroli, Nagaur"],
"341319":[1000,4793,0.13,"Chindaliya, Nagaur"],
"341501":[754,3766,0.17,"Nimbri, Nagaur"],
"341502":[951,2504,0.3,"Bidiad, Nagaur"],
"341503":[774,5710,0.13,"Degana Village, Nagaur"],
"341504":[806,3620,0.13,"Barnel, Nagaur"],
"341505":[990,2236,0.3,"Barwala, Nagaur"],
"341506":[582,2567,0.31,"Akoda, Nagaur"],
"341507":[756,3081,0.3,"Deolikallan, Nagaur"],
"341508":[628,2576,0.3,"Anandpura, Nagaur"],
"341509":[579,2666,0.16,"Chosala, Nagaur"],
"341510":[337,2000,0.21,"Akeli a, Nagaur"],
"341511":[279,1926,0.25,"Chhapri, Nagaur"],
"341512":[540,2117,0.31,"Neniya, Nagaur"],
"341513":[132,1619,0.2,"Rohisa, Nagaur"],
"341514":[552,2815,0.35,"Punas, Nagaur"],
"341515":[540,2806,0.19,"Bajwas, Nagaur"],
"341516":[230,1395,0.07,"Bhadasar, Nagaur"],
"341517":[380,1847,0.44,"Rasidpura, Nagaur"],
"341518":[196,1227,0.18,"Bhanwal, Nagaur"],
"341519":[527,2427,0.14,"Jijoth, Nagaur"],
"341520":[992,3309,0.23,"Gedakallan, Nagaur"],
"341521":[689,3861,0.15,"Palrikallan, Nagaur"],
"341533":[768,3094,0.3,"Lichana, Nagaur"],
"341551":[360,1678,0.21,"Kyamsar, Nagaur"],
"342001":[280,1261,0.3,"Jodhpur, Jodhpur"],
"342002":[280,1147,0.28,"NDC Jodhpur, Jodhpur"],
"342003":[280,1239,0.27,"Jodhpur Chopasni Road, Jodhpur"],
"342005":[440,1519,0.29,"Jodhpur Marudhar Ind Area, Jodhpur"],
"342006":[360,1462,0.3,"Jodhpur Kachery, Jodhpur"],
"342007":[360,1409,0.3,"Jodhpur KUM Mandore Road, Jodhpur"],
"342008":[280,1407,0.31,"Nandanwan, Jodhpur"],
"342011":[280,1174,0.29,"Jodhpur Aerodrame, Jodhpur"],
"342012":[235,2566,0.29,"Boranada, Jodhpur"],
"342013":[280,1999,0.3,"Salawas, Jodhpur"],
"342014":[360,1616,0.31,"Badliya, Jodhpur"],
"342015":[440,1645,0.23,"Nandri, Jodhpur"],
"342016":[390,1777,0.29,"Rajasthan High Court NB, Jodhpur"],
"342017":[280,1556,0.32,"Rohila Khurd, Jodhpur"],
"342021":[613,2754,0.02,"Jethania, Jodhpur"],
"342022":[270,2521,0.05,"Chaba, Jodhpur"],
"342023":[440,1495,0.22,"Bastawa, Jodhpur"],
"342024":[440,1397,0.28,"Beru, Jodhpur"],
"342025":[613,2755,0.02,"Bhaloo Kallan, Jodhpur"],
"342026":[280,1345,0.29,"Jodhpur BSF Trg Centre, Jodhpur"],
"342027":[452,1867,0.23,"Banwarla, Jodhpur"],
"342028":[280,2255,0.02,"Khirja Khas, Jodhpur"],
"342029":[418,1868,0.14,"Nandia Kallan, Jodhpur"],
"342030":[459,1798,0.22,"IIT JODHPUR, Jodhpur"],
"342032":[371,1547,1.22,"Chamu, Jodhpur"],
"342037":[426,2019,0.19,"Danwra, Jodhpur"],
"342301":[250,1346,0.17,"Jamba, Jodhpur"],
"342302":[240,1333,-1,"Palli, Jodhpur"],
"342303":[335,1979,0.46,"Neora, Jodhpur"],
"342304":[305,1394,0.25,"Punjla, Jodhpur"],
"342305":[290,1028,0.4,"Jud, Jodhpur"],
"342306":[305,1327,0.27,"Barla Basni, Jodhpur"],
"342307":[310,947,0.16,"Chakhoo, Jodhpur"],
"342308":[280,1289,0.19,"Denok, Jodhpur"],
"342309":[480,2468,0.08,"Bhojakore, Jodhpur"],
"342310":[552,1553,0.2,"Bodana, Jaisalmer"],
"342311":[490,1234,-1,"Badu, Jodhpur"],
"342312":[442,1285,-1,"Bugri, Jodhpur"],
"342314":[475,2536,0.15,"Utwaliya, Jodhpur"],
"342601":[330,5035,2.01,"Chodhan, Jodhpur"],
"342602":[200,2688,0.18,"Jetiwas, Jodhpur"],
"342603":[598,2465,0.4,"Birai, Jodhpur"],
"342604":[582,2881,0.23,"Patel Nagar, Jodhpur"],
"342605":[494,2620,0.71,"Hariada, Jodhpur"],
"342606":[515,3035,0.26,"Artiyan Kallan, Jodhpur"],
"342801":[345,1299,0.25,"Bhacharna, Jodhpur"],
"342802":[755,3202,0.33,"Kakani, Jodhpur"],
"342901":[605,2555,0.66,"Barni Khurd, Jodhpur"],
"342902":[562,2555,0.34,"Harsolav, Nagaur"],
"343001":[651,1689,0.2,"Jalore, Jalore"],
"343002":[652,1694,0.2,"I.A.Jalore, Jalore"],
"343021":[787,1890,0.2,"Elana, Jalore"],
"343022":[900,2318,-1,"Chorau, Jalore"],
"343023":[1219,2653,0.17,"Thalwad, Jalore"],
"343024":[596,2032,0.34,"Raipuria, Jalore"],
"343025":[920,2036,0.2,"Bakra, Jalore"],
"343027":[551,1151,0.22,"Arwa, Mulugu"],
"343028":[1038,2479,0.2,"Basda Dhanji, Jalore"],
"343029":[380,1961,0.65,"Bhagal Bhim, Jalore"],
"343030":[657,1602,1.05,"Loonawas, Jalore"],
"343032":[900,2318,-1,"Dadal, Jalore"],
"343039":[257,869,1.33,"Puran, Jalore"],
"343040":[548,1979,1.13,"Ajodar, Jalore"],
"343041":[489,1346,0.2,"Achalpur, Jalore"],
"343042":[440,1235,-1,"Balwara, Jalore"],
"343048":[167,1176,0.0,"Dhamseen, Jalore"],
"343049":[340,950,0.94,"Alri, Jalore"],
"344001":[245,698,0.09,"Barmer, Barmer"],
"344011":[270,2168,0.07,"Sesau, Barmer"],
"344012":[515,2958,0.16,"Dudhwakhurd, Barmer"],
"344021":[614,2309,0.27,"Bhalron Ka Bada, Barmer"],
"344022":[300,3132,0.64,"Bhunka, Barmer"],
"344024":[297,2935,0.61,"Jasol, Barmer"],
"344025":[305,3421,0.69,"Variya Tagji, Barmer"],
"344026":[359,2383,0.21,"Korna, Barmer"],
"344027":[414,2220,0.46,"Kharwa, Barmer"],
"344031":[1320,-1,-1,"Banta, Barmer"],
"344032":[368,1995,0.39,"Badnava, Barmer"],
"344033":[757,7441,0.08,"Bhanasar Dhatarwalon Ki Dhani, Barmer"],
"344034":[1282,6376,0.41,"Narsali Nadi, Barmer"],
"344035":[737,3961,0.36,"Batadu, Barmer"],
"344037":[576,3312,2.35,"Punion Ka Tala, Barmer"],
"344043":[592,2930,0.33,"Dhiran, Barmer"],
"344044":[500,2984,0.69,"Deora, Barmer"],
"344501":[160,1930,0.07,"Munabao, Barmer"],
"344502":[700,5747,0.15,"Kachhabe Ki Dhani, Barmer"],
"344701":[732,2882,0.16,"Balai, Barmer"],
"344702":[528,3363,0.03,"Samelon Ka Tala, Barmer"],
"344703":[1660,6949,0.91,"Chawa, Barmer"],
"344704":[760,3040,0.25,"Kabooli, Barmer"],
"344705":[650,2968,0.14,"Swamy Ka Gaon, Barmer"],
"344706":[847,1390,0.77,"Arti, Barmer"],
"344708":[470,3561,0.17,"Bachhrau, Barmer"],
"344801":[704,7129,0.08,"Dharna, Barmer"],
"344802":[1080,2752,-1,"Lapundara Barthan, Barmer"],
"345001":[457,1519,0.24,"Jaisalmer, Jaisalmer"],
"345021":[349,1966,0.27,"Ratariya, Jaisalmer"],
"345022":[470,2012,-1,"Ratrau, Jaisalmer"],
"345023":[386,2053,0.32,"Sujasar, Jaisalmer"],
"345024":[360,2455,0.7,"Jaimla, Jaisalmer"],
"345025":[395,2483,0.24,"Hariyasar, Jaisalmer"],
"345026":[279,1542,0.32,"Loona Khurd, Jaisalmer"],
"345027":[250,2555,-1,"Kunda, Jaisalmer"],
"345028":[335,3105,0.3,"Askandra, Jaisalmer"],
"345031":[444,2700,0.32,"Odhania, Jaisalmer"],
"345033":[508,3145,0.2,"Narendra Nagar, Jaisalmer"],
"345034":[255,1004,0.19,"Bericiyala, Jaisalmer"],
"360001":[438,922,0.17,"Rajkot, Rajkot"],
"360002":[468,983,0.39,"Kherdi, Rajkot"],
"360003":[469,1029,0.06,"Kagadadi, Rajkot"],
"360004":[402,887,0.0,"Pal, Rajkot"],
"360005":[415,992,0.01,"Kankot, Rajkot"],
"360006":[471,1051,0.06,"SRPF GrXIII Ghanteshwar, Rajkot"],
"360007":[415,941,0.01,"Rajkot Raiya Road, Rajkot"],
"360008":[435,917,0.15,"Vinzivad, Rajkot"],
"360020":[478,1019,0.03,"Padasan, Rajkot"],
"360021":[513,1340,0.84,"Devgam, Rajkot"],
"360022":[402,728,0.01,"Dholara, Rajkot"],
"360023":[380,1215,1.93,"Kuchiyadad, Rajkot"],
"360024":[402,712,0.01,"Pardi, Rajkot"],
"360025":[520,1134,0.01,"Dahisara, Rajkot"],
"360026":[402,869,1.03,"Sapar Veraval, Rajkot"],
"360028":[430,901,0.06,"Rajkot Bedi D, Rajkot"],
"360030":[395,933,0.06,"Khareda, Rajkot"],
"360035":[365,1534,4.0,"Chandli, Rajkot"],
"360040":[520,1132,0.43,"Panchavda, Rajkot"],
"360045":[435,1042,0.33,"Bildi, Rajkot"],
"360050":[494,1112,0.29,"Gadhadia, Rajkot"],
"360055":[511,1249,0.22,"Khandhevadia, Rajkot"],
"360060":[615,1317,0.07,"LakhavadNani, Rajkot"],
"360070":[402,1016,1.32,"Dalia, Rajkot"],
"360110":[725,1917,0.22,"Adbalka, Rajkot"],
"360311":[320,905,0.1,"Gondal, Rajkot"],
"360320":[355,753,0.04,"Navagam, Rajkot"],
"360325":[435,916,0.15,"Vinzivad, Rajkot"],
"360330":[320,1005,0.1,"Bandra, Rajkot"],
"360360":[520,1372,0.01,"Dedarva, Rajkot"],
"360370":[928,2218,0.0,"Champrajpur, Rajkot"],
"360375":[928,2196,0.0,"Sardharpur, Rajkot"],
"360380":[690,1486,0.03,"Kagvad, Rajkot"],
"360405":[500,977,0.02,"Boria, Rajkot"],
"360410":[558,1247,0.02,"Bhukhi, Rajkot"],
"360421":[300,983,0.03,"Bhadajalia, Rajkot"],
"360430":[422,928,0.02,"Chichod, Rajkot"],
"360440":[422,1143,0.05,"Dumiyani, Rajkot"],
"360450":[488,1035,0.1,"Sajadiyali, Rajkot"],
"360452":[405,802,0.01,"Chavandi, Rajkot"],
"360460":[629,1762,0.03,"Dhank, Rajkot"],
"360465":[460,1069,0.06,"Moti Khilori, Rajkot"],
"360470":[320,871,0.1,"Kharachiya, Rajkot"],
"360480":[444,995,0.05,"Bagadhra, Jamnagar"],
"360485":[820,1560,0.03,"Khirasara, Rajkot"],
"360490":[422,1508,0.11,"Amrapar, Jamnagar"],
"360510":[390,1282,0.95,"Bhomiyavadar, Devbhumi Dwarka"],
"360515":[410,1000,1.36,"Ambardi, Devbhumi Dwarka"],
"360520":[462,846,0.03,"Chirodasang, Jamnagar"],
"360530":[517,1168,0.43,"Patan, Jamnagar"],
"360531":[400,1912,0.93,"Tarsai, Jamnagar"],
"360540":[310,1075,1.93,"Bhavabhi Khijadia, Jamnagar"],
"360545":[250,1037,0.3,"Boricha, Porbandar"],
"360550":[318,1150,0.09,"Dharampur, Porbandar"],
"360570":[724,2447,0.0,"Ranabordi, Porbandar"],
"360575":[500,2038,0.13,"Porbandar, Porbandar"],
"360576":[500,1618,0.0,"Garej, Porbandar"],
"360577":[318,1856,0.17,"Porbandar Seva Sadan, Porbandar"],
"360578":[301,2162,0.09,"Chhaya, Porbandar"],
"360579":[500,1886,0.14,"Bhavpara, Porbandar"],
"360590":[594,1309,0.09,"Khambhodar, Porbandar"],
"361001":[235,694,0.0,"Jamnagar, Jamnagar"],
"361002":[235,679,0.0,"Bedeshwar, Jamnagar"],
"361003":[235,679,0.0,"Aerodromme, Jamnagar"],
"361004":[235,669,0.0,"GIDC PHASE II, Jamnagar"],
"361005":[235,700,0.0,"Digvijay Plot, Jamnagar"],
"361006":[342,771,0.0,"Bed, Jamnagar"],
"361007":[235,679,0.0,"Navanagna, Jamnagar"],
"361008":[235,686,0.0,"Medical Campus, Jamnagar"],
"361009":[309,781,0.0,"Bedi, Jamnagar"],
"361010":[527,1345,0.03,"Motamandha, Devbhumi Dwarka"],
"361011":[310,822,0.0,"Beraja Fala, Jamnagar"],
"361012":[340,893,0.01,"Lavadia, Jamnagar"],
"361013":[340,626,0.12,"Laloi, Jamnagar"],
"361110":[210,517,0.05,"Moda, Jamnagar"],
"361120":[250,727,0.0,"Jambuda, Jamnagar"],
"361130":[200,446,0.12,"Dhudasia, Jamnagar"],
"361140":[507,1090,0.01,"Gagva, Jamnagar"],
"361142":[235,679,0.0,"Reliance Greens, Jamnagar"],
"361150":[332,785,0.0,"Valsura, Jamnagar"],
"361160":[400,735,0.03,"Chelabedi, Jamnagar"],
"361162":[400,768,0.04,"Kotha Bhadukia, Jamnagar"],
"361170":[409,865,0.01,"Haripar, Jamnagar"],
"361210":[393,1015,0.04,"Hadatoda, Jamnagar"],
"361220":[423,962,0.09,"Bhensdad, Jamnagar"],
"361230":[377,769,0.0,"Sachana, Jamnagar"],
"361240":[468,957,0.0,"Hajamchora, Jamnagar"],
"361250":[342,1488,0.0,"Badanpar, Jamnagar"],
"361280":[522,1362,0.0,"Rangpur, Jamnagar"],
"361305":[280,1051,0.1,"Danta, Devbhumi Dwarka"],
"361306":[427,824,0.06,"Chhapar, Devbhumi Dwarka"],
"361310":[313,1351,0.07,"Beh, Devbhumi Dwarka"],
"361315":[370,920,0.0,"Gandhavi, Devbhumi Dwarka"],
"361320":[470,1563,0.0,"Jampar, Devbhumi Dwarka"],
"361325":[620,1498,0.02,"Ashiyavadar, Devbhumi Dwarka"],
"361330":[503,1637,0.0,"Bet, Devbhumi Dwarka"],
"361335":[675,2739,0.03,"Khatumba, Devbhumi Dwarka"],
"361345":[644,2335,0.02,"Bhimrana, Devbhumi Dwarka"],
"361347":[644,2184,0.01,"Surajkaradi, Devbhumi Dwarka"],
"361350":[566,2196,0.02,"Okha, Devbhumi Dwarka"],
"362001":[482,730,0.0,"Junagadh, Junagadh"],
"362002":[411,760,0.0,"Vadhavi, Junagadh"],
"362011":[426,916,0.01,"Goladhar, Junagadh"],
"362015":[501,869,0.0,"Ivnagar, Junagadh"],
"362020":[450,1042,0.01,"Dholva, Junagadh"],
"362030":[637,1161,0.0,"Hadmatiya Vishal, Junagadh"],
"362037":[370,746,0.0,"Khamdhrol, Junagadh"],
"362110":[695,1122,0.0,"Mota Hadmatia, Junagadh"],
"362120":[430,785,0.07,"Juni Chavand, Junagadh"],
"362130":[270,621,0.08,"Kalavad Gir, Junagadh"],
"362135":[343,643,0.07,"Surajgadh B.O., Junagadh"],
"362140":[340,594,0.04,"Javantri, Gir Somnath"],
"362150":[340,695,0.01,"Borvav, Gir Somnath"],
"362205":[491,962,0.0,"Dhanfuliya, Junagadh"],
"362215":[491,986,0.0,"Bhatiya, Junagadh"],
"362220":[345,1261,0.0,"Ajab, Junagadh"],
"362222":[491,1122,0.0,"Jonpur, Junagadh"],
"362225":[410,1472,0.0,"Sultanpur, Junagadh"],
"362226":[428,2018,0.0,"Mangrol Bundar, Junagadh"],
"362227":[300,759,0.0,"Meswan, Junagadh"],
"362230":[698,1792,0.01,"Balej, Porbandar"],
"362240":[418,1676,0.0,"Antroli, Junagadh"],
"362245":[410,827,0.0,"Amrapur Gir, Junagadh"],
"362250":[388,1892,0.0,"Visanvel, Junagadh"],
"362255":[310,1430,0.07,"Achhidra, Junagadh"],
"362260":[491,790,0.01,"Chiroda, Junagadh"],
"362263":[482,1058,0.0,"Anandpur, Junagadh"],
"362265":[474,1169,0.09,"Dari, Gir Somnath"],
"362268":[340,888,0.03,"Ajotha, Gir Somnath"],
"362269":[310,557,0.05,"Inaj, Gir Somnath"],
"362275":[535,958,0.02,"Dhamlej, Gir Somnath"],
"362310":[370,824,0.01,"Sukhpur, Junagadh"],
"362315":[445,1002,0.01,"Kathrota, Junagadh"],
"362510":[450,1460,0.16,"Anjar, Gir Somnath"],
"362520":[720,2141,0.09,"Diu, Diu"],
"362530":[325,651,0.11,"Fatsar, Gir Somnath"],
"362540":[720,2025,0.12,"Ghoghla, Diu"],
"362550":[410,1077,0.08,"Saiyad Rajpara, Gir Somnath"],
"362560":[340,901,0.16,"Ambavad, Gir Somnath"],
"362565":[400,743,0.06,"Ugla, Gir Somnath"],
"362570":[810,2298,0.09,"Bucharvada, Diu"],
"362610":[477,1280,0.0,"Bantia, Junagadh"],
"362620":[748,2495,0.0,"Bagasara Ghed, Junagadh"],
"362625":[633,1990,0.0,"Nakra, Junagadh"],
"362630":[632,2024,0.01,"Kothdi, Junagadh"],
"362640":[556,1708,0.02,"Zinjri, Junagadh"],
"362650":[1112,2598,0.0,"Chhatrava, Porbandar"],
"362710":[288,692,0.03,"Gir Devli, Gir Somnath"],
"362715":[454,936,0.03,"Ambujanagar, Gir Somnath"],
"362720":[554,1165,0.07,"Aalidar, Gir Somnath"],
"363001":[300,1979,0.0,"Surendranagar, Surendranagar"],
"363020":[340,1472,0.65,"Kherali, Surendranagar"],
"363030":[340,1252,0.07,"Dedadra, Surendranagar"],
"363040":[320,1314,0.0,"Chamaraj, Surendranagar"],
"363110":[280,662,0.01,"Anindra, Surendranagar"],
"363115":[560,1981,0.04,"Chharad, Surendranagar"],
"363310":[386,1059,0.0,"Jasmatpur, Surendranagar"],
"363320":[290,783,0.01,"Dumana, Surendranagar"],
"363330":[541,1942,0.02,"Kadiyana, Morbi"],
"363351":[600,2199,0.0,"Susvav, Morbi"],
"363410":[635,1397,0.55,"Chhatriyala, Surendranagar"],
"363421":[359,1541,0.44,"Bhathan, Surendranagar"],
"363423":[433,1741,0.22,"Balol, Surendranagar"],
"363427":[255,1178,0.24,"Tavi, Surendranagar"],
"363430":[584,1534,0.41,"Sidhsar, Surendranagar"],
"363435":[260,1574,0.83,"Gundiyala, Surendranagar"],
"363440":[580,1445,0.1,"Khintala, Surendranagar"],
"363510":[385,1324,0.06,"Somasar, Surendranagar"],
"363520":[424,962,0.1,"Sapar, Surendranagar"],
"363530":[510,1301,-1,"Chorvira, Surendranagar"],
"363621":[365,850,0.26,"Kankot, Morbi"],
"363623":[430,878,0.03,"Dhuva, Morbi"],
"363630":[252,847,0.04,"Juna Ghantila, Morbi"],
"363641":[596,1751,0.06,"Barvala, Morbi"],
"363642":[285,1071,0.0,"Lalpar, Morbi"],
"363643":[530,1059,0.41,"Sakat Sanala, Morbi"],
"363650":[535,1130,0.11,"Hirapar, Morbi"],
"363655":[326,1005,0.01,"Jamsar, Jamnagar"],
"363660":[480,1689,0.05,"Bodki, Morbi"],
"363670":[370,1113,0.06,"Motibarar, Morbi"],
"363745":[228,705,0.01,"Sokhda, Surendranagar"],
"363750":[425,2864,0.0,"Bubvana, Surendranagar"],
"363755":[420,1337,0.02,"Fatepur, Surendranagar"],
"363760":[308,655,0.01,"Odu, Surendranagar"],
"363765":[228,1487,0.0,"Moti Majethi, Surendranagar"],
"363775":[265,585,0.01,"Lilapur, Surendranagar"],
"363780":[420,1856,0.06,"Surel, Surendranagar"],
"364001":[585,948,0.0,"Bhavnagar, Bhavnagar"],
"364002":[818,1619,0.02,"Malanka, Bhavnagar"],
"364003":[505,1391,0.02,"Bhavnagar Para, Bhavnagar"],
"364004":[516,1372,0.03,"Nari, Bhavnagar"],
"364005":[818,1719,0.02,"Concret Jetty, Bhavnagar"],
"364006":[458,1266,0.02,"Bhavnagar Station Road, Bhavnagar"],
"364050":[598,1295,0.08,"Morchand, Bhavnagar"],
"364060":[582,1508,0.04,"Kardej, Bhavnagar"],
"364070":[818,2058,0.07,"Hathab, Bhavnagar"],
"364081":[482,812,0.25,"Alang SBY, Bhavnagar"],
"364110":[585,2436,0.05,"Bhumbhli, Bhavnagar"],
"364120":[610,874,0.32,"Sankhdasar No2, Bhavnagar"],
"364130":[200,787,0.08,"Nincha Kotda, Bhavnagar"],
"364135":[220,789,0.11,"Pratappara, Bhavnagar"],
"364140":[425,762,0.1,"Devaliya, Bhavnagar"],
"364145":[220,574,0.11,"Bagdana, Bhavnagar"],
"364150":[550,894,0.35,"Bapada, Bhavnagar"],
"364210":[480,736,0.1,"Ramdhari, Bhavnagar"],
"364230":[415,1014,0.06,"Vavdi, Bhavnagar"],
"364240":[423,905,0.13,"Pipaliya, Bhavnagar"],
"364250":[407,887,0.13,"Navagam, Bhavnagar"],
"364260":[489,864,0.19,"Agiyali, Bhavnagar"],
"364265":[334,792,0.01,"Damrala, Bhavnagar"],
"364270":[408,855,0.0,"Jamanvav, Bhavnagar"],
"364275":[260,932,0.0,"Mangadh, Bhavnagar"],
"364280":[559,1199,0.58,"Mota Asrana, Bhavnagar"],
"364290":[347,1404,0.39,"Talgajarda, Bhavnagar"],
"364295":[200,658,0.04,"Degvada, Bhavnagar"],
"364310":[333,2425,0.06,"Kanthariya, Bhavnagar"],
"364313":[355,2104,0.11,"Bhadbhid, Bhavnagar"],
"364320":[542,1017,0.07,"Langala, Bhavnagar"],
"364330":[420,1341,0.2,"Chogath, Bhavnagar"],
"364505":[300,1476,0.01,"Morba, Bhavnagar"],
"364510":[407,1210,0.07,"Chok, Bhavnagar"],
"364515":[502,2031,0.03,"Oliya, Amreli"],
"364521":[172,2851,0.12,"Bhuva, Amreli"],
"364522":[598,1118,0.08,"Abhrampara, Amreli"],
"364525":[250,1226,0.01,"Katrodi, Bhavnagar"],
"364530":[514,1076,0.22,"Chikhali, Amreli"],
"364710":[275,992,0.05,"Nagalpar, Botad"],
"364720":[762,1493,0.09,"Bodi, Botad"],
"364730":[387,953,0.26,"Malpara, Botad"],
"364740":[542,1987,0.08,"Anida, Botad"],
"364750":[409,845,0.1,"Itaria, Botad"],
"364760":[291,1296,0.05,"Melana, Bhavnagar"],
"364765":[275,604,0.0,"Adtala, Botad"],
"365220":[258,638,0.65,"Bhattvadar, Amreli"],
"365410":[350,791,0.68,"Nadala, Amreli"],
"365421":[313,606,0.73,"Charkha, Amreli"],
"365430":[335,955,0.34,"Luvariya, Amreli"],
"365435":[268,580,0.47,"Barwala Jam, Amreli"],
"365440":[525,1393,0.02,"Jamka, Amreli"],
"365450":[308,1262,0.02,"Anida, Amreli"],
"365455":[540,1337,0.15,"Jangar, Amreli"],
"365456":[600,1300,0.03,"Khijadiakhara, Amreli"],
"365460":[453,1189,0.1,"Balelpiparia, Amreli"],
"365480":[674,1478,0.02,"KhijadiaKhan, Amreli"],
"365535":[155,1390,0.26,"Sanaliya, Amreli"],
"365540":[400,1221,0.01,"Lunsapur, Amreli"],
"365541":[498,924,0.17,"Kovaya, Amreli"],
"365550":[350,913,0.02,"Dadali, Amreli"],
"365555":[448,1313,0.34,"Kumbhariya, Amreli"],
"365560":[242,1497,0.08,"Babriyadhar, Amreli"],
"365601":[411,1205,0.49,"Amreli, Amreli"],
"365610":[511,1334,0.17,"Vadera, Amreli"],
"365620":[490,1143,0.2,"Ingorala2, Amreli"],
"365630":[255,1572,0.65,"Chhatadiya, Amreli"],
"365635":[410,1185,0.03,"Anida, Amreli"],
"365640":[450,943,0.09,"Bordi, Amreli"],
"365645":[438,985,0.03,"Kadaya, Amreli"],
"365650":[350,748,0.25,"Bhavrdi, Amreli"],
"365730":[520,1358,0.02,"Bhada, Amreli"],
"370001":[489,1390,0.22,"Bhuj, Kachchh"],
"370015":[300,1328,2.18,"Haripar, Kachchh"],
"370020":[490,1392,0.19,"Bhujodi, Kachchh"],
"370030":[457,1346,0.11,"Naredi, Kachchh"],
"370040":[300,2330,1.85,"Ratiya, Kachchh"],
"370105":[544,1497,2.02,"Kotda Reha, Kachchh"],
"370110":[684,2868,0.19,"Khambhara, Kachchh"],
"370115":[600,1787,0.15,"Khokhara, Kachchh"],
"370130":[770,2701,0.48,"Chandia, Kachchh"],
"370135":[817,1847,0.47,"Halra, Kachchh"],
"370140":[596,1380,0.44,"Bharudia, Kachchh"],
"370145":[751,1713,0.09,"Thoriyari, Kachchh"],
"370150":[1005,2827,0.05,"Amaliyara, Kachchh"],
"370155":[690,1453,0.11,"Hamirpar, Kachchh"],
"370160":[450,863,0.18,"Padampar, Kachchh"],
"370165":[1114,2463,0.33,"Ganeshpar, Kachchh"],
"370201":[521,1618,0.32,"Bhimasar, Kachchh"],
"370203":[540,1484,2.01,"Udaynagar, Kachchh"],
"370205":[631,3037,0.14,"Antarjar, Kachchh"],
"370210":[300,952,1.17,"Kandla Port, Kachchh"],
"370230":[300,952,1.17,"Kandla Special Economic Zone, Kachchh"],
"370405":[360,1441,0.19,"Deshalpar, Kachchh"],
"370410":[830,2226,0.85,"Luni, Kachchh"],
"370415":[501,1980,0.4,"Karaghogha, Kachchh"],
"370421":[475,2031,0.49,"Dhrab, Kachchh"],
"370425":[472,1679,1.42,"Kanjara, Kachchh"],
"370427":[456,1328,3.25,"Bharapar, Kachchh"],
"370430":[350,1387,3.06,"Chundi, Kachchh"],
"370435":[316,1065,0.21,"Siracha, Kachchh"],
"370445":[288,1004,0.05,"Darshadi, Kachchh"],
"370450":[300,1978,0.18,"Bhojay, Kachchh"],
"370455":[320,927,0.21,"Nana Bhadia, Kachchh"],
"370460":[270,752,-1,"Talwana, Kachchh"],
"370465":[270,698,-1,"Durgapur, Kachchh"],
"370475":[539,1685,0.13,"Bada, Kachchh"],
"370485":[377,1096,1.01,"Goniasar, Kachchh"],
"370490":[235,768,0.1,"Sandhan, Kachchh"],
"370510":[1000,2551,0.21,"Bhirandiara, Kachchh"],
"370601":[654,1337,0.11,"Narayan Sarovar, Kachchh"],
"370605":[1220,3594,0.13,"Mathal, Kachchh"],
"370610":[570,1492,0.15,"Anandpar, Kachchh"],
"370615":[285,1953,2.26,"Naranpar R, Kachchh"],
"370620":[638,2258,0.32,"Khirsara, Kachchh"],
"370625":[849,2387,0.13,"Gadani, Kachchh"],
"370627":[569,1167,0.13,"Guneri, Kachchh"],
"370630":[330,657,0.19,"Dolatpar, Kachchh"],
"370641":[140,1610,0.21,"Moti Sindhodi, Kachchh"],
"370645":[220,1841,0.25,"Khirsara, Kachchh"],
"370650":[338,1053,0.28,"Balachod Nani, Kachchh"],
"370655":[242,1444,0.41,"Aida, Kachchh"],
"370660":[140,2085,0.83,"Kalatalav, Kachchh"],
"370665":[830,1975,0.31,"Jatavira, Kachchh"],
"370670":[898,2706,0.24,"Rasalia, Kachchh"],
"370675":[793,1994,0.23,"Angiya Mota, Kachchh"],
"380001":[912,2525,0.02,"Ahmedabad GPO, Ahmadabad"],
"380002":[914,2528,0.02,"Revdibazar, Ahmadabad"],
"380003":[914,2529,0.02,"DELIVERY HUB AHMEDABAD, Ahmadabad"],
"380004":[916,2530,0.02,"Shahibag, Ahmadabad"],
"380005":[927,2546,0.02,"Sabarmati, Ahmadabad"],
"380006":[908,2519,0.02,"Ellisbridge, Ahmadabad"],
"380007":[905,2515,0.02,"Paldi SO Ahmedabad, Ahmadabad"],
"380008":[913,2527,0.02,"Maninagar, Ahmadabad"],
"380009":[910,2522,0.02,"Navrangpura, Ahmadabad"],
"380010":[908,2519,0.02,"Ellisbridge, Ahmadabad"],
"380011":[911,2524,0.02,"Shah Alam Roza, Ahmadabad"],
"380012":[910,2522,0.02,"Naranpura Vistar, Ahmadabad"],
"380013":[910,2522,0.02,"Naranpura Vistar, Ahmadabad"],
"380014":[911,2523,0.02,"Navjivan, Ahmadabad"],
"380015":[901,2508,0.02,"Jodhpur Char Rasta, Ahmadabad"],
"380016":[918,2534,0.02,"Civil Hospital, Ahmadabad"],
"380018":[916,2532,0.02,"Saraspur, Ahmadabad"],
"380019":[925,2544,0.02,"Railway Colony SO Ahmedabad, Ahmadabad"],
"380021":[914,2528,0.02,"Rajpur Gomtipur, Ahmadabad"],
"380022":[910,2523,0.02,"Behrampura, Ahmadabad"],
"380023":[916,2531,0.02,"Sukhrampura, Ahmadabad"],
"380024":[917,2533,0.02,"Bapunagar, Ahmadabad"],
"380026":[916,2532,0.02,"Ctm Char Rasta, Ahmadabad"],
"380027":[855,2533,0.02,"Gandhi Ashram SO Ahmedabad, Ahmadabad"],
"380028":[910,2522,0.02,"Shah Alam Roza, Ahmadabad"],
"380049":[844,2255,0.09,"Nikol, Ahmadabad"],
"380050":[911,2525,0.02,"Ghodasar SO Ahmedabad, Ahmadabad"],
"380051":[895,2500,0.02,"Jivraj Park, Ahmadabad"],
"380052":[903,2511,0.02,"Memnagar, Ahmadabad"],
"380054":[900,2506,0.02,"Bodakdev, Ahmadabad"],
"380055":[897,2503,0.02,"Juhapura, Ahmadabad"],
"380057":[876,2469,0.02,"South Bopal, Ahmadabad"],
"380058":[859,2443,0.02,"Shela, Ahmadabad"],
"380059":[889,2489,0.02,"Shilaj, Ahmadabad"],
"380060":[855,2528,0.02,"Ognaj, Ahmadabad"],
"380061":[855,2524,0.02,"Ghatlodia, Ahmadabad"],
"380063":[911,2524,0.02,"Sola H B C, Ahmadabad"],
"382006":[897,2393,0.06,"Gandhinagar Sector 3, Gandhinagar"],
"382007":[881,2336,0.07,"Indroda, Gandhinagar"],
"382010":[876,2321,0.07,"Gandhinagar Gujarat, Gandhinagar"],
"382016":[883,2345,0.07,"Vavol, Gandhinagar"],
"382021":[867,2288,0.08,"Gandhinagar Sector 30, Gandhinagar"],
"382028":[886,2355,0.07,"Kolavada, Gandhinagar"],
"382030":[874,2313,0.08,"NDC Gandhinagar, Gandhinagar"],
"382041":[858,2257,0.08,"Thermal Power Station, Gandhinagar"],
"382042":[902,2511,0.02,"Lekawada, Gandhinagar"],
"382045":[817,2074,0.46,"BSF GANDHINAGAR, Gandhinagar"],
"382050":[853,2236,0.09,"Gift City, Gandhinagar"],
"382055":[706,2025,0.01,"Palaj, Gandhinagar"],
"382110":[824,3309,0.04,"Fangadi, Ahmadabad"],
"382115":[850,2429,-1,"Chekhla, Ahmadabad"],
"382120":[343,1174,0.01,"Charol, Mahesana"],
"382122":[855,2002,0.02,"Dantali, Gandhinagar"],
"382130":[476,2079,0.01,"Endla, Ahmadabad"],
"382140":[429,1693,0.01,"Chhaniar, Ahmadabad"],
"382145":[445,1111,0.08,"Balsasan, Ahmadabad"],
"382150":[445,2233,0.02,"Bhojwa, Ahmadabad"],
"382170":[583,1914,0.0,"Bol, Ahmadabad"],
"382210":[850,2429,-1,"Bakrol, Ahmadabad"],
"382213":[850,2429,-1,"Vasna Chacharvadi, Ahmadabad"],
"382220":[633,2275,0.02,"Adroda, Ahmadabad"],
"382225":[544,1842,0.3,"Vautha, Ahmadabad"],
"382230":[413,1539,0.15,"Bholad, Ahmadabad"],
"382240":[596,2140,0.01,"Gangad, Ahmadabad"],
"382245":[329,1175,0.34,"Alampur, Botad"],
"382250":[467,1839,0.1,"Chokdi, Botad"],
"382255":[423,1676,0.19,"Godhavata, Botad"],
"382260":[618,1831,0.02,"Chandisar, Ahmadabad"],
"382265":[355,906,0.0,"Virdi, Ahmadabad"],
"382305":[855,2506,0.02,"Vadvasa, Gandhinagar"],
"382308":[532,1269,0.51,"Chiskari, Gandhinagar"],
"382315":[580,1299,0.69,"Patna Kuva, Gandhinagar"],
"382320":[694,1649,0.37,"Dolarana Vasna, Gandhinagar"],
"382321":[569,1191,0.46,"Giyod, Gandhinagar"],
"382330":[848,2260,0.09,"Pardhol, Ahmadabad"],
"382340":[857,2291,0.08,"Kubernagar, Ahmadabad"],
"382345":[855,2291,0.09,"Krishnanagar SO Ahmedabad, Ahmadabad"],
"382350":[920,2537,0.02,"T B Nagar, Ahmadabad"],
"382355":[841,2323,0.02,"Prantiya, Gandhinagar"],
"382405":[850,2429,-1,"Gyaspur, Ahmadabad"],
"382415":[918,2536,0.02,"Odhav Industrial Estate, Ahmadabad"],
"382418":[917,2533,0.02,"Vastral, Ahmadabad"],
"382419":[904,2438,0.05,"Sargasan, Gandhinagar"],
"382421":[940,2564,0.02,"Zundal, Ahmadabad"],
"382422":[893,2411,0.02,"Bhoyan Rathod, Gandhinagar"],
"382423":[800,2225,0.01,"Jamiyatpura, Gandhinagar"],
"382424":[929,2549,0.02,"Chandkheda, Ahmadabad"],
"382425":[757,2476,0.04,"Girmatha, Ahmadabad"],
"382426":[883,2369,0.07,"Raysan, Gandhinagar"],
"382427":[751,2479,0.04,"Ode, Ahmadabad"],
"382428":[850,2429,-1,"Bhat, Ahmadabad"],
"382430":[820,2119,0.1,"Kubadthal, Ahmadabad"],
"382433":[580,1265,0.18,"Chamla, Ahmadabad"],
"382435":[650,2529,0.04,"Geratpur, Ahmadabad"],
"382443":[910,2522,0.02,"Isanpur, Ahmadabad"],
"382445":[850,2429,-1,"Vinzol, Ahmadabad"],
"382449":[850,2429,-1,"Gatrad, Ahmadabad"],
"382450":[306,2508,0.03,"Kundal, Ahmadabad"],
"382455":[618,2231,0.02,"Bhangadh, Ahmadabad"],
"382460":[240,1601,0.28,"Jaliya, Ahmadabad"],
"382463":[489,1890,0.15,"Ambli, Ahmadabad"],
"382465":[590,2003,0.0,"Buranpur, Ahmadabad"],
"382470":[855,2546,0.02,"Jagatpur, Ahmadabad"],
"382475":[862,2308,0.08,"Sardarnagar, Ahmadabad"],
"382480":[855,2534,0.02,"Ranip, Ahmadabad"],
"382481":[855,2531,0.02,"Gota, Ahmadabad"],
"382501":[894,2421,0.02,"Shantigram, Gandhinagar"],
"382610":[854,2240,0.09,"Pethapur, Gandhinagar"],
"382620":[872,2305,0.08,"Randheja, Gandhinagar"],
"382630":[752,2054,0.02,"Rupal, Gandhinagar"],
"382640":[850,2274,0.02,"Adrajmoti, Gandhinagar"],
"382650":[766,2171,0.02,"Amrapur Gram Bharti, Gandhinagar"],
"382721":[855,2197,0.02,"Kalol, Gandhinagar"],
"382722":[855,2535,0.02,"Bhadaj, Ahmadabad"],
"382725":[855,2198,0.02,"Serisa, Gandhinagar"],
"382729":[591,1643,0.01,"Chhatral, Gandhinagar"],
"382735":[455,1197,0.09,"Amja, Gandhinagar"],
"382740":[855,2551,0.02,"Dhamasana, Gandhinagar"],
"382810":[400,1344,-1,"Samau, Gandhinagar"],
"382835":[400,1344,-1,"Lakroda, Gandhinagar"],
"382845":[620,1749,0.02,"Itadar, Gandhinagar"],
"382855":[400,1344,-1,"Khadat, Gandhinagar"],
"383001":[440,1173,0.12,"Himatnagar, Sabar Kantha"],
"383002":[440,1164,0.11,"Vishwamangalam, Sabar Kantha"],
"383006":[390,1210,0.03,"Boria SO Sabarkantha, Sabar Kantha"],
"383010":[400,1021,0.05,"Kaniol, Sabar Kantha"],
"383030":[355,827,0.05,"Sadha, Sabar Kantha"],
"383110":[352,1176,0.02,"Chadasana, Sabar Kantha"],
"383120":[436,1126,0.08,"Sampad, Sabar Kantha"],
"383205":[488,1149,0.32,"Balisana, Sabar Kantha"],
"383210":[330,1182,0.1,"Mauchha, Sabar Kantha"],
"383215":[375,974,0.1,"Amrapur, Sabar Kantha"],
"383220":[440,1254,0.11,"Dedhrota, Sabar Kantha"],
"383225":[470,1369,0.05,"Pethapur, Sabar Kantha"],
"383230":[390,1101,0.01,"Oda, Sabar Kantha"],
"383235":[390,1180,0.05,"Mahor, Sabar Kantha"],
"383240":[400,550,0.01,"Hunj, Sabar Kantha"],
"383245":[370,793,0.08,"Mau Bhavnath, Arvalli"],
"383246":[412,1024,0.03,"Bhanmer, Arvalli"],
"383250":[255,621,0.39,"Vandhiyol, Arvalli"],
"383251":[280,512,0.47,"Mota Kantharia, Arvalli"],
"383255":[1500,2055,0.15,"Khedva, Sabar Kantha"],
"383260":[390,639,0.01,"Vatrakgadh, Arvalli"],
"383270":[370,1220,0.07,"Lambadiya, Sabar Kantha"],
"383275":[385,1491,0.24,"Galodiya, Sabar Kantha"],
"383276":[360,767,0.05,"Adpodra, Sabar Kantha"],
"383305":[330,885,0.02,"Antroli, Sabar Kantha"],
"383307":[330,846,0.01,"Khilodia, Arvalli"],
"383310":[315,713,0.01,"Naranpura Kampa, Arvalli"],
"383315":[350,715,0.01,"Ganeshpur, Arvalli"],
"383316":[380,808,0.04,"Bhavanpura Kampa, Arvalli"],
"383317":[445,803,0.05,"Moti Isrol, Arvalli"],
"383320":[335,808,0.07,"Shampur, Arvalli"],
"383325":[390,929,0.0,"Ambaliara, Arvalli"],
"383330":[380,1144,0.0,"Boral, Arvalli"],
"383335":[340,522,0.0,"Barnoli, Arvalli"],
"383340":[600,964,0.04,"Bordi, Arvalli"],
"383345":[348,624,0.02,"Mahiyapur, Arvalli"],
"383350":[350,517,0.09,"Bhemapur, Arvalli"],
"383355":[280,422,0.87,"Karchha, Arvalli"],
"383410":[400,953,0.02,"Ankala, Sabar Kantha"],
"383421":[418,917,0.01,"Mota Kotda, Sabar Kantha"],
"383422":[422,935,0.11,"Ambamahuda, Sabar Kantha"],
"383430":[418,875,0.01,"Lei, Sabar Kantha"],
"383434":[370,785,0.0,"Rampur Fudeda, Sabar Kantha"],
"383440":[395,1070,0.04,"Chulla, Sabar Kantha"],
"383450":[428,921,0.02,"Nankhi, Arvalli"],
"383460":[230,611,0.05,"Atarsumba, Sabar Kantha"],
"383462":[230,730,0.04,"Gadi, Sabar Kantha"],
"384001":[400,1646,0.0,"Mahesana, Mahesana"],
"384002":[290,1274,0.23,"Mahesana Radhanpur Road, Mahesana"],
"384003":[368,1109,0.0,"Mahesana Ongc Colony, Mahesana"],
"384005":[345,1448,0.09,"PALODAR, Mahesana"],
"384012":[345,1479,0.12,"Ganpat Vidyanagar, Mahesana"],
"384110":[245,1095,0.23,"Der, Patan"],
"384120":[290,1393,0.06,"Bamosana, Mahesana"],
"384130":[367,1305,0.04,"Bhunav, Mahesana"],
"384135":[445,1436,0.05,"Vishol, Mahesana"],
"384140":[367,1371,0.03,"Jagnathpura, Mahesana"],
"384151":[290,759,0.15,"Dethli, Patan"],
"384160":[290,1746,0.07,"Unava, Mahesana"],
"384170":[280,1714,0.03,"Amudh, Mahesana"],
"384220":[290,759,0.15,"Khorsam, Patan"],
"384221":[290,759,0.15,"Mithi Gariyal, Patan"],
"384225":[238,438,0.0,"Zilia, Patan"],
"384229":[290,759,0.15,"Pindharpura, Patan"],
"384230":[290,759,0.15,"Itoda, Patan"],
"384240":[290,759,0.15,"Bilia, Patan"],
"384241":[290,759,0.15,"Lolada, Patan"],
"384245":[290,759,0.15,"Amrapuara, Patan"],
"384246":[264,494,0.0,"Dantisana, Patan"],
"384255":[290,759,0.15,"Sankra, Patan"],
"384260":[330,1216,0.0,"Pali, Mahesana"],
"384265":[340,1904,0.82,"Patan, Patan"],
"384266":[340,1648,0.81,"Kunwara, Patan"],
"384272":[290,759,0.15,"Bepadar, Patan"],
"384275":[290,759,0.15,"Islampura, Patan"],
"384285":[290,759,0.15,"Bhilvan, Patan"],
"384290":[290,759,0.15,"Sahesa, Patan"],
"384305":[510,1509,0.0,"Dadhial, Mahesana"],
"384310":[362,1237,0.01,"Khandosan, Mahesana"],
"384315":[415,1324,0.06,"Gunja, Mahesana"],
"384316":[404,1278,0.02,"Kansa, Nagaur"],
"384320":[307,866,0.08,"Umta, Mahesana"],
"384325":[372,1291,0.13,"Dabhad, Mahesana"],
"384330":[418,1001,0.02,"Ankaliyara, Mahesana"],
"384335":[641,2572,0.02,"Madhasana, Mahesana"],
"384340":[412,1017,0.04,"Sardarpur, Mahesana"],
"384345":[442,1362,0.12,"Sundhia, Mahesana"],
"384355":[470,1569,0.07,"Bamanva, Mahesana"],
"384360":[419,1051,0.02,"Hadol, Mahesana"],
"384410":[350,1288,0.16,"Maguna, Mahesana"],
"384412":[320,1296,0.18,"Motap, Mahesana"],
"384415":[402,1590,0.11,"Ambala, Mahesana"],
"384421":[491,1292,0.08,"Jakasana, Mahesana"],
"384430":[350,1115,0.18,"Katosan, Mahesana"],
"384435":[513,1304,0.17,"Boriavi, Mahesana"],
"384440":[360,1089,0.01,"Balasar, Mahesana"],
"384441":[580,1685,0.01,"Fuletra, Mahesana"],
"384445":[385,1437,0.0,"Agol, Mahesana"],
"384450":[549,1596,0.01,"Kaiyal, Mahesana"],
"384455":[496,1321,0.08,"Bhasaria, Mahesana"],
"384460":[474,1418,0.11,"Devrasan, Mahesana"],
"384465":[407,1254,-1,"Meu, Mahesana"],
"384470":[400,1344,-1,"Gozaria, Mahesana"],
"384515":[579,1756,0.22,"Malosan, Mahesana"],
"384520":[400,1344,-1,"Tatosan, Mahesana"],
"384530":[360,1052,0.0,"Vadasan, Mahesana"],
"384540":[563,1816,0.09,"Mandali, Mahesana"],
"384550":[584,1768,0.22,"Khanusa, Mahesana"],
"384560":[508,1570,0.07,"Jantral, Mahesana"],
"384565":[400,1344,-1,"Dabhala, Mahesana"],
"384570":[461,1279,0.11,"Bhavsor, Mahesana"],
"385001":[319,946,0.02,"Palanpur, Banas Kantha"],
"385010":[298,888,0.04,"Bhatamalmoti, Banas Kantha"],
"385110":[388,866,0.1,"Dhagadia, Banas Kantha"],
"385120":[395,735,0.02,"Bhakhari, Banas Kantha"],
"385130":[372,1474,0.07,"Dabhela, Banas Kantha"],
"385135":[390,1050,0.07,"Jethi, Banas Kantha"],
"385210":[385,1040,0.05,"Manpura, Banas Kantha"],
"385310":[210,1248,-1,"Dharnodhar, Banas Kantha"],
"385320":[550,2377,2.57,"Chatra, Banas Kantha"],
"385330":[343,1077,1.32,"Jasali, Banas Kantha"],
"385340":[290,759,0.15,"Chalvada, Patan"],
"385350":[290,759,0.15,"Charanka, Patan"],
"385360":[290,759,0.15,"Babra, Patan"],
"385410":[315,921,0.05,"Badargadh, Banas Kantha"],
"385421":[373,969,0.09,"Dalwana, Banas Kantha"],
"385505":[205,910,0.03,"Odhava, Banas Kantha"],
"385506":[237,772,0.04,"Sardar Krishinagar, Banas Kantha"],
"385510":[268,794,0.04,"Bhakhar moti, Banas Kantha"],
"385515":[268,715,0.04,"Dalwada, Banas Kantha"],
"385520":[279,776,0.03,"Changwada, Banas Kantha"],
"385530":[357,1078,0.21,"Balodhar, Banas Kantha"],
"385535":[206,577,0.03,"Agthala, Banas Kantha"],
"385540":[205,383,0.07,"Lunpur, Banas Kantha"],
"385545":[205,1038,0.03,"Dhaniawada, Banas Kantha"],
"385550":[468,1532,1.3,"Khoda, Banas Kantha"],
"385555":[472,1612,1.3,"Isarva, Banas Kantha"],
"385560":[550,2377,2.57,"Bhadrewadi, Banas Kantha"],
"385565":[210,527,0.02,"Charda, Banas Kantha"],
"385566":[234,400,0.03,"Akoli, Banas Kantha"],
"385570":[333,1018,1.24,"Bharadva, Banas Kantha"],
"385575":[235,401,0.03,"Baluntri, Banas Kantha"],
"385581":[217,549,0.03,"Lalpur, Banas Kantha"],
"387001":[435,909,0.07,"Nadiad, Kheda"],
"387002":[400,879,0.38,"Bilodara, Kheda"],
"387003":[435,879,0.07,"Petlad Road, Kheda"],
"387105":[504,1468,0.17,"Haldharvas, Kheda"],
"387110":[400,901,0.03,"Jaravat, Kheda"],
"387115":[435,879,0.07,"Chalali, Kheda"],
"387120":[400,901,0.03,"Sankhej, Kheda"],
"387130":[400,901,0.03,"Amrapura, Kheda"],
"387210":[413,1289,0.46,"Manghrol, Anand"],
"387220":[315,692,1.2,"Petli, Anand"],
"387230":[510,1185,0.05,"Tundel, Kheda"],
"387240":[250,1003,0.8,"Palol, Anand"],
"387310":[400,883,0.74,"Lambhvel, Anand"],
"387315":[618,2224,0.04,"Chaklashi, Kheda"],
"387320":[341,1147,0.76,"Arera, Kheda"],
"387325":[618,2224,0.04,"Kanjari, Kheda"],
"387330":[490,1021,0.52,"Heranj, Kheda"],
"387335":[400,901,0.03,"Karoli, Kheda"],
"387340":[52,112,0.0,"Nizampura, Kheda"],
"387345":[445,1063,0.59,"Rajnagar, Kheda"],
"387350":[514,1286,0.11,"Bamroli, Kheda"],
"387355":[380,737,0.57,"Piplata, Kheda"],
"387360":[435,932,0.08,"Hathaj, Kheda"],
"387365":[461,1439,0.22,"Khadol, Kheda"],
"387370":[440,878,0.43,"Bhumel, Kheda"],
"387375":[225,895,1.9,"Sanjaya, Anand"],
"387380":[500,1590,0.59,"Deva Vanta, Anand"],
"387411":[618,2224,0.04,"Kheda, Kheda"],
"387430":[225,918,0.53,"Bharkunda, Kheda"],
"387510":[400,901,0.03,"Undhela, Kheda"],
"387520":[266,535,0.0,"Kharanti, Kheda"],
"387530":[400,901,0.03,"Asamli, Kheda"],
"387540":[510,1573,0.09,"Dharoda, Kheda"],
"387550":[400,901,0.03,"Dhathal, Kheda"],
"387560":[400,901,0.03,"Chandana, Kheda"],
"387570":[400,901,0.03,"Sokhada, Kheda"],
"387610":[400,901,0.03,"Ravdavat, Kheda"],
"387620":[400,901,0.03,"Danadra, Kheda"],
"387630":[400,901,0.03,"Bhatera, Kheda"],
"387635":[489,1447,0.24,"Badarpur, Kheda"],
"387640":[400,901,0.03,"Vadol, Kheda"],
"387650":[450,1451,0.25,"Abvel, Kheda"],
"387710":[40,129,0.0,"Navagam, Kheda"],
"388001":[440,948,0.7,"Anand, Anand"],
"388110":[440,915,0.82,"Hadgood, Anand"],
"388120":[400,841,1.06,"Vallabh Vidyanagar, Anand"],
"388130":[250,816,0.96,"Dhundakuva, Anand"],
"388140":[340,843,3.16,"Chuva, Anand"],
"388150":[312,1020,1.7,"Manpura, Anand"],
"388160":[225,895,1.9,"Amod, Anand"],
"388170":[399,1997,0.3,"Kalitalavadi, Anand"],
"388180":[500,1561,0.52,"Jichka, Anand"],
"388205":[390,927,1.45,"Badapura, Anand"],
"388210":[370,948,1.3,"Bharoda, Anand"],
"388215":[388,1030,0.62,"Khijalpur, Kheda"],
"388220":[388,956,0.71,"Lingda, Anand"],
"388225":[388,1038,0.22,"Bordi, Kheda"],
"388230":[330,929,0.2,"Mithapura Jesapura, Kheda"],
"388235":[245,549,0.1,"Mahi Itadi, Kheda"],
"388239":[238,570,0.07,"Wanakbori TPS, Kheda"],
"388245":[274,801,0.05,"Sonaiya, Kheda"],
"388250":[388,1024,0.09,"Gumadia, Kheda"],
"388255":[239,513,0.14,"Bhanthala, Mahisagar"],
"388260":[340,1046,0.05,"Kheroli, Mahisagar"],
"388265":[619,2233,0.04,"Dev, Mahisagar"],
"388270":[515,1170,0.11,"Bhalada, Mahisagar"],
"388305":[480,822,0.0,"Sundan, Anand"],
"388306":[510,879,0.0,"Rajupura, Anand"],
"388307":[480,827,0.0,"Amrol, Anand"],
"388310":[440,951,0.68,"Ajarpura, Anand"],
"388315":[440,844,0.95,"Jol, Anand"],
"388320":[440,935,0.94,"Gamdi, Anand"],
"388325":[390,787,1.39,"Valasan, Anand"],
"388330":[340,872,0.0,"Khambholej, Anand"],
"388335":[480,951,1.05,"Rasnol, Anand"],
"388340":[440,924,0.85,"Ramnagar, Anand"],
"388345":[430,780,0.55,"Gana, Anand"],
"388350":[480,849,0.0,"Khadol, Anand"],
"388355":[400,839,1.03,"Navli, Anand"],
"388360":[480,926,0.83,"Ajupura, Anand"],
"388365":[480,990,1.06,"Dholi, Anand"],
"388370":[480,918,0.92,"Gopalpura, Anand"],
"388410":[618,2224,0.04,"Bandhani, Anand"],
"388421":[380,665,0.98,"Changa, Anand"],
"388430":[400,814,1.14,"Dharmajranoli, Anand"],
"388440":[309,735,1.62,"Ghunteli, Anand"],
"388450":[225,895,1.9,"Bhavanipura, Anand"],
"388460":[315,1229,1.55,"Kasor, Anand"],
"388465":[440,951,0.68,"Palaj, Anand"],
"388470":[440,951,0.68,"Sunav, Anand"],
"388480":[238,881,2.3,"Virol (simarda BO), Anand"],
"388510":[340,796,1.43,"Asarma, Anand"],
"388520":[340,857,2.19,"Navapura, Anand"],
"388530":[340,923,4.35,"Sisva, Anand"],
"388540":[340,822,2.35,"Nisraya, Anand"],
"388543":[340,772,2.55,"Alarsa, Anand"],
"388545":[238,817,2.74,"Kavitha, Anand"],
"388550":[399,1997,0.3,"Dahevan, Anand"],
"388560":[295,783,2.12,"Khandhli, Anand"],
"388570":[295,1135,4.69,"Amiyad, Anand"],
"388580":[399,1997,0.3,"Finav, Anand"],
"388590":[340,809,3.23,"Kasari, Anand"],
"388610":[399,1997,0.3,"Dhuvaran, Anand"],
"388620":[399,1997,0.3,"Malu, Anand"],
"388625":[399,1997,0.3,"Vadgam, Anand"],
"388630":[391,1910,1.06,"Nana Kalodara, Anand"],
"388640":[399,1997,0.3,"Kalamsar, Anand"],
"388710":[280,627,0.09,"Nadisar, Panch Mahals"],
"388713":[270,712,0.04,"Manipur C, Panch Mahals"],
"389001":[300,510,0.07,"Godhra, Panch Mahals"],
"389002":[240,639,0.04,"Ambali, Panch Mahals"],
"389110":[370,670,0.04,"MotirelW, Mahisagar"],
"389115":[290,614,0.15,"Agarwada, Panch Mahals"],
"389120":[250,617,0.14,"Bakkhar, Panch Mahals"],
"389130":[250,491,0.15,"Aasayadi, Dohad"],
"389135":[320,637,0.0,"Singvad, Dohad"],
"389140":[300,532,0.33,"Dhadhela, Dohad"],
"389146":[312,629,0.59,"Padalia, Dohad"],
"389151":[360,1086,0.29,"Dahod, Dohad"],
"389152":[388,1155,0.38,"Kaliavad, Dohad"],
"389154":[369,1102,0.44,"Agavada, Dohad"],
"389155":[345,1840,0.4,"Jambua, Dohad"],
"389160":[363,1049,0.24,"Bhathiwada, Dohad"],
"389170":[250,572,0.12,"Kadval, Dohad"],
"389172":[270,545,0.06,"Chhalor, Dohad"],
"389175":[312,610,0.14,"Methan, Dohad"],
"389180":[339,938,0.05,"Amba, Dohad"],
"389190":[250,530,0.1,"Nani Bhugedi, Mahisagar"],
"389210":[325,925,0.04,"Aniyad, Panch Mahals"],
"389220":[330,978,0.11,"Kharol, Mahisagar"],
"389230":[299,606,0.0,"Gangta, Mahisagar"],
"389232":[256,534,0.01,"Pandaravada, Mahisagar"],
"389235":[280,532,0.0,"Vadina Gorda, Mahisagar"],
"389250":[267,532,0.04,"Ankalia, Mahisagar"],
"389260":[290,572,0.05,"Hirapur, Mahisagar"],
"389265":[280,524,0.02,"Kelamul, Mahisagar"],
"389310":[400,827,0.2,"Bedhiya, Panch Mahals"],
"389320":[360,974,0.2,"Pingli, Panch Mahals"],
"389330":[410,956,0.12,"Boru Bakorl, Panch Mahals"],
"389340":[290,844,0.17,"Mehlol, Panch Mahals"],
"389341":[340,821,0.08,"Bhilod, Panch Mahals"],
"389350":[380,471,0.05,"Tarkhanda, Panch Mahals"],
"389360":[380,436,0.07,"Bhamaria, Panch Mahals"],
"389365":[379,716,0.21,"Davadra, Panch Mahals"],
"389370":[325,947,0.02,"Palikhanda, Panch Mahals"],
"389380":[275,703,0.14,"Antela, Dohad"],
"389382":[348,624,0.02,"Bhorva, Dohad"],
"389390":[363,592,0.13,"Hirapur, Panch Mahals"],
"390001":[316,1134,0.0,"Vadodara, Vadodara"],
"390002":[336,1184,0.0,"Fateganj, Vadodara"],
"390003":[240,362,0.0,"Gorwa, Vadodara"],
"390004":[360,831,0.0,"Danteshwar, Vadodara"],
"390006":[336,1184,0.0,"Fatepura SO Vadodara, Vadodara"],
"390007":[406,1227,0.0,"Vidhyut Nagar Colony, Vadodara"],
"390008":[404,1211,0.0,"Karelibaug, Vadodara"],
"390009":[485,1555,0.0,"Tarsali, Vadodara"],
"390010":[240,286,0.0,"Vadsar, Vadodara"],
"390011":[422,1408,0.0,"Manjalpur, Vadodara"],
"390012":[231,345,0.0,"Tandalja, Vadodara"],
"390013":[336,1184,0.0,"Maneja, Vadodara"],
"390014":[340,1001,4.21,"Dhaniavi, Vadodara"],
"390016":[336,1184,0.0,"Industrial Estate Vadodara, Vadodara"],
"390017":[394,1308,0.0,"Wadi SN Road, Vadodara"],
"390018":[389,1214,0.0,"Karelibaug, Vadodara"],
"390019":[340,789,4.06,"Bakrol, Vadodara"],
"390020":[394,1208,0.0,"Akota, Vadodara"],
"390021":[336,1184,0.0,"T B Sanatorium, Vadodara"],
"390022":[421,1188,0.0,"Harni, Vadodara"],
"390023":[419,1195,0.0,"Subhanpura, Vadodara"],
"390024":[420,1194,0.0,"Chhani Rd, Vadodara"],
"390025":[383,1281,0.0,"Soma Talav, Vadodara"],
"390026":[336,1184,0.0,"Jawahar Nagar SO Vadodara, Vadodara"],
"391101":[336,1184,0.0,"Ampad, Vadodara"],
"391105":[75,161,0.0,"Nanderia, Vadodara"],
"391107":[75,160,0.0,"Bhilapur, Vadodara"],
"391110":[90,172,0.0,"Dabhoi, Vadodara"],
"391115":[360,831,0.0,"Kanjetha, Vadodara"],
"391120":[300,462,0.0,"Bhadarwa, Narmada"],
"391125":[95,189,0.0,"Bamroli, Chhotaudepur"],
"391130":[75,161,0.0,"Chorngala, Chhotaudepur"],
"391135":[89,172,0.0,"Tandalja, Chhotaudepur"],
"391150":[95,189,0.0,"Alwa, Narmada"],
"391152":[75,160,0.0,"Bhaka, Chhotaudepur"],
"391156":[90,172,0.0,"Bhilpur, Chhotaudepur"],
"391160":[90,172,0.0,"Sukal, Chhotaudepur"],
"391165":[45,156,0.0,"Dhandhoda, Chhotaudepur"],
"391168":[35,120,0.0,"Karanjwant, Chhotaudepur"],
"391170":[38,109,0.0,"Pipaldi, Chhotaudepur"],
"391210":[360,831,0.0,"Dhavat, Vadodara"],
"391220":[360,831,0.0,"Jiyatalavdi, Vadodara"],
"391240":[75,161,0.0,"Gosindra, Vadodara"],
"391243":[35,149,0.0,"Ramnath, Vadodara"],
"391244":[360,831,0.0,"Bachar, Vadodara"],
"391250":[360,831,0.0,"Achisara, Vadodara"],
"391310":[50,177,0.0,"Karodia, Vadodara"],
"391320":[336,1184,0.0,"Jawahar Nagar SO Vadodara, Vadodara"],
"391330":[360,831,0.0,"Angadh, Vadodara"],
"391340":[95,189,0.0,"Fazalpur, Vadodara"],
"391345":[340,1266,0.0,"Petrochemical T Ship, Vadodara"],
"391350":[264,386,0.0,"Dhanora, Vadodara"],
"391410":[290,473,0.01,"Raipura, Vadodara"],
"391421":[383,967,1.54,"Masar, Vadodara"],
"391430":[360,831,0.0,"Jalalpura, Vadodara"],
"391440":[360,831,0.0,"Dabka, Vadodara"],
"391445":[50,251,0.0,"Rajupura, Vadodara"],
"391450":[360,831,0.0,"Chokari, Vadodara"],
"391510":[60,131,0.0,"Ghantiyal, Vadodara"],
"391520":[360,831,0.0,"Pasva, Vadodara"],
"391530":[52,187,0.0,"Latwa, Vadodara"],
"391740":[410,1123,5.25,"Ajod, Vadodara"],
"391745":[240,368,0.0,"Pilol, Vadodara"],
"391750":[510,1364,0.0,"Fartilizer Nagar, Vadodara"],
"391760":[75,161,0.0,"Ambali, Vadodara"],
"391761":[95,189,0.0,"Kuvarpura, Vadodara"],
"391770":[75,161,0.0,"Muval, Vadodara"],
"391774":[75,161,0.0,"Dajipura, Vadodara"],
"391775":[252,353,0.0,"Namisara, Vadodara"],
"391776":[450,1134,0.0,"Manjusar GIDC, Vadodara"],
"391780":[360,831,0.0,"Natwar Nagar, Vadodara"],
"391810":[302,864,0.05,"Kareli, Bharuch"],
"392001":[482,1734,1.15,"Bharuch, Bharuch"],
"392011":[482,1663,0.8,"Haldarva, Bharuch"],
"392012":[549,1713,0.88,"Argama, Bharuch"],
"392015":[482,1698,1.02,"Kantharia, Bharuch"],
"392020":[502,1652,1.05,"Kasad, Bharuch"],
"392025":[474,1021,0.44,"Anor, Bharuch"],
"392030":[551,1503,0.57,"Mangleshwar, Bharuch"],
"392035":[306,749,0.09,"Manjola, Bharuch"],
"392040":[330,1439,2.13,"Islampur, Bharuch"],
"392110":[330,704,0.12,"Buva, Bharuch"],
"392130":[245,795,0.35,"Atali, Bharuch"],
"392135":[230,755,0.4,"Jolva, Bharuch"],
"392140":[250,697,0.06,"Gandhar, Bharuch"],
"392150":[330,790,0.08,"Magnad, Bharuch"],
"392155":[341,998,1.4,"Malpur, Bharuch"],
"392160":[308,1223,1.84,"Kurla, Bharuch"],
"392165":[278,785,0.13,"Limdi, Bharuch"],
"392170":[302,858,0.64,"Nahar, Bharuch"],
"392180":[330,1120,0.59,"Kavli, Bharuch"],
"392210":[619,1672,0.71,"Hingalla, Bharuch"],
"392215":[601,1641,0.62,"Urja Nagar, Bharuch"],
"392220":[716,1607,0.99,"Matroj, Vadodara"],
"392230":[299,725,0.05,"Mangrol, Bharuch"],
"392240":[619,1680,0.73,"Adol, Bharuch"],
"392310":[213,353,0.0,"Kiya, Vadodara"],
"393001":[482,1660,0.55,"Borbhathabet, Bharuch"],
"393002":[370,1700,0.35,"Kapodra, Bharuch"],
"393010":[482,1730,0.52,"Andada, Bharuch"],
"393017":[527,1308,0.33,"Avidha, Bharuch"],
"393020":[370,1221,1.02,"Piludra, Bharuch"],
"393025":[265,474,0.01,"Ambagam, Narmada"],
"393030":[385,1013,1.97,"Digas, Bharuch"],
"393040":[300,479,0.0,"Pansar, Narmada"],
"393041":[250,454,0.3,"Chikda, Narmada"],
"393050":[290,435,0.0,"Kuilivel, Narmada"],
"393105":[507,1097,0.01,"Lilod, Vadodara"],
"393110":[440,1357,0.38,"Navagam Borjai, Bharuch"],
"393115":[448,1136,0.2,"Mota Sorva, Bharuch"],
"393120":[411,826,0.01,"Panetha, Bharuch"],
"393125":[410,882,0.31,"Mokhdi, Bharuch"],
"393130":[365,835,0.02,"Anjoli, Bharuch"],
"393135":[509,1481,0.86,"Bharadia, Bharuch"],
"393140":[417,744,0.02,"Amletha, Narmada"],
"393145":[290,803,0.03,"Hajarpura, Narmada"],
"393150":[345,794,0.03,"Sehrav, Narmada"],
"393151":[418,678,0.05,"Mithivav, Narmada"],
"394101":[480,1141,0.25,"Mota Varachha, Surat"],
"394105":[480,1142,0.27,"Utran, Surat"],
"394107":[419,946,0.31,"Chhapra Bhatha, Surat"],
"394110":[530,1846,0.34,"Anita, Surat"],
"394112":[350,1143,0.17,"Borsad, Surat"],
"394115":[370,2597,0.23,"Kharod, Bharuch"],
"394120":[530,2052,0.3,"Kharach, Bharuch"],
"394125":[330,1639,0.36,"Mahuvej, Surat"],
"394130":[430,1428,0.31,"Bharundi, Surat"],
"394140":[260,763,0.1,"Munjlav, Surat"],
"394150":[430,1267,0.35,"Abrama, Surat"],
"394155":[280,905,0.23,"Virpur, Surat"],
"394160":[270,649,0.17,"Lakhgam, Surat"],
"394163":[270,601,0.08,"Karvali, Surat"],
"394170":[280,1231,0.25,"Vegi, Surat"],
"394180":[315,1008,0.29,"Dhatva, Surat"],
"394185":[315,997,0.29,"Kathodara, Surat"],
"394190":[315,1034,0.32,"Kholvad, Surat"],
"394210":[305,1127,0.01,"Bamroli, Surat"],
"394221":[305,1148,0.17,"Pandesara IE, Surat"],
"394230":[344,1464,0.13,"Vanz, Surat"],
"394235":[315,1025,0.29,"Popda, Surat"],
"394240":[240,609,0.06,"Bartad, Surat"],
"394245":[255,595,0.21,"Zervavra, Surat"],
"394246":[190,305,0.14,"Bhagvanpura, Surat"],
"394248":[245,819,0.11,"Butwada, Surat"],
"394250":[235,441,0.1,"Miyapur, Surat"],
"394270":[305,744,0.02,"Nandniketan, Surat"],
"394305":[230,844,0.07,"Bagumara, Surat"],
"394310":[309,936,0.11,"Barasadi, Surat"],
"394315":[380,1207,0.12,"Malekpor, Surat"],
"394317":[400,1573,0.17,"Vadadla Tanti, Surat"],
"394320":[315,1010,0.29,"Segva, Surat"],
"394325":[380,892,0.16,"Ladvi, Surat"],
"394326":[390,1010,0.21,"Vav Kathodara, Surat"],
"394327":[268,716,0.34,"Kadodara, Surat"],
"394330":[315,1010,0.29,"Timba, Surat"],
"394335":[270,561,0.18,"Kamlapore, Surat"],
"394340":[248,590,0.19,"Vatsalyadham, Surat"],
"394345":[235,666,0.15,"Umrakh, Surat"],
"394350":[248,664,0.11,"Chhitra, Surat"],
"394352":[274,1073,0.13,"Lakhanpor, Surat"],
"394355":[255,782,0.12,"Kharvasa, Surat"],
"394365":[190,564,0.11,"Raniamba, Tapi"],
"394370":[332,666,0.0,"Bortha, Tapi"],
"394375":[290,503,0.03,"Haripur, Tapi"],
"394380":[310,599,0.0,"Gangtha, Tapi"],
"394405":[315,990,0.23,"Asarma, Surat"],
"394410":[550,2130,0.51,"Gijram, Surat"],
"394421":[420,1270,0.17,"Harsani, Surat"],
"394430":[280,788,0.06,"Ambawadi, Surat"],
"394440":[450,647,0.04,"Umarzar, Surat"],
"394445":[250,466,0.37,"Khota Rampura, Surat"],
"394510":[305,748,0.02,"Bhatpore, Surat"],
"394515":[326,963,0.25,"Kribhconagar, Surat"],
"394516":[480,1141,0.25,"Adityanagar, Surat"],
"394517":[262,799,0.23,"Damka, Surat"],
"394518":[480,1141,0.25,"Ongc Nagar, Surat"],
"394520":[430,1473,0.33,"Kosam, Surat"],
"394530":[379,1344,0.15,"Jinod, Surat"],
"394540":[598,1644,0.16,"Asnad, Surat"],
"394550":[262,713,0.14,"Dumasgam, Surat"],
"394601":[240,667,0.12,"Bardoli, Surat"],
"394620":[240,557,0.2,"Kikwad, Surat"],
"394630":[250,645,0.11,"Vankla, Tapi"],
"394633":[240,862,0.06,"Mangalia, Tapi"],
"394635":[250,547,0.07,"Kakadva, Tapi"],
"394640":[312,455,0.06,"Navafalia, Tapi"],
"394641":[312,552,0.18,"Gandhi Vidhyapith, Tapi"],
"394650":[190,257,0.15,"Chikhali Khadka, Tapi"],
"394651":[228,388,0.17,"Panchpipla, Tapi"],
"394652":[190,277,0.15,"Moghvan, Tapi"],
"394655":[205,379,0.14,"Balpur, Tapi"],
"394660":[224,376,0.09,"Centrap Pulp Mill, Tapi"],
"394670":[223,312,0.04,"Moti Khervan, Tapi"],
"394680":[268,505,0.07,"Limbi, Tapi"],
"394690":[225,405,0.08,"Bhojpur Najik, Tapi"],
"394710":[200,343,2.4,"Chankhal, Dang"],
"394715":[190,305,0.14,"Bhalkhet, Dang"],
"394716":[240,290,0.12,"Kadmal, Dang"],
"394720":[180,288,1.25,"Malegaon, Dang"],
"394730":[175,283,1.19,"Manmodi, Dang"],
"394810":[385,1396,1.69,"Asarma, Bharuch"],
"395001":[385,1423,1.56,"Nanpura, Surat"],
"395002":[362,1104,0.01,"Surat Textile Market, Surat"],
"395003":[480,1139,0.25,"Surat, Surat"],
"395004":[419,895,0.29,"Dabholi, Surat"],
"395005":[392,1234,0.15,"Ambheta, Surat"],
"395006":[480,1149,0.27,"Varachha Road, Surat"],
"395007":[262,1017,0.29,"Abhva, Surat"],
"395008":[480,1133,0.28,"A K Road, Surat"],
"395009":[362,985,0.01,"Palanpur, Surat"],
"395010":[419,1029,0.17,"Saroli, Surat"],
"395011":[480,1141,0.25,"Puna Kumbharia, Surat"],
"395012":[449,1077,0.2,"Godadara, Surat"],
"395013":[480,1151,0.27,"Kosmada, Surat"],
"395014":[362,1060,0.01,"Surat Textile Market, Surat"],
"395015":[480,1141,0.25,"Ongc Nagar, Surat"],
"395017":[577,1800,0.05,"Althan, Surat"],
"395023":[258,1137,0.14,"Bhestan, Surat"],
"396001":[400,1053,0.09,"Valsad, Valsad"],
"396002":[385,1025,0.13,"Valsad Abrama, Valsad"],
"396007":[320,838,0.17,"Velvach, Valsad"],
"396020":[385,988,0.2,"Dived, Valsad"],
"396030":[385,1096,0.09,"Lilapore, Valsad"],
"396035":[335,826,0.19,"Khajurdi, Valsad"],
"396040":[269,539,0.12,"Achhavani, Navsari"],
"396045":[300,947,0.26,"Pitha, Valsad"],
"396050":[220,445,0.07,"Barsol, Valsad"],
"396051":[240,424,0.05,"Bhavthan Ambosi, Valsad"],
"396055":[265,563,0.11,"Bodlai, Valsad"],
"396060":[260,423,0.03,"Mogravadi, Navsari"],
"396065":[190,336,0.07,"Kakadkuva, Valsad"],
"396067":[160,220,0.63,"Burla, Valsad"],
"396105":[244,490,0.07,"Dehli, Valsad"],
"396110":[330,840,0.12,"Dholai Falia, Navsari"],
"396115":[240,638,0.51,"Kolak, Valsad"],
"396120":[270,474,0.06,"Manekpore, Valsad"],
"396125":[295,686,0.42,"Pachlai, Valsad"],
"396126":[190,695,0.06,"Deli, Valsad"],
"396130":[270,532,0.09,"Sarai, Valsad"],
"396135":[270,467,0.07,"Saronda, Valsad"],
"396140":[240,584,0.33,"Kalgam, Valsad"],
"396145":[295,590,0.32,"Ambach Paria, Valsad"],
"396150":[270,459,0.06,"Tembhi, Valsad"],
"396155":[229,536,0.25,"Punat, Valsad"],
"396165":[229,426,0.05,"Bhathi Karmbeli, Valsad"],
"396170":[259,507,0.06,"Dehri, Valsad"],
"396171":[270,533,0.06,"Umargam IE, Valsad"],
"396180":[260,685,0.47,"Udvada, Valsad"],
"396185":[260,629,0.39,"Kalsar, Valsad"],
"396191":[240,565,0.36,"Chhiri, Valsad"],
"396193":[220,418,0.12,"Karvad, Valsad"],
"396195":[260,564,0.31,"Chanod Md, Valsad"],
"396210":[220,620,0.48,"Bhimpore, Daman"],
"396215":[240,662,0.65,"Kunta, Valsad"],
"396220":[220,735,0.47,"Dholar, Daman"],
"396230":[189,301,0.0,"Amboli, Dadra And Nagar Haveli"],
"396235":[229,433,0.03,"Athal, Dadra And Nagar Haveli"],
"396240":[209,392,0.0,"Chinchpada, Dadra And Nagar Haveli"],
"396310":[310,938,0.08,"Dhamdachha, Navsari"],
"396321":[310,867,0.08,"Bilimora, Navsari"],
"396325":[330,747,0.14,"Nandarkha, Navsari"],
"396350":[440,1440,0.09,"Kolva, Navsari"],
"396360":[330,824,0.12,"Ajrai, Navsari"],
"396370":[385,1336,0.09,"Kachholi, Navsari"],
"396375":[365,605,0.17,"Gorgam, Valsad"],
"396380":[310,886,0.08,"Valoti, Navsari"],
"396385":[330,636,0.04,"Bhagal, Valsad"],
"396403":[355,1478,0.15,"Aat, Navsari"],
"396406":[330,1627,0.09,"Kalthan, Navsari"],
"396409":[280,585,0.11,"Bamanvel, Navsari"],
"396412":[330,917,0.1,"Motikakrad, Navsari"],
"396415":[380,1541,0.17,"Dhaman, Navsari"],
"396418":[309,1528,0.12,"Tarsadi, Navsari"],
"396421":[355,1748,0.17,"Jalalpore, Navsari"],
"396427":[380,2267,0.18,"Amli Kasba, Navsari"],
"396430":[300,601,0.15,"Gandeva, Navsari"],
"396433":[720,1711,0.1,"Sarpore Pardi, Navsari"],
"396436":[380,1170,0.49,"Bhinar, Navsari"],
"396439":[330,1431,0.22,"Machhad, Navsari"],
"396445":[380,2009,0.15,"Navsari, Navsari"],
"396450":[355,1587,0.13,"Hansapore, Navsari"],
"396460":[330,1129,0.08,"Krishnapur, Navsari"],
"396463":[550,1893,0.11,"Italva, Navsari"],
"396466":[255,580,0.2,"Nagdhara, Navsari"],
"396469":[270,1326,0.1,"Kurel, Navsari"],
"396472":[330,1566,0.1,"Chandravasansupa, Navsari"],
"396475":[380,1681,0.11,"Sandalpore, Navsari"],
"396510":[225,412,0.1,"Kumkotar, Surat"],
"396521":[275,651,0.15,"Sadakpore, Navsari"],
"396530":[275,551,0.14,"Chasa, Navsari"],
"396540":[230,391,0.07,"Kaliari, Navsari"],
"396560":[250,380,0.17,"Ranverikalla, Navsari"],
"396570":[250,411,0.12,"Chapaldhara, Navsari"],
"396580":[230,381,0.05,"Ambapani, Navsari"],
"396590":[250,451,0.08,"Kurelia, Navsari"],
"400001":[243,526,0.0,"Mumbai GPO, Mumbai"],
"400002":[243,502,0.0,"Kalbadevi, Mumbai"],
"400003":[235,469,0.0,"B.P.Lane, Mumbai"],
"400004":[242,481,0.0,"Girgaon, Mumbai"],
"400005":[245,522,0.0,"Asvini, Mumbai"],
"400006":[242,481,0.0,"Malabar Hill, Mumbai"],
"400007":[242,476,0.0,"S V Marg, Mumbai"],
"400008":[242,472,0.0,"Mumbai Central, Mumbai"],
"400009":[242,466,0.0,"Princess Dock, Mumbai"],
"400010":[242,465,0.0,"Mazgaon Dock, Mumbai"],
"400011":[242,470,0.0,"Agripada, Mumbai"],
"400012":[236,441,0.0,"Parel Rly Work Shop, Mumbai"],
"400013":[242,449,0.0,"Delisle Road, Mumbai"],
"400014":[230,411,0.0,"Dadar, Mumbai"],
"400015":[242,458,0.0,"Sewri, Mumbai"],
"400016":[228,406,0.0,"Mahim, Mumbai"],
"400017":[227,404,0.0,"Dharavi Road, Mumbai"],
"400018":[236,442,0.0,"Worli Naka, Mumbai"],
"400019":[230,403,0.0,"Matunga, Mumbai"],
"400020":[242,507,0.0,"Marine Lines, Mumbai"],
"400021":[243,513,0.0,"Elephanta Caves Po, Mumbai"],
"400022":[227,398,0.0,"Raoli Camp, Mumbai"],
"400024":[221,391,0.0,"Nehru Nagar, Mumbai Suburban"],
"400025":[230,425,0.0,"New Prabhadevi Road, Mumbai"],
"400026":[243,472,0.0,"Cumballa Hill, Mumbai"],
"400027":[242,483,0.0,"V J B Udyan, Mumbai"],
"400028":[236,411,0.0,"Ranade Road, Mumbai"],
"400029":[214,385,0.0,"A I Staff Colony, Mumbai Suburban"],
"400030":[242,441,0.0,"Worli Police Camp, Mumbai"],
"400031":[230,412,0.0,"Wadala, Mumbai"],
"400032":[243,514,0.0,"Mantralaya SO Mumbai, Mumbai"],
"400033":[242,470,0.0,"Kalachowki, Mumbai"],
"400034":[243,471,0.0,"Tulsiwadi, Mumbai"],
"400035":[243,492,0.0,"Rajbhavan S.O (Mumbai), Mumbai"],
"400037":[230,404,0.0,"C G S Colony, Mumbai"],
"400042":[212,384,0.0,"Bhandup East, Mumbai Suburban"],
"400043":[210,383,0.0,"DM Colony, Mumbai Suburban"],
"400049":[222,463,0.0,"Juhu, Mumbai Suburban"],
"400050":[227,417,0.0,"Bandra West, Mumbai Suburban"],
"400051":[227,409,0.0,"Audit Bhavan, Mumbai Suburban"],
"400052":[227,423,0.0,"Khar Delivery, Mumbai Suburban"],
"400053":[222,453,0.0,"Andheri, Mumbai Suburban"],
"400054":[214,442,0.0,"Santacruz Central, Mumbai Suburban"],
"400055":[214,422,0.0,"Santacruz(East), Mumbai Suburban"],
"400056":[221,466,0.0,"Vileparle(West), Mumbai Suburban"],
"400057":[221,460,0.0,"Hanuman Road, Mumbai Suburban"],
"400058":[222,450,0.0,"Andheri Railway Station, Mumbai Suburban"],
"400059":[212,399,0.0,"Marol Naka, Mumbai Suburban"],
"400060":[212,405,0.0,"Jogeshwari East, Mumbai Suburban"],
"400061":[222,455,0.0,"Vesava, Mumbai Suburban"],
"400063":[214,407,0.0,"Sharma Estate, Mumbai Suburban"],
"400064":[237,420,0.0,"Malad, Mumbai Suburban"],
"400065":[214,384,0.0,"Nagari Niwara, Mumbai Suburban"],
"400066":[244,384,0.0,"Daulat Nagar SO Mumbai, Mumbai Suburban"],
"400067":[244,440,0.0,"Charkop, Mumbai Suburban"],
"400068":[244,351,0.0,"Dahisar RS, Mumbai Suburban"],
"400069":[210,437,0.0,"Nagardas Road, Mumbai Suburban"],
"400070":[214,390,0.0,"Kurla West, Mumbai Suburban"],
"400071":[221,365,0.0,"Chembur, Mumbai Suburban"],
"400072":[210,391,0.0,"Sakinaka, Mumbai Suburban"],
"400074":[221,374,0.0,"Chembur Extension, Mumbai Suburban"],
"400075":[214,396,0.0,"Best Staff Colony, Mumbai Suburban"],
"400076":[208,369,0.0,"Powai Iit, Mumbai Suburban"],
"400077":[214,391,0.0,"Rajawadi, Mumbai Suburban"],
"400078":[210,381,0.0,"JM Road, Mumbai Suburban"],
"400079":[208,395,0.0,"Psm Colony, Mumbai Suburban"],
"400080":[210,368,0.0,"Mulund Dd Road, Mumbai Suburban"],
"400081":[219,394,0.0,"Mulund East, Mumbai Suburban"],
"400082":[212,363,0.0,"Mulund Colony, Mumbai Suburban"],
"400083":[205,390,0.0,"Kannamwar Nagar, Mumbai Suburban"],
"400084":[212,399,0.0,"Barve Nagar, Mumbai Suburban"],
"400085":[230,408,0.0,"BARC, Mumbai Suburban"],
"400086":[214,396,0.0,"Ghatkopar West, Mumbai Suburban"],
"400087":[212,377,0.0,"IIM Mumbai PO, Mumbai Suburban"],
"400088":[212,391,0.0,"Govandi, Mumbai Suburban"],
"400089":[214,381,0.0,"Chembur Rs, Mumbai Suburban"],
"400091":[244,418,0.0,"Borivali, Mumbai Suburban"],
"400092":[244,399,0.0,"Borivali West, Mumbai Suburban"],
"400093":[210,418,0.0,"Chakala Midc, Mumbai Suburban"],
"400094":[214,418,0.0,"Anushakti Nagar, Mumbai Suburban"],
"400095":[244,509,0.0,"Ins Hamla, Mumbai Suburban"],
"400096":[210,392,0.0,"Seepz, Mumbai Suburban"],
"400097":[230,409,0.0,"Rani Sati Marg, Mumbai Suburban"],
"400098":[214,390,0.0,"Vidyanagari, Mumbai Suburban"],
"400099":[221,427,0.0,"International Airport, Mumbai Suburban"],
"400101":[230,390,0.0,"Kandivali East, Mumbai Suburban"],
"400102":[214,420,0.0,"Oshiwara, Mumbai Suburban"],
"400103":[244,379,0.0,"Mandapeshwar, Mumbai Suburban"],
"400104":[230,428,0.0,"Bangur Nagar, Mumbai Suburban"],
"400111":[243,528,0.0,"Mumbai GPO, Mumbai"],
"400114":[230,411,0.0,"Dadar, Mumbai"],
"400118":[243,477,0.0,"Mumbai Central, Mumbai"],
"400150":[227,419,0.0,"Bandra West, Mumbai Suburban"],
"400153":[222,455,0.0,"Vesava, Mumbai Suburban"],
"400160":[214,438,0.0,"Oshiwara, Mumbai Suburban"],
"400167":[230,410,0.0,"Malad, Mumbai Suburban"],
"400171":[221,365,0.0,"Chembur, Mumbai Suburban"],
"400183":[205,391,0.0,"Kannamwar Nagar, Mumbai Suburban"],
"400186":[214,396,0.0,"Ghatkopar West, Mumbai Suburban"],
"400193":[249,490,0.0,"Chikhal Dongre, Palghar"],
"400201":[230,389,0.0,"Kandivali East, Mumbai Suburban"],
"400601":[214,384,0.0,"Thane, Thane"],
"400602":[214,327,0.0,"Gokhale Road S.O (Thane), Thane"],
"400603":[214,391,0.0,"Kopri Colony, Thane"],
"400604":[219,379,0.0,"Wagle I.E., Thane"],
"400605":[214,399,0.0,"Kalwa, Thane"],
"400606":[214,357,0.0,"Jekegram, Thane"],
"400607":[214,327,0.0,"Sandozbaugh, Thane"],
"400608":[214,359,0.0,"Tapasenagar, Thane"],
"400609":[214,381,0.0,"Thane, Thane"],
"400610":[210,296,0.0,"Apna Bazar, Thane"],
"400612":[244,521,0.0,"Dahisar, Thane"],
"400614":[264,428,0.0,"Belapur Node V, Thane"],
"400615":[210,334,0.0,"Kasarvadavali, Thane"],
"400701":[214,470,0.0,"Ghansoli, Thane"],
"400702":[251,526,0.0,"Karanja, Raigad"],
"400703":[205,473,0.0,"Vashi S.O (Thane), Thane"],
"400704":[245,466,0.0,"Mora, Raigad"],
"400705":[215,463,0.0,"Sanpada, Thane"],
"400706":[209,442,0.0,"Darave, Thane"],
"400707":[251,526,0.0,"Jaskhar, Raigad"],
"400708":[212,438,0.0,"Airoli, Thane"],
"400709":[210,500,0.0,"Kopar Khairne, Thane"],
"400710":[214,520,0.0,"Millenium Business Park, Thane"],
"401101":[252,421,0.0,"Rai, Thane"],
"401102":[173,380,0.0,"Agarwadi, Palghar"],
"401103":[273,373,0.0,"Asangaon, Palghar"],
"401105":[289,456,0.0,"Bhayander East, Palghar"],
"401106":[328,449,0.0,"Dongari, Thane"],
"401107":[248,397,0.0,"Ghodbander, Thane"],
"401108":[248,393,0.0,"Ghodbander, Thane"],
"401201":[248,466,0.0,"Bhuigaon, Palghar"],
"401202":[242,496,0.0,"Umela, Palghar"],
"401203":[239,659,0.0,"Gass, Palghar"],
"401204":[257,333,0.0,"Vedhe, Thane"],
"401205":[242,592,0.0,"Juchandra, Palghar"],
"401207":[252,488,0.0,"Naigaon, Palghar"],
"401208":[241,534,0.0,"Sasun Navghar, Palghar"],
"401209":[240,538,0.0,"Nallosapare E, Palghar"],
"401301":[249,490,0.0,"Chikhal Dongre, Palghar"],
"401302":[237,519,0.0,"Arnala, Palghar"],
"401303":[235,392,0.0,"Dahisar T V, Palghar"],
"401304":[252,415,0.0,"Kalamb, Palghar"],
"401305":[240,494,0.0,"Chandansar, Palghar"],
"401401":[240,488,0.0,"Kelwa Road, Palghar"],
"401402":[237,419,0.0,"Kelwa mahim, Palghar"],
"401403":[204,406,0.0,"Bandhan, Palghar"],
"401404":[178,357,0.0,"Palghar, Palghar"],
"401405":[213,414,0.0,"Nandore, Palghar"],
"401501":[237,397,0.0,"Mahagaon, Palghar"],
"401502":[223,336,0.0,"Vengani, Palghar"],
"401503":[280,405,0.0,"Varor, Palghar"],
"401504":[219,331,0.0,"Parnali, Palghar"],
"401506":[251,445,0.0,"Tarapur Ti, Palghar"],
"401601":[280,525,0.0,"Badapokharan, Palghar"],
"401602":[273,-1,0.0,"Charoti, Palghar"],
"401603":[123,-1,0.0,"Khuded, Palghar"],
"401604":[105,210,0.0,"Morhanda, Palghar"],
"401605":[212,445,0.0,"Khoste, Palghar"],
"401606":[229,349,0.0,"Dabhadi, Palghar"],
"401607":[184,330,0.0,"Rankol, Palghar"],
"401608":[273,403,0.0,"Dahanu TPS, Palghar"],
"401701":[184,365,0.0,"Borigaon, Palghar"],
"401702":[275,453,0.02,"Gholvad, Palghar"],
"401703":[275,428,0.01,"Kosbad hill, Palghar"],
"402101":[115,143,0.0,"Lipniwave, Raigad"],
"402102":[178,249,0.0,"TolBudruk, Raigad"],
"402103":[151,241,0.0,"Nagaon, Raigad"],
"402104":[164,221,0.0,"Hodgaon, Raigad"],
"402105":[45,93,0.0,"Khamgaon, Raigad"],
"402106":[212,381,0.0,"Bense, Raigad"],
"402107":[273,616,0.0,"Ambeghar, Raigad"],
"402108":[286,538,0.0,"Kusumbale, Raigad"],
"402109":[204,425,0.0,"Ashtami, Raigad"],
"402110":[59,92,0.0,"Galsure, Raigad"],
"402111":[153,248,0.0,"Rahatad, Raigad"],
"402112":[220,253,0.0,"Mahagaon, Raigad"],
"402113":[53,90,0.0,"Chikhlap, Raigad"],
"402114":[59,94,0.0,"Kolmandla, Raigad"],
"402115":[178,250,0.0,"Ravdhal, Raigad"],
"402116":[212,414,0.0,"Varse, Raigad"],
"402117":[164,205,0.0,"Degaon, Raigad"],
"402120":[220,277,0.0,"Borwadi, Raigad"],
"402122":[50,98,0.0,"Chandore, Raigad"],
"402125":[212,395,0.0,"PCTS Nagothane, Raigad"],
"402126":[212,336,0.0,"Ainghar, Raigad"],
"402201":[286,461,0.0,"Alibag, Raigad"],
"402202":[281,461,0.0,"Borlimandla, Raigad"],
"402203":[280,423,0.0,"Agrav, Raigad"],
"402204":[284,452,0.0,"Akshi, Raigad"],
"402207":[284,487,0.0,"Thal SO RaigarhMH, Raigad"],
"402208":[284,488,0.0,"Chondhi, Raigad"],
"402209":[286,453,0.0,"Kamarle, Raigad"],
"402301":[178,281,0.0,"Chandhave Budruk, Raigad"],
"402302":[178,247,0.0,"Dahivad, Raigad"],
"402303":[126,195,0.0,"Golegani, Raigad"],
"402304":[212,389,0.0,"Devkanhe, Raigad"],
"402305":[189,301,0.0,"Konzar, Raigad"],
"402306":[118,179,0.0,"Mazeri, Raigad"],
"402307":[150,206,0.0,"Ambavade, Raigad"],
"402308":[220,302,0.0,"Kudli, Raigad"],
"402309":[178,273,0.0,"Kamble Tarfe Mahad, Raigad"],
"402401":[250,463,0.0,"Agardanda, Raigad"],
"402402":[314,692,0.0,"Kudgaon, Raigad"],
"402403":[72,142,0.0,"Sarve, Raigad"],
"402404":[72,134,0.0,"Bharadkhol, Raigad"],
"403001":[55,171,0.0,"Panaji, North Goa"],
"403002":[60,177,0.0,"Caranzalem, North Goa"],
"403004":[60,184,0.0,"Matri Indian Antartic Station, North Goa"],
"403005":[60,169,0.0,"Santa Cruz, North Goa"],
"403006":[50,158,0.0,"Chimbel, North Goa"],
"403101":[50,174,0.0,"Salvador Do Mundo, North Goa"],
"403102":[47,173,0.0,"Chorao, North Goa"],
"403103":[46,118,0.0,"Tarvalem, South Goa"],
"403104":[60,159,0.0,"Mandur, North Goa"],
"403105":[35,144,0.0,"Velguem, North Goa"],
"403106":[35,146,0.0,"Sant Estevam, North Goa"],
"403107":[36,157,0.0,"Cumbharjua, North Goa"],
"403108":[55,161,0.0,"Siridao, North Goa"],
"403109":[67,186,0.0,"N B Verem, North Goa"],
"403110":[45,164,0.0,"Carambolim, North Goa"],
"403114":[67,184,0.0,"Pilerne, North Goa"],
"403115":[38,155,0.0,"Cundaim, South Goa"],
"403201":[55,157,0.0,"Bambolim Camp, North Goa"],
"403202":[55,168,0.0,"Bambolim Complex, North Goa"],
"403203":[55,161,0.0,"Pilar S.O (North Goa), North Goa"],
"403204":[60,154,0.0,"St. Lourence, North Goa"],
"403206":[60,182,0.0,"Goa University, North Goa"],
"403401":[51,146,0.0,"Bandora, South Goa"],
"403402":[45,182,0.0,"Velha goa, North Goa"],
"403403":[47,165,0.0,"Piedade, North Goa"],
"403404":[43,142,0.0,"Marcaim, South Goa"],
"403406":[36,117,0.0,"Darbandora, South Goa"],
"403409":[48,144,0.0,"Betora I.E., South Goa"],
"403410":[30,42,0.0,"Mollem, South Goa"],
"403501":[50,177,0.0,"Porvorim, North Goa"],
"403502":[50,159,0.0,"Sirsaim, North Goa"],
"403503":[45,143,0.0,"Ibrampur, North Goa"],
"403504":[35,146,0.0,"Mauliguem, North Goa"],
"403505":[35,139,0.0,"Morlem, North Goa"],
"403506":[38,134,0.0,"Sanvordem, North Goa"],
"403507":[50,178,0.0,"Moira, North Goa"],
"403508":[49,165,0.0,"Nachinola, North Goa"],
"403509":[52,184,0.0,"Caisua, North Goa"],
"403510":[50,175,0.0,"Canca, North Goa"],
"403511":[60,210,0.0,"Sem Saligao, North Goa"],
"403512":[55,152,0.0,"Corgao, North Goa"],
"403513":[50,193,0.0,"Dhargalim, North Goa"],
"403515":[60,206,0.0,"Saipem, North Goa"],
"403516":[60,228,0.0,"Arpora, North Goa"],
"403517":[55,173,0.0,"Parxem, North Goa"],
"403521":[50,175,0.0,"Secretariat S.O (North Goa), North Goa"],
"403522":[50,175,0.0,"Secretariat S.O (North Goa), North Goa"],
"403523":[49,168,0.0,"Calvim, North Goa"],
"403524":[62,126,0.0,"Querim, North Goa"],
"403525":[50,167,0.0,"Goa High Court, North Goa"],
"403526":[50,167,0.0,"Tivim Ie, North Goa"],
"403527":[65,148,0.0,"Morjim, North Goa"],
"403529":[35,144,0.0,"Bicholim Industrial Estate, North Goa"],
"403530":[38,137,0.0,"Pissurlem, North Goa"],
"403601":[46,98,0.0,"Margao, South Goa"],
"403602":[48,111,0.0,"Fatorda, South Goa"],
"403701":[45,84,0.0,"Assolna, South Goa"],
"403702":[56,177,0.0,"Bhatpal, South Goa"],
"403703":[48,105,0.0,"Balli, South Goa"],
"403704":[32,91,0.0,"Bati, South Goa"],
"403705":[35,105,0.0,"Avedem, South Goa"],
"403706":[35,106,0.0,"Panchwadi, South Goa"],
"403707":[46,81,0.0,"Talaulim, South Goa"],
"403708":[46,99,0.0,"Seraulim, South Goa"],
"403709":[45,112,0.0,"Macazana, South Goa"],
"403710":[65,156,0.0,"Thana, South Goa"],
"403711":[60,182,0.0,"Chicalim, South Goa"],
"403712":[55,145,0.0,"Cansaulim, South Goa"],
"403713":[57,115,0.0,"Utorda, South Goa"],
"403714":[45,106,0.0,"Cavorim, South Goa"],
"403715":[46,95,0.0,"Chinchinim, South Goa"],
"403716":[46,99,0.0,"Benaulim, South Goa"],
"403717":[45,86,0.0,"Carmona, South Goa"],
"403718":[50,128,0.0,"Camurlim, South Goa"],
"403719":[46,117,0.0,"Sem rachol Soso, South Goa"],
"403720":[48,118,0.0,"Raia, South Goa"],
"403721":[46,90,0.0,"Varca, South Goa"],
"403722":[53,138,0.0,"Verna, South Goa"],
"403723":[45,92,0.0,"Ambelim, South Goa"],
"403724":[46,89,0.0,"Orlim, South Goa"],
"403725":[45,98,0.0,"Dramapur, South Goa"],
"403726":[65,163,0.0,"Zuarinagar, South Goa"],
"403728":[59,170,0.0,"Loliem Polem, South Goa"],
"403729":[45,97,0.0,"Navelim Camp, South Goa"],
"403731":[45,73,0.0,"Cavelossim, South Goa"],
"403801":[55,179,0.0,"A.P.Dabolim, South Goa"],
"403802":[70,188,0.0,"Mangor Hill, South Goa"],
"403803":[67,173,0.0,"Mormugao, South Goa"],
"403804":[67,173,0.0,"Sada, South Goa"],
"403806":[57,171,0.0,"Bogmalo, South Goa"],
"410101":[252,383,0.0,"Baliware, Raigad"],
"410102":[264,386,0.0,"Matheran, Raigad"],
"410201":[252,377,0.0,"Kondivade, Raigad"],
"410202":[147,211,0.0,"Savroli, Raigad"],
"410203":[176,233,0.0,"Khambewadi, Raigad"],
"410204":[147,232,0.0,"Khopoli Power House, Raigad"],
"410205":[216,364,0.0,"Mahagaon, Raigad"],
"410206":[240,347,0.0,"Panvel, Raigad"],
"410207":[240,347,0.0,"Apta, Raigad"],
"410208":[252,445,0.0,"Koynavale, Raigad"],
"410209":[264,432,0.0,"KAMOTHE, Raigad"],
"410210":[240,371,0.0,"Kharghar, Raigad"],
"410216":[176,255,0.0,"Jagdish Nagar, Raigad"],
"410218":[264,438,0.0,"Kalamboli Node, Raigad"],
"410220":[256,470,0.0,"Mazgaon, Raigad"],
"410221":[240,368,0.0,"Shirdhon, Raigad"],
"410222":[240,300,0.0,"Mohopada, Raigad"],
"410301":[147,242,0.0,"Khandala, Pune"],
"410302":[147,248,0.0,"R P T S Khandala, Pune"],
"410401":[201,284,0.0,"Udhewadi, Pune"],
"410402":[147,240,0.0,"Kurwande, Pune"],
"410403":[205,278,0.0,"Kaivalyadham, Pune"],
"410405":[296,415,0.0,"Karanjgaon, Pune"],
"410406":[205,293,0.0,"Shivali, Pune"],
"410501":[234,532,0.0,"Bhose, Pune"],
"410502":[315,514,0.0,"Aptale, Pune"],
"410503":[280,623,0.0,"Vadgaon Kashimbeg, Pune"],
"410504":[290,516,0.0,"Hivare BK, Pune"],
"410505":[260,397,0.0,"Amboli, Pune"],
"410506":[311,438,0.0,"Chandkhed, Pune"],
"410507":[326,444,0.0,"Umbre Navlakh, Pune"],
"410508":[324,601,0.0,"Dhamani, Pune"],
"410509":[270,389,0.0,"Phulawade, Pune"],
"410510":[330,611,0.0,"Savindane, Pune"],
"410511":[295,536,0.0,"Kuran, Pune"],
"410512":[256,479,0.0,"Karegaon, Pune"],
"410513":[311,490,0.0,"Tiwai Hills, Pune"],
"410515":[280,595,0.0,"Chas, Pune"],
"410516":[313,550,0.0,"Gangapur KH, Pune"],
"410517":[277,636,0.0,"Pargaon Tarfe Ala, Pune"],
"411001":[265,449,0.0,"Pune, Pune"],
"411002":[269,443,0.0,"Pune City, Pune"],
"411003":[250,439,0.0,"Ammunition Factory Khadki, Pune"],
"411004":[265,434,0.0,"A.R. Shala, Pune"],
"411005":[265,446,0.0,"Shivajinagar, Pune"],
"411006":[265,467,0.0,"Yerwada, Pune"],
"411007":[265,427,0.0,"Ganeshkhind, Pune"],
"411008":[265,430,0.0,"N.C.L. Pune, Pune"],
"411009":[269,436,0.0,"Parvati, Pune"],
"411011":[265,453,0.0,"Rasta Peth, Pune"],
"411012":[250,425,0.0,"Dapodi Bazar, Pune"],
"411013":[270,471,0.0,"Hadpsar I.E., Pune"],
"411014":[292,506,0.0,"9 DRD, Pune"],
"411015":[265,454,0.0,"Dhanori, Pune"],
"411016":[265,441,0.0,"Shivaji Housing Society, Pune"],
"411017":[259,387,0.0,"Kalewadi, Pune"],
"411018":[265,427,0.0,"Masulkar Colony, Pune"],
"411019":[265,418,0.0,"M.Phulenagar, Pune"],
"411020":[265,426,0.0,"Botanical Garden S.O (Pune), Pune"],
"411021":[265,424,0.0,"Sus, Pune"],
"411022":[265,446,0.0,"Srpf, Pune"],
"411023":[273,409,0.0,"Kudje, Pune"],
"411024":[295,422,0.0,"Khadakwasla R.S., Pune"],
"411025":[250,308,0.0,"Khanapur Haveli, Pune"],
"411026":[265,436,0.0,"Bhosari I.E., Pune"],
"411027":[265,419,0.0,"Sangavi, Pune"],
"411028":[270,471,0.0,"Gondhale Nagar, Pune"],
"411030":[269,443,0.0,"Narayan Peth, Pune"],
"411031":[250,426,0.0,"C M E, Pune"],
"411032":[265,483,0.0,"Airport S.O (Pune), Pune"],
"411033":[250,392,0.0,"Punawale, Pune"],
"411034":[250,420,0.0,"Kasarwadi, Pune"],
"411035":[265,416,0.0,"Akurdi, Pune"],
"411036":[292,508,0.0,"Mundhva, Pune"],
"411037":[265,448,0.0,"Salisbury Park, Pune"],
"411038":[265,425,0.0,"Bhusari Colony, Pune"],
"411039":[250,421,0.0,"Bhosarigoan, Pune"],
"411040":[265,448,0.0,"Wanowarie, Pune"],
"411041":[269,431,0.0,"Vadgaon Budruk, Pune"],
"411042":[269,438,0.0,"Guruwar Peth, Pune"],
"411043":[295,436,0.0,"Dhankawadi, Pune"],
"411044":[234,427,0.0,"Yamunanagar, Pune"],
"411045":[265,409,0.0,"N.I.A., Pune"],
"411046":[318,455,0.0,"Katraj, Pune"],
"411047":[320,651,0.0,"Vadgaon Shinde, Pune"],
"411048":[269,426,0.0,"Kondhwa KH, Pune"],
"411051":[269,429,0.0,"Anandnagar S.O (Pune), Pune"],
"411052":[269,430,0.0,"Karvenagar, Pune"],
"411057":[485,1252,0.61,"Wakad, Pune"],
"411058":[273,418,0.0,"Warje, Pune"],
"411060":[269,420,0.0,"Mohamadwadi, Pune"],
"411061":[265,416,0.0,"Pimple Gurav, Pune"],
"411062":[250,423,0.0,"Talawade, Pune"],
"411067":[265,422,0.0,"Aundh S.O (Pune), Pune"],
"411068":[273,414,0.0,"Nanded S.O (Pune), Pune"],
"411069":[265,415,0.0,"Baner DSO (Pune), Pune"],
"411070":[265,449,0.0,"Moshi, Pune"],
"411071":[265,408,0.0,"Bavdhan, Pune"],
"411073":[295,434,0.0,"Ambegaon Bk D, Pune"],
"411074":[265,428,0.0,"Ganeshkhind, Pune"],
"411075":[265,446,0.0,"Shivajinagar, Pune"],
"411076":[269,436,0.0,"Parvati, Pune"],
"411077":[265,402,0.0,"M.Phulenagar, Pune"],
"411078":[265,429,0.0,"Masulkar Colony, Pune"],
"411079":[265,470,0.0,"Yerwada, Pune"],
"411080":[270,471,0.0,"Hadpsar I.E., Pune"],
"411081":[292,498,0.0,"Charholi, Pune"],
"412101":[288,426,0.0,"Ravet, Pune"],
"412102":[368,919,0.0,"Khandobachi Wadi, Pune"],
"412103":[326,664,0.0,"Korhale BK, Pune"],
"412104":[314,515,0.0,"Malshiras, Pune"],
"412105":[265,507,0.0,"Solu, Pune"],
"412106":[303,417,0.0,"Bhoyare, Pune"],
"412107":[218,306,0.0,"Kadve, Pune"],
"412108":[155,205,0.0,"Bhadas, Pune"],
"412109":[307,451,0.0,"Sadumbre, Pune"],
"412110":[318,675,0.0,"Kolwadi, Pune"],
"412112":[185,265,0.0,"Mugaon, Pune"],
"412115":[246,349,0.0,"Sangrun, Pune"],
"412201":[296,494,0.0,"Alandi Chorachi, Pune"],
"412202":[296,622,0.0,"Koregaon Mul, Pune"],
"412203":[342,726,0.0,"Galandwadi, Pune"],
"412204":[334,692,0.0,"Babhurdi, Pune"],
"412205":[296,417,0.0,"Khed Shivapur, Pune"],
"412206":[370,444,0.0,"Ambeghar, Pune"],
"412207":[283,543,0.0,"Dahitane, Pune"],
"412208":[378,657,0.0,"Dhanore, Pune"],
"412209":[457,679,0.0,"Bhamburde, Pune"],
"412210":[641,665,0.0,"Inamgaon, Pune"],
"412211":[429,615,0.0,"Sadalgaon, Pune"],
"412212":[185,323,0.0,"Kodapur, Pune"],
"412213":[318,412,0.0,"Kurungwadi, Pune"],
"412214":[274,589,0.0,"Kasurdi, Pune"],
"412215":[385,820,0.0,"Kadethan, Pune"],
"412216":[380,1014,0.0,"Fulgaon, Pune"],
"412218":[424,614,0.0,"Amdabad, Pune"],
"412219":[384,815,0.0,"Roti, Pune"],
"412220":[402,656,0.0,"Karegaon, Pune"],
"412301":[270,396,0.0,"Bhivari, Pune"],
"412303":[304,510,0.0,"Belsar, Pune"],
"412304":[323,684,0.0,"Murti Modhave, Pune"],
"412305":[275,642,0.0,"Harni, Pune"],
"412306":[368,759,0.0,"Karanje, Pune"],
"412307":[283,484,0.0,"Manjari BK, Pune"],
"412308":[270,399,0.0,"Uruli Devachi, Pune"],
"412311":[275,497,0.0,"Dawanewadi, Pune"],
"412312":[270,652,0.0,"Tondal, Pune"],
"412401":[272,398,0.0,"Gunjalwadi, Pune"],
"412402":[308,493,0.0,"Kharoshi, Pune"],
"412403":[407,709,0.0,"Dhamari, Pune"],
"412404":[311,487,0.0,"Washere, Pune"],
"412405":[285,512,0.0,"Gawadewadi, Pune"],
"412406":[424,775,0.0,"Pargaon Tarfe Avasari, Pune"],
"412408":[260,555,0.0,"Amondi, Pune"],
"412409":[290,435,0.0,"Chilewadi, Pune"],
"412410":[265,412,0.0,"Sakori Tarfe Belha, Pune"],
"412411":[265,407,0.0,"Alephata, Pune"],
"412412":[424,797,0.0,"Kolvadi, Pune"],
"412801":[310,552,0.0,"Wing (Shirwal), Satara"],
"412802":[368,959,0.0,"Dhawad Wadi, Satara"],
"412803":[312,484,0.0,"Bopardi, Satara"],
"412804":[358,498,0.0,"Kanur, Satara"],
"412805":[235,297,0.0,"Bhilar, Satara"],
"412806":[74,132,0.0,"Birwadi, Satara"],
"413001":[585,967,0.0,"Solapur, Solapur"],
"413002":[585,921,0.0,"Musti, Solapur"],
"413003":[585,991,0.0,"Sadar Bazar S.O (Solapur), Solapur"],
"413004":[538,917,0.0,"Jule Solapur, Solapur"],
"413005":[585,989,0.0,"Market Yard Solapur, Solapur"],
"413006":[500,949,0.0,"Kumbhari, Solapur"],
"413007":[585,957,0.0,"Solapur City, Solapur"],
"413008":[605,979,0.0,"Takali, Solapur"],
"413101":[429,469,0.0,"Sangramnagar, Solapur"],
"413102":[248,251,0.0,"Baramati, Pune"],
"413103":[429,-1,0.0,"Sarati, Pune"],
"413104":[230,327,0.0,"Bori, Pune"],
"413105":[466,674,0.0,"Kalas, Pune"],
"413106":[345,636,0.0,"Hingangaon, Pune"],
"413107":[460,511,0.0,"Medad, Solapur"],
"413108":[474,794,0.0,"Tambave, Solapur"],
"413109":[266,795,0.0,"Gursale, Solapur"],
"413110":[248,-1,0.0,"Mudhale, Pune"],
"413111":[435,-1,0.0,"Girvi, Solapur"],
"413112":[554,931,0.0,"Borgaon, Solapur"],
"413113":[278,613,0.0,"Khandali, Solapur"],
"413114":[289,-1,0.0,"Kalamb, Pune"],
"413115":[366,402,0.0,"Malegaon IRR Colony, Pune"],
"413116":[284,569,0.0,"Khandaj, Pune"],
"413118":[449,-1,0.0,"Yeshwantnagar S.O (Solapur), Solapur"],
"413120":[345,634,0.0,"Kati, Pune"],
"413130":[361,476,0.0,"Chincholi, Pune"],
"413132":[343,439,0.0,"Dalaj, Pune"],
"413133":[239,262,0.0,"Katfal, Pune"],
"413201":[352,679,0.0,"Arangaon, Ahmednagar"],
"413202":[275,997,0.0,"Chikhalthan, Solapur"],
"413203":[355,825,0.0,"Jinti, Solapur"],
"413204":[250,276,0.0,"Dighol, Ahmednagar"],
"413205":[630,818,0.0,"Chondi, Ahmednagar"],
"413206":[339,648,0.0,"Washimbe, Solapur"],
"413207":[292,492,0.0,"Chikhali, Beed"],
"413208":[859,1571,0.0,"Dhavlas, Solapur"],
"413209":[976,1391,0.0,"Darfal, Solapur"],
"413210":[377,733,0.0,"Dahiwali, Solapur"],
"413211":[586,864,0.0,"Kanhapuri, Solapur"],
"413212":[455,794,0.0,"Adhegaon, Solapur"],
"413213":[465,850,0.0,"Narkhed, Solapur"],
"413214":[670,991,0.0,"Bitle, Solapur"],
"413215":[595,945,0.0,"Hotgigaon, Solapur"],
"413216":[532,595,0.0,"Sangvi Budruk, Solapur"],
"413217":[532,595,0.0,"Torni, Solapur"],
"413218":[384,798,0.0,"Bhurikavathe, Solapur"],
"413219":[532,595,0.0,"Ankalge, Solapur"],
"413220":[532,595,0.0,"Ruddewadi, Solapur"],
"413221":[713,1453,0.0,"Malkavathe, Solapur"],
"413222":[355,682,0.0,"Darfalbibi, Solapur"],
"413223":[335,726,0.0,"Wadshivane, Solapur"],
"413224":[585,1006,0.0,"Kumathe, Solapur"],
"413226":[532,595,0.0,"Barhanpur, Solapur"],
"413227":[445,651,0.0,"Gaudgaon, Solapur"],
"413228":[512,696,0.0,"Karjal, Solapur"],
"413229":[308,488,0.0,"Jatnandur, Beed"],
"413248":[465,828,0.0,"Aundhi, Solapur"],
"413249":[286,561,0.0,"Rakshas Bhuwan Tamba, Beed"],
"413250":[960,1537,0.0,"Tandulwadi, Solapur"],
"413251":[335,913,0.0,"Varkute, Solapur"],
"413252":[418,1255,0.0,"Barloni, Solapur"],
"413253":[465,828,0.0,"Virvade, Solapur"],
"413255":[384,798,0.0,"Kegaon, Solapur"],
"413301":[595,1107,0.0,"Bavi, Solapur"],
"413302":[595,811,0.0,"Bardi, Solapur"],
"413303":[630,1005,0.0,"Ashti S.O (Solapur), Solapur"],
"413304":[956,1385,0.0,"Pandharpur, Solapur"],
"413305":[282,890,0.0,"Andhalgaon, Solapur"],
"413306":[412,876,0.0,"Katphal, Solapur"],
"413307":[403,813,0.0,"Ekhatpur, Solapur"],
"413308":[429,964,0.0,"Chopadi, Solapur"],
"413309":[403,689,0.0,"Alegaon, Solapur"],
"413310":[418,962,0.0,"Bhalwani, Solapur"],
"413314":[418,983,0.0,"Gaudwadi, Solapur"],
"413315":[956,1223,0.0,"Hole, Solapur"],
"413317":[423,611,0.0,"Dhyati (E), Solapur"],
"413319":[247,697,0.0,"Bhalvani, Solapur"],
"413322":[282,842,0.0,"Nimboni, Solapur"],
"413324":[335,863,0.0,"Deodi, Solapur"],
"413401":[507,630,0.0,"Kuslumb, Solapur"],
"413402":[435,636,0.0,"Raleras, Solapur"],
"413403":[153,363,-1,"Sakat, Solapur"],
"413404":[303,513,0.0,"Pandhari, Solapur"],
"413405":[443,768,0.0,"Ghatangri, Osmanabad"],
"413406":[550,778,0.0,"Ratanjan, Solapur"],
"413409":[253,464,0.0,"Umbarge, Solapur"],
"413410":[702,1065,0.0,"Degaon ( Valuj ), Solapur"],
"413411":[479,548,0.0,"K.V.Nagar Barshi, Solapur"],
"413412":[595,899,0.0,"Mouje Tadvale, Solapur"],
"413501":[441,608,0.0,"Osmanabad, Osmanabad"],
"413502":[418,468,0.0,"Ida Pida, Osmanabad"],
"413503":[441,608,0.0,"Kunthalgiri, Osmanabad"],
"413504":[278,-1,0.0,"Hadongri, Osmanabad"],
"413505":[441,608,0.0,"Domgaon, Osmanabad"],
"413506":[443,768,0.0,"Takviki, Osmanabad"],
"413507":[155,475,0.0,"Khamaswadi, Osmanabad"],
"413508":[441,632,0.0,"Tugaon, Osmanabad"],
"413509":[443,741,0.0,"Nitali, Osmanabad"],
"413510":[475,969,0.0,"Nipani, Osmanabad"],
"413511":[472,530,0.0,"Tandulja, Latur"],
"413512":[475,934,0.0,"Latur, Latur"],
"413513":[326,576,0.0,"Chapoli, Latur"],
"413514":[641,665,0.0,"Chera, Latur"],
"413515":[413,706,0.0,"Ganga Hipparga, Latur"],
"413516":[283,412,0.0,"Chincholi Tapse, Latur"],
"413517":[372,666,0.0,"Daithana, Latur"],
"413518":[293,675,0.0,"Gudsur, Latur"],
"413519":[324,816,0.0,"Chavani Hipperga, Latur"],
"413520":[449,729,0.0,"Bhada, Latur"],
"413521":[541,656,0.0,"Hadga, Latur"],
"413522":[540,640,0.0,"Sawari, Latur"],
"413523":[413,706,0.0,"Chikhali, Latur"],
"413524":[380,572,0.0,"Sindala Shivpur, Latur"],
"413525":[155,475,0.0,"Gour, Osmanabad"],
"413526":[278,-1,0.0,"Hatola, Osmanabad"],
"413527":[384,798,0.0,"Gharsoli, Latur"],
"413528":[155,475,0.0,"Awad Shirpura, Osmanabad"],
"413529":[365,533,0.0,"Janwal, Latur"],
"413530":[540,640,0.0,"Lambota, Latur"],
"413531":[490,890,0.0,"Babhalgaon, Latur"],
"413532":[384,798,0.0,"Ravankola, Latur"],
"413534":[250,324,0.0,"Pakhrud, Osmanabad"],
"413544":[641,665,0.0,"Halki, Latur"],
"413581":[380,572,0.0,"Devangra, Latur"],
"413582":[443,713,0.0,"Mendha, Osmanabad"],
"413601":[325,619,0.0,"Barul, Osmanabad"],
"413602":[450,521,0.0,"Morta, Osmanabad"],
"413603":[325,618,0.0,"Katgaon, Osmanabad"],
"413604":[380,618,0.0,"Kaldeo Nimbala, Osmanabad"],
"413605":[326,603,0.0,"Chincholi Bhuyar, Osmanabad"],
"413606":[326,615,0.0,"Diggi, Osmanabad"],
"413607":[541,656,0.0,"Badur, Latur"],
"413608":[418,1034,0.0,"Kanegaon, Osmanabad"],
"413623":[355,1045,0.0,"Sangvi Kati, Osmanabad"],
"413624":[325,618,0.0,"Sawargaon Kati, Osmanabad"],
"413625":[265,680,0.0,"Itkur, Osmanabad"],
"413626":[253,329,0.0,"Terkheda, Osmanabad"],
"413701":[567,621,0.0,"Adhalgaon, Ahmednagar"],
"413702":[476,662,0.0,"Ukkadgaon, Ahmednagar"],
"413703":[485,900,0.0,"Ranjangaon, Ahmednagar"],
"413704":[190,423,0.0,"Dhamori, Ahmednagar"],
"413705":[383,742,0.0,"Aradgaon, Ahmednagar"],
"413706":[363,517,0.0,"Kolewadi, Ahmednagar"],
"413707":[429,572,0.0,"Puntamba, Ahmednagar"],
"413708":[370,614,0.0,"Bhojade, Ahmednagar"],
"413709":[449,614,0.0,"Shrirampur, Ahmednagar"],
"413710":[284,514,0.0,"Chincholi Bk, Ahmednagar"],
"413711":[341,548,0.0,"Nimbhere, Ahmednagar"],
"413712":[284,483,0.0,"Lohgaon, Ahmednagar"],
"413713":[284,424,0.0,"Loni Kd, Ahmednagar"],
"413714":[284,584,0.0,"Nimgaon Jali, Ahmednagar"],
"413715":[302,598,0.0,"Ambi, Ahmednagar"],
"413716":[465,651,0.0,"Taklimiya, Ahmednagar"],
"413717":[316,686,0.0,"Matapur, Ahmednagar"],
"413718":[493,673,0.0,"Undirgaon, Ahmednagar"],
"413719":[284,536,0.0,"Ekrukhe, Ahmednagar"],
"413720":[302,587,0.0,"Khandala Nandur, Ahmednagar"],
"413721":[316,713,0.0,"Pathare Kd, Ahmednagar"],
"413722":[302,558,0.0,"Mulanagar, Ahmednagar"],
"413723":[439,598,0.0,"Chitali, Ahmednagar"],
"413725":[392,793,0.0,"Ghogargaon, Ahmednagar"],
"413726":[486,681,0.0,"Vangdari, Ahmednagar"],
"413728":[498,850,0.0,"Ghotvi, Ahmednagar"],
"413736":[284,531,0.0,"Gogalgaon, Ahmednagar"],
"413737":[284,503,0.0,"Rajuri, Ahmednagar"],
"413738":[332,554,0.0,"Panodi, Ahmednagar"],
"413739":[665,-1,0.0,"Bhamathan, Ahmednagar"],
"413801":[538,660,0.0,"Alegaon, Pune"],
"413802":[427,684,0.0,"Kurkumbh, Pune"],
"414001":[340,-1,0.0,"Ahmednagar, Ahmednagar"],
"414002":[230,374,0.0,"Mehekari, Ahmednagar"],
"414003":[230,339,0.0,"Savedi Road, Ahmednagar"],
"414005":[230,282,0.0,"Chas, Ahmednagar"],
"414006":[357,379,0.0,"Baburdi Ghumat, Ahmednagar"],
"414101":[541,1057,0.0,"Pisorekhand, Ahmednagar"],
"414102":[342,687,0.0,"Koradgaon, Ahmednagar"],
"414103":[451,477,0.0,"Daithane Gunjal, Ahmednagar"],
"414105":[190,512,0.0,"Umbra, Ahmednagar"],
"414106":[256,597,0.0,"Devrai, Ahmednagar"],
"414110":[206,351,0.0,"MIRC, Ahmednagar"],
"414111":[206,351,0.0,"Dehere, Ahmednagar"],
"414113":[417,433,0.0,"Munguswade, Ahmednagar"],
"414201":[357,465,0.0,"Narayan Doho, Ahmednagar"],
"414202":[357,713,0.0,"Dhanora, Beed"],
"414203":[266,756,0.0,"Chikhali, Beed"],
"414204":[349,691,0.0,"Domri, Beed"],
"414205":[295,777,0.0,"Belura, Beed"],
"414208":[266,890,0.0,"Khilad, Beed"],
"414301":[458,637,0.0,"Hanga, Ahmednagar"],
"414302":[461,612,0.0,"Loni Haveli, Ahmednagar"],
"414303":[292,518,0.0,"Karandi, Ahmednagar"],
"414304":[268,489,0.0,"Khadakwadi, Ahmednagar"],
"414305":[259,460,0.0,"Kalas, Ahmednagar"],
"414306":[398,614,0.0,"Vadner BK, Ahmednagar"],
"414401":[429,602,0.0,"Dighi, Ahmednagar"],
"414402":[265,-1,0.0,"Alsunde, Ahmednagar"],
"414403":[356,574,0.0,"Baradgaon Sudrik, Ahmednagar"],
"414501":[301,547,0.0,"Khospuri, Ahmednagar"],
"414502":[271,553,0.0,"Hasnapur, Ahmednagar"],
"414503":[369,882,0.0,"Hatgaon, Ahmednagar"],
"414504":[300,405,0.0,"Shekte, Ahmednagar"],
"414505":[430,556,0.0,"Jawkhede Khalsa, Ahmednagar"],
"414601":[301,501,0.0,"Shendi, Ahmednagar"],
"414602":[209,695,0.0,"Kharwandi, Ahmednagar"],
"414603":[402,578,0.0,"Nevasa Bk, Ahmednagar"],
"414604":[375,694,0.0,"Georai, Ahmednagar"],
"414605":[365,595,0.0,"Bhende SK, Ahmednagar"],
"414606":[185,478,0.0,"Kauthe, Ahmednagar"],
"414607":[291,459,0.0,"Lohgaon, Ahmednagar"],
"414609":[306,531,0.0,"Usthal Dumala, Ahmednagar"],
"414701":[576,630,0.0,"Chimbhale, Ahmednagar"],
"415001":[250,456,0.0,"Satara, Satara"],
"415002":[250,427,0.0,"Bamanoli, Satara"],
"415003":[250,434,0.0,"Kshetra Mahuli, Satara"],
"415004":[251,427,0.0,"Chinchaner Vandan, Satara"],
"415010":[228,526,0.0,"Bhaktawadi, Satara"],
"415011":[251,397,0.0,"Ambavade S Wagholi, Satara"],
"415012":[253,478,0.0,"Alewadi, Satara"],
"415013":[250,453,0.0,"Ambawade, Satara"],
"415014":[220,294,0.0,"Ambale, Satara"],
"415015":[250,405,0.0,"Nagewadi, Satara"],
"415019":[287,528,0.0,"Kameri, Satara"],
"415020":[204,429,0.0,"Kharshi, Satara"],
"415021":[227,551,0.0,"Chanchali, Satara"],
"415022":[204,367,0.0,"Bhanang, Satara"],
"415023":[290,611,0.0,"Nidhal, Satara"],
"415101":[94,177,0.0,"Ainwadi, Kolhapur"],
"415102":[240,502,0.0,"Morale, Satara"],
"415103":[231,345,0.0,"Talmavale, Satara"],
"415104":[329,446,0.0,"Dhondewadi, Satara"],
"415105":[275,475,0.0,"Karavadi, Satara"],
"415106":[223,459,0.0,"Chikhali(Masur), Satara"],
"415107":[280,557,0.0,"Nandgaon, Satara"],
"415108":[250,431,0.0,"Rethare BK, Satara"],
"415109":[183,366,0.0,"Marali(Chore), Satara"],
"415110":[208,387,0.0,"Karad, Satara"],
"415111":[208,386,0.0,"Ghogaon, Satara"],
"415112":[212,312,0.0,"Banpuri, Satara"],
"415114":[183,356,0.0,"Sakurdi, Satara"],
"415115":[208,393,0.0,"Vadoli Nileshwar, Satara"],
"415116":[280,605,0.0,"Arvi, Satara"],
"415122":[370,463,0.0,"Yeravale, Satara"],
"415124":[208,391,0.0,"Parle, Satara"],
"415202":[115,163,0.0,"Pimploli, Ratnagiri"],
"415203":[115,147,0.0,"Dhutroli, Ratnagiri"],
"415205":[220,310,0.0,"Adul, Satara"],
"415206":[220,294,0.0,"Marul, Satara"],
"415207":[220,294,0.0,"Helwak, Satara"],
"415208":[115,145,0.0,"Velas, Ratnagiri"],
"415209":[220,298,0.0,"Garwade, Satara"],
"415211":[214,303,0.0,"Marali, Satara"],
"415212":[240,508,0.0,"Marul Haveli, Satara"],
"415213":[124,181,0.0,"Chimbhave, Raigad"],
"415214":[89,162,0.0,"Peve, Ratnagiri"],
"415301":[361,1650,0.0,"Kautholi, Sangli"],
"415302":[231,480,0.0,"Bichud, Sangli"],
"415303":[224,390,0.0,"Ramapur, Sangli"],
"415304":[258,482,0.0,"Shalgaon, Sangli"],
"415305":[241,475,0.0,"Hingangaon Bk, Sangli"],
"415306":[340,1130,0.0,"Gomewadi, Sangli"],
"415307":[277,592,0.0,"Sultangade, Sangli"],
"415308":[340,1206,0.0,"Ghanand, Sangli"],
"415309":[277,585,0.0,"Bhood, Sangli"],
"415310":[277,585,0.0,"Bhendavade, Sangli"],
"415311":[290,588,0.0,"Dhavaleshwar, Sangli"],
"415312":[310,748,0.0,"Pachvad, Satara"],
"415313":[209,462,0.0,"Tupari, Sangli"],
"415315":[382,1100,0.0,"Lingiware, Sangli"],
"415401":[328,581,0.0,"Karve, Sangli"],
"415402":[212,367,0.0,"Mangrul, Sangli"],
"415403":[245,424,0.0,"Itkare, Sangli"],
"415404":[178,264,0.0,"Tambave, Sangli"],
"415405":[240,361,0.0,"Chincholi, Sangli"],
"415406":[340,655,0.0,"Kalamwadi, Sangli"],
"415407":[325,696,0.0,"Red, Sangli"],
"415408":[325,645,0.0,"Kandur, Sangli"],
"415409":[320,577,0.0,"Kapuskhed, Sangli"],
"415410":[329,562,0.0,"Bambavade, Sangli"],
"415411":[398,577,0.0,"Tandulwadi, Sangli"],
"415412":[243,400,0.0,"Devwadi, Sangli"],
"415413":[325,691,0.0,"Masuchiwadi, Sangli"],
"415414":[255,536,0.0,"Sakharale, Sangli"],
"415415":[240,360,0.0,"Sonavade, Sangli"],
"415418":[222,385,0.0,"Mangale S.O., Sangli"],
"415501":[275,625,0.0,"Lhasurne, Satara"],
"415502":[306,637,0.0,"Katgun, Satara"],
"415503":[312,660,0.0,"Kulakjai, Satara"],
"415504":[289,571,0.0,"Mol (Diskal), Satara"],
"415505":[313,660,0.0,"Bhurkawadi, Satara"],
"415506":[240,504,0.0,"Padegaon, Satara"],
"415507":[307,708,0.0,"Yeralwadi, Satara"],
"415508":[285,650,0.0,"Shingnapur, Satara"],
"415509":[339,873,0.0,"Divad, Satara"],
"415510":[253,486,0.0,"Nandoshi, Satara"],
"415511":[323,605,0.0,"Pimpari, Satara"],
"415512":[258,497,0.0,"Vadgaon J.S, Satara"],
"415513":[263,464,0.0,"Asale, Satara"],
"415514":[274,479,0.0,"Bamnoli Tarf Kudal, Satara"],
"415515":[340,548,0.0,"Pande, Satara"],
"415516":[340,550,0.0,"Kavathe, Satara"],
"415517":[340,550,0.0,"Vele, Satara"],
"415518":[252,448,0.0,"Venegaon, Satara"],
"415519":[270,487,0.0,"Saspade, Satara"],
"415520":[220,377,0.0,"Chavanwadi, Satara"],
"415521":[368,975,0.0,"Andori, Satara"],
"415522":[252,451,0.0,"Hol, Satara"],
"415523":[357,1501,0.0,"Girvi, Satara"],
"415524":[340,435,0.0,"Dahigaon, Satara"],
"415525":[284,543,0.0,"Rautwadi, Satara"],
"415526":[370,754,0.0,"Bholi, Satara"],
"415527":[304,632,0.0,"Ambheri, Satara"],
"415528":[369,1021,0.0,"Nandal, Satara"],
"415530":[258,452,0.0,"Jamb (Kikali), Satara"],
"415536":[340,551,0.0,"Gulumb, Satara"],
"415537":[344,625,0.0,"Bibi, Satara"],
"415538":[312,660,0.0,"Chitali, Satara"],
"415539":[208,386,0.0,"Vathar KH, Satara"],
"415540":[300,770,0.0,"Palshi (Man), Satara"],
"415601":[50,87,0.0,"Pophali, Ratnagiri"],
"415602":[60,89,0.0,"Mundhe, Ratnagiri"],
"415603":[61,167,0.0,"Kolke Wadi, Ratnagiri"],
"415604":[65,250,0.0,"Anari, Ratnagiri"],
"415605":[65,250,0.0,"Chiplun, Ratnagiri"],
"415606":[65,250,0.0,"Mandki, Ratnagiri"],
"415607":[61,83,0.0,"Kutra, Ratnagiri"],
"415608":[63,70,0.0,"Aravali, Ratnagiri"],
"415609":[63,69,0.0,"Chikhali, Ratnagiri"],
"415610":[115,242,0.0,"Karbhatale, Ratnagiri"],
"415611":[69,85,0.0,"Golavali, Ratnagiri"],
"415612":[90,213,0.0,"Ratnagiri, Ratnagiri"],
"415613":[48,82,0.0,"Padve, Ratnagiri"],
"415614":[55,83,0.0,"Jaigad, Ratnagiri"],
"415615":[55,95,0.0,"Ganpatipule, Ratnagiri"],
"415616":[88,226,0.0,"Purnagad, Ratnagiri"],
"415617":[58,127,0.0,"Vetoshi, Ratnagiri"],
"415619":[84,153,0.0,"Kapad Gaon, Ratnagiri"],
"415620":[55,104,0.0,"Chafe, Ratnagiri"],
"415621":[59,266,0.0,"Nilavane, Ratnagiri"],
"415626":[70,159,0.0,"Shivar Ambere, Ratnagiri"],
"415628":[130,153,-1,"Donavali, Ratnagiri"],
"415629":[61,81,0.0,"Kasarveli, Ratnagiri"],
"415634":[110,263,0.0,"Anjanvel, Ratnagiri"],
"415635":[80,117,0.0,"Bhambed, Ratnagiri"],
"415637":[52,109,0.0,"Talekante, Ratnagiri"],
"415639":[88,178,0.0,"Niwali, Ratnagiri"],
"415640":[145,252,0.0,"Chinchavali, Ratnagiri"],
"415641":[39,96,0.0,"Pate Pillavali, Ratnagiri"],
"415643":[70,413,0.0,"Shiravali, Ratnagiri"],
"415701":[61,138,0.0,"Bamnoli, Ratnagiri"],
"415702":[46,67,0.0,"Umroli, Ratnagiri"],
"415703":[95,199,0.0,"Pimpar, Ratnagiri"],
"415705":[68,121,0.0,"Adur S.O (Ratnagiri), Ratnagiri"],
"415706":[185,255,0.0,"Oni navase, Ratnagiri"],
"415708":[59,181,0.0,"Ayani, Ratnagiri"],
"415709":[55,598,0.0,"Alsure, Ratnagiri"],
"415710":[42,178,0.0,"Dayal, Ratnagiri"],
"415711":[119,192,0.0,"Bhopan, Ratnagiri"],
"415712":[39,69,0.0,"Chickalgaon, Ratnagiri"],
"415713":[39,72,0.0,"Murud, Ratnagiri"],
"415714":[38,81,0.0,"Adkhaltari, Ratnagiri"],
"415715":[55,63,0.0,"Kulvandi, Ratnagiri"],
"415716":[39,72,0.0,"Mugij, Ratnagiri"],
"415717":[54,87,0.0,"Kelshi, Ratnagiri"],
"415718":[80,119,0.0,"Choravane, Ratnagiri"],
"415719":[89,162,0.0,"Mundhar, Ratnagiri"],
"415720":[38,73,0.0,"Karanjgaon, Ratnagiri"],
"415722":[55,598,0.0,"Songaon, Ratnagiri"],
"415724":[74,118,0.0,"Malan, Ratnagiri"],
"415726":[30,62,0.0,"Masu, Ratnagiri"],
"415727":[94,308,0.0,"Shirshi, Ratnagiri"],
"415728":[48,86,0.0,"Narvan, Ratnagiri"],
"415729":[36,168,0.0,"Sakhari Agar, Ratnagiri"],
"415730":[214,283,0.0,"Kalamani Khurd, Ratnagiri"],
"415801":[80,145,0.0,"Tiware Medhe Tarfe Devale, Ratnagiri"],
"415802":[70,99,0.0,"Korle, Ratnagiri"],
"415803":[55,95,0.0,"Dabhole, Ratnagiri"],
"415804":[75,110,0.0,"Angavali, Ratnagiri"],
"415805":[36,330,0.0,"Dale, Ratnagiri"],
"415806":[36,245,0.0,"Ambolgad, Ratnagiri"],
"415807":[214,283,0.0,"Chafavali, Ratnagiri"],
"416001":[225,297,0.0,"Haldi, Kolhapur"],
"416002":[382,536,0.0,"Shukrawar Peth S.O (Kolhapur), Kolhapur"],
"416003":[315,487,0.0,"Kolhapur, Kolhapur"],
"416004":[298,472,0.0,"Ujalaiwadi, Kolhapur"],
"416005":[298,499,0.0,"Uchgaon, Kolhapur"],
"416006":[298,481,0.0,"Kasba Bavada, Kolhapur"],
"416007":[272,403,0.0,"Kalamba, Kolhapur"],
"416008":[298,469,0.0,"Pratibhanagar, Kolhapur"],
"416010":[315,439,0.0,"Padali Khurd, Kolhapur"],
"416011":[298,403,0.0,"Beed, Kolhapur"],
"416012":[315,450,0.0,"Kolhapur City, Kolhapur"],
"416013":[298,448,0.0,"Pachgaon, Kolhapur"],
"416101":[370,967,0.0,"Danoli, Kolhapur"],
"416102":[363,983,0.0,"Haroli, Kolhapur"],
"416103":[363,1291,0.0,"Ghalwad, Kolhapur"],
"416104":[370,1121,0.0,"Alas, Kolhapur"],
"416105":[307,950,0.0,"Shedshal, Kolhapur"],
"416106":[538,1063,0.0,"Bastwad, Kolhapur"],
"416107":[365,1119,0.0,"Ghosarwad, Kolhapur"],
"416108":[765,1704,-1,"Takaliwadi, Kolhapur"],
"416109":[431,794,0.0,"Alate, Kolhapur"],
"416110":[408,816,0.0,"Narande, Kolhapur"],
"416111":[435,913,0.0,"Kavathesar, Kolhapur"],
"416112":[382,539,0.0,"Chavare, Kolhapur"],
"416113":[218,324,0.0,"June Pargaon, Kolhapur"],
"416114":[222,360,0.0,"Kakhe, Kolhapur"],
"416115":[405,687,0.0,"Ichalkaranji, Kolhapur"],
"416116":[419,732,0.0,"Ganganagar Ichalkaranji, Kolhapur"],
"416118":[370,571,0.0,"Atigre, Kolhapur"],
"416119":[315,537,0.0,"Gadmudshingi, Kolhapur"],
"416120":[357,1140,0.0,"Arjunwad, Kolhapur"],
"416121":[447,849,0.0,"Shirdhon, Kolhapur"],
"416122":[332,535,0.0,"Nagaon, Kolhapur"],
"416138":[418,737,0.0,"Rui, Kolhapur"],
"416143":[432,806,0.0,"Rangoli, Kolhapur"],
"416144":[370,986,0.0,"Akiwate Industrial Estate, Kolhapur"],
"416146":[448,876,0.0,"Yadrav, Kolhapur"],
"416201":[214,-1,0.0,"Ambavade, Kolhapur"],
"416202":[351,534,0.0,"Vasagade, Kolhapur"],
"416203":[332,519,0.0,"Randivewadi, Kolhapur"],
"416204":[175,245,0.0,"Khupire, Kolhapur"],
"416205":[163,179,0.0,"Dhundwade, Kolhapur"],
"416206":[64,71,0.0,"Katali, Kolhapur"],
"416207":[225,319,0.0,"Kavane, Kolhapur"],
"416208":[185,334,0.0,"Arjunwada, Kolhapur"],
"416209":[235,442,0.0,"Barve, Kolhapur"],
"416210":[169,318,0.0,"Mhasrang, Kolhapur"],
"416211":[165,227,0.0,"Durgamanwad, Kolhapur"],
"416212":[105,231,0.0,"Nartavade, Kolhapur"],
"416213":[187,407,0.0,"Charan, Kolhapur"],
"416214":[200,364,0.0,"Kapshi, Kolhapur"],
"416215":[181,294,0.0,"Molawade, Kolhapur"],
"416216":[258,469,0.0,"Gorambe, Kolhapur"],
"416218":[250,476,0.0,"Tamnakwada, Kolhapur"],
"416219":[231,440,0.0,"Malage BK, Kolhapur"],
"416220":[242,486,0.0,"Aralgundi, Kolhapur"],
"416221":[185,305,0.0,"Belawale BK, Kolhapur"],
"416223":[227,446,0.0,"Bhativade, Kolhapur"],
"416229":[315,458,0.0,"Chikhali, Kolhapur"],
"416230":[169,210,0.0,"Nandgaon, Kolhapur"],
"416231":[129,278,0.0,"Panori, Kolhapur"],
"416232":[230,355,0.0,"Shankarwadi, Kolhapur"],
"416234":[298,449,0.0,"Kaneri, Kolhapur"],
"416235":[250,490,0.0,"Banage, Kolhapur"],
"416236":[332,496,0.0,"Yalgud, Kolhapur"],
"416301":[393,704,0.0,"Tung, Sangli"],
"416302":[396,1024,0.0,"Bhadkimbe, Sangli"],
"416303":[435,1102,0.0,"Tavadarwadi, Sangli"],
"416304":[357,1046,0.0,"Kavaji Khotwadi, Sangli"],
"416305":[357,1062,0.0,"Digraj Kasaba Agri School, Sangli"],
"416306":[318,919,0.0,"Kanchanpur, Sangli"],
"416307":[435,1216,0.0,"Kavathe Ekand, Sangli"],
"416308":[255,736,0.0,"Amnapur, Sangli"],
"416309":[240,608,0.0,"Balavadi(Bhalavani), Sangli"],
"416310":[255,781,0.0,"Bambavade, Sangli"],
"416311":[305,582,0.0,"Banur, Sangli"],
"416312":[330,1173,0.0,"Karanje, Sangli"],
"416313":[235,349,0.0,"Nagthane, Sangli"],
"416314":[280,1046,0.0,"Padali, Sangli"],
"416315":[414,821,0.0,"Malwadi, Sangli"],
"416316":[290,979,0.0,"Audumbar, Sangli"],
"416317":[302,578,-1,"Manjarde, Sangli"],
"416401":[307,724,0.0,"Khatav, Sangli"],
"416402":[40,74,0.0,"Baj, Sangli"],
"416403":[273,771,0.0,"Chorochi, Sangli"],
"416404":[448,1173,0.0,"Bevnur, Sangli"],
"416405":[365,603,0.0,"Jakhapur, Sangli"],
"416406":[357,1057,0.0,"Madhavnagar, Sangli"],
"416407":[247,626,0.0,"Dongarwadi, Sangli"],
"416408":[305,665,0.0,"Gavan, Sangli"],
"416409":[332,832,0.0,"Narwad, Sangli"],
"416410":[396,805,0.0,"Miraj, Sangli"],
"416411":[273,739,0.0,"Agran Dhulgaon, Sangli"],
"416412":[394,939,-1,"Ankalagi, Sangli"],
"416413":[182,2057,-1,"Utagi, Sangli"],
"416414":[396,823,0.0,"District Court Sangli, Sangli"],
"416415":[396,979,0.0,"Mouje Digraj, Sangli"],
"416416":[396,1019,0.0,"Sangli, Sangli"],
"416417":[442,998,0.0,"Kavathe Piran, Sangli"],
"416418":[571,1363,0.0,"Shipur, Sangli"],
"416419":[370,990,0.0,"Borgaon, Sangli"],
"416420":[357,917,0.0,"Bhose, Sangli"],
"416429":[588,1161,-1,"Madgyal, Sangli"],
"416436":[357,953,0.0,"Savali B.O., Sangli"],
"416437":[332,773,0.0,"Bolwad, Sangli"],
"416501":[415,508,0.0,"Hitni, Kolhapur"],
"416502":[415,448,0.0,"Gijawane, Kolhapur"],
"416503":[171,340,0.0,"Kolindre, Kolhapur"],
"416504":[98,175,0.0,"Hadalage, Kolhapur"],
"416505":[129,262,0.0,"Madilage, Kolhapur"],
"416506":[247,590,0.0,"Basarge BK, Kolhapur"],
"416507":[76,116,0.0,"Basarge, Kolhapur"],
"416508":[118,219,0.0,"Mhalewadi, Kolhapur"],
"416509":[50,62,0.0,"Adkur, Kolhapur"],
"416510":[73,169,0.0,"Sawantwadi, Sindhudurg"],
"416511":[55,146,0.0,"Sasoli, Sindhudurg"],
"416512":[35,109,0.0,"Maneri, Sindhudurg"],
"416513":[60,118,0.0,"Talavane, Sindhudurg"],
"416514":[60,144,0.0,"Kas, Sindhudurg"],
"416515":[71,126,0.0,"Tulas, Sindhudurg"],
"416516":[71,118,0.0,"Adeli, Sindhudurg"],
"416517":[65,98,0.0,"Redi, Sindhudurg"],
"416518":[70,113,0.0,"Aravli, Sindhudurg"],
"416519":[58,200,0.0,"Kaleli, Sindhudurg"],
"416520":[62,140,0.0,"Ghavanale, Sindhudurg"],
"416521":[62,123,0.0,"Bhadgaon Budruk, Sindhudurg"],
"416522":[45,95,0.0,"Kochara, Sindhudurg"],
"416523":[60,173,0.0,"Bhogave, Sindhudurg"],
"416524":[56,113,0.0,"Chendavan, Sindhudurg"],
"416525":[52,100,0.0,"Nerur, Sindhudurg"],
"416526":[227,348,0.0,"Ainapur, Kolhapur"],
"416527":[66,87,0.0,"Tillarinagar, Kolhapur"],
"416528":[62,137,0.0,"Pinguli, Sindhudurg"],
"416529":[71,160,0.0,"Matond, Sindhudurg"],
"416531":[50,107,0.0,"Verle, Sindhudurg"],
"416534":[53,105,0.0,"Gavrai, Sindhudurg"],
"416549":[41,101,0.0,"Konal Katta Colony, Sindhudurg"],
"416550":[56,110,0.0,"Choukul, Sindhudurg"],
"416551":[242,484,0.0,"Khandal, Kolhapur"],
"416552":[36,127,0.0,"Date, Kolhapur"],
"416601":[75,122,0.0,"Belnekhurd, Sindhudurg"],
"416602":[74,143,0.0,"Aynal, Sindhudurg"],
"416603":[66,118,0.0,"Hiwale, Sindhudurg"],
"416604":[53,120,0.0,"Golvan, Sindhudurg"],
"416605":[60,193,0.0,"Kumbharmath, Sindhudurg"],
"416606":[60,325,0.0,"Malvan, Sindhudurg"],
"416608":[55,102,0.0,"Kandalgaon, Sindhudurg"],
"416609":[76,136,0.0,"Nardave, Sindhudurg"],
"416610":[65,95,0.0,"Koloshi, Sindhudurg"],
"416611":[45,75,0.0,"Are, Sindhudurg"],
"416612":[45,72,0.0,"Ilye, Sindhudurg"],
"416613":[45,72,0.0,"Taramumbari, Sindhudurg"],
"416614":[55,98,0.0,"Chindar, Sindhudurg"],
"416615":[46,76,0.0,"Tambaldeg, Sindhudurg"],
"416616":[50,87,0.0,"Rathivade, Sindhudurg"],
"416620":[75,142,0.0,"Shirval, Sindhudurg"],
"416623":[45,76,0.0,"Waniwade, Sindhudurg"],
"416626":[61,237,0.0,"Tondavali, Sindhudurg"],
"416628":[73,129,0.0,"Pokharan, Sindhudurg"],
"416630":[46,71,0.0,"Munge, Sindhudurg"],
"416632":[76,124,0.0,"Ghotage, Sindhudurg"],
"416701":[80,117,0.0,"Bhambed, Ratnagiri"],
"416702":[36,382,0.0,"Angale, Ratnagiri"],
"416703":[72,245,0.0,"Kurangavane, Sindhudurg"],
"416704":[36,382,0.0,"Ajiwali, Ratnagiri"],
"416705":[50,481,0.0,"Gothane Doniwade, Ratnagiri"],
"416707":[75,125,0.0,"Rajwadi, Ratnagiri"],
"416709":[73,127,0.0,"Katali Sagave, Ratnagiri"],
"416712":[70,110,0.0,"Bhade, Ratnagiri"],
"416713":[38,102,0.0,"Dasur, Ratnagiri"],
"416801":[70,114,0.0,"Wargaon, Sindhudurg"],
"416803":[45,84,0.0,"Mutat, Sindhudurg"],
"416804":[43,95,0.0,"Soundale, Sindhudurg"],
"416805":[45,89,0.0,"Pural, Sindhudurg"],
"416806":[75,129,0.0,"Girye, Sindhudurg"],
"416807":[43,103,0.0,"Tirlot, Sindhudurg"],
"416810":[64,87,0.0,"Gadmath, Sindhudurg"],
"416811":[46,96,0.0,"Mahalunge, Sindhudurg"],
"416812":[57,104,0.0,"Humarmala, Sindhudurg"],
"416813":[45,66,0.0,"Mangavli, Sindhudurg"],
"421002":[332,666,0.0,"Bus Terminus, Thane"],
"421004":[388,647,0.0,"Ulhasnagar 4, Thane"],
"421005":[388,610,0.0,"Ulhasnagar 5, Thane"],
"421101":[304,676,0.0,"Mohandul, Thane"],
"421102":[387,776,0.0,"Atali, Thane"],
"421103":[304,639,0.0,"Mamnoli, Thane"],
"421201":[354,663,0.0,"Thakurli, Thane"],
"421202":[264,601,0.0,"Vishnunagar, Thane"],
"421203":[445,670,0.0,"Dombivali I.A., Thane"],
"421204":[244,558,0.0,"Khoni, Thane"],
"421301":[318,677,0.0,"Kalyan City, Thane"],
"421302":[257,578,0.0,"Anjur, Thane"],
"421303":[205,328,0.0,"Dahe, Palghar"],
"421305":[347,555,0.0,"Vidyashram, Thane"],
"421306":[332,653,0.0,"Wadi, Thane"],
"421308":[347,584,0.0,"Bhiwandi, Thane"],
"421311":[264,568,0.0,"Pimplas, Thane"],
"421312":[262,507,0.0,"Kondhale, Palghar"],
"421401":[171,416,0.0,"Kasegaon, Thane"],
"421402":[179,264,0.0,"Palu, Thane"],
"421403":[370,1015,0.0,"Gegaon, Thane"],
"421501":[298,605,0.0,"Ambernath, Thane"],
"421502":[298,621,0.0,"O.E.Ambernath, Thane"],
"421503":[251,372,0.0,"Karand, Thane"],
"421505":[298,611,0.0,"Jambhul, Thane"],
"421506":[298,583,0.0,"Additional Ambernath, Thane"],
"421601":[168,328,0.0,"Alyani, Thane"],
"421602":[238,409,0.0,"Vashala, Thane"],
"421603":[254,446,0.0,"Birwadi, Thane"],
"421605":[318,724,0.0,"Khadavali, Thane"],
"422001":[302,476,0.0,"Nashik, Nashik"],
"422002":[268,471,0.0,"Gole Colony, Nashik"],
"422003":[268,465,0.0,"Adgaon, Nashik"],
"422004":[285,403,0.0,"Mhasrul, Nashik"],
"422005":[235,434,0.0,"H P T College, Nashik"],
"422006":[285,482,0.0,"Gandhi Nagar (Nashik), Nashik"],
"422007":[251,432,0.0,"Barhe, Nashik"],
"422008":[285,457,0.0,"Trimurti Chowk, Nashik"],
"422009":[443,825,0.0,"Cidco Colony S.O (Nashik), Nashik"],
"422010":[311,482,0.0,"Pimpalgaon Khamb, Nashik"],
"422011":[235,434,0.0,"Dwarka Corner, Nashik"],
"422012":[235,434,0.0,"Ashok Nagar S.O (Nashik), Nashik"],
"422013":[268,470,0.0,"Bhonsala Military School, Nashik"],
"422014":[285,477,0.0,"Bhonsala Military School, Nashik"],
"422101":[302,482,0.0,"Nashik Road, Nashik"],
"422102":[422,711,0.0,"Pimpalgaon Nipani, Nashik"],
"422103":[429,1200,0.0,"Dhondbhar, Nashik"],
"422104":[222,971,0.0,"Dahiwadi, Nashik"],
"422105":[302,495,0.0,"Kotamgaon, Nashik"],
"422112":[458,983,0.0,"Khopadi BK, Nashik"],
"422113":[348,526,0.0,"Paste, Nashik"],
"422201":[675,1539,0.0,"Kherwadi R.S, Nashik"],
"422202":[318,448,0.0,"Awankhed, Nashik"],
"422203":[159,293,0.0,"Devargaon, Nashik"],
"422204":[170,298,0.0,"Jategaon BK, Nashik"],
"422205":[419,613,0.0,"Shindwad, Nashik"],
"422206":[675,2112,0.0,"Ojhar, Nashik"],
"422207":[285,488,0.0,"Amba, Nashik"],
"422208":[180,283,0.75,"Karanjali, Nashik"],
"422209":[572,1471,0.0,"Ahergaon, Nashik"],
"422210":[705,1815,0.0,"Chatori, Nashik"],
"422211":[165,319,0.29,"Bhormal, Nashik"],
"422212":[159,274,0.0,"Aswali Harsh, Nashik"],
"422213":[180,318,0.0,"Talegaon Anjneri, Nashik"],
"422214":[159,274,0.0,"Devgaon, Nashik"],
"422215":[231,305,0.0,"Chausale, Nashik"],
"422221":[235,434,0.0,"Ojhar A.F. Stn., Nashik"],
"422222":[302,483,0.0,"Gangapur, Nashik"],
"422301":[302,483,0.0,"B.S. Nagar, Nashik"],
"422302":[302,483,0.0,"Oney, Nashik"],
"422303":[675,2248,0.0,"Kothure, Nashik"],
"422304":[645,1471,0.0,"Khadak Malegaon, Nashik"],
"422305":[766,900,0.0,"Nandgaon, Nashik"],
"422306":[464,948,0.0,"Kotamgaon, Nashik"],
"422308":[302,483,0.0,"Kumbhardi, Nashik"],
"422401":[302,514,0.0,"Vadner Dumala, Nashik"],
"422402":[219,422,0.0,"Kavnai, Nashik"],
"422403":[217,413,0.0,"Bhavali Khurd, Nashik"],
"422501":[285,498,0.0,"Devlali Air Force, Nashik"],
"422502":[374,555,0.0,"Shivde, Nashik"],
"422601":[368,727,0.0,"Dhamangaon Awari, Ahmednagar"],
"422602":[260,481,0.0,"Badgi, Ahmednagar"],
"422603":[328,620,0.0,"Kalas Bk, Ahmednagar"],
"422604":[325,720,0.0,"Chitalvedhe, Ahmednagar"],
"422605":[350,641,0.0,"Dongargaon, Ahmednagar"],
"422606":[446,904,0.0,"Bhojapur, Nashik"],
"422608":[361,646,0.0,"Maldad, Ahmednagar"],
"422610":[287,515,0.0,"Lingdeo, Ahmednagar"],
"422611":[392,977,0.0,"Kawathe Kamaleshwar, Ahmednagar"],
"422620":[361,616,0.0,"Nandur Khandarmal, Ahmednagar"],
"422622":[323,574,0.0,"Mandve Kd, Ahmednagar"],
"423101":[382,854,0.0,"Neminagar, Nashik"],
"423102":[330,868,0.0,"Dahiwad, Nashik"],
"423104":[484,843,0.0,"Nagapur, Nashik"],
"423105":[324,676,0.0,"Dahiwal, Nashik"],
"423106":[377,735,0.0,"Bhalur, Nashik"],
"423107":[284,593,0.0,"Korhale, Ahmednagar"],
"423108":[395,748,0.0,"Vaygaon, Nashik"],
"423109":[340,695,0.0,"Savali Vihir Farm, Ahmednagar"],
"423110":[395,1095,0.0,"Chinchave, Nashik"],
"423111":[385,463,0.0,"Redgaon BK, Nashik"],
"423117":[290,666,0.0,"Dhodamba, Nashik"],
"423201":[335,748,0.0,"Dhavaleshwar, Nashik"],
"423202":[335,748,0.0,"Pimpalgaon D, Nashik"],
"423203":[350,777,0.0,"Malegaon, Nashik"],
"423204":[395,816,0.0,"Khirmani, Nashik"],
"423205":[350,835,0.0,"Astane, Nashik"],
"423206":[350,835,0.0,"Kashti, Nashik"],
"423208":[440,790,0.0,"Aghar KH, Nashik"],
"423212":[315,805,0.0,"Khayde, Nashik"],
"423213":[395,884,0.0,"Mahalpatane, Nashik"],
"423301":[286,1212,0.0,"Arai, Nashik"],
"423302":[286,1212,0.0,"Aliyabad, Nashik"],
"423303":[286,1135,0.0,"Tandulwadi, Nashik"],
"423401":[443,728,0.0,"Bharam, Nashik"],
"423402":[443,944,0.0,"Angulgaon, Nashik"],
"423403":[443,928,0.0,"Dhamode, Nashik"],
"423501":[352,825,0.0,"Ganore, Nashik"],
"423502":[265,491,0.0,"Gosrane, Nashik"],
"423601":[274,627,0.0,"Kopargaon Bet, Ahmednagar"],
"423602":[305,707,0.0,"Kumbhari, Ahmednagar"],
"423603":[384,687,0.0,"Dahigaon Bolka, Ahmednagar"],
"423604":[207,574,0.0,"Manjur, Ahmednagar"],
"423605":[289,767,0.0,"Derde Korhale, Ahmednagar"],
"423607":[207,582,0.0,"Maygaon Devi, Ahmednagar"],
"423701":[355,572,0.0,"Akoli Wadgaon, Aurangabad"],
"423702":[460,832,0.0,"Pimpalgaon Diwashi, Aurangabad"],
"423703":[355,595,0.0,"Borsar(Bhingi), Aurangabad"],
"424001":[278,1023,0.0,"Dhule, Dhule"],
"424002":[264,951,0.0,"Babhulvadi, Dhule"],
"424004":[278,963,0.0,"Agriculture College, Dhule"],
"424005":[292,750,0.0,"Nagaon, Dhule"],
"424006":[326,942,0.0,"Arvi, Dhule"],
"424101":[505,-1,0.0,"Chalisgaon, Jalgaon"],
"424102":[508,-1,0.0,"Hingona Kh, Jalgaon"],
"424103":[393,585,0.0,"Takali Bk, Jalgaon"],
"424104":[354,545,0.0,"Akhatwade, Jalgaon"],
"424105":[354,734,0.0,"Anjanvihire, Jalgaon"],
"424106":[536,-1,0.0,"Kunzar, Jalgaon"],
"424107":[501,573,0.0,"Juwardi, Jalgaon"],
"424108":[463,-1,0.0,"Brahmanshevge, Jalgaon"],
"424109":[377,735,0.0,"Chandora, Nashik"],
"424119":[505,-1,0.0,"Shindi, Jalgaon"],
"424201":[340,620,0.0,"Anturli Bk, Jalgaon"],
"424202":[344,495,-1,"Vadgaon Ambe, Jalgaon"],
"424203":[334,613,0.0,"Chinchapura, Jalgaon"],
"424204":[440,716,0.0,"Kalamsare, Jalgaon"],
"424205":[432,-1,0.0,"Nachankheda, Jalgaon"],
"424206":[395,713,0.0,"Khadki, Jalgaon"],
"424207":[418,658,0.0,"Loni, Jalgaon"],
"424208":[413,692,0.0,"Deulgaon, Jalgaon"],
"424301":[340,989,0.0,"Kalkheda, Dhule"],
"424302":[288,940,0.0,"Chaugaon, Dhule"],
"424303":[420,854,0.0,"Khandalai, Dhule"],
"424304":[420,744,0.0,"Chaupale, Dhule"],
"424305":[302,527,0.0,"Amkhel, Dhule"],
"424306":[275,350,0.0,"Shendwad, Dhule"],
"424307":[369,860,0.0,"Lonkheda, Dhule"],
"424308":[356,1003,0.0,"Moghan, Dhule"],
"424309":[529,860,0.0,"Walkheda, Dhule"],
"424310":[441,819,0.0,"Chhail, Dhule"],
"424311":[388,853,0.0,"Junawane, Dhule"],
"424318":[326,952,0.0,"Navara navari, Dhule"],
"425001":[303,605,0.0,"Jalgaon, Jalgaon"],
"425002":[280,579,0.0,"Amoda, Jalgaon"],
"425003":[311,535,0.0,"Chincholi, Jalgaon"],
"425004":[303,596,0.0,"N M University Jalgaon, Jalgaon"],
"425101":[312,587,0.0,"Asoda, Jalgaon"],
"425102":[320,594,0.0,"Bholane, Jalgaon"],
"425103":[320,623,0.0,"Anjanvihire, Jalgaon"],
"425104":[372,731,0.0,"Borkheda, Jalgaon"],
"425105":[235,477,0.0,"Dheku, Jalgaon"],
"425107":[130,478,0.0,"Adgaon, Jalgaon"],
"425108":[186,466,0.0,"Mauje Hingona, Jalgaon"],
"425109":[429,758,0.0,"Bhatkheda, Jalgaon"],
"425110":[486,1359,0.0,"Adgaon, Jalgaon"],
"425111":[365,666,0.0,"Dholi, Jalgaon"],
"425112":[365,639,0.0,"Toli, Jalgaon"],
"425113":[413,540,0.0,"Bholane, Jalgaon"],
"425114":[311,383,0.0,"Palaskheda Mirache, Jalgaon"],
"425115":[334,469,0.0,"Kurangi, Jalgaon"],
"425116":[491,656,0.0,"Dahigaon, Jalgaon"],
"425201":[484,617,0.0,"Bhusawal, Jalgaon"],
"425203":[429,582,0.0,"Sakegaon, Jalgaon"],
"425301":[486,579,0.0,"Korpavali, Jalgaon"],
"425302":[488,792,0.0,"Adgaon, Jalgaon"],
"425303":[409,660,0.0,"Vadgaon B K, Jalgaon"],
"425304":[385,535,0.0,"Chikali, Jalgaon"],
"425305":[350,836,0.0,"Pimpalgaon K H, Jalgaon"],
"425306":[336,488,0.0,"Nimkhedi KH, Jalgaon"],
"425307":[421,605,0.0,"Fekari, Jalgaon"],
"425308":[336,707,0.0,"Tahakali, Jalgaon"],
"425309":[303,570,0.0,"Jalgaon K H, Jalgaon"],
"425310":[316,609,0.0,"Kurha Hardo, Jalgaon"],
"425311":[480,644,0.0,"Chorwad, Jalgaon"],
"425314":[352,576,0.0,"Gadegaon, Jalgaon"],
"425327":[444,865,0.0,"Charthana, Jalgaon"],
"425401":[361,576,0.0,"AmbaPimpri, Jalgaon"],
"425402":[392,399,0.0,"Karankheda, Jalgaon"],
"425403":[575,-1,0.0,"Mudawad, Dhule"],
"425404":[757,-1,0.0,"Pashta, Dhule"],
"425405":[345,598,0.0,"Jatode, Dhule"],
"425406":[643,1001,0.0,"Jogshelu, Dhule"],
"425407":[462,1125,0.0,"Jakhane, Dhule"],
"425408":[412,1364,0.0,"Daul, Dhule"],
"425409":[272,1034,0.0,"Brahmanpuri, Nandurbar"],
"425410":[329,1020,0.0,"Biladi T.S, Nandurbar"],
"425411":[728,1029,0.0,"Bahyane, Nandurbar"],
"425412":[315,650,0.0,"Ashte, Nandurbar"],
"425413":[310,528,-1,"Amlad, Nandurbar"],
"425414":[308,394,0.0,"Sisa, Nandurbar"],
"425415":[295,477,0.0,"RajMohi, Nandurbar"],
"425416":[293,462,0.01,"Bhadvad, Nandurbar"],
"425417":[275,392,0.0,"Sonare Digar, Nandurbar"],
"425418":[290,423,0.01,"Gadat, Nandurbar"],
"425419":[280,490,0.0,"Raisingpur, Nandurbar"],
"425420":[248,423,0.0,"Pimpali, Jalgaon"],
"425421":[414,578,0.0,"Hisale, Dhule"],
"425422":[372,1021,0.0,"Katharde Digar, Nandurbar"],
"425423":[343,762,0.0,"Jainagar, Nandurbar"],
"425424":[251,770,0.0,"Gogapur, Nandurbar"],
"425426":[300,399,0.0,"Bandharpada, Nandurbar"],
"425427":[403,788,0.0,"Arthe, Dhule"],
"425428":[345,819,0.0,"Umarde, Dhule"],
"425432":[258,488,-1,"Fattepur, Nandurbar"],
"425442":[396,632,0.0,"Lakhapur, Nandurbar"],
"425444":[263,686,0.0,"Chandsaily, Nandurbar"],
"425452":[254,276,0.0,"Bhagdari, Nandurbar"],
"425501":[314,585,0.0,"Gate, Jalgaon"],
"425502":[332,519,0.0,"Kochur, Jalgaon"],
"425503":[332,491,0.0,"Hingona, Jalgaon"],
"425504":[332,506,0.0,"Kusumbe B K, Jalgaon"],
"425505":[283,534,0.0,"Kumbharkheda, Jalgaon"],
"425506":[283,532,0.0,"Dasnoor, Jalgaon"],
"425507":[283,532,0.0,"Balwadi, Jalgaon"],
"425508":[447,642,0.0,"Abhoda, Jalgaon"],
"425524":[305,492,0.0,"Andharmali, Jalgaon"],
"431001":[428,648,0.0,"Chhatrapati Sambhajinagar (MH), Aurangabad"],
"431002":[304,703,0.0,"Padegaon, Aurangabad"],
"431003":[310,753,0.0,"Nizamganj, Aurangabad"],
"431004":[304,776,0.0,"Dr. B.A. Marathwada University, Aurangabad"],
"431005":[310,713,0.0,"Session Court S.O (Chhatrapati Sambhajinagar), Aurangabad"],
"431006":[315,789,0.0,"Chikalthana Industrial Area, Aurangabad"],
"431007":[315,871,0.0,"Khodegaon, Aurangabad"],
"431008":[445,1389,0.0,"Adgaon Sarak, Aurangabad"],
"431009":[315,765,0.0,"Garkheda, Aurangabad"],
"431010":[315,755,0.0,"Satara Parisar, Aurangabad"],
"431011":[304,697,0.0,"Kanchanwadi, Aurangabad"],
"431025":[310,753,0.0,"Nizamganj, Aurangabad"],
"431101":[331,669,0.0,"Golegaon, Aurangabad"],
"431102":[363,765,0.0,"Ellora Caves, Aurangabad"],
"431103":[392,955,0.0,"Amba (Upla), Aurangabad"],
"431104":[392,955,0.0,"Hasta, Aurangabad"],
"431105":[528,1332,0.0,"Chitegaon, Aurangabad"],
"431107":[302,541,0.0,"Nander, Aurangabad"],
"431109":[485,979,0.0,"Singhi, Aurangabad"],
"431110":[398,848,0.0,"Agarwadgaon, Aurangabad"],
"431111":[225,484,0.0,"Nandra, Aurangabad"],
"431112":[365,605,0.0,"Hatti, Aurangabad"],
"431113":[400,800,0.0,"Relgaon, Aurangabad"],
"431114":[475,813,0.0,"Pahtepur, Jalna"],
"431115":[450,744,0.0,"Lakhani, Aurangabad"],
"431116":[355,554,0.0,"Biloni, Aurangabad"],
"431117":[559,1265,0.0,"Balapur, Aurangabad"],
"431118":[440,701,0.0,"Palaskheda, Aurangabad"],
"431120":[432,818,0.0,"Jarandi, Aurangabad"],
"431121":[380,781,0.0,"Gharegaon Ektuni, Aurangabad"],
"431122":[445,1012,0.0,"Beed, Beed"],
"431123":[270,496,0.0,"Chandan Sawargaon, Beed"],
"431124":[199,519,0.0,"Choramba, Beed"],
"431125":[246,283,0.0,"Kalsambar, Beed"],
"431126":[267,286,0.0,"Hingni BK, Beed"],
"431127":[485,1293,0.0,"Talwada, Beed"],
"431128":[311,966,0.0,"Moha, Beed"],
"431129":[239,291,0.0,"Bhendtakli, Beed"],
"431130":[291,400,0.0,"Ardha Pimpri, Beed"],
"431131":[277,672,0.0,"Rajewadi, Beed"],
"431132":[490,881,0.0,"Madni, Aurangabad"],
"431133":[485,979,0.0,"Talpimpri, Aurangabad"],
"431134":[225,484,0.0,"Pimalgaon Kolte, Jalna"],
"431135":[365,641,0.0,"Gavli Tanda, Aurangabad"],
"431136":[467,826,0.0,"Waladgaon, Aurangabad"],
"431137":[350,647,0.0,"Dahyala, Jalna"],
"431142":[279,680,0.0,"Kittiadgaon, Beed"],
"431143":[459,667,0.0,"Pachegaon, Beed"],
"431144":[280,947,0.0,"Harichanra Pimpri, Beed"],
"431147":[419,647,0.0,"Dahegaon, Aurangabad"],
"431148":[309,954,0.0,"Pimpalwadi (Pirachi), Aurangabad"],
"431150":[413,586,0.0,"Gondegaon, Aurangabad"],
"431151":[423,652,0.0,"Babra, Aurangabad"],
"431152":[304,683,0.0,"BODKHA, Aurangabad"],
"431153":[459,933,0.0,"Shivni, Beed"],
"431154":[315,723,0.0,"Shekta, Aurangabad"],
"431202":[389,474,0.0,"Akola (Niklak), Jalna"],
"431203":[284,475,0.0,"Jalna, Jalna"],
"431204":[353,759,0.0,"Hastepokhari, Jalna"],
"431205":[353,762,0.0,"Sonakpimpalgaon, Jalna"],
"431206":[335,591,0.0,"Janephal, Jalna"],
"431207":[627,-1,0.0,"Hivra Roshangaon, Jalna"],
"431208":[325,472,0.0,"Kumbharzari, Jalna"],
"431209":[819,-1,0.0,"Khapardev Hivra, Jalna"],
"431211":[711,-1,0.0,"Pimparkheda (Bk), Jalna"],
"431212":[362,600,0.0,"Pimpalgaon Saste, Jalna"],
"431213":[539,898,0.0,"Mandwa, Jalna"],
"431214":[539,898,0.0,"Seoli, Jalna"],
"431215":[475,813,0.0,"Delegavan, Jalna"],
"431401":[245,694,0.0,"Parbhani, Parbhani"],
"431402":[238,715,0.0,"Asola, Parbhani"],
"431501":[340,638,0.0,"Amba, Jalna"],
"431502":[340,809,0.0,"Osmanpur, Jalna"],
"431503":[257,612,0.0,"Kundi, Parbhani"],
"431504":[327,696,0.0,"Idoli, Jalna"],
"431505":[275,717,0.0,"Karanji, Parbhani"],
"431506":[307,692,0.0,"Khavane Pimpri, Parbhani"],
"431507":[380,829,0.0,"P. Dhamangaon, Jalna"],
"431508":[280,546,0.0,"Chandaj, Parbhani"],
"431509":[289,625,0.0,"Dhanora, Parbhani"],
"431510":[295,401,0.0,"Ambarwadi, Parbhani"],
"431511":[499,806,0.0,"Chudawa, Parbhani"],
"431512":[324,726,0.0,"Hayatnagar, Hingoli"],
"431513":[259,586,0.0,"Ganjapur, Hingoli"],
"431514":[303,658,0.0,"Harangul, Parbhani"],
"431515":[301,444,0.0,"Dharmapuri, Beed"],
"431516":[387,741,0.0,"Dighol Islampur, Parbhani"],
"431517":[273,493,0.0,"Dighol Amba, Beed"],
"431518":[356,642,0.0,"Borisawargaon, Beed"],
"431519":[375,461,0.0,"Ujani, Beed"],
"431520":[406,519,0.0,"Parli Tps, Beed"],
"431521":[372,908,-1,"Dhasadi, Parbhani"],
"431522":[372,774,0.0,"Bittergaon, Latur"],
"431523":[273,514,0.0,"Dhanora, Beed"],
"431530":[406,773,0.0,"Belamba, Beed"],
"431536":[332,602,0.0,"Banvas, Parbhani"],
"431537":[220,579,0.0,"Bhogaon, Parbhani"],
"431540":[197,606,0.0,"Bobde Takli, Parbhani"],
"431541":[332,665,0.0,"Mangrul, Parbhani"],
"431542":[270,482,0.0,"Jaipur B.O SENGAON, Hingoli"],
"431543":[222,404,0.0,"Borisawant, Hingoli"],
"431601":[372,760,0.0,"Nanded, Nanded"],
"431602":[372,737,0.0,"Kakandi, Nanded"],
"431603":[369,772,0.0,"Dhanegaon, Nanded"],
"431604":[378,787,0.0,"Karimabad Nanded, Nanded"],
"431605":[372,675,0.0,"Lakshminagar, Nanded"],
"431606":[378,742,0.0,"Wadepuri, Nanded"],
"431701":[246,401,0.0,"Jawala Panchal, Hingoli"],
"431702":[284,567,0.0,"Khanapur Chitta, Hingoli"],
"431703":[309,587,0.0,"Jawala BK, Hingoli"],
"431704":[384,604,0.0,"Nimgaon, Nanded"],
"431705":[232,416,0.0,"Shirad Shahapur, Hingoli"],
"431707":[277,475,0.0,"Dahikalamba, Nanded"],
"431708":[364,740,0.0,"Berli, Nanded"],
"431709":[487,581,0.0,"Dhanora, Nanded"],
"431710":[372,549,0.0,"Belkoni Kh, Nanded"],
"431711":[425,767,0.1,"Hungunda, Nanded"],
"431712":[305,611,0.0,"Baradshewala, Nanded"],
"431713":[343,534,0.0,"Kandli, Nanded"],
"431714":[398,575,0.0,"Ambulga, Nanded"],
"431715":[428,949,-1,"Kharabkhandgaon, Nanded"],
"431716":[428,573,0.0,"P. Sawargaon, Nanded"],
"431717":[298,792,0.0,"Hottal, Nanded"],
"431718":[314,609,0.0,"Martoli, Nanded"],
"431719":[302,723,0.0,"Halni, Nanded"],
"431720":[431,697,0.0,"Kerwadi, Parbhani"],
"431721":[415,613,0.0,"Malakaguda, Nanded"],
"431722":[398,530,0.0,"Manjram, Nanded"],
"431723":[295,697,0.01,"Sugaon, Nanded"],
"431724":[338,562,0.0,"Wai Bazar, Nanded"],
"431731":[280,577,0.01,"Bolegaon, Nanded"],
"431736":[351,535,0.0,"Alandi, Nanded"],
"431741":[180,443,0.0,"Bhutan Hipparga, Nanded"],
"431742":[330,539,0.0,"Digras, Nanded"],
"431743":[280,550,0.0,"Koli, Nanded"],
"431745":[320,614,0.0,"Barasgaon, Nanded"],
"431746":[364,575,0.0,"Chikhali, Nanded"],
"431750":[363,581,0.0,"Kamtha, Nanded"],
"431801":[354,668,0.0,"Bembari, Nanded"],
"431802":[325,342,0.0,"Mangrul, Nanded"],
"431803":[296,579,0.0,"Malakjamb, Nanded"],
"431804":[326,606,0.0,"Digadi, Nanded"],
"431805":[320,645,0.0,"Daheli, Nanded"],
"431806":[366,589,0.0,"Malkautha, Nanded"],
"431807":[359,589,0.0,"Bitnal, Nanded"],
"431808":[260,658,0.02,"Dhanora, Nanded"],
"431809":[347,619,0.03,"Dugaon, Nanded"],
"431810":[322,613,0.0,"Kopra, Nanded"],
"431811":[369,671,0.0,"Chikhali, Nanded"],
"440001":[316,566,0.0,"Nagpur GPO, Nagpur"],
"440002":[316,630,0.0,"Nagpur City, Nagpur"],
"440003":[316,592,0.0,"Ajni, Nagpur"],
"440005":[276,465,0.0,"Nagpur Airport, Nagpur"],
"440006":[321,537,0.0,"Seminary Hills, Nagpur"],
"440007":[316,550,0.0,"Vayusena Nagar, Nagpur"],
"440008":[316,639,0.0,"Bagadganj, Nagpur"],
"440010":[316,559,0.0,"Khare Town, Nagpur"],
"440012":[316,578,0.0,"Netaji Market, Nagpur"],
"440013":[321,468,0.0,"Borgaon Road, Nagpur"],
"440014":[333,593,0.0,"Jaripatka, Nagpur"],
"440015":[375,630,0.0,"Vivekanand Nagar, Nagpur"],
"440016":[259,486,0.0,"Indl.Area Nagpur, Nagpur"],
"440017":[325,624,0.0,"Dr.Ambedkar Marg, Nagpur"],
"440018":[316,605,0.0,"Mominpura, Nagpur"],
"440019":[261,554,0.0,"C.R.P.F. Nagpur, Nagpur"],
"440020":[316,575,0.0,"Neeri, Nagpur"],
"440021":[316,572,0.0,"A.D. Project, Nagpur"],
"440022":[316,578,0.0,"Shradhananpeth, Nagpur"],
"440023":[308,532,0.0,"Adegaon, Nagpur"],
"440024":[316,630,0.0,"Ayodhya Nagar, Nagpur"],
"440025":[316,583,0.0,"Ujwal Nagar S.O (Nagpur), Nagpur"],
"440026":[325,625,0.0,"Uppalwadi, Nagpur"],
"440027":[260,605,0.0,"Vishwakarma Nagar, Nagpur"],
"440029":[303,767,0.0,"Bhilgaon, Nagpur"],
"440030":[321,557,0.0,"Mankapur S.O (Nagpur), Nagpur"],
"440032":[316,561,0.0,"Mahal S.O (Nagpur), Nagpur"],
"440033":[316,561,0.0,"University Campus S.O (Nagpur), Nagpur"],
"440034":[288,637,0.0,"Mhalginagar, Nagpur"],
"440035":[346,617,0.0,"Kalmna Market Yard, Nagpur"],
"440036":[277,560,0.0,"Jaitala, Nagpur"],
"440037":[288,610,0.0,"BESA Road, Nagpur"],
"440038":[316,561,0.0,"University Campus S.O (Nagpur), Nagpur"],
"441001":[316,774,0.0,"Kamthi, Nagpur"],
"441101":[292,709,0.0,"Khubala, Nagpur"],
"441102":[316,615,0.0,"Bina, Nagpur"],
"441103":[322,486,0.0,"Kachari Sawanga, Nagpur"],
"441104":[470,1346,0.0,"Chirwa, Nagpur"],
"441105":[316,561,0.0,"Suwardhara, Nagpur"],
"441106":[239,649,0.0,"Kachurwahi, Nagpur"],
"441107":[320,732,0.0,"Telgaon, Nagpur"],
"441108":[348,602,0.0,"Ashta, Nagpur"],
"441109":[316,552,0.0,"Sillewara Project, Nagpur"],
"441110":[316,515,0.0,"Amgaon Deori, Nagpur"],
"441111":[316,615,0.0,"Gumthi, Nagpur"],
"441112":[314,659,0.0,"Khairi Dhalgaon, Nagpur"],
"441113":[323,583,0.0,"Dahegaon Rangari, Nagpur"],
"441122":[355,589,0.0,"Salaidhabha, Nagpur"],
"441123":[316,618,0.0,"Godhani, Nagpur"],
"441124":[260,644,0.0,"Ujwal Nagar S.O (Nagpur), Nagpur"],
"441201":[262,562,0.0,"Menda, Nagpur"],
"441202":[311,1056,0.0,"Deoli Kalan, Nagpur"],
"441203":[236,307,0.0,"Bhagwanpur, Nagpur"],
"441204":[286,586,0.0,"Kalamna, Nagpur"],
"441205":[483,763,0.0,"Dongargaon BK, Chandrapur"],
"441206":[344,651,0.0,"Arher Nawargaon, Chandrapur"],
"441207":[483,774,0.0,"Amgaon Buti, Gadchiroli"],
"441208":[338,457,0.0,"Shioni BK, Gadchiroli"],
"441209":[205,442,0.0,"Gothangaon, Gadchiroli"],
"441210":[332,708,0.0,"Fegad, Nagpur"],
"441212":[505,1203,0.0,"Navegaon Lonkhairi, Chandrapur"],
"441214":[260,443,0.0,"Mandwa, Nagpur"],
"441215":[351,634,0.0,"Antargaon, Chandrapur"],
"441217":[297,423,0.0,"Ghati, Gadchiroli"],
"441221":[434,642,0.0,"AKAPUR, Chandrapur"],
"441222":[469,1102,0.0,"Jamsala, Chandrapur"],
"441223":[434,760,0.0,"Visapur, Chandrapur"],
"441224":[411,781,0.0,"Maroda, Chandrapur"],
"441225":[244,586,0.0,"Keroda, Chandrapur"],
"441226":[344,596,0.0,"Gowardhan, Chandrapur"],
"441301":[413,675,0.0,"Thugaon Deo, Nagpur"],
"441302":[300,542,0.0,"Dhawlapur, Nagpur"],
"441303":[382,666,0.0,"Khairgaon, Nagpur"],
"441304":[300,606,0.0,"Tinkheda, Nagpur"],
"441305":[346,590,0.0,"Lohari Sawanga, Nagpur"],
"441306":[309,481,0.0,"Masora, Nagpur"],
"441401":[245,644,0.0,"Deolapar, Nagpur"],
"441404":[281,704,0.0,"Borda (Ganeshi), Nagpur"],
"441501":[308,593,0.0,"Fetri, Nagpur"],
"441502":[303,575,0.0,"Kohli, Nagpur"],
"441601":[252,654,0.0,"Gondia, Gondia"],
"441614":[380,693,0.0,"Dhakni, Gondia"],
"441701":[274,552,0.0,"Bakti, Gondia"],
"441702":[236,386,0.0,"Kesori, Gondia"],
"441801":[252,686,0.0,"Ghoti, Gondia"],
"441802":[232,309,0.0,"Amgaon BK, Bhandara"],
"441803":[388,681,0.0,"Opera, Bhandara"],
"441804":[398,717,0.0,"Gadegaon, Bhandara"],
"441805":[262,485,0.0,"Barwa, Bhandara"],
"441806":[215,314,0.0,"Bopabodi, Gondia"],
"441807":[235,423,0.0,"Chopa, Gondia"],
"441809":[262,467,0.0,"Channa, Bhandara"],
"441901":[128,326,0.0,"Dawki, Gondia"],
"441902":[252,684,0.0,"Kalimati, Gondia"],
"441903":[246,613,0.0,"Pimpalgaon Nipani, Bhandara"],
"441904":[360,605,0.0,"Bhandara, Bhandara"],
"441905":[321,679,0.0,"Mandvi, Bhandara"],
"441906":[322,824,0.0,"Bela, Bhandara"],
"441907":[295,689,0.0,"Ashti, Bhandara"],
"441908":[223,419,0.0,"Bhawad, Bhandara"],
"441909":[390,736,0.0,"Dongargaon, Bhandara"],
"441910":[222,451,0.0,"Bhendala, Bhandara"],
"441911":[313,580,0.0,"Chikhali, Gondia"],
"441912":[393,942,0.0,"Khapa, Bhandara"],
"441913":[398,747,0.0,"Madgi, Bhandara"],
"441914":[339,918,0.0,"Jamb, Bhandara"],
"441915":[394,677,0.0,"Bapera, Bhandara"],
"441916":[122,477,0.0,"Dhanoli, Gondia"],
"441924":[398,731,0.0,"Kardha, Bhandara"],
"442001":[340,618,0.0,"Wardha, Wardha"],
"442003":[330,610,0.0,"Cotton Market, Wardha"],
"442101":[330,658,0.0,"Agargaon, Wardha"],
"442102":[330,668,0.0,"Hamdapur, Wardha"],
"442104":[388,849,0.0,"Hingani, Wardha"],
"442105":[440,960,0.0,"Sindi, Wardha"],
"442106":[362,474,0.0,"Kachnoor, Wardha"],
"442107":[308,526,0.0,"Sawangi Meghe, Wardha"],
"442111":[350,812,0.0,"Paunar, Wardha"],
"442201":[287,459,0.0,"Jasapur, Wardha"],
"442202":[382,644,0.0,"Bharaswara, Wardha"],
"442203":[249,488,0.0,"Kakda, Wardha"],
"442301":[340,610,0.0,"Dongargaon, Wardha"],
"442302":[337,701,0.0,"Borgaon Hatla, Wardha"],
"442303":[365,675,0.0,"Pulgaon Camp, Wardha"],
"442304":[350,732,0.0,"Dhotra, Wardha"],
"442305":[350,742,0.0,"Waigaon Gond, Wardha"],
"442306":[415,858,0.0,"Inzhala, Wardha"],
"442307":[364,702,0.0,"Pipri, Wardha"],
"442401":[242,352,0.0,"Chandrapur, Chandrapur"],
"442402":[242,357,0.0,"Marda, Chandrapur"],
"442403":[363,657,0.0,"Junona, Chandrapur"],
"442404":[194,323,0.0,"WARWAT, Chandrapur"],
"442406":[245,420,0.0,"Padoli, Chandrapur"],
"442501":[369,822,0.0,"Chandrapur Ord Fact, Chandrapur"],
"442502":[339,771,0.0,"WADA, Chandrapur"],
"442503":[379,498,0.0,"Kuchana, Chandrapur"],
"442504":[338,593,0.0,"Narayanpur, Gadchiroli"],
"442505":[339,711,0.0,"Shengaon, Chandrapur"],
"442507":[322,568,0.0,"Nandgaon Podey, Chandrapur"],
"442603":[294,430,0.0,"Bhendala, Gadchiroli"],
"442604":[436,723,0.0,"Nimgaon, Gadchiroli"],
"442605":[236,398,0.0,"Amirza, Gadchiroli"],
"442606":[404,791,0.0,"Karwafa, Gadchiroli"],
"442701":[416,581,0.0,"Tohogaon, Chandrapur"],
"442702":[355,925,0.0,"Dhamangaon, Chandrapur"],
"442703":[350,622,0.0,"Kasampeth, Gadchiroli"],
"442704":[355,562,0.0,"Ghotsur, Gadchiroli"],
"442705":[325,688,0.0,"Mahagaon BK, Gadchiroli"],
"442707":[307,763,0.0,"Kalinagar, Gadchiroli"],
"442709":[357,612,0.0,"Kolamarka, Gadchiroli"],
"442710":[312,591,0.0,"Kandoli, Gadchiroli"],
"442901":[416,539,0.0,"Ballarpur Paper Mill, Chandrapur"],
"442902":[362,620,0.0,"Jena, Chandrapur"],
"442903":[382,784,0.0,"Bhisi, Chandrapur"],
"442904":[386,654,0.0,"Adegaon, Chandrapur"],
"442905":[363,735,0.0,"Bhedoda, Chandrapur"],
"442906":[410,1012,0.0,"KODEWADA (MA), Chandrapur"],
"442907":[416,692,0.0,"Chikani, Chandrapur"],
"442908":[330,640,0.01,"Nandpa, Chandrapur"],
"442914":[388,456,0.0,"Khemjai, Chandrapur"],
"442916":[283,660,0.0,"Dhanoli, Chandrapur"],
"442917":[284,728,0.0,"Antargaon, Chandrapur"],
"442918":[314,499,0.0,"Kasargatta, Gadchiroli"],
"442919":[351,619,0.0,"Warsawada, Gadchiroli"],
"442920":[408,775,0.0,"Jamgaon Komti, Chandrapur"],
"443001":[436,714,0.0,"Buldana, Buldhana"],
"443002":[436,680,0.0,"Padali, Buldhana"],
"443101":[401,765,0.0,"Dudhalgaon BK, Buldhana"],
"443102":[320,826,0.0,"Dabhadi, Buldhana"],
"443103":[480,949,0.0,"Borakhedi, Buldhana"],
"443104":[462,924,0.0,"Panhera Khedi, Buldhana"],
"443106":[415,568,0.0,"Dudha, Buldhana"],
"443112":[401,767,0.0,"Narvel, Buldhana"],
"443201":[399,637,0.0,"Ambashi, Buldhana"],
"443202":[321,567,0.0,"Daregaon, Buldhana"],
"443203":[372,995,0.0,"Dawargaon, Buldhana"],
"443204":[398,673,0.0,"Singaon Jahagir, Buldhana"],
"443206":[405,817,0.0,"Saramba, Buldhana"],
"443301":[479,1067,0.0,"Chincholi Bore, Buldhana"],
"443302":[520,981,0.0,"Hirdao, Buldhana"],
"443303":[397,689,0.0,"Pangarkhed, Buldhana"],
"443304":[459,724,0.0,"Hiwara Khurd, Buldhana"],
"443308":[398,1500,0.0,"Jambhora, Buldhana"],
"443401":[634,1064,0.0,"Dighi, Buldhana"],
"443402":[497,1018,0.0,"Asalgaon, Buldhana"],
"443403":[494,980,0.0,"Adol BK, Buldhana"],
"443404":[722,1051,0.0,"Wasadi BK, Buldhana"],
"444001":[891,2237,0.0,"Akola, Akola"],
"444002":[723,1753,0.0,"Gajanan Nagar, Akola"],
"444003":[788,1634,0.0,"Ghusar, Akola"],
"444004":[833,1578,0.0,"Malkapur, Akola"],
"444005":[764,1766,0.0,"Gudadhi, Akola"],
"444006":[891,2203,0.0,"Chikhalgaon, Akola"],
"444007":[684,1527,0.0,"Wholesale Kirana Market Sub Post Office Akola, Akola"],
"444101":[340,515,0.0,"Chohatta, Akola"],
"444102":[575,974,0.0,"Dhotardi, Akola"],
"444103":[385,661,0.0,"Chittalwadi, Akola"],
"444104":[775,1561,0.0,"Dongargaon, Akola"],
"444105":[349,620,0.0,"Shaha, Washim"],
"444106":[458,866,0.0,"Pohi, Akola"],
"444107":[508,699,0.0,"Anbhora, Akola"],
"444108":[492,1209,0.0,"Belkhed, Akola"],
"444109":[649,1666,0.0,"Gaigaon, Akola"],
"444110":[366,727,0.0,"Dhanaj KD, Washim"],
"444111":[620,1386,0.0,"Jaulkhed, Akola"],
"444117":[340,1079,0.0,"Pathardi, Akola"],
"444126":[346,548,0.0,"Adgaon KD, Akola"],
"444201":[596,1146,0.0,"Kavthal, Buldhana"],
"444202":[418,597,0.0,"Bodkha, Buldhana"],
"444203":[630,2174,-1,"Adsul, Buldhana"],
"444204":[506,860,0.0,"Banoda Eklara, Buldhana"],
"444301":[277,690,0.0,"Karwand, Buldhana"],
"444302":[324,951,0.0,"Kanheri Gawali, Akola"],
"444303":[304,584,0.0,"Khamgaon, Buldhana"],
"444304":[680,1173,0.0,"Matergaon, Buldhana"],
"444306":[352,641,0.0,"Bhalegaon Bazar, Buldhana"],
"444311":[546,1783,-1,"Karanja Ramzanpur, Akola"],
"444312":[630,2174,-1,"Pimpri Deshmukh, Buldhana"],
"444401":[332,594,0.0,"Dhabha, Akola"],
"444402":[333,610,0.0,"Kanzara, Washim"],
"444403":[384,709,0.0,"Mendra, Washim"],
"444404":[315,711,0.0,"Dhanora Ghatge, Washim"],
"444405":[298,447,0.0,"Januna, Akola"],
"444407":[298,491,0.0,"Kherda Bhagai, Akola"],
"444409":[350,537,0.0,"Dhanora KD, Washim"],
"444501":[292,505,0.0,"Gawandgaon, Akola"],
"444502":[322,558,0.0,"Degaon, Akola"],
"444503":[318,622,0.0,"Rajura, Washim"],
"444504":[389,692,0.0,"Tiwali, Washim"],
"444505":[308,615,0.0,"Bhatumara, Washim"],
"444506":[324,779,0.0,"Loni Sm, Washim"],
"444507":[324,645,-1,"Pimpalgaon, Washim"],
"444510":[371,619,0.0,"Assegaon Pen, Washim"],
"444511":[326,445,0.0,"Umarwadi, Akola"],
"444601":[349,410,0.0,"Amravati, Amravati"],
"444602":[443,614,0.0,"Dadhi, Amravati"],
"444603":[349,409,0.0,"Shivaji Nagar S.O (Amravati), Amravati"],
"444604":[349,-1,0.0,"V.M.V. (Amravati), Amravati"],
"444605":[367,416,0.0,"H. V. Nagar, Amravati"],
"444606":[349,413,0.0,"Gokul Market, Amravati"],
"444607":[331,440,0.0,"Sai Nagar, Amravati"],
"444701":[423,550,0.0,"Dabha, Amravati"],
"444702":[264,326,0.0,"Chakarda, Amravati"],
"444704":[301,597,0.0,"Borala, Amravati"],
"444705":[358,735,0.0,"Dhanegaon, Amravati"],
"444706":[538,1398,0.0,"Jainpur, Amravati"],
"444707":[411,560,0.0,"Dapori Khurd, Amravati"],
"444708":[348,563,0.0,"Bori, Amravati"],
"444709":[280,507,0.0,"Anjanwati, Amravati"],
"444710":[244,448,0.0,"Dhanodi, Amravati"],
"444711":[264,638,0.0,"Nimboli, Amravati"],
"444717":[227,298,0.0,"Ambapati, Amravati"],
"444719":[330,426,0.0,"Bhokarbardi, Amravati"],
"444720":[341,592,0.0,"Wani, Amravati"],
"444723":[289,479,0.0,"Belaj, Amravati"],
"444801":[443,1269,0.0,"Dhamori Kasba, Amravati"],
"444802":[613,1019,0.0,"Hartala, Amravati"],
"444803":[549,2141,0.0,"Kokarda, Amravati"],
"444804":[651,1741,0.0,"Rama, Amravati"],
"444805":[245,432,0.0,"Paratwada, Amravati"],
"444806":[259,394,0.0,"Borgaon Peth, Amravati"],
"444807":[216,274,0.0,"Salona, Amravati"],
"444808":[512,-1,0.0,"Kushta BK, Amravati"],
"444809":[259,414,0.0,"Karanja Bahiram, Amravati"],
"444810":[247,418,0.0,"Sirasgaon Kasba, Amravati"],
"444813":[193,241,0.0,"Hatru, Amravati"],
"444901":[302,337,0.0,"Brahmanwada Gov, Amravati"],
"444902":[307,531,0.0,"Mozri, Amravati"],
"444903":[303,520,0.0,"Nimbhora Delwad, Amravati"],
"444904":[325,574,0.0,"Amla Vishweshwar, Amravati"],
"444905":[425,814,0.0,"Ashtoli, Amravati"],
"444906":[413,666,0.0,"Gadegaon, Amravati"],
"444907":[413,621,0.0,"Teosa Ghat, Amravati"],
"444908":[405,670,0.0,"Sawanga, Amravati"],
"444915":[306,556,0.0,"Dewara, Amravati"],
"445001":[310,573,0.0,"Yavatmal, Yavatmal"],
"445002":[315,575,0.0,"Ghodkhindi, Yavatmal"],
"445101":[296,565,0.0,"Dighi, Yavatmal"],
"445102":[392,722,0.0,"Brahmanwada, Yavatmal"],
"445103":[263,350,0.0,"Sakur, Yavatmal"],
"445105":[315,574,0.0,"Belora, Yavatmal"],
"445106":[290,-1,0.0,"Ayata, Yavatmal"],
"445109":[342,613,0.0,"Kolambi, Yavatmal"],
"445110":[382,658,0.0,"Haru, Yavatmal"],
"445201":[320,551,-1,"Borgaon (Linga ), Yavatmal"],
"445202":[402,863,-1,"Karajgaon, Yavatmal"],
"445203":[377,814,0.0,"Singad, Yavatmal"],
"445204":[466,653,0.0,"Jamni Dhundi, Yavatmal"],
"445205":[315,574,0.0,"Senad, Yavatmal"],
"445206":[291,613,0.0,"Belkhed, Yavatmal"],
"445207":[315,574,0.0,"Bittergaon, Yavatmal"],
"445209":[251,555,0.0,"Lohara Izara, Yavatmal"],
"445210":[390,560,0.0,"Hatola, Yavatmal"],
"445211":[254,608,0.0,"Palsi, Yavatmal"],
"445215":[452,594,0.0,"Dhansal, Yavatmal"],
"445216":[477,697,0.0,"P.N.C. Pusad, Yavatmal"],
"445230":[290,467,-1,"Morchandi, Yavatmal"],
"445301":[368,723,0.0,"Rajurwadi, Yavatmal"],
"445302":[352,610,0.0,"Akoli, Yavatmal"],
"445303":[302,608,0.0,"Chinchmandal, Yavatmal"],
"445304":[483,716,0.0,"Mukutban, Yavatmal"],
"445305":[525,877,0.0,"Arali, Yavatmal"],
"445306":[368,824,0.0,"Jamb, Yavatmal"],
"445307":[311,680,0.0,"Chikparam, Yavatmal"],
"445308":[333,562,0.0,"Pimpalapur, Yavatmal"],
"445323":[390,560,0.0,"Pahur Izara, Yavatmal"],
"445324":[344,532,0.0,"Matharjun, Yavatmal"],
"445401":[315,574,0.0,"Katri, Yavatmal"],
"445402":[377,682,0.0,"Zadgaon, Yavatmal"],
"450001":[278,562,0.0,"Khandwa, East Nimar"],
"450051":[280,434,0.0,"Sukva, East Nimar"],
"450110":[271,442,0.0,"Bhagwanpura, East Nimar"],
"450112":[192,326,0.0,"Gulgaon Raiyat, East Nimar"],
"450114":[307,489,0.0,"Gujarkhedi, East Nimar"],
"450116":[288,510,0.0,"Barud, East Nimar"],
"450117":[393,593,0.0,"Bhaganwa, East Nimar"],
"450119":[306,640,0.0,"Narmada Nagar S.O (East Nimar), East Nimar"],
"450221":[339,536,0.0,"Bhatkheda, Burhanpur"],
"450331":[350,685,0.0,"Biroda, Burhanpur"],
"450332":[338,594,0.0,"Manjrodkala, Burhanpur"],
"450337":[426,772,0.0,"Aabud, East Nimar"],
"450445":[374,806,0.0,"Bhawasa, Burhanpur"],
"450551":[282,472,0.0,"Attar, East Nimar"],
"450554":[300,501,0.0,"Mortakka, East Nimar"],
"450661":[439,703,0.0,"Diwal, East Nimar"],
"450771":[455,660,0.0,"Barud, East Nimar"],
"450881":[397,679,0.0,"Rajgadh, East Nimar"],
"450991":[205,394,0.0,"Kehlari, East Nimar"],
"451001":[286,634,0.0,"Khargone, Khargone"],
"451111":[325,629,0.0,"Badud, Khargone"],
"451113":[265,562,0.0,"Rahatkot, Khargone"],
"451114":[402,722,0.0,"Khedi Bujurg, Khargone"],
"451115":[325,686,0.0,"Jagatpura, Khargone"],
"451220":[390,903,0.0,"Bawi, Khargone"],
"451221":[319,748,0.0,"Choli, Khargone"],
"451224":[325,793,0.0,"Ashapur, Khargone"],
"451225":[416,978,0.0,"Pathrad, Khargone"],
"451228":[265,470,0.0,"Amlatha, Khargone"],
"451331":[440,745,0.0,"Behrampur, Khargone"],
"451332":[466,791,0.0,"Chainpur, Khargone"],
"451335":[406,878,0.0,"Dayalpura, Khargone"],
"451440":[222,568,0.0,"Satawad, Khargone"],
"451441":[282,546,0.0,"Bahadarpur, Khargone"],
"451442":[220,523,0.0,"Chitawal, Khargone"],
"451447":[367,714,0.0,"Badgaon, Barwani"],
"451449":[295,531,0.0,"Baghadi, Barwani"],
"451551":[478,775,0.0,"Bawangaja, Barwani"],
"451556":[438,898,0.0,"Balkuwan, Barwani"],
"451660":[213,608,0.0,"Dolani, Khargone"],
"451666":[460,771,0.0,"Dhanora, Barwani"],
"451770":[405,868,0.0,"Bandhara Bujurg, Barwani"],
"451881":[265,418,-1,"Rakhibujurg, Barwani"],
"452001":[349,611,0.0,"Indore G.P.O., Indore"],
"452002":[335,690,0.0,"Indore City 2, Indore"],
"452003":[335,629,0.0,"Indore Pardesipura, Indore"],
"452005":[335,687,0.0,"Indore Airport, Indore"],
"452006":[335,690,0.0,"Army Head Quarter, Indore"],
"452007":[335,656,0.0,"Indore Nagar, Indore"],
"452009":[335,629,0.0,"Lokmanya Nagar Indore, Indore"],
"452010":[335,625,0.0,"Indore DDU Nagar, Indore"],
"452011":[349,590,0.0,"Nanda Nagar, Indore"],
"452012":[168,555,0.0,"Rajendra Nagar S.O (Indore), Indore"],
"452013":[335,621,0.0,"Indore Cat, Indore"],
"452014":[349,640,0.0,"Khatiwala Tank, Indore"],
"452015":[302,608,0.0,"Indore Kumar Khadi, Indore"],
"452016":[374,596,0.0,"Sivani, Indore"],
"452018":[349,549,0.0,"Indore Tillaknagar, Indore"],
"452020":[328,600,0.0,"Machala, Indore"],
"452999":[349,603,0.0,"IIM CAMPUS RAO, Indore"],
"453001":[326,893,0.0,"Machal, Indore"],
"453111":[345,1040,0.0,"Alwasa, Indore"],
"453112":[335,690,0.0,"Jamburdi Hapsi, Indore"],
"453115":[360,1321,0.0,"Limbodapar, Indore"],
"453220":[340,1130,0.0,"Bhilbadoli, Indore"],
"453331":[302,970,0.0,"Rangwasa, Indore"],
"453441":[266,506,0.0,"Jamli, Indore"],
"453446":[208,583,0.0,"Rasalpura, Indore"],
"453551":[558,1204,0.0,"Fatehabad Chandrawati Ganj, Indore"],
"453552":[319,615,0.0,"Bai, Indore"],
"453555":[349,603,0.0,"Shri Aurobindo, Indore"],
"453556":[349,603,0.0,"IIM CAMPUS RAO, Indore"],
"453661":[266,505,0.0,"Hasalpur, Indore"],
"453771":[350,696,0.0,"Barlai Jagir, Indore"],
"454001":[253,602,0.0,"Dhar, Dhar"],
"454010":[199,509,0.0,"Lunhera, Dhar"],
"454111":[376,657,0.0,"Bhopawar, Dhar"],
"454116":[328,523,0.0,"Bhangarh, Dhar"],
"454221":[319,618,0.0,"Akhada, Dhar"],
"454331":[455,913,0.0,"Dharamrai, Dhar"],
"454335":[432,835,0.0,"Konda, Dhar"],
"454441":[454,963,0.0,"Bandedi, Dhar"],
"454446":[407,678,0.0,"Barda, Dhar"],
"454449":[269,505,0.0,"Kalibawdi, Dhar"],
"454552":[359,1187,0.0,"Bikhron, Dhar"],
"454660":[186,573,0.0,"Bakhatgarh, Dhar"],
"454665":[381,735,0.0,"Gajnod, Dhar"],
"454773":[278,751,0.0,"Kalsoda khurd, Dhar"],
"454774":[324,970,0.0,"Khandwa, Dhar"],
"454775":[307,620,0.0,"Pithampur, Dhar"],
"455001":[378,1124,0.0,"Dewas, Dewas"],
"455111":[410,1607,0.0,"Tigriya Chota, Dewas"],
"455115":[354,841,0.0,"Churlai Badi, Dewas"],
"455116":[297,704,0.0,"Bhutia Bujurg, Dewas"],
"455118":[339,671,0.0,"Anabad, Dewas"],
"455221":[312,520,0.0,"Dehriya Sahu, Dewas"],
"455223":[308,742,0.0,"Amlataj, Dewas"],
"455227":[271,579,0.0,"Agurli, Dewas"],
"455332":[308,657,0.0,"Baodi Kheda, Dewas"],
"455336":[232,572,0.0,"Chandwana, Dewas"],
"455339":[255,782,0.0,"Eklera, Dewas"],
"455440":[332,512,0.0,"Bedgaon, Dewas"],
"455459":[300,594,0.0,"Atwas, Dewas"],
"456001":[280,762,0.0,"Ujjain, Ujjain"],
"456003":[599,1263,0.0,"Kaliadeh, Ujjain"],
"456006":[280,736,0.0,"Kaluheda, Ujjain"],
"456010":[282,665,0.0,"Ujjain M.L.Nagar, Ujjain"],
"456221":[435,1023,0.0,"Paslod, Ujjain"],
"456222":[308,658,0.0,"Dangwada, Ujjain"],
"456224":[390,671,0.0,"Buranabad, Ujjain"],
"456313":[355,-1,0.0,"Bhikampur, Ujjain"],
"456331":[171,361,0.07,"Durgapura, Ujjain"],
"456335":[426,887,0.0,"Barkheda Pitramal, Ujjain"],
"456337":[405,885,0.0,"Makdavan, Ujjain"],
"456440":[442,799,0.0,"Sagwali, Ujjain"],
"456441":[386,669,0.0,"Gogakheda, Ujjain"],
"456443":[315,626,0.0,"Barkheda Buzurg, Ujjain"],
"456550":[460,865,0.0,"Dhabla Hardu, Ujjain"],
"456661":[290,772,0.0,"Badkummed, Ujjain"],
"456664":[335,882,0.0,"Matana Kalan, Ujjain"],
"456665":[255,1039,0.0,"Khajuria, Ujjain"],
"456668":[364,809,0.0,"Kadoudiya, Ujjain"],
"456770":[255,628,0.0,"Samgi, Ujjain"],
"456771":[253,607,0.0,"Piplu, Ujjain"],
"456776":[328,619,0.0,"Sundarabad, Ujjain"],
"457001":[302,902,0.0,"Ratlam, Ratlam"],
"457111":[302,902,0.0,"Hanumaniya, Ratlam"],
"457114":[398,756,0.0,"Piplia Sisodia, Ratlam"],
"457118":[430,1059,0.0,"Bardiagoyal, Ratlam"],
"457119":[405,683,0.0,"Luni, Ratlam"],
"457222":[345,852,0.0,"Baroda, Ratlam"],
"457226":[467,1197,0.0,"Lalakheda, Ratlam"],
"457331":[465,1019,0.0,"Baraylamataji, Ratlam"],
"457333":[275,769,0.04,"Sujapur, Ratlam"],
"457336":[409,802,0.0,"Gondishankar, Ratlam"],
"457339":[302,902,0.0,"Hanumaniya, Ratlam"],
"457340":[172,853,0.0,"Naveli, Ratlam"],
"457441":[218,541,0.0,"Dantodia, Ratlam"],
"457550":[244,848,0.0,"Kunda, Ratlam"],
"457555":[437,762,0.01,"Thikria, Ratlam"],
"457661":[407,830,0.0,"Jhabua, Jhabua"],
"457770":[365,874,0.0,"Amargarh, Jhabua"],
"457772":[407,861,0.0,"Kukdipada, Jhabua"],
"457773":[264,492,0.0,"Rupgarh, Jhabua"],
"457775":[376,611,0.0,"Bekalda, Jhabua"],
"457777":[278,806,0.0,"Bedawa, Jhabua"],
"457779":[350,806,0.0,"Panchkui, Jhabua"],
"457882":[249,506,0.0,"Amankunwa, Alirajpur"],
"457885":[248,473,0.01,"Kadwal, Alirajpur"],
"457887":[252,460,0.0,"Haraswat, Alirajpur"],
"457888":[210,420,0.0,"Bakhatgarh, Alirajpur"],
"457990":[275,635,0.0,"Bhilkhedi, Alirajpur"],
"457993":[385,817,0.0,"Kanjwanikhas, Jhabua"],
"458001":[410,763,0.03,"Mandsaur, Mandsaur"],
"458002":[429,741,0.02,"Amlawad, Mandsaur"],
"458110":[428,907,0.0,"Chukani, Neemuch"],
"458113":[428,913,0.0,"Aankali, Neemuch"],
"458116":[470,1031,0.0,"Piplia Ghota, Neemuch"],
"458118":[428,913,0.0,"Dudhlai, Neemuch"],
"458220":[316,717,0.0,"Lasur, Neemuch"],
"458226":[485,704,0.02,"Dorai, Neemuch"],
"458228":[316,717,0.0,"Dhangaon, Neemuch"],
"458330":[316,717,0.0,"Suwakheda, Neemuch"],
"458336":[320,776,0.0,"Harkia Khal, Neemuch"],
"458339":[385,650,0.0,"Chaldu, Neemuch"],
"458389":[286,681,0.0,"Jhangria, Mandsaur"],
"458441":[630,1242,0.0,"Neemuch, Neemuch"],
"458468":[320,784,0.0,"Kesharpura, Neemuch"],
"458470":[309,596,0.0,"Khor, Neemuch"],
"458553":[381,648,0.0,"Jharda, Mandsaur"],
"458556":[381,648,0.0,"Dorwada, Mandsaur"],
"458558":[418,743,0.0,"Vishnia Dak Bunglow, Mandsaur"],
"458664":[381,648,0.0,"Balaguda, Mandsaur"],
"458667":[212,626,0.0,"Akodara, Mandsaur"],
"458669":[283,673,0.04,"Patlawad, Mandsaur"],
"458771":[340,690,0.11,"C.C. Camp, Mandsaur"],
"458775":[212,606,0.0,"Hamirgarh, Mandsaur"],
"458778":[302,564,0.0,"Dhuan Khedi, Mandsaur"],
"458880":[321,525,0.0,"Barkheda Loya, Mandsaur"],
"458883":[366,739,0.0,"Baghunia, Mandsaur"],
"458888":[366,731,0.0,"Dhalpat, Mandsaur"],
"458895":[268,845,0.0,"Afzalpur, Mandsaur"],
"458990":[453,867,0.0,"Rathana, Mandsaur"],
"460001":[245,535,0.0,"Betul, Betul"],
"460004":[252,540,0.0,"Bagholi, Betul"],
"460110":[336,533,0.0,"Gargud, Betul"],
"460220":[233,337,0.0,"Belkund, Betul"],
"460225":[196,372,0.0,"Kumbhi, Betul"],
"460330":[216,368,0.0,"Awaria Chicholi, Betul"],
"460440":[314,504,0.0,"Bhaiyawari, Betul"],
"460443":[350,570,0.0,"Dharakhoh, Betul"],
"460447":[319,475,0.0,"Rajegaon Khapa Ryt, Betul"],
"460449":[323,495,0.0,"Salaiya, Betul"],
"460551":[255,433,0.0,"Jambada, Betul"],
"460553":[285,484,0.0,"Nahiya, Betul"],
"460554":[475,799,0.0,"Chhipanya Pipariya, Betul"],
"460557":[286,422,0.0,"Goula, Betul"],
"460661":[223,428,0.0,"Khedlibazar, Betul"],
"460663":[297,505,0.0,"Barkhed, Betul"],
"460665":[160,303,0.0,"Mangonakhurd, Betul"],
"460666":[247,365,0.0,"Dhabla, Betul"],
"460668":[329,414,0.0,"Etawa Masod, Betul"],
"461001":[413,685,0.0,"Hoshangabad, Hoshangabad"],
"461005":[376,664,0.0,"Sp Mills Hoshangabad, Hoshangabad"],
"461110":[413,670,0.0,"Reshalpur, Hoshangabad"],
"461111":[335,603,0.0,"Gurra, Hoshangabad"],
"461114":[348,583,0.0,"Cpe Itarsi, Hoshangabad"],
"461115":[335,607,0.0,"Bhatti, Hoshangabad"],
"461116":[208,673,0.0,"Tigria, Hoshangabad"],
"461122":[335,549,0.0,"OFE Itarsi, Hoshangabad"],
"461221":[376,629,0.0,"Chatarkheda, Hoshangabad"],
"461223":[351,702,0.0,"B.Jamani, Hoshangabad"],
"461228":[280,646,0.0,"Bajania, Harda"],
"461331":[290,721,0.0,"Pachola, Harda"],
"461335":[264,559,0.0,"Rolgaon, Harda"],
"461441":[292,435,0.0,"Bediakala, Harda"],
"461445":[292,559,0.0,"Budni Ghat, Sehore"],
"461446":[413,681,0.0,"Of Itarsi, Hoshangabad"],
"461551":[291,880,0.0,"Pipliya Kala, Hoshangabad"],
"461661":[376,658,0.0,"Anchalkheda, Hoshangabad"],
"461668":[323,574,0.0,"Sangakhedakhurd, Hoshangabad"],
"461771":[300,453,0.0,"Kalmeshra, Hoshangabad"],
"461775":[360,526,0.0,"Garhaghat, Hoshangabad"],
"461881":[199,293,0.0,"Pagara, Hoshangabad"],
"461990":[352,658,0.0,"Chandon, Hoshangabad"],
"462001":[276,524,0.0,"Bhopal G.P.O., Bhopal"],
"462002":[273,478,0.0,"Vidya Vihar, Bhopal"],
"462003":[273,486,0.0,"C.T.T.Nagar, Bhopal"],
"462004":[276,498,0.0,"M.P. Vidhan Sabha, Bhopal"],
"462008":[276,518,0.0,"Barkhedi, Bhopal"],
"462010":[276,508,0.0,"Sukhi Sewania, Bhopal"],
"462011":[276,494,0.0,"Shiksha Mandal, Bhopal"],
"462016":[273,481,0.0,"R.S.Market, Bhopal"],
"462020":[262,454,0.0,"AIIMS, Bhopal"],
"462022":[270,508,0.0,"Bhel, Bhopal"],
"462023":[273,503,0.0,"Govindpura, Bhopal"],
"462024":[262,464,0.0,"H.E. Hospital, Bhopal"],
"462026":[273,482,0.0,"Bawadia Kalan, Bhopal"],
"462027":[276,505,0.0,"Arera Hills, Bhopal"],
"462028":[273,516,0.0,"Kokta, Bhopal"],
"462030":[276,444,0.0,"Khajuri Sadak, Bhopal"],
"462031":[276,442,0.0,"3 EME Centre, Bhopal"],
"462033":[277,464,0.0,"RGPV, Bhopal"],
"462034":[270,420,0.0,"Mungalia Chhap, Bhopal"],
"462036":[265,429,0.0,"Tara Sewaniya, Bhopal"],
"462037":[276,502,0.0,"Peoples Campus, Bhopal"],
"462038":[281,538,0.0,"Eintkhedi, Bhopal"],
"462039":[270,443,0.0,"Trilanga, Bhopal"],
"462040":[273,489,0.0,"IBD Hallmark city kolar road, Bhopal"],
"462041":[213,416,0.0,"Ayodhaya Nagar, Bhopal"],
"462042":[270,455,0.0,"Amarawat Kalan, Bhopal"],
"462043":[254,465,0.0,"Bag Mungalia, Bhopal"],
"462044":[271,441,0.0,"Mungalia Chhap, Bhopal"],
"462045":[273,517,0.0,"Bangrasia, Bhopal"],
"462046":[229,439,0.0,"Satalapur, Raisen"],
"462047":[229,421,0.0,"Palas Indus Town, Bhopal"],
"462057":[276,505,0.0,"Arera Hills, Bhopal"],
"462066":[254,402,0.0,"IISER Bhouri, Bhopal"],
"462099":[276,506,0.0,"Bhopal G.P.O., Bhopal"],
"462100":[276,494,0.0,"Nariyalkheda, Bhopal"],
"462101":[287,518,0.0,"Gunga, Bhopal"],
"462116":[270,423,0.0,"Trilanga, Bhopal"],
"462120":[304,631,0.0,"Mangal Garh, Bhopal"],
"463106":[330,522,0.0,"Balachoan, Bhopal"],
"463111":[307,498,0.0,"Bawachiya, Bhopal"],
"464001":[342,591,0.0,"Vidisha, Vidisha"],
"464111":[290,538,0.0,"Dangarwada, Vidisha"],
"464113":[220,479,0.0,"Beenjh, Vidisha"],
"464114":[302,499,0.0,"Danwas, Vidisha"],
"464220":[215,639,0.0,"Andiakala, Vidisha"],
"464221":[280,470,0.0,"Ambanagar, Vidisha"],
"464224":[535,890,0.0,"Piklone, Vidisha"],
"464226":[294,648,0.0,"Barro, Vidisha"],
"464228":[302,548,0.0,"Deepnakheda, Vidisha"],
"464240":[344,625,0.0,"Dudhawari, Vidisha"],
"464258":[285,415,0.0,"Deokhajuri, Vidisha"],
"464331":[330,624,0.0,"Dhamnod, Vidisha"],
"464334":[365,646,0.0,"Mainwada, Vidisha"],
"464337":[317,646,0.0,"Khajuriya, Vidisha"],
"464551":[263,493,0.0,"Raisen, Raisen"],
"464570":[304,436,0.0,"Bamhorititore, Raisen"],
"464573":[285,632,0.0,"Bankhedi, Raisen"],
"464651":[347,673,0.0,"Berkhedi, Raisen"],
"464661":[317,562,0.0,"Banskheda, Raisen"],
"464665":[229,574,0.0,"Harsili, Raisen"],
"464668":[277,569,0.0,"Bagpiparia, Raisen"],
"464671":[377,748,0.0,"Noornagar, Raisen"],
"464672":[275,680,0.0,"Keeratpur, Raisen"],
"464770":[306,562,0.0,"Anghora, Raisen"],
"464774":[281,468,0.0,"Gorakhpur, Raisen"],
"464881":[395,580,0.0,"Begumganj Tahsil, Raisen"],
"464884":[375,624,0.0,"Agariakalan, Raisen"],
"464886":[306,474,0.0,"Jaithari, Raisen"],
"464986":[237,492,0.0,"Bagaspur, Raisen"],
"464990":[260,504,0.0,"Pahad Khedi, Raisen"],
"464993":[216,511,0.0,"Salkani, Raisen"],
"465001":[326,567,0.0,"Shajapur, Shajapur"],
"465106":[236,600,0.0,"Jhokar, Shajapur"],
"465110":[338,615,0.0,"BERCHHA TOWN, Shajapur"],
"465113":[302,520,0.0,"Simrol, Shajapur"],
"465116":[327,647,0.0,"Mortakhevdi, Shajapur"],
"465118":[388,796,0.0,"PADLIYA, Shajapur"],
"465220":[328,662,0.0,"Gulana, Shajapur"],
"465223":[368,714,0.0,"Uchod, Shajapur"],
"465226":[397,735,0.0,"Dudhana, Shajapur"],
"465227":[328,687,0.0,"Mitera, Shajapur"],
"465230":[388,966,0.0,"Pachlana, Agar Malwa"],
"465313":[351,778,0.0,"Mungawadi, Ujjain"],
"465333":[357,740,0.0,"Raipur, Shajapur"],
"465335":[308,662,0.0,"Amlay, Shajapur"],
"465337":[302,504,0.0,"Behraval, Shajapur"],
"465339":[314,514,0.0,"Bhaisaygarh, Shajapur"],
"465441":[298,571,0.0,"Palkhedi, Agar Malwa"],
"465445":[212,680,0.0,"Badagaon, Agar Malwa"],
"465447":[274,550,0.0,"Payli, Agar Malwa"],
"465449":[200,573,0.0,"Dogargaon, Agar Malwa"],
"465550":[283,555,0.0,"Bapcha, Agar Malwa"],
"465661":[245,440,0.0,"Rajgarh(Bia), Rajgarh"],
"465667":[333,526,0.0,"Geelakhedi, Rajgarh"],
"465669":[492,795,0.0,"Bagwaaj, Rajgarh"],
"465674":[262,527,0.0,"Aamliyahat, Rajgarh"],
"465677":[452,462,0.0,"Mau, Rajgarh"],
"465679":[276,606,0.11,"Durgpur, Rajgarh"],
"465680":[344,735,0.0,"Amlaar, Rajgarh"],
"465683":[342,771,0.0,"Dehri Kalan, Rajgarh"],
"465685":[492,838,0.0,"Dhabla, Rajgarh"],
"465687":[210,608,0.0,"Leemachouhan, Rajgarh"],
"465689":[210,565,0.0,"Bhatkheda, Rajgarh"],
"465691":[220,616,0.0,"Dhatarawda, Rajgarh"],
"465693":[292,528,0.01,"Ghoghatpur, Rajgarh"],
"465697":[341,716,0.0,"Ashareta, Rajgarh"],
"466001":[217,533,0.0,"Sehore, Sehore"],
"466111":[270,526,0.0,"Aabidabad, Sehore"],
"466113":[302,745,0.0,"Dhamnda, Sehore"],
"466114":[414,918,0.0,"Gavakheda, Sehore"],
"466115":[339,635,0.0,"Bhaukhedi, Sehore"],
"466116":[338,650,0.0,"Barkheda, Sehore"],
"466118":[709,1275,0.0,"Gwali, Sehore"],
"466120":[414,763,0.0,"Jasmat, Sehore"],
"466125":[350,491,0.13,"Baijnath, Sehore"],
"466221":[702,1238,0.0,"Arniyagaji, Sehore"],
"466331":[291,972,0.0,"Chhitgaonmoji, Sehore"],
"466445":[356,624,0.0,"Budhni T.N., Sehore"],
"466446":[250,572,0.0,"Amirganj, Sehore"],
"466448":[270,554,0.0,"Nandner, Sehore"],
"466554":[248,417,0.0,"Dobi, Sehore"],
"466651":[324,352,0.0,"Kachnariya, Sehore"],
"466661":[277,399,0.0,"Paatan, Sehore"],
"466665":[386,583,0.0,"Barkheda Hasan, Sehore"],
"470001":[275,443,0.0,"Sagar Cantt, Sagar"],
"470002":[275,459,0.0,"Sagar Bada Bazar, Sagar"],
"470003":[255,415,0.0,"Sagar University, Sagar"],
"470004":[255,551,0.0,"Gambhiriyia, Sagar"],
"470021":[542,817,0.0,"Girwar, Sagar"],
"470051":[320,560,0.0,"Baxwaha, Sagar"],
"470113":[385,677,0.0,"Dewal, Sagar"],
"470115":[332,537,0.0,"Bidwasan, Sagar"],
"470117":[245,822,0.0,"Kumrol, Sagar"],
"470118":[308,627,0.0,"Bharchha, Sagar"],
"470119":[390,677,0.0,"Khari Gumariya, Sagar"],
"470120":[303,513,0.0,"Bhaisa, Sagar"],
"470124":[472,800,0.0,"Bina BPCL Refinery, Sagar"],
"470125":[337,605,0.0,"Karaiya, Sagar"],
"470221":[307,786,0.0,"Udaypura Tiwari, Sagar"],
"470223":[313,479,0.0,"Madi Jamuniya, Sagar"],
"470226":[333,612,0.0,"Rajola, Sagar"],
"470227":[327,518,0.0,"Boma, Sagar"],
"470228":[307,546,0.0,"Patna Buzurg, Sagar"],
"470229":[292,602,0.0,"Garhakota, Sagar"],
"470232":[487,585,0.0,"Chapra, Sagar"],
"470235":[297,477,0.0,"Kanjera, Sagar"],
"470335":[276,652,0.0,"Barayatha, Sagar"],
"470337":[374,608,0.0,"Panari, Sagar"],
"470339":[480,738,0.0,"Bagrohi, Sagar"],
"470340":[215,528,0.0,"Papet, Sagar"],
"470441":[271,622,0.0,"Khiriya Kala, Sagar"],
"470442":[223,426,0.0,"Chandrapur, Sagar"],
"470661":[286,522,0.0,"Damoh, Damoh"],
"470663":[188,462,0.0,"Jalhari, Damoh"],
"470664":[288,597,0.0,"Ballarpur, Damoh"],
"470666":[317,441,0.0,"Nandrai, Damoh"],
"470669":[292,543,0.0,"Tada, Sagar"],
"470672":[284,533,0.0,"Chourai, Damoh"],
"470673":[278,438,0.0,"Agara, Damoh"],
"470675":[239,460,0.0,"Aslana, Damoh"],
"470771":[294,471,0.0,"Gunji, Damoh"],
"470772":[149,574,0.0,"Barkhera Bais, Damoh"],
"470775":[212,512,0.0,"Bardha, Damoh"],
"470776":[252,483,0.0,"Madiyado, Damoh"],
"470880":[210,402,0.0,"Ramgarh, Damoh"],
"470881":[272,471,0.0,"Korta, Damoh"],
"471001":[303,698,0.0,"Chhatarpur, Chhatarpur"],
"471101":[291,573,0.0,"Dhamna, Chhatarpur"],
"471105":[303,721,0.0,"Jamtuli, Chhatarpur"],
"471111":[261,646,0.0,"Kenthokar, Chhatarpur"],
"471201":[405,611,0.0,"Bangain, Chhatarpur"],
"471301":[275,422,0.0,"Atrar, Chhatarpur"],
"471311":[308,510,0.0,"Kayan, Chhatarpur"],
"471313":[256,377,0.0,"Bhagwan, Chhatarpur"],
"471315":[481,771,0.0,"Deri, Chhatarpur"],
"471318":[300,459,0.0,"Bamhori, Chhatarpur"],
"471405":[198,326,0.0,"Dharampura, Chhatarpur"],
"471408":[190,256,0.0,"Bandani, Chhatarpur"],
"471411":[320,551,0.0,"Nuna, Chhatarpur"],
"471501":[400,576,0.0,"Budrakh, Chhatarpur"],
"471510":[238,388,0.0,"Kherakasar, Chhatarpur"],
"471515":[492,972,0.0,"Aktonha, Chhatarpur"],
"471516":[383,596,0.0,"Pahara, Chhatarpur"],
"471525":[375,577,0.0,"Bachhon, Chhatarpur"],
"471606":[353,634,0.0,"Beniganj, Chhatarpur"],
"471625":[271,402,0.0,"Khajuwa, Chhatarpur"],
"472001":[306,877,0.0,"Tikamgarh, Tikamgarh"],
"472005":[292,645,0.0,"Judawan, Tikamgarh"],
"472010":[324,599,0.0,"Lar, Tikamgarh"],
"472101":[303,526,0.0,"Acharra, Tikamgarh"],
"472111":[286,440,0.0,"Dikoli Chowk, Tikamgarh"],
"472115":[265,439,0.0,"Banne Bujraj, Tikamgarh"],
"472118":[298,478,0.0,"Jarua, Tikamgarh"],
"472221":[302,548,0.0,"Banne Khurd, Tikamgarh"],
"472246":[450,591,0.0,"Chakarpur, Niwari"],
"472331":[306,590,0.0,"Marguwna, Tikamgarh"],
"472336":[312,505,0.0,"Daretha, Niwari"],
"472337":[312,442,0.0,"Beersagar, Niwari"],
"472339":[288,562,0.0,"Bachhora, Tikamgarh"],
"472442":[318,568,0.0,"Pohakhas, Niwari"],
"472445":[300,576,0.0,"Shaktibheron, Niwari"],
"472447":[288,496,0.0,"Bahera, Niwari"],
"473001":[290,510,0.0,"Guna, Guna"],
"473101":[295,510,0.0,"Barkhrda Hat, Guna"],
"473105":[251,475,0.0,"Dibiya Manpur, Guna"],
"473106":[357,604,0.08,"Dibiya Manpur, Guna"],
"473110":[301,516,0.0,"Barodiya Kalan, Guna"],
"473111":[277,506,0.0,"Bhamawad, Guna"],
"473112":[290,510,0.0,"Gail Complex, Guna"],
"473113":[290,516,0.0,"Bhadora, Guna"],
"473115":[421,653,0.0,"Barkheda Khurd, Guna"],
"473118":[255,539,0.0,"Umarthana, Guna"],
"473222":[252,524,0.0,"Barod, Guna"],
"473226":[252,478,0.0,"Kherai, Guna"],
"473249":[290,500,0.0,"Gehunkheda, Guna"],
"473287":[415,731,0.0,"Torai, Guna"],
"473330":[304,679,0.0,"Pipri, Ashoknagar"],
"473331":[314,551,0.0,"Ashoknagar, Ashoknagar"],
"473332":[296,600,0.0,"Piprol Nai Saray, Ashoknagar"],
"473335":[262,438,0.0,"Dhakoni, Ashoknagar"],
"473440":[342,562,0.0,"Keshopur, Ashoknagar"],
"473443":[331,657,0.0,"Kirola, Ashoknagar"],
"473444":[239,451,0.0,"Pathari, Ashoknagar"],
"473445":[504,893,0.0,"Bawrod, Ashoknagar"],
"473446":[184,404,0.0,"Dungasara, Ashoknagar"],
"473447":[247,388,0.0,"Kadwaya, Ashoknagar"],
"473551":[272,579,0.0,"Shivpuri, Shivpuri"],
"473585":[369,663,0.0,"Pipra, Shivpuri"],
"473638":[170,481,0.0,"Bichi, Shivpuri"],
"473660":[304,615,0.0,"Karotha, Shivpuri"],
"473662":[304,665,0.0,"Karahi, Shivpuri"],
"473665":[274,542,0.0,"Dhand, Shivpuri"],
"473670":[315,594,0.0,"Pipra Pichhore, Shivpuri"],
"473770":[206,463,0.01,"Kharai, Shivpuri"],
"473773":[284,574,0.0,"Barod, Shivpuri"],
"473774":[227,576,0.03,"Sakhnor, Shivpuri"],
"473775":[330,687,0.0,"Chakrana, Shivpuri"],
"473781":[246,362,0.0,"Kutwara, Shivpuri"],
"473793":[328,655,0.0,"Khatka, Shivpuri"],
"473865":[301,627,0.0,"Sehore, Shivpuri"],
"473880":[336,582,0.0,"Tharkheda, Shivpuri"],
"473885":[322,849,0.1,"Bamore, Shivpuri"],
"473990":[375,805,0.0,"Deokho, Shivpuri"],
"473995":[401,914,0.0,"Karar Kheda, Shivpuri"],
"474001":[250,404,0.0,"Lashkar, Gwalior"],
"474002":[260,368,0.0,"Defence Colony S.O (Gwalior, Gwalior"],
"474003":[260,379,0.0,"Hazira Chowk, Gwalior"],
"474004":[260,368,0.0,"Birla Nagar, Gwalior"],
"474005":[227,397,0.0,"Bhadroli, Gwalior"],
"474006":[260,368,0.0,"Morar, Gwalior"],
"474007":[260,368,0.0,"Moti Mahal, Gwalior"],
"474008":[260,368,0.0,"Gwalior Fort, Gwalior"],
"474009":[250,404,0.0,"Naya Bazar S.O (Gwalior, Gwalior"],
"474010":[223,428,0.0,"Sigora, Gwalior"],
"474011":[260,368,0.0,"Jiwaji University, Gwalior"],
"474012":[250,404,0.0,"S.P. Ashram, Gwalior"],
"474015":[260,368,0.0,"AB VIII TM Gwalior, Gwalior"],
"474020":[264,578,0.0,"Senthri, Gwalior"],
"475001":[212,534,0.0,"Rora, Gwalior"],
"475002":[215,350,0.0,"Hastinapur, Gwalior"],
"475005":[212,632,0.0,"Kalyani, Gwalior"],
"475110":[310,692,0.0,"Chandpur, Gwalior"],
"475115":[259,574,0.0,"Sukhapatha, Gwalior"],
"475220":[310,630,0.0,"Kheda, Gwalior"],
"475330":[240,449,0.0,"Sabrai, Gwalior"],
"475331":[262,462,0.0,"Ghatigaon, Gwalior"],
"475335":[242,474,0.0,"Salon A, Datia"],
"475336":[266,435,0.0,"Jouri, Datia"],
"475661":[435,729,0.0,"Khiria Ghonghu, Datia"],
"475671":[435,792,0.0,"Sadwara, Datia"],
"475673":[380,889,0.0,"Parsoda Khurd, Datia"],
"475675":[265,580,0.0,"Uchad, Datia"],
"475682":[291,691,0.0,"Mangrol, Datia"],
"475685":[356,644,0.0,"Raori, Datia"],
"475686":[342,682,0.0,"Lamkana, Datia"],
"476001":[447,722,0.0,"Morena, Morena"],
"476111":[384,783,0.19,"Parikshit Ka Pura, Morena"],
"476115":[310,767,0.0,"Tareni, Morena"],
"476134":[493,789,0.0,"Sirmorkapura, Morena"],
"476219":[350,747,0.57,"Galetha, Morena"],
"476221":[369,699,0.0,"Bilgoun, Morena"],
"476224":[343,823,0.0,"Khutiyanihar, Morena"],
"476228":[375,892,0.0,"Mamchon, Morena"],
"476229":[349,500,0.0,"Jalalgarh, Morena"],
"476332":[344,867,0.0,"Gohta, Sheopur"],
"476335":[386,768,0.0,"Shyampur, Sheopur"],
"476337":[328,682,0.0,"Tillipur, Sheopur"],
"476338":[389,755,0.0,"Shyampur, Sheopur"],
"476339":[400,724,0.0,"Awada, Sheopur"],
"476355":[257,473,0.0,"Budhera (Karhal), Sheopur"],
"476444":[441,752,0.0,"Jaitpur, Morena"],
"476554":[493,811,0.0,"Lallu Basai, Morena"],
"477001":[270,652,0.0,"Bhind, Bhind"],
"477105":[270,662,0.0,"Didi, Bhind"],
"477111":[280,844,0.0,"Akon, Bhind"],
"477116":[355,1195,0.0,"Piparsana, Bhind"],
"477117":[439,1062,0.0,"Rayat pura, Bhind"],
"477222":[285,1234,0.0,"Ghamori, Bhind"],
"477227":[285,1415,0.0,"Adokhar, Bhind"],
"477331":[262,559,0.0,"Bajhai, Bhind"],
"477332":[268,631,0.0,"Heera Lalka Pura, Bhind"],
"477333":[253,764,0.0,"Tehangur, Bhind"],
"477335":[274,1065,0.0,"Indurkhi, Bhind"],
"477441":[160,1399,0.0,"Muratpura, Bhind"],
"477445":[236,997,0.0,"Heerapura (lahar), Bhind"],
"477446":[240,591,0.0,"Jalalpura (Aswar So), Bhind"],
"477447":[240,431,0.0,"Devari, Bhind"],
"477449":[240,451,0.0,"Gangepura, Bhind"],
"477450":[239,647,0.0,"Rawatpura sarkar ashram B.o, Bhind"],
"477555":[330,795,0.0,"Aheti, Bhind"],
"477557":[286,1581,0.0,"Gutor, Bhind"],
"477566":[305,805,0.0,"Badepura, Bhind"],
"477660":[270,1080,0.0,"Akloni, Bhind"],
"480001":[379,570,0.0,"Chhindwara, Chhindwara"],
"480003":[379,580,0.0,"CHANDANGAON, Chhindwara"],
"480105":[338,592,0.0,"Nandewani, Chhindwara"],
"480106":[379,745,0.0,"Nimni, Chhindwara"],
"480107":[290,465,0.0,"Parasgaon, Chhindwara"],
"480108":[383,640,0.0,"Ghoti, Chhindwara"],
"480109":[379,637,0.0,"Koparwari, Chhindwara"],
"480110":[260,542,0.0,"Dilawar Mohgaon, Chhindwara"],
"480111":[297,477,0.0,"Deori, Chhindwara"],
"480112":[263,375,0.0,"Palaspani, Chhindwara"],
"480115":[364,545,0.0,"Kunda, Chhindwara"],
"480221":[234,386,0.0,"Barahira, Chhindwara"],
"480223":[330,699,0.0,"Sarna, Chhindwara"],
"480224":[229,453,0.0,"Banka, Chhindwara"],
"480331":[342,539,0.0,"Pipariya, Chhindwara"],
"480334":[212,413,0.0,"Changoba, Chhindwara"],
"480337":[281,508,0.0,"Anjangaon, Chhindwara"],
"480338":[226,423,0.0,"wadegaon, Chhindwara"],
"480441":[269,536,0.0,"Dighawani, Chhindwara"],
"480442":[330,563,0.0,"Jamuniya Jethu, Chhindwara"],
"480447":[289,550,0.0,"Barkuhi, Chhindwara"],
"480449":[253,543,0.0,"Darbai, Chhindwara"],
"480551":[282,543,0.0,"Barelipar, Chhindwara"],
"480555":[341,532,0.0,"Dhobe, Chhindwara"],
"480557":[266,527,0.0,"Kundali, Chhindwara"],
"480559":[298,447,0.0,"Bijori, Chhindwara"],
"480661":[208,469,0.0,"Seoni, Seoni"],
"480667":[265,589,0.0,"Dhobisarra, Seoni"],
"480771":[182,389,0.0,"Darasikala, Seoni"],
"480880":[357,745,0.0,"Patan, Seoni"],
"480881":[208,469,0.0,"Riddi, Seoni"],
"480882":[215,389,0.0,"Kalarbanki, Seoni"],
"480884":[251,399,0.0,"Anjania, Seoni"],
"480886":[357,745,0.0,"Bamhanwada, Seoni"],
"480887":[234,370,0.0,"Imaliya Raitwar, Seoni"],
"480888":[250,385,0.0,"Nagandeori, Seoni"],
"480990":[244,425,0.0,"Chhindbarri, Seoni"],
"480991":[232,451,0.0,"Panjara, Seoni"],
"480994":[244,367,0.0,"Baghai, Seoni"],
"480996":[232,452,0.0,"Durenda, Seoni"],
"480997":[304,442,0.0,"Ataria, Seoni"],
"480999":[276,479,0.0,"Ganeri, Seoni"],
"481001":[182,388,0.0,"Balaghat, Balaghat"],
"481051":[207,306,0.0,"Bakal, Balaghat"],
"481102":[302,469,0.0,"MOHANPUR, Balaghat"],
"481105":[182,389,0.0,"KINARDA, Balaghat"],
"481111":[280,575,0.0,"Sarekha, Balaghat"],
"481115":[206,425,0.0,"Kandrikala, Balaghat"],
"481116":[214,299,0.0,"Gudma, Balaghat"],
"481117":[182,366,0.0,"BHALAPURI, Balaghat"],
"481222":[302,517,0.0,"Kalimati, Balaghat"],
"481224":[235,618,0.0,"Devalgaon, Balaghat"],
"481226":[212,489,0.0,"Kariadand, Balaghat"],
"481331":[194,351,0.0,"Beni, Balaghat"],
"481332":[182,367,0.0,"Kochewahi, Balaghat"],
"481335":[237,570,0.0,"GUNAI, Balaghat"],
"481337":[395,719,0.0,"Saleteka, Balaghat"],
"481441":[217,443,0.0,"Kanjai, Balaghat"],
"481445":[293,787,0.0,"Jam, Balaghat"],
"481449":[230,465,0.0,"Bamhani, Balaghat"],
"481551":[194,539,0.0,"Charegaon R.S., Balaghat"],
"481556":[297,398,0.0,"Bhidi, Balaghat"],
"481661":[303,509,0.0,"Mandla, Mandla"],
"481662":[336,567,0.0,"Devhar, Mandla"],
"481663":[173,264,0.0,"Singarpur, Mandla"],
"481664":[222,323,0.0,"Patan, Mandla"],
"481665":[174,303,0.0,"Ahmedpur, Mandla"],
"481666":[385,591,0.0,"Pondimal, Mandla"],
"481668":[288,447,0.0,"Bharweli, Mandla"],
"481672":[166,290,0.0,"Chhirpani, Mandla"],
"481768":[236,332,0.0,"Chichgaon, Mandla"],
"481771":[244,384,0.0,"Dhenko, Mandla"],
"481776":[180,296,0.0,"Gokulthana, Mandla"],
"481778":[252,398,0.0,"Fitari, Dindori"],
"481879":[167,330,0.0,"Amani Piparia, Dindori"],
"481880":[95,337,0.0,"Chhanta, Dindori"],
"481882":[290,474,0.0,"Khargahna, Dindori"],
"481883":[263,427,0.0,"Teliapani Ledara, Dindori"],
"481884":[232,401,0.65,"Bhusanda, Dindori"],
"481885":[404,647,0.0,"Chhapra, Dindori"],
"481990":[214,301,0.0,"Manikpur, Dindori"],
"481995":[160,288,0.0,"Anjani, Mandla"],
"481996":[266,461,0.0,"Dhangaon, Mandla"],
"481998":[340,519,0.0,"Dudka, Mandla"],
"482001":[210,395,0.0,"Jabalpur, Jabalpur"],
"482002":[210,381,0.0,"Archha, Jabalpur"],
"482003":[210,390,0.0,"Ghat Piparia, Jabalpur"],
"482004":[210,409,0.0,"Maharajpur, Jabalpur"],
"482005":[228,433,0.0,"Sunderpur, Jabalpur"],
"482007":[210,380,0.0,"Jabalpur, Jabalpur"],
"482008":[210,381,0.0,"Bargi IPC, Jabalpur"],
"482009":[210,442,0.0,"Shobhapur, Jabalpur"],
"482010":[210,416,0.0,"Richhai, Jabalpur"],
"482011":[210,426,0.0,"Gokulpur, Jabalpur"],
"482020":[210,393,0.0,"Bilhari, Jabalpur"],
"482021":[210,427,0.0,"Khamaria Neemkheda, Jabalpur"],
"482051":[218,459,0.0,"Mohas, Jabalpur"],
"482056":[241,428,0.0,"Sahajpuri, Jabalpur"],
"483001":[219,415,0.0,"Khukkham, Jabalpur"],
"483053":[161,414,0.0,"Majhita, Jabalpur"],
"483105":[293,783,0.0,"Boria, Jabalpur"],
"483110":[366,561,0.0,"Tauri, Jabalpur"],
"483113":[232,412,0.0,"Kymori, Jabalpur"],
"483119":[310,483,0.0,"Bhaironghat Pipariya, Jabalpur"],
"483220":[215,403,0.0,"Badkheda, Jabalpur"],
"483222":[232,448,0.0,"Gandhi Gram, Jabalpur"],
"483225":[249,416,0.0,"Badkhera, Katni"],
"483330":[312,516,0.0,"Gatakheda, Katni"],
"483331":[222,476,0.0,"Imalaiya, Katni"],
"483332":[329,471,0.0,"Biharia, Katni"],
"483334":[249,416,0.0,"Gaura Khamaria, Katni"],
"483336":[232,448,0.0,"Khitola, Jabalpur"],
"483440":[263,403,0.0,"Deorimawai, Katni"],
"483442":[237,373,0.0,"Padarbhata, Katni"],
"483501":[210,357,0.0,"Katni, Katni"],
"483504":[176,372,0.0,"Mangal Nagar, Katni"],
"483770":[255,422,0.0,"Adarsh Gram Dhabaiya, Katni"],
"483773":[166,190,0.0,"Vilayat Kalan, Katni"],
"483775":[99,367,0.0,"Singodi, Katni"],
"483880":[321,697,0.0,"Kharkhari, Katni"],
"483990":[320,665,0.0,"Khamaria Jhanda, Katni"],
"484001":[246,427,0.0,"Shahdol, Shahdol"],
"484110":[250,509,0.0,"Amraha, Shahdol"],
"484113":[197,352,0.31,"Cholna, Anuppur"],
"484114":[206,382,0.0,"Dhanpuri, Shahdol"],
"484116":[213,375,0.0,"Kelhauri, Anuppur"],
"484117":[277,443,0.0,"Bargawan, Shahdol"],
"484120":[265,551,0.0,"S.K. Nagar, Anuppur"],
"484220":[213,379,0.0,"Chachai, Anuppur"],
"484224":[240,378,0.0,"Audhera, Anuppur"],
"484330":[160,303,0.0,"Gorsi, Anuppur"],
"484334":[210,441,0.0,"Koti, Shahdol"],
"484336":[200,377,0.0,"Barbaspur, Anuppur"],
"484440":[191,348,0.01,"Baitola, Anuppur"],
"484444":[201,355,0.0,"Latar, Anuppur"],
"484446":[189,397,0.0,"Bangawan, Anuppur"],
"484447":[196,369,0.38,"Bhad, Anuppur"],
"484551":[248,385,0.0,"Mangthar, Umaria"],
"484555":[142,283,0.0,"Baskuta, Umaria"],
"484660":[220,231,0.0,"Bilaspur, Umaria"],
"484661":[204,396,0.0,"Mairee, Umaria"],
"484664":[210,422,0.0,"Milli, Umaria"],
"484665":[206,250,0.0,"Majhauli, Umaria"],
"484669":[205,343,0.0,"Kadaudi, Shahdol"],
"484770":[175,392,0.0,"Barkoda, Shahdol"],
"484771":[157,320,0.0,"Amjhor, Shahdol"],
"484774":[220,485,0.0,"Baraundha, Shahdol"],
"484776":[242,398,0.0,"Jagmal, Shahdol"],
"484881":[314,515,0.0,"Gonda, Shahdol"],
"484886":[193,316,0.0,"Khajurwar, Anuppur"],
"484887":[209,344,0.0,"Amgawan, Anuppur"],
"485001":[361,769,0.0,"Satna, Satna"],
"485005":[194,332,0.0,"Badkhar, Satna"],
"485111":[194,332,0.0,"Bairiha, Satna"],
"485112":[194,332,0.0,"Khamaria, Satna"],
"485113":[361,769,0.0,"Birnai, Satna"],
"485114":[194,332,0.0,"Bharjuna Kala, Satna"],
"485115":[194,332,0.0,"Aira, Satna"],
"485221":[194,332,0.0,"Dagdiha, Satna"],
"485226":[194,332,0.0,"Badkhera, Satna"],
"485227":[390,696,0.0,"Golahata, Satna"],
"485331":[361,769,0.0,"Arjunpur, Satna"],
"485334":[361,769,0.0,"Hardua, Satna"],
"485441":[194,332,0.0,"Bachwai, Satna"],
"485446":[361,769,0.0,"Rajapur, Satna"],
"485447":[194,332,0.0,"Chorwari, Satna"],
"485551":[194,332,0.0,"Dureha, Satna"],
"485661":[194,332,0.0,"Bihata, Satna"],
"485666":[361,769,0.0,"Bamhraula, Satna"],
"485771":[361,769,0.0,"Ichaul, Satna"],
"485772":[194,332,0.0,"Latagaon, Satna"],
"485773":[361,769,0.0,"Binaika, Satna"],
"485774":[361,769,0.0,"Budherua, Satna"],
"485775":[442,855,0.0,"Satna Mukhtiyarganj B.O., Satna"],
"485778":[361,769,0.0,"Dhaurahara, Satna"],
"485881":[361,769,0.0,"Deodaha, Satna"],
"486001":[638,1005,0.0,"Rewa, Rewa"],
"486002":[207,535,0.0,"Rewa Engineering College, Rewa"],
"486003":[650,1068,0.0,"Ajgarha, Rewa"],
"486005":[650,1068,0.0,"Laxmanpur, Rewa"],
"486006":[650,1068,0.0,"Khaira, Rewa"],
"486111":[650,1068,0.0,"Gangeo, Rewa"],
"486114":[650,1068,0.0,"Budhiya, Rewa"],
"486115":[650,1068,0.0,"Bandhwa, Rewa"],
"486117":[650,1068,0.0,"Jamui, Rewa"],
"486123":[650,1068,0.0,"Tamradesh, Rewa"],
"486220":[650,1068,0.0,"Amilkoni, Rewa"],
"486223":[650,1068,0.0,"Parasiya, Rewa"],
"486226":[650,1068,0.0,"Majhigawan, Rewa"],
"486331":[650,1068,0.0,"Baraon, Rewa"],
"486333":[650,1068,0.0,"Padar, Rewa"],
"486335":[650,1068,0.0,"Majhgawan, Rewa"],
"486338":[650,1068,0.0,"Duara, Rewa"],
"486340":[650,1068,0.0,"Deorisengran, Rewa"],
"486341":[650,1068,0.0,"Judmaniya, Rewa"],
"486440":[650,1068,0.0,"Kharhari, Rewa"],
"486441":[650,1068,0.0,"Khaira, Rewa"],
"486445":[650,1068,0.0,"Badagaon Kothar, Rewa"],
"486446":[650,1068,0.0,"Amwa, Rewa"],
"486447":[650,1068,0.0,"Itma, Rewa"],
"486448":[650,1068,0.0,"Badraon, Rewa"],
"486450":[650,1068,0.0,"Bihra, Rewa"],
"486550":[650,1068,0.0,"Dihiya, Rewa"],
"486553":[650,1068,0.0,"Barsaita, Rewa"],
"486556":[650,1068,0.0,"Madri, Rewa"],
"486661":[240,423,0.0,"Sidhi, Sidhi"],
"486666":[357,745,0.0,"Karwahi, Sidhi"],
"486669":[246,428,0.0,"Jhara, Singrauli"],
"486670":[240,510,0.0,"Hinauti, Sidhi"],
"486675":[206,386,0.0,"Bamuri, Sidhi"],
"486771":[220,322,0.0,"Chakdaur, Sidhi"],
"486775":[269,421,0.0,"Gordaha, Sidhi"],
"486776":[337,484,0.0,"Amlai, Sidhi"],
"486881":[240,490,0.0,"Chatainiha, Singrauli"],
"486882":[198,386,0.0,"Bairdah, Singrauli"],
"486883":[142,312,0.0,"SARAI, Sidhi"],
"486884":[329,558,0.0,"Nigahi Project, Singrauli"],
"486885":[320,554,0.0,"Vindhyanagar, Singrauli"],
"486886":[172,327,0.0,"Daga Bargawan, Singrauli"],
"486887":[232,382,0.0,"Kachnimamla, Singrauli"],
"486889":[289,504,0.0,"Bagdewa, Singrauli"],
"486890":[303,523,0.0,"DUDHICHUA PROJECT, Singrauli"],
"486892":[214,331,0.0,"Dudhmania, Singrauli"],
"487001":[389,627,0.0,"Narsinghpur, Narsinghpur"],
"487110":[389,627,0.0,"Gorakhpur, Narsinghpur"],
"487114":[331,606,0.0,"Jhamar, Narsinghpur"],
"487118":[305,614,0.0,"Chandankheda, Narsinghpur"],
"487221":[373,674,0.0,"Jobha, Narsinghpur"],
"487225":[357,746,0.0,"Nayakheda Bansadehi, Narsinghpur"],
"487330":[413,688,0.0,"Bhamni, Narsinghpur"],
"487334":[333,540,0.0,"Bhanda, Narsinghpur"],
"487337":[223,443,0.0,"Marawan, Narsinghpur"],
"487441":[389,627,0.0,"Gaghrolakala, Narsinghpur"],
"487551":[280,392,0.0,"Deedhori, Narsinghpur"],
"487555":[340,603,0.0,"Bhatera, Narsinghpur"],
"487661":[389,627,0.0,"Piparpani, Narsinghpur"],
"487770":[371,722,0.0,"Gotitoriya, Narsinghpur"],
"487881":[260,395,0.0,"Amada, Narsinghpur"],
"488001":[191,380,0.0,"Bargarhi Camp, Panna"],
"488050":[609,880,0.0,"Nachnora, Panna"],
"488059":[191,327,0.0,"Lahargawan, Panna"],
"488220":[316,519,0.0,"Baramajhguwan, Panna"],
"488222":[276,510,0.0,"Kiratpur, Panna"],
"488333":[221,376,0.0,"Badagaon, Panna"],
"488441":[406,564,0.0,"Maheba, Panna"],
"488442":[220,412,0.0,"Barkheda, Panna"],
"488443":[278,431,0.0,"Baghwar, Panna"],
"488446":[330,533,0.0,"Kriishangarh, Panna"],
"488448":[338,472,0.0,"Khamariya Bori, Panna"],
"490001":[225,404,0.02,"Bhilai 1, Durg"],
"490004":[208,386,0.02,"New Khursipar Bhilai, Durg"],
"490006":[264,464,0.03,"Maroda Bhilai, Durg"],
"490009":[190,273,0.0,"Bhilai West, Durg"],
"490011":[208,392,0.02,"New Khursipar Bhilai, Durg"],
"490020":[235,420,0.02,"Smriti Nagar Bhilai, Durg"],
"490021":[180,655,0.01,"Sirsakala, Durg"],
"490022":[239,536,0.27,"S A F Lines Bhilai, Durg"],
"490023":[222,396,0.01,"Supela Bhilai, Durg"],
"490024":[190,594,0.01,"Karanja Bhilai, Durg"],
"490025":[190,338,0.0,"Janjgiri, Durg"],
"490026":[275,933,0.11,"I E Bhilai, Durg"],
"490036":[205,354,0.01,"Hasda, Bemetara"],
"490042":[175,553,0.02,"Oteband, Durg"],
"491001":[240,448,0.01,"Durg, Durg"],
"491002":[225,426,0.01,"IIT Bhilai, Durg"],
"491107":[190,634,0.01,"Khopli, Durg"],
"491111":[190,676,0.01,"Bhansuli, Durg"],
"491221":[275,816,0.06,"Marra, Durg"],
"491222":[280,876,0.07,"Barbaspur, Balod"],
"491223":[268,1012,0.06,"Achaud, Balod"],
"491225":[288,715,0.06,"Chaurel, Balod"],
"491226":[192,355,0.0,"Admabad, Balod"],
"491227":[200,320,0.0,"Chitod, Balod"],
"491228":[204,346,0.09,"Ghotia, Balod"],
"491229":[251,414,0.0,"Bharritola, Rajnandgaon"],
"491230":[226,446,0.0,"CHIHARO B.O., Balod"],
"491331":[234,360,0.02,"Barhapur, Durg"],
"491332":[225,401,0.0,"Biroda, Durg"],
"491335":[340,706,0.02,"Chandanu, Bemetara"],
"491336":[305,510,0.0,"Dharamgarh, Kabirdham"],
"491337":[345,523,0.18,"Andhiarkhor, Bemetara"],
"491338":[340,664,0.0,"Hatranka, Bemetara"],
"491340":[259,513,0.47,"Kunra, Bemetara"],
"491441":[195,621,0.0,"Rajnandgaon, Rajnandgaon"],
"491443":[159,351,0.0,"SOMNI, Rajnandgaon"],
"491444":[242,564,0.0,"Bijetala, Rajnandgaon"],
"491445":[232,566,0.03,"Dhara, Rajnandgaon"],
"491557":[235,596,0.03,"Kothitola, Rajnandgaon"],
"491558":[221,415,0.05,"Bholapur, Rajnandgaon"],
"491559":[172,363,0.0,"Bodtarakhurd, Kabirdham"],
"491661":[212,389,0.03,"Atargaon, Rajnandgaon"],
"491665":[175,326,0.02,"Piparkhar, Rajnandgaon"],
"491666":[229,471,0.0,"Dumartola, Rajnandgaon"],
"491668":[190,519,0.0,"Chikhli, Rajnandgaon"],
"491771":[161,316,0.89,"Achholi, Balod"],
"491881":[210,441,0.0,"Baldeopur, Rajnandgaon"],
"491885":[219,502,0.0,"Khudmudi, Rajnandgaon"],
"491888":[162,353,0.01,"Bundeli, Durg"],
"491993":[340,580,0.0,"Mohbhatta, Bemetara"],
"491995":[150,276,0.0,"Bodla, Kabirdham"],
"491996":[172,356,0.01,"NAVGHATA B.O., Kabirdham"],
"492001":[229,523,0.14,"Raipur, Raipur"],
"492002":[208,735,0.01,"Mantralaya Raipur, Raipur"],
"492003":[229,484,0.05,"Urla, Raipur"],
"492004":[229,520,0.14,"Pandri, Raipur"],
"492005":[229,513,0.14,"Vidhan Sabha SO Raipur, Raipur"],
"492008":[229,521,0.06,"WRSColony, Raipur"],
"492009":[229,510,0.13,"Raipur RS, Raipur"],
"492010":[180,654,0.01,"Ravi Shankar University, Raipur"],
"492012":[228,454,0.17,"Krishak Nagar, Raipur"],
"492013":[228,454,0.17,"Raipura, Raipur"],
"492014":[228,454,0.17,"Saddu, Raipur"],
"492015":[256,442,0.0,"Deopuri, Raipur"],
"492016":[229,513,0.14,"Mana Basti, Raipur"],
"492017":[229,504,0.14,"IBC Raipur PO, Raipur"],
"492018":[205,371,0.01,"Rakhi, Raipur"],
"492099":[240,424,0.01,"Tenduwa, Raipur"],
"492101":[228,530,0.07,"Kurud Camp, Raipur"],
"492109":[256,442,0.0,"Atarmara, Gariyaband"],
"492112":[256,442,0.0,"Chandan, Baloda Bazar"],
"493101":[228,454,0.17,"OTGAN, Baloda Bazar"],
"493111":[256,442,0.0,"Barbanda, Raipur"],
"493113":[256,442,0.0,"Bhainsa, Baloda Bazar"],
"493114":[220,308,0.02,"Tilda RS, Raipur"],
"493116":[256,442,0.0,"Chhataud, Raipur"],
"493118":[256,442,0.0,"Bitkuli, Baloda Bazar"],
"493195":[256,442,0.0,"Tohda, Raipur"],
"493196":[256,442,0.0,"Newari, Baloda Bazar"],
"493221":[220,308,0.02,"Dharsiwa, Raipur"],
"493222":[220,308,0.02,"Junwani, Baloda Bazar"],
"493225":[228,454,0.17,"Amodi, Raipur"],
"493228":[256,442,0.0,"Datan, Baloda Bazar"],
"493229":[256,442,0.0,"Charoda, Baloda Bazar"],
"493331":[256,442,0.0,"Maldi, Baloda Bazar"],
"493332":[256,442,0.0,"Khainda, Baloda Bazar"],
"493335":[256,442,0.0,"Hatodbazar, Baloda Bazar"],
"493338":[220,308,0.02,"Pauni, Baloda Bazar"],
"493344":[228,454,0.17,"Bareli, Baloda Bazar"],
"493441":[220,308,0.02,"Bhansoj, Raipur"],
"493445":[256,442,0.0,"Bemcha, Mahasamund"],
"493448":[220,308,0.02,"Salhebhata, Mahasamund"],
"493449":[220,308,0.02,"Bakma, Mahasamund"],
"493526":[220,308,0.02,"Marda, Baloda Bazar"],
"493551":[256,442,0.0,"Ghonch, Mahasamund"],
"493554":[256,442,0.0,"Bansula, Mahasamund"],
"493555":[256,442,0.0,"Arangi, Mahasamund"],
"493558":[278,449,0.0,"Amarkot, Mahasamund"],
"493559":[228,454,0.17,"Kosamkunda, Baloda Bazar"],
"493661":[256,442,0.0,"Chandi Bazar, Raipur"],
"493662":[220,308,0.02,"Bhothidih, Dhamtari"],
"493663":[220,308,0.02,"Barna, Dhamtari"],
"493770":[256,442,0.0,"Doma, Dhamtari"],
"493773":[256,442,0.0,"Bazar Kurridih, Dhamtari"],
"493776":[256,442,0.0,"RSPColony Gangrel, Dhamtari"],
"493778":[256,442,0.0,"Bahigaon, Dhamtari"],
"493881":[162,264,0.03,"Nawapara Rajim, Raipur"],
"493885":[256,442,0.0,"Champaran, Raipur"],
"493887":[175,358,0.0,"Kopra, Gariyaband"],
"493888":[272,713,0.0,"Dhawalpur, Gariyaband"],
"493889":[256,442,0.0,"Bindranawagarh, Gariyaband"],
"493890":[256,442,0.0,"Girsul, Gariyaband"],
"493891":[256,442,0.0,"Amlipadar, Gariyaband"],
"493992":[256,442,0.0,"Basin, Gariyaband"],
"493996":[229,504,0.16,"Khadma, Gariyaband"],
"494001":[150,566,0.0,"Jagdalpur, Raipur"],
"494010":[214,639,0.13,"Badedharaur, Raipur"],
"494111":[207,306,0.27,"Gumodhi, Raipur"],
"494114":[370,381,0.0,"Injeram, Raipur"],
"494115":[228,345,0.36,"Chindawada, Raipur"],
"494220":[190,716,0.03,"Hadeli, Kondagaon"],
"494221":[252,309,0.39,"Talnar, Raipur"],
"494222":[163,514,0.08,"Karpawand, Raipur"],
"494223":[216,611,0.13,"Baghmohlai, Raipur"],
"494224":[145,747,0.01,"Chapka, Kondagaon"],
"494226":[194,332,0.03,"Bayanar, Kondagaon"],
"494228":[160,779,0.01,"Alor, Kondagaon"],
"494229":[160,805,0.0,"Fufgaon, Kondagaon"],
"494230":[162,550,0.16,"Amabeda, Kondagaon"],
"494237":[182,331,0.0,"Torandi, Kondagaon"],
"494331":[135,534,0.11,"Singanpur, Raipur"],
"494332":[215,477,0.06,"Shriguhan, Raipur"],
"494333":[208,764,0.0,"Badal, Raipur"],
"494334":[215,443,0.21,"Kanker, Raipur"],
"494335":[160,402,0.01,"Dudhawa, Raipur"],
"494336":[219,393,0.14,"Haradula, Raipur"],
"494337":[172,349,0.25,"Anwari, Raipur"],
"494347":[132,360,0.03,"Salna, Raipur"],
"494441":[145,233,-1,"Ghotpal, Dantewada"],
"494442":[135,160,0.01,"Badekakloor, Bastar"],
"494444":[250,444,-1,"Etpal, Raipur"],
"494446":[405,652,-1,"Bareguda, Raipur"],
"494447":[240,459,0.02,"Basaguda, Raipur"],
"494448":[405,652,-1,"Cherpalli, Raipur"],
"494449":[134,199,-1,"Dabpal, Dantewada"],
"494450":[145,188,-1,"Badekakler, Bijapur"],
"494552":[145,178,-1,"Badegudra, Dantewada"],
"494553":[145,178,-1,"Bhansi, Dantewada"],
"494556":[156,255,-1,"Hiroli, Dantewada"],
"494635":[268,548,-1,"Karmoti, Kanker"],
"494661":[252,397,0.0,"Devgaon, Narayanpur"],
"494662":[145,188,-1,"Dhanora, Narayanpur"],
"494665":[50,255,-1,"Amodi, Kanker"],
"494669":[50,255,-1,"Gudum, Kanker"],
"494670":[250,434,-1,"Kottara, Raipur"],
"494771":[249,490,-1,"Gurwandi, Kanker"],
"494776":[122,588,0.03,"PV 9, Kanker"],
"494777":[208,384,0.0,"Erpanar, Kanker"],
"495001":[255,563,0.25,"Bilaspur BilaspurCGH, Bilaspur"],
"495002":[255,566,0.25,"Bilaspur BilaspurCGH, Bilaspur"],
"495003":[249,422,0.04,"Bahatarai, Bilaspur"],
"495004":[286,495,0.1,"Sirgitti, Bilaspur"],
"495006":[255,473,0.11,"Urtum, Bilaspur"],
"495009":[286,400,0.08,"Paunsara, Bilaspur"],
"495112":[234,348,0.02,"Tanda, Bilaspur"],
"495113":[202,366,0.02,"Kargikhurd, Bilaspur"],
"495115":[240,407,1.04,"Akhrar, Mungeli"],
"495116":[180,339,0.0,"Majhgaon, Bilaspur"],
"495117":[142,267,0.92,"Keonchi, Gaurella Pendra Marwahi"],
"495118":[200,396,0.29,"Ratga, Gaurella Pendra Marwahi"],
"495119":[182,291,0.18,"Basti Bagra, Gaurella Pendra Marwahi"],
"495220":[289,443,0.08,"Muru, Bilaspur"],
"495222":[296,485,0.08,"Hirri, Bilaspur"],
"495224":[326,588,0.1,"Baitalpur, Mungeli"],
"495330":[250,501,0.02,"Pura, Bilaspur"],
"495334":[358,693,0.14,"Donda, Mungeli"],
"495335":[435,664,0.07,"Kukusda, Mungeli"],
"495442":[272,432,0.03,"Garwat, Bilaspur"],
"495444":[130,227,0.32,"Dhelwadih, Korba"],
"495445":[139,252,0.13,"Binjhra, Korba"],
"495446":[100,158,0.69,"Boida, Korba"],
"495447":[118,193,1.42,"Mongra, Korba"],
"495448":[155,347,0.1,"Gursia, Korba"],
"495449":[155,288,0.04,"Batra, Korba"],
"495450":[108,232,0.63,"Gerwa, Korba"],
"495452":[100,193,1.04,"Deepika Project Korba, Korba"],
"495454":[100,188,1.08,"Gevra Basti, Korba"],
"495455":[104,201,1.01,"Balgi Project Korba, Korba"],
"495550":[230,377,0.03,"Gatora, Bilaspur"],
"495551":[248,429,0.04,"Deogaon, Bilaspur"],
"495552":[210,351,0.01,"Arjuni, Janjgir-Champa"],
"495553":[230,448,0.02,"Kirari, Janjgir-Champa"],
"495554":[240,424,0.04,"Kharkhod, Janjgir-Champa"],
"495555":[230,365,0.07,"Seepat, Bilaspur"],
"495556":[250,429,0.06,"Dhardei, Janjgir-Champa"],
"495557":[220,374,0.0,"Bhathali, Janjgir-Champa"],
"495559":[212,409,0.03,"Bachhaud, Janjgir-Champa"],
"495660":[196,289,0.01,"Puchheli, Janjgir-Champa"],
"495661":[280,425,0.0,"Harethikala, Janjgir-Champa"],
"495663":[230,419,0.02,"Mulmula, Janjgir-Champa"],
"495668":[208,423,0.04,"Janjgir, Janjgir-Champa"],
"495669":[230,400,0.01,"Bhaistara, Janjgir-Champa"],
"495671":[220,390,0.0,"Chicholi, Korba"],
"495674":[80,177,1.95,"Ghinara, Korba"],
"495677":[126,234,0.85,"Korba, Korba"],
"495682":[128,252,1.06,"Dadarkhurd, Korba"],
"495683":[90,203,1.2,"Patrapali, Korba"],
"495684":[160,283,0.06,"Ajgarbahar, Korba"],
"495686":[198,314,0.0,"Choria, Janjgir-Champa"],
"495687":[200,292,0.07,"Jharna, Janjgir-Champa"],
"495688":[250,425,0.04,"Saraskela, Janjgir-Champa"],
"495689":[224,377,0.01,"Portha, Janjgir-Champa"],
"495690":[222,329,0.0,"Beladula, Janjgir-Champa"],
"495691":[270,377,0.0,"Charpara, Janjgir-Champa"],
"495692":[265,478,0.08,"Latesara, Janjgir-Champa"],
"495695":[195,578,0.0,"Tundri, Janjgir-Champa"],
"496001":[154,291,0.0,"Raigarh, Raigarh"],
"496005":[145,244,0.0,"Kirodimalnagar, Raigarh"],
"496100":[230,370,0.02,"Jatri, Raigarh"],
"496107":[128,510,0.01,"Kolam, Raigarh"],
"496108":[128,312,0.01,"Urjanagar Telirampur, Raigarh"],
"496109":[135,184,0.01,"Punjipathra, Raigarh"],
"496111":[137,221,0.02,"Baihamunda, Raigarh"],
"496113":[120,246,0.35,"Jhagarpur, Raigarh"],
"496115":[125,242,0.18,"Salakia, Raigarh"],
"496116":[86,520,0.1,"Behramar, Raigarh"],
"496118":[160,263,0.12,"Bakaruma, Raigarh"],
"496220":[159,274,0.13,"Bagbahar, Jashpur"],
"496223":[158,256,0.05,"Bataikela, Jashpur"],
"496224":[105,188,0.1,"Ghughari, Jashpur"],
"496225":[85,172,0.07,"Behrakhar, Jashpur"],
"496227":[142,260,0.03,"Kandaibahar, Jashpur"],
"496242":[140,228,0.11,"Menderbahar, Jashpur"],
"496245":[142,233,0.15,"Bansajhal, Jashpur"],
"496330":[116,194,0.13,"Orkela, Jashpur"],
"496331":[68,114,0.07,"Gamharia, Jashpur"],
"496334":[65,119,0.23,"Basantala, Jashpur"],
"496336":[110,150,0.0,"Saraitoli, Jashpur"],
"496338":[90,224,0.01,"Bada Karonja, Jashpur"],
"496440":[222,358,0.0,"Badehardi, Raigarh"],
"496445":[176,578,0.09,"Chhind, Raigarh"],
"496450":[225,605,0.04,"Chhote Khaira, Raigarh"],
"496551":[220,341,0.14,"Katangpali, Raigarh"],
"496554":[180,324,0.14,"Bade Nawapara, Raigarh"],
"496661":[170,582,0.0,"Anjoripali, Raigarh"],
"496665":[128,155,0.05,"Bangursuta, Raigarh"],
"497001":[116,247,0.03,"Ambikapur, Surguja"],
"497101":[118,187,0.51,"Patora, Surguja"],
"497111":[98,178,0.1,"Narbadapur, Surguja"],
"497114":[100,189,0.04,"Pent, Surguja"],
"497116":[105,340,0.01,"Turna, Surguja"],
"497117":[100,228,0.01,"Mahgai, Surajpur"],
"497118":[121,320,0.23,"Dipadih, Balrampur"],
"497119":[100,169,0.68,"Shahpur, Balrampur"],
"497220":[140,280,0.61,"Annapara, Balrampur"],
"497223":[124,217,0.12,"Lolki, Surajpur"],
"497224":[125,212,0.88,"Bhulsikala, Balrampur"],
"497225":[267,394,0.27,"Gudru, Balrampur"],
"497226":[99,242,0.12,"Kandrai, Surajpur"],
"497229":[139,468,0.13,"Dedri, Surajpur"],
"497231":[150,406,0.06,"Darripara, Surajpur"],
"497235":[92,231,0.36,"Dawna, Surajpur"],
"497331":[150,371,0.06,"Badsara, Korea"],
"497333":[164,291,1.21,"Ganeshpur, Surajpur"],
"497335":[185,368,0.0,"Chhinddand, Korea"],
"497339":[129,285,0.0,"Katgodi, Korea"],
"497442":[140,342,0.01,"Ghutra, Korea"],
"497446":[170,366,0.01,"Jhagrakhand Colly, Korea"],
"497447":[185,371,0.0,"Bseam Colly, Korea"],
"497448":[170,382,0.01,"South Jhagrakhand Colly, Korea"],
"497449":[149,274,0.05,"Udhanapur, Korea"],
"497450":[150,249,0.06,"Khadgawan, Korea"],
"497451":[145,355,0.02,"Haldibadi, Korea"],
"497553":[150,341,0.03,"Kurasia Colly, Korea"],
"497555":[150,345,0.03,"Godripara, Korea"],
"497557":[145,334,0.02,"Sonawani Colly, Korea"],
"497559":[148,355,0.02,"Gelhapani, Korea"],
"497773":[130,363,0.0,"West Chirimiri, Korea"],
"497778":[149,204,0.0,"Bhagwanpur, Korea"],
"500001":[298,597,0.56,"Hyderabad G.P.O., Hyderabad"],
"500002":[330,626,0.54,"Charminar, Hyderabad"],
"500003":[314,583,0.92,"Secunderabad, Hyderabad"],
"500004":[298,580,0.7,"Khairatabad, Hyderabad"],
"500005":[350,667,0.36,"Balapur, Ranga Reddy"],
"500006":[390,672,0.78,"Karwan Sahu, Hyderabad"],
"500007":[314,646,0.7,"Jama I Osmania, Hyderabad"],
"500008":[298,573,0.81,"Nanakramguda, Hyderabad"],
"500009":[298,579,1.01,"Manovikasnagar, Hyderabad"],
"500010":[324,559,1.17,"Alwal, Medchal Malkajgiri"],
"500011":[298,579,0.93,"Bowenpally, Hyderabad"],
"500012":[340,614,0.51,"Begum Bazar, Hyderabad"],
"500013":[314,613,0.81,"Ramanthapur, Medchal Malkajgiri"],
"500014":[350,557,1.17,"Hakimpet, Hyderabad"],
"500015":[298,591,1.22,"Trimulgherry, Hyderabad"],
"500016":[314,607,0.75,"Prakashamnagar, Hyderabad"],
"500017":[330,599,0.76,"Lallaguda, Hyderabad"],
"500018":[410,662,0.31,"Fathenagar Colony, Medchal Malkajgiri"],
"500019":[322,630,0.37,"Lingampalli, Ranga Reddy"],
"500020":[330,593,0.76,"Golconda Chowrastha, Hyderabad"],
"500022":[298,585,0.75,"Central Secretariat, Hyderabad"],
"500023":[340,634,0.47,"Yakutpura, Hyderabad"],
"500024":[314,621,0.65,"Sahifa, Hyderabad"],
"500026":[330,573,1.08,"Nehrunagar, Hyderabad"],
"500027":[298,606,0.73,"Stn.Kachiguda, Hyderabad"],
"500028":[314,590,0.71,"Humayunnagar, Hyderabad"],
"500029":[470,882,0.19,"Gagan Mahal, Hyderabad"],
"500030":[312,549,0.24,"Kismatpur, Ranga Reddy"],
"500031":[314,611,0.41,"Ibrahim Bagh Lines, Hyderabad"],
"500032":[350,494,1.59,"Gachibowli, Hyderabad"],
"500033":[298,578,0.79,"Dr.B R Ambedkar O.U, Hyderabad"],
"500034":[314,574,1.17,"Banjara Hills, Hyderabad"],
"500035":[330,659,0.66,"Huda Resi. Complex, Ranga Reddy"],
"500036":[330,623,0.71,"Sripuram Colony, Hyderabad"],
"500037":[330,578,1.43,"Balanagar Township, Medchal Malkajgiri"],
"500038":[410,656,0.42,"Sanjeev Reddy Nagar, Hyderabad"],
"500039":[340,646,0.71,"UPPAL, Medchal Malkajgiri"],
"500040":[314,590,0.95,"Ie Moulali, Hyderabad"],
"500041":[314,582,0.96,"Raj Bhawan, Hyderabad"],
"500042":[298,589,0.55,"Hal, Medchal Malkajgiri"],
"500043":[310,512,0.52,"Dindigul, Medchal Malkajgiri"],
"500044":[298,596,0.74,"Vidyanagar, Hyderabad"],
"500045":[296,561,0.91,"Yousufguda, Hyderabad"],
"500046":[370,647,0.58,"CUC, Ranga Reddy"],
"500047":[360,736,0.32,"Malkajgiri, Medchal Malkajgiri"],
"500048":[330,680,0.38,"Hyderguda, Ranga Reddy"],
"500049":[314,576,1.21,"Mathrusri Nagar, Medchal Malkajgiri"],
"500050":[155,387,1.6,"Chandanagar, Ranga Reddy"],
"500051":[294,609,0.76,"Hindustan Cables, Medchal Malkajgiri"],
"500052":[340,657,0.35,"Gaganpahad, Ranga Reddy"],
"500053":[330,657,0.43,"Falaknuma, Hyderabad"],
"500054":[298,563,1.63,"HMT Township, Medchal Malkajgiri"],
"500055":[298,561,1.89,"Kutbullapur, Medchal Malkajgiri"],
"500056":[360,860,0.48,"Neredmet, Hyderabad"],
"500057":[314,577,1.11,"Vijay Nagar Colony, Hyderabad"],
"500058":[314,655,0.51,"Kanchanbagh, Hyderabad"],
"500059":[330,639,0.58,"Saidabad, Hyderabad"],
"500060":[330,635,0.72,"P and T Colony (Gaddiannaram), Ranga Reddy"],
"500061":[314,593,0.66,"Sitaphalmandi, Hyderabad"],
"500062":[455,961,0.35,"Ecil, Medchal Malkajgiri"],
"500064":[350,640,0.41,"Bahadurpura, Hyderabad"],
"500065":[340,635,0.44,"Shahalibanda, Hyderabad"],
"500066":[330,610,0.49,"High Court, Hyderabad"],
"500067":[350,564,1.82,"Suchitra Junction, Medchal Malkajgiri"],
"500068":[298,660,0.8,"G.S.I (S.R) Bandlaguda, Medchal Malkajgiri"],
"500069":[360,743,0.47,"Research Centre Imarat, Ranga Reddy"],
"500070":[330,713,0.67,"Vaidehinagar, Ranga Reddy"],
"500072":[360,600,1.1,"Kukatpally, Medchal Malkajgiri"],
"500073":[298,586,0.9,"Srinagar Colony, Hyderabad"],
"500074":[350,709,0.56,"Rangareddy District Court, Ranga Reddy"],
"500075":[370,687,0.21,"Himayathnagar, Ranga Reddy"],
"500076":[330,652,0.67,"I.E.Nacharam, Medchal Malkajgiri"],
"500077":[330,658,0.35,"Kattedan I.E., Ranga Reddy"],
"500078":[350,560,1.07,"Bomraspet, Medchal Malkajgiri"],
"500079":[330,689,0.54,"Jillellaguda, Ranga Reddy"],
"500080":[298,589,0.79,"Gandhinagar, Hyderabad"],
"500081":[314,570,0.81,"Cyberabad, Hyderabad"],
"500082":[330,578,1.12,"Somajiguda, Hyderabad"],
"500083":[290,597,0.98,"Dammaiguda, Medchal Malkajgiri"],
"500084":[370,591,0.87,"Kothaguda, Hyderabad"],
"500085":[350,544,1.22,"VASANTHNAGAR, Medchal Malkajgiri"],
"500086":[350,633,0.29,"Don Bosco Nagar, Ranga Reddy"],
"500087":[294,575,1.02,"Jawahar Nagar, Medchal Malkajgiri"],
"500088":[410,774,0.72,"Venkatadri, Medchal Malkajgiri"],
"500089":[360,617,0.35,"Narsingi, Ranga Reddy"],
"500090":[290,610,1.18,"Mallampet, Medchal Malkajgiri"],
"500091":[296,615,0.43,"Hydershahkote, Ranga Reddy"],
"500092":[330,635,0.73,"Boduppal, Medchal Malkajgiri"],
"500094":[298,552,1.13,"Sainikpuri, Hyderabad"],
"500096":[298,572,0.75,"Film Nagar, Hyderabad"],
"500097":[330,696,0.54,"Gayathrinagar, Ranga Reddy"],
"500098":[350,645,0.72,"Medipalli, Medchal Malkajgiri"],
"500100":[290,542,1.55,"Doolapalli, Medchal Malkajgiri"],
"500101":[270,519,1.23,"Jaggamguda, Medchal Malkajgiri"],
"500102":[350,654,0.69,"Rama Krishnapuram, Ranga Reddy"],
"500103":[298,597,1.02,"Jai Jawan Colony, Medchal Malkajgiri"],
"500104":[296,576,0.69,"Chitrapuri Colony S.O., Ranga Reddy"],
"500106":[360,641,0.32,"MANCHIREVULA, Hyderabad"],
"500108":[375,724,0.09,"R.G.I. Airport, Ranga Reddy"],
"500109":[391,1011,0.22,"IBC Hyderabad, Hyderabad"],
"500110":[296,566,0.77,"Prashasan Nagar, Hyderabad"],
"500111":[350,592,0.74,"I S B Campus, Ranga Reddy"],
"500112":[360,708,0.53,"Almasguda, Ranga Reddy"],
"500113":[355,423,0.82,"Chippalapalli, Ranga Reddy"],
"500114":[294,564,0.97,"Motinagar, Medchal Malkajgiri"],
"500117":[290,563,1.5,"Kailash Hills Colony, Hyderabad"],
"500118":[275,602,1.04,"Bachupally, Hyderabad"],
"500901":[298,598,0.56,"Hyderabad G.P.O., Hyderabad"],
"500903":[314,583,0.92,"Secunderabad, Hyderabad"],
"500915":[294,601,1.25,"Trimulgherry, Hyderabad"],
"500920":[330,591,0.79,"Golconda Chowrastha, Hyderabad"],
"500927":[298,605,0.72,"Stn.Kachiguda, Hyderabad"],
"500930":[330,565,0.24,"Kismatpur, Ranga Reddy"],
"500939":[350,663,0.62,"UPPAL, Medchal Malkajgiri"],
"500955":[298,540,1.71,"Kutbullapur, Medchal Malkajgiri"],
"500958":[314,655,0.5,"Kanchanbagh, Hyderabad"],
"500962":[350,642,0.8,"Ie Moulali, Hyderabad"],
"500970":[330,711,0.67,"Vaidehinagar, Ranga Reddy"],
"500972":[360,600,1.1,"Kukatpally, Medchal Malkajgiri"],
"501101":[280,407,0.04,"Vikarabad, Vikarabad"],
"501102":[271,422,0.03,"Phulmaddi, Vikarabad"],
"501106":[350,408,0.27,"Malasomaram, Vikarabad"],
"501111":[318,537,0.02,"Madireddipalli, Vikarabad"],
"501121":[350,652,0.27,"Ghatepalli, Vikarabad"],
"501141":[345,597,2.22,"Narayanpur, Vikarabad"],
"501142":[320,461,1.05,"Turmamidi, Vikarabad"],
"501143":[275,779,0.06,"Chinnagottiga, Vikarabad"],
"501144":[350,540,0.97,"Bennur, Vikarabad"],
"501158":[330,651,1.34,"Mittabaspalle, Vikarabad"],
"501202":[369,-1,0.2,"Kolkonda, Vikarabad"],
"501203":[356,436,0.04,"Mokila, Ranga Reddy"],
"501218":[375,733,0.08,"Kothwalguda, Ranga Reddy"],
"501301":[594,969,0.26,"Ankushapur, Medchal Malkajgiri"],
"501302":[341,575,0.63,"Rampallidiara, Medchal Malkajgiri"],
"501303":[438,520,0.74,"Cherial, Medchal Malkajgiri"],
"501359":[375,495,0.0,"Rachaloor, Ranga Reddy"],
"501401":[209,332,1.09,"Girmapur, Medchal Malkajgiri"],
"501501":[450,766,0.02,"Chityal, Vikarabad"],
"501502":[372,512,1.63,"Badampalli, Vikarabad"],
"501503":[388,-1,0.02,"Devuniyerravalli, Ranga Reddy"],
"501504":[405,632,0.01,"RAMANUJAPUR, Ranga Reddy"],
"501505":[445,911,0.88,"Bandaraviryal, Ranga Reddy"],
"501506":[640,825,0.21,"Cherlapatelguda, Ranga Reddy"],
"501508":[570,872,0.26,"Japal, Ranga Reddy"],
"501509":[540,779,0.64,"Kurmidda, Ranga Reddy"],
"501510":[560,910,0.54,"Seriguda, Ranga Reddy"],
"501512":[560,994,0.47,"Anajpur, Ranga Reddy"],
"501513":[570,983,0.69,"Abdullapurmet, Ranga Reddy"],
"502001":[305,486,0.48,"Sangareddy, Sangareddy"],
"502032":[275,618,0.33,"Tellapur, Sangareddy"],
"502033":[262,626,0.84,"Ameenpur, Sangareddy"],
"502101":[355,641,0.58,"Ramayampet, Medak"],
"502102":[318,380,0.23,"Narlapur, Medak"],
"502103":[195,387,0.15,"Siddipet, Siddipet"],
"502106":[341,522,0.12,"MIRDODDI, Siddipet"],
"502107":[400,794,0.07,"Narayanaraopet, Siddipet"],
"502108":[408,637,0.17,"Gambheerpur, Siddipet"],
"502109":[423,954,0.15,"Perur, Medak"],
"502110":[423,716,0.07,"Medak, Medak"],
"502113":[480,929,0.09,"Nagapuram, Medak"],
"502114":[283,572,0.12,"Thimmapur, Siddipet"],
"502115":[354,656,0.31,"Katrial, Medak"],
"502117":[365,893,0.12,"M.Bhupathipur, Medak"],
"502125":[518,1162,0.14,"Laxminagar, Medak"],
"502130":[480,930,0.1,"Toguta, Medak"],
"502205":[318,438,0.06,"O.F.Yeddumailaram, Sangareddy"],
"502210":[390,572,0.11,"Pothareddypally, Sangareddy"],
"502220":[345,494,0.26,"Zaheerabad, Sangareddy"],
"502221":[240,-1,0.35,"Gopanpally, Sangareddy"],
"502228":[238,350,0.39,"Didgi, Sangareddy"],
"502246":[436,651,0.03,"Jeerlapally, Sangareddy"],
"502247":[212,270,0.17,"Ananthasagar, Medak"],
"502248":[330,-1,0.37,"Khajapur, Medak"],
"502249":[395,498,0.15,"Mamidgi, Sangareddy"],
"502251":[350,651,0.05,"Dappur, Sangareddy"],
"502255":[263,424,0.2,"Chinna Shivnoor, Medak"],
"502256":[235,401,0.41,"Chalki, Sangareddy"],
"502257":[465,475,0.29,"Pampad, Sangareddy"],
"502267":[305,522,0.03,"Ramunipatla, Siddipet"],
"502269":[373,663,0.42,"Devnoor, Sangareddy"],
"502270":[232,373,0.0,"Neredigunta, Sangareddy"],
"502271":[328,834,0.81,"Jukal, Medak"],
"502273":[265,314,0.35,"Korpole, Sangareddy"],
"502276":[195,426,0.1,"Lingareddipally, Siddipet"],
"502277":[302,557,0.07,"Ankireddipally, Siddipet"],
"502278":[303,706,0.2,"Anajipur, Siddipet"],
"502279":[329,587,0.63,"Erraballi, Siddipet"],
"502280":[430,726,0.0,"Akkenapally, Siddipet"],
"502281":[432,883,0.26,"Gollapally, Siddipet"],
"502284":[292,416,0.02,"IIT HYDERABAD, Sangareddy"],
"502285":[292,364,0.03,"Kalivemula, Sangareddy"],
"502286":[270,371,0.52,"Abbenda, Sangareddy"],
"502287":[332,499,0.34,"Naganpally, Sangareddy"],
"502290":[330,684,0.27,"R ITIKYAL, Medak"],
"502291":[265,299,0.01,"Atmakur, Sangareddy"],
"502293":[265,277,0.01,"Gonglur, Sangareddy"],
"502294":[305,362,0.27,"Tadlapally, Sangareddy"],
"502295":[305,445,0.01,"Mallepalli, Sangareddy"],
"502296":[341,598,0.42,"Bodupatla, Sangareddy"],
"502300":[370,608,0.23,"Nagulapalli, Sangareddy"],
"502301":[273,505,0.1,"Mangole, Siddipet"],
"502302":[275,500,1.44,"Kadloor, Medak"],
"502303":[380,604,0.94,"Lingaipally, Medak"],
"502305":[318,482,0.08,"Bhanur, Sangareddy"],
"502306":[320,320,0.07,"Kondapur, Sangareddy"],
"502307":[331,471,0.07,"Chitkul, Sangareddy"],
"502310":[353,647,0.0,"Vittalapur, Siddipet"],
"502311":[380,780,0.14,"Akkaram, Siddipet"],
"502312":[366,670,0.07,"Timmapur, Siddipet"],
"502313":[270,684,0.41,"Ratnapur, Medak"],
"502314":[285,480,0.41,"CHANDUR, Medak"],
"502316":[365,751,0.29,"Kanchanpally, Medak"],
"502318":[308,493,0.29,"Hoti, Sangareddy"],
"502319":[354,563,0.15,"Jinnaram, Sangareddy"],
"502321":[398,636,0.06,"Chinthalghat, Sangareddy"],
"502324":[331,646,0.29,"Icrisat, Sangareddy"],
"502325":[275,627,1.01,"Aie Bollaram, Sangareddy"],
"502329":[345,535,0.03,"Kowlampet, Sangareddy"],
"502331":[480,858,0.08,"Kurthiwada, Medak"],
"502334":[155,367,3.22,"Waddepalli, Siddipet"],
"502335":[220,517,0.9,"Nagulapally, Medak"],
"502336":[183,392,2.4,"Manoharabad, Medak"],
"502345":[342,464,0.04,"Lonikurd, Sangareddy"],
"502371":[301,661,0.46,"Bachepally, Sangareddy"],
"502372":[253,507,0.1,"Thoguta, Siddipet"],
"502375":[298,546,0.06,"Baddipadaga, Siddipet"],
"502381":[480,853,0.11,"Kulcharam, Medak"],
"502932":[370,649,0.34,"Tellapur, Sangareddy"],
"503001":[379,889,1.4,"Nizamabad, Nizamabad"],
"503002":[370,902,1.35,"Gurbabadi, Nizamabad"],
"503003":[462,961,1.0,"KALOOR, Nizamabad"],
"503101":[355,854,0.3,"Bhagirathipalli, Kamareddy"],
"503102":[488,906,0.01,"Narsannapalli, Kamareddy"],
"503108":[518,937,0.19,"Malthummeda, Kamareddy"],
"503110":[475,861,0.01,"Yellareddypalli, Kamareddy"],
"503111":[452,985,0.09,"Kamareddy, Kamareddy"],
"503112":[452,929,0.08,"Adloor, Kamareddy"],
"503114":[590,-1,0.23,"Gurjal, Kamareddy"],
"503120":[532,860,0.16,"Karadpalli, Kamareddy"],
"503122":[469,710,0.76,"Mathumal, Kamareddy"],
"503123":[490,945,0.08,"ANCHANUR, Kamareddy"],
"503124":[495,843,0.71,"Polkampet, Kamareddy"],
"503125":[422,630,0.25,"Tujlapur, Kamareddy"],
"503144":[452,857,0.31,"Moshampur, Kamareddy"],
"503145":[430,892,0.37,"Kalwaral, Kamareddy"],
"503164":[368,743,0.77,"Nallapalli, Nizamabad"],
"503165":[316,563,0.3,"Challagarga, Nizamabad"],
"503174":[403,717,0.86,"APSP Camp, Nizamabad"],
"503175":[412,825,2.55,"Kanjar, Nizamabad"],
"503180":[318,693,0.01,"NARSAPUR, Nizamabad"],
"503185":[397,666,0.2,"Raithunagar, Nizamabad"],
"503186":[388,733,0.58,"Ananthagiri, Nizamabad"],
"503187":[336,653,0.47,"Konapur, Kamareddy"],
"503188":[361,743,0.23,"Raikur, Nizamabad"],
"503201":[344,768,0.4,"Old Varni, Nizamabad"],
"503202":[388,742,0.65,"Jamlam, Nizamabad"],
"503206":[370,642,0.56,"Govur, Nizamabad"],
"503207":[318,633,0.01,"Jillapalli, Nizamabad"],
"503212":[368,748,0.05,"Badguni, Nizamabad"],
"503213":[450,986,0.29,"Kalhadi, Nizamabad"],
"503217":[335,422,1.35,"Vennelb, Nizamabad"],
"503218":[335,385,1.48,"Shetpalli, Nizamabad"],
"503219":[370,563,0.45,"SOANPET, Nizamabad"],
"503223":[450,745,0.94,"Manthani, Nizamabad"],
"503224":[450,764,0.86,"Armoor, Nizamabad"],
"503225":[254,461,0.33,"Sunket, Nizamabad"],
"503230":[338,695,1.67,"Badsi, Nizamabad"],
"503235":[476,857,0.43,"Kandagaon, Nizamabad"],
"503245":[405,986,0.2,"Abhangapatnam, Nizamabad"],
"503246":[398,1013,0.22,"Ailapur, Nizamabad"],
"503301":[445,912,0.02,"Namli, Kamareddy"],
"503302":[340,574,1.84,"MOHAMMADNAGAR, Kamareddy"],
"503305":[305,549,0.06,"BASWAPUR, Kamareddy"],
"503306":[315,680,0.05,"Fathlapur, Kamareddy"],
"503307":[303,498,0.28,"Janakampet, Nizamabad"],
"503308":[420,534,0.18,"Tadlarampur, Nizamabad"],
"503309":[306,584,0.04,"Gundekallur, Kamareddy"],
"503310":[329,625,0.48,"Kodapkal Kalan, Kamareddy"],
"503311":[245,418,0.79,"Lakhora, Nizamabad"],
"503321":[309,764,0.02,"Kistapur, Kamareddy"],
"503322":[412,823,2.55,"Telangana University, Nizamabad"],
"504001":[350,610,0.02,"Adilabad, Adilabad"],
"504002":[350,630,0.02,"Ankoli, Adilabad"],
"504101":[435,1215,0.13,"Kankapur, Nirmal"],
"504102":[380,599,0.39,"Dehgaon, Nirmal"],
"504103":[428,734,0.47,"Sonari, Nirmal"],
"504104":[320,703,0.0,"New Pipri, Nirmal"],
"504105":[405,829,0.13,"Kadthal, Nirmal"],
"504106":[405,969,0.08,"Waddial, Nirmal"],
"504107":[405,991,0.14,"RGU IIIT Campus Basar, Nirmal"],
"504109":[345,652,0.0,"Kallur, Nirmal"],
"504110":[275,605,0.02,"Aloor, Nirmal"],
"504201":[314,550,0.01,"Angarajpalli, Mancherial"],
"504202":[435,708,0.02,"Ambaripet, Nirmal"],
"504203":[345,585,0.03,"Badankurthi, Nirmal"],
"504204":[309,1103,0.05,"Awadam, Mancherial"],
"504205":[478,844,0.0,"Kalmadgu, Mancherial"],
"504206":[355,705,0.01,"Tapalpur, Mancherial"],
"504207":[365,695,0.0,"Laxmipur, Mancherial"],
"504208":[313,868,0.03,"Mancherial, Mancherial"],
"504209":[370,941,0.06,"Vempalli, Mancherial"],
"504214":[437,668,0.0,"Jangaon, Mancherial"],
"504215":[355,552,0.01,"Itikyal, Mancherial"],
"504216":[278,772,0.02,"Pownur, Mancherial"],
"504218":[355,2414,0.16,"Sonapur, Mancherial"],
"504219":[534,1471,0.05,"Giravalli, Mancherial"],
"504220":[330,953,0.01,"Madaram Township, Mancherial"],
"504231":[338,2656,0.2,"Dharmaraopet, Mancherial"],
"504251":[355,1395,0.07,"Police Colony, Mancherial"],
"504272":[330,953,0.01,"Chakepalli, Mancherial"],
"504273":[500,959,0.0,"Kothimir, Kumuram Bheem Asifabad"],
"504292":[362,853,0.01,"Khairgaon, Kumuram Bheem Asifabad"],
"504293":[380,525,0.03,"Ada, Kumuram Bheem Asifabad"],
"504294":[423,707,0.01,"Tumpally, Kumuram Bheem Asifabad"],
"504295":[410,637,0.02,"Malini, Kumuram Bheem Asifabad"],
"504296":[330,507,0.01,"Bareguda, Kumuram Bheem Asifabad"],
"504297":[429,731,0.01,"Ginnedhari, Kumuram Bheem Asifabad"],
"504299":[505,935,0.0,"Papanpet, Kumuram Bheem Asifabad"],
"504301":[338,2175,0.17,"Kyathanpalli, Mancherial"],
"504302":[308,1108,0.06,"Singapur, Mancherial"],
"504303":[308,1159,0.06,"Srirampur Colony, Mancherial"],
"504304":[391,692,0.19,"Patnapur, Adilabad"],
"504306":[405,849,0.06,"Bansapalli, Nirmal"],
"504307":[320,761,0.18,"Powna, Adilabad"],
"504308":[360,622,0.02,"Gurjamannur, Adilabad"],
"504309":[308,621,0.01,"Koora, Adilabad"],
"504310":[391,748,0.07,"Medpalli, Nirmal"],
"504311":[450,664,0.1,"Dhaba, Adilabad"],
"504312":[370,632,0.02,"Karanji, Adilabad"],
"504313":[480,607,0.16,"Sirpur, Kumuram Bheem Asifabad"],
"504323":[391,662,0.19,"Tarnam, Adilabad"],
"504346":[434,677,0.07,"Gourapur, Prakasam"],
"505001":[500,695,0.02,"Karimnagar, Karimnagar"],
"505002":[480,585,0.0,"Bommakal, Karimnagar"],
"505101":[499,-1,0.0,"Kannur, Hanumakonda"],
"505102":[443,-1,0.0,"Madannapet, Hanumakonda"],
"505122":[594,623,0.0,"Madipalli, Karimnagar"],
"505129":[478,726,0.01,"Kanaparthi, Karimnagar"],
"505152":[363,691,0.01,"Komera, Peddapalli"],
"505153":[367,700,0.02,"Mirzampet, Peddapalli"],
"505162":[358,694,0.01,"Madupalli, Peddapalli"],
"505172":[378,1048,0.01,"Peddapalli, Peddapalli"],
"505174":[378,921,0.01,"Maredgonda, Peddapalli"],
"505184":[529,694,0.01,"Adivisomanpalli, Peddapalli"],
"505185":[279,524,0.02,"Kodurpak, Peddapalli"],
"505186":[218,382,0.0,"Ithrajpalle, Karimnagar"],
"505187":[395,708,0.0,"Dongathurthi, Peddapalli"],
"505188":[490,838,0.01,"Elakalapalli, Peddapalli"],
"505208":[278,493,0.0,"Peddampet, Peddapalli"],
"505209":[315,405,0.01,"Maredpak, Peddapalli"],
"505210":[391,646,0.01,"Fertilizercity, Peddapalli"],
"505211":[462,683,0.01,"Gv8incline, Peddapalli"],
"505212":[590,887,0.01,"Begumpet, Peddapalli"],
"505214":[315,437,0.01,"Vithalnagar, Peddapalli"],
"505215":[300,491,0.0,"Annapoorna colony, Peddapalli"],
"505301":[550,1131,0.0,"Nagaram, Rajanna Sircilla"],
"505302":[512,1023,-1,"Rudraram, Rajanna Sircilla"],
"505303":[565,1122,0.05,"Dumala, Rajanna Sircilla"],
"505304":[486,853,0.06,"Mucherla, Rajanna Sircilla"],
"505305":[508,958,0.06,"Adivipadira, Rajanna Sircilla"],
"505306":[470,592,0.0,"Potharam, Jagitial"],
"505307":[466,725,0.0,"Thimmapur, Rajanna Sircilla"],
"505325":[425,560,0.0,"Chowlamaddi, Jagitial"],
"505326":[443,519,0.0,"Koratla Bazar, Jagitial"],
"505327":[460,734,0.0,"Jagtial, Jagitial"],
"505330":[425,547,0.0,"Venkatapur, Jagitial"],
"505331":[345,632,0.03,"Mogalpet, Jagitial"],
"505401":[449,790,0.03,"Kandikatkur, Rajanna Sircilla"],
"505402":[428,845,0.0,"Vallampatla, Rajanna Sircilla"],
"505403":[498,974,0.0,"Bandapalli, Rajanna Sircilla"],
"505404":[608,1289,0.01,"Namapur, Rajanna Sircilla"],
"505405":[420,882,0.0,"Tangallapalli, Rajanna Sircilla"],
"505415":[378,500,0.03,"Yellapur, Jagitial"],
"505416":[368,561,0.02,"Chegaon, Jagitial"],
"505425":[345,616,0.01,"Donthapur, Jagitial"],
"505445":[352,585,0.04,"Achampalli, Karimnagar"],
"505450":[385,582,0.09,"Vemulakurthi, Jagitial"],
"505451":[382,592,0.03,"Vedira, Karimnagar"],
"505452":[510,736,0.01,"Maddutla, Jagitial"],
"505453":[460,661,0.0,"Kalvakota, Jagitial"],
"505454":[325,494,0.0,"Nakkalapet, Jagitial"],
"505455":[460,672,0.0,"Chelgal, Jagitial"],
"505460":[422,642,0.0,"Joganapalli, Jagitial"],
"505462":[425,559,0.0,"Ekeenpur, Jagitial"],
"505466":[450,829,0.0,"Akkannapet, Siddipet"],
"505467":[438,701,0.01,"Samudrala, Siddipet"],
"505468":[547,705,0.0,"Huzurabad, Karimnagar"],
"505469":[550,694,0.02,"Polampalli, Karimnagar"],
"505470":[552,762,0.0,"Muttaram, Karimnagar"],
"505471":[590,719,0.0,"Mallaram, Hanumakonda"],
"505472":[556,826,0.01,"Aknoor, Karimnagar"],
"505473":[305,645,0.0,"Koheda, Siddipet"],
"505474":[551,761,0.01,"Mogalipalam, Karimnagar"],
"505475":[182,389,0.02,"Bijnur, Karimnagar"],
"505476":[559,567,0.0,"Damera, Hanumakonda"],
"505480":[546,733,0.0,"Katrapalli, Karimnagar"],
"505481":[515,751,0.02,"Nallagonda, Karimnagar"],
"505490":[552,773,0.0,"Kothaghat, Karimnagar"],
"505497":[532,653,0.0,"Kothapalli, Hanumakonda"],
"505498":[594,728,0.0,"Kanikulagidda, Karimnagar"],
"505501":[439,721,0.02,"Cheppial, Jagitial"],
"505502":[373,600,0.01,"Deshaipalli, Karimnagar"],
"505503":[461,1213,0.01,"Bayyaram, Jayashankar Bhupalapally"],
"505504":[460,1024,0.0,"Bommapur, Jayashankar Bhupalapally"],
"505505":[340,506,0.01,"Vegurpalli, Karimnagar"],
"505506":[461,1145,0.01,"Mutharam, Peddapalli"],
"505514":[313,678,0.0,"Pothiyal, Peddapalli"],
"505524":[414,797,0.05,"Tadagonda, Rajanna Sircilla"],
"505525":[378,533,0.0,"Kothur, Peddapalli"],
"505526":[446,618,0.02,"Ambaripet, Jagitial"],
"505527":[480,740,0.02,"Algunur, Karimnagar"],
"505528":[465,783,0.0,"Gundaram, Siddipet"],
"505529":[460,581,0.01,"Pembatla Konapur, Jagitial"],
"505530":[515,876,0.02,"Jangapalli, Karimnagar"],
"505531":[337,530,0.04,"Katnapalli, Karimnagar"],
"505532":[510,734,0.02,"Pegadapalli, Jagitial"],
"506001":[325,-1,0.0,"Hanamkonda, Hanumakonda"],
"506002":[325,-1,0.0,"Warangal, Hanumakonda"],
"506003":[310,390,0.0,"Kondaparthy, Hanumakonda"],
"506004":[325,356,0.0,"Fatimanagar, Hanumakonda"],
"506005":[325,363,0.0,"Ashalapalli, Hanumakonda"],
"506006":[340,394,0.0,"Kothapeta, Hanumakonda"],
"506007":[340,-1,0.0,"Agricultur Research Station, Hanumakonda"],
"506008":[310,-1,0.0,"Railway Gate, Hanumakonda"],
"506009":[325,-1,0.0,"Vidyaranyapuri, Hanumakonda"],
"506011":[400,-1,0.0,"D H Suthoon, Hanumakonda"],
"506013":[410,703,0.0,"Laxmipur, Hanumakonda"],
"506015":[325,-1,0.0,"Bheemaram, Hanumakonda"],
"506101":[546,959,0.07,"Mahabubabad, Mahabubabad"],
"506102":[542,928,0.01,"Mallial, Mahabubabad"],
"506103":[522,920,0.02,"Nadiwada, Mahabubabad"],
"506104":[530,828,0.0,"Jangligonda, Mahabubabad"],
"506105":[601,976,0.0,"Sudenapalli, Mahabubabad"],
"506112":[293,885,0.01,"Alankhanipet, Warangal"],
"506122":[408,836,0.02,"Soorpalli, Warangal"],
"506132":[398,697,0.01,"Bhanjipet, Warangal"],
"506134":[720,-1,0.04,"Ayodhyapur, Mahabubabad"],
"506135":[425,854,0.02,"Inchaguda, Mahabubabad"],
"506142":[660,693,0.0,"Narayanagiri, Hanumakonda"],
"506143":[270,755,0.01,"Garmillapalli, Hanumakonda"],
"506144":[406,771,0.01,"Rajavaram, Jangoan"],
"506145":[310,599,0.0,"Abdulnagaram, Jangoan"],
"506146":[271,584,0.02,"Palakurthy, Jangoan"],
"506151":[295,679,0.0,"Rampur, Hanumakonda"],
"506163":[339,732,0.0,"Ammapur, Hanumakonda"],
"506164":[381,594,0.0,"Parkal, Warangal"],
"506165":[272,410,0.03,"Sarvai, Mulugu"],
"506166":[325,333,0.0,"Mamnoor, Hanumakonda"],
"506167":[420,524,0.01,"Jangaon, Jangoan"],
"506168":[348,696,0.02,"Laxmareddipalli, Jayashankar Bhupalapally"],
"506169":[517,1047,0.01,"Kasimpalli, Jayashankar Bhupalapally"],
"506170":[271,516,0.02,"Jadalpet, Jayashankar Bhupalapally"],
"506172":[188,204,0.01,"Balannagudem, Mulugu"],
"506175":[403,541,0.0,"Narmetta, Jangoan"],
"506201":[578,1240,0.22,"Pasaramadla, Jangoan"],
"506221":[342,563,0.0,"China Raman Cherla, Jangoan"],
"506222":[350,413,0.01,"Chennur, Jangoan"],
"506223":[380,589,0.05,"Chinchinkota, Siddipet"],
"506224":[512,-1,0.01,"Veerannapet, Siddipet"],
"506244":[505,1051,0.08,"Nidigonda, Jangoan"],
"506252":[240,976,0.01,"Bommera, Jangoan"],
"506301":[270,854,0.0,"Tatikonda, Jangoan"],
"506302":[330,560,0.05,"Mondrai, Jangoan"],
"506303":[61,102,0.0,"Wanaparthy, Jangoan"],
"506310":[332,468,0.0,"Punnel, Hanumakonda"],
"506313":[374,601,0.0,"Katrial, Hanumakonda"],
"506314":[319,564,0.01,"Kondapur, Warangal"],
"506315":[715,1054,0.0,"Dharmaram, Mahabubabad"],
"506316":[232,848,0.01,"Dardepalli, Jangoan"],
"506317":[355,469,0.01,"Pochampalli, Mahabubabad"],
"506318":[392,729,0.01,"Gantlakunta, Mahabubabad"],
"506319":[360,631,0.0,"Gatlakaniparthy, Jayashankar Bhupalapally"],
"506324":[443,892,0.01,"Gunnepalli, Mahabubabad"],
"506325":[461,876,0.01,"Nagaram, Warangal"],
"506329":[332,721,0.01,"VASANTAPUR CSP, Warangal"],
"506330":[410,605,0.0,"GANGADEVIPALLE, Hanumakonda"],
"506331":[410,684,0.02,"Viswanathapur, Warangal"],
"506332":[385,813,0.03,"Maqdumpuram, Mahabubabad"],
"506333":[398,692,0.01,"Mallampalli, Warangal"],
"506342":[325,622,0.0,"Dammannapet, Warangal"],
"506343":[405,898,0.0,"Abbapur, Mulugu"],
"506344":[290,462,0.07,"Machapur, Mulugu"],
"506345":[375,733,0.02,"Thimmapur, Jayashankar Bhupalapally"],
"506347":[360,972,0.04,"Oorattam, Mulugu"],
"506348":[356,678,0.01,"Ramannagudem, Jayashankar Bhupalapally"],
"506349":[340,646,0.0,"Vasanthapur, Mulugu"],
"506350":[355,661,0.0,"Relakunta, Warangal"],
"506352":[451,869,0.01,"Potlapur, Mulugu"],
"506355":[440,1314,0.15,"Posanpalli, Siddipet"],
"506356":[155,342,0.02,"Garimillapalli, Jayashankar Bhupalapally"],
"506365":[354,668,0.01,"Annaram, Warangal"],
"506366":[228,504,0.01,"Akinepalli, Jayashankar Bhupalapally"],
"506367":[438,443,0.03,"Rebarthy, Siddipet"],
"506368":[310,593,0.01,"Rajulakothapalli, Mahabubabad"],
"506369":[369,777,0.02,"Topanapalli, Warangal"],
"506370":[434,-1,0.0,"Devannapet, Hanumakonda"],
"506371":[325,-1,0.0,"Yellapur, Hanumakonda"],
"506381":[420,626,0.23,"Vennaram, Mahabubabad"],
"506391":[390,471,0.0,"Narlapur, Warangal"],
"507001":[410,559,0.1,"Khammam, Khammam"],
"507002":[415,777,0.01,"Ballepalli, Khammam"],
"507003":[433,968,0.01,"Papatpalli, Khammam"],
"507101":[320,810,0.03,"Kothagudem Colls, Bhadradri Kothagudem"],
"507103":[475,1065,0.04,"Penagadapa, Bhadradri Kothagudem"],
"507111":[324,524,3.46,"Bhadrachalam, Bhadradri Kothagudem"],
"507112":[850,1679,-1,"Posugudem, Bhadradri Kothagudem"],
"507114":[850,1389,3.94,"Nagineniprolu, Bhadradri Kothagudem"],
"507115":[234,1277,0.03,"Kinnersani Project, Bhadradri Kothagudem"],
"507116":[325,797,0.06,"Ashwapur, Bhadradri Kothagudem"],
"507117":[272,977,0.07,"Mallaram, Bhadradri Kothagudem"],
"507118":[306,720,0.03,"Garibpeta, Bhadradri Kothagudem"],
"507119":[292,891,0.04,"Rudrampur, Bhadradri Kothagudem"],
"507120":[292,927,0.04,"Karivarigudem, Bhadradri Kothagudem"],
"507122":[410,611,0.64,"Madhavaram, Khammam"],
"507123":[460,505,1.46,"Bhagyanagar Thanda, Bhadradri Kothagudem"],
"507124":[460,556,1.47,"Polaram, Bhadradri Kothagudem"],
"507125":[399,857,0.04,"P.V.Township, Bhadradri Kothagudem"],
"507126":[319,781,0.03,"Ramanujagudem, Bhadradri Kothagudem"],
"507127":[320,919,0.03,"Bodu, Bhadradri Kothagudem"],
"507128":[449,831,2.25,"Nellipaka, Bhadradri Kothagudem"],
"507133":[330,782,0.03,"Pusuguppa, Mulugu"],
"507136":[240,556,0.01,"Patrapuram, Mulugu"],
"507137":[350,637,0.01,"Gangolu, Bhadradri Kothagudem"],
"507140":[300,940,0.04,"DEVARAPALLI, Bhadradri Kothagudem"],
"507154":[292,1118,0.04,"Collectorate(Bhadradri Kothagudem)ND, Bhadradri Kothagudem"],
"507157":[682,993,0.02,"Nayakangudem, Khammam"],
"507158":[470,575,0.02,"Mallannapalem, Khammam"],
"507159":[595,828,0.01,"Perikasingaram, Khammam"],
"507160":[345,567,0.02,"Bodualbanda, Khammam"],
"507161":[656,984,0.01,"Bachodu, Khammam"],
"507163":[433,687,0.0,"Gopalapuram, Khammam"],
"507164":[440,1233,0.22,"Kunchaparthi, Khammam"],
"507165":[522,1150,0.06,"Kondakodima, Khammam"],
"507166":[250,862,0.05,"Kakarla, Bhadradri Kothagudem"],
"507167":[385,1070,0.06,"Annaruguda, Khammam"],
"507168":[292,744,0.03,"Jannaram, Khammam"],
"507169":[470,595,0.02,"Mallaram, Khammam"],
"507170":[530,1098,0.02,"Jeelacheruvu, Khammam"],
"507171":[511,928,0.03,"Bendalapadu, Bhadradri Kothagudem"],
"507182":[390,625,1.42,"Budidampad, Khammam"],
"507183":[680,873,0.0,"Dammaigudem, Khammam"],
"507201":[643,1932,0.01,"Meenavolu, Khammam"],
"507202":[405,1371,0.16,"Choppakatlapalem, Khammam"],
"507203":[360,1042,0.3,"Chilkur, Khammam"],
"507204":[510,974,0.05,"Choppakatlapalem, Khammam"],
"507208":[522,1006,0.03,"Kodumuru, Khammam"],
"507209":[385,913,0.04,"Korlagudem, Khammam"],
"507210":[440,603,0.57,"Budharam, Mahabubabad"],
"507211":[305,904,0.05,"Uppalapahad, Mahabubabad"],
"507301":[70,225,0.02,"Gummadivalli, Bhadradri Kothagudem"],
"507302":[472,824,0.07,"Kuppanakuntla, Khammam"],
"507303":[350,598,0.63,"Nagupalli, Khammam"],
"507304":[448,1016,0.23,"Brahmanapalli, Khammam"],
"507305":[539,1166,0.04,"Konijerla, Khammam"],
"507306":[188,385,0.02,"Vadlagudem, Bhadradri Kothagudem"],
"507315":[370,1009,0.0,"Regallapadu, Bhadradri Kothagudem"],
"507316":[536,709,0.01,"Abbugudem, Bhadradri Kothagudem"],
"507318":[539,1144,0.03,"Allipuram, Khammam"],
"508001":[260,1107,0.04,"Nalgonda, Nalgonda"],
"508002":[260,1109,0.04,"Appajipet, Nalgonda"],
"508004":[370,1000,0.05,"Cherla Gowravaram, Nalgonda"],
"508101":[470,-1,0.01,"Golankonda, Yadadri Bhuvanagiri"],
"508105":[350,688,0.37,"Challoor, Yadadri Bhuvanagiri"],
"508111":[568,811,0.05,"Paladugu, Yadadri Bhuvanagiri"],
"508112":[645,1686,0.05,"Sunkishala, Yadadri Bhuvanagiri"],
"508113":[750,1255,0.02,"Suraram, Yadadri Bhuvanagiri"],
"508114":[452,1062,0.05,"Mandra, Nalgonda"],
"508115":[465,1104,0.33,"Jangampalli, Yadadri Bhuvanagiri"],
"508116":[465,830,0.11,"Bhongir, Yadadri Bhuvanagiri"],
"508117":[470,1081,0.26,"Hanumapuram, Yadadri Bhuvanagiri"],
"508126":[470,910,0.2,"Guduru, Yadadri Bhuvanagiri"],
"508201":[325,660,0.04,"Ganugabanda, Suryapet"],
"508202":[360,825,0.02,"Vijayapuri North, Nalgonda"],
"508204":[380,675,0.01,"Karakkayala Gudem, Suryapet"],
"508205":[412,1088,0.1,"Dugenevally, Nalgonda"],
"508206":[470,829,0.01,"Dwarakunta, Suryapet"],
"508207":[421,956,0.08,"Miryalguda, Nalgonda"],
"508208":[455,1005,0.09,"Babasahebpet, Nalgonda"],
"508210":[333,1159,0.33,"Bhairavanibanda, Nalgonda"],
"508211":[440,1029,0.06,"Chandampally, Nalgonda"],
"508212":[626,990,0.02,"Annariguda, Suryapet"],
"508213":[444,1091,0.05,"Suryapet, Suryapet"],
"508214":[448,1115,0.03,"Chintalacheruvu, Suryapet"],
"508217":[468,705,0.16,"Molkapatnam, Nalgonda"],
"508218":[353,780,0.1,"Bodaladinne, Suryapet"],
"508221":[395,1031,0.02,"Edavalli, Suryapet"],
"508223":[350,579,0.06,"Jalalpuram, Suryapet"],
"508224":[490,1190,0.11,"Kandagatla, Suryapet"],
"508233":[825,1192,0.02,"Akupamula, Suryapet"],
"508234":[660,1198,0.02,"Ratnavaram, Suryapet"],
"508238":[442,1399,0.04,"Kuchipudi, Suryapet"],
"508243":[328,900,0.04,"Mustipalli, Nalgonda"],
"508244":[438,1180,0.06,"Narsinghpatla, Nalgonda"],
"508245":[530,1054,0.12,"Ananthampet, Nalgonda"],
"508246":[394,908,0.06,"Chintriyala, Suryapet"],
"508247":[490,952,0.01,"Indloor, Nalgonda"],
"508248":[340,652,0.02,"Gagillapur, Nalgonda"],
"508250":[459,651,0.03,"Kurmedu, Nalgonda"],
"508252":[700,1483,0.08,"Jaikesaram, Yadadri Bhuvanagiri"],
"508253":[590,1100,0.21,"Gujja, Yadadri Bhuvanagiri"],
"508254":[466,1067,0.07,"Vattimarthi, Nalgonda"],
"508255":[495,1172,0.1,"G.Aeroli, Nalgonda"],
"508256":[495,804,0.13,"Koppole, Nalgonda"],
"508257":[344,888,0.06,"Palwai, Nalgonda"],
"508258":[438,552,0.01,"Mududandla, Nalgonda"],
"508266":[382,1083,0.04,"Utlapally, Nalgonda"],
"508277":[350,603,0.13,"Chowllaramavaram, Yadadri Bhuvanagiri"],
"508278":[330,506,0.01,"Tummadam, Nalgonda"],
"508279":[450,1204,0.04,"Pasthala, Suryapet"],
"508280":[417,1154,0.02,"Gonrentla, Suryapet"],
"508284":[630,1355,0.07,"Jiblakpalli, Yadadri Bhuvanagiri"],
"508285":[603,1193,0.04,"Bollepalli, Yadadri Bhuvanagiri"],
"508286":[435,553,0.02,"Varaturu, Yadadri Bhuvanagiri"],
"508355":[416,984,0.13,"Dilawarpur, Nalgonda"],
"508373":[383,749,0.1,"Medlavai, Nalgonda"],
"508374":[461,854,0.1,"Chirumarthy, Nalgonda"],
"508376":[440,1249,0.1,"Yendlapally, Suryapet"],
"508377":[318,572,0.01,"Anumula, Nalgonda"],
"509001":[438,1092,0.85,"Mahabubnagar, Mahabubnagar"],
"509002":[438,1110,0.87,"Boyapally, Mahabubnagar"],
"509102":[645,1256,0.11,"Singotam, Nagarkurnool"],
"509103":[278,740,0.31,"Wanaparthy, Wanaparthy"],
"509104":[429,636,0.21,"Chinnamaroor, Wanaparthy"],
"509105":[348,872,0.04,"Ayyavaripally, Wanaparthy"],
"509106":[235,334,0.11,"Pedamandadi, Wanaparthy"],
"509110":[428,623,0.06,"Dantanoor, Wanaparthy"],
"509120":[470,668,0.03,"Mahmmadapuram, Wanaparthy"],
"509125":[696,730,0.18,"Gadwal, Jogulamba Gadwal"],
"509126":[549,1312,0.03,"Paipadu, Jogulamba Gadwal"],
"509127":[717,1462,0.07,"Mittadoddi, Jogulamba Gadwal"],
"509128":[390,1104,0.03,"Peddamamidala Padu, Jogulamba Gadwal"],
"509129":[667,1880,0.05,"Tottinon Doddi, Jogulamba Gadwal"],
"509130":[511,797,0.11,"Nagal Kadmoor, Wanaparthy"],
"509131":[497,685,0.16,"Rechintala, Wanaparthy"],
"509132":[713,719,0.18,"Amervoi, Jogulamba Gadwal"],
"509133":[722,-1,0.19,"Alwalpad, Jogulamba Gadwal"],
"509135":[390,1193,0.04,"Yapadinne, Jogulamba Gadwal"],
"509152":[575,1418,0.05,"Bukkapur, Jogulamba Gadwal"],
"509153":[398,1183,0.02,"Marmungal, Jogulamba Gadwal"],
"509201":[229,320,0.01,"Thirmalapuram, Nagarkurnool"],
"509202":[520,-1,0.0,"Burgula, Ranga Reddy"],
"509203":[422,-1,0.0,"Gangaram, Nagarkurnool"],
"509204":[322,-1,0.0,"Dokur, Mahabubnagar"],
"509205":[450,984,0.1,"Kollampalli, Narayanpet"],
"509206":[466,632,0.04,"Singaiapalli, Nagarkurnool"],
"509207":[475,695,0.06,"Mutpoor, Ranga Reddy"],
"509208":[547,786,0.06,"Chityala, Narayanpet"],
"509209":[476,-1,0.0,"Uuyyalwada, Nagarkurnool"],
"509210":[351,756,0.12,"Amdipur, Narayanpet"],
"509215":[235,340,0.11,"Khanapur, Nagarkurnool"],
"509216":[501,-1,0.0,"Doskal, Ranga Reddy"],
"509217":[298,630,1.37,"Hythabad, Ranga Reddy"],
"509219":[322,449,0.0,"Rekulampalli, Mahabubnagar"],
"509228":[380,496,0.0,"Nandigaon, Ranga Reddy"],
"509235":[476,-1,0.0,"Nagapore, Wanaparthy"],
"509301":[502,514,0.23,"Stn. Jadcherla, Mahabubnagar"],
"509302":[565,630,0.31,"Bhuddasamadram, Nagarkurnool"],
"509311":[437,729,0.06,"Chinnaporla, Narayanpet"],
"509320":[455,510,0.01,"Rachala Pally, Nagarkurnool"],
"509321":[497,-1,0.52,"Akuthotapalli, Ranga Reddy"],
"509324":[370,762,0.0,"Raghupathipeta, Nagarkurnool"],
"509325":[455,476,0.0,"Kalwakole, Ranga Reddy"],
"509326":[318,562,0.0,"Watwarlapalli, Nagarkurnool"],
"509327":[494,-1,0.12,"Appareddipally, Ranga Reddy"],
"509328":[298,573,1.07,"Kanha Shanti Vanam ND, Ranga Reddy"],
"509334":[430,1108,2.15,"Tankara, Mahabubnagar"],
"509335":[356,457,2.48,"Antharam, Vikarabad"],
"509336":[478,760,0.11,"Antharam, Vikarabad"],
"509337":[356,410,1.34,"Mangampet, Mahabubnagar"],
"509338":[330,707,0.39,"Parsapur, Vikarabad"],
"509339":[680,980,0.13,"Chandravancha, Narayanpet"],
"509340":[511,-1,0.0,"Lingampaly, Mahabubnagar"],
"509349":[512,526,0.06,"Thippareddypalli, Nagarkurnool"],
"509350":[680,841,0.1,"Hakeempet, Narayanpet"],
"509351":[451,868,0.08,"Theelair, Narayanpet"],
"509352":[407,761,0.0,"Tangadgi, Narayanpet"],
"509353":[497,944,0.08,"Kachwar, Narayanpet"],
"509357":[430,-1,0.11,"Kothapalli, Mahabubnagar"],
"509358":[279,434,2.28,"Ekvaipalli, Ranga Reddy"],
"509360":[363,890,0.02,"Kuppagandla, Nagarkurnool"],
"509371":[504,875,0.99,"Chandraspalli, Mahabubnagar"],
"509375":[310,333,0.0,"Ghanpur, Nagarkurnool"],
"509376":[340,-1,0.0,"Penmella, Nagarkurnool"],
"509380":[322,593,0.6,"Laxmipally, Mahabubnagar"],
"509381":[438,1107,0.85,"Kanmetta, Wanaparthy"],
"509382":[438,730,1.27,"Kandur, Mahabubnagar"],
"509385":[389,462,0.06,"Laxmapur, Nagarkurnool"],
"509401":[390,818,0.09,"Kondareddipally, Nagarkurnool"],
"509406":[441,1087,0.14,"Yelkacherla, Mahabubnagar"],
"509407":[554,1134,0.12,"Bommanpad, Narayanpet"],
"509408":[466,571,0.09,"Eklaskhampet, Ranga Reddy"],
"509409":[413,727,0.05,"Nellikondi, Mahabubnagar"],
"509410":[410,666,0.0,"Manmarri, Ranga Reddy"],
"509411":[528,1030,0.12,"Dorepally, Narayanpet"],
"509412":[390,632,0.12,"Mustipally, Nagarkurnool"],
"515001":[320,-1,0.0,"Anantapur, Anantapur"],
"515002":[320,530,0.0,"Bramhanayaleru, Anantapur"],
"515003":[320,-1,0.0,"AKUTHOTAPALLI, Anantapur"],
"515004":[465,-1,0.0,"Somaladoddi, Anantapur"],
"515005":[465,-1,0.0,"Rajaji Street, Anantapur"],
"515006":[326,562,0.0,"Syndicate Nagar, Anantapur"],
"515101":[236,-1,0.0,"Nyamaddala, Sri Sathya Sai"],
"515110":[537,1279,0.02,"Bandlapalli, Sri Sathya Sai"],
"515122":[325,1095,0.0,"Challapalli, Sri Sathya Sai"],
"515123":[250,839,0.0,"Gonimekalapalli, Sri Sathya Sai"],
"515124":[538,1107,0.02,"Kalipi, Sri Sathya Sai"],
"515133":[409,938,0.07,"Kappalabanda, Sri Sathya Sai"],
"515134":[352,745,0.01,"Badenaikthanda, Sri Sathya Sai"],
"515144":[447,848,0.12,"Kodapaganipalli, Sri Sathya Sai"],
"515154":[725,859,0.01,"Kothakota, Sri Sathya Sai"],
"515159":[465,-1,0.0,"Elukuntla, Sri Sathya Sai"],
"515164":[335,782,0.0,"Kurubavandlapalli, Sri Sathya Sai"],
"515201":[325,583,0.0,"Hindupur, Sri Sathya Sai"],
"515202":[325,569,0.0,"Hindupur Fort, Sri Sathya Sai"],
"515211":[302,825,0.01,"Chowluru, Sri Sathya Sai"],
"515212":[205,229,0.0,"Sasanakota, Sri Sathya Sai"],
"515231":[716,1583,0.06,"Karavulapalli, Sri Sathya Sai"],
"515241":[620,628,0.0,"Budidagaddapalli, Sri Sathya Sai"],
"515251":[560,859,0.0,"NACIN, Sri Sathya Sai"],
"515261":[291,613,0.0,"Honnampalli, Sri Sathya Sai"],
"515271":[465,-1,0.0,"Mandalahalli, Sri Sathya Sai"],
"515281":[325,-1,0.0,"Aladahalli, Sri Sathya Sai"],
"515286":[262,272,0.01,"Nachenahalli, Sri Sathya Sai"],
"515291":[208,736,0.01,"Guddampalle, Sri Sathya Sai"],
"515301":[210,790,0.02,"Aswartharayaniroppam, Sri Sathya Sai"],
"515303":[210,786,0.02,"R.Anantapuram, Anantapur"],
"515305":[205,569,0.01,"Basavanahalli, Sri Sathya Sai"],
"515311":[465,-1,0.0,"Hallikera Devarahalli, Sri Sathya Sai"],
"515321":[330,625,0.0,"Dokkalahalli, Sri Sathya Sai"],
"515331":[325,2110,0.02,"Demakethapalli, Sri Sathya Sai"],
"515341":[490,827,0.01,"Bhupasamudram, Sri Sathya Sai"],
"515401":[560,1309,0.01,"Konganapalli, Anantapur"],
"515402":[526,1167,0.01,"Karidikonda, Anantapur"],
"515405":[582,1297,0.01,"Lachumpalli, Anantapur"],
"515408":[789,2269,0.37,"Konauppalapadu, Anantapur"],
"515411":[173,-1,0.0,"Bondaladinne, Anantapur"],
"515413":[188,-1,0.0,"Bhogasamudram Project, Anantapur"],
"515414":[345,-1,0.01,"Diguvapalli, Anantapur"],
"515415":[185,-1,0.0,"Igaduru, Anantapur"],
"515425":[320,-1,0.0,"Nadimidoddi, Anantapur"],
"515435":[487,1039,0.01,"Narasapuram West, Anantapur"],
"515445":[303,-1,0.01,"Kadavakallu, Anantapur"],
"515455":[480,1039,0.01,"Lakshumpalli, Anantapur"],
"515465":[495,2130,0.0,"Chilamakuru, Anantapur"],
"515501":[713,1104,0.02,"Gopepalli, Sri Sathya Sai"],
"515511":[725,-1,0.0,"Uppalapadu, Sri Sathya Sai"],
"515521":[634,1180,0.01,"Katarupalle, Sri Sathya Sai"],
"515531":[460,906,0.01,"Bonthalapalle, Sri Sathya Sai"],
"515541":[222,761,0.01,"Chippalamadugu, Sri Sathya Sai"],
"515551":[780,1889,0.0,"Peddayellampalli, Sri Sathya Sai"],
"515556":[584,1116,0.01,"Tummala, Sri Sathya Sai"],
"515561":[410,597,0.01,"Gowrapuram, Sri Sathya Sai"],
"515571":[780,1166,0.0,"Balasamudram, Sri Sathya Sai"],
"515581":[430,-1,0.0,"Nuthanakalva, Sri Sathya Sai"],
"515591":[550,1087,0.01,"Muthyalacheruvu, Sri Sathya Sai"],
"515601":[360,384,0.0,"Nesevandlapalli, Sri Sathya Sai"],
"515611":[403,856,0.18,"Chitrachedu, Anantapur"],
"515621":[170,935,0.0,"Bhanukota, Sri Sathya Sai"],
"515631":[858,-1,0.02,"Marrimakulapalle, Sri Sathya Sai"],
"515641":[358,636,0.01,"Dadalur, Sri Sathya Sai"],
"515651":[372,773,0.01,"Kanumukkala, Sri Sathya Sai"],
"515661":[672,-1,0.01,"Musturu, Sri Sathya Sai"],
"515671":[523,1159,0.02,"Dharmavaram, Sri Sathya Sai"],
"515672":[541,1062,0.02,"Badannapalli, Sri Sathya Sai"],
"515701":[345,389,0.01,"K.K.Agraharam, Anantapur"],
"515711":[190,802,0.0,"Karutlapalli, Anantapur"],
"515721":[543,-1,0.0,"Chiyyedu, Anantapur"],
"515722":[608,-1,0.01,"Hampapuram, Anantapur"],
"515731":[320,-1,0.0,"Marthadu, Anantapur"],
"515741":[459,1130,0.03,"Nakkalapalli, Anantapur"],
"515751":[522,639,0.0,"Goridindla, Anantapur"],
"515761":[280,1034,0.04,"Chapiri, Anantapur"],
"515763":[270,780,0.03,"Theetakallu, Anantapur"],
"515765":[318,1092,0.01,"Marrimakulapalli, Anantapur"],
"515766":[385,-1,0.0,"Kadarampalli, Anantapur"],
"515767":[311,1439,-1,"Cheliminahalli, Anantapur"],
"515774":[559,1505,0.02,"Kesavapuram, Anantapur"],
"515775":[620,1184,0.01,"G.Kottala, Anantapur"],
"515787":[280,778,0.04,"Bhattuvanipalli, Anantapur"],
"515801":[639,1683,0.03,"Guntakal, Anantapur"],
"515803":[600,1711,0.03,"Dosaludiki, Anantapur"],
"515812":[840,2052,2.45,"Renimakulapalli, Anantapur"],
"515822":[579,2046,0.04,"Nimbagallu, Anantapur"],
"515832":[617,1644,0.03,"Gadehothur, Anantapur"],
"515842":[760,1955,0.1,"Kadadarabenchi, Anantapur"],
"515863":[346,1325,0.01,"B.T.Project, Anantapur"],
"515865":[227,495,0.01,"Chadam, Anantapur"],
"515867":[235,801,0.0,"B.N.Halli, Anantapur"],
"515870":[563,2698,-1,"Palthur, Anantapur"],
"515871":[268,847,0.0,"Bommanahal, Anantapur"],
"515872":[344,1719,-1,"MALAPANAGUDI, Anantapur"],
"516001":[335,514,0.0,"Cuddapah, Y.S.R."],
"516002":[355,678,0.01,"Chinnachowk, Y.S.R."],
"516003":[335,530,0.0,"Chintha Komma Dinne, Y.S.R."],
"516004":[358,690,0.02,"Industrial Estate, Y.S.R."],
"516005":[379,836,0.01,"Yogi Vemana University S.O., Y.S.R."],
"516101":[388,834,-1,"Obanapalli, Y.S.R."],
"516104":[398,-1,0.0,"Devamachupalli, Y.S.R."],
"516105":[419,726,0.0,"Balireddy Palli, Annamayya"],
"516107":[384,-1,0.0,"Dalavaipalli, Y.S.R."],
"516108":[408,533,0.0,"Chinnampelli, Y.S.R."],
"516110":[435,462,0.0,"Bommavaram, Y.S.R."],
"516115":[351,355,0.03,"Rajampet, Y.S.R."],
"516126":[287,364,0.03,"Brahmanapalli, Y.S.R."],
"516127":[335,514,0.0,"Velagacherla, Y.S.R."],
"516128":[335,514,0.0,"Kattavaripalli, Y.S.R."],
"516129":[335,514,0.0,"Madithadu, Y.S.R."],
"516130":[205,-1,0.07,"Gundlapalli, Y.S.R."],
"516150":[338,406,0.04,"Allwyn Nagar, Y.S.R."],
"516151":[326,380,0.0,"Pothapi, Y.S.R."],
"516152":[285,474,0.0,"Nadimpalli, Y.S.R."],
"516162":[345,1210,0.01,"Mundlapalli, Y.S.R."],
"516163":[502,1419,0.02,"Kothapet, Y.S.R."],
"516172":[484,1450,0.01,"Krishnapuram, Y.S.R."],
"516173":[362,1338,0.04,"Ellampalle, Y.S.R."],
"516175":[760,1320,0.96,"Nelatur, Y.S.R."],
"516193":[280,808,0.03,"Boppapuram, Y.S.R."],
"516203":[401,1830,0.02,"Appanapalli, Y.S.R."],
"516213":[310,450,-1,"Gollapalli, Y.S.R."],
"516214":[465,1006,0.8,"Kalibanda, Y.S.R."],
"516215":[303,793,0.35,"Motakatla, Y.S.R."],
"516216":[376,822,0.01,"Gopalapuram, Y.S.R."],
"516217":[286,809,0.03,"Brahmanapalli, Y.S.R."],
"516218":[447,853,0.04,"Minnaiahgaripalle, Y.S.R."],
"516227":[473,608,0.05,"Chinthalacheruvu, Y.S.R."],
"516228":[381,695,0.05,"B . Kodur, Y.S.R."],
"516233":[737,-1,0.02,"Bethayapalli, Y.S.R."],
"516237":[366,761,0.02,"Jyothi, Y.S.R."],
"516247":[312,455,-1,"Nekanapuram, Y.S.R."],
"516257":[392,-1,0.01,"Ananthapuram, Y.S.R."],
"516259":[365,751,0.16,"Gangarapupalli, Y.S.R."],
"516267":[881,1650,0.24,"Gundlacheruvu, Y.S.R."],
"516268":[501,-1,0.04,"Gurrappagaripalli, Y.S.R."],
"516269":[581,-1,0.24,"Anumpalli, Y.S.R."],
"516270":[586,-1,0.24,"Pothukurapalli, Y.S.R."],
"516289":[400,1113,0.04,"Gangavaram, Y.S.R."],
"516293":[440,1387,0.03,"Ambavaram, Y.S.R."],
"516309":[440,1051,0.01,"T Sunkesula, Y.S.R."],
"516310":[400,876,0.0,"Nidizuvvi, Y.S.R."],
"516311":[440,1061,0.01,"Krishna Nagar S.O (Cuddapah), Y.S.R."],
"516312":[371,1242,0.27,"Illur, Y.S.R."],
"516321":[370,963,0.01,"Busireddypalle, Y.S.R."],
"516329":[471,669,0.06,"Tangedupalle, Y.S.R."],
"516330":[230,474,0.0,"Idupulapaya(IIIT), Y.S.R."],
"516339":[440,1084,0.01,"A. Obayapalle, Y.S.R."],
"516349":[300,415,0.01,"Chagaleru, Y.S.R."],
"516350":[404,621,0.04,"Kathalur, Y.S.R."],
"516355":[400,1304,0.02,"Nakkaladinne, Y.S.R."],
"516356":[561,1279,0.23,"Alladupalle, Y.S.R."],
"516359":[760,1389,1.51,"Arakatavemula, Y.S.R."],
"516360":[535,1284,0.47,"Proddatur, Y.S.R."],
"516361":[566,1137,0.44,"Peddasettipalle, Y.S.R."],
"516362":[400,1338,0.41,"Meenapuram, Y.S.R."],
"516380":[200,815,0.0,"Chintakunta, Y.S.R."],
"516390":[191,380,0.0,"Pulivendla, Y.S.R."],
"516391":[230,456,0.0,"Peddajutur, Y.S.R."],
"516396":[527,722,0.0,"Chinnakudala, Y.S.R."],
"516401":[294,1147,0.0,"Kamballe, Y.S.R."],
"516411":[480,1739,0.02,"Balapanagudur, Y.S.R."],
"516421":[263,926,0.0,"Achavalli, Y.S.R."],
"516431":[440,1553,0.01,"Gundlakunta, Y.S.R."],
"516432":[274,730,0.01,"Kallutla, Y.S.R."],
"516433":[400,1104,0.01,"Torrivemula, Y.S.R."],
"516434":[400,2974,0.03,"Palur, Y.S.R."],
"516439":[400,876,0.01,"Mylavaram S.O (Cuddapah), Y.S.R."],
"516444":[260,1459,0.0,"Mangapatnam, Y.S.R."],
"516454":[485,2188,0.0,"Bidinamcherla, Y.S.R."],
"516464":[310,3714,0.0,"Nandyalampalle, Y.S.R."],
"516474":[461,857,0.13,"Erragudi, Y.S.R."],
"516484":[220,949,0.0,"Madur, Y.S.R."],
"516501":[656,-1,0.0,"Chenduvoyi, Y.S.R."],
"516502":[408,672,0.05,"Gunthapalli, Y.S.R."],
"516503":[320,762,0.05,"Palugurallapalli, Y.S.R."],
"516504":[392,-1,0.02,"Chitlur, Y.S.R."],
"516505":[282,809,0.03,"Thokalapalli, Y.S.R."],
"517001":[466,873,0.03,"Chittoor, Chittoor"],
"517002":[466,825,0.03,"Chennamagudipalle, Chittoor"],
"517004":[405,726,0.02,"Cherlopalle, Chittoor"],
"517101":[376,725,0.24,"Chandragiri, Tirupati"],
"517102":[376,759,0.24,"Ayithepalle, Tirupati"],
"517112":[465,-1,0.0,"Chittipiralla, Chittoor"],
"517113":[446,585,0.02,"Cherukuvaripalle, Chittoor"],
"517123":[384,629,0.1,"Cherukuvaipalle, Chittoor"],
"517124":[510,-1,0.0,"Palakur, Chittoor"],
"517125":[480,672,0.01,"Ramanaidupalle, Chittoor"],
"517126":[579,-1,0.06,"Jakkidona, Chittoor"],
"517127":[579,-1,0.06,"Chittoor Sugarfactory, Chittoor"],
"517128":[285,474,0.0,"Madhavaram IRM, Chittoor"],
"517129":[452,452,0.0,"Gajulapalle, Chittoor"],
"517130":[699,761,0.03,"Ellampalle Kothuru, Chittoor"],
"517131":[625,777,0.04,"Puthur, Chittoor"],
"517132":[500,1521,0.0,"Chittapara, Chittoor"],
"517152":[520,991,0.0,"Krishnapuram, Tirupati"],
"517167":[255,351,0.0,"Nellaipalle, Chittoor"],
"517172":[500,514,0.0,"Pulicherla, Chittoor"],
"517192":[325,518,0.0,"Peddagottigallu, Chittoor"],
"517193":[450,501,0.0,"T.Sattevaripalle, Tirupati"],
"517194":[426,627,0.24,"Nerabailu, Tirupati"],
"517213":[325,1022,0.0,"Garnimitta, Chittoor"],
"517214":[325,533,0.0,"Mudupulavemula, Annamayya"],
"517234":[476,729,0.04,"Guttapalem, Chittoor"],
"517235":[435,1192,0.16,"Thimmapuram, Annamayya"],
"517236":[457,1586,0.12,"Galivaripalle, Annamayya"],
"517237":[442,702,0.07,"Budithavedu, Chittoor"],
"517247":[869,-1,0.02,"Arikela, Annamayya"],
"517257":[808,1598,0.0,"Gaddamvaripalle, Chittoor"],
"517277":[620,1165,0.01,"Gandaboyanapalle, Annamayya"],
"517280":[510,1550,0.0,"Agraharam, Annamayya"],
"517291":[659,1384,0.0,"Amilepalle, Annamayya"],
"517297":[472,979,0.26,"Kadirirayacheruvu, Annamayya"],
"517299":[600,1366,0.0,"Kuraparthi, Annamayya"],
"517305":[465,1498,0.02,"Nadimcherla, Annamayya"],
"517319":[408,835,0.09,"Gajulavaripalle, Annamayya"],
"517325":[842,1658,0.0,"Madanapalle, Annamayya"],
"517326":[689,1194,0.0,"Basinikonda, Annamayya"],
"517350":[713,1355,0.0,"Matluvaripalle, Annamayya"],
"517351":[792,1550,0.0,"Devalacheruvu, Annamayya"],
"517352":[748,1455,0.0,"Thettu, Annamayya"],
"517370":[275,429,0.0,"Badikayalapalle, Annamayya"],
"517390":[736,1170,0.0,"Mulakalacheruvu, Annamayya"],
"517391":[431,545,0.0,"Kandukuru, Annamayya"],
"517401":[545,1217,0.09,"Muddanapalle, Chittoor"],
"517403":[550,1356,0.04,"Adilakshmambapuram, Chittoor"],
"517408":[609,1132,0.16,"Chalamangalam, Chittoor"],
"517414":[808,1598,0.0,"Itikanellore, Chittoor"],
"517415":[631,1187,0.16,"Theertham, Chittoor"],
"517416":[469,-1,0.03,"K.G. Satram, Chittoor"],
"517417":[588,1519,0.0,"Chokkandlapalle, Annamayya"],
"517418":[570,893,0.0,"Bandrevu, Annamayya"],
"517419":[480,774,0.02,"Muthukur NRP, Chittoor"],
"517421":[666,1252,0.01,"Varathur, Chittoor"],
"517422":[480,910,0.03,"Budithireddipalle, Chittoor"],
"517423":[652,-1,0.01,"Boyanapalle, Chittoor"],
"517424":[385,1083,0.22,"Chintamakulapalle, Chittoor"],
"517425":[424,810,0.0,"Cheekunatham, Chittoor"],
"517426":[442,747,0.0,"Gudipalle, Chittoor"],
"517429":[666,1252,0.01,"Gurramkonda Vandlavuru, Chittoor"],
"517432":[280,758,0.17,"Chappidipalle, Chittoor"],
"517501":[352,737,0.35,"Tirupati, Tirupati"],
"517502":[348,807,0.0,"S.V.Arts College, Chittoor"],
"517503":[352,723,0.31,"Daminadu, Tirupati"],
"517504":[362,650,0.82,"Tirumala North, Tirupati"],
"517505":[465,-1,0.0,"C.Gollapalle, Tirupati"],
"517506":[342,721,0.5,"Settipalli, Tirupati"],
"517507":[352,750,0.35,"A.P.H.B.Colony, Tirupati"],
"517508":[278,510,0.0,"Chiguruvada, Tirupati"],
"517509":[362,738,0.4,"Mangalam, Chittoor"],
"517510":[450,-1,0.0,"Munjurpattu, Vellore"],
"517520":[371,588,0.23,"Cotton Mills, Tirupati"],
"517526":[360,568,0.19,"Gudimallam, Tirupati"],
"517536":[458,572,0.05,"Kasaram, Tirupati"],
"517541":[398,1185,0.09,"Kadur, Chittoor"],
"517551":[352,715,0.01,"Padiredu, Tirupati"],
"517561":[441,754,0.01,"Balijapalli, Tirupati"],
"517569":[278,373,0.0,"Pathagunta, Chittoor"],
"517571":[356,785,0.0,"Alimelumangapuram, Tirupati"],
"517581":[362,1171,0.0,"Palamangalam, Tirupati"],
"517582":[220,410,0.0,"Annur, Chittoor"],
"517583":[348,774,0.0,"Nesanur, Tirupati"],
"517584":[330,960,0.0,"Parameswaramangalam, Tirupati"],
"517586":[500,1333,0.06,"Kosalanagaram, Chittoor"],
"517587":[330,1122,0.04,"Kotamangapuram, Tirupati"],
"517588":[224,283,0.04,"Madanambedu, Tirupati"],
"517589":[368,895,0.01,"Govardhanagiri, Tirupati"],
"517590":[330,1122,-1,"Kothur Venkatapuram, Chittoor"],
"517591":[352,1199,0.04,"Agaram, Chittoor"],
"517592":[530,1175,0.1,"Mudipalle, Chittoor"],
"517599":[238,473,0.0,"Deenabandupuram, Chittoor"],
"517619":[346,467,0.02,"Anjimedu, Tirupati"],
"517620":[335,-1,0.01,"Empedu, Tirupati"],
"517640":[350,479,0.02,"Agraharam, Tirupati"],
"517641":[346,449,0.02,"Bandarupalle, Tirupati"],
"517642":[338,515,0.02,"Konathaneri, Chittoor"],
"517643":[354,606,0.03,"Adavaram, Tirupati"],
"517644":[350,516,0.02,"Srikalahasti, Tirupati"],
"517645":[464,1075,0.31,"Alathur, Tirupati"],
"517646":[346,-1,0.01,"Chilamathur, Tirupati"],
"518001":[575,1100,0.03,"Kurnool, Kurnool"],
"518002":[575,1178,0.04,"Dinnedevarapadu, Kurnool"],
"518003":[575,1171,0.04,"Industrial Estate, Kurnool"],
"518004":[575,1115,0.03,"Edururu, Kurnool"],
"518005":[575,1154,0.04,"Ashoknagar S.O (Kurnool), Kurnool"],
"518006":[398,1096,0.03,"Stantanpuram, Kurnool"],
"518007":[575,1208,0.04,"B.Tandrapadu, Kurnool"],
"518010":[516,1065,0.05,"Komarole, Kurnool"],
"518101":[165,660,0.05,"Srisailam, Nandyal"],
"518102":[165,573,0.05,"S.S.Dam East, Nandyal"],
"518112":[574,1400,0.13,"Sugalithanda, Nandyal"],
"518122":[273,359,0.26,"Cherlopalli, Nandyal"],
"518123":[236,-1,0.0,"Ankireddypalli, Nandyal"],
"518124":[420,1141,0.72,"Lingambodu, Nandyal"],
"518134":[451,1495,0.27,"Gunjalapadu, Nandyal"],
"518135":[460,1187,0.03,"Ammireddinagar, Nandyal"],
"518145":[426,1114,0.03,"Akkampalli, Nandyal"],
"518155":[566,901,0.06,"Injedu, Nandyal"],
"518165":[370,817,0.15,"Mukkamalla, Nandyal"],
"518166":[293,464,0.01,"Ramireddipalle, Nandyal"],
"518176":[750,2691,0.1,"Ramakrishnapuram, Nandyal"],
"518186":[580,1758,0.07,"Illuri Kotha Peta, Nandyal"],
"518196":[253,351,0.21,"Singanapalle, Nandyal"],
"518206":[410,506,0.05,"Kandikayapalli, Nandyal"],
"518216":[538,960,0.09,"Amakathadu, Kurnool"],
"518217":[663,924,0.07,"Kalugotla, Kurnool"],
"518218":[617,1183,0.06,"Bastipadu, Kurnool"],
"518220":[465,-1,0.07,"Kommemarri, Nandyal"],
"518221":[507,669,0.1,"Devarabanda, Nandyal"],
"518222":[320,-1,0.0,"Jagadurthi, Nandyal"],
"518225":[538,1229,0.08,"Erukalacheruvu, Kurnool"],
"518301":[760,2062,0.02,"Adoni, Kurnool"],
"518302":[760,1998,0.02,"Dibbanakallu, Kurnool"],
"518308":[787,2008,0.48,"Hebbatam, Kurnool"],
"518313":[820,1788,0.09,"Belagallu, Kurnool"],
"518323":[501,1095,0.03,"Doddanakeri, Kurnool"],
"518333":[932,2141,0.05,"Gudikambali, Kurnool"],
"518343":[220,305,0.02,"Machapuram, Kurnool"],
"518344":[938,1859,0.03,"Erigeri, Kurnool"],
"518345":[620,1528,0.09,"Ibharampuram, Kurnool"],
"518346":[550,1845,0.06,"Chinnahyti, Kurnool"],
"518347":[471,1010,0.35,"Atikalagundu, Kurnool"],
"518348":[550,1827,1.14,"Medehal, Kurnool"],
"518349":[560,1506,0.14,"Madhavaram (kurnool), Kurnool"],
"518350":[278,768,0.06,"B.Agraharam, Kurnool"],
"518360":[220,288,0.01,"Venkatagiri, Kurnool"],
"518380":[307,493,0.24,"Chakkaralla, Kurnool"],
"518385":[705,1381,0.1,"M.Agraharam, Kurnool"],
"518390":[446,979,0.12,"Madananthapuram, Kurnool"],
"518395":[525,2472,3.36,"Ellarthi, Kurnool"],
"518396":[1320,2242,3.84,"Beldona, Kurnool"],
"518401":[486,1132,0.02,"Malyala, Nandyal"],
"518405":[466,899,0.11,"Cherukucherla, Nandyal"],
"518411":[560,1495,0.13,"Nehru Nagar, Nandyal"],
"518412":[422,676,0.01,"Biravolu, Nandyal"],
"518422":[300,827,0.18,"Dudyala, Nandyal"],
"518432":[620,1082,0.06,"Bollavaram, Nandyal"],
"518442":[370,721,0.02,"Chelimilla, Nandyal"],
"518452":[509,1332,0.06,"Diguvapadu, Kurnool"],
"518462":[467,1004,0.03,"Mudumala, Kurnool"],
"518463":[272,700,0.06,"Iranbanda, Kurnool"],
"518464":[277,1199,0.07,"Krishna Puram, Kurnool"],
"518465":[266,1351,0.18,"Karivemula, Kurnool"],
"518466":[841,1398,0.03,"Remata, Kurnool"],
"518467":[643,1241,0.04,"K.Markapuram, Kurnool"],
"518468":[412,845,0.14,"Bondimadugula, Kurnool"],
"518501":[376,882,0.11,"Nandyal, Nandyal"],
"518502":[372,868,0.11,"Billalapuram, Nandyal"],
"518508":[435,956,0.31,"Bilakalaguduru, Nandyal"],
"518510":[445,1133,0.13,"Venkatapuram, Nandyal"],
"518511":[445,1133,0.13,"Koratamaddi, Nandyal"],
"518512":[331,672,0.13,"Bollavaram, Nandyal"],
"518513":[453,831,0.16,"Singavaram, Nandyal"],
"518523":[308,950,0.2,"A.Kodur, Nandyal"],
"518533":[470,-1,0.04,"Boyarevula, Nandyal"],
"518543":[445,1133,0.13,"Chintakommudinne, Nandyal"],
"518553":[602,842,0.58,"Muthyalapadu, Nandyal"],
"518563":[551,1576,0.08,"Deebaguntla, Nandyal"],
"518573":[576,1644,0.16,"Balavegammanagar, Nandyal"],
"518583":[366,779,0.07,"Gundampadu, Nandyal"],
"518593":[548,1442,0.08,"Maddur, Nandyal"],
"518594":[407,879,0.03,"Peddakambalur, Nandyal"],
"518598":[433,588,0.13,"H.Kottala, Nandyal"],
"518599":[750,2031,0.12,"Yembai, Nandyal"],
"518674":[613,1766,0.19,"Pasurapadu, Nandyal"],
"520001":[380,1237,0.04,"Vijayawada GPO, Ntr"],
"520002":[380,1120,0.04,"Buckinghampet, Ntr"],
"520003":[380,1177,0.05,"Ramakrishnapuram, Ntr"],
"520004":[380,1127,0.06,"Machavaram S.O (Krishna), Ntr"],
"520007":[380,1138,0.06,"Yanamalakuduru, Ntr"],
"520008":[412,1215,0.07,"APUHS, Ntr"],
"520010":[412,1064,0.03,"Punnamathota, Ntr"],
"520011":[380,1122,0.04,"Lakshminagar, Ntr"],
"520012":[380,1296,0.05,"Ambapuram, Ntr"],
"520013":[380,1131,0.03,"RAMALINGESWAR NAGAR, Ntr"],
"520015":[412,859,0.12,"Wambay Colony, Ntr"],
"521001":[938,2713,0.15,"Machilipatnam, Krishna"],
"521002":[938,2773,0.16,"Pedapatnam, Krishna"],
"521003":[756,2531,0.15,"Gundupalem, Krishna"],
"521004":[568,1703,0.06,"Polatitippa, Krishna"],
"521101":[539,1682,0.06,"Azzampudi, Krishna"],
"521102":[415,1613,0.08,"Kesarapalli, Krishna"],
"521104":[530,1364,0.06,"Gudavalli, Ntr"],
"521105":[527,1172,0.02,"Bapulapadu, Krishna"],
"521106":[677,1632,0.04,"Aripirala, Krishna"],
"521107":[530,1636,0.07,"Savaragudem, Krishna"],
"521108":[445,1262,0.07,"Enikepadu, Ntr"],
"521109":[580,1473,0.06,"Bandarugudem, Krishna"],
"521110":[575,1641,0.02,"Kodurupadu, Krishna"],
"521111":[530,1293,0.05,"Tukkuluru, Eluru"],
"521120":[534,979,0.02,"Etimogga, Krishna"],
"521121":[534,1454,0.02,"Avanigadda, Krishna"],
"521122":[528,1321,0.04,"Puligadda, Krishna"],
"521125":[490,1079,0.0,"Nagayatippa, Krishna"],
"521126":[410,917,0.02,"Vakkalagadda, Krishna"],
"521130":[528,1225,0.06,"Kummaripalem, Krishna"],
"521131":[410,1308,0.03,"Endakuduru, Krishna"],
"521132":[358,847,0.02,"Tadepalli, Krishna"],
"521133":[405,1046,0.04,"V.Rudravaram, Krishna"],
"521134":[450,948,0.04,"Pedapulipaka, Krishna"],
"521135":[370,791,0.01,"Gudapadu, Krishna"],
"521136":[345,1048,0.03,"Barlapudi, Krishna"],
"521137":[488,1263,0.05,"Poranki, Krishna"],
"521138":[345,1125,0.04,"Bhatlapenumarru, Krishna"],
"521139":[415,1370,0.05,"Chodavaram, Krishna"],
"521148":[298,941,0.02,"Edulamaddali, Krishna"],
"521149":[640,2588,0.12,"Akumarru, Krishna"],
"521150":[410,1371,0.05,"Chitturu, Krishna"],
"521151":[305,1244,0.02,"Boddapadu, Krishna"],
"521153":[305,1146,0.04,"Kolavennu, Krishna"],
"521156":[560,1786,0.09,"P.G.Lanka, Krishna"],
"521157":[328,1342,0.03,"Daggumilli(Z), Krishna"],
"521158":[370,1068,0.09,"Nimmaluru, Krishna"],
"521162":[410,1459,0.05,"Ramannapet, Krishna"],
"521163":[290,982,0.04,"Devarapalli, Krishna"],
"521164":[298,838,0.02,"Kadavakollu, Krishna"],
"521165":[305,1011,0.03,"Penamakuru, Krishna"],
"521170":[412,1480,0.04,"Damulur, Ntr"],
"521175":[344,610,0.19,"Budavada, Ntr"],
"521178":[315,685,0.22,"Bhimavaram, Ntr"],
"521180":[435,2412,0.03,"Gani Atkuru, Ntr"],
"521181":[592,2057,0.0,"Chennaraopalem, Ntr"],
"521182":[412,1215,0.07,"Konayapalem, Ntr"],
"521183":[390,1643,0.05,"Turlapadu, Ntr"],
"521184":[424,1390,0.06,"Konduru, Ntr"],
"521185":[424,1307,0.08,"Cheruvukommupalem, Ntr"],
"521190":[408,788,0.49,"Anigandlapadu, Ntr"],
"521201":[485,1178,0.1,"Dum Dum Gardens, Eluru"],
"521202":[500,1133,0.07,"Boruvancha, Eluru"],
"521207":[365,1036,0.01,"Katrenipadu, Eluru"],
"521211":[483,1490,0.06,"Kotha Edara, Eluru"],
"521212":[412,1538,0.08,"Adavinekkalam, Eluru"],
"521213":[560,1281,0.04,"Somavaram, Eluru"],
"521214":[560,1708,0.04,"Korlamanda, Ntr"],
"521215":[505,1444,0.04,"Annaraopet, Ntr"],
"521224":[380,1449,0.03,"NDC VIJAYAWADA, Krishna"],
"521225":[380,1428,0.04,"Gollapudi, Ntr"],
"521226":[425,1223,0.02,"Krishnaraopalem, Ntr"],
"521227":[440,1181,0.04,"Vallampatla, Ntr"],
"521228":[343,1487,0.04,"Pinapaka, Ntr"],
"521229":[305,1205,0.04,"Duggiralapadu, Ntr"],
"521230":[431,1069,0.06,"Morusumilli, Ntr"],
"521231":[375,1228,0.03,"JNNURM Colony, Ntr"],
"521235":[425,1280,0.2,"Kokilampadu, Krishna"],
"521241":[396,1409,0.03,"Rayanapadu, Krishna"],
"521245":[305,877,0.03,"Nepalli, Krishna"],
"521246":[560,1688,0.08,"Hanumanthapuram, Krishna"],
"521247":[345,961,0.02,"Iluru, Krishna"],
"521250":[345,1062,0.03,"ALINAKHIPALEM, Krishna"],
"521256":[290,881,0.04,"Kanumuru, Krishna"],
"521260":[305,1349,0.04,"Komatigunta Lock, Krishna"],
"521261":[290,798,0.01,"Appikatla, Krishna"],
"521263":[305,1048,0.02,"Pedaparupudi, Krishna"],
"521286":[659,1945,0.06,"Atkur, Eluru"],
"521301":[418,1221,0.02,"Gudivada, Krishna"],
"521311":[298,932,0.03,"Vemanda, Eluru"],
"521312":[305,1570,0.04,"Amudalapalli, Eluru"],
"521320":[635,1381,0.06,"Komallapudi, Krishna"],
"521321":[636,1733,0.02,"Tummalapalli, Krishna"],
"521322":[328,1014,0.03,"Komaravolu, Krishna"],
"521323":[540,1638,0.03,"Chowtapalli, Krishna"],
"521324":[768,1612,0.05,"Jayapuram, Krishna"],
"521325":[619,1508,0.05,"Pedakamanapudi, Eluru"],
"521326":[760,2212,0.03,"Unikili, Eluru"],
"521327":[698,1894,0.04,"Anamanapudi, Krishna"],
"521328":[528,981,0.09,"Jayapuram, Krishna"],
"521329":[666,1656,0.08,"Pedatummidi, Krishna"],
"521330":[540,1409,0.07,"Serikalavapudi, Krishna"],
"521331":[615,1883,0.1,"Kongamcherla, Krishna"],
"521332":[575,1987,0.11,"Jakkamcherla, Krishna"],
"521333":[800,2607,0.04,"Konduru, Eluru"],
"521340":[710,2846,0.15,"Seetanapalli, Eluru"],
"521343":[710,2133,0.06,"Tamarakollu, Eluru"],
"521344":[705,1901,0.1,"Kondangi, Eluru"],
"521345":[720,2192,0.03,"Ayyavarirudravaram, Eluru"],
"521356":[560,1487,0.07,"Mamidikolla, Krishna"],
"521366":[575,3024,0.25,"Lellagaruvu, Krishna"],
"521369":[901,1815,0.11,"Satulru, Krishna"],
"521390":[316,1184,0.03,"Addada, Krishna"],
"521401":[452,1224,0.32,"Tunikipadu, Ntr"],
"521402":[510,949,0.31,"Kakaravai, Ntr"],
"521403":[425,1446,0.19,"Gosavedu, Ntr"],
"521456":[595,2131,0.02,"Chilukuru, Ntr"],
"521457":[315,596,0.17,"Vedadri, Ntr"],
"522001":[530,1367,0.06,"Old Guntur, Guntur"],
"522002":[375,1317,0.03,"Guntur, Guntur"],
"522003":[415,1247,0.05,"Factories Ward, Guntur"],
"522004":[488,1141,0.06,"Guntur Collectorate, Guntur"],
"522005":[551,1375,0.03,"Vengalayapalem, Guntur"],
"522006":[360,1296,0.03,"S.V.N.Colony(Guntur), Guntur"],
"522007":[360,1319,0.03,"Amaravathi Road(Guntur), Guntur"],
"522008":[360,1284,0.03,"NDC Guntur, Guntur"],
"522009":[360,1291,0.04,"Pedapalakaluru, Guntur"],
"522015":[705,2125,0.02,"Gogulamudi, Guntur"],
"522016":[385,1724,0.08,"Nevalikallu, Palnadu"],
"522017":[378,1432,0.03,"Chintapallipadu, Guntur"],
"522018":[390,1290,0.06,"Gorlavaripalem, Guntur"],
"522019":[415,2087,0.03,"Enamadala, Guntur"],
"522020":[380,2125,0.03,"Didugu, Palnadu"],
"522034":[360,1474,0.04,"Gorantla, Guntur"],
"522101":[400,875,0.1,"Bapatla, Bapatla"],
"522111":[458,1173,0.05,"Ganapavaram, Bapatla"],
"522112":[383,1099,0.07,"Ballukanudivari Palem, Guntur"],
"522113":[616,1154,0.19,"Mulapalem, Bapatla"],
"522124":[455,847,0.03,"Aluru, Guntur"],
"522201":[342,760,0.02,"Tenali, Guntur"],
"522202":[342,761,0.02,"Nelapadu, Guntur"],
"522211":[330,799,0.02,"Valiveru, Bapatla"],
"522212":[469,1011,0.03,"Vellaluru, Guntur"],
"522213":[340,864,0.03,"Selapadu, Guntur"],
"522233":[470,1380,0.02,"Jaggapuram, Palnadu"],
"522234":[470,1226,0.02,"Chirumamilla, Palnadu"],
"522235":[685,1761,0.21,"Nagualapadu, Guntur"],
"522236":[380,1727,0.05,"Nekkallu, Guntur"],
"522237":[488,1738,0.02,"Abbarajupalem, Guntur"],
"522238":[445,1733,0.01,"A.P.Secretariat, Guntur"],
"522239":[345,777,0.01,"A.P.High Court, Guntur"],
"522240":[418,1404,0.02,"Kuragallu, Guntur"],
"522241":[418,1671,0.04,"VIT-AP UNIVERSITY, Guntur"],
"522256":[345,711,0.07,"Surepalli, Bapatla"],
"522257":[375,714,0.05,"Amudarlanka, Bapatla"],
"522258":[345,763,0.08,"Venigallavaripalem, Bapatla"],
"522259":[368,1620,0.07,"Peddavaram, Bapatla"],
"522261":[345,599,0.03,"Butumalli, Bapatla"],
"522262":[400,797,0.07,"Kallipalem, Bapatla"],
"522264":[528,1117,0.04,"Singupalem, Bapatla"],
"522265":[470,1143,0.11,"Bethapudi, Bapatla"],
"522268":[290,600,0.96,"Karankivaripalem, Bapatla"],
"522301":[900,2102,0.19,"Annavarapulanka, Guntur"],
"522302":[455,1065,0.04,"Revendrapadu, Guntur"],
"522303":[450,941,0.04,"Mellempudi, Guntur"],
"522304":[345,1050,0.02,"Munnangi, Guntur"],
"522305":[450,992,0.03,"Pedakonduru, Guntur"],
"522306":[345,786,0.03,"Kunchavaram, Guntur"],
"522307":[340,565,0.02,"Kazipeta, Guntur"],
"522308":[350,866,0.03,"Vallabhapuram, Guntur"],
"522309":[400,895,0.08,"Vinayasramam, Bapatla"],
"522310":[600,969,0.06,"Gopapuram, Bapatla"],
"522311":[519,993,0.06,"Sangupalem, Bapatla"],
"522312":[382,790,0.06,"Moparru, Bapatla"],
"522313":[350,732,0.02,"Yadavuru, Bapatla"],
"522314":[382,1368,0.04,"Pedamatlapudi, Bapatla"],
"522315":[528,928,0.06,"Mulukuduru, Guntur"],
"522316":[455,957,0.01,"Mannava, Guntur"],
"522317":[320,835,0.33,"Kankatapalem, Bapatla"],
"522318":[340,877,0.04,"Mamillapalli, Guntur"],
"522324":[345,631,0.01,"Boddulurupadu, Bapatla"],
"522325":[350,748,0.06,"Govada, Bapatla"],
"522329":[456,991,0.06,"Manthenavaripalem, Bapatla"],
"522330":[365,716,0.03,"Chiluvuru, Guntur"],
"522341":[400,921,0.05,"Kondamudi, Guntur"],
"522401":[640,1199,0.06,"Mandapadu, Guntur"],
"522402":[698,1442,0.03,"Kattamuru, Palnadu"],
"522403":[819,1090,0.04,"Sattenapalle, Palnadu"],
"522408":[372,938,0.02,"Lankalakurapadu, Palnadu"],
"522409":[645,1516,0.05,"Challagariga, Palnadu"],
"522410":[639,1949,0.06,"Gudipadu, Palnadu"],
"522411":[486,1676,0.02,"Machayapalem, Palnadu"],
"522412":[819,1561,0.03,"Ganapavaram, Palnadu"],
"522413":[462,877,0.01,"Konanki, Palnadu"],
"522414":[155,807,0.03,"Gamalapadu, Palnadu"],
"522415":[378,745,0.0,"Miriyala, Palnadu"],
"522421":[355,622,0.1,"Rentala, Palnadu"],
"522426":[318,624,0.07,"Gannavaram, Palnadu"],
"522435":[421,1071,0.03,"Velampalle, Palnadu"],
"522436":[368,1594,0.06,"RAMAPURAM, Palnadu"],
"522437":[405,816,0.01,"Chinaagraharam, Palnadu"],
"522438":[375,1297,0.03,"Korrapadu, Guntur"],
"522439":[436,953,0.05,"Thimmareddipuram, Palnadu"],
"522501":[412,1162,0.04,"Kunchanapalle, Guntur"],
"522502":[413,1125,0.04,"Yerrabalem, Guntur"],
"522503":[530,912,0.03,"Mangalagiri, Guntur"],
"522508":[390,1221,0.03,"Koppuravuru, Guntur"],
"522509":[380,1255,0.03,"Uppalapadu, Guntur"],
"522510":[418,1179,0.03,"Nagarjuna Nagar, Guntur"],
"522529":[744,1212,0.02,"Nudurupadu, Guntur"],
"522549":[392,1149,0.02,"Bethapudi, Guntur"],
"522601":[372,965,0.01,"Narasaraopet, Palnadu"],
"522603":[392,1090,0.02,"Rupenagunta, Palnadu"],
"522611":[458,1450,0.02,"Kattubadivaripalem, Palnadu"],
"522612":[384,-1,0.0,"Obulesunipalle, Palnadu"],
"522613":[533,1651,0.02,"Kandlagunta, Palnadu"],
"522614":[160,719,0.0,"Chintapalle, Palnadu"],
"522615":[575,1333,0.02,"Machavaram, Palnadu"],
"522616":[665,1541,0.02,"Annavaram, Guntur"],
"522617":[450,1482,0.03,"Gogulapadu, Palnadu"],
"522619":[665,1635,0.11,"Sandepudi, Palnadu"],
"522626":[568,1829,0.02,"Boppudi, Palnadu"],
"522646":[460,867,0.02,"Karumanchi, Palnadu"],
"522647":[475,1110,0.01,"Andugula Kothapalem, Palnadu"],
"522649":[469,-1,0.0,"Pitchikalapalem, Palnadu"],
"522657":[480,1102,0.02,"Gutlapalle, Palnadu"],
"522658":[470,998,0.02,"Angaluru, Palnadu"],
"522659":[458,1732,0.04,"Cheruvukommupalem, Palnadu"],
"522660":[469,1014,0.03,"Mupparajuvaripalem, Palnadu"],
"522661":[460,1433,0.02,"Inumella, Palnadu"],
"522663":[472,832,0.02,"Remidicherla, Palnadu"],
"523001":[233,714,1.01,"Ongole, Prakasam"],
"523002":[233,752,1.64,"Kurnool Road (O), Prakasam"],
"523003":[233,720,1.11,"NDC ONGOLE, Prakasam"],
"523101":[1035,2722,0.98,"Kanumalla, Prakasam"],
"523104":[952,2552,0.51,"Binginapalli, Prakasam"],
"523105":[768,2108,1.13,"Kandukur, Prakasam"],
"523108":[390,940,0.53,"Narramarella, Prakasam"],
"523109":[380,1459,1.11,"Cherukur, Prakasam"],
"523110":[610,970,0.3,"Mopadu, Prakasam"],
"523111":[210,668,0.45,"Venkateswarapuram, Prakasam"],
"523112":[390,940,0.53,"Musunurukothapalli, Prakasam"],
"523113":[610,1630,1.12,"Machavaram, Prakasam"],
"523114":[447,1171,0.37,"Bodawada, Prakasam"],
"523115":[371,1090,0.32,"Mutyalapadu, Prakasam"],
"523116":[473,1028,0.63,"Ayyavaripalli, Prakasam"],
"523117":[388,845,0.83,"Pedairlapadu, Prakasam"],
"523135":[580,1349,0.92,"Rajubangarupalem, Bapatla"],
"523155":[400,966,0.53,"Chirala, Bapatla"],
"523157":[400,915,0.37,"Burlavaripalem, Bapatla"],
"523165":[400,999,0.7,"Gandhinagar, Bapatla"],
"523166":[360,932,0.34,"Thotavaripalem, Bapatla"],
"523167":[345,1162,0.46,"Gangavaram, Bapatla"],
"523168":[530,1531,0.45,"Kunkalamarru, Bapatla"],
"523169":[350,2331,0.62,"Munnagivaripalem, Bapatla"],
"523170":[400,1638,0.46,"Timidithapadu, Bapatla"],
"523171":[464,1941,0.34,"Edubadu, Bapatla"],
"523180":[278,1261,0.62,"Chavatapalem, Prakasam"],
"523181":[444,1409,0.87,"Chinagumpalle, Bapatla"],
"523182":[245,958,0.8,"Ulichi, Prakasam"],
"523183":[308,1248,0.85,"Hanumapuram, Prakasam"],
"523184":[400,1273,0.8,"Motupalli, Bapatla"],
"523185":[375,1306,0.63,"Timmasamudram, Prakasam"],
"523186":[308,1147,0.89,"Pedaganjam, Bapatla"],
"523187":[350,1175,0.81,"Desaipet, Bapatla"],
"523190":[705,2042,0.29,"Vankayalapadu, Bapatla"],
"523201":[356,650,0.1,"Kotikalapudi, Bapatla"],
"523211":[233,875,0.97,"Basavannapalem, Prakasam"],
"523212":[363,1025,0.54,"Yerrapalem, Bapatla"],
"523213":[334,927,0.44,"Kopperapadu, Bapatla"],
"523214":[324,921,0.43,"Arikatlavaripalem, Bapatla"],
"523223":[535,1299,1.38,"Pedagogulapalli, Prakasam"],
"523224":[390,940,0.53,"Rallapalli, Prakasam"],
"523225":[261,727,0.89,"B.Machavaram, Prakasam"],
"523226":[340,706,0.49,"Kunamnenivaripalem, Prakasam"],
"523227":[715,1746,2.45,"Pedadasullapalli, Prakasam"],
"523228":[488,1182,1.3,"Narayapalli, Prakasam"],
"523230":[667,1653,2.35,"Cheerladinne, Prakasam"],
"523240":[330,731,0.56,"Podili, Prakasam"],
"523241":[659,1444,0.17,"Kaluzuvvalapadu, Prakasam"],
"523245":[389,972,1.09,"Challagirigala, Prakasam"],
"523246":[715,1746,2.45,"Perareddipalli, Prakasam"],
"523247":[270,970,0.09,"Devavaram, Prakasam"],
"523252":[210,923,0.1,"Bellamkondavaripalem, Prakasam"],
"523253":[347,698,0.67,"Nippatlapadu, Prakasam"],
"523254":[210,1358,1.97,"Bommireddipalli, Prakasam"],
"523260":[482,1248,0.11,"Pedjangalapalli, Bapatla"],
"523261":[340,712,0.16,"Kolalapudi, Bapatla"],
"523262":[233,810,0.92,"Lingamgunta, Prakasam"],
"523263":[305,864,0.69,"Pallamalli, Prakasam"],
"523264":[306,802,0.32,"Modepalli, Bapatla"],
"523265":[325,887,0.31,"Pasupugallu, Prakasam"],
"523270":[388,883,0.75,"Petlur, Prakasam"],
"523271":[360,1238,1.13,"Chirrikurapadu, Prakasam"],
"523272":[261,1111,0.99,"Kandulur, Prakasam"],
"523273":[458,1233,0.9,"Ponduru, Prakasam"],
"523274":[790,2342,0.72,"Jayavaram, Prakasam"],
"523279":[694,2019,1.02,"Paletipadu, Prakasam"],
"523280":[612,1712,0.64,"Madanur, Prakasam"],
"523281":[665,1849,0.88,"Puretipalli, Prakasam"],
"523286":[245,1041,0.72,"Alluru, Prakasam"],
"523291":[661,1892,0.7,"Tettu, Prakasam"],
"523292":[1078,2701,0.76,"Bhimavaram, Prakasam"],
"523301":[900,2275,0.03,"Degaramudi, Bapatla"],
"523302":[372,1559,0.03,"Tangedumalli, Bapatla"],
"523303":[365,991,0.06,"Elchuru, Bapatla"],
"523304":[465,1576,0.11,"West Veerayapalem, Prakasam"],
"523305":[701,1688,0.18,"Nallabothulavaripalem, Prakasam"],
"523315":[807,1506,0.2,"Kocherlakota, Prakasam"],
"523316":[1020,2021,0.25,"Markapur, Prakasam"],
"523320":[1020,2021,0.25,"B.Cherlopalle, Prakasam"],
"523326":[465,1607,0.06,"Annasamudram, Prakasam"],
"523327":[378,634,0.05,"Gollavidipi, Prakasam"],
"523328":[488,1669,0.05,"R.Ummadivaram, Prakasam"],
"523329":[260,614,0.15,"Kondepalle, Prakasam"],
"523330":[583,1510,0.12,"Vadampalli, Prakasam"],
"523331":[400,843,0.1,"Chintala, Prakasam"],
"523332":[260,614,0.15,"Bondalapadu, Prakasam"],
"523333":[420,904,0.1,"Chinnacumbum, Prakasam"],
"523334":[384,838,0.11,"Nekunambad, Prakasam"],
"523335":[496,1041,0.08,"Atchampeta, Prakasam"],
"523336":[462,979,0.09,"Mittameedipalle, Prakasam"],
"523346":[432,925,0.1,"Basinepalle, Prakasam"],
"523356":[502,1051,0.08,"Satyavolu, Prakasam"],
"523357":[670,1356,0.02,"Narava, Prakasam"],
"523367":[421,814,0.06,"Obulapuram, Prakasam"],
"523368":[541,1123,0.06,"Kalavapalle, Prakasam"],
"523369":[670,1356,0.02,"Narashimapalle, Prakasam"],
"523370":[348,773,0.12,"Lanjakota, Prakasam"],
"523371":[260,614,0.15,"Kethagudipi, Prakasam"],
"523372":[615,1257,0.04,"Peddanallakalva, Prakasam"],
"523373":[380,830,0.17,"Pamurupalle, Prakasam"],
"524001":[390,1009,0.06,"Nellore, Spsr Nellore"],
"524002":[390,1053,0.14,"Kodur, Spsr Nellore"],
"524003":[386,1023,0.08,"Gundlapalem, Spsr Nellore"],
"524004":[371,1130,0.08,"Pottepalem, Spsr Nellore"],
"524005":[390,861,0.06,"Polytechnic S.O (Nellore), Spsr Nellore"],
"524101":[255,1196,0.18,"Gudur, Tirupati"],
"524121":[409,1944,0.37,"Damanellore, Tirupati"],
"524123":[660,1553,0.37,"Anepudi, Tirupati"],
"524124":[258,1648,0.18,"Pernadu, Tirupati"],
"524126":[255,1580,0.18,"Nelaballi, Spsr Nellore"],
"524127":[443,1126,0.08,"Eswrawaka, Tirupati"],
"524129":[358,785,0.31,"Jeelapatur, Tirupati"],
"524131":[255,1472,-1,"Alimili, Spsr Nellore"],
"524132":[320,612,0.04,"Chilakampadu, Tirupati"],
"524134":[740,-1,0.07,"Mopur, Tirupati"],
"524137":[390,853,0.04,"Pothireddypalem, Spsr Nellore"],
"524142":[273,761,0.19,"Akkarajuvari Kandriga, Spsr Nellore"],
"524152":[428,1338,0.15,"Venkatesupalem, Spsr Nellore"],
"524201":[241,709,0.28,"Kavali, Spsr Nellore"],
"524203":[241,703,0.29,"Lingamgunta B.O-An, Spsr Nellore"],
"524221":[257,853,0.21,"Kothapeta, Spsr Nellore"],
"524222":[143,713,0.35,"Rachavaripalli, Spsr Nellore"],
"524223":[241,768,0.26,"Annavaram, Spsr Nellore"],
"524224":[185,653,0.0,"Polampadu, Spsr Nellore"],
"524225":[182,710,0.08,"Turupur, Spsr Nellore"],
"524226":[150,582,0.36,"Balayapalli, Spsr Nellore"],
"524227":[105,570,0.43,"Chinna Kaniyampadu, Spsr Nellore"],
"524228":[185,696,0.0,"Dubagunta B.O-V, Spsr Nellore"],
"524230":[409,560,0.15,"Chinnamachanur, Spsr Nellore"],
"524234":[185,906,0.17,"Kavali Yadavalli, Spsr Nellore"],
"524236":[247,754,0.48,"Gudinarava, Spsr Nellore"],
"524239":[384,1149,0.11,"Dubagunta B.O-K, Spsr Nellore"],
"524240":[381,1185,0.11,"Chowtaputtedu, Spsr Nellore"],
"524300":[340,1438,0.23,"Padamatikhambampadu, Spsr Nellore"],
"524302":[420,1005,0.13,"Gowravaram B.O-A, Spsr Nellore"],
"524303":[240,1236,0.19,"Bandarupalli, Spsr Nellore"],
"524304":[241,1119,0.21,"Peddabbipuram, Spsr Nellore"],
"524305":[387,992,0.08,"Chellayapalem, Spsr Nellore"],
"524306":[406,1147,0.7,"Panchedu, Spsr Nellore"],
"524307":[203,1345,0.23,"Mahimalur, Spsr Nellore"],
"524308":[247,1147,0.28,"Hasanapuram, Spsr Nellore"],
"524309":[408,1195,1.57,"Bathulapalli, Spsr Nellore"],
"524310":[390,940,0.53,"Bodasi Idayapalli, Spsr Nellore"],
"524311":[358,1248,0.2,"Papireddypalem, Spsr Nellore"],
"524312":[368,749,0.16,"Tikkavaram, Spsr Nellore"],
"524313":[611,1160,0.49,"Gangapatnam, Spsr Nellore"],
"524314":[390,983,0.18,"Komarika, Spsr Nellore"],
"524315":[611,2298,0.19,"Batrakagallu, Spsr Nellore"],
"524316":[397,1340,0.04,"Damagunta, Spsr Nellore"],
"524317":[397,1127,0.02,"Turimerla, Spsr Nellore"],
"524318":[397,1400,0.21,"Alaganipadu, Spsr Nellore"],
"524319":[397,1188,0.02,"Peyyalapalem, Spsr Nellore"],
"524320":[435,793,0.12,"Dontali, Spsr Nellore"],
"524321":[342,756,0.15,"Idimepalli, Spsr Nellore"],
"524322":[240,1386,0.27,"Cherloyadavalli, Spsr Nellore"],
"524323":[435,793,0.12,"Tirumalammapalem, Spsr Nellore"],
"524324":[305,1000,0.12,"VIKRAMASIMHAPURI UNIVERSITY, Spsr Nellore"],
"524341":[284,967,0.37,"Perumallapadu, Spsr Nellore"],
"524342":[483,904,0.58,"Kollapanayunipalli, Spsr Nellore"],
"524343":[353,911,0.16,"Kanupurpalli, Spsr Nellore"],
"524344":[390,1309,0.19,"Krishnapatnam, Spsr Nellore"],
"524345":[408,1454,3.73,"Ammavaripalem, Spsr Nellore"],
"524346":[342,1191,0.17,"Pidathapoluru, Spsr Nellore"],
"524347":[358,1238,0.17,"Ananthapuram B.O-A, Spsr Nellore"],
"524366":[390,928,0.05,"Yellayapalem, Spsr Nellore"],
"524401":[408,1023,0.4,"Karur, Tirupati"],
"524402":[255,2349,0.19,"Armenipadu, Spsr Nellore"],
"524403":[280,795,0.06,"Chinnathota, Tirupati"],
"524404":[740,1154,0.63,"Kayyur, Tirupati"],
"524405":[229,1139,0.16,"Kommalapudi, Spsr Nellore"],
"524406":[255,1387,0.18,"Nindali, Tirupati"],
"524407":[431,1098,1.02,"Daggavolu, Spsr Nellore"],
"524408":[689,-1,0.02,"Gilakapadu, Spsr Nellore"],
"524409":[230,1308,0.18,"Devaravemuru, Spsr Nellore"],
"524410":[258,1093,0.19,"Ayyavaripalem, Tirupati"],
"524411":[118,363,0.1,"Kokkupadu, Tirupati"],
"524412":[230,1990,0.19,"Tikkavaram, Tirupati"],
"524413":[118,539,0.07,"Tinnelapudi, Tirupati"],
"524414":[581,752,0.7,"Penubarthi, Spsr Nellore"],
"524415":[118,539,0.07,"Kallur, Tirupati"],
"524421":[276,877,0.12,"Bheemavaram, Tirupati"],
"530001":[334,718,0.13,"Visakhapatnam, Visakhapatanam"],
"530002":[334,695,0.13,"D.C. Buildings, Visakhapatanam"],
"530003":[334,705,0.16,"Ghandhi Place, Visakhapatanam"],
"530004":[335,655,0.12,"Waltair R S, Visakhapatanam"],
"530005":[332,785,0.1,"Yarada, Visakhapatanam"],
"530007":[342,678,0.1,"Muralinagar, Visakhapatanam"],
"530008":[342,663,0.1,"Kancharapalem, Visakhapatanam"],
"530009":[334,619,0.1,"N A D, Visakhapatanam"],
"530011":[334,669,0.11,"Malkapuram, Visakhapatanam"],
"530012":[350,525,0.07,"Mindi, Visakhapatanam"],
"530013":[342,699,0.17,"P and T Colony (VM), Visakhapatanam"],
"530014":[334,722,0.14,"Naval Base, Visakhapatanam"],
"530015":[334,629,0.1,"Zinc Smelter P, Visakhapatanam"],
"530016":[342,685,0.14,"Dwarakanagar, Visakhapatanam"],
"530017":[332,748,0.17,"M.V.P.Colony, Visakhapatanam"],
"530018":[335,683,0.09,"Marripalem, Visakhapatanam"],
"530020":[335,683,0.13,"Dabagardens, Visakhapatanam"],
"530022":[334,716,0.2,"Isakathota, Visakhapatanam"],
"530024":[342,677,0.14,"Salagramapuram, Visakhapatanam"],
"530026":[350,559,0.08,"Gajuwaka, Visakhapatanam"],
"530027":[334,570,0.08,"Yellapuvanipalem, Visakhapatanam"],
"530028":[342,627,0.11,"Simhachalam Hills, Visakhapatanam"],
"530029":[334,516,0.07,"Durganagar, Visakhapatanam"],
"530031":[346,714,0.05,"Devada, Visakhapatanam"],
"530032":[340,510,0.02,"VM Steel Projrct Town Ship, Visakhapatanam"],
"530040":[342,678,0.15,"Pedagadili, Visakhapatanam"],
"530041":[326,718,0.14,"Pothinamallayapalem, Visakhapatanam"],
"530043":[335,734,0.16,"Visalakshinagar, Visakhapatanam"],
"530044":[342,609,0.05,"Nadupuru, Visakhapatanam"],
"530045":[334,794,0.14,"Yendada, Visakhapatanam"],
"530046":[350,572,0.04,"Vadlapudi, Visakhapatanam"],
"530047":[335,542,0.07,"Chintalaagaraharam, Visakhapatanam"],
"530048":[318,689,0.14,"Gayatri Engg College, Visakhapatanam"],
"530049":[342,552,0.03,"Pakeertekya, Visakhapatanam"],
"530051":[334,563,0.07,"Chinamushidiwada, Visakhapatanam"],
"530052":[341,558,0.09,"Palavalasa, Visakhapatanam"],
"530053":[340,595,0.03,"Aganampudi, Visakhapatanam"],
"530055":[342,551,0.03,"Duvvada, Visakhapatanam"],
"530056":[342,534,0.08,"Sheelanagar, Visakhapatanam"],
"530057":[342,703,0.22,"Arilova, Visakhapatanam"],
"530058":[334,705,0.15,"NDC Andhra University, Visakhapatanam"],
"530059":[309,615,0.12,"Sontyam, Visakhapatanam"],
"531001":[345,862,0.03,"Anakapalle, Anakapalli"],
"531002":[287,797,0.03,"Ammulapalem, Visakhapatanam"],
"531011":[414,1079,0.05,"Chodapalle, Anakapalli"],
"531019":[321,685,0.03,"Lankelapalem, Anakapalli"],
"531020":[359,879,0.03,"Nunaparthi, Visakhapatanam"],
"531021":[333,765,0.03,"Dopperla, Anakapalli"],
"531022":[180,288,0.09,"Anandapuram, Anakapalli"],
"531023":[345,875,0.03,"Rayapurajupeta, Anakapalli"],
"531024":[95,151,0.06,"Iradapalle, Alluri Sitharama Raju"],
"531025":[365,671,0.1,"Marupaka, Anakapalli"],
"531026":[345,798,0.15,"Dibbapalem, Anakapalli"],
"531027":[282,553,0.93,"Kinthalli, Anakapalli"],
"531028":[309,698,0.61,"Appalrajupuram, Anakapalli"],
"531029":[98,146,0.08,"Vanthala, Alluri Sitharama Raju"],
"531030":[60,147,0.14,"Kasipuram, Anakapalli"],
"531031":[404,935,0.05,"Theeda, Visakhapatanam"],
"531032":[358,927,0.03,"Uderoo, Anakapalli"],
"531033":[345,942,0.04,"Pallapu Anandapuram, Anakapalli"],
"531034":[180,493,0.09,"Medicherla, Anakapalli"],
"531035":[380,565,0.03,"Amruthpuram., Visakhapatanam"],
"531036":[345,872,0.12,"Jannavaram, Anakapalli"],
"531040":[48,66,0.26,"Aradakota, Visakhapatanam"],
"531055":[430,1005,0.06,"Enugutuni, Anakapalli"],
"531060":[529,1505,0.08,"Vakapadu, Anakapalli"],
"531061":[430,1150,0.06,"Govindapalem, Anakapalli"],
"531075":[180,444,0.1,"Vadrapalem, Anakapalli"],
"531077":[91,135,0.07,"Guda, Alluri Sitharama Raju"],
"531081":[649,1627,0.08,"D L Puram, Visakhapatanam"],
"531082":[430,1404,0.07,"Bhimavaram, Visakhapatanam"],
"531083":[529,1887,0.05,"Koruprolu, Anakapalli"],
"531084":[332,568,0.03,"Bangarampeta, Visakhapatanam"],
"531085":[315,858,0.25,"Lingapuram, Visakhapatanam"],
"531087":[335,345,0.02,"Chintalapudi, Visakhapatanam"],
"531105":[98,140,0.08,"Duppulavada, Alluri Sitharama Raju"],
"531111":[62,108,0.09,"Bennavaram, Alluri Sitharama Raju"],
"531113":[320,888,0.23,"Burugupalem, Anakapalli"],
"531114":[265,843,0.07,"Komaruvolu, Anakapalli"],
"531115":[360,616,0.02,"Dharagangavaram, Visakhapatanam"],
"531116":[322,586,0.03,"Narsipatnam, Anakapalli"],
"531117":[315,716,0.31,"Amalapuram, Visakhapatanam"],
"531118":[290,692,0.13,"Dharnasagaram, Visakhapatanam"],
"531126":[430,1212,0.02,"Gullipadu, Anakapalli"],
"531127":[430,1143,-1,"Kumarapuram, Visakhapatanam"],
"531133":[50,110,0.1,"R V NAGAR, Alluri Sitharama Raju"],
"531149":[105,178,0.06,"Bondam, Visakhapatanam"],
"531151":[122,213,0.08,"Korra, Visakhapatanam"],
"531162":[290,639,0.15,"Gudivada, Vizianagaram"],
"531163":[326,729,0.14,"INS Kalinga, Visakhapatanam"],
"531173":[344,549,0.07,"Gurrampalem, Visakhapatanam"],
"531219":[252,650,0.15,"Ananthavaram, Visakhapatanam"],
"532001":[301,642,0.02,"Srikakulam, Srikakulam"],
"532005":[295,653,0.02,"Thotapalem, Srikakulam"],
"532122":[442,725,0.03,"Madduvalasa, Srikakulam"],
"532123":[367,695,0.08,"Ambakhandi, Srikakulam"],
"532127":[419,659,0.08,"Agurukancharam, Srikakulam"],
"532148":[370,729,0.02,"Boddam, Srikakulam"],
"532167":[252,694,0.05,"Gokarnapalli, Srikakulam"],
"532168":[252,694,0.05,"Palakhandyam, Srikakulam"],
"532184":[351,438,0.0,"Amadalavalasa, Srikakulam"],
"532185":[351,438,0.0,"Amadalavalasa, Srikakulam"],
"532186":[301,641,0.02,"Kalaparthi, Srikakulam"],
"532187":[301,641,0.02,"Kasimivalasa, Srikakulam"],
"532190":[251,747,0.32,"Alamajipeta, Srikakulam"],
"532195":[346,668,0.25,"Kistupuram, Srikakulam"],
"532201":[400,785,0.47,"Tekkali, Srikakulam"],
"532203":[400,786,0.49,"Kommusariapalli, Srikakulam"],
"532204":[400,786,0.49,"Nowgam, Srikakulam"],
"532207":[400,786,0.49,"VENUGOPALAPURAM, Srikakulam"],
"532211":[428,713,0.19,"Mulapeta, Srikakulam"],
"532212":[400,974,0.16,"Buragam, Srikakulam"],
"532213":[207,373,0.2,"Peddamallipuram, Srikakulam"],
"532214":[456,1007,0.04,"Kallata, Srikakulam"],
"532215":[235,442,0.22,"Pedapadmapuram, Srikakulam"],
"532216":[238,437,0.17,"Pedalaxmipuram, Srikakulam"],
"532218":[265,632,0.09,"Reyyipadu, Srikakulam"],
"532219":[225,524,0.03,"Metturu, Srikakulam"],
"532220":[260,430,0.14,"Bendi, Srikakulam"],
"532221":[260,498,0.11,"Kedaripuram, Srikakulam"],
"532222":[301,645,0.02,"Boddapadu, Srikakulam"],
"532242":[268,775,0.08,"Cheepi, Srikakulam"],
"532243":[330,894,0.12,"Rangoi, Srikakulam"],
"532263":[330,998,0.24,"Nadumuru, Srikakulam"],
"532264":[330,799,0.19,"Chowkipeta, Srikakulam"],
"532284":[330,965,0.4,"Jalantrakota, Srikakulam"],
"532290":[225,388,0.23,"Makarampuram, Srikakulam"],
"532291":[246,605,0.34,"Dolagovindapuram, Srikakulam"],
"532292":[268,933,0.39,"Borivanka, Srikakulam"],
"532312":[244,601,0.23,"Arakabhadra, Srikakulam"],
"532322":[331,725,0.31,"Rajapuram, Srikakulam"],
"532401":[301,632,0.02,"Mofusbandar, Srikakulam"],
"532402":[301,727,0.03,"Dallavalasa, Srikakulam"],
"532403":[298,792,0.06,"Kesavadasupuram, Srikakulam"],
"532404":[351,625,0.04,"Chinavatsavalasa, Srikakulam"],
"532405":[402,822,0.06,"Bhairi, Srikakulam"],
"532406":[402,1101,0.07,"Bandaruvanipeta, Srikakulam"],
"532407":[210,570,0.09,"Patharlapalli, Srikakulam"],
"532408":[308,753,0.03,"D. Matchilesam, Srikakulam"],
"532409":[298,385,0.06,"Devunipalavalasa, Srikakulam"],
"532410":[302,842,0.04,"Fareedpeta, Srikakulam"],
"532421":[272,676,0.19,"Kambakaya, Srikakulam"],
"532425":[268,547,0.23,"Lukulam, Srikakulam"],
"532426":[266,1178,0.17,"Burujuvada, Srikakulam"],
"532427":[330,1000,0.26,"Kommanapalli, Srikakulam"],
"532428":[388,1100,0.04,"Karakavalasa, Srikakulam"],
"532429":[395,868,0.13,"Challayyavalasa, Srikakulam"],
"532430":[301,645,0.02,"Nimmada, Srikakulam"],
"532432":[330,689,0.32,"Karavanja, Srikakulam"],
"532440":[525,933,0.22,"Aradali, Parvathipuram Manyam"],
"532443":[305,593,0.68,"Gondi, Parvathipuram Manyam"],
"532445":[441,801,0.1,"Guttavilli, Srikakulam"],
"532455":[223,461,1.1,"Baleru, Parvathipuram Manyam"],
"532456":[204,366,0.6,"Bhamini, Parvathipuram Manyam"],
"532457":[217,467,0.84,"Kurigam, Srikakulam"],
"532458":[301,645,0.02,"Dabbapadu, Srikakulam"],
"532459":[354,969,0.3,"Neradi, Srikakulam"],
"532460":[370,832,0.07,"Kambara, Parvathipuram Manyam"],
"532461":[364,724,0.04,"Talagam, Srikakulam"],
"532462":[411,821,0.1,"Navagam, Parvathipuram Manyam"],
"532474":[250,611,0.3,"Rana, Srikakulam"],
"532484":[295,667,0.02,"Belamam, Srikakulam"],
"533001":[325,868,0.04,"Kakinada, Kakinada"],
"533002":[325,702,0.03,"Jagannaickpur, Kakinada"],
"533003":[325,893,0.05,"Sriramnagar S.O (Kakinada), East Godavari"],
"533004":[325,933,0.06,"Gandhinagar(KKD), Kakinada"],
"533005":[325,928,0.09,"Panasapadu, Kakinada"],
"533006":[325,835,0.06,"Kaikavolu, Kakinada"],
"533007":[325,873,0.05,"Dairy Farm Center, East Godavari"],
"533016":[360,819,0.04,"Gurazanapalli, Kakinada"],
"533101":[291,576,0.01,"Rajahmundry, East Godavari"],
"533102":[302,746,0.06,"Gadala, East Godavari"],
"533103":[298,582,0.02,"Danavaipeta, East Godavari"],
"533104":[299,575,0.02,"Aryapuram, East Godavari"],
"533105":[301,615,0.02,"Venkatanagaram, East Godavari"],
"533106":[295,628,0.02,"APHB Colony, East Godavari"],
"533107":[300,576,0.02,"Pidimgoyya, East Godavari"],
"533108":[295,628,0.02,"NDC Rajahmundry, East Godavari"],
"533124":[326,536,0.02,"Rajavolu, East Godavari"],
"533125":[350,570,0.13,"Vemagiri, East Godavari"],
"533126":[350,643,0.36,"Madiki, Konaseema"],
"533201":[385,565,0.15,"Amalapuram, Konaseema"],
"533210":[355,799,0.0,"Komaragiripatnam, Konaseema"],
"533211":[431,1093,0.05,"Ainavillilanka, Konaseema"],
"533212":[540,962,0.07,"Bojjavaripeta, Konaseema"],
"533213":[345,651,0.14,"Vannechintalapudi, Konaseema"],
"533214":[369,580,0.11,"Munganda, Konaseema"],
"533215":[330,699,0.13,"Bodasakurru, Konaseema"],
"533217":[300,673,0.15,"Godilanka, Konaseema"],
"533218":[369,669,0.13,"Gudala, Konaseema"],
"533219":[375,924,0.04,"Muramalla, Konaseema"],
"533220":[375,772,0.04,"T.Kothapalli, Konaseema"],
"533221":[369,574,0.12,"Sakurru, Konaseema"],
"533222":[334,720,0.12,"Pedagadavilli, Konaseema"],
"533223":[368,1065,0.14,"Vadapalem, Konaseema"],
"533228":[340,751,0.07,"Madupalli, Konaseema"],
"533229":[348,911,0.13,"Modekurru, East Godavari"],
"533232":[348,713,0.21,"Sandhipudi, Konaseema"],
"533233":[348,708,0.33,"Mulastanam, Konaseema"],
"533234":[320,524,0.31,"Choppella, Konaseema"],
"533235":[348,747,0.84,"Pulidindi, Konaseema"],
"533236":[348,770,0.73,"Ankampalem, Konaseema"],
"533237":[348,777,0.58,"Lolla, Konaseema"],
"533238":[299,771,0.29,"Komarajulanka, Konaseema"],
"533239":[385,723,0.1,"K.Pedapudi, Konaseema"],
"533240":[315,719,0.04,"Mondepulanka, Konaseema"],
"533241":[385,737,0.1,"Nallacheruvu, Konaseema"],
"533242":[395,775,0.01,"Razole, Konaseema"],
"533244":[359,630,0.0,"Medicherlapalem, Konaseema"],
"533247":[348,897,0.13,"Mamidikuduru, Konaseema"],
"533248":[359,746,0.0,"Kadali, Konaseema"],
"533249":[322,759,0.02,"Palagummi, Konaseema"],
"533250":[390,524,0.0,"Sankaraguptam, Konaseema"],
"533251":[322,757,0.01,"Sakhinetipallipalem, Konaseema"],
"533252":[393,672,0.01,"Antarvedi, Konaseema"],
"533253":[393,649,0.0,"Gudimellanka, East Godavari"],
"533254":[390,547,0.0,"Kathimanda, Konaseema"],
"533255":[345,739,0.0,"Ramachandrapuram, Konaseema"],
"533256":[348,763,0.0,"Kurmapuram, Konaseema"],
"533260":[348,859,0.02,"Yanamadala, Kakinada"],
"533261":[345,709,0.01,"Matsavaram, Konaseema"],
"533262":[334,786,0.0,"Kapavaram, Konaseema"],
"533263":[365,838,0.04,"Balantram, Konaseema"],
"533264":[248,531,0.19,"Ramavaram, East Godavari"],
"533274":[345,785,0.21,"Ganti, Konaseema"],
"533284":[252,472,0.13,"Goragummi, Alluri Sitharama Raju"],
"533285":[248,542,0.18,"Bayyanapalli, Alluri Sitharama Raju"],
"533286":[279,606,0.24,"Gangampalem, East Godavari"],
"533287":[280,876,0.05,"Purushottapatnam, East Godavari"],
"533288":[274,488,0.01,"V.Ramannapalem, East Godavari"],
"533289":[440,901,0.25,"Gadarada, East Godavari"],
"533290":[372,783,0.2,"NAGAMPALLI, East Godavari"],
"533291":[350,879,0.01,"Mukundavaram, East Godavari"],
"533292":[302,705,0.26,"Burugupudi, East Godavari"],
"533293":[302,746,0.04,"Mirthipadu, East Godavari"],
"533294":[512,937,-1,"Veerampalem, East Godavari"],
"533295":[239,375,0.01,"Kundada, Alluri Sitharama Raju"],
"533296":[325,781,0.03,"Tokada, East Godavari"],
"533297":[298,798,0.27,"Kalavacherala, East Godavari"],
"533305":[350,806,0.06,"Satyavada, Konaseema"],
"533306":[350,789,0.08,"Kota, Konaseema"],
"533307":[345,735,0.19,"Vedurumudi, Konaseema"],
"533308":[350,598,0.02,"Nelaturu, Konaseema"],
"533309":[368,854,0.02,"Tatapudi, Konaseema"],
"533339":[278,504,0.0,"Chinaramanayyapeta, East Godavari"],
"533340":[350,617,0.02,"Palathodu, Konaseema"],
"533341":[326,502,0.04,"Z.Medapadu, Konaseema"],
"533342":[350,623,0.0,"Mahendrawada, East Godavari"],
"533343":[405,910,0.01,"Balabhadrapuram, East Godavari"],
"533344":[295,961,0.0,"Peddada, Kakinada"],
"533345":[345,807,0.0,"Konkuduru, East Godavari"],
"533346":[340,717,0.01,"Komaripalem, East Godavari"],
"533347":[319,608,0.28,"Lakkavaram, Alluri Sitharama Raju"],
"533348":[280,-1,0.02,"Forebey Dam Camp, Alluri Sitharama Raju"],
"533349":[302,774,0.06,"Tellamvarigudem, Alluri Sitharama Raju"],
"533350":[302,889,0.04,"KUTURU B.O., Alluri Sitharama Raju"],
"533351":[280,414,0.05,"Nandigama, Alluri Sitharama Raju"],
"533352":[275,703,0.12,"Gogubaka, East Godavari"],
"533353":[350,829,0.02,"Srikrishnapatnam, East Godavari"],
"533354":[305,647,0.13,"Devaram, Alluri Sitharama Raju"],
"533355":[355,815,0.07,"K gangavaram, East Godavari"],
"533401":[380,1078,-1,"Addaripeta, Kakinada"],
"533406":[270,720,0.03,"Thimmapuram, Kakinada"],
"533407":[395,717,-1,"Kothakottam, Kakinada"],
"533408":[405,895,0.05,"Krishnapuram, Kakinada"],
"533428":[210,422,0.03,"Vetamamidi, Alluri Sitharama Raju"],
"533429":[450,1161,0.05,"Bhadravaram, Kakinada"],
"533430":[442,832,0.02,"Pothuluru, Kakinada"],
"533431":[320,915,0.0,"Mukkullu, Kakinada"],
"533432":[315,843,0.02,"Yeluru, Kakinada"],
"533433":[320,890,0.09,"Jalluru, Kakinada"],
"533434":[312,848,0.11,"P Vemavaram, Kakinada"],
"533435":[315,1147,0.0,"Somavaram, Kakinada"],
"533436":[272,476,0.01,"Ammirekula, Alluri Sitharama Raju"],
"533437":[268,639,0.17,"Ramesampeta, East Godavari"],
"533440":[300,777,0.14,"Samalkot, Kakinada"],
"533444":[380,857,0.04,"Vazrakutam, Kakinada"],
"533445":[428,924,0.03,"Rayavaram, Kakinada"],
"533446":[250,674,0.02,"G Kothapalli, Kakinada"],
"533447":[435,1100,0.08,"Nagulapalli, Kakinada"],
"533448":[450,1114,0.08,"Mulapeta, Kakinada"],
"533449":[431,990,0.03,"Kothaperumallapuram, Kakinada"],
"533450":[328,942,0.09,"Chandanampalem, Kakinada"],
"533451":[435,958,0.02,"Kodavali, Kakinada"],
"533460":[325,853,0.06,"Pedapudi, Kakinada"],
"533461":[335,947,0.04,"Chollangipeta, Kakinada"],
"533462":[268,755,0.12,"Kandregula, Kakinada"],
"533463":[343,915,0.05,"Kesavapuram, Kakinada"],
"533464":[345,749,0.03,"Pallipalem, Kakinada"],
"533468":[334,804,0.03,"Manjeru, Kakinada"],
"533483":[200,298,0.02,"D. Ramavaram, Alluri Sitharama Raju"],
"533577":[345,665,0.16,"Pothukurru, Konaseema"],
"534001":[276,721,0.05,"Eluru, Eluru"],
"534002":[276,609,0.09,"Malkapuram, Eluru"],
"534003":[288,692,0.08,"Ankannagudem, Eluru"],
"534004":[450,1196,0.08,"Sriparru, Eluru"],
"534005":[276,670,0.07,"Eluru R.S, Eluru"],
"534006":[276,602,0.09,"Eluru Bus Station, Eluru"],
"534007":[288,778,0.06,"Kokkiripadu, Eluru"],
"534008":[276,666,0.07,"NDC ELURU, Eluru"],
"534101":[272,951,0.06,"Tadepalligudem, West Godavari"],
"534102":[335,1064,0.07,"Jaggannapeta, West Godavari"],
"534111":[386,547,0.0,"Gundepalli, West Godavari"],
"534112":[480,654,0.0,"Jajulakunta, West Godavari"],
"534122":[425,1278,0.08,"Satyavaram, West Godavari"],
"534123":[408,1063,0.05,"Deva, West Godavari"],
"534124":[360,1116,0.07,"Juttiga, West Godavari"],
"534126":[478,1285,0.08,"Podalada, West Godavari"],
"534134":[330,973,0.15,"Manchili, West Godavari"],
"534145":[550,1071,0.29,"Jagannadhapuram, West Godavari"],
"534146":[330,967,0.27,"Marampalli, West Godavari"],
"534156":[360,1019,0.25,"Surya Rao Palem, West Godavari"],
"534165":[332,1199,0.19,"Mounjipadu, West Godavari"],
"534166":[330,1296,0.19,"Darisaparru, West Godavari"],
"534176":[324,501,0.0,"Cheepurugudem, West Godavari"],
"534186":[360,1208,0.27,"Garagaparru, West Godavari"],
"534195":[332,1288,0.23,"D.Gopavaram, Eluru"],
"534196":[332,1099,0.17,"Mudunuru, West Godavari"],
"534197":[335,924,0.12,"Muggalla, Eluru"],
"534198":[332,1205,0.37,"Adavikolanu, Eluru"],
"534199":[330,1384,0.37,"Chilukuru, West Godavari"],
"534201":[390,1593,0.41,"Bhimavaram, West Godavari"],
"534202":[390,1581,0.41,"Annavaram, West Godavari"],
"534204":[349,2147,0.65,"Peda amiram, West Godavari"],
"534206":[349,1655,0.45,"Lakshminarasimhapuram, West Godavari"],
"534207":[355,1052,0.18,"Vempa, West Godavari"],
"534208":[349,1500,0.4,"Ankoderu, West Godavari"],
"534209":[360,1362,0.27,"Lakshminarayanapuram, West Godavari"],
"534210":[375,1366,0.25,"Kondepudi, West Godavari"],
"534211":[352,939,0.43,"Tanuku, West Godavari"],
"534215":[488,1512,0.06,"Venkatrayapuram, West Godavari"],
"534216":[345,894,0.58,"Chilakapadu, West Godavari"],
"534217":[358,1039,0.12,"Arjunudupalem, West Godavari"],
"534218":[345,921,0.26,"Tetali, West Godavari"],
"534222":[345,949,0.12,"Kavalipuram, West Godavari"],
"534225":[360,879,0.18,"S.Illindalaparru, West Godavari"],
"534227":[338,866,0.62,"Velagaduuru, West Godavari"],
"534230":[360,1270,0.24,"Kanchumarru, West Godavari"],
"534235":[390,1336,0.18,"Aibhimavaram, West Godavari"],
"534236":[490,1137,0.1,"Kalavapudi, West Godavari"],
"534237":[390,1505,0.28,"Kolanapalli, West Godavari"],
"534238":[460,1340,0.16,"Andaluru, West Godavari"],
"534239":[308,1153,0.29,"Gollavanitippa, West Godavari"],
"534240":[478,1239,0.07,"Nelapogula, West Godavari"],
"534243":[460,1452,0.2,"Dusanapudi, West Godavari"],
"534244":[550,1431,0.18,"Vankayalapalem, West Godavari"],
"534245":[478,1429,0.12,"Tillapudi, West Godavari"],
"534247":[478,1403,0.18,"Toleru, West Godavari"],
"534250":[495,1406,0.03,"Velivela, West Godavari"],
"534260":[393,1531,0.05,"Palakol, West Godavari"],
"534265":[478,1333,0.05,"Ullamparru, West Godavari"],
"534266":[376,937,0.03,"Bhimala Puram, West Godavari"],
"534267":[460,1300,0.05,"A.Vemavaram, West Godavari"],
"534268":[395,1134,0.03,"Chinchinada, West Godavari"],
"534269":[390,921,0.05,"Karugorumilli, West Godavari"],
"534275":[356,782,0.01,"Chittavaram, West Godavari"],
"534280":[355,687,0.01,"Kummarapurugupalem, West Godavari"],
"534281":[240,455,0.01,"Serepalem, West Godavari"],
"534301":[365,734,0.09,"Settipeta, West Godavari"],
"534302":[316,785,0.3,"Purushottapalli, West Godavari"],
"534305":[345,552,0.0,"Katakoteswaram, West Godavari"],
"534311":[310,491,0.04,"Kopalli, Eluru"],
"534312":[390,-1,-1,"Atchuthapuram, Eluru"],
"534313":[390,-1,-1,"Krishnampalem, West Godavari"],
"534315":[270,555,0.03,"Bangarampeta, West Godavari"],
"534316":[348,514,0.01,"Nandigudem, West Godavari"],
"534318":[290,593,0.04,"Gunjavaram, Eluru"],
"534320":[375,1086,0.09,"Kakileru, West Godavari"],
"534324":[390,1116,0.06,"Munamarru, West Godavari"],
"534326":[390,938,0.04,"Ilaparru, West Godavari"],
"534327":[495,1344,0.05,"Miniminchilipadu, West Godavari"],
"534328":[360,919,0.39,"Kannai Kumudavalli, West Godavari"],
"534329":[338,1057,0.88,"K.Agraharam, West Godavari"],
"534330":[338,818,0.23,"Mukkamala, West Godavari"],
"534331":[338,870,0.75,"Ajjaram, West Godavari"],
"534338":[588,1355,0.04,"Kommuchikkala, West Godavari"],
"534340":[280,670,0.06,"Peddavam, West Godavari"],
"534341":[300,643,0.06,"Gajjaram, West Godavari"],
"534342":[351,668,0.15,"Dommeru, West Godavari"],
"534350":[302,578,0.03,"Kovvur, West Godavari"],
"534401":[335,769,0.01,"P.Kannapuram, Eluru"],
"534406":[468,748,0.02,"Narayanapuram, Eluru"],
"534411":[335,1128,0.18,"Uppakapadu, West Godavari"],
"534416":[335,846,0.01,"A.Gokavaram, West Godavari"],
"534425":[345,387,0.0,"Surappagudem, Eluru"],
"534426":[300,702,0.0,"Timmapuram, Eluru"],
"534427":[254,536,0.04,"Krothagudem, Eluru"],
"534432":[265,550,0.08,"Satynarayanapuram, Eluru"],
"534435":[299,741,0.04,"Ramasingavaram, Eluru"],
"534437":[575,1358,0.05,"Naidugudem, Eluru"],
"534442":[230,416,0.08,"Dosapadu, Eluru"],
"534444":[302,749,0.05,"ARVAIPALLE, Eluru"],
"534447":[225,451,0.32,"Jangareddygudem, Eluru"],
"534448":[225,473,0.32,"Kommugudem, Eluru"],
"534449":[300,717,0.0,"Ankalampadu, Eluru"],
"534450":[265,570,0.08,"Munduru, Eluru"],
"534451":[318,571,0.0,"Devulapalli, Eluru"],
"534452":[300,668,0.0,"Vemulapally, Eluru"],
"534455":[225,426,0.37,"Ganapavaram, Eluru"],
"534456":[238,513,0.03,"A.Polavaram, Eluru"],
"534460":[338,896,-1,"Utasamudram, Eluru"],
"534461":[338,941,-1,"Tedlam, Eluru"],
"534462":[343,1007,0.0,"Bhogole, Eluru"],
"534467":[335,841,0.0,"Epigunta, Eluru"],
"534475":[338,804,0.06,"Rayannapalem, Eluru"],
"535001":[325,495,0.04,"Vizianagaram City, Vizianagaram"],
"535002":[315,410,0.04,"Vizianagaram, Vizianagaram"],
"535003":[325,696,0.07,"Ambativalasa, Vizianagaram"],
"535004":[300,555,0.1,"Pinavemali, Vizianagaram"],
"535005":[230,484,0.18,"Cheluvuru, Vizianagaram"],
"535006":[230,483,0.08,"Munginapalli, Vizianagaram"],
"535101":[395,473,0.1,"Geddapuvalasa, Vizianagaram"],
"535102":[370,524,0.04,"Bhyripuram, Vizianagaram"],
"535124":[285,686,0.01,"Kusumuru, Vizianagaram"],
"535125":[346,567,0.09,"Devarapodilam, Vizianagaram"],
"535126":[442,810,0.01,"Velagavalasa, Vizianagaram"],
"535128":[395,612,0.06,"Bondapalli, Vizianagaram"],
"535145":[281,697,0.15,"Konapuram, Visakhapatanam"],
"535148":[290,1185,0.09,"Kottam, Vizianagaram"],
"535160":[290,671,0.08,"Revallapalem, Vizianagaram"],
"535161":[290,856,0.06,"Seetharampuram, Vizianagaram"],
"535183":[370,598,0.04,"K R Peta, Vizianagaram"],
"535204":[222,502,0.03,"Govindapuram, Vizianagaram"],
"535213":[180,597,0.06,"Konada, Vizianagaram"],
"535214":[318,742,0.08,"Korukonda, Vizianagaram"],
"535215":[298,800,0.09,"P.S.R Puram, Vizianagaram"],
"535216":[230,511,0.12,"Nandigam, Vizianagaram"],
"535217":[275,659,0.04,"Jammu, Vizianagaram"],
"535218":[225,497,0.05,"Alugolu, Vizianagaram"],
"535220":[285,712,0.3,"Palavalasa, Vizianagaram"],
"535221":[305,871,0.22,"Godiyada, Vizianagaram"],
"535240":[318,759,0.07,"Alamanda Sandy, Vizianagaram"],
"535250":[298,850,0.12,"V R Palem, Visakhapatanam"],
"535260":[315,949,0.36,"Devupalli, Vizianagaram"],
"535270":[328,818,0.92,"Bhudevipeta, Vizianagaram"],
"535273":[337,559,0.34,"Gummakota, Alluri Sitharama Raju"],
"535280":[325,880,0.28,"Chintalapeta, Vizianagaram"],
"535281":[290,797,0.12,"Gudivada, Vizianagaram"],
"535463":[195,299,0.25,"Ravipalli, Parvathipuram Manyam"],
"535501":[280,383,0.08,"Parvatipuram, Parvathipuram Manyam"],
"535502":[280,405,0.07,"Duggi, Parvathipuram Manyam"],
"535521":[314,461,0.07,"Babbidi, Parvathipuram Manyam"],
"535522":[424,841,0.01,"Lakshminarayanapuram, Parvathipuram Manyam"],
"535523":[168,311,0.02,"Kedaripuram, Vizianagaram"],
"535524":[278,408,0.04,"Sivannapeta, Parvathipuram Manyam"],
"535525":[370,549,0.02,"Gijaba, Parvathipuram Manyam"],
"535526":[370,745,0.06,"Kannapudoravalasa, Parvathipuram Manyam"],
"535527":[314,485,0.03,"Surampeta, Parvathipuram Manyam"],
"535534":[168,305,0.02,"Udayapuram, Parvathipuram Manyam"],
"535546":[378,734,0.03,"Burja, Parvathipuram Manyam"],
"535547":[424,851,0.01,"Bangaruvalasa, Parvathipuram Manyam"],
"535557":[265,361,0.04,"Chilakalapalli, Parvathipuram Manyam"],
"535558":[404,611,0.02,"Bobbili, Vizianagaram"],
"535559":[404,615,0.02,"Mirthivalasa, Parvathipuram Manyam"],
"535568":[358,543,0.02,"Nandabalaga, Vizianagaram"],
"535569":[378,686,0.02,"Pakki, Vizianagaram"],
"535573":[404,607,0.02,"Chitrakota Boddavalasa, Vizianagaram"],
"535578":[340,514,0.03,"Badangi, Vizianagaram"],
"535579":[370,513,0.03,"Patharega, Vizianagaram"],
"535580":[310,599,0.29,"Ingilapalli Agraharam, Vizianagaram"],
"535581":[298,508,0.33,"Konda.Lingalavalasa, Vizianagaram"],
"535582":[310,563,0.23,"Datti, Vizianagaram"],
"535591":[221,348,0.16,"Viswanadhapuram, Parvathipuram Manyam"],
"535592":[202,298,0.26,"Karrivalasa, Parvathipuram Manyam"],
"535593":[245,400,0.13,"Kottuparuva, Parvathipuram Manyam"],
"535594":[330,634,0.05,"Ramabhadrapuram, Parvathipuram Manyam"],
"560001":[210,470,0.0,"Bengaluru G.P.O., Bengaluru Urban"],
"560002":[210,577,0.0,"Bengaluru Corporation Building, Bengaluru Urban"],
"560003":[210,433,0.0,"Swimming Pool Extn, Bengaluru Urban"],
"560004":[210,559,0.0,"Basavanagudi, Bengaluru Urban"],
"560005":[210,451,0.0,"Fraser Town, Bengaluru Urban"],
"560006":[210,463,0.0,"Training Command IAF, Bengaluru Urban"],
"560007":[277,793,0.0,"Agram, Bengaluru Urban"],
"560008":[277,794,0.0,"H A L II Stage, Bengaluru Urban"],
"560009":[210,492,0.0,"Bengaluru Dist Offices Bldg, Bengaluru Urban"],
"560010":[210,438,0.0,"Rajajinagar, Bengaluru Urban"],
"560011":[210,555,0.0,"Madhavan Park, Bengaluru Urban"],
"560012":[210,454,0.0,"Science Institute, Bengaluru Urban"],
"560013":[225,432,0.0,"Jalahalli, Bengaluru Urban"],
"560015":[205,357,0.0,"Jalahalli West, Bengaluru Urban"],
"560016":[185,434,0.0,"Ramamurthy Nagar, Bengaluru Urban"],
"560017":[310,793,0.0,"N A L, Bengaluru Urban"],
"560018":[210,527,0.0,"Goripalya, Bengaluru Urban"],
"560020":[210,482,0.0,"Seshadripuram, Bengaluru Urban"],
"560021":[210,458,0.0,"Gayathrinagar, Bengaluru Urban"],
"560022":[220,456,0.0,"Yeswanthpura, Bengaluru Urban"],
"560023":[210,488,0.0,"Magadi Road, Bengaluru Urban"],
"560024":[200,469,0.0,"H A Farm, Bengaluru Urban"],
"560025":[210,498,0.0,"Richmond Town, Bengaluru Urban"],
"560026":[210,561,0.0,"NAYANDAHALLI, Bengaluru Urban"],
"560027":[210,492,0.0,"Sampangiramnagar, Bengaluru Urban"],
"560029":[210,552,0.0,"Tavarekere, Bengaluru Urban"],
"560030":[210,482,0.0,"Adugodi, Bengaluru Urban"],
"560032":[210,467,0.0,"R T Nagar, Bengaluru Urban"],
"560033":[260,367,0.0,"Maruthi Sevanagar, Bengaluru Urban"],
"560034":[210,540,0.0,"St. Johns Medical College, Bengaluru Urban"],
"560035":[180,500,0.0,"Carmelram, Bengaluru Urban"],
"560036":[185,434,0.0,"Devasandra, Bengaluru Urban"],
"560037":[185,435,0.0,"Kundalahalli, Bengaluru Urban"],
"560038":[210,556,0.0,"Indiranagar S.O (Bengaluru), Bengaluru Urban"],
"560040":[210,524,0.0,"Chandra Lay Out, Bengaluru Urban"],
"560041":[210,578,0.0,"Jayanagar, Bengaluru Urban"],
"560042":[210,461,0.0,"Sivan Chetty Gardens, Bengaluru Urban"],
"560043":[210,454,0.0,"Banaswadi, Bengaluru Urban"],
"560045":[200,453,0.0,"Arabic College, Bengaluru Urban"],
"560047":[210,470,0.0,"Viveknagar S.O (Bengaluru), Bengaluru Urban"],
"560048":[180,407,0.0,"Hoodi, Bengaluru Urban"],
"560049":[185,441,0.0,"Mandur, Bengaluru Rural"],
"560050":[210,575,0.0,"Ashoknagar S.O (Bengaluru), Bengaluru Urban"],
"560051":[725,1468,0.02,"H K P Road, Bengaluru Urban"],
"560053":[210,504,0.0,"Chickpet, Bengaluru Urban"],
"560054":[220,447,0.0,"Msrit, Bengaluru Urban"],
"560055":[210,450,0.0,"Malleswaram West, Bengaluru Urban"],
"560056":[211,561,0.0,"Mallathahalli, Bengaluru Urban"],
"560057":[205,345,0.0,"Peenya Dasarahalli, Bengaluru Urban"],
"560058":[220,453,0.0,"Laggere, Bengaluru Urban"],
"560059":[210,624,0.0,"Rv Niketan, Bengaluru Urban"],
"560060":[212,628,0.0,"Chudenapura, Bengaluru Urban"],
"560061":[210,702,0.0,"Chikkalasandra, Bengaluru Urban"],
"560062":[210,647,0.0,"Doddakallasandra, Bengaluru Urban"],
"560063":[357,849,0.0,"BSF Campus Yelahanka, Bengaluru Urban"],
"560064":[225,364,0.0,"Singanayakanahalli, Bengaluru Urban"],
"560065":[220,470,0.0,"G K V K, Bengaluru Urban"],
"560066":[128,498,0.0,"E P I P, Bengaluru Urban"],
"560067":[310,740,0.0,"Naduvathi, Bengaluru Rural"],
"560068":[210,549,0.0,"Singasandra, Bengaluru Urban"],
"560070":[210,597,0.0,"Padmanabhnagar, Bengaluru Urban"],
"560071":[300,705,0.0,"Domlur, Bengaluru Urban"],
"560072":[210,571,0.0,"Nagarbhavi, Bengaluru Urban"],
"560073":[220,340,0.0,"Nelakadiranahalli, Bengaluru Urban"],
"560074":[275,662,0.0,"Kumbalgodu Gollahalli, Bengaluru Urban"],
"560075":[277,786,0.0,"Jeevanbhimanagar, Bengaluru Urban"],
"560076":[210,628,0.0,"Mount St Joseph, Bengaluru Urban"],
"560077":[210,439,0.0,"Doddagubbi, Bengaluru Urban"],
"560078":[210,612,0.0,"JP Nagar III Phase, Bengaluru Urban"],
"560079":[230,492,0.0,"Kamakshipalya, Bengaluru Urban"],
"560080":[210,450,0.0,"Sadashivanagar, Bengaluru Urban"],
"560081":[211,533,0.0,"Chandapura, Bengaluru Urban"],
"560082":[231,781,0.0,"Thataguni, Bengaluru Urban"],
"560083":[210,734,0.0,"Sakalavara, Bengaluru Urban"],
"560084":[210,448,0.0,"Lingarajapuram, Bengaluru Urban"],
"560085":[210,587,0.0,"Banashankari III Stage, Bengaluru Urban"],
"560086":[220,446,0.0,"West of Chord Road II stage, Bengaluru Urban"],
"560087":[210,527,0.0,"Muthsandra, Bengaluru Rural"],
"560088":[260,-1,0.0,"Hessarghatta, Bengaluru Urban"],
"560089":[240,-1,0.0,"Shivakote, Bengaluru Urban"],
"560090":[225,275,0.0,"Silvepura, Bengaluru Urban"],
"560091":[220,455,0.0,"Bapagrama, Bengaluru Urban"],
"560092":[210,451,0.0,"Kodigehalli, Bengaluru Urban"],
"560093":[210,478,0.0,"C V Raman Nagar, Bengaluru Urban"],
"560094":[280,449,0.0,"ISRO Anthariksha Bhavan, Bengaluru Urban"],
"560095":[210,523,0.0,"Koramangala VI Bk, Bengaluru Urban"],
"560096":[220,452,0.0,"Nandinilayout, Bengaluru Urban"],
"560097":[225,434,0.0,"Vidyaranyapura, Bengaluru Urban"],
"560098":[210,628,0.0,"Pattanagere P.O, Bengaluru Urban"],
"560099":[212,566,0.0,"Huskur, Bengaluru Urban"],
"560100":[211,618,0.0,"Electronics City, Bengaluru Urban"],
"560102":[210,533,0.0,"HSR Layout, Bengaluru Urban"],
"560103":[150,437,0.0,"Bellandur, Bengaluru Urban"],
"560104":[210,535,0.0,"Hampinagar, Bengaluru Urban"],
"560105":[212,707,0.0,"Haragadde, Bengaluru Urban"],
"560107":[230,243,0.0,"Achitnagar, Bengaluru Urban"],
"560108":[210,999,0.0,"Anjanapura, Bengaluru Urban"],
"560109":[210,767,0.0,"Thalaghattapura, Bengaluru Urban"],
"560110":[220,526,0.0,"Ullalu Upanagar, Bengaluru Urban"],
"560111":[210,740,0.0,"Kumaraswamy Layout, Bengaluru Urban"],
"560112":[495,1406,0.0,"Kodigehalli, Bengaluru Urban"],
"560113":[185,430,0.0,"Horamavu, Bengaluru Urban"],
"560114":[210,600,0.0,"Begur, Bengaluru Urban"],
"560115":[225,422,0.0,"Kannamangala, Bengaluru Urban"],
"560116":[280,751,0.0,"Taralu, Bengaluru Urban"],
"560117":[224,456,0.0,"Devanagundi, Bengaluru Rural"],
"560119":[220,406,0.0,"Singanayakanahalli, Bengaluru Urban"],
"560300":[450,994,0.0,"Kempegowda International Airport, Bengaluru Urban"],
"560500":[210,480,0.0,"CPC ITD BNPL booking HUB, Bengaluru Urban"],
"561101":[200,304,0.0,"Adarangi, Ramanagara"],
"561201":[230,517,0.0,"Madabal, Ramanagara"],
"561202":[245,671,0.03,"Rangasamudra, Tumakuru"],
"561203":[582,1252,0.0,"Gundamgere, Bengaluru Rural"],
"561204":[295,727,0.0,"Hulikunte, Bengaluru Rural"],
"561205":[450,1050,0.0,"Heggadahalli, Bengaluru Rural"],
"561206":[370,727,0.0,"Huduguru, Chikkaballapura"],
"561207":[236,614,0.0,"Hosahudya, Chikkaballapura"],
"561208":[320,571,0.0,"Chandandur, Chikkaballapura"],
"561209":[100,510,0.0,"Beechaganahalli, Chikkaballapura"],
"561210":[225,641,0.0,"Hampasandra, Chikkaballapura"],
"561211":[315,874,0.0,"Jarabandahalli, Chikkaballapura"],
"561212":[315,382,0.0,"Naremaddepalli, Chikkaballapura"],
"561213":[315,738,0.0,"Alipura, Chikkaballapura"],
"561228":[360,927,0.01,"Gundlakothur, Chikkaballapura"],
"562101":[285,726,0.0,"Chickballapur, Chikkaballapura"],
"562102":[348,1115,0.0,"BHAKTHARAHALLI, Chikkaballapura"],
"562103":[225,591,0.0,"Doddamarali, Chikkaballapura"],
"562104":[360,555,0.0,"Aruru, Chikkaballapura"],
"562105":[353,658,0.0,"Devaramallur, Chikkaballapura"],
"562106":[455,543,0.0,"Bestamaranahalli, Bengaluru Urban"],
"562107":[390,437,0.0,"Neralur, Bengaluru Urban"],
"562108":[210,629,0.0,"Abbur, Ramanagara"],
"562109":[250,401,0.0,"Ganakal, Ramanagara"],
"562110":[495,1110,0.0,"Alurduddanahalli, Bengaluru Rural"],
"562111":[110,448,0.0,"Billanakote, Bengaluru Rural"],
"562112":[310,718,0.0,"Attikuppe, Ramanagara"],
"562114":[343,476,0.0,"Hoskote Indl. Area, Bengaluru Rural"],
"562117":[312,739,0.0,"Alahalli, Ramanagara"],
"562119":[240,461,0.0,"Hunasanahalli, Ramanagara"],
"562120":[215,454,0.0,"Bachenahatti, Ramanagara"],
"562121":[262,622,0.0,"Guttalahunase, Ramanagara"],
"562122":[292,409,0.0,"Bylanarasapura, Bengaluru Rural"],
"562123":[200,200,0.0,"Arasinakunte, Bengaluru Rural"],
"562125":[135,383,0.0,"Dommasandra, Bengaluru Urban"],
"562126":[250,597,0.0,"Attihalli, Ramanagara"],
"562127":[200,292,0.0,"Byalakere, Ramanagara"],
"562128":[200,474,0.0,"Mayaganahalli, Ramanagara"],
"562129":[354,854,0.0,"Bendiganahalli, Bengaluru Rural"],
"562130":[199,253,0.0,"Kadabagere, Bengaluru Urban"],
"562131":[240,289,0.0,"Biskur, Ramanagara"],
"562132":[110,418,0.0,"Kalalaghatta, Bengaluru Rural"],
"562135":[316,956,0.0,"Channarayapatna, Bengaluru Rural"],
"562138":[275,680,0.0,"Aralalasandra, Ramanagara"],
"562149":[190,451,0.0,"Bandikodigehalli, Bengaluru Urban"],
"562157":[450,950,0.0,"Doddajala, Bengaluru Urban"],
"562159":[210,508,0.0,"Lakkojanahalli, Ramanagara"],
"562160":[210,513,0.0,"Channapatna, Ramanagara"],
"562161":[210,406,0.0,"Government Silk Farm, Ramanagara"],
"562162":[225,-1,0.0,"Lakshmipura, Bengaluru Urban"],
"562163":[495,1390,0.0,"Basettihalli, Bengaluru Rural"],
"562164":[348,928,0.0,"Venkatagirikote, Bengaluru Rural"],
"562165":[345,764,0.0,"Lakkondanahalli, Bengaluru Rural"],
"562166":[370,532,0.0,"Marasur, Ramanagara"],
"563101":[177,303,0.0,"Kolar, Kolar"],
"563103":[177,487,0.0,"Kamadenahalli, Kolar"],
"563113":[347,962,0.0,"Doddakambali, Kolar"],
"563114":[306,919,0.0,"Hulibele, Kolar"],
"563115":[381,872,0.0,"Beml Nagar, Kolar"],
"563116":[260,894,0.07,"Gollahalli, Kolar"],
"563117":[400,839,0.0,"Championreefs, Kolar"],
"563118":[299,913,0.0,"Coromandel, Kolar"],
"563119":[400,839,0.0,"Marikuppam, Kolar"],
"563120":[381,972,0.0,"Doddachinnahalli, Kolar"],
"563121":[260,841,0.0,"Jakkarasanakuppa, Kolar"],
"563122":[326,923,0.0,"Ganeshpuram, Kolar"],
"563123":[367,747,0.0,"Raghuttahalli, Chikkaballapura"],
"563124":[506,657,0.0,"Venkatapura, Chikkaballapura"],
"563125":[310,960,0.0,"Kallahalli, Chikkaballapura"],
"563126":[177,508,0.0,"Muduvadi, Kolar"],
"563127":[260,838,0.0,"Yelagondahalli, Kolar"],
"563128":[262,717,0.0,"Hirekattigenahalli, Chikkaballapura"],
"563129":[406,902,0.0,"DONIMADAGU, Kolar"],
"563130":[312,376,0.0,"Hongenahalli, Kolar"],
"563131":[260,834,0.0,"Gokunte, Kolar"],
"563132":[370,748,0.0,"Alangur, Kolar"],
"563133":[225,280,0.0,"Belamaranahalli, Kolar"],
"563134":[766,1536,0.0,"Jinkalavaripalli, Kolar"],
"563135":[394,981,0.0,"Kasettipalli, Kolar"],
"563136":[261,689,0.05,"Mallanayakanahalli, Kolar"],
"563137":[374,1057,0.0,"Kondasettihalli, Kolar"],
"563138":[360,830,0.0,"Devalapalli, Kolar"],
"563139":[410,959,0.0,"Hassandahalli, Kolar"],
"563146":[345,1269,0.0,"Kagathi, Chikkaballapura"],
"563147":[400,1062,0.0,"Magondhi, Kolar"],
"563157":[245,375,0.0,"Madderi, Kolar"],
"563159":[408,634,0.0,"E. Thimmasandra, Chikkaballapura"],
"563160":[324,500,0.0,"Malur Railway Station, Kolar"],
"563161":[376,968,0.0,"Byraganahalli, Kolar"],
"563162":[362,969,0.0,"Karahalli, Kolar"],
"563163":[324,500,0.0,"Alambadi, Kolar"],
"570001":[185,467,0.0,"Mysuru, Mysuru"],
"570002":[185,473,0.0,"Gokulam, Mysuru"],
"570003":[203,458,0.0,"Naganahalli, Mysuru"],
"570004":[201,415,0.0,"Mysuru Fort, Mysuru"],
"570005":[201,420,0.0,"Mysuru Law Courts, Mysuru"],
"570006":[185,457,0.0,"University Campus S.O (Mysuru), Mysuru"],
"570007":[216,479,0.0,"Narasimha Raja Mohalla, Mysuru"],
"570008":[213,505,-1,"Gopalapura, Mysuru"],
"570009":[201,440,0.0,"Saraswathipuram, Mysuru"],
"570010":[178,472,0.0,"Chamundi Betta, Mysuru"],
"570011":[185,494,0.0,"Siddarthanagar Nagar, Mysuru"],
"570012":[185,455,0.0,"Jayalakshmipuram S.O (Mysuru), Mysuru"],
"570014":[185,467,0.0,"Jayanagar S.O (Mysuru), Mysuru"],
"570015":[203,462,0.0,"Shivaraathreeswar Nagar, Mysuru"],
"570016":[188,447,0.0,"Metagalli, Mysuru"],
"570017":[185,461,0.0,"Vijaynagar II Stage, Mysuru"],
"570018":[190,469,0.0,"Koorgalli, Mysuru"],
"570019":[185,467,0.0,"Ramanahalli, Mysuru"],
"570020":[185,466,0.0,"Yadavagiri, Mysuru"],
"570022":[185,467,0.0,"Ramakrishna Nagar S.O (Mysuru), Mysuru"],
"570023":[201,409,0.0,"Kuvempunagar S.O (Mysuru), Mysuru"],
"570025":[172,484,-1,"G S Ashram, Mysuru"],
"570026":[172,460,-1,"Doddamaragowdanahalli, Mysuru"],
"570027":[188,458,0.0,"Infosys Campus, Mysuru"],
"570028":[216,539,0.0,"Lalithadripura, Mysuru"],
"570029":[185,467,0.0,"Shakthinagar, Mysuru"],
"570030":[185,467,0.0,"Vijayanagar III Stage, Mysuru"],
"570031":[172,485,-1,"Jaya Prakash Nagar, Mysuru"],
"570032":[185,466,-1,"Vijayanagar IV Stage, Mysuru"],
"570033":[201,440,0.0,"Dattagalli, Mysuru"],
"570034":[185,481,-1,"Sri Rampura 2nd Stage, Mysuru"],
"571101":[230,714,0.0,"Hanumanalu, Mysuru"],
"571102":[274,703,-1,"Bettadathunga, Mysuru"],
"571103":[390,711,-1,"Chikkabeechanahalli, Mysuru"],
"571104":[238,575,-1,"Koppa, Mysuru"],
"571105":[320,840,-1,"Maradur, Mysuru"],
"571106":[230,823,-1,"Veeranahosahalli, Mysuru"],
"571107":[305,835,-1,"Chowthi, Mysuru"],
"571108":[310,841,-1,"Thammadahalli, Mysuru"],
"571109":[319,859,-1,"Belachalavadi, Chamarajanagara"],
"571110":[230,789,-1,"Binakanahalli, Mysuru"],
"571111":[350,707,-1,"Annurkeri, Chamarajanagara"],
"571114":[228,527,-1,"Chakkodanahalli, Mysuru"],
"571115":[320,579,0.0,"Kastur Chamarajanagara, Chamarajanagara"],
"571116":[192,484,-1,"Bidarahalli, Mysuru"],
"571117":[320,457,0.0,"Honganur, Chamarajanagara"],
"571118":[270,579,-1,"Devarasanahalli, Mysuru"],
"571119":[255,728,-1,"Mallupura, Mysuru"],
"571120":[230,773,-1,"Chiduravalli, Mysuru"],
"571121":[205,588,-1,"Hadanur, Mysuru"],
"571122":[265,808,0.0,"T Bettahalli, Mysuru"],
"571123":[299,564,0.0,"Balachavadi, Chamarajanagara"],
"571124":[235,808,-1,"Hosa Alagodu, Mysuru"],
"571125":[229,748,-1,"Kolagala, Mysuru"],
"571126":[290,865,-1,"Mangala, Chamarajanagara"],
"571127":[140,507,0.0,"Venkatainachatra, Chamarajanagara"],
"571128":[253,560,-1,"Aralikatte, Chamarajanagara"],
"571129":[265,683,-1,"Suttur, Mysuru"],
"571130":[218,612,0.0,"Kallur Naganahalli, Mysuru"],
"571134":[392,549,-1,"Hirekyathanahalli, Mysuru"],
"571187":[198,486,-1,"Doddakamaravalli, Mysuru"],
"571189":[230,768,-1,"Paduvakote, Mysuru"],
"571190":[225,423,-1,"SERA THEKCHENLING, Mysuru"],
"571201":[95,178,-1,"Madikeri, Kodagu"],
"571202":[135,214,-1,"Vidyanagar, Kodagu"],
"571211":[129,260,-1,"Kalathmadu, Kodagu"],
"571212":[135,184,-1,"Arapattu, Kodagu"],
"571213":[122,232,-1,"Mayamudi, Kodagu"],
"571214":[100,146,-1,"Nelji, Kodagu"],
"571215":[144,281,-1,"Chennayanakote, Kodagu"],
"571216":[120,159,-1,"Balliamandur, Kodagu"],
"571217":[62,172,0.0,"Badaga, Kodagu"],
"571218":[129,261,-1,"Bittangala, Kodagu"],
"571219":[72,246,-1,"Devanur, Kodagu"],
"571231":[168,259,-1,"Bessur, Kodagu"],
"571232":[225,341,-1,"Madalapura, Kodagu"],
"571234":[178,281,-1,"Guddehosur, Kodagu"],
"571235":[159,296,-1,"Gopalapura, Kodagu"],
"571236":[130,239,-1,"Shanthalli, Kodagu"],
"571237":[175,270,-1,"Haradur, Kodagu"],
"571247":[80,145,-1,"Chettimani, Kodagu"],
"571248":[148,262,-1,"CHES, Kodagu"],
"571249":[68,161,-1,"Hysodlur, Kodagu"],
"571250":[64,204,0.0,"Manchalli, Kodagu"],
"571251":[130,217,-1,"Aigoor, Kodagu"],
"571252":[135,177,-1,"Hakathur, Kodagu"],
"571253":[169,297,-1,"Maldare, Kodagu"],
"571254":[121,322,-1,"Maroor, Kodagu"],
"571301":[265,635,-1,"Nanjangud, Mysuru"],
"571302":[265,625,-1,"K S Hundi, Mysuru"],
"571311":[260,596,-1,"Ayyarahalli, Mysuru"],
"571312":[255,655,-1,"Halepura, Mysuru"],
"571313":[300,714,0.0,"Doddarayapet, Chamarajanagara"],
"571314":[230,643,-1,"Haradanahalli, Mysuru"],
"571315":[185,467,0.0,"Naganapura, Mysuru"],
"571316":[300,714,0.0,"Bagali, Chamarajanagara"],
"571320":[330,777,0.0,"Kurahatti Hosur, Chamarajanagara"],
"571342":[300,714,0.0,"Hebbasur, Chamarajanagara"],
"571401":[288,777,0.0,"Mandya, Mandya"],
"571402":[293,860,0.0,"Hosur mandya, Mandya"],
"571403":[298,752,0.0,"Cheeranahalli, Mandya"],
"571404":[288,641,0.0,"Hanakere, Mandya"],
"571405":[230,602,0.0,"Bevkal, Mandya"],
"571415":[220,594,0.0,"Kodiyala, Mandya"],
"571416":[365,541,0.0,"Benahatti, Mandya"],
"571417":[258,522,0.0,"Kaggalipura, Mandya"],
"571418":[395,693,0.0,"Bilagunda, Mandya"],
"571419":[288,662,0.0,"Belathur, Mandya"],
"571421":[275,949,0.0,"Lingapatna, Mandya"],
"571422":[289,744,0.0,"Chikkarasinakere, Mandya"],
"571423":[291,437,0.0,"Hirekalale, Mandya"],
"571424":[250,717,0.0,"Anasale, Mandya"],
"571425":[300,676,0.0,"Bekkalale, Mandya"],
"571426":[225,459,0.0,"Byrapura, Mandya"],
"571427":[215,450,0.0,"Haravu, Mandya"],
"571428":[294,650,0.0,"Goravanahalli, Mandya"],
"571429":[294,704,0.0,"Chamanahalli, Mandya"],
"571430":[310,688,0.0,"Nidaghatta, Mandya"],
"571431":[335,842,0.0,"Balighatta, Mandya"],
"571432":[504,-1,0.0,"Bommanayakanahalli, Mandya"],
"571433":[279,668,0.0,"Alur maddur, Mandya"],
"571434":[218,475,0.0,"Doddabyadarahalli, Mandya"],
"571435":[220,593,0.0,"Nelamane, Mandya"],
"571436":[360,569,0.0,"Malagur, Mandya"],
"571438":[215,493,0.0,"Srirangapatna, Mandya"],
"571439":[532,1582,-1,"Bodimuthanahalli, Chamarajanagara"],
"571440":[300,715,0.0,"Kollegal, Chamarajanagara"],
"571441":[320,755,0.0,"Irasavadi, Chamarajanagara"],
"571442":[320,805,0.0,"Kinakanahalli, Chamarajanagara"],
"571443":[350,1086,-1,"Mangalam, Chamarajanagara"],
"571444":[532,791,-1,"Dinnahalli, Chamarajanagara"],
"571445":[588,996,0.0,"Thattihalli, Mandya"],
"571446":[293,605,0.0,"Chikkaballi, Mandya"],
"571448":[395,604,0.0,"Gondenahalli, Mandya"],
"571450":[288,655,0.0,"Hodaghatta, Mandya"],
"571455":[222,486,0.0,"Kanivekoppal, Mandya"],
"571457":[558,924,-1,"Odeyarapalyam, Chamarajanagara"],
"571463":[235,576,0.0,"Buhalli, Mandya"],
"571475":[290,1249,0.0,"Agasanapura, Mandya"],
"571476":[275,671,0.0,"Toresettihalli, Mandya"],
"571477":[190,444,0.0,"Nagoonahalli, Mandya"],
"571478":[240,616,0.0,"Santhekasalagere, Mandya"],
"571490":[435,795,0.02,"Marukotai, Chamarajanagara"],
"571601":[229,744,-1,"Munjanahalli, Mysuru"],
"571602":[395,887,-1,"Basavarajapura, Mysuru"],
"571603":[420,938,-1,"Gandanahalli, Mysuru"],
"571604":[185,467,0.0,"Ankanahalli, Mysuru"],
"571605":[370,853,0.0,"Alenahalli, Mandya"],
"571606":[215,495,0.0,"Hosahalli, Mandya"],
"571607":[188,431,0.0,"Krishnaraja Sagar, Mandya"],
"571610":[392,865,-1,"Chikkadaganahalli, Mysuru"],
"571617":[420,973,-1,"Hosakote, Mysuru"],
"571802":[420,-1,0.0,"Honnavara, Mandya"],
"571807":[215,514,0.0,"Ballenahalli, Mandya"],
"571811":[298,767,0.0,"Kanchanahalli, Mandya"],
"571812":[270,420,0.0,"Ballenahalli, Mandya"],
"572101":[291,676,0.0,"Tumakuru, Tumakuru"],
"572102":[297,694,0.0,"Settihalli, Tumakuru"],
"572103":[91,130,-1,"Kuvempunagara, Tumakuru"],
"572104":[285,703,0.0,"Kattige Gollahalli, Tumakuru"],
"572105":[249,1254,0.0,"Melekote, Tumakuru"],
"572106":[285,613,0.0,"Oorkere, Tumakuru"],
"572107":[310,801,0.0,"Halanur, Tumakuru"],
"572111":[375,614,0.0,"K.Honnamachanahalli, Tumakuru"],
"572112":[185,714,0.0,"Hanumanahalli, Tumakuru"],
"572113":[260,492,0.0,"Chikkabanagere, Tumakuru"],
"572114":[145,299,0.0,"Kuppalu, Tumakuru"],
"572115":[170,398,0.0,"Hunsekatte, Tumakuru"],
"572116":[235,586,0.03,"Jangamarahalli, Tumakuru"],
"572117":[260,427,0.0,"Ankasandra, Tumakuru"],
"572118":[310,792,0.0,"Makanahalli, Tumakuru"],
"572119":[172,467,0.0,"Baragihalli, Tumakuru"],
"572120":[222,476,0.0,"Dawoodsab Palya, Tumakuru"],
"572121":[175,279,0.0,"Chikkanahalli, Tumakuru"],
"572122":[165,327,0.0,"Maskal, Tumakuru"],
"572123":[327,643,0.0,"Halevoor, Tumakuru"],
"572124":[180,613,0.0,"Garani, Tumakuru"],
"572125":[462,915,0.0,"Gopaladeverahalli, Tumakuru"],
"572126":[270,480,0.0,"Seenappanahalli, Tumakuru"],
"572127":[175,414,0.0,"Chikkadalavatta, Tumakuru"],
"572128":[234,577,0.0,"Brahmasandra, Tumakuru"],
"572129":[175,206,0.0,"Bukkapatna, Tumakuru"],
"572130":[228,434,0.0,"Arakere, Tumakuru"],
"572132":[165,306,0.0,"Neralekere, Tumakuru"],
"572133":[210,474,0.0,"Bedathur, Tumakuru"],
"572134":[190,407,0.0,"Jiddigere, Tumakuru"],
"572135":[508,791,0.01,"Nadur, Tumakuru"],
"572136":[163,663,0.0,"Kyathaganakere, Tumakuru"],
"572137":[600,1097,0.0,"Guligenehalli, Tumakuru"],
"572138":[613,1294,0.0,"Dasalakunte, Tumakuru"],
"572139":[599,783,0.0,"Gowdagere, Tumakuru"],
"572140":[260,845,0.0,"Aregujjanahalli, Tumakuru"],
"572141":[302,984,0.0,"Chikkahalli, Tumakuru"],
"572142":[158,643,0.0,"Doddamadure, Tumakuru"],
"572168":[291,676,0.0,"Hirehalli, Tumakuru"],
"572175":[170,498,0.0,"Kondavadi, Tumakuru"],
"572201":[249,1248,0.0,"Tiptur, Tumakuru"],
"572211":[173,594,0.0,"Hadavanahalli, Tumakuru"],
"572212":[282,512,0.0,"Kunikenahalli, Tumakuru"],
"572213":[165,354,0.0,"Idagur, Tumakuru"],
"572214":[145,324,0.0,"Godekere, Tumakuru"],
"572215":[172,603,0.0,"Pura, Tumakuru"],
"572216":[264,984,0.0,"Chikkonahalli, Tumakuru"],
"572217":[212,775,0.0,"Hulihalli, Tumakuru"],
"572218":[212,775,0.0,"Ganadal, Tumakuru"],
"572219":[202,393,0.0,"Byadigere, Tumakuru"],
"572220":[202,393,0.0,"Bittagondanahalli, Tumakuru"],
"572221":[170,1203,0.0,"Soravanahalli, Tumakuru"],
"572222":[140,266,0.0,"Hagalawadi, Tumakuru"],
"572223":[217,569,0.0,"Bandihalli, Tumakuru"],
"572224":[221,525,0.0,"Aremallenahalli, Tumakuru"],
"572225":[236,648,0.0,"Attikatte, Tumakuru"],
"572226":[175,586,0.0,"Thammadihalli, Tumakuru"],
"572227":[142,464,0.0,"Benakanakere, Tumakuru"],
"572228":[140,410,0.0,"Muddenahalli, Tumakuru"],
"573101":[166,722,-1,"Nandigondanahalli, Hassan"],
"573102":[267,681,-1,"Bychanahalli, Hassan"],
"573103":[210,1008,0.0,"Arsikere, Hassan"],
"573111":[372,678,-1,"Kembalu, Hassan"],
"573112":[242,827,-1,"Basavanahalli, Hassan"],
"573113":[244,594,-1,"Belavadi, Hassan"],
"573115":[281,574,-1,"Iravalli, Hassan"],
"573116":[353,601,0.0,"Janivara, Hassan"],
"573117":[205,1518,0.0,"Madalu, Hassan"],
"573118":[283,733,-1,"Attavara, Hassan"],
"573119":[332,773,0.0,"Heggatta, Hassan"],
"573120":[240,647,-1,"Ankanayakanahalli, Hassan"],
"573121":[400,485,-1,"Gonisomanahalli, Hassan"],
"573122":[364,601,-1,"Doddenahalli, Hassan"],
"573123":[120,175,-1,"Hongadahalla, Hassan"],
"573124":[396,570,0.0,"Honnenahalli, Hassan"],
"573125":[348,574,-1,"Bandur, Hassan"],
"573126":[208,977,0.0,"Nagavedi, Hassan"],
"573127":[143,406,-1,"Halasulige, Hassan"],
"573128":[243,601,-1,"Kunduru, Hassan"],
"573129":[129,210,-1,"Harihalli, Hassan"],
"573130":[141,369,-1,"Bellame, Hassan"],
"573131":[372,607,-1,"Atthihalli, Hassan"],
"573133":[244,414,-1,"Doddahalli, Hassan"],
"573134":[129,199,-1,"Kadamane, Hassan"],
"573135":[364,579,0.0,"Dadighatta, Hassan"],
"573136":[244,580,-1,"Bidarakka, Hassan"],
"573137":[144,233,-1,"Doddakundur, Hassan"],
"573141":[313,627,0.0,"Masakanahalli, Hassan"],
"573142":[214,531,-1,"Heggadihalli, Hassan"],
"573144":[242,1260,0.0,"Sathangere, Hassan"],
"573162":[336,694,-1,"Basavaghatta, Hassan"],
"573164":[389,650,-1,"Chagachagere, Hassan"],
"573165":[128,202,-1,"Devaladakere, Hassan"],
"573201":[247,659,-1,"Hassan, Hassan"],
"573202":[251,648,-1,"Antharikshanagar, Hassan"],
"573210":[300,812,-1,"Niduvani, Hassan"],
"573211":[300,607,-1,"Bagivalu, Hassan"],
"573212":[251,730,-1,"Mosale, Hassan"],
"573213":[238,491,-1,"Kadalu, Hassan"],
"573214":[161,322,-1,"Jammanahalli, Hassan"],
"573215":[250,623,-1,"Ankihalli, Hassan"],
"573216":[390,601,-1,"Andale, Hassan"],
"573217":[276,579,-1,"Jodihandankere, Hassan"],
"573218":[219,485,-1,"Singapur, Hassan"],
"573219":[298,583,-1,"Yelagunda, Hassan"],
"573220":[294,812,-1,"Hongere, Hassan"],
"573225":[331,820,-1,"Dandiganahalli, Hassan"],
"573226":[269,793,-1,"Gadenahalli, Hassan"],
"574101":[38,96,-1,"Andar, Udupi"],
"574102":[41,114,-1,"Nire, Udupi"],
"574103":[58,199,-1,"Avral, Udupi"],
"574104":[78,113,-1,"Karkala, Udupi"],
"574105":[40,130,-1,"Manipura West, Udupi"],
"574106":[38,134,-1,"Padur, Udupi"],
"574107":[75,131,-1,"Nooralbettu, Udupi"],
"574108":[40,105,-1,"Ellare, Udupi"],
"574109":[45,128,-1,"Idu, Udupi"],
"574110":[100,170,-1,"Kedinje, Udupi"],
"574111":[50,183,-1,"Nandikur, Udupi"],
"574112":[50,196,-1,"Santhur, Udupi"],
"574113":[45,143,-1,"Halasinakatte, Udupi"],
"574114":[50,125,-1,"Irvathur, Udupi"],
"574115":[41,136,-1,"Herur92, Udupi"],
"574116":[40,130,-1,"Pernal, Udupi"],
"574117":[48,151,-1,"Bada, Udupi"],
"574118":[44,158,-1,"Alevoor, Udupi"],
"574119":[48,132,-1,"Admar, Udupi"],
"574122":[75,106,-1,"Nallur, Udupi"],
"574129":[55,182,-1,"Belady, Udupi"],
"574141":[60,254,-1,"Kollur, Dakshina Kannada"],
"574142":[60,249,-1,"Paduperar, Dakshina Kannada"],
"574143":[60,171,-1,"Pudu, Dakshina Kannada"],
"574144":[70,219,-1,"Neerude, Dakshina Kannada"],
"574145":[60,214,-1,"Addoor, Dakshina Kannada"],
"574146":[65,272,-1,"Koikude, Dakshina Kannada"],
"574148":[60,346,-1,"Kateel, Dakshina Kannada"],
"574150":[60,268,-1,"Nadugodu, Dakshina Kannada"],
"574151":[60,190,-1,"Malali, Dakshina Kannada"],
"574153":[85,361,0.0,"Montepadavu, Dakshina Kannada"],
"574154":[60,204,-1,"Karnire, Dakshina Kannada"],
"574162":[65,179,-1,"Iruvail, Dakshina Kannada"],
"574197":[82,148,-1,"Peranja, Dakshina Kannada"],
"574198":[90,140,-1,"Petrame, Dakshina Kannada"],
"574199":[61,478,-1,"Konaje, Dakshina Kannada"],
"574201":[91,151,-1,"Puttur(D.K.), Dakshina Kannada"],
"574202":[60,127,-1,"Savanur(Puttur), Dakshina Kannada"],
"574203":[90,148,-1,"Bannur, Dakshina Kannada"],
"574210":[55,121,0.0,"Kaikara, Dakshina Kannada"],
"574211":[113,181,-1,"Agrar, Dakshina Kannada"],
"574212":[70,160,-1,"Kodiyala, Dakshina Kannada"],
"574213":[50,133,-1,"Daregudde, Dakshina Kannada"],
"574214":[50,143,-1,"Koyyur, Dakshina Kannada"],
"574216":[60,156,-1,"Kayarthadka, Dakshina Kannada"],
"574217":[80,147,-1,"Gerukatte, Dakshina Kannada"],
"574218":[70,136,-1,"Balugodu, Dakshina Kannada"],
"574219":[70,171,-1,"Modankap, Dakshina Kannada"],
"574220":[100,157,-1,"Idkidu, Dakshina Kannada"],
"574221":[80,124,-1,"Kutrupady, Dakshina Kannada"],
"574222":[100,179,-1,"Veerakamba, Dakshina Kannada"],
"574223":[60,113,0.0,"Kanakamajal, Dakshina Kannada"],
"574224":[50,144,-1,"Machina, Dakshina Kannada"],
"574225":[70,202,-1,"Mijar, Dakshina Kannada"],
"574226":[60,207,-1,"Paladka, Dakshina Kannada"],
"574227":[75,191,-1,"Hosabettu, Dakshina Kannada"],
"574228":[65,159,-1,"Charmadi, Dakshina Kannada"],
"574229":[75,136,-1,"Gundia, Dakshina Kannada"],
"574230":[80,128,-1,"Kombar, Dakshina Kannada"],
"574231":[100,187,-1,"Sajipamudu, Dakshina Kannada"],
"574232":[75,140,-1,"Balpa, Dakshina Kannada"],
"574233":[65,150,-1,"Badagakajekar, Dakshina Kannada"],
"574234":[50,90,-1,"Sampaje Gate, Kodagu"],
"574235":[90,144,0.0,"Alike, Dakshina Kannada"],
"574236":[45,125,-1,"Mantrady, Dakshina Kannada"],
"574237":[75,158,-1,"Karpe, Dakshina Kannada"],
"574238":[75,145,-1,"Bilinele, Dakshina Kannada"],
"574239":[50,112,0.0,"Sonangeri, Dakshina Kannada"],
"574240":[50,144,-1,"Belal, Dakshina Kannada"],
"574241":[88,138,-1,"Bajathur, Dakshina Kannada"],
"574242":[85,156,-1,"Andinje, Dakshina Kannada"],
"574243":[90,152,0.0,"Neerkaje, Dakshina Kannada"],
"574244":[30,109,-1,"Kuntady, Udupi"],
"574248":[70,121,-1,"Markanja, Dakshina Kannada"],
"574253":[100,168,-1,"Ananthady, Dakshina Kannada"],
"574259":[55,120,0.01,"Nidpalli, Dakshina Kannada"],
"574260":[81,145,0.0,"Moodambail, Dakshina Kannada"],
"574265":[105,189,-1,"Kavalkatte, Dakshina Kannada"],
"574267":[80,221,-1,"Badagayedapadavu, Dakshina Kannada"],
"574274":[60,251,-1,"Niddodi, Dakshina Kannada"],
"574279":[81,136,0.0,"Kudupallathadka, Dakshina Kannada"],
"574285":[80,140,-1,"Perabe, Dakshina Kannada"],
"574313":[48,103,0.02,"Karnoor, Dakshina Kannada"],
"574314":[60,102,-1,"Thodikana, Dakshina Kannada"],
"574323":[100,158,0.0,"Barebettu, Dakshina Kannada"],
"574324":[100,170,-1,"Kudambettu, Dakshina Kannada"],
"574325":[100,153,-1,"Perne, Dakshina Kannada"],
"574326":[80,152,-1,"Karaya, Dakshina Kannada"],
"574327":[50,112,0.0,"Kurunjibag, Dakshina Kannada"],
"574328":[80,132,-1,"Bobbekri, Dakshina Kannada"],
"574509":[65,300,-1,"Yekkar, Dakshina Kannada"],
"575001":[65,354,-1,"Mangaluru, Dakshina Kannada"],
"575002":[60,385,-1,"Nagori, Dakshina Kannada"],
"575003":[60,402,-1,"Kodiyalbail, Dakshina Kannada"],
"575004":[60,411,-1,"Bijai, Dakshina Kannada"],
"575005":[60,390,-1,"Kulshekar, Dakshina Kannada"],
"575006":[60,437,-1,"Ashoknagar(MR), Dakshina Kannada"],
"575007":[60,404,-1,"Kannur, Dakshina Kannada"],
"575008":[60,401,-1,"Bikkarnakatte, Dakshina Kannada"],
"575009":[60,444,-1,"Jalligudde, Dakshina Kannada"],
"575010":[60,495,-1,"Meenakaliya, Dakshina Kannada"],
"575011":[60,311,-1,"Jokatte, Dakshina Kannada"],
"575013":[60,454,-1,"Panjimogaru, Dakshina Kannada"],
"575014":[60,299,-1,"Krishnapura, Dakshina Kannada"],
"575015":[70,390,-1,"Kunjathbail, Dakshina Kannada"],
"575016":[60,392,-1,"Shakthinagar (Dakshina Kannada), Dakshina Kannada"],
"575017":[50,569,-1,"Munnur, Dakshina Kannada"],
"575018":[50,458,0.0,"Mangalanthi, Dakshina Kannada"],
"575019":[60,322,-1,"MSEZ Colony, Dakshina Kannada"],
"575020":[55,1618,-1,"Ullal, Dakshina Kannada"],
"575022":[50,676,0.0,"Kumpala, Dakshina Kannada"],
"575023":[50,441,0.0,"Talapady, Dakshina Kannada"],
"575025":[65,325,-1,"Srinivasnagar, Dakshina Kannada"],
"575028":[60,392,-1,"Kudupu, Dakshina Kannada"],
"575029":[80,388,-1,"Mallur, Dakshina Kannada"],
"575030":[60,297,-1,"Kuthethur, Dakshina Kannada"],
"576101":[48,163,-1,"Udupi, Udupi"],
"576102":[42,160,-1,"Manchikodi, Udupi"],
"576103":[49,175,-1,"Kadekar, Udupi"],
"576104":[42,151,-1,"Manipal, Udupi"],
"576105":[48,182,-1,"Kelarkalabettu, Udupi"],
"576106":[50,200,-1,"Tenkanidiyur, Udupi"],
"576107":[41,142,-1,"Badagabettu, Udupi"],
"576108":[42,241,-1,"Thottam, Udupi"],
"576111":[50,173,-1,"Nandalike, Udupi"],
"576112":[31,90,0.0,"Kabbinale, Udupi"],
"576113":[38,122,-1,"Panchanbettu, Udupi"],
"576114":[48,194,-1,"Kallianapura, Udupi"],
"576115":[62,199,-1,"Badanidiyur, Udupi"],
"576117":[35,93,-1,"Kukkundur West, Udupi"],
"576120":[42,142,-1,"Manipura, Udupi"],
"576121":[58,198,-1,"Inna, Udupi"],
"576122":[41,135,-1,"Innanje, Udupi"],
"576124":[39,116,-1,"Kukkehalli, Udupi"],
"576201":[38,197,-1,"Kundapura, Udupi"],
"576210":[40,135,-1,"Bennekudru, Udupi"],
"576211":[35,158,-1,"Ampar, Udupi"],
"576212":[32,109,-1,"Ardi, Udupi"],
"576213":[48,167,-1,"Baikadi, Udupi"],
"576214":[46,547,-1,"Mayyadi, Udupi"],
"576215":[44,100,-1,"Karje, Udupi"],
"576216":[38,181,-1,"Ganguli, Udupi"],
"576217":[39,156,-1,"Mudlakatte, Udupi"],
"576218":[48,181,-1,"Kodibengre, Udupi"],
"576219":[45,645,-1,"Kalthod, Udupi"],
"576220":[48,132,-1,"Kollur, Udupi"],
"576221":[40,158,-1,"Belur Devasthanabettu, Udupi"],
"576222":[38,130,-1,"Hardallimandalli, Udupi"],
"576223":[40,110,-1,"Avarse, Udupi"],
"576224":[45,424,-1,"Badakere, Udupi"],
"576225":[40,161,-1,"Karkada, Udupi"],
"576226":[44,167,-1,"Kodi Kanyana, Udupi"],
"576227":[35,130,-1,"Amasebail, Udupi"],
"576228":[80,177,0.0,"Shiruru Udupi, Udupi"],
"576229":[32,204,-1,"Kamalashile, Udupi"],
"576230":[38,276,-1,"Hemmadi, Udupi"],
"576231":[40,142,-1,"Korgi, Udupi"],
"576232":[46,553,-1,"Tarapathi, Udupi"],
"576233":[45,262,-1,"Mudmunda, Udupi"],
"576234":[41,115,-1,"Baidabettu, Udupi"],
"576235":[41,341,-1,"Kundabarandadi, Udupi"],
"576247":[40,298,-1,"Hosadu, Udupi"],
"576257":[40,141,-1,"Vakwadi, Udupi"],
"576282":[50,216,-1,"Yedamoge, Udupi"],
"576283":[38,151,-1,"Gulvadi, Udupi"],
"577001":[244,1014,-1,"Davangere, Davangere"],
"577002":[340,891,-1,"Bethur, Davangere"],
"577003":[375,1004,-1,"Avaragere, Davangere"],
"577004":[350,998,-1,"Shyamanur, Davangere"],
"577005":[567,837,0.0,"Siramagondanahalli, Davangere"],
"577006":[335,786,-1,"CHIKKABUDIHAL, Davangere"],
"577007":[281,929,0.0,"Tholahunse, Davangere"],
"577008":[375,1004,-1,"NITTUVALLI B CLASS, Davangere"],
"577101":[233,456,-1,"Chikkamagaluru, Chikkamagaluru"],
"577102":[233,541,-1,"Hiremagalur, Chikkamagaluru"],
"577111":[101,230,-1,"Guddadamane, Chikkamagaluru"],
"577112":[81,262,-1,"Bannur, Chikkamagaluru"],
"577113":[91,133,-1,"Guthi, Chikkamagaluru"],
"577114":[61,211,-1,"Bilalkoppa, Chikkamagaluru"],
"577115":[227,515,0.0,"Gonibeedu, Shivamogga"],
"577116":[621,1598,-1,"Mundre, Chikkamagaluru"],
"577117":[81,369,-1,"Hiregadde, Chikkamagaluru"],
"577120":[48,73,0.0,"Melubelare, Chikkamagaluru"],
"577121":[61,116,-1,"Hemmakki, Chikkamagaluru"],
"577122":[71,148,-1,"Balur, Chikkamagaluru"],
"577123":[60,238,-1,"Guddethota, Chikkamagaluru"],
"577124":[60,102,-1,"Marasanige, Chikkamagaluru"],
"577125":[40,75,0.0,"Kammaradi, Chikkamagaluru"],
"577126":[48,82,0.0,"Koppa, Chikkamagaluru"],
"577127":[70,214,-1,"Kattinamane, Chikkamagaluru"],
"577128":[235,507,0.0,"Lakkavalli, Chikkamagaluru"],
"577129":[378,600,0.0,"Tanigebyle, Chikkamagaluru"],
"577130":[130,241,-1,"Hosahallipet, Chikkamagaluru"],
"577131":[232,292,-1,"Bisagnimutt, Chikkamagaluru"],
"577132":[80,133,-1,"Baskal, Chikkamagaluru"],
"577133":[150,374,-1,"Kuduvalli, Chikkamagaluru"],
"577134":[100,229,0.0,"Gubbiga (Sutta), Chikkamagaluru"],
"577135":[322,455,-1,"Banur, Chikkamagaluru"],
"577136":[96,137,-1,"Jannagadde, Chikkamagaluru"],
"577137":[258,467,-1,"Togarihankal, Chikkamagaluru"],
"577138":[242,849,-1,"Annigere(Yagati), Chikkamagaluru"],
"577139":[53,80,-1,"Kerekatte, Chikkamagaluru"],
"577140":[439,1395,-1,"Chikkaballekere, Chikkamagaluru"],
"577144":[235,659,0.0,"Duglapura, Chikkamagaluru"],
"577145":[621,1993,-1,"Javoor, Chikkamagaluru"],
"577146":[282,540,-1,"Kurubarabudihal, Chikkamagaluru"],
"577160":[81,147,-1,"Huigere, Chikkamagaluru"],
"577168":[302,476,-1,"Hulikere, Chikkamagaluru"],
"577175":[282,957,-1,"Nagaralu, Chikkamagaluru"],
"577179":[60,198,-1,"Thotadur, Chikkamagaluru"],
"577180":[397,1104,0.0,"Kalkere, Chikkamagaluru"],
"577181":[60,137,-1,"Horanadu, Chikkamagaluru"],
"577182":[242,1273,0.0,"Honnenahalli, Chikkamagaluru"],
"577201":[146,449,0.0,"Shivamogga, Shivamogga"],
"577202":[146,432,0.0,"Gajanur, Shivamogga"],
"577203":[201,410,0.0,"Mathur, Shivamogga"],
"577204":[146,449,0.0,"Navile, Shivamogga"],
"577205":[80,98,0.0,"Purudal, Shivamogga"],
"577211":[154,172,0.0,"Sirigere, Shivamogga"],
"577213":[375,1136,0.0,"Donihalli, Davangere"],
"577214":[130,271,0.0,"Ambligola, Shivamogga"],
"577215":[380,1128,0.0,"Kanchiganahalu, Davangere"],
"577216":[238,470,0.0,"Hadonahalli, Shivamogga"],
"577217":[335,455,-1,"Arabagatta, Davangere"],
"577218":[390,865,-1,"Channapura, Davangere"],
"577219":[395,852,-1,"Bannikodu, Davangere"],
"577220":[98,215,0.0,"Singanabidre, Shivamogga"],
"577221":[420,804,-1,"Kagathur, Davangere"],
"577222":[215,394,0.0,"Kachinakatte, Shivamogga"],
"577223":[70,138,0.0,"Doddethinahalli, Davangere"],
"577224":[335,779,-1,"Beeragondanahalli, Davangere"],
"577225":[240,342,0.0,"Chattanahalli, Davangere"],
"577226":[70,160,0.0,"Guthi Yedehalli, Shivamogga"],
"577227":[227,497,0.0,"Kudli, Shivamogga"],
"577228":[470,705,0.0,"Amruthapura, Chikkamagaluru"],
"577229":[218,439,0.0,"Siriyur, Shivamogga"],
"577230":[270,600,0.0,"Govinakovi, Davangere"],
"577231":[380,834,-1,"Chirdoni, Davangere"],
"577232":[51,144,0.0,"Kudumallige, Shivamogga"],
"577233":[230,522,0.0,"Arabilichi, Shivamogga"],
"577243":[238,532,0.0,"Hanagawadi, Shivamogga"],
"577245":[224,477,0.0,"Sunnadahalli, Shivamogga"],
"577301":[224,461,0.0,"Bhadravati, Shivamogga"],
"577302":[220,488,0.0,"Doddagoppenahalli, Shivamogga"],
"577401":[69,83,0.0,"Sagar, Shivamogga"],
"577411":[35,62,0.0,"Guddekere, Shivamogga"],
"577412":[78,-1,0.0,"Gilalagundi, Shivamogga"],
"577413":[369,663,0.0,"Bharangi, Shivamogga"],
"577414":[45,92,0.0,"Nonabur, Shivamogga"],
"577415":[45,92,0.0,"Hosa Agrahara, Shivamogga"],
"577416":[240,456,0.0,"Byranakoppa, Shivamogga"],
"577417":[73,-1,0.0,"Bheemanakone, Shivamogga"],
"577418":[74,116,0.0,"Kotethariga, Shivamogga"],
"577419":[210,338,0.0,"Dyavanahalli, Shivamogga"],
"577421":[66,70,0.0,"Aralagodu, Shivamogga"],
"577422":[64,114,0.0,"Hadigallu, Shivamogga"],
"577423":[118,118,0.0,"Thuppur, Shivamogga"],
"577424":[35,68,0.0,"Huruli, Shivamogga"],
"577425":[60,111,0.0,"Hulikal, Shivamogga"],
"577426":[71,76,0.0,"Harohithlu, Shivamogga"],
"577427":[252,368,0.0,"Ambaragoppa, Shivamogga"],
"577428":[269,459,0.0,"Agraharamuchadi, Shivamogga"],
"577429":[100,130,0.0,"Tavanandi, Shivamogga"],
"577430":[65,85,0.0,"Tadagalale, Shivamogga"],
"577431":[115,-1,0.0,"Barur, Shivamogga"],
"577432":[40,106,0.0,"Dooravasapura, Shivamogga"],
"577433":[334,534,0.0,"Tattur, Shivamogga"],
"577434":[86,94,0.0,"B.Dodderi, Shivamogga"],
"577435":[90,144,0.0,"Vadanbail, Shivamogga"],
"577436":[70,127,0.0,"Heddaripura, Shivamogga"],
"577451":[231,518,0.0,"KVV Shankaraghattta, Shivamogga"],
"577452":[72,109,0.0,"Mathikai, Shivamogga"],
"577453":[71,89,0.0,"Byacodu, Shivamogga"],
"577501":[216,736,0.0,"Chitradurga, Chitradurga"],
"577502":[210,961,0.0,"Madanayakanahalli, Chitradurga"],
"577511":[361,964,0.0,"Kodihally, Chitradurga"],
"577512":[330,1249,-1,"Alur, Davangere"],
"577513":[428,915,0.0,"Basavanakote, Davangere"],
"577514":[345,954,-1,"Kandagal, Davangere"],
"577515":[292,867,0.0,"Aralihally, Chitradurga"],
"577516":[410,922,-1,"Ukkadagatri, Davangere"],
"577517":[229,1094,0.0,"Haikal, Chitradurga"],
"577518":[410,1202,0.0,"Kalaghatta, Chitradurga"],
"577519":[274,1212,0.0,"Bhahadurghatta, Chitradurga"],
"577520":[270,808,0.0,"Hireguntanur, Chitradurga"],
"577521":[263,1289,0.0,"Bistuvalli, Davangere"],
"577522":[498,1261,0.0,"Balenahalli, Chitradurga"],
"577523":[281,1007,0.0,"Kodagavalli, Chitradurga"],
"577524":[289,1024,0.0,"Dyamavvanahally, Chitradurga"],
"577525":[340,1009,-1,"Mathi, Davangere"],
"577526":[330,878,0.0,"Beesanahally, Chitradurga"],
"577527":[236,864,0.0,"Aralahalli, Chitradurga"],
"577528":[250,930,-1,"Donehalli, Davangere"],
"577529":[337,1237,0.01,"Gowrasamudra, Chitradurga"],
"577530":[400,867,-1,"Guddadabevinahalli, Davangere"],
"577531":[150,484,0.0,"Dogganahal, Chitradurga"],
"577532":[210,1377,0.0,"Sondekere, Chitradurga"],
"577533":[314,916,0.0,"Nagathihally, Chitradurga"],
"577534":[450,1067,0.0,"Anaberu, Davangere"],
"577535":[432,2184,-1,"Chikkerahally, Chitradurga"],
"577536":[432,2184,-1,"Nelagathanahatti, Chitradurga"],
"577537":[432,2184,-1,"Doddaullarthi, Chitradurga"],
"577538":[335,494,0.0,"Korlakunte, Chitradurga"],
"577539":[345,821,0.0,"Gowdihalli, Chitradurga"],
"577540":[224,494,0.01,"Jagirbuddenahally, Chitradurga"],
"577541":[281,1093,0.0,"Basavasivanakere, Chitradurga"],
"577542":[232,825,0.0,"S. Nerlakere, Chitradurga"],
"577543":[432,2184,-1,"Kodihally, Chitradurga"],
"577544":[475,908,-1,"Nalkudre, Davangere"],
"577545":[258,1494,0.0,"Mallappanahally, Chitradurga"],
"577546":[382,686,0.0,"Abbinahole, Chitradurga"],
"577547":[621,1731,-1,"Antharaghatta, Chikkamagaluru"],
"577548":[406,905,-1,"Patnagere, Chikkamagaluru"],
"577549":[342,1125,0.0,"Cheeranahalli, Chikkamagaluru"],
"577550":[621,1571,-1,"Begur, Chikkamagaluru"],
"577551":[360,817,-1,"Daginakatte, Davangere"],
"577552":[415,1114,-1,"Aralikatte, Davangere"],
"577553":[220,668,-1,"Chaduragolla, Davangere"],
"577554":[278,992,0.0,"Annivala, Chitradurga"],
"577555":[219,801,0.0,"Hullur, Chitradurga"],
"577556":[225,765,0.0,"Hebbal, Davangere"],
"577557":[150,476,0.0,"Doddakittadahalli, Chitradurga"],
"577558":[258,1771,0.0,"Hulithotlu, Chitradurga"],
"577566":[345,994,-1,"Kundawada, Davangere"],
"577589":[350,1005,-1,"Avaragolla, Davangere"],
"577596":[382,1031,0.0,"Kanajanahalli, Chitradurga"],
"577597":[298,1132,0.0,"Kabbala, Chitradurga"],
"577598":[299,1151,0.0,"Peelali, Chitradurga"],
"577599":[281,1181,0.0,"Beeranahally, Chitradurga"],
"577601":[220,889,0.0,"Amaravathi, Davangere"],
"580001":[225,312,0.0,"Dharwad, Dharwad"],
"580002":[210,320,0.0,"Dharwad S D M E college, Dharwad"],
"580003":[225,314,0.0,"Dharwad K V V, Dharwad"],
"580004":[210,320,0.0,"Dharwad Vidyagiri, Dharwad"],
"580005":[225,341,0.0,"Narendra, Dharwad"],
"580006":[210,293,0.0,"Kavalgeri, Dharwad"],
"580007":[225,312,0.0,"Chikkamalligawad, Dharwad"],
"580008":[225,307,0.0,"Dharwad Narayanpur, Dharwad"],
"580009":[228,389,0.0,"Navalur, Dharwad"],
"580011":[208,401,0.0,"Tegur, Dharwad"],
"580020":[405,745,0.0,"Hubballi, Dharwad"],
"580021":[362,719,0.0,"Hubballi Vidyanagar, Dharwad"],
"580023":[330,668,0.0,"Gopankoppa, Dharwad"],
"580024":[320,692,0.0,"Rayanal, Dharwad"],
"580025":[320,574,0.0,"Amragol, Dharwad"],
"580026":[245,463,0.0,"Hubballi Tarihal Indl. Estate, Dharwad"],
"580027":[290,619,0.0,"Gokul, Dharwad"],
"580028":[320,643,0.0,"Sherewad, Dharwad"],
"580029":[362,720,0.0,"Hubballii Traffic Island, Dharwad"],
"580030":[362,713,0.0,"Hubballi Akashaya Colony, Dharwad"],
"580031":[320,718,0.0,"Hubballi Eng College, Dharwad"],
"580032":[362,768,0.0,"Hubballi Vijayanagar, Dharwad"],
"580112":[518,1588,0.0,"Shivalli, Dharwad"],
"580114":[270,408,0.0,"G Basavanakoppa, Dharwad"],
"580118":[210,379,0.0,"Nigadi, Dharwad"],
"581101":[255,480,-1,"Kanchinegalur, Haveri"],
"581102":[400,609,-1,"Havanagi, Haveri"],
"581103":[240,450,0.0,"Kadabagatti, Dharwad"],
"581104":[335,567,0.0,"Araleshwar, Haveri"],
"581105":[208,332,0.0,"Kotabagi, Dharwad"],
"581106":[270,519,-1,"Kadaramandalagi, Haveri"],
"581107":[370,789,0.0,"Kalas, Dharwad"],
"581108":[306,961,-1,"Basapur, Haveri"],
"581109":[319,606,-1,"Hirekonati, Haveri"],
"581110":[326,549,-1,"Haveri, Haveri"],
"581111":[287,580,-1,"Hullatti, Haveri"],
"581112":[377,838,0.0,"Kalasur, Haveri"],
"581113":[333,512,0.0,"Gudenakatti, Dharwad"],
"581115":[360,790,-1,"Asundi, Haveri"],
"581116":[320,653,-1,"Chikkayadachi, Haveri"],
"581117":[230,509,0.0,"Pashupatihal, Dharwad"],
"581118":[481,872,0.0,"Dombaramattur, Haveri"],
"581119":[390,747,-1,"Chikkabbar, Haveri"],
"581120":[440,792,-1,"Kachavi, Haveri"],
"581121":[39,96,0.0,"Bazarkunang, Uttara Kannada"],
"581123":[415,1181,-1,"Itagi, Haveri"],
"581126":[478,1182,0.0,"Mantrodi, Haveri"],
"581128":[346,668,-1,"Anandavan, Haveri"],
"581129":[39,96,0.0,"Asu, Uttara Kannada"],
"581145":[385,1426,-1,"Kamadod, Haveri"],
"581148":[388,771,-1,"Didagur, Haveri"],
"581186":[39,96,0.0,"Chapoli, Uttara Kannada"],
"581187":[39,96,0.0,"Nujji, Uttara Kannada"],
"581193":[232,338,0.0,"Kunnur, Haveri"],
"581195":[434,489,0.0,"Umachagi, Dharwad"],
"581196":[250,537,0.0,"Ganjigatti, Dharwad"],
"581198":[256,454,-1,"Kalledevaru, Haveri"],
"581199":[255,470,-1,"Savasagi, Haveri"],
"581201":[300,1136,0.0,"Harobelvadi, Dharwad"],
"581202":[328,570,-1,"Narayanapur, Haveri"],
"581203":[160,342,0.0,"Hotanahalli, Haveri"],
"581204":[210,397,0.0,"Biravalli, Dharwad"],
"581205":[270,591,-1,"Gangebhavi, Haveri"],
"581206":[146,289,0.0,"Pudakalakatti, Dharwad"],
"581207":[290,641,0.0,"Agadi, Dharwad"],
"581208":[380,694,-1,"Joisaraharalalli, Haveri"],
"581209":[540,-1,0.0,"Manakawad, Dharwad"],
"581210":[265,705,-1,"Hosakatti, Haveri"],
"581211":[497,1394,-1,"Belur, Haveri"],
"581212":[250,550,0.0,"Tadas, Haveri"],
"581213":[411,990,0.0,"Negalur, Haveri"],
"581237":[479,1066,0.0,"Naikerur, Haveri"],
"581301":[110,350,0.0,"Karwar, Uttara Kannada"],
"581302":[110,297,0.0,"Awara Road, Uttara Kannada"],
"581303":[100,305,0.0,"Kodibag, Uttara Kannada"],
"581304":[105,314,0.0,"Nandangadda, Uttara Kannada"],
"581306":[105,288,0.0,"Baad(KWR), Uttara Kannada"],
"581307":[110,284,0.0,"Binaga, Uttara Kannada"],
"581308":[100,180,0.0,"Karwar Naval Base, Uttara Kannada"],
"581314":[93,143,0.0,"Baleguli, Uttara Kannada"],
"581315":[39,96,0.0,"Navilgar, Uttara Kannada"],
"581316":[85,154,0.0,"Harwada, Uttara Kannada"],
"581317":[102,179,0.0,"Bhaire, Uttara Kannada"],
"581318":[85,165,0.0,"Korlakatta, Uttara Kannada"],
"581319":[110,-1,0.0,"Dubbanshashi, Uttara Kannada"],
"581320":[80,114,0.0,"Heble, Uttara Kannada"],
"581321":[90,161,0.0,"Bhavikeri, Uttara Kannada"],
"581322":[39,96,0.0,"Chapparmane, Uttara Kannada"],
"581323":[65,147,0.0,"Santgal, Uttara Kannada"],
"581324":[105,217,0.0,"Mudga, Uttara Kannada"],
"581325":[216,368,0.0,"Pradhani, Uttara Kannada"],
"581326":[110,-1,0.0,"Tadri, Uttara Kannada"],
"581327":[70,136,0.0,"Dhareshwar, Uttara Kannada"],
"581328":[105,186,0.0,"Bolshitta, Uttara Kannada"],
"581329":[39,96,0.0,"Ammankoppa, Uttara Kannada"],
"581330":[80,109,0.0,"Masur, Uttara Kannada"],
"581331":[39,96,0.0,"Balekoppa, Uttara Kannada"],
"581332":[70,128,0.0,"Valgalli, Uttara Kannada"],
"581333":[80,109,0.0,"Kimani, Uttara Kannada"],
"581334":[70,146,0.0,"Durgakeri, Uttara Kannada"],
"581335":[70,137,0.0,"Mavinkurve, Uttara Kannada"],
"581336":[70,146,0.0,"Balegadde, Uttara Kannada"],
"581337":[39,96,0.0,"Gullapur, Uttara Kannada"],
"581338":[70,143,0.0,"Hodkeshirur, Uttara Kannada"],
"581339":[102,195,0.0,"Wailwada, Uttara Kannada"],
"581340":[75,165,0.0,"Kodsaramuttalli, Uttara Kannada"],
"581341":[65,143,0.0,"Konkar, Uttara Kannada"],
"581342":[72,133,0.0,"Kelaginoor, Uttara Kannada"],
"581343":[60,122,0.0,"Kumta, Uttara Kannada"],
"581344":[110,117,0.0,"Torke, Uttara Kannada"],
"581345":[100,227,0.0,"Gaongeri, Uttara Kannada"],
"581346":[322,1430,-1,"Bhedasgaon, Uttara Kannada"],
"581347":[156,293,0.0,"Hasangi, Uttara Kannada"],
"581348":[90,106,0.0,"Gunavante, Uttara Kannada"],
"581349":[56,152,-1,"Chigalli, Uttara Kannada"],
"581350":[70,161,0.0,"Bailur, Uttara Kannada"],
"581351":[80,112,0.0,"Baad, Uttara Kannada"],
"581352":[100,251,0.0,"Devbag, Uttara Kannada"],
"581353":[110,142,0.0,"Manjuguni, Uttara Kannada"],
"581354":[92,-1,0.0,"Alvekodi(BKTL), Uttara Kannada"],
"581355":[39,96,0.0,"Bedkani, Uttara Kannada"],
"581356":[39,96,0.0,"Havagi, Uttara Kannada"],
"581357":[111,131,0.0,"Belse, Uttara Kannada"],
"581358":[39,96,0.0,"Dasankoppa, Uttara Kannada"],
"581359":[163,378,0.0,"D.T.Road, Uttara Kannada"],
"581360":[84,125,0.0,"Mudgeri, Uttara Kannada"],
"581361":[72,149,0.0,"Kharwa, Uttara Kannada"],
"581362":[70,137,0.0,"Kodambale, Uttara Kannada"],
"581363":[125,263,0.0,"Virnoli, Uttara Kannada"],
"581365":[61,74,0.0,"Aveda, Uttara Kannada"],
"581384":[70,169,0.0,"Kudrige, Uttara Kannada"],
"581396":[98,122,0.0,"Kadra, Uttara Kannada"],
"581400":[98,119,0.0,"Devalmakki, Uttara Kannada"],
"581401":[90,163,0.0,"Sirsi, Uttara Kannada"],
"581402":[140,228,0.0,"Chipgeri, Uttara Kannada"],
"581403":[90,155,0.0,"Barur, Uttara Kannada"],
"581411":[295,579,0.0,"Nandikatta, Uttara Kannada"],
"581412":[39,96,0.0,"Hosalli, Uttara Kannada"],
"581421":[80,163,0.0,"Bengre, Uttara Kannada"],
"581423":[90,132,0.0,"Balkur, Uttara Kannada"],
"581440":[75,85,0.0,"Nilkod, Uttara Kannada"],
"581450":[39,96,0.0,"Herur, Uttara Kannada"],
"581453":[39,96,0.0,"Anmod, Uttara Kannada"],
"582101":[295,758,0.0,"Gadag, Gadag"],
"582102":[470,1568,0.0,"Hirekoppa, Gadag"],
"582103":[295,821,0.0,"Nagavi, Gadag"],
"582111":[733,1509,0.0,"Kotumachagi, Gadag"],
"582112":[375,1212,0.0,"Bannikoppa, Gadag"],
"582113":[355,1525,0.0,"Mewundi, Gadag"],
"582114":[335,675,0.0,"Nidgundi, Gadag"],
"582115":[468,1644,0.0,"Hatalgeri, Gadag"],
"582116":[370,749,0.0,"Battur, Gadag"],
"582117":[230,610,0.0,"Madhalli, Gadag"],
"582118":[225,969,0.0,"Nagarahalli, Gadag"],
"582119":[868,1746,0.0,"Halkeri, Gadag"],
"582120":[325,846,0.0,"Yelisirur, Gadag"],
"582201":[330,893,0.0,"Basapur, Dharwad"],
"582202":[355,-1,0.0,"Koujageri, Gadag"],
"582203":[355,778,0.0,"Holemannur, Gadag"],
"582204":[295,1032,0.0,"Belhod, Gadag"],
"582205":[295,779,0.0,"Chickhandigol, Gadag"],
"582206":[473,943,0.0,"Konnur S.O (Gadag), Gadag"],
"582207":[946,1799,0.0,"Hirekoppa, Gadag"],
"582208":[472,1266,0.0,"Arekurahatti, Dharwad"],
"582209":[560,897,0.0,"Hosalli, Gadag"],
"582210":[435,1030,0.0,"Doddur, Gadag"],
"582211":[335,674,0.0,"Lakkalkatti, Gadag"],
"583101":[263,1391,-1,"Ballari, Ballari"],
"583102":[313,1492,-1,"Rupangudi, Ballari"],
"583103":[244,1449,0.78,"Gududur, Ballari"],
"583104":[414,1828,-1,"Allipur, Ballari"],
"583105":[440,1913,-1,"Ballari Jnanasagara, Ballari"],
"583111":[432,1523,0.49,"P D Halli, Ballari"],
"583112":[278,965,-1,"Gollalingammanahalli, Ballari"],
"583113":[418,1766,-1,"Kottal, Ballari"],
"583114":[1460,2771,0.06,"Agasanur, Ballari"],
"583115":[270,1853,-1,"Siddammanahalli, Ballari"],
"583116":[224,737,-1,"Genikihal, Ballari"],
"583117":[550,2121,0.52,"Basarakodu, Ballari"],
"583118":[250,1348,-1,"D T Ship, Ballari"],
"583119":[300,1102,-1,"Nandihalli, Ballari"],
"583120":[280,1315,-1,"Havinal, Ballari"],
"583121":[545,1887,0.0,"Bandrahalu, Ballari"],
"583122":[295,2041,-1,"Halekota, Ballari"],
"583123":[270,2484,-1,"Kurekuppa, Ballari"],
"583124":[323,1113,-1,"Hirekeriginalli, Ballari"],
"583125":[462,1183,-1,"Chatnihalli, Vijaynagar"],
"583126":[218,736,0.0,"Huralihal, Vijaynagar"],
"583127":[243,819,-1,"Mattihalli, Vijaynagar"],
"583128":[323,1057,-1,"Jiginihalli, Ballari"],
"583129":[409,2885,-1,"Chikkajayaganur, Ballari"],
"583130":[204,686,0.0,"Chandrashekharapura, Vijaynagar"],
"583131":[185,684,-1,"Hulikatti, Vijaynagar"],
"583132":[378,1508,-1,"Kampli Sugar Factory, Ballari"],
"583134":[284,1115,0.0,"Ambli, Vijaynagar"],
"583135":[268,649,0.0,"Jarimale, Vijaynagar"],
"583136":[258,1049,0.0,"Kalapura, Vijaynagar"],
"583137":[600,1978,-1,"Kadathi, Vijaynagar"],
"583152":[569,2329,-1,"Anthapura, Ballari"],
"583153":[271,1417,-1,"Shankar Hill Town Colony S.O., Ballari"],
"583154":[280,1662,0.37,"Bhairapura, Ballari"],
"583155":[164,1439,-1,"Dammuru, Ballari"],
"583201":[256,815,-1,"Hosapete, Vijaynagar"],
"583203":[256,849,-1,"Kallahalli Rajapura, Vijaynagar"],
"583211":[256,742,-1,"Hosur, Vijaynagar"],
"583212":[290,1475,-1,"Anekal, Vijaynagar"],
"583213":[380,1290,-1,"Kunchur, Vijaynagar"],
"583214":[202,873,0.0,"Enigi Basapura, Vijaynagar"],
"583215":[265,673,-1,"Hampi Power House, Vijaynagar"],
"583216":[345,921,-1,"Hirebannimatti, Vijaynagar"],
"583217":[352,1124,-1,"Dasanahalli, Vijaynagar"],
"583218":[209,930,-1,"Lokikere, Vijaynagar"],
"583219":[179,915,-1,"Dasarahalli, Vijaynagar"],
"583220":[220,948,-1,"Kogali, Vijaynagar"],
"583221":[265,673,-1,"Hampi Power House, Vijaynagar"],
"583222":[420,1758,-1,"Chilakanahatti, Vijaynagar"],
"583223":[307,722,-1,"Byluvaddigere, Vijaynagar"],
"583224":[249,1049,-1,"Bannigola, Vijaynagar"],
"583225":[260,849,-1,"T B Dam, Vijaynagar"],
"583226":[390,1287,0.0,"Halwagali, Koppal"],
"583227":[335,1087,-1,"Gangavathi ARS, Koppal"],
"583228":[256,829,-1,"Hirebaganal, Koppal"],
"583229":[282,1146,0.0,"Kardoni, Koppal"],
"583230":[300,1287,-1,"Arkeri, Koppal"],
"583231":[300,923,-1,"Koppal, Koppal"],
"583232":[840,2414,-1,"Mandalgera, Koppal"],
"583233":[214,896,-1,"Munirabad, Koppal"],
"583234":[237,864,-1,"Sanapur, Koppal"],
"583235":[310,974,-1,"Agoli, Koppal"],
"583236":[816,2542,-1,"Gadgeri, Koppal"],
"583237":[615,1566,-1,"Vanageri, Koppal"],
"583238":[300,1385,-1,"Bahaddurbandi, Koppal"],
"583239":[265,656,-1,"Kondanayakanahalli, Vijaynagar"],
"583268":[406,2232,-1,"Hebbal, Koppal"],
"583275":[270,2394,-1,"Vidyanagar S.O(Ballari), Ballari"],
"583276":[265,703,-1,"K U Campus, Vijaynagar"],
"583277":[360,1181,-1,"Gumgera, Koppal"],
"583278":[328,1650,-1,"Mudenur, Koppal"],
"583279":[310,927,0.0,"Navalhalli, Koppal"],
"583280":[335,1001,0.0,"Bilekal, Koppal"],
"583281":[405,1591,-1,"Hoolgera, Koppal"],
"583282":[300,1258,-1,"Bargoor, Koppal"],
"583283":[406,793,-1,"Chickkabommanhal, Koppal"],
"583284":[470,1730,0.0,"Karmudi, Koppal"],
"583285":[350,1557,-1,"Kolur, Koppal"],
"583286":[135,415,0.0,"Siddapura, Koppal"],
"583287":[246,1360,-1,"Chilakmukhi, Koppal"],
"583288":[220,917,-1,"Chalagera, Koppal"],
"584101":[412,1097,0.0,"Raichur, Raichur"],
"584102":[415,1448,0.06,"Chandrabanda, Raichur"],
"584103":[522,1395,0.03,"Mitti Malkapur, Raichur"],
"584104":[385,977,0.0,"Nelhal, Raichur"],
"584111":[310,1563,-1,"Konchapli, Raichur"],
"584113":[280,838,0.0,"Arshangi, Raichur"],
"584115":[370,918,0.0,"Medinapur, Raichur"],
"584116":[320,693,0.0,"Hosur Siddapur, Raichur"],
"584118":[330,2056,0.0,"Neermanvi, Raichur"],
"584120":[335,1479,0.0,"Bagalwad, Raichur"],
"584122":[340,692,0.0,"Kalli Lingasugur, Raichur"],
"584123":[560,1571,0.0,"Harvi, Raichur"],
"584124":[225,927,0.0,"Medikinhal, Raichur"],
"584125":[430,1825,0.0,"Gudihal, Raichur"],
"584126":[295,878,0.0,"Shivangi, Raichur"],
"584127":[290,523,0.0,"Gorebal, Raichur"],
"584128":[250,799,0.0,"Alabanur, Raichur"],
"584129":[220,717,0.0,"Jadaladinni, Raichur"],
"584132":[280,751,0.0,"Hirebhergi, Raichur"],
"584133":[469,1621,0.0,"Puchaldinni, Raichur"],
"584134":[393,1159,0.0,"Hosapete, Raichur"],
"584135":[364,1040,0.05,"Dongarampur, Raichur"],
"584136":[240,702,0.0,"Athnur, Raichur"],
"584138":[418,1409,0.0,"Diddgi, Raichur"],
"584139":[340,851,0.0,"Gowdur, Raichur"],
"584140":[620,1387,0.05,"Alkur, Raichur"],
"584143":[480,1865,0.0,"Hosur, Raichur"],
"584167":[250,1236,0.0,"Mukkunda, Raichur"],
"584170":[429,913,0.0,"Deosugur, Raichur"],
"584202":[620,1344,0.08,"Hanamapur, Raichur"],
"584203":[630,1169,0.04,"Aroli, Raichur"],
"585101":[122,737,-1,"Kalaburagi, Kalaburagi"],
"585102":[33,736,-1,"Hadagil Haruthi, Kalaburagi"],
"585103":[210,769,-1,"Sirasgi, Kalaburagi"],
"585104":[370,912,-1,"Asta, Kalaburagi"],
"585105":[33,729,-1,"Gb Santrashwadi, Kalaburagi"],
"585106":[480,812,-1,"GB Jnanaganga, Kalaburagi"],
"585107":[350,577,0.04,"Kalaburagi HCB, Kalaburagi"],
"585201":[385,1238,-1,"Yadgiri, Yadgir"],
"585202":[225,370,0.0,"Babalad, Yadgir"],
"585210":[569,1052,0.1,"Kurkunta, Kalaburagi"],
"585211":[185,911,-1,"Alhalli, Kalaburagi"],
"585212":[380,1341,-1,"Tellur, Kalaburagi"],
"585213":[950,1859,-1,"Jawali, Kalaburagi"],
"585214":[383,882,0.0,"Buragpalli, Kalaburagi"],
"585215":[310,965,-1,"Srinivasapur, Yadgir"],
"585216":[245,747,-1,"Alhal, Yadgir"],
"585217":[480,729,0.0,"Udachan, Kalaburagi"],
"585218":[256,818,-1,"Kulkunta, Kalaburagi"],
"585219":[225,405,0.0,"Narayanpur S.O (Yadgir), Yadgir"],
"585220":[280,666,-1,"Devargonal, Yadgir"],
"585221":[260,446,-1,"Balichakra, Yadgir"],
"585222":[60,682,-1,"Bhimanhalli, Kalaburagi"],
"585223":[295,793,-1,"Hattigudur, Yadgir"],
"585224":[365,1020,-1,"Baichbal, Yadgir"],
"585225":[200,1512,-1,"Ingalagi, Kalaburagi"],
"585226":[175,272,0.0,"Chatnalli, Bidar"],
"585227":[178,512,0.0,"Bemalkhed, Bidar"],
"585228":[240,1080,-1,"Bhankur, Kalaburagi"],
"585229":[122,737,-1,"Shahabad ACC, Kalaburagi"],
"585236":[360,1041,-1,"Chalgera, Kalaburagi"],
"585237":[450,1260,-1,"Yenniwadgera, Yadgir"],
"585265":[325,1291,-1,"Hasargundagi, Kalaburagi"],
"585287":[305,829,-1,"Mudbal, Yadgir"],
"585290":[310,929,-1,"Hunsihole, Yadgir"],
"585291":[255,620,-1,"Geddalmari, Yadgir"],
"585292":[122,737,-1,"Malkhed Road, Kalaburagi"],
"585301":[284,1033,-1,"Ankalga, Kalaburagi"],
"585302":[405,790,0.0,"Alund Bazar, Kalaburagi"],
"585303":[320,807,-1,"Biriyala B, Kalaburagi"],
"585304":[273,708,0.0,"Sharadahalli, Yadgir"],
"585305":[345,1191,0.1,"Garagapalli, Kalaburagi"],
"585306":[170,951,-1,"Ainapur, Kalaburagi"],
"585307":[50,1110,0.0,"Chandrampalli, Kalaburagi"],
"585308":[295,1044,-1,"Saradgi Battad, Kalaburagi"],
"585309":[300,892,-1,"Rajapur, Yadgir"],
"585310":[390,1351,-1,"Kalhangarga, Kalaburagi"],
"585311":[310,739,0.0,"Duttargaon, Kalaburagi"],
"585312":[148,1104,-1,"Mangalgi, Kalaburagi"],
"585313":[158,710,0.0,"Dongargaon, Kalaburagi"],
"585314":[365,706,0.0,"Tadola, Kalaburagi"],
"585315":[312,455,0.0,"Idloor, Yadgir"],
"585316":[380,844,0.0,"Bilgunda, Kalaburagi"],
"585317":[102,997,-1,"Belgumpa, Kalaburagi"],
"585318":[363,883,0.07,"Kadacherla, Kalaburagi"],
"585319":[280,346,-1,"Gundagurthi, Yadgir"],
"585320":[238,923,-1,"Karachked, Kalaburagi"],
"585321":[280,430,0.0,"Arkera K, Yadgir"],
"585322":[299,792,-1,"Nagur, Kalaburagi"],
"585323":[310,910,-1,"Ganganal, Yadgir"],
"585324":[196,959,-1,"Hudebeeranahalli, Kalaburagi"],
"585325":[295,672,-1,"Magingera, Kalaburagi"],
"585326":[220,290,0.0,"Bhandarkumta, Bidar"],
"585327":[220,341,0.0,"SASTAPUR BANGLA D, Bidar"],
"585328":[158,328,0.0,"Ambesangvi, Bidar"],
"585329":[145,479,0.0,"Kappargaon, Bidar"],
"585330":[182,367,0.0,"Hallikhed (K), Bidar"],
"585331":[178,512,0.0,"Nirgudi, Bidar"],
"585353":[182,414,0.0,"Kankatta, Bidar"],
"585355":[250,589,-1,"Bilhar, Yadgir"],
"585367":[122,737,-1,"Central University of KarnatakaKad, Kalaburagi"],
"585401":[178,512,0.0,"Bidar, Bidar"],
"585402":[184,506,0.0,"Gadgi, Bidar"],
"585403":[178,485,0.0,"Amlapur, Bidar"],
"585404":[265,318,0.17,"Kaplapur (A), Bidar"],
"585411":[178,512,0.0,"Bhatasangvi, Bidar"],
"585412":[171,516,0.0,"Banhalli, Bidar"],
"585413":[195,827,-1,"Kanji, Bidar"],
"585414":[165,300,0.0,"Chalakapur, Bidar"],
"585416":[178,512,0.0,"Halsi Tugaon, Bidar"],
"585417":[94,303,0.53,"Dongam (M), Bidar"],
"585418":[178,512,0.0,"Chandanhalli, Bidar"],
"585419":[379,2690,-1,"Chitta (K), Bidar"],
"585421":[178,512,0.0,"Chikli (J), Bidar"],
"585436":[178,512,0.0,"Bedkunda, Bidar"],
"585437":[178,512,0.0,"Harkud, Bidar"],
"585443":[178,512,0.0,"Karkyal, Bidar"],
"585444":[264,691,0.0,"Hupla, Bidar"],
"585445":[199,255,0.0,"Bhosga, Bidar"],
"585446":[158,307,0.0,"Khatak Chincholli, Bidar"],
"585447":[220,428,0.0,"Yakatpur, Bidar"],
"585448":[159,631,0.0,"Dabka CH, Bidar"],
"586101":[365,974,0.0,"Vijayapura, Vijayapura"],
"586103":[365,888,0.0,"Bhutnal, Vijayapura"],
"586104":[365,927,0.0,"Ittangihal, Vijayapura"],
"586108":[655,1426,-1,"Gunki, Vijayapura"],
"586109":[365,1096,0.0,"Vijayapura Jalanagar, Vijayapura"],
"586111":[500,1086,0.0,"Gubbewad (Indi), Vijayapura"],
"586112":[440,1686,-1,"Aliyabad, Vijayapura"],
"586113":[630,1898,-1,"Hokkundi, Vijayapura"],
"586114":[368,1214,-1,"Hubnur, Vijayapura"],
"586115":[410,1934,-1,"Otihal, Vijayapura"],
"586116":[360,1163,-1,"Hallur, Vijayapura"],
"586117":[285,725,-1,"Domanal, Vijayapura"],
"586118":[150,1072,-1,"Binjalbhavi, Vijayapura"],
"586119":[410,1063,0.0,"Kannal, Vijayapura"],
"586120":[310,1284,-1,"Handiganur, Vijayapura"],
"586121":[840,2118,-1,"Malghan, Vijayapura"],
"586122":[800,1774,-1,"Jumanal, Vijayapura"],
"586123":[300,1135,-1,"Gabsavalgi, Vijayapura"],
"586124":[504,1241,-1,"Bijjur, Vijayapura"],
"586125":[694,1970,-1,"Bolachikkalki (JKD), Vijayapura"],
"586127":[325,726,-1,"Ankalgi, Vijayapura"],
"586128":[775,2077,-1,"Asantapur, Vijayapura"],
"586129":[425,1251,-1,"Handargal, Vijayapura"],
"586130":[300,1002,-1,"Dashyal, Vijayapura"],
"586162":[440,1099,-1,"Lingadalli, Vijayapura"],
"586170":[702,2008,-1,"Jainapur, Vijayapura"],
"586201":[240,793,-1,"Almatti R.S., Vijayapura"],
"586202":[670,1424,-1,"Huvinhalli, Vijayapura"],
"586203":[380,1286,-1,"Byalal, Vijayapura"],
"586204":[520,1295,-1,"Jevoor, Vijayapura"],
"586205":[731,2054,-1,"Jeerankalgi, Vijayapura"],
"586206":[480,1152,-1,"Devar Navadagi, Vijayapura"],
"586207":[535,1102,0.0,"Dhulkhed, Vijayapura"],
"586208":[200,990,-1,"Hunshyal, Vijayapura"],
"586209":[500,874,-1,"Alur (Indi), Vijayapura"],
"586210":[534,1229,0.0,"Asangi Khurd, Vijayapura"],
"586211":[520,920,-1,"Bargudi, Vijayapura"],
"586212":[585,1319,-1,"Muddebihal Fort ND, Vijayapura"],
"586213":[240,630,-1,"Hebbal, Vijayapura"],
"586214":[405,1695,-1,"Bhantanur (TKT), Vijayapura"],
"586215":[635,2356,-1,"Chikrugi, Vijayapura"],
"586216":[285,1007,-1,"Angadgeri, Vijayapura"],
"586217":[720,1941,-1,"Khedgi, Vijayapura"],
"587101":[306,736,0.0,"Bagalkot, Bagalkot"],
"587102":[303,869,0.0,"Gaddankeri, Bagalkot"],
"587103":[305,736,0.0,"Haveli, Bagalkot"],
"587104":[307,742,0.0,"Murnal, Bagalkot"],
"587111":[305,736,0.0,"Niralkeri, Bagalkot"],
"587112":[530,2432,-1,"Belgal, Bagalkot"],
"587113":[198,1684,0.0,"Sorgaon, Bagalkot"],
"587114":[530,3310,-1,"Dhanakshirur, Bagalkot"],
"587115":[305,736,0.0,"Bodanaikanadinni, Bagalkot"],
"587116":[385,818,0.0,"Tolmatti, Bagalkot"],
"587117":[385,675,0.0,"Badagi, Bagalkot"],
"587118":[510,4092,-1,"Amaravati, Bagalkot"],
"587119":[685,1741,0.0,"Kadapatti, Bagalkot"],
"587120":[550,4322,-1,"Kadiwal Kallapur, Bagalkot"],
"587121":[630,1745,0.0,"Budni, Bagalkot"],
"587122":[198,1684,0.0,"Kadarkoppa, Bagalkot"],
"587124":[470,4560,-1,"Tallikeri, Bagalkot"],
"587125":[405,2490,-1,"Balkundi, Bagalkot"],
"587154":[470,4560,-1,"Gorbal, Bagalkot"],
"587155":[230,473,-1,"Belavalakoppa, Bagalkot"],
"587156":[305,736,0.0,"Shirur, Bagalkot"],
"587157":[459,1890,-1,"Kudalasangam, Bagalkot"],
"587201":[230,473,-1,"Chikmuchalgudda, Bagalkot"],
"587202":[440,1593,-1,"Mangalgudda, Bagalkot"],
"587203":[360,1032,-1,"Haunsnur, Bagalkot"],
"587204":[302,746,0.0,"Kundaragi, Bagalkot"],
"587205":[320,810,-1,"Hirebudihal, Bagalkot"],
"587206":[319,867,-1,"Hoolgeri, Bagalkot"],
"587207":[305,736,0.0,"Bilkerur, Bagalkot"],
"587301":[685,1741,0.0,"Jamkhandi, Bagalkot"],
"587311":[685,1741,0.0,"Jagadal, Bagalkot"],
"587312":[740,1181,0.0,"Nandgaon, Bagalkot"],
"587313":[198,1684,0.0,"Bidari, Bagalkot"],
"587314":[440,1201,0.0,"Rampur, Bagalkot"],
"587315":[685,1741,0.0,"Halingali, Bagalkot"],
"587316":[198,1684,0.0,"Madabhavi, Bagalkot"],
"587330":[685,1741,0.0,"Kalabilagi, Bagalkot"],
"587331":[290,1558,0.0,"Kullhalli, Bagalkot"],
"590001":[175,378,0.0,"Belagavi, Belagavi"],
"590003":[180,382,-1,"Belagavi Shahapur, Belagavi"],
"590005":[187,356,-1,"Dhamne, Belagavi"],
"590006":[192,337,0.0,"Angol, Belagavi"],
"590008":[192,320,0.0,"Mandoli, Belagavi"],
"590009":[170,256,0.0,"Belagavi Records MLI, Belagavi"],
"590010":[180,401,-1,"Kangrali KH, Belagavi"],
"590011":[175,358,0.0,"Hindawadi, Belagavi"],
"590014":[205,335,-1,"Desur, Belagavi"],
"590015":[210,480,-1,"Khanagaon, Belagavi"],
"590016":[192,405,-1,"Belagavi Bus Stand, Belagavi"],
"590017":[180,401,-1,"Vantmuri Colony Belagavi S. O, Belagavi"],
"590018":[170,274,0.0,"Santibastwad, Belagavi"],
"590019":[180,385,0.0,"Belagavi Vishweswaraih Nagar, Belagavi"],
"590020":[205,438,-1,"Halga, Belagavi"],
"590100":[175,373,0.0,"Kakati, Belagavi"],
"591101":[295,1016,-1,"Mallapur KA, Belagavi"],
"591102":[295,738,-1,"Bailhongal, Belagavi"],
"591103":[215,564,-1,"Modge, Belagavi"],
"591104":[203,381,0.0,"Hirebellikatti, Belagavi"],
"591106":[175,424,-1,"Kakkeri, Belagavi"],
"591107":[225,692,-1,"Aralikatti, Belagavi"],
"591108":[129,211,0.0,"Belagundi, Belagavi"],
"591109":[250,429,-1,"Ankalgi, Belagavi"],
"591110":[205,610,-1,"Chulaki, Belagavi"],
"591111":[290,471,-1,"Yakkundi, Belagavi"],
"591112":[199,390,-1,"Ambadgatti, Belagavi"],
"591113":[175,373,0.0,"Kakati, Belagavi"],
"591114":[345,620,-1,"Chandargi, Belagavi"],
"591115":[215,411,0.0,"Basarkod, Belagavi"],
"591117":[284,581,-1,"Mabnur, Belagavi"],
"591118":[242,466,-1,"Holehosur, Belagavi"],
"591119":[295,526,-1,"Nugganatti, Belagavi"],
"591120":[147,238,-1,"Halasal, Belagavi"],
"591121":[322,995,-1,"Gajminhal, Belagavi"],
"591122":[260,752,-1,"Mavanur, Belagavi"],
"591123":[205,482,-1,"Ramdurg, Belagavi"],
"591124":[192,484,-1,"Basvan Kudchi, Belagavi"],
"591125":[215,562,-1,"Bhavihal, Belagavi"],
"591126":[375,881,0.0,"Goravankolla, Belagavi"],
"591127":[409,832,0.0,"Avaradi, Belagavi"],
"591128":[170,277,0.0,"Turamari, Belagavi"],
"591129":[275,721,-1,"Kadabi, Belagavi"],
"591130":[402,902,-1,"Chilmur, Belagavi"],
"591131":[182,389,-1,"Badas Khalsa, Belagavi"],
"591136":[579,1400,-1,"Yaragudri, Belagavi"],
"591143":[205,394,-1,"Bombarge, Belagavi"],
"591147":[215,512,-1,"Mattikoppa, Belagavi"],
"591153":[268,523,-1,"Devara Shigihalli, Belagavi"],
"591156":[210,385,-1,"Hosavantmuri, Belagavi"],
"591173":[295,731,-1,"Ugargol, Belagavi"],
"591201":[360,1197,-1,"Chikodi, Belagavi"],
"591211":[345,657,-1,"Pangire (A), Belagavi"],
"591212":[600,1534,0.0,"Balligeri, Belagavi"],
"591213":[380,1292,-1,"Chandur, Belagavi"],
"591214":[365,855,0.0,"Shamanewadi, Belagavi"],
"591215":[342,615,0.0,"Adi, Belagavi"],
"591216":[365,930,0.0,"Janwad, Belagavi"],
"591217":[398,1039,-1,"Bhiradi, Belagavi"],
"591218":[317,992,-1,"Arabhavimath, Belagavi"],
"591219":[345,638,-1,"Galataga, Belagavi"],
"591220":[495,980,-1,"Khavtkoppa, Belagavi"],
"591221":[242,498,0.0,"Badakundri, Belagavi"],
"591222":[282,867,-1,"Belkud, Belagavi"],
"591223":[605,1085,0.0,"Kagvad, Belagavi"],
"591224":[375,944,-1,"Sangankeri, Belagavi"],
"591225":[291,536,0.0,"Akkiwat, Belagavi"],
"591226":[200,858,-1,"Vadral, Belagavi"],
"591227":[395,824,-1,"Honakuppi, Belagavi"],
"591228":[345,650,-1,"Sankanwadi, Belagavi"],
"591229":[259,438,0.0,"Hanchinal K.S., Belagavi"],
"591230":[755,1439,-1,"Badchi, Belagavi"],
"591231":[200,722,-1,"Melmanhatti, Belagavi"],
"591232":[1430,3096,0.0,"Siddewadi, Belagavi"],
"591233":[275,792,-1,"Betageri, Belagavi"],
"591234":[999,2204,0.0,"Lokur, Belagavi"],
"591235":[505,1235,-1,"Palbhavi, Belagavi"],
"591236":[240,709,-1,"Amminbhavi, Belagavi"],
"591237":[340,673,0.0,"Gondikuppi, Belagavi"],
"591238":[345,673,-1,"Walki, Belagavi"],
"591239":[352,856,-1,"Nej, Belagavi"],
"591240":[475,1399,-1,"Janwad, Belagavi"],
"591241":[292,560,0.0,"Hadnal, Belagavi"],
"591242":[765,1800,-1,"Ingali, Belagavi"],
"591243":[245,453,0.0,"Islampur, Belagavi"],
"591244":[360,1658,-1,"Malikwad, Belagavi"],
"591246":[152,372,0.0,"Yamakanmardi, Belagavi"],
"591247":[445,928,-1,"Basavanalgadde, Belagavi"],
"591248":[640,1427,-1,"Artal, Belagavi"],
"591254":[105,331,0.0,"Naganur KM, Belagavi"],
"591263":[352,604,0.0,"Dhonewadi, Belagavi"],
"591265":[697,1874,-1,"Halhalli, Belagavi"],
"591287":[342,606,-1,"Kuthali, Belagavi"],
"591301":[154,315,0.0,"Nagaragali, Belagavi"],
"591302":[102,355,-1,"Garalgunji, Belagavi"],
"591303":[757,1990,-1,"Mole, Belagavi"],
"591304":[615,1712,0.0,"Athani, Belagavi"],
"591305":[240,689,-1,"Jaganur, Belagavi"],
"591306":[260,703,-1,"Dhupdal, Belagavi"],
"591307":[260,1308,-1,"Gokak, Belagavi"],
"591308":[277,996,-1,"Gokak Falls, Belagavi"],
"591309":[200,472,-1,"Bastwad, Belagavi"],
"591310":[685,1634,-1,"Avaradi, Belagavi"],
"591311":[475,745,-1,"Khemalapur, Belagavi"],
"591312":[531,1137,-1,"Dharmatti, Belagavi"],
"591313":[385,602,0.0,"Hadalga, Belagavi"],
"591314":[240,569,0.0,"Sankeshwar College Road, Belagavi"],
"591315":[653,1341,0.0,"Shedbal R.S., Belagavi"],
"591316":[1157,1843,-1,"Molwad, Belagavi"],
"591317":[545,1002,-1,"Alagwadi, Belagavi"],
"591340":[200,543,0.0,"Kamatnur, Belagavi"],
"591344":[260,865,-1,"Benchinmardi, Belagavi"],
"591345":[82,143,0.0,"Kanakumbi, Belagavi"],
"591346":[205,556,-1,"Karvinkumpi, Belagavi"],
"600001":[295,1189,0.09,"Chennai G.P.O., Chennai"],
"600002":[290,1277,0.11,"Anna Road, Chennai"],
"600003":[290,1306,0.1,"Park Town, Chennai"],
"600004":[304,1015,0.1,"Mylapore, Chennai"],
"600005":[290,1375,0.09,"Chepauk, Chennai"],
"600006":[290,1209,0.12,"Greams Road, Chennai"],
"600007":[295,1226,0.1,"Vepery, Chennai"],
"600008":[300,1159,0.11,"EGMORE ND, Chennai"],
"600009":[290,1265,0.1,"Fort St George, Chennai"],
"600010":[300,1097,0.12,"Kilpauk, Chennai"],
"600011":[300,1121,0.16,"Sembiam, Chennai"],
"600012":[290,1131,0.09,"Perambur Barracks, Chennai"],
"600013":[290,1284,0.09,"Rayapuram, Chennai"],
"600014":[415,1032,0.2,"Royapettah, Chennai"],
"600015":[340,975,0.1,"Saidapet S.O (Chennai), Chennai"],
"600016":[350,1002,0.08,"St Thomas Mount, Chennai"],
"600017":[335,1028,0.11,"Thygarayanagar, Chennai"],
"600018":[300,1117,0.15,"Teynampet, Chennai"],
"600019":[304,1324,0.22,"Tiruvottiyur West, Thiruvallur"],
"600020":[340,987,0.1,"Shastri Nagar S.O (Chennai), Chennai"],
"600021":[288,1400,0.1,"Washermanpet East, Chennai"],
"600022":[335,1032,0.11,"Rajbhavan S.O (Chennai), Chennai"],
"600023":[295,1109,0.15,"Aynavaram, Chennai"],
"600024":[330,1026,0.12,"Kodambakkam, Chennai"],
"600025":[335,1032,0.11,"Engineering College S.O (Chennai), Chennai"],
"600026":[331,755,2.59,"Vadapalani, Chennai"],
"600028":[427,1429,0.13,"Raja Annamalaipuram, Chennai"],
"600030":[300,1045,0.12,"Shenoy Nagar, Chennai"],
"600031":[300,1120,0.11,"Chetput, Chennai"],
"600032":[340,982,0.12,"Guindy Industrial Estate, Chennai"],
"600033":[345,981,0.11,"West Mambalam, Chennai"],
"600034":[400,1600,0.05,"Loyola College, Chennai"],
"600035":[340,1018,0.1,"Nandanam, Chennai"],
"600036":[340,943,0.09,"Indian Institute Of Technology, Chennai"],
"600037":[295,1133,0.14,"Mogappair, Chennai"],
"600038":[300,1083,0.21,"Icf Colony, Chennai"],
"600039":[288,1293,0.11,"Vyasarpadi, Chennai"],
"600040":[308,1034,0.3,"Anna Nagar S.O (Chennai), Chennai"],
"600041":[330,921,0.13,"Palavakkam S.O (Kanchipuram), Chennai"],
"600042":[350,943,0.08,"Velacheri, Chennai"],
"600043":[410,1118,0.03,"Rajajinagar SO Kanchipuram, Chengalpattu"],
"600044":[385,978,0.02,"Nemilichery, Chengalpattu"],
"600045":[400,1063,0.02,"Tambaram, Chengalpattu"],
"600046":[309,664,0.24,"Tambaram IAF, Chengalpattu"],
"600047":[398,1028,0.02,"Kadaperi, Chengalpattu"],
"600048":[410,1015,0.02,"Mannivakkam, Chengalpattu"],
"600049":[300,1103,0.23,"Srinivasanagar, Chennai"],
"600050":[345,1124,0.14,"Padi, Chennai"],
"600051":[562,1526,1.04,"Madhavaram Milk Colony, Chennai"],
"600052":[310,1077,0.41,"Alamathi, Thiruvallur"],
"600053":[304,1285,0.19,"Ambattur, Chennai"],
"600054":[320,1172,0.17,"Avadi Camp, Thiruvallur"],
"600055":[530,1385,0.04,"Koduvalli, Thiruvallur"],
"600056":[382,1079,0.09,"Kattupakkam, Thiruvallur"],
"600057":[537,1518,0.88,"Kamarajnagar, Thiruvallur"],
"600058":[319,1114,0.16,"Athipattu, Chennai"],
"600059":[398,1183,0.02,"LIC Colony, Chengalpattu"],
"600060":[324,1096,0.15,"Vadaperumbakkam, Chennai"],
"600061":[495,1133,1.64,"Pazhavanthangal, Chennai"],
"600062":[290,1119,0.2,"Kovilpadagai, Thiruvallur"],
"600063":[408,1018,0.02,"Old Perungalathur, Chengalpattu"],
"600064":[297,596,0.02,"Hasthinapuram, Chengalpattu"],
"600066":[345,1061,0.21,"Pozhal, Chennai"],
"600067":[420,968,0.51,"Erumaivettipalayam, Thiruvallur"],
"600068":[350,1303,0.09,"Manali SO Tiruvallur, Chennai"],
"600069":[408,1100,0.03,"Sirukalathur, Kanchipuram"],
"600070":[375,1002,0.08,"Anakaputhur, Chengalpattu"],
"600071":[375,1195,0.19,"Paruthipattu, Thiruvallur"],
"600072":[500,1286,0.05,"Arignar Anna Nagar, Thiruvallur"],
"600073":[390,992,0.02,"Rajakilpakkam, Chengalpattu"],
"600074":[345,1001,0.06,"Polichalur, Chengalpattu"],
"600075":[340,999,0.06,"Pammal East, Chengalpattu"],
"600076":[300,1136,0.19,"Korattur RS, Chennai"],
"600077":[382,1043,0.12,"Numbal, Thiruvallur"],
"600078":[340,914,0.09,"Kalaignar Karunanidhi Nagar, Chennai"],
"600081":[300,1349,0.18,"Tondiarpet Bazaar, Chennai"],
"600082":[300,1122,0.16,"Kumaran Nagar, Chennai"],
"600083":[345,988,0.11,"Ashoknagar S.O (Chennai), Chennai"],
"600084":[300,1161,0.11,"Flowers Road, Chennai"],
"600085":[340,980,0.1,"Kotturpuram, Chennai"],
"600086":[335,1032,0.11,"Gopalapuram S.O (Chennai), Chennai"],
"600087":[340,1019,0.13,"Alwarthirunagar, Chennai"],
"600088":[246,505,0.12,"Adambakkam, Chennai"],
"600089":[350,1036,0.09,"Ramapuram S.O (Kanchipuram), Chennai"],
"600090":[345,996,0.08,"Rajaji Bhavan, Chennai"],
"600091":[152,401,-1,"Madipakkam, Chennai"],
"600092":[340,1000,0.13,"Virugambakkam, Chennai"],
"600093":[340,907,0.09,"Saligramam, Chennai"],
"600094":[370,1518,0.04,"Choolaimedu, Chennai"],
"600095":[340,997,0.12,"Vanagaram, Thiruvallur"],
"600096":[335,899,0.08,"Perungudi, Chennai"],
"600097":[360,954,0.04,"Karapakkam, Chennai"],
"600099":[50,131,-1,"Lakshmipuram, Chennai"],
"600100":[360,1127,0.02,"Medavakkam, Chengalpattu"],
"600101":[308,1040,0.32,"Anna Nagar Western Extn, Chennai"],
"600102":[304,1062,0.18,"Anna Nagar East, Chennai"],
"600103":[300,1188,0.42,"Andarkuppam, Thiruvallur"],
"600104":[290,1231,0.1,"High Court Building S.O (Chennai), Chennai"],
"600106":[304,1016,0.19,"Arumbakkam, Chennai"],
"600107":[335,1041,0.2,"Koyambedu Wholesale Mkt, Chennai"],
"600110":[556,1537,0.98,"Ponniammanmedu, Thiruvallur"],
"600113":[335,933,0.11,"Dr Ambedkar Law Univeristy, Chennai"],
"600115":[340,939,0.08,"Injambakkam, Chennai"],
"600116":[382,1047,0.11,"Alapakkam, Chennai"],
"600117":[335,974,0.05,"Keelakattalai, Chengalpattu"],
"600118":[300,1151,0.13,"Erukkancheri, Chennai"],
"600119":[372,968,0.02,"Sholinganallur, Chennai"],
"600120":[270,1270,1.19,"Nandiambakkam, Thiruvallur"],
"600122":[400,1052,0.08,"Paraniputhur, Kanchipuram"],
"600123":[408,1130,0.04,"Malayambakkam, Thiruvallur"],
"600124":[400,1329,0.05,"Nemam, Thiruvallur"],
"600125":[335,964,0.05,"Manapakkam, Chennai"],
"600126":[392,1016,0.01,"Mappedu, Chengalpattu"],
"600127":[403,999,0.02,"Kolapakkam, Chengalpattu"],
"600128":[405,1068,0.03,"Thandalam, Kanchipuram"],
"600129":[360,1037,0.03,"Kovilambakkam, Chengalpattu"],
"600130":[337,656,0.04,"Navalur, Chengalpattu"],
"600131":[390,967,0.02,"SITHALAPAKKAM, Chengalpattu"],
"600132":[178,494,0.0,"Tiruneermalai, Kanchipuram"],
"600133":[410,1094,0.03,"Somangalam, Thiruvallur"],
"600200":[300,1125,0.11,"EGMORE ND, Chennai"],
"600201":[350,1004,0.08,"St Thomas Mount, Chennai"],
"600202":[330,929,0.12,"Palavakkam S.O (Kanchipuram), Chennai"],
"601101":[280,675,0.38,"Pondavakkam, Thiruvallur"],
"601102":[280,672,0.28,"Athivakkam, Thiruvallur"],
"601103":[350,1399,0.04,"Damaraipakkam, Thiruvallur"],
"601201":[280,781,1.94,"Mangavaram, Thiruvallur"],
"601202":[250,338,0.04,"Manellore, Thiruvallur"],
"601203":[270,1123,1.14,"Devadanam, Thiruvallur"],
"601204":[275,811,1.6,"Uthandikandigai, Thiruvallur"],
"601205":[270,738,2.59,"Kolur, Thiruvallur"],
"601206":[270,721,1.42,"Kilmudalambedu, Thiruvallur"],
"601301":[410,1080,0.02,"Malaipattu, Kanchipuram"],
"602001":[350,1392,0.04,"Tiruvallur, Thiruvallur"],
"602002":[350,1222,0.17,"Melnallathur, Thiruvallur"],
"602003":[350,1300,0.09,"Kakalur Ind Estate, Thiruvallur"],
"602021":[350,1141,0.02,"Perattur, Thiruvallur"],
"602023":[420,1271,0.02,"Sandarayanpalayam, Thiruvallur"],
"602024":[350,1361,0.06,"Vadattur, Thiruvallur"],
"602025":[350,1248,0.12,"Kalambakkam, Thiruvallur"],
"602026":[333,835,0.0,"Pennaluripeta, Thiruvallur"],
"602105":[610,1697,0.06,"Thodukadu, Kanchipuram"],
"602106":[465,1211,0.02,"Sendamangalam, Kanchipuram"],
"602108":[610,1788,0.05,"Kandoor, Kanchipuram"],
"602117":[520,1469,0.02,"Irungattukottai, Kanchipuram"],
"602118":[365,754,0.05,"Oragadam, Kanchipuram"],
"603001":[383,726,0.06,"Chengalpattu, Chengalpattu"],
"603002":[375,746,0.05,"Paranur, Chengalpattu"],
"603003":[375,795,0.08,"Meleripakkam, Chengalpattu"],
"603004":[342,736,0.07,"Ammanambakkam, Chengalpattu"],
"603101":[392,849,0.07,"Reddipalayam, Chengalpattu"],
"603102":[327,649,0.02,"Manamai, Chengalpattu"],
"603103":[265,449,0.14,"Pudupakkam, Chengalpattu"],
"603104":[365,440,0.06,"Kokilamedu, Chengalpattu"],
"603105":[342,757,0.06,"Sirudavur, Chengalpattu"],
"603106":[375,772,0.04,"Tiruvanaikoil, Kanchipuram"],
"603107":[368,572,0.03,"Kilakadi, Kanchipuram"],
"603108":[342,661,0.05,"Kalvoy, Chengalpattu"],
"603109":[329,650,0.04,"Mullikolathur, Chengalpattu"],
"603110":[390,887,0.02,"Illalur, Chengalpattu"],
"603111":[384,724,0.05,"Meyyur, Chengalpattu"],
"603112":[240,804,0.02,"Thiruvidanthai, Chengalpattu"],
"603127":[360,1037,0.03,"Anupuram, Chengalpattu"],
"603201":[410,751,0.02,"Kattukaranai, Chengalpattu"],
"603202":[383,726,0.06,"Kayarambedu, Chengalpattu"],
"603203":[383,726,0.06,"Ninnakarai, Chengalpattu"],
"603204":[375,821,0.08,"Melrosapuram, Chengalpattu"],
"603209":[410,1085,0.03,"Panangottur, Chengalpattu"],
"603210":[402,995,0.02,"Madurai Meenakshipuram, Chengalpattu"],
"603211":[360,1037,0.03,"Annai Anjugam Nagar, Chengalpattu"],
"603301":[410,751,0.02,"Kayapakkam, Chengalpattu"],
"603302":[333,606,0.06,"Palaiyur, Chengalpattu"],
"603303":[410,751,0.02,"Malayalipettai, Chengalpattu"],
"603304":[333,606,0.06,"Kolathur, Chengalpattu"],
"603305":[410,751,0.02,"Seekanankuppam, Chengalpattu"],
"603306":[410,751,0.02,"Thatchur, Chengalpattu"],
"603307":[530,842,0.03,"Sirudamur, Chengalpattu"],
"603308":[375,680,0.05,"Isur, Chengalpattu"],
"603309":[400,690,0.02,"Chitrvadi, Chengalpattu"],
"603310":[385,771,0.03,"Ayakonamkolathur, Chengalpattu"],
"603311":[410,709,0.02,"Peria Venmani, Chengalpattu"],
"603312":[368,663,0.05,"KNelvoy, Chengalpattu"],
"603313":[333,606,0.06,"Nugumbal, Chengalpattu"],
"603314":[495,1534,0.17,"Kattiampandal, Kanchipuram"],
"603319":[383,726,0.06,"Sendivakkam, Chengalpattu"],
"603401":[250,465,0.12,"Puthirankottai, Chengalpattu"],
"603402":[495,1527,0.17,"Alisoor, Kanchipuram"],
"603403":[495,1469,0.16,"R.N.Kandigai, Kanchipuram"],
"603405":[383,726,0.06,"Ponpathirkoodam, Chengalpattu"],
"603406":[495,1534,0.17,"Kammalampoondi, Kanchipuram"],
"604001":[663,1904,-1,"Tindivanam, Villupuram"],
"604101":[663,1918,0.03,"Andapattu, Villupuram"],
"604102":[663,2114,-1,"Molasur, Villupuram"],
"604151":[360,668,0.0,"Kalleri, Villupuram"],
"604152":[385,859,0.03,"Thadagam, Villupuram"],
"604153":[360,626,0.0,"Pakkam, Villupuram"],
"604154":[485,1569,-1,"Olagapuram, Villupuram"],
"604201":[490,1023,0.07,"Melvailamur, Villupuram"],
"604202":[370,894,0.0,"Melacheri, Villupuram"],
"604203":[300,1223,0.41,"Viranamur, Villupuram"],
"604204":[465,927,0.04,"Eyyakunam, Villupuram"],
"604205":[395,825,0.0,"Kappai, Villupuram"],
"604206":[425,809,0.0,"Modaiyur, Villupuram"],
"604207":[493,1138,-1,"Dadapuram, Villupuram"],
"604208":[470,958,0.03,"Devandavadi, Villupuram"],
"604210":[395,820,0.0,"Mahadevimangalam, Villupuram"],
"604301":[380,889,0.13,"Siruvadi, Villupuram"],
"604302":[555,1653,-1,"Karnavur, Villupuram"],
"604303":[239,428,0.24,"Nadukuppam, Villupuram"],
"604304":[535,1568,0.0,"Eraiyur, Villupuram"],
"604305":[530,1355,0.03,"Nallathur, Villupuram"],
"604306":[493,1184,-1,"Thenputhur, Villupuram"],
"604307":[555,1873,0.03,"Melpettai, Villupuram"],
"604401":[450,993,0.02,"Elaneerkundram, Tiruvannamalai"],
"604402":[635,1178,0.02,"Vadamanapakkam, Tiruvannamalai"],
"604403":[410,1186,0.04,"Badur, Tiruvannamalai"],
"604404":[635,1178,0.02,"Echur, Tiruvannamalai"],
"604405":[500,1257,0.04,"Nelliyankulam, Tiruvannamalai"],
"604406":[452,761,0.02,"Nallur, Tiruvannamalai"],
"604407":[290,757,0.02,"Cheyyar, Tiruvannamalai"],
"604408":[485,1140,0.0,"Manganallur, Tiruvannamalai"],
"604409":[635,1178,0.02,"Vadathinallur, Tiruvannamalai"],
"604410":[635,1178,0.02,"Pillanthangal, Tiruvannamalai"],
"604411":[635,1176,0.02,"Ponnur, Tiruvannamalai"],
"604501":[485,1300,0.05,"Arunthodu, Tiruvannamalai"],
"604502":[350,924,0.01,"Melachery, Tiruvannamalai"],
"604503":[500,1071,0.03,"Melmattaivinnamangalam, Tiruvannamalai"],
"604504":[350,924,0.01,"Anmarudai, Tiruvannamalai"],
"604505":[300,855,0.02,"Ayalpadi, Tiruvannamalai"],
"604601":[747,1429,1.64,"Erumpoondi, Tiruvannamalai"],
"605001":[400,1126,0.0,"Pondicherry, Pondicherry"],
"605002":[400,1109,0.0,"Sri Aurobindo Ashram, Pondicherry"],
"605003":[400,1098,0.0,"Muthialpet, Pondicherry"],
"605004":[380,1087,0.0,"Mouroungapakkam, Pondicherry"],
"605005":[380,1071,0.0,"Nellithope, Pondicherry"],
"605006":[400,1075,0.0,"Dhanvantri Nagar, Pondicherry"],
"605007":[400,1079,0.0,"Nallavadu, Pondicherry"],
"605008":[400,1093,0.0,"Lawspet, Pondicherry"],
"605009":[400,1070,0.0,"Mouttoupalayam, Pondicherry"],
"605010":[400,1044,0.0,"Olugarai, Pondicherry"],
"605011":[400,1114,0.0,"Venkata Nagar, Pondicherry"],
"605012":[400,1127,0.0,"Pondicherry, Pondicherry"],
"605013":[400,1104,0.0,"SaramPy, Pondicherry"],
"605014":[410,874,0.0,"Kilpudupattu, Villupuram"],
"605101":[420,1043,0.0,"Kuilapalayam, Villupuram"],
"605102":[400,1069,0.0,"Ariyur, Pondicherry"],
"605103":[394,868,0.53,"Melpathi, Villupuram"],
"605104":[380,1029,0.0,"Bommayarpalayam, Villupuram"],
"605105":[366,876,0.0,"Kallipattu, Villupuram"],
"605106":[415,1013,-1,"Pakkam, Villupuram"],
"605107":[423,1014,0.0,"Thirubuvanai, Pondicherry"],
"605108":[416,992,0.0,"Kumarakuppam, Villupuram"],
"605109":[556,1452,0.0,"Olundiyapattu, Villupuram"],
"605110":[380,924,0.0,"Arumparthapuram, Pondicherry"],
"605111":[420,1029,0.0,"Irumbai, Villupuram"],
"605201":[355,805,0.51,"Karuvakshi, Villupuram"],
"605202":[342,904,0.48,"Porur, Villupuram"],
"605203":[435,880,0.36,"Asokapuri, Villupuram"],
"605301":[338,1011,0.62,"Kondangi, Villupuram"],
"605302":[332,1049,0.81,"Kangiyanur, Villupuram"],
"605401":[364,904,0.69,"Kandamanadi, Villupuram"],
"605402":[340,1004,0.63,"Palliandur, Villupuram"],
"605403":[342,904,0.48,"Salamedu, Villupuram"],
"605501":[378,875,0.0,"Kodukkur, Villupuram"],
"605502":[420,1020,0.0,"Kadaperikuppam, Villupuram"],
"605601":[485,1198,0.25,"Ayyur Agaram, Villupuram"],
"605602":[384,905,0.56,"VILUPPURAM, Villupuram"],
"605651":[425,786,0.0,"Pidaripattu, Villupuram"],
"605652":[509,1159,0.0,"TPudupalayam, Villupuram"],
"605701":[295,1013,0.99,"Alambadi, Villupuram"],
"605702":[465,900,0.02,"Pounjipattu, Kallakurichi"],
"605751":[440,1284,0.07,"Cholavandipuram, Kallakurichi"],
"605752":[300,1271,0.34,"V . Puthur, Villupuram"],
"605754":[495,1234,0.15,"Kangeyanur, Kallakurichi"],
"605755":[295,949,1.19,"Ayandur, Villupuram"],
"605756":[370,1325,0.11,"Kottamarudur, Villupuram"],
"605757":[300,1346,0.2,"Tirukkoyilur, Kallakurichi"],
"605758":[300,1212,0.49,"Oddampattu, Villupuram"],
"605759":[300,1315,0.25,"T Athipakkam, Kallakurichi"],
"605766":[468,1322,0.11,"Kattupaiyur, Kallakurichi"],
"605801":[465,1074,0.02,"Endal, Kallakurichi"],
"605802":[496,1208,0.2,"Sirpadanallur, Kallakurichi"],
"605803":[295,1085,0.76,"Arunkurukkai, Villupuram"],
"606001":[202,505,0.01,"Vriddhachalam, Cuddalore"],
"606003":[202,481,0.01,"Ko Adhanur, Cuddalore"],
"606102":[371,966,0.31,"Kuvagam, Kallakurichi"],
"606103":[220,492,0.11,"Kathazhai, Cuddalore"],
"606104":[355,872,0.0,"Mathur, Cuddalore"],
"606105":[165,344,0.0,"Murugangudi, Cuddalore"],
"606106":[518,921,0.13,"Akkanur, Cuddalore"],
"606107":[435,968,0.0,"Pu killanur, Kallakurichi"],
"606108":[570,1167,0.13,"Malayanur, Cuddalore"],
"606109":[550,1345,0.02,"Vallimaduram, Cuddalore"],
"606110":[188,385,0.0,"Sathiyavadi, Cuddalore"],
"606111":[261,553,0.06,"Tiruvattathurai, Cuddalore"],
"606115":[455,857,0.0,"Senkurichi, Kallakurichi"],
"606201":[422,883,0.01,"Pethanur, Kallakurichi"],
"606202":[430,1050,0.01,"Kallakurichi, Kallakurichi"],
"606203":[430,1267,0.01,"Porasakurichi, Kallakurichi"],
"606204":[490,1249,0.01,"Ammakalathur, Kallakurichi"],
"606205":[437,1205,0.01,"Sathaputhur, Kallakurichi"],
"606206":[430,1417,0.01,"Madur, Kallakurichi"],
"606207":[440,1016,0.01,"Kachirapalayam, Kallakurichi"],
"606208":[452,1133,0.01,"Manjaputhur, Kallakurichi"],
"606209":[445,864,0.02,"Thoradipattu, Kallakurichi"],
"606213":[434,1110,0.01,"Agarakottalam, Kallakurichi"],
"606301":[470,1035,0.02,"Karunthalakurichi, Kallakurichi"],
"606302":[454,1059,0.07,"Varambanur, Cuddalore"],
"606303":[600,1071,-1,"Eluthur, Cuddalore"],
"606304":[539,1181,0.13,"Nithinatham, Cuddalore"],
"606305":[420,1090,0.02,"T.Mavidanthal, Kallakurichi"],
"606401":[452,1021,0.02,"Pootai, Kallakurichi"],
"606402":[452,992,0.01,"Ravathanallur, Kallakurichi"],
"606601":[410,920,0.01,"Tiruvannamalai, Tiruvannamalai"],
"606603":[410,920,0.01,"Nallavanpalayam, Tiruvannamalai"],
"606604":[410,920,0.01,"Durgainammiyandal, Tiruvannamalai"],
"606611":[410,920,0.01,"Kilnachipattu, Tiruvannamalai"],
"606701":[370,979,0.02,"Chennasamudram, Tiruvannamalai"],
"606702":[518,1139,0.03,"Kallarai Padi, Tiruvannamalai"],
"606703":[348,886,0.0,"Melvanakakambadi, Tiruvannamalai"],
"606704":[410,1080,0.01,"Melmudiyanur, Tiruvannamalai"],
"606705":[518,1139,0.03,"Munnurmangalam, Tiruvannamalai"],
"606706":[518,1139,0.03,"S Sorpanandal, Tiruvannamalai"],
"606707":[518,1139,0.03,"Kilsirupakkam, Tiruvannamalai"],
"606708":[538,1233,0.02,"Bhimarapatti, Tiruvannamalai"],
"606709":[518,1139,0.03,"Pakkiripalayam, Tiruvannamalai"],
"606710":[450,917,0.01,"Kallathur, Tiruvannamalai"],
"606751":[382,697,0.05,"Kalur, Tiruvannamalai"],
"606752":[430,992,0.03,"Nookambadi, Tiruvannamalai"],
"606753":[328,672,0.01,"Palayanur, Tiruvannamalai"],
"606754":[354,990,0.56,"Olaipadi, Tiruvannamalai"],
"606755":[718,1725,0.03,"Chellankuppam, Tiruvannamalai"],
"606801":[500,1030,0.03,"Ulagampattu, Tiruvannamalai"],
"606802":[500,1030,0.03,"Periyakilambadi, Tiruvannamalai"],
"606803":[333,833,0.0,"Athimoor Tindivanam, Tiruvannamalai"],
"606804":[495,1122,0.0,"Andampallam, Tiruvannamalai"],
"606805":[500,1030,0.03,"Kalasthambadi, Tiruvannamalai"],
"606806":[495,1175,0.2,"Chinnakallapadi, Tiruvannamalai"],
"606807":[500,1030,0.03,"Melathangal, Tiruvannamalai"],
"606808":[500,1030,0.03,"Kolakudi, Tiruvannamalai"],
"606811":[422,931,0.01,"Thachampattu, Tiruvannamalai"],
"606901":[370,798,0.0,"Kanthapalayam, Tiruvannamalai"],
"606902":[450,1092,0.04,"Budamangalam, Tiruvannamalai"],
"606903":[282,339,0.02,"Kalvasal, Tiruvannamalai"],
"606904":[370,798,0.0,"Allialamangalam, Tiruvannamalai"],
"606905":[398,1435,0.31,"Kesavapuram, Tiruvannamalai"],
"606906":[375,668,0.05,"Siruvallur, Tiruvannamalai"],
"606907":[280,1340,0.0,"Kelur, Tiruvannamalai"],
"606908":[373,731,0.03,"Thenmahadevamangalam, Tiruvannamalai"],
"607001":[420,1185,0.0,"Cuddalore, Cuddalore"],
"607002":[410,1091,0.0,"Tirupadiripuliyur, Cuddalore"],
"607003":[340,800,0.0,"Vellakarai, Cuddalore"],
"607004":[375,1024,0.0,"M.Pudur, Cuddalore"],
"607005":[340,726,0.0,"Sangolikuppam, Cuddalore"],
"607006":[415,990,0.0,"Gundu Uppalavadi, Cuddalore"],
"607101":[311,525,0.0,"Kudimiyankuppam, Cuddalore"],
"607102":[235,458,-1,"Badrakottai, Cuddalore"],
"607103":[228,367,0.12,"Melmampattu, Cuddalore"],
"607104":[347,823,0.0,"Kalinjikuppam, Cuddalore"],
"607105":[340,728,0.0,"Kilarungunam, Cuddalore"],
"607106":[244,411,0.04,"Sathipattu, Cuddalore"],
"607107":[374,990,0.47,"Arasur, Villupuram"],
"607108":[317,494,-1,"Bandarakottai, Cuddalore"],
"607109":[420,930,0.0,"Gunamangalam, Cuddalore"],
"607112":[323,770,0.0,"Maligaimedu, Cuddalore"],
"607201":[430,1016,0.01,"Periyakurukkai, Kallakurichi"],
"607202":[430,1248,0.01,"Pugaipatti, Kallakurichi"],
"607203":[340,1007,0.66,"Emappur, Villupuram"],
"607204":[469,817,0.0,"Parikkal, Kallakurichi"],
"607205":[351,709,0.0,"Akkadavalli, Cuddalore"],
"607209":[377,1056,0.41,"Saravanapakkam, Villupuram"],
"607301":[268,584,0.04,"Ambalavananpettai, Cuddalore"],
"607302":[255,629,0.08,"Pethanaickenkuppam, Cuddalore"],
"607303":[250,567,0.17,"Maruvai, Cuddalore"],
"607308":[250,465,0.12,"Gandhi Nagar S.O (Cuddalore), Cuddalore"],
"607401":[340,774,0.0,"Sundaravandi, Cuddalore"],
"607402":[415,960,0.0,"Seliyamedu, Pondicherry"],
"607403":[380,1011,0.0,"Reddichavadi, Cuddalore"],
"607801":[245,432,0.11,"Block 10neyveli, Cuddalore"],
"607802":[250,686,0.13,"A.Kuravankuppam, Cuddalore"],
"607803":[245,437,0.11,"Block 26 Neyveli, Cuddalore"],
"607804":[235,507,0.01,"Uttangal, Cuddalore"],
"607805":[215,374,0.11,"Iruppu, Cuddalore"],
"607807":[240,444,0.07,"Neyveli II Thermal Station, Cuddalore"],
"608001":[320,2013,0.08,"Chidambaram, Cuddalore"],
"608002":[348,1505,0.22,"Sivapuri, Cuddalore"],
"608102":[384,1028,0.39,"Nanjamahathuvazkai, Cuddalore"],
"608201":[265,957,0.0,"Ayyanur Akkaramangalam, Cuddalore"],
"608301":[277,676,0.18,"Arantangi, Cuddalore"],
"608302":[375,1447,0.24,"C.Arasur, Cuddalore"],
"608303":[399,1351,0.29,"Elleri, Cuddalore"],
"608304":[240,679,0.07,"Kanjankollai, Cuddalore"],
"608305":[320,910,0.1,"Terkuviruthangam, Cuddalore"],
"608306":[235,665,0.18,"Kunjimedu, Cuddalore"],
"608401":[320,1530,0.12,"Athipatu, Cuddalore"],
"608501":[348,959,0.3,"B.Adivaraganallur, Cuddalore"],
"608502":[375,1016,0.42,"Ariyakoshti, Cuddalore"],
"608601":[260,731,0.12,"B.Odaiyur, Cuddalore"],
"608602":[375,1327,0.22,"Ennanagaram, Cuddalore"],
"608701":[217,593,-1,"Sholathiram, Cuddalore"],
"608702":[228,499,0.32,"Agara Alambadi, Cuddalore"],
"608703":[200,417,0.0,"Kozhai, Cuddalore"],
"608704":[255,685,0.12,"Ambapuram, Cuddalore"],
"608801":[340,761,0.28,"Periyakuppam, Cuddalore"],
"608901":[165,398,0.0,"Attukurichi, Ariyalur"],
"609001":[543,1307,0.14,"Mayiladuthurai, Mayiladuthurai"],
"609003":[474,1145,0.12,"Koranad South, Mayiladuthurai"],
"609101":[375,1825,0.19,"Alakkudi, Mayiladuthurai"],
"609102":[320,1646,0.08,"Hanumanthapuram, Mayiladuthurai"],
"609103":[372,912,1.03,"Keelamaruthandanallur, Mayiladuthurai"],
"609104":[370,1226,1.4,"Kannukiniyanar Koil, Mayiladuthurai"],
"609105":[195,494,5.47,"Kaveripattinam Beach, Mayiladuthurai"],
"609106":[318,955,2.3,"Perunthottam, Mayiladuthurai"],
"609107":[195,495,4.52,"Talachangadu, Mayiladuthurai"],
"609108":[320,1505,0.1,"Erukkur, Mayiladuthurai"],
"609109":[322,990,2.12,"Annamperumalkoil, Mayiladuthurai"],
"609110":[362,1162,1.56,"Sirkali, Mayiladuthurai"],
"609111":[363,1165,1.55,"Arappakkam, Mayiladuthurai"],
"609112":[327,818,1.47,"Mannipallam, Mayiladuthurai"],
"609113":[329,999,0.18,"Koolaiyar, Mayiladuthurai"],
"609114":[190,444,6.0,"Radhanallur (TVG), Mayiladuthurai"],
"609115":[299,982,2.16,"Keeranallur, Mayiladuthurai"],
"609116":[320,795,0.18,"Nemmeli(SRK), Mayiladuthurai"],
"609117":[200,876,2.95,"Athukudi, Mayiladuthurai"],
"609118":[387,905,0.98,"Alaveli, Mayiladuthurai"],
"609201":[280,-1,0.01,"Talanayar Vsk, Mayiladuthurai"],
"609202":[329,971,0.18,"Kiloy, Mayiladuthurai"],
"609203":[453,1090,0.13,"Kanganamputhur, Mayiladuthurai"],
"609204":[349,861,0.09,"Athur, Mayiladuthurai"],
"609205":[320,866,0.18,"Pulavanur, Mayiladuthurai"],
"609301":[195,479,3.74,"Kalamanallur, Mayiladuthurai"],
"609302":[420,728,0.08,"Muthur, Mayiladuthurai"],
"609303":[432,580,0.14,"Kattuchery, Mayiladuthurai"],
"609304":[195,713,2.85,"Karuvazhakarai, Mayiladuthurai"],
"609305":[398,946,0.86,"Mannampandal, Mayiladuthurai"],
"609306":[420,613,0.06,"Tiruvilayattam, Mayiladuthurai"],
"609307":[200,552,0.74,"Porayar Market, Mayiladuthurai"],
"609308":[350,477,0.05,"Nalluchery, Mayiladuthurai"],
"609309":[195,733,2.67,"Memathur, Mayiladuthurai"],
"609310":[200,403,1.45,"Tiruvidaikali, Mayiladuthurai"],
"609311":[420,-1,0.01,"Tirumeignanam, Mayiladuthurai"],
"609312":[280,350,0.01,"Eduthukatti, Mayiladuthurai"],
"609313":[432,-1,0.11,"Manickapangu, Mayiladuthurai"],
"609314":[350,-1,0.01,"Kodangudi, Mayiladuthurai"],
"609401":[280,-1,0.0,"Valuvur, Mayiladuthurai"],
"609402":[448,722,0.15,"Perambur, Mayiladuthurai"],
"609403":[260,684,0.06,"Keeranur, Thiruvarur"],
"609404":[260,965,0.1,"Manganallur, Mayiladuthurai"],
"609405":[200,514,0.02,"Tirumeichur, Thiruvarur"],
"609501":[260,673,0.06,"Vilagam, Thiruvarur"],
"609502":[328,841,0.07,"Alangudi, Thiruvarur"],
"609503":[303,691,0.06,"Agarathirumalam, Thiruvarur"],
"609504":[327,858,0.08,"Panangudi, Thiruvarur"],
"609601":[280,299,0.01,"Nallambal, Karaikal"],
"609602":[420,-1,0.01,"Dharmapuram, Karaikal"],
"609603":[280,-1,0.01,"Nallathur, Karaikal"],
"609604":[432,562,0.13,"Alathur, Nagapattinam"],
"609605":[280,-1,0.01,"Karaikoilpathu, Karaikal"],
"609606":[600,1905,0.16,"T.R.Pattinam South, Karaikal"],
"609607":[350,-1,0.01,"Vizhithiyur, Karaikal"],
"609608":[260,357,0.01,"Menangudi, Thiruvarur"],
"609609":[280,463,0.01,"Tiruvettakudi, Karaikal"],
"609701":[433,968,0.05,"Pakkamkottur, Nagapattinam"],
"609702":[450,743,0.01,"Polagam, Nagapattinam"],
"609703":[445,966,0.19,"Agara Kondagai, Nagapattinam"],
"609704":[480,1065,0.18,"Pillali, Nagapattinam"],
"609801":[380,901,0.08,"Madirimangalam, Mayiladuthurai"],
"609802":[370,791,0.05,"Tirukodikaval, Thanjavur"],
"609803":[370,775,0.05,"Tiruvavaduthurai, Mayiladuthurai"],
"609804":[370,802,0.07,"Kanjanur, Thanjavur"],
"609805":[320,851,0.08,"Kozhaiyur, Mayiladuthurai"],
"609806":[385,1142,0.1,"Vanathirajapuram, Mayiladuthurai"],
"609807":[370,797,0.05,"Konulampallam, Thanjavur"],
"609808":[370,803,0.07,"Terizhandur, Mayiladuthurai"],
"609810":[380,828,0.06,"Tiruvalangadu, Mayiladuthurai"],
"609811":[320,790,0.06,"Namasivayapuram, Mayiladuthurai"],
"610001":[600,1696,0.16,"Tiruvarur, Thiruvarur"],
"610003":[600,1774,0.16,"Kekkarai, Thiruvarur"],
"610004":[600,1649,0.16,"Vilamal, Thiruvarur"],
"610005":[600,1515,0.16,"Selvapuram, Thiruvarur"],
"610101":[600,1718,0.16,"Palayavalam, Thiruvarur"],
"610102":[320,1076,0.06,"Kandodathavanitham, Thiruvarur"],
"610103":[541,1544,0.12,"Authur, Thiruvarur"],
"610104":[270,1124,0.1,"ELVANGARGUDI, Thiruvarur"],
"610105":[230,723,0.06,"Achuthamangalam, Thiruvarur"],
"610106":[600,1945,0.16,"Alivalam, Thiruvarur"],
"610107":[328,880,0.07,"Vikrapandiyam, Thiruvarur"],
"610109":[600,1772,0.16,"Kilapadugai, Thiruvarur"],
"610201":[515,1420,0.09,"Mutharasapuram, Nagapattinam"],
"610202":[600,1897,0.16,"Komal, Thiruvarur"],
"610203":[591,1553,0.07,"Sithaimur, Nagapattinam"],
"610204":[550,1347,0.11,"Tiruvoimur, Nagapattinam"],
"610205":[525,1347,0.08,"Seruvamani, Thiruvarur"],
"610206":[493,1307,0.08,"Sendangudi, Thiruvarur"],
"610207":[600,1785,0.16,"Terkupanaiyur, Nagapattinam"],
"611001":[445,1248,0.4,"Nagapattinam, Nagapattinam"],
"611002":[445,1209,0.23,"Okkur, Nagapattinam"],
"611003":[445,1234,0.3,"Palpannaichery, Nagapattinam"],
"611101":[600,1994,0.16,"Semangalam, Thiruvarur"],
"611102":[445,1352,0.26,"Papakoil, Nagapattinam"],
"611103":[514,1366,0.18,"Madapuram, Nagapattinam"],
"611104":[448,1826,0.21,"Tirukannangudi, Nagapattinam"],
"611105":[525,1941,0.23,"Kurukathi, Nagapattinam"],
"611106":[445,1404,0.27,"Palaiyur, Nagapattinam"],
"611108":[445,1385,0.26,"Poravacherry, Nagapattinam"],
"611109":[450,1573,0.2,"Erayangudi, Nagapattinam"],
"611110":[330,1152,0.08,"Kameswaram, Nagapattinam"],
"611111":[445,851,0.11,"Serudur, Nagapattinam"],
"611112":[460,1076,0.08,"Vellapallam, Nagapattinam"],
"612001":[360,889,0.08,"Kumbakonam, Thanjavur"],
"612002":[300,845,0.0,"Melakaveri, Thanjavur"],
"612101":[370,772,0.09,"Aduthurai Bazar, Thanjavur"],
"612102":[375,824,0.08,"Palakudi, Thanjavur"],
"612103":[370,847,0.09,"Ammachathiram, Thanjavur"],
"612104":[370,794,0.07,"Mahadana Street, Thanjavur"],
"612105":[375,841,0.07,"Tiruvisalur, Thanjavur"],
"612106":[380,873,0.07,"Aralur, Thanjavur"],
"612201":[310,688,0.06,"Anniyur, Mayiladuthurai"],
"612202":[365,761,0.07,"Poundarigapuram, Thanjavur"],
"612203":[310,708,0.05,"Sengarangudi Pudur, Thanjavur"],
"612204":[370,826,0.09,"Tepperumanallur, Thanjavur"],
"612301":[350,664,0.0,"Tyagasamudram, Thanjavur"],
"612302":[350,730,0.0,"Tiruvalanjuli, Thanjavur"],
"612303":[350,786,0.0,"Eraharam, Thanjavur"],
"612401":[310,844,0.09,"Annalagraharam, Thanjavur"],
"612402":[300,728,0.0,"Korukkai Thottam, Thanjavur"],
"612501":[360,802,0.09,"Kadichambadi, Thanjavur"],
"612502":[360,905,0.04,"Thathuvancheri, Thanjavur"],
"612503":[375,861,0.07,"Kovilacherri, Thanjavur"],
"612504":[360,794,0.05,"Manikudi, Thanjavur"],
"612601":[284,699,0.04,"Agaraohai, Thiruvarur"],
"612602":[315,739,0.07,"Mathur, Thanjavur"],
"612603":[260,635,0.02,"Arasavanangadu, Thiruvarur"],
"612604":[200,586,0.02,"Paruthiyur, Thiruvarur"],
"612605":[296,732,0.04,"Nagarasampettai, Thanjavur"],
"612610":[305,816,0.06,"Moolangudi, Thiruvarur"],
"612701":[350,699,0.0,"Oothucadu, Thiruvarur"],
"612702":[350,792,0.0,"Valayapettai, Thanjavur"],
"612703":[350,739,0.0,"Teynampadugai, Thanjavur"],
"612801":[283,689,0.04,"Melamaravathy, Thiruvarur"],
"612802":[305,667,0.0,"Muniyur, Thiruvarur"],
"612803":[339,797,0.03,"Kalacheri, Thiruvarur"],
"612804":[350,763,0.0,"Adichamangalam, Thiruvarur"],
"612901":[240,576,0.02,"Kuruvalapparkoil, Ariyalur"],
"612902":[215,535,0.02,"Anaikudam, Ariyalur"],
"612903":[213,544,0.0,"Kattagaram, Ariyalur"],
"612904":[300,702,0.02,"Kaduvettankurichi, Ariyalur"],
"612905":[237,555,0.01,"Kidaramkondan, Ariyalur"],
"612906":[235,565,0.02,"Melanikuzhi, Kozhikode"],
"613001":[365,1059,0.0,"Thanjavur, Thanjavur"],
"613002":[385,1114,0.0,"Sakkarasamandam, Thanjavur"],
"613003":[370,1363,0.0,"Annappanpettai, Thanjavur"],
"613004":[385,902,0.0,"State Bank Colony, Thanjavur"],
"613005":[340,542,0.01,"Inayathukkanpatti, Thanjavur"],
"613006":[288,501,0.01,"Mukasa Nanjikottai, Thanjavur"],
"613007":[365,861,0.01,"Ganapathi Nagar, Thanjavur"],
"613008":[340,922,0.01,"Thanjavur North Gate, Thanjavur"],
"613009":[385,1033,0.0,"Srinivasapuram, Thanjavur"],
"613010":[340,922,0.01,"Tamil University, Thanjavur"],
"613101":[360,989,0.01,"Allur, Thanjavur"],
"613102":[340,823,0.08,"Mekalathur, Thanjavur"],
"613103":[390,1734,0.0,"Thiruvalampozhil, Thanjavur"],
"613104":[380,682,0.03,"Maharajapuram, Thanjavur"],
"613105":[380,658,0.03,"Koviladi TPL, Thanjavur"],
"613201":[390,2264,-1,"Mohamed Bunder, Thanjavur"],
"613202":[356,1883,0.08,"Tiruchottuthurai, Thanjavur"],
"613203":[385,1334,0.02,"Maruvur, Thanjavur"],
"613204":[385,2238,-1,"Royampettai, Thanjavur"],
"613205":[385,1309,0.0,"Arkadu, Thanjavur"],
"613301":[115,1457,0.02,"Thachankurichi, Pudukkottai"],
"613303":[340,739,0.01,"Kurungulam, Thanjavur"],
"613401":[365,823,0.0,"Tirumalaisamudram, Thanjavur"],
"613402":[340,910,0.07,"Muthandipatti, Thanjavur"],
"613403":[340,622,0.0,"Chennampatti, Thanjavur"],
"613501":[292,555,0.02,"Kulichapattu, Thanjavur"],
"613502":[350,686,0.0,"Kumilakudi, Thanjavur"],
"613503":[258,492,0.02,"Sri Pushpam College, Thanjavur"],
"613504":[400,831,0.01,"Arsuthipattu, Thanjavur"],
"613601":[360,957,0.01,"Vannarapettai, Thanjavur"],
"613602":[380,879,0.01,"Marudakudi, Thanjavur"],
"613701":[270,1031,0.08,"Athisolamangalam, Thiruvarur"],
"613702":[373,940,0.04,"Tiruvidavasal, Thiruvarur"],
"613703":[296,742,0.03,"Hanumanthapuram, Thiruvarur"],
"613704":[483,1312,0.08,"Kalyanamahadevi, Thiruvarur"],
"613705":[286,702,0.04,"Abivirthiswaram, Thiruvarur"],
"614001":[320,663,0.0,"Mannargudi, Thiruvarur"],
"614013":[290,616,0.02,"Kattakudi, Thiruvarur"],
"614014":[320,671,0.01,"Neduvakottai, Thiruvarur"],
"614015":[400,1083,0.0,"Kilakurichi, Thanjavur"],
"614016":[320,688,0.01,"Solapandi, Thiruvarur"],
"614017":[574,1486,0.01,"Kaniyakurichi, Thanjavur"],
"614018":[402,917,0.01,"Kandithampettai, Thiruvarur"],
"614019":[276,557,0.02,"Sadayarkoil, Thiruvarur"],
"614020":[400,1258,0.0,"Radhanarasimhapuram, Thiruvarur"],
"614101":[320,980,0.05,"Sathanur(KTN), Thiruvarur"],
"614102":[320,892,0.04,"Kudithangicheri, Thiruvarur"],
"614103":[320,857,0.04,"Segarai, Thiruvarur"],
"614201":[350,1604,0.0,"Ayyampet, Thanjavur"],
"614202":[300,1399,0.0,"Manalur, Thanjavur"],
"614203":[404,837,0.01,"Karuppur KBS, Thanjavur"],
"614204":[350,974,0.0,"Devarayanpettai, Thanjavur"],
"614205":[350,488,0.0,"Papanasam, Thanjavur"],
"614206":[370,1595,0.0,"Vaiyacheri, Thanjavur"],
"614207":[413,863,0.01,"Rajaghiri, Thanjavur"],
"614208":[350,593,0.0,"Kiliyur, Thiruvarur"],
"614210":[350,1290,0.0,"Neduntheru, Thanjavur"],
"614211":[350,1294,0.0,"Ayyampet R.S, Thanjavur"],
"614301":[370,1224,0.0,"Kovathagudi, Thanjavur"],
"614302":[395,853,0.0,"Idaiyiruppu, Thanjavur"],
"614303":[350,1254,0.0,"Vembakudi, Thanjavur"],
"614401":[290,627,0.01,"Chinnakadaitheru, Thanjavur"],
"614402":[286,601,0.01,"Tirukoilpathu, Thanjavur"],
"614403":[320,667,0.01,"Chettichatram, Thiruvarur"],
"614404":[319,773,0.03,"Narthangudi, Thiruvarur"],
"614601":[507,1001,0.0,"Pattukottai, Thanjavur"],
"614602":[506,1021,0.0,"Ponnavarayankottai, Thanjavur"],
"614612":[480,1245,0.08,"Rudrachinthamani, Thanjavur"],
"614613":[500,1479,0.0,"Manjavayal, Thanjavur"],
"614614":[344,710,0.02,"Padirankottai, Thanjavur"],
"614615":[457,961,0.01,"Enadi, Thanjavur"],
"614616":[273,1117,0.02,"Edaiyathur, Pudukkottai"],
"614617":[373,1048,0.04,"Vichchur, Pudukkottai"],
"614618":[480,3157,0.0,"Pandipathiram, Pudukkottai"],
"614619":[592,3887,0.02,"Karakathikottai, Pudukkottai"],
"614620":[202,535,0.54,"Vellore, Pudukkottai"],
"614621":[695,6406,0.01,"Arasanagaripattinam, Pudukkottai"],
"614622":[250,634,0.07,"Chidambaraviduthi, Pudukkottai"],
"614623":[353,924,0.04,"Ammaiyandi, Thanjavur"],
"614624":[263,955,0.03,"Kasimpudupet, Pudukkottai"],
"614625":[286,558,0.02,"Neduvakottai, Thanjavur"],
"614626":[433,952,0.02,"Ambalapattu North, Thanjavur"],
"614628":[314,628,0.01,"Neyvelivadapathi, Thanjavur"],
"614629":[598,4011,0.02,"Kalabam, Pudukkottai"],
"614630":[552,1699,0.07,"Singavanam, Pudukkottai"],
"614701":[503,1150,0.0,"Rajamadam, Thanjavur"],
"614702":[535,1442,0.04,"Ariyalur, Thiruvarur"],
"614703":[525,1436,0.05,"Ovarur, Thiruvarur"],
"614704":[542,1411,0.03,"Kilakadu, Thiruvarur"],
"614705":[564,1517,0.03,"Palaiyur, Thiruvarur"],
"614706":[522,1413,0.04,"Kummattitidal, Thiruvarur"],
"614707":[460,1401,0.06,"Adanur, Nagapattinam"],
"614708":[535,1368,0.06,"Irulneeki, Thiruvarur"],
"614710":[534,1458,0.06,"Terkunanallur, Thiruvarur"],
"614711":[507,1372,0.08,"Arunthavambulam, Nagapattinam"],
"614712":[546,1507,0.1,"Pirinjimulai, Nagapattinam"],
"614713":[530,1444,0.07,"Tiruturaipundi, Thiruvarur"],
"614714":[611,1744,0.06,"Annapettai, Nagapattinam"],
"614715":[534,1459,0.07,"Vittukatti, Thiruvarur"],
"614716":[549,1535,0.06,"Pichankottagam, Thiruvarur"],
"614717":[473,1222,0.05,"Vattar, Thiruvarur"],
"614723":[437,1024,0.04,"Andikadu, Thanjavur"],
"614738":[514,1345,0.04,"Jambavanodai, Thiruvarur"],
"614801":[273,1248,0.02,"Vallavari, Pudukkottai"],
"614802":[395,952,0.05,"Marungapallam, Thanjavur"],
"614803":[444,915,0.04,"Chokkanathapuram, Thanjavur"],
"614804":[409,1005,0.05,"Kalathur, Thanjavur"],
"614805":[480,1404,0.05,"Amarasimhendrapuram, Pudukkottai"],
"614806":[484,1324,0.06,"Kariyapattinam West, Nagapattinam"],
"614807":[429,1206,0.06,"Kodiakkadu, Nagapattinam"],
"614808":[460,1235,0.06,"Neivilakku, Nagapattinam"],
"614809":[437,1160,0.06,"Arkattuthurai, Nagapattinam"],
"614810":[308,856,0.05,"Agasthiampalli, Nagapattinam"],
"614901":[500,1282,0.0,"Alampallam, Thanjavur"],
"614902":[271,539,0.03,"Cholapuram, Thanjavur"],
"614903":[580,1492,0.01,"Madukkur North, Thanjavur"],
"614904":[235,331,0.04,"Sydambalpuram, Thanjavur"],
"614905":[411,934,0.02,"Tirumangalakottai, Thanjavur"],
"614906":[500,1285,0.0,"Vendakottai, Thanjavur"],
"620001":[480,868,0.2,"Tiruchirappalli, Tiruchirappalli"],
"620002":[480,854,0.18,"Teppakulam, Tiruchirappalli"],
"620003":[480,845,0.14,"Salainagar, Tiruchirappalli"],
"620004":[410,916,0.27,"Golden Rock Market, Tiruchirappalli"],
"620005":[480,759,0.08,"Tiruvalarsolai, Tiruchirappalli"],
"620006":[495,730,0.08,"Srirangam, Tiruchirappalli"],
"620007":[332,976,0.2,"Gundur, Tiruchirappalli"],
"620008":[480,849,0.18,"Clock Tower SO Tiruchirappalli, Tiruchirappalli"],
"620009":[520,748,0.07,"Paganur, Tiruchirappalli"],
"620010":[410,842,0.24,"Sircarpalayam, Tiruchirappalli"],
"620011":[410,895,0.25,"Kilakurichi, Tiruchirappalli"],
"620012":[520,846,0.12,"Fathimanagar, Tiruchirappalli"],
"620013":[410,827,0.23,"Malaiadivaram, Tiruchirappalli"],
"620014":[480,893,0.24,"Boiler Project TR, Tiruchirappalli"],
"620015":[500,895,0.29,"Tirunedungulam, Tiruchirappalli"],
"620016":[520,1014,0.24,"Navalpattu, Tiruchirappalli"],
"620017":[480,849,0.17,"Puthur, Tiruchirappalli"],
"620018":[480,837,0.16,"Thillai Nagar, Tiruchirappalli"],
"620019":[410,843,0.24,"Pappakurichi Kattur, Tiruchirappalli"],
"620020":[325,858,0.23,"Jamal Mohamed College, Tiruchirappalli"],
"620021":[480,865,0.19,"KSathanur, Tiruchirappalli"],
"620022":[410,870,0.24,"Thuvakudimalai, Tiruchirappalli"],
"620023":[325,858,0.21,"Khajanagar, Tiruchirappalli"],
"620024":[480,1292,0.14,"Bharathidasan University, Tiruchirappalli"],
"620025":[540,1080,0.23,"Palanganangudi, Tiruchirappalli"],
"620026":[520,1037,0.24,"Annanagar, Tiruchirappalli"],
"620027":[520,698,0.06,"Tamilnadu National Law University, Tiruchirappalli"],
"620101":[480,946,0.11,"Allur, Tiruchirappalli"],
"620102":[460,848,0.13,"Kumaravayalur, Tiruchirappalli"],
"621001":[340,940,0.45,"Kottaiyur, Tiruchirappalli"],
"621002":[560,1119,0.19,"T.Renganathapuram, Tiruchirappalli"],
"621003":[475,962,0.26,"B.Mettur, Tiruchirappalli"],
"621004":[540,1331,0.12,"Kilakunnupatti, Tiruchirappalli"],
"621005":[510,1138,0.0,"Kariyamanickam, Tiruchirappalli"],
"621006":[520,1821,0.0,"Mambarai, Tiruchirappalli"],
"621007":[540,1431,0.07,"Edumalai, Tiruchirappalli"],
"621008":[454,1139,0.24,"Murukkur, Tiruchirappalli"],
"621009":[510,1247,0.0,"Kattukulam, Tiruchirappalli"],
"621010":[340,1191,0.43,"Turaiyur, Tiruchirappalli"],
"621011":[455,1113,0.14,"Puthur, Tiruchirappalli"],
"621012":[441,987,0.27,"Koppampatti, Tiruchirappalli"],
"621014":[460,1312,0.17,"Karattampatti, Tiruchirappalli"],
"621101":[545,1041,0.01,"Puduattur, Perambalur"],
"621102":[531,1066,0.01,"Viswagudi, Perambalur"],
"621103":[330,1289,-1,"Thaluthalai, Perambalur"],
"621104":[600,1362,0.02,"Chathiramanai, Perambalur"],
"621105":[540,2169,0.02,"Reddimangudi, Tiruchirappalli"],
"621106":[745,2001,0.02,"Kolathur, Perambalur"],
"621107":[625,1109,0.02,"Tirupayar, Perambalur"],
"621108":[600,1038,-1,"Athiyur, Perambalur"],
"621109":[610,2333,0.02,"Naranamangalam, Perambalur"],
"621110":[495,1322,0.0,"Periyammapalayam, Perambalur"],
"621111":[510,1157,0.02,"R.Valavanur, Tiruchirappalli"],
"621112":[495,1015,0.06,"Pallividai, Tiruchirappalli"],
"621113":[654,1605,0.02,"Varagupadi, Perambalur"],
"621114":[560,1569,0.07,"Tenur, Perambalur"],
"621115":[645,1240,0.02,"Ayikudi, Perambalur"],
"621116":[680,1280,-1,"Krishnapuram, Perambalur"],
"621117":[695,1277,-1,"Karianur, Perambalur"],
"621118":[545,1313,0.05,"Adaikkampatti, Perambalur"],
"621119":[576,1168,0.01,"Kaikalathur, Perambalur"],
"621133":[698,1359,0.02,"Sirumathur, Perambalur"],
"621202":[430,1062,0.0,"Sundaikkai, Tiruchirappalli"],
"621203":[400,1014,0.07,"M.Puthur, Tiruchirappalli"],
"621204":[480,1331,0.0,"Amur, Tiruchirappalli"],
"621205":[385,836,0.0,"Mangalam, Tiruchirappalli"],
"621206":[400,858,0.18,"Devarappampatti, Tiruchirappalli"],
"621207":[460,1189,0.17,"Pidaramangalam, Tiruchirappalli"],
"621208":[400,928,0.01,"Surampatti, Tiruchirappalli"],
"621209":[400,980,0.02,"Thiruvengimalai, Tiruchirappalli"],
"621210":[435,914,0.17,"Angiyam, Tiruchirappalli"],
"621211":[400,952,0.01,"Thumbalam, Tiruchirappalli"],
"621212":[680,1188,0.01,"Perambalur, Perambalur"],
"621213":[480,1372,0.0,"Kilianallur, Tiruchirappalli"],
"621214":[459,909,0.12,"Arachi, Tiruchirappalli"],
"621215":[400,970,0.09,"Varadarajapuram, Tiruchirappalli"],
"621216":[495,812,0.05,"Thalakudi, Tiruchirappalli"],
"621217":[470,1238,0.0,"T pudupatti, Tiruchirappalli"],
"621218":[410,750,0.16,"Melavalady, Tiruchirappalli"],
"621219":[680,1160,0.02,"Vadakkumadevi, Perambalur"],
"621220":[640,1207,0.01,"Kavulpalayam, Perambalur"],
"621301":[399,897,0.01,"Manjapulipatti, Karur"],
"621302":[648,1712,0.01,"Kumaravadi, Tiruchirappalli"],
"621305":[658,1568,0.03,"Minaveli, Pudukkottai"],
"621306":[520,1294,0.05,"K.Periyapatti, Tiruchirappalli"],
"621307":[560,1397,0.03,"Amayapuram, Tiruchirappalli"],
"621308":[315,1125,0.0,"Kodumbapatti, Tiruchirappalli"],
"621310":[710,1671,0.02,"Alagagoundanpatti, Tiruchirappalli"],
"621311":[490,1133,0.01,"Sevapur, Karur"],
"621312":[520,1213,0.04,"Seegampatti, Tiruchirappalli"],
"621313":[455,1441,0.03,"Kavalkaranpatti, Karur"],
"621314":[659,1461,0.03,"Adhigaram, Tiruchirappalli"],
"621315":[600,1560,0.0,"Kalpatti, Tiruchirappalli"],
"621316":[525,1414,0.0,"Velur, Pudukkottai"],
"621601":[340,1096,0.16,"Lalgudi, Tiruchirappalli"],
"621651":[910,2254,0.04,"Kanakiliyanallur, Tiruchirappalli"],
"621652":[960,2080,0.03,"Malvoy, Tiruchirappalli"],
"621653":[860,1570,0.04,"Keelarasur, Tiruchirappalli"],
"621701":[421,837,0.03,"Kasankottai, Ariyalur"],
"621702":[380,1544,0.03,"Ariyur, Tiruchirappalli"],
"621703":[495,1045,0.09,"Manakkal, Tiruchirappalli"],
"621704":[331,1076,0.06,"Kavanur, Ariyalur"],
"621705":[355,1007,0.05,"Kadugur, Ariyalur"],
"621706":[310,1681,0.04,"Sirumayankudi, Tiruchirappalli"],
"621707":[596,935,0.06,"Arungal, Ariyalur"],
"621708":[680,1471,0.03,"Ilandaikuli, Perambalur"],
"621709":[220,607,0.0,"Manapathur, Ariyalur"],
"621710":[193,461,-1,"Kuvagam, Ariyalur"],
"621711":[860,2964,0.05,"Vandalaigudalur, Tiruchirappalli"],
"621712":[510,1501,0.02,"Agalanganallur, Tiruchirappalli"],
"621713":[536,1574,0.05,"Allinagaram, Perambalur"],
"621714":[318,904,0.04,"Elangaicheri, Ariyalur"],
"621715":[380,1417,0.05,"Sullangudi, Ariyalur"],
"621716":[535,1364,0.04,"Kadur, Perambalur"],
"621717":[680,1139,0.04,"Andikurumbalur, Perambalur"],
"621718":[740,1732,0.04,"Anandavadi, Ariyalur"],
"621719":[145,428,0.0,"Edayakurichi, Ariyalur"],
"621722":[670,1493,0.03,"Thinnakulam B.O., Tiruchirappalli"],
"621729":[331,1182,0.06,"Ariyalur Cement Factory, Ariyalur"],
"621730":[242,512,0.06,"Dalavoy, Ariyalur"],
"621731":[395,981,0.04,"Reddipalayam, Ariyalur"],
"621801":[596,963,0.06,"Pattanamkurichi, Ariyalur"],
"621802":[190,495,0.01,"Chinnavalayam, Ariyalur"],
"621803":[178,526,0.0,"Kattathur, Ariyalur"],
"621804":[155,338,-1,"Kumiliam, Ariyalur"],
"621805":[183,502,0.0,"Kilaneduvoi, Ariyalur"],
"621806":[155,381,0.0,"Pilakurichi, Ariyalur"],
"621851":[380,1482,0.04,"Koilesanai, Ariyalur"],
"622001":[510,1411,0.65,"Pudukkottai, Pudukkottai"],
"622002":[163,369,0.46,"Karaiyur, Pudukkottai"],
"622003":[440,1168,1.07,"Attangudi, Pudukkottai"],
"622004":[380,1313,0.59,"Vadavalam, Pudukkottai"],
"622005":[640,1497,0.45,"Pudukkottai Collectorate, Pudukkottai"],
"622101":[640,996,0.39,"Vilathupatti, Pudukkottai"],
"622102":[478,1251,0.46,"Ennai, Pudukkottai"],
"622103":[429,979,0.36,"Pudur pdk, Pudukkottai"],
"622104":[315,595,0.57,"Pulvayal, Pudukkottai"],
"622201":[301,902,0.65,"Mirattunilai, Pudukkottai"],
"622202":[277,699,0.12,"Kongudi, Pudukkottai"],
"622203":[199,871,0.01,"Ganapathipuram, Pudukkottai"],
"622204":[344,1881,0.07,"Kurungalur, Pudukkottai"],
"622209":[301,719,0.15,"Kallur kilanilai, Pudukkottai"],
"622301":[225,695,0.35,"Kalabam, Pudukkottai"],
"622302":[297,747,0.02,"Kallakottai, Pudukkottai"],
"622303":[315,919,1.17,"Tirukkattalai, Pudukkottai"],
"622304":[246,717,0.02,"Mangadu, Pudukkottai"],
"622401":[185,368,0.0,"Semboodi, Pudukkottai"],
"622402":[250,666,0.26,"Arasamalai, Pudukkottai"],
"622403":[421,1458,0.0,"Selliampatti, Sivaganga"],
"622404":[420,923,0.21,"Rarapuram, Pudukkottai"],
"622407":[281,795,0.0,"R.Palakurichi, Pudukkottai"],
"622409":[315,1191,0.02,"Kannanur, Pudukkottai"],
"622411":[343,924,0.12,"Kesarapatti, Pudukkottai"],
"622412":[461,1249,0.53,"Melapanaiyur, Pudukkottai"],
"622422":[440,1264,0.65,"Namanasamudram, Pudukkottai"],
"622501":[460,1712,0.0,"Puthambur, Pudukkottai"],
"622502":[460,1685,0.0,"Kalamavur, Pudukkottai"],
"622503":[405,1489,0.08,"Athanur, Pudukkottai"],
"622504":[442,1710,0.0,"Valamangalam, Pudukkottai"],
"622505":[440,1383,0.39,"Hirudayapuram, Pudukkottai"],
"622506":[440,1290,0.71,"Sengirai, Pudukkottai"],
"622507":[405,1475,0.34,"Pilivalam, Pudukkottai"],
"622515":[510,1553,0.0,"Mandaiyur, Pudukkottai"],
"623115":[367,1294,0.09,"Pammanendal, Ramanathapuram"],
"623120":[608,2245,0.13,"Pillaiyarkulam, Ramanathapuram"],
"623135":[490,1931,0.1,"STharaikudi, Ramanathapuram"],
"623308":[565,2463,0.05,"Kookudi, Ramanathapuram"],
"623315":[565,2754,0.06,"Nilamalagiamangalam, Ramanathapuram"],
"623401":[705,2063,0.12,"Radhanur, Ramanathapuram"],
"623402":[920,2470,0.05,"Sevvaipettai, Ramanathapuram"],
"623403":[565,2723,0.06,"Muhilthagam, Ramanathapuram"],
"623404":[565,2624,0.06,"Nagarikathan, Ramanathapuram"],
"623406":[780,4697,0.05,"Oriyur, Ramanathapuram"],
"623407":[435,2453,0.06,"Thinaiyathur, Ramanathapuram"],
"623409":[565,2972,0.08,"Pasipattinam, Ramanathapuram"],
"623501":[655,3426,0.08,"Ramanathapuram, Ramanathapuram"],
"623502":[795,3167,0.22,"Puthenthal, Ramanathapuram"],
"623503":[388,752,0.01,"Pattanamkathan, Ramanathapuram"],
"623504":[655,3448,0.08,"Peravoor, Ramanathapuram"],
"623512":[425,1571,0.05,"Athankarai, Ramanathapuram"],
"623513":[655,3388,0.08,"Peruvayal, Ramanathapuram"],
"623514":[597,2021,0.06,"Devipattinam South, Ramanathapuram"],
"623515":[711,3972,0.31,"Mayakulam, Ramanathapuram"],
"623516":[408,741,0.01,"Kadukkavalasai, Ramanathapuram"],
"623517":[711,4122,0.22,"Kanjirangudi, Ramanathapuram"],
"623518":[425,980,0.05,"Thonithurai, Ramanathapuram"],
"623519":[388,776,0.02,"Vedalai, Ramanathapuram"],
"623520":[388,799,0.03,"Marine Fisheries, Ramanathapuram"],
"623521":[501,1238,0.03,"Akkamadam, Ramanathapuram"],
"623522":[468,1695,0.06,"Puduvalasai, Ramanathapuram"],
"623523":[468,1893,0.04,"Kumbaram, Ramanathapuram"],
"623524":[408,1009,0.03,"Vellariodai, Ramanathapuram"],
"623525":[698,1866,0.08,"Attangudi, Ramanathapuram"],
"623526":[454,1291,0.03,"Rameswaram East, Ramanathapuram"],
"623527":[710,3020,0.16,"Kamankottai, Ramanathapuram"],
"623528":[804,3092,0.29,"Kilakidaram, Ramanathapuram"],
"623529":[408,1479,0.05,"Ariyangundu, Ramanathapuram"],
"623530":[600,1916,-1,"Kiliyur, Ramanathapuram"],
"623531":[600,2110,0.07,"Kothiyarkottai, Ramanathapuram"],
"623532":[710,3458,0.05,"Pudukoil, Ramanathapuram"],
"623533":[711,4768,0.2,"Marttiyarendal, Ramanathapuram"],
"623534":[408,977,0.02,"Nagachi, Ramanathapuram"],
"623536":[545,1835,0.06,"Vani, Ramanathapuram"],
"623537":[600,2074,0.07,"Naranamangalam, Ramanathapuram"],
"623538":[678,1874,0.07,"Arunoothimangalam, Ramanathapuram"],
"623566":[711,2055,0.69,"Ervadi Dargha, Ramanathapuram"],
"623601":[400,1590,0.02,"Anaiyur, Ramanathapuram"],
"623603":[586,1451,0.01,"Kombuthi KMU, Ramanathapuram"],
"623604":[509,1383,0.06,"Pakkuvetti, Ramanathapuram"],
"623605":[638,1685,0.01,"Koodakulam, Ramanathapuram"],
"623608":[402,1212,0.03,"Melaperungarai, Ramanathapuram"],
"623701":[480,1607,0.16,"Alimadurai, Ramanathapuram"],
"623703":[517,1814,0.27,"Oppilan, Ramanathapuram"],
"623704":[400,2206,0.14,"Ilanjembur, Ramanathapuram"],
"623705":[495,1343,0.14,"Chathurvethamangalam, Ramanathapuram"],
"623706":[560,2136,0.1,"Kilathooval, Ramanathapuram"],
"623707":[480,1578,0.15,"Paramakudi, Ramanathapuram"],
"623708":[639,1958,0.1,"Senkottaipatti, Ramanathapuram"],
"623711":[886,3286,0.25,"Kakkur, Ramanathapuram"],
"623712":[1040,2975,0.14,"Alanganoor, Ramanathapuram"],
"623806":[711,4137,0.11,"Sathaksalai, Ramanathapuram"],
"624001":[462,1357,0.02,"Dindigul, Dindigul"],
"624002":[443,1096,0.02,"Kottapatti, Dindigul"],
"624003":[490,1115,0.02,"Koovanuthu, Dindigul"],
"624004":[495,1232,0.02,"Sennamanaickenpatti, Dindigul"],
"624005":[490,1127,0.12,"Thamaraipadi, Dindigul"],
"624101":[233,427,0.39,"Attuvampatti, Dindigul"],
"624103":[114,176,0.22,"Kavunji, Dindigul"],
"624201":[418,793,0.02,"Kalladipatti, Dindigul"],
"624202":[270,642,0.0,"Poosaripatti, Dindigul"],
"624204":[430,789,0.0,"Maruthanathiproject, Dindigul"],
"624206":[443,632,0.05,"Jambudarikottai, Dindigul"],
"624208":[432,748,0.05,"Nilakottai, Dindigul"],
"624210":[510,1301,0.06,"Moolaiyar, Dindigul"],
"624211":[430,774,0.0,"MVadipatti, Dindigul"],
"624212":[430,632,0.2,"Pallathukalvai, Dindigul"],
"624215":[432,722,0.05,"Kottur, Dindigul"],
"624216":[366,702,0.18,"Kanalkadu, Dindigul"],
"624219":[461,892,0.06,"Ethilodu, Dindigul"],
"624220":[270,718,0.05,"Sandaiyur, Dindigul"],
"624301":[490,1111,0.03,"Chinnalapatti, Dindigul"],
"624302":[495,1137,0.04,"ANadupatti, Dindigul"],
"624303":[451,1079,0.02,"Munnilakottai, Dindigul"],
"624304":[518,921,0.04,"Avilipatti, Dindigul"],
"624306":[354,738,0.07,"Madur, Dindigul"],
"624307":[451,1086,0.02,"Sirunaickenpatti, Dindigul"],
"624308":[460,730,0.05,"KAyyapatti, Dindigul"],
"624401":[456,998,0.03,"Kuttupatti, Dindigul"],
"624402":[490,1061,0.02,"Sirugudi, Dindigul"],
"624403":[487,1094,0.03,"Kodagipatti, Dindigul"],
"624601":[510,1159,0.02,"Palani, Dindigul"],
"624610":[570,1262,0.04,"Palarparundalar Dam, Dindigul"],
"624612":[615,1161,0.09,"Chinnamandavadi, Dindigul"],
"624613":[510,1276,0.06,"Erramanaickenpatti, Dindigul"],
"624614":[551,1084,0.07,"19 Pudur, Dindigul"],
"624615":[468,1044,0.02,"Chinnakalayamputhur, Dindigul"],
"624616":[570,1446,0.06,"Aranmanaivalasu, Dindigul"],
"624617":[497,1198,0.04,"Thoppampatti, Dindigul"],
"624618":[510,1105,0.03,"Periyamottanuthu, Dindigul"],
"624619":[540,1051,0.03,"Old Oddanchatram, Dindigul"],
"624620":[304,1106,0.02,"Anaipatti, Dindigul"],
"624621":[468,954,0.02,"Thathanaickenpatti, Dindigul"],
"624622":[495,957,0.01,"Gurunathanaickanur, Dindigul"],
"624701":[785,1435,0.04,"Attur, Dindigul"],
"624702":[442,1378,1.11,"Achanampatti, Dindigul"],
"624703":[282,825,0.02,"Thozhipatti, Dindigul"],
"624704":[551,1266,0.0,"Jogipatti, Dindigul"],
"624705":[470,1021,0.02,"Kasavanampatti, Dindigul"],
"624706":[426,1065,1.11,"Nagayakottai, Dindigul"],
"624707":[451,1048,0.03,"Mallayapuram, Dindigul"],
"624708":[432,834,0.05,"KSingarakottai, Dindigul"],
"624709":[518,1302,0.19,"Agaram, Dindigul"],
"624710":[442,1654,1.11,"Alagapuri, Dindigul"],
"624711":[895,1590,-1,"Devinaickenpatti, Dindigul"],
"624712":[961,1502,-1,"Chinnakkampatti, Dindigul"],
"624801":[514,1274,0.72,"Kollapatti, Dindigul"],
"624802":[390,1158,0.56,"Bojanampatti, Dindigul"],
"625001":[412,1022,0.0,"Madurai, Madurai"],
"625002":[409,980,0.0,"Tallakulam, Madurai"],
"625003":[430,982,0.0,"Madakkulam, Madurai"],
"625004":[435,994,0.0,"Pasumalai, Madurai"],
"625005":[435,943,0.0,"Nilaiyur, Madurai"],
"625006":[435,955,0.0,"Thanakkankulam, Madurai"],
"625007":[409,980,0.0,"Pudur Bazaar, Madurai"],
"625008":[430,874,0.0,"Thoppur, Madurai"],
"625009":[665,1977,0.1,"Chintamani, Madurai"],
"625011":[430,1086,0.0,"Subramaniapuram SO Madurai, Madurai"],
"625012":[421,1008,0.0,"Avaniapuram, Madurai"],
"625014":[404,917,0.04,"Tirumalpuram, Madurai"],
"625015":[435,977,0.0,"Thiagarajar Engg College, Madurai"],
"625016":[430,975,0.0,"Arasaradi, Madurai"],
"625017":[331,947,0.0,"Kulamangalam, Madurai"],
"625018":[430,963,0.0,"Vilangudi, Madurai"],
"625019":[435,965,0.0,"Erkudi Achampathu, Madurai"],
"625020":[411,635,0.0,"Karuppayurani, Madurai"],
"625021":[430,983,0.0,"Vadapalanji, Madurai"],
"625022":[427,900,0.0,"Perungudi, Madurai"],
"625023":[404,822,0.04,"Madras High Court Madurai Bench, Madurai"],
"625101":[460,1153,0.0,"Mangalampatti, Madurai"],
"625102":[605,1423,0.01,"Malampatti, Madurai"],
"625103":[538,1377,0.01,"Valaicheripatti, Madurai"],
"625104":[404,665,0.05,"Kodikulam, Madurai"],
"625105":[405,933,0.0,"Arukkampatti, Madurai"],
"625106":[352,714,0.01,"Kallampatti, Madurai"],
"625107":[411,840,0.0,"Uthangudi, Madurai"],
"625108":[560,1309,0.0,"Attapatti, Madurai"],
"625109":[350,1045,0.02,"Kottanathampatti, Madurai"],
"625110":[223,551,-1,"Poonjuthi, Madurai"],
"625122":[350,710,0.07,"Narsingampatti, Madurai"],
"625201":[412,929,0.0,"Puliankulam, Madurai"],
"625203":[270,584,0.0,"G.Kallupatti, Theni"],
"625205":[430,978,0.0,"Irumbadi, Madurai"],
"625207":[430,1073,0.03,"Kadupatti, Madurai"],
"625214":[430,1029,0.0,"Thenkarai, Madurai"],
"625218":[390,1054,0.0,"Andipatti, Madurai"],
"625221":[430,932,0.0,"Sithalangudi, Madurai"],
"625234":[430,982,0.0,"Melakkal, Madurai"],
"625301":[345,581,0.07,"Kallandiri, Madurai"],
"625402":[453,1050,0.0,"Paravai, Madurai"],
"625501":[390,728,0.02,"Ayyur, Madurai"],
"625503":[360,709,0.07,"Sendamangalam, Madurai"],
"625512":[275,888,0.24,"Kanniappapillaipatti, Theni"],
"625513":[346,933,0.08,"Bodinayakanur, Theni"],
"625514":[430,1087,0.0,"Jothimanickam, Madurai"],
"625515":[257,787,0.06,"Highwavys, Theni"],
"625516":[249,911,0.01,"Karunagamuthanpatti, Theni"],
"625517":[325,1219,0.06,"Marikundu, Theni"],
"625518":[100,484,0.01,"Angoorpal, Theni"],
"625520":[346,774,0.06,"Poomalaikundu, Theni"],
"625521":[257,1184,0.02,"Narayanathevanpatti, Theni"],
"625522":[194,316,0.06,"Kombai, Theni"],
"625523":[298,1011,0.16,"Saruthupatti, Theni"],
"625524":[284,575,0.09,"Pallavarayanpatti, Theni"],
"625525":[335,1019,0.14,"Periyar Project, Theni"],
"625526":[257,784,0.06,"Gokilapuram, Theni"],
"625527":[110,428,0.01,"Allikundam, Madurai"],
"625528":[349,1005,0.06,"Pottipuram, Theni"],
"625529":[430,721,0.06,"Thummagundu, Madurai"],
"625530":[320,566,0.12,"Sankarapuram, Theni"],
"625531":[346,888,0.08,"Kodangipatti, Theni"],
"625532":[265,685,0.12,"Ariyapatti, Madurai"],
"625533":[257,371,0.1,"Hanumanthanpatti, Theni"],
"625534":[349,863,0.07,"Kottur, Theni"],
"625535":[110,347,-1,"Jothilnayakanur, Madurai"],
"625536":[290,771,0.33,"Bodidasanpatti, Theni"],
"625537":[430,1002,0.12,"Kuravagudi, Madurai"],
"625540":[406,807,0.08,"Vellaiyammalpuram, Theni"],
"625552":[333,671,0.08,"Kujjanur, Theni"],
"625556":[520,1344,0.16,"C.Pudupatti, Theni"],
"625562":[272,940,0.19,"Gullapuram, Theni"],
"625579":[473,832,0.07,"Kombaitholu, Theni"],
"625582":[349,937,0.06,"Anaikaraipatti, Theni"],
"625601":[339,752,0.05,"Periyakulam, Theni"],
"625602":[272,796,0.08,"A.Vadipatti, Theni"],
"625603":[270,1066,0.14,"Melmangalam, Theni"],
"625604":[270,939,0.0,"Endapuli, Theni"],
"625605":[230,1009,0.07,"Murugamalainagar, Theni"],
"625701":[436,1102,0.05,"KSennampatti, Madurai"],
"625702":[257,804,0.01,"MSubbulapuram, Madurai"],
"625703":[260,636,0.01,"Deivanayagapuram, Madurai"],
"625704":[350,1046,0.01,"Kilavaneri, Madurai"],
"625705":[254,327,0.01,"Kuduseri, Madurai"],
"625706":[430,1800,0.01,"AAmmapatti, Madurai"],
"625707":[436,1075,0.05,"Lalapuram, Madurai"],
"625708":[302,1029,0.01,"Solaipatti, Madurai"],
"626001":[398,1578,0.11,"Virudhunagar, Virudhunagar"],
"626002":[436,1040,0.07,"Kokkalanjeri, Virudhunagar"],
"626003":[398,1321,0.07,"Inamreddiapatti, Virudhunagar"],
"626004":[530,1264,0.04,"Periavallikulam, Virudhunagar"],
"626005":[470,964,0.08,"MepcoEnggCollege, Virudhunagar"],
"626101":[535,1648,0.04,"Aruppukottai, Virudhunagar"],
"626102":[550,1792,0.12,"Nallamanaickenpatti, Virudhunagar"],
"626103":[436,937,0.05,"Pudukottai, Virudhunagar"],
"626104":[530,1145,0.02,"Vakkanangundu, Virudhunagar"],
"626105":[540,1788,0.04,"Sembatti, Virudhunagar"],
"626106":[529,1171,0.01,"Mustakurichi, Virudhunagar"],
"626107":[540,1546,0.03,"Kattangudi, Virudhunagar"],
"626108":[550,1310,0.12,"Chockalingapuram, Virudhunagar"],
"626109":[568,1139,0.07,"Villipathiri, Virudhunagar"],
"626110":[520,1349,0.17,"Melapattamkarisalkulam, Virudhunagar"],
"626111":[570,1274,0.03,"Puthur, Virudhunagar"],
"626112":[540,1630,0.03,"TMeenakshipuram, Virudhunagar"],
"626113":[640,1797,0.03,"Koppusithampatti, Virudhunagar"],
"626114":[543,1326,0.04,"Poolangal, Virudhunagar"],
"626115":[211,920,0.0,"Aviyur, Virudhunagar"],
"626116":[480,996,0.28,"Seshapuram, Virudhunagar"],
"626117":[550,1104,0.1,"Rajapalayam, Virudhunagar"],
"626118":[585,2355,0.04,"Thummusinnampatti, Virudhunagar"],
"626119":[535,1159,0.06,"Muthulapuram, Virudhunagar"],
"626121":[570,1186,0.04,"Chockanathanpudur, Virudhunagar"],
"626122":[570,1265,0.04,"Settiyarpatti, Virudhunagar"],
"626123":[475,1174,0.09,"Sivakasi, Virudhunagar"],
"626124":[480,924,0.07,"Anaiyur, Virudhunagar"],
"626125":[480,1340,0.24,"Inamkarisalkulam, Virudhunagar"],
"626126":[475,901,0.15,"Kunnur South, Virudhunagar"],
"626127":[444,1126,0.09,"Appayanaickenpatti, Virudhunagar"],
"626128":[315,784,0.06,"Salvarpatti, Virudhunagar"],
"626129":[670,1806,0.04,"Tamilpadi, Virudhunagar"],
"626130":[392,852,0.05,"Alamarathupatti, Virudhunagar"],
"626131":[431,1043,0.08,"Kundayiruppu, Virudhunagar"],
"626132":[393,848,0.16,"Sethunarayanapuram, Virudhunagar"],
"626133":[443,985,0.14,"Pilavakkaldam, Virudhunagar"],
"626134":[640,1960,0.02,"Vadhuvarpatti, Virudhunagar"],
"626135":[475,1196,0.19,"Nachiyarkoil, Virudhunagar"],
"626136":[520,1455,0.12,"Gopalapuram, Virudhunagar"],
"626137":[500,1246,0.12,"Nathikudi, Virudhunagar"],
"626138":[475,876,0.11,"Moovaraivendran, Virudhunagar"],
"626139":[605,1935,0.05,"Solapuram, Virudhunagar"],
"626140":[374,609,0.05,"Varaganur, Tenkasi"],
"626141":[475,1112,0.12,"TManagaseri, Virudhunagar"],
"626142":[570,1239,0.04,"Sundararajapuram, Virudhunagar"],
"626149":[254,474,-1,"Kottaiyur, Virudhunagar"],
"626161":[535,1788,0.03,"Athipatti, Virudhunagar"],
"626188":[570,1261,0.04,"Dhalavaipuram, Virudhunagar"],
"626189":[392,837,0.06,"Meenampatti, Virudhunagar"],
"626201":[310,514,0.04,"Karisalpatti, Virudhunagar"],
"626202":[334,700,0.03,"Chockalingapuram, Virudhunagar"],
"626203":[447,746,0.04,"Mettamalai, Virudhunagar"],
"626204":[530,901,0.0,"Appayanaickenpatti, Virudhunagar"],
"626205":[280,593,0.03,"Mulliseval, Virudhunagar"],
"626607":[585,1448,0.01,"Siruvanur, Virudhunagar"],
"626612":[340,991,0.0,"Dharmam, Virudhunagar"],
"627001":[340,718,0.05,"Tirunelveli, Tirunelveli"],
"627002":[328,610,0.04,"Palayankottai, Tirunelveli"],
"627003":[340,620,0.04,"Vannarpettai, Tirunelveli"],
"627004":[420,838,0.08,"Tirunelveli Pettai, Tirunelveli"],
"627005":[315,685,0.05,"Melapalayam BazaarTirunelveli, Tirunelveli"],
"627006":[380,810,0.06,"Pattapathu, Tirunelveli"],
"627007":[285,627,0.05,"Konganthanparai, Tirunelveli"],
"627008":[368,789,0.09,"Palayapettai, Tirunelveli"],
"627009":[340,645,0.04,"Tirunelveli Collectorate, Tirunelveli"],
"627010":[458,916,0.06,"Vaduganpatti, Tirunelveli"],
"627011":[340,678,0.01,"Krishnapuram, Tirunelveli"],
"627012":[368,816,0.14,"Seethaparpanallur, Tirunelveli"],
"627101":[255,625,0.02,"Nallankulam, Tirunelveli"],
"627102":[255,525,0.02,"Vadukachimadil, Tirunelveli"],
"627103":[255,569,0.03,"Kodaiseri, Tirunelveli"],
"627104":[225,490,0.06,"Kuthenkuli, Tirunelveli"],
"627105":[246,516,0.03,"Kavalkinaru, Tirunelveli"],
"627106":[145,387,0.04,"Perumanal, Tirunelveli"],
"627107":[302,524,0.03,"Salainainarpallivasal, Tirunelveli"],
"627108":[230,705,-1,"Battarpuram, Tirunelveli"],
"627109":[258,568,0.04,"Kalandapanai, Tirunelveli"],
"627110":[300,945,0.09,"Elankulam, Tirunelveli"],
"627111":[225,475,0.04,"Kakkarai, Tirunelveli"],
"627112":[272,585,0.03,"Seelathikulam, Tirunelveli"],
"627113":[290,688,0.01,"Soundarapandiapuram, Tirunelveli"],
"627114":[230,542,0.03,"Jacobpuram, Tirunelveli"],
"627115":[272,562,0.03,"Nambithalaivanpattaiyam, Tirunelveli"],
"627116":[208,426,0.04,"Sembikulam, Tirunelveli"],
"627117":[258,776,0.03,"Kizhavaneri, Tirunelveli"],
"627118":[500,1172,0.18,"Venkatarayapuram, Tirunelveli"],
"627119":[280,734,0.08,"Vijayanarayanam Naval Base, Tirunelveli"],
"627120":[208,314,0.03,"Settikulam, Tirunelveli"],
"627127":[210,518,0.03,"Kannankulam, Tirunelveli"],
"627133":[246,526,0.03,"Perungudi, Tirunelveli"],
"627151":[255,601,0.01,"Kovaikulam, Tirunelveli"],
"627152":[280,608,0.0,"Sengulam, Tirunelveli"],
"627201":[330,558,0.07,"Kalakudi, Tirunelveli"],
"627202":[345,778,0.02,"Vagaikulam, Tirunelveli"],
"627351":[255,621,0.01,"Kilapattam, Tirunelveli"],
"627352":[300,621,0.01,"Kilakottai Kailasapuram, Tuticorin"],
"627353":[315,637,0.04,"Manapadaiveedu, Tirunelveli"],
"627354":[268,913,0.19,"Alwaneri, Tirunelveli"],
"627355":[500,1171,0.18,"Kundakulam, Tirunelveli"],
"627356":[315,809,0.06,"Kila Omanallur, Tirunelveli"],
"627357":[315,657,0.06,"Karaieruppu, Tirunelveli"],
"627358":[340,785,0.04,"Azhaganeri, Tirunelveli"],
"627359":[255,585,0.05,"Palamadai, Tirunelveli"],
"627401":[190,605,0.03,"Ambasamudram, Tirunelveli"],
"627412":[230,641,0.01,"Merku Alwarkurichi, Tenkasi"],
"627413":[215,705,0.02,"Rengasamudram, Tenkasi"],
"627414":[458,939,0.04,"Karisalpatti, Tirunelveli"],
"627415":[260,716,0.03,"Mathapuram, Tenkasi"],
"627416":[190,594,0.02,"Kodarankulam, Tirunelveli"],
"627417":[315,744,0.0,"Kuniyur, Tirunelveli"],
"627418":[190,581,0.02,"Ayanthiruvaleeswaram, Tirunelveli"],
"627420":[190,480,0.02,"Manjolai, Tirunelveli"],
"627421":[170,514,0.03,"Aladiyur, Tirunelveli"],
"627422":[190,553,0.03,"Papanasam Mills, Tirunelveli"],
"627423":[240,669,0.01,"Pappangulam, Tenkasi"],
"627424":[235,567,0.03,"Govindaperi, Tenkasi"],
"627425":[180,532,0.03,"Papanasam Upper Dam, Tirunelveli"],
"627426":[220,791,0.01,"Attalanallur, Tirunelveli"],
"627427":[200,457,0.03,"Oothu, Tirunelveli"],
"627428":[268,867,0.18,"Agasthiyarpatti, Tirunelveli"],
"627451":[315,786,0.04,"Gopalasamudram, Tirunelveli"],
"627452":[315,871,0.03,"Melaseval, Tirunelveli"],
"627453":[600,965,0.03,"Karisulnthamangalam, Tirunelveli"],
"627501":[255,513,0.03,"Kilakku Kalakkadu, Tirunelveli"],
"627502":[315,617,0.01,"Devanallur, Tirunelveli"],
"627601":[288,862,0.03,"Singamparai, Tirunelveli"],
"627602":[255,1077,0.03,"Kabaliparai, Tirunelveli"],
"627603":[282,843,0.04,"Vadakku Ariyanayagipuram Petta, Tirunelveli"],
"627604":[458,945,0.04,"Suttamally Vilakku, Tirunelveli"],
"627651":[298,652,0.03,"Kooduthalai, Tirunelveli"],
"627652":[350,1052,0.12,"Suviseshapuram, Tirunelveli"],
"627654":[245,570,0.03,"Anaikkarai, Tirunelveli"],
"627657":[485,813,0.07,"Karaichuthupudur, Tirunelveli"],
"627713":[275,463,0.06,"Sippiparai, Virudhunagar"],
"627719":[478,919,0.02,"Kalingapatti, Tenkasi"],
"627751":[415,1488,0.03,"CHOCKAMPATTI, Tenkasi"],
"627753":[444,1158,0.02,"Pandapuli, Tenkasi"],
"627754":[502,792,0.02,"Sathirakondan, Tenkasi"],
"627755":[473,1141,0.03,"Malayadikurichi, Tenkasi"],
"627756":[442,910,0.02,"Sankarankovil, Tenkasi"],
"627757":[550,1038,0.01,"Arugankulam, Tenkasi"],
"627758":[410,855,0.01,"Ariyur, Tenkasi"],
"627759":[415,1325,0.03,"Krishnapuram (TVL), Tenkasi"],
"627760":[410,795,0.01,"Naranapuram, Tenkasi"],
"627761":[442,922,0.02,"Periyur, Tenkasi"],
"627764":[442,941,0.01,"Duraisamypuram, Tenkasi"],
"627802":[330,757,0.02,"Kasimajorpuram, Tenkasi"],
"627803":[415,894,0.02,"ACHANPUTHUR, Tenkasi"],
"627804":[500,1083,0.04,"Kodikurichi, Tenkasi"],
"627805":[330,723,0.01,"Ayyapuram, Tenkasi"],
"627806":[500,1029,0.07,"Melapavur, Tenkasi"],
"627807":[335,846,0.01,"Karisalkudiyiruppu, Tenkasi"],
"627808":[458,759,0.02,"Sivanadanur, Tenkasi"],
"627809":[335,701,0.02,"Melur, Tenkasi"],
"627811":[335,881,0.03,"Tenkasi, Tenkasi"],
"627812":[335,835,0.01,"Vadakaraikilpidagai, Tenkasi"],
"627813":[330,616,0.0,"Karkudi, Tenkasi"],
"627814":[375,939,0.04,"Gunaramanallur, Tenkasi"],
"627818":[375,942,0.03,"Melagaram, Tenkasi"],
"627851":[255,822,0.02,"Kalathimadam, Tenkasi"],
"627852":[458,1111,0.04,"Agarakattu, Tenkasi"],
"627853":[382,876,0.02,"Sivalarkulam, Tenkasi"],
"627854":[302,1028,0.02,"Venkateswarapuram, Tenkasi"],
"627855":[442,1169,0.03,"Chinthamani, Tenkasi"],
"627856":[415,1104,0.04,"Poigai, Tenkasi"],
"627857":[473,1174,0.03,"Ichanda, Tenkasi"],
"627858":[500,1114,0.05,"SUNDARAPANDIAPURAM, Tenkasi"],
"627859":[530,1230,0.06,"Anaikulam, Tenkasi"],
"627860":[345,943,0.03,"Karuvanda, Tenkasi"],
"627861":[380,971,0.04,"Veeranam, Tenkasi"],
"627862":[473,906,0.03,"Kulasekaramangalam, Tenkasi"],
"627951":[354,798,0.01,"Muthammalpuram, Tenkasi"],
"627953":[528,907,0.02,"BALABATHRARAMAPURAM, Tenkasi"],
"628001":[517,2599,0.02,"Tuticorin, Tuticorin"],
"628002":[500,2727,0.02,"Milavittan R S, Tuticorin"],
"628003":[403,2066,0.02,"Tuticorin courts, Tuticorin"],
"628004":[509,2272,0.02,"Tt. Thermal Power Plant, Tuticorin"],
"628005":[489,1696,0.02,"Athimarapatti, Tuticorin"],
"628006":[411,1302,0.03,"Thermal Nagagr, Tuticorin"],
"628007":[486,1658,0.02,"Heavy Water Project Colony, Tuticorin"],
"628008":[513,2349,0.02,"Madathur, Tuticorin"],
"628101":[443,1545,0.03,"Maravanmadam, Tuticorin"],
"628102":[236,714,0.04,"Thimmarajapuraam, Tuticorin"],
"628103":[325,782,0.03,"Kootampuli, Tuticorin"],
"628104":[278,638,0.04,"Chockalingapuram, Tuticorin"],
"628105":[587,2010,0.02,"Duraisamypuram, Tuticorin"],
"628151":[406,1106,0.04,"Keeranur, Tuticorin"],
"628152":[405,1205,0.03,"Kovankadu, Tuticorin"],
"628155":[419,1250,0.03,"Punnakayal, Tuticorin"],
"628201":[396,1003,0.03,"Moolakarai, Tuticorin"],
"628202":[397,1011,0.03,"Kandasamypuram, Tuticorin"],
"628203":[425,955,0.06,"Kootankadu, Tuticorin"],
"628204":[384,994,0.03,"Kayalpatnam Bazaar, Tuticorin"],
"628205":[316,973,0.03,"Mela Tiruchendur, Tuticorin"],
"628206":[342,842,0.04,"Kallamozhi, Tuticorin"],
"628207":[525,1312,0.03,"Sethukuvaithan, Tuticorin"],
"628208":[335,961,0.03,"Seerkatchi, Tuticorin"],
"628209":[335,809,0.04,"Manapad, Tuticorin"],
"628210":[522,1055,0.11,"Lakshmipuram, Tuticorin"],
"628211":[500,1099,0.14,"Idaiyanvilai, Tuticorin"],
"628212":[525,1311,0.03,"Viramanickam, Tuticorin"],
"628213":[335,1013,0.03,"Seerudaiyarpuram, Tuticorin"],
"628215":[335,1389,0.04,"Tiruchendur, Tuticorin"],
"628216":[335,1230,0.03,"Tiruchendur Devasthanam, Tuticorin"],
"628217":[403,2066,0.02,"Adaikalapuram, Tuticorin"],
"628218":[316,1015,0.03,"Pallipathu, Tuticorin"],
"628219":[316,940,0.03,"Pitchivilai, Tuticorin"],
"628229":[384,913,0.04,"Sahupuram, Tuticorin"],
"628251":[325,796,0.04,"Kattalangulam, Tuticorin"],
"628252":[255,612,0.02,"Vasavappapuram, Tuticorin"],
"628301":[280,1414,0.02,"Dalavaipuram, Tuticorin"],
"628302":[300,675,0.03,"Muramban, Tuticorin"],
"628303":[320,637,0.03,"Akkanaickenpatti, Tuticorin"],
"628304":[328,1329,0.03,"Melatattaparai, Tuticorin"],
"628401":[551,1591,0.02,"Kulasekaranallur, Tuticorin"],
"628402":[280,1553,0.02,"Pudupatcheri, Tuticorin"],
"628501":[419,567,0.05,"Kovilpatti, Tuticorin"],
"628502":[378,665,0.01,"Kovilpatti North, Tuticorin"],
"628503":[378,688,0.04,"Alampatti, Tuticorin"],
"628552":[528,702,0.03,"Karadikulam, Tuticorin"],
"628601":[570,689,0.04,"Srivaikuntam, Tuticorin"],
"628612":[570,955,0.04,"Alwarthope West, Tuticorin"],
"628613":[522,1420,0.15,"Therkankulam, Tuticorin"],
"628614":[765,974,0.04,"Kadayanodaiai, Tuticorin"],
"628615":[546,876,0.03,"Karungulam, Tuticorin"],
"628616":[198,749,0.04,"Nazareth R S, Tuticorin"],
"628617":[545,1122,0.12,"Vellamadam, Tuticorin"],
"628618":[411,1071,0.04,"Pattakarai, Tuticorin"],
"628619":[358,681,0.03,"Arampannai, Tuticorin"],
"628620":[375,1120,0.04,"Perur, Tuticorin"],
"628621":[570,789,0.04,"Athichanallur, Tuticorin"],
"628622":[280,1109,0.11,"Cherakulam, Tuticorin"],
"628623":[335,1200,0.03,"Kurangani, Tuticorin"],
"628653":[342,938,0.07,"Naduvakurichi, Tuticorin"],
"628656":[350,871,0.06,"Idaichivilai, Tuticorin"],
"628701":[622,1288,0.14,"Palankulam, Tuticorin"],
"628702":[350,989,0.1,"Anbinnagaram, Tuticorin"],
"628703":[342,882,0.06,"Periyathalai, Tuticorin"],
"628704":[500,1286,0.16,"Kalinguvilai, Tuticorin"],
"628712":[495,1486,0.03,"Arungulam, Tuticorin"],
"628714":[335,1010,0.0,"Ilavelangal, Tuticorin"],
"628716":[335,937,0.03,"Villiseri, Tuticorin"],
"628718":[530,1397,0.05,"Sillankulam, Tuticorin"],
"628720":[452,1356,0.0,"Koppampatti, Tuticorin"],
"628721":[528,658,0.03,"Alagappapuram, Tuticorin"],
"628722":[604,1800,0.01,"Vedanatham, Tuticorin"],
"628751":[325,865,0.04,"Pandaravilai, Tuticorin"],
"628752":[403,2066,0.02,"Perungulam S.O (Tuticorin), Tuticorin"],
"628753":[375,953,0.04,"Sivagalai, Tuticorin"],
"628801":[275,813,0.04,"Vallavallan, Tuticorin"],
"628802":[275,842,0.04,"Maramangalam, Tuticorin"],
"628809":[340,626,0.03,"Vittilapuram, Tuticorin"],
"628851":[280,702,0.04,"Singathakurichi, Tuticorin"],
"628901":[360,1316,0.04,"THATTANERI, Tuticorin"],
"628902":[452,1069,0.01,"Padanthapuli, Tuticorin"],
"628903":[491,1791,0.01,"Kilavaippar, Tuticorin"],
"628904":[275,847,0.05,"Kilakarandai, Tuticorin"],
"628905":[295,688,0.04,"Kandasamypuram, Tuticorin"],
"628906":[505,1772,0.02,"PERIASAMIPURAM, Tuticorin"],
"628907":[310,1137,0.01,"Vadamalaisamudram, Tuticorin"],
"628908":[530,1486,0.03,"Sholapuram, Tuticorin"],
"628952":[335,674,0.01,"Athikulam, Tuticorin"],
"629001":[248,740,0.01,"Nagercoil, Kanniyakumari"],
"629002":[268,767,0.01,"Edalakudy, Kanniyakumari"],
"629003":[258,633,0.02,"Peruvilai, Kanniyakumari"],
"629004":[268,675,0.02,"Erumbukadu, Kanniyakumari"],
"629101":[95,340,0.03,"Maruthemparai, Kanniyakumari"],
"629102":[150,341,0.02,"Kodayarkilthangal, Kanniyakumari"],
"629151":[88,240,0.02,"Chitharal, Kanniyakumari"],
"629152":[85,279,0.02,"Meppalai, Kanniyakumari"],
"629153":[85,267,0.01,"Kulapuram, Kanniyakumari"],
"629154":[90,387,0.02,"Nithiravilai, Kanniyakumari"],
"629155":[128,343,0.02,"Kanjiracode, Kanniyakumari"],
"629156":[128,441,0.02,"Kappiyarai, Kanniyakumari"],
"629157":[100,440,0.02,"Mangarai, Kanniyakumari"],
"629158":[128,382,0.03,"Eravipudurkadai, Kanniyakumari"],
"629159":[128,404,0.01,"Alanchi, Kanniyakumari"],
"629160":[88,411,0.02,"Palavilai, Kanniyakumari"],
"629161":[117,335,0.03,"Ponmanai, Kanniyakumari"],
"629162":[100,356,0.02,"Mulankuzhi, Kanniyakumari"],
"629163":[104,293,0.01,"Vanniyur, Kanniyakumari"],
"629164":[129,391,0.03,"Mukkampala, Kanniyakumari"],
"629165":[114,330,0.02,"Nallur marthandam, Kanniyakumari"],
"629166":[129,390,0.03,"Verkilambi, Kanniyakumari"],
"629167":[129,425,0.02,"Kozhiporvilai, Kanniyakumari"],
"629168":[116,326,0.02,"Anducode, Kanniyakumari"],
"629169":[128,393,0.02,"Kanjikuzhi, Kanniyakumari"],
"629170":[76,276,0.01,"Manivilai, Kanniyakumari"],
"629171":[95,376,0.02,"Elavuvilai, Kanniyakumari"],
"629172":[85,335,0.02,"Methukummal, Kanniyakumari"],
"629173":[90,401,0.02,"Painkulam, Kanniyakumari"],
"629174":[129,473,0.03,"Keralapuram, Kanniyakumari"],
"629175":[148,496,0.03,"Thuckalay, Kanniyakumari"],
"629176":[88,414,0.02,"Poothurai, Kanniyakumari"],
"629177":[129,288,0.03,"Chenkody, Kanniyakumari"],
"629178":[114,397,0.02,"Mangalakunnu, Kanniyakumari"],
"629179":[100,300,0.02,"Unnamalakada, Kanniyakumari"],
"629180":[248,501,0.02,"Kumaracoil, Kanniyakumari"],
"629193":[100,424,0.02,"Enayam, Kanniyakumari"],
"629201":[258,589,0.02,"Santhapuram, Kanniyakumari"],
"629202":[221,485,0.02,"Azhikkal, Kanniyakumari"],
"629203":[248,509,0.02,"Saral Agasteeswaram, Kanniyakumari"],
"629204":[248,476,0.02,"Kalpadi, Kanniyakumari"],
"629251":[162,365,0.01,"Vaniyakudi, Kanniyakumari"],
"629252":[248,549,0.02,"Mondaikad, Kanniyakumari"],
"629301":[268,425,0.01,"Kumarapuram, Kanniyakumari"],
"629302":[230,641,0.01,"Vellamadam, Kanniyakumari"],
"629401":[249,643,0.02,"Variyoor, Kanniyakumari"],
"629402":[268,676,0.01,"Eraviputhur, Kanniyakumari"],
"629403":[268,689,0.02,"Kulasekharapuram, Kanniyakumari"],
"629501":[248,674,0.01,"North Soorankudy, Kanniyakumari"],
"629502":[248,547,0.02,"Rajakkamangalam, Kanniyakumari"],
"629601":[284,802,0.02,"Pallam, Kanniyakumari"],
"629602":[284,792,0.02,"Melamanakudy, Kanniyakumari"],
"629701":[268,734,0.02,"Therku Thamaraikulam, Kanniyakumari"],
"629702":[268,750,0.03,"Kovalam, Kanniyakumari"],
"629703":[249,696,0.02,"Potraiyadi, Kanniyakumari"],
"629704":[268,721,0.01,"Devakulam, Kanniyakumari"],
"629801":[248,527,0.02,"Kattimancode, Kanniyakumari"],
"629802":[195,362,0.03,"Kannattuvilai, Kanniyakumari"],
"629803":[130,373,0.02,"Konamkadu, Kanniyakumari"],
"629804":[128,373,0.02,"Chemponvilai, Kanniyakumari"],
"629809":[248,508,0.02,"Peyankuzhi, Kanniyakumari"],
"629810":[221,470,0.02,"Kandanvilai, Kanniyakumari"],
"629851":[221,511,0.02,"Maramalai, Kanniyakumari"],
"629852":[268,643,0.01,"Tittivilai, Kanniyakumari"],
"629901":[258,670,0.01,"Thirupathisaram, Kanniyakumari"],
"630001":[310,782,0.12,"Karaikudi, Sivaganga"],
"630002":[325,823,0.12,"Karaikudi Southstreet, Sivaganga"],
"630003":[325,808,0.13,"Alagappapuram, Sivaganga"],
"630005":[295,591,0.12,"Devakottai Road, Sivaganga"],
"630101":[420,1560,0.09,"Chockalingampudur, Sivaganga"],
"630102":[405,1475,0.07,"Chettinad, Sivaganga"],
"630103":[424,1496,0.0,"Nemathanpatti, Sivaganga"],
"630104":[325,632,0.22,"Kandanurperumalkoil, Sivaganga"],
"630105":[405,1380,0.09,"Lakshmipuram, Sivaganga"],
"630106":[325,814,0.16,"K.Alagapuri, Sivaganga"],
"630107":[405,1249,0.11,"Ac.School, Sivaganga"],
"630108":[325,373,0.17,"Sakkottai, Sivaganga"],
"630201":[520,1741,0.0,"Vanjinipatti, Sivaganga"],
"630202":[310,581,0.14,"Unjanai, Sivaganga"],
"630203":[380,1607,0.0,"Vaiyakalathur, Sivaganga"],
"630204":[281,1055,0.08,"Naduvikottai, Sivaganga"],
"630205":[420,1450,0.02,"Avanipatti, Sivaganga"],
"630206":[342,1197,0.04,"Koratti, Sivaganga"],
"630207":[435,1326,0.03,"Kambanur, Sivaganga"],
"630208":[390,1193,0.1,"Palavangudi, Sivaganga"],
"630210":[480,1505,0.01,"Bhramanampatti, Sivaganga"],
"630211":[480,1525,0.0,"Ayyapatti, Sivaganga"],
"630212":[461,1632,0.02,"N.Vairavanpatti, Sivaganga"],
"630301":[235,498,0.11,"Amaravathipudur, Sivaganga"],
"630302":[456,1238,0.12,"Devakottai, Sivaganga"],
"630303":[462,1271,0.13,"Arakottai, Sivaganga"],
"630305":[235,456,0.14,"ASiruvayal, Sivaganga"],
"630306":[358,699,0.15,"Visalayankottai, Sivaganga"],
"630307":[325,846,0.12,"Kovilur, Sivaganga"],
"630309":[587,1274,0.02,"Musundapatti, Sivaganga"],
"630311":[265,1545,0.11,"Velayuthapattinam, Sivaganga"],
"630312":[920,2539,0.05,"Neivayal, Sivaganga"],
"630313":[407,861,0.08,"Chockanathapuram, Sivaganga"],
"630314":[295,447,0.13,"Kandadevi, Sivaganga"],
"630321":[353,1307,0.22,"AKarungulam, Sivaganga"],
"630405":[233,876,0.0,"Tuvar, Sivaganga"],
"630408":[726,2181,0.12,"Sekkakudi, Sivaganga"],
"630410":[710,1106,0.01,"Kilavayal, Sivaganga"],
"630411":[471,2333,0.19,"Thirani, Sivaganga"],
"630501":[520,1669,0.0,"Kallampatti, Sivaganga"],
"630502":[558,1388,0.0,"Kirungakottai, Sivaganga"],
"630551":[471,1340,0.27,"KSukkanurani, Sivaganga"],
"630552":[380,1287,0.04,"Salur, Sivaganga"],
"630553":[470,1271,0.03,"Kattanipatti, Sivaganga"],
"630554":[561,1391,0.18,"Melamarungur, Sivaganga"],
"630555":[335,537,0.18,"Satharasanpatti, Sivaganga"],
"630556":[380,777,0.22,"Alagapuri, Sivaganga"],
"630557":[471,919,0.05,"Nalukottai, Sivaganga"],
"630558":[471,855,0.05,"Nagarampatti, Sivaganga"],
"630559":[335,1084,0.0,"Vembattur, Sivaganga"],
"630561":[426,1250,0.08,"Sivaganga, Sivaganga"],
"630562":[360,1185,0.02,"Enathi, Sivaganga"],
"630566":[480,1470,0.01,"Aralikottai, Sivaganga"],
"630602":[331,903,0.0,"Muthanendhal, Sivaganga"],
"630606":[340,689,0.01,"Manamadurai, Sivaganga"],
"630609":[340,808,0.01,"Milaganoor, Sivaganga"],
"630610":[331,941,0.0,"Kattanur, Virudhunagar"],
"630611":[115,449,-1,"AMukkulam, Sivaganga"],
"630612":[411,941,0.0,"Keeladi, Sivaganga"],
"630702":[420,1719,0.2,"Ariyandipuram, Sivaganga"],
"630709":[523,1514,0.19,"Kannamangalam, Sivaganga"],
"630710":[435,1363,0.18,"Vandal, Sivaganga"],
"630713":[671,1927,0.14,"Akkavayal, Sivaganga"],
"631001":[350,729,0.02,"Arakkonam, Ranipet"],
"631002":[408,831,0.03,"Kilandurai, Ranipet"],
"631003":[465,1025,0.03,"Chitteri, Ranipet"],
"631004":[460,975,0.02,"Mosur, Ranipet"],
"631005":[316,359,0.07,"Winterpet, Ranipet"],
"631006":[385,1079,0.03,"Ins Rajali, Ranipet"],
"631051":[253,640,0.09,"Pallur, Ranipet"],
"631052":[370,518,0.2,"Ulianallore, Ranipet"],
"631101":[408,916,0.03,"Nandiveduthangal, Ranipet"],
"631102":[350,720,0.02,"Karikkal, Ranipet"],
"631151":[350,720,0.02,"Iluppaithandalam, Ranipet"],
"631152":[200,458,0.0,"Suraksha Cisf Campus, Ranipet"],
"631201":[397,1293,0.09,"Nemili, Thiruvallur"],
"631202":[482,1265,0.07,"Konasamudram, Thiruvallur"],
"631203":[385,1059,0.21,"Kaivandur, Thiruvallur"],
"631204":[385,1246,0.09,"Arcot, Thiruvallur"],
"631205":[482,1265,0.07,"Beerakuppam, Thiruvallur"],
"631206":[465,1219,0.07,"Krishnasamudram, Thiruvallur"],
"631207":[220,413,0.0,"Karimbedu, Thiruvallur"],
"631208":[420,1105,0.13,"Jangalapalli, Thiruvallur"],
"631209":[465,1238,0.07,"Agooru, Thiruvallur"],
"631210":[385,1221,0.02,"Athipattu, Thiruvallur"],
"631211":[482,1265,0.07,"Karthikeyapuram, Thiruvallur"],
"631212":[570,1309,0.08,"Nallathur, Thiruvallur"],
"631213":[482,1265,0.07,"Alamelumangapuram, Thiruvallur"],
"631301":[518,1111,0.1,"Kadananagaram, Thiruvallur"],
"631302":[385,1112,0.17,"Myladumparai, Thiruvallur"],
"631303":[316,359,0.07,"Ammaneri, Thiruvallur"],
"631304":[465,1236,0.07,"Rajanagaram, Thiruvallur"],
"631402":[340,981,0.27,"Kondancheri, Thiruvallur"],
"631501":[450,2040,0.09,"Kanchipuram, Kanchipuram"],
"631502":[450,1687,0.08,"Orikkai, Kanchipuram"],
"631551":[450,1920,0.09,"Krishnapuram, Kanchipuram"],
"631552":[450,1921,0.09,"Karai, Kanchipuram"],
"631553":[610,1788,0.05,"Pichivakkam, Kanchipuram"],
"631561":[450,1880,0.09,"Singadivakkam, Kanchipuram"],
"631601":[450,1920,0.09,"Thenambakkam, Kanchipuram"],
"631603":[450,1921,0.09,"Puthali, Kanchipuram"],
"631604":[700,1481,0.13,"Varanavasi, Kanchipuram"],
"631605":[350,1184,0.04,"Nathanallur, Kanchipuram"],
"631606":[450,823,0.02,"Madhur, Kanchipuram"],
"631701":[350,988,0.06,"Madipakkam, Tiruvannamalai"],
"631702":[444,1239,0.07,"Chinnaelacheri, Tiruvannamalai"],
"632001":[450,950,0.0,"Vellore, Vellore"],
"632002":[460,1638,0.01,"Palamathi, Vellore"],
"632004":[500,1064,0.0,"Bakiyath, Vellore"],
"632006":[510,1103,0.01,"Senur, Vellore"],
"632007":[500,1231,0.0,"Katpadi Agricultural Farm, Vellore"],
"632008":[412,1088,0.13,"Shenbakkam, Vellore"],
"632009":[440,1553,0.01,"Alamelumangapuram, Vellore"],
"632010":[510,1191,0.0,"Melmonavur, Vellore"],
"632011":[405,938,0.0,"A Kattupadi, Vellore"],
"632012":[450,959,0.0,"Saidapet S.O (Vellore), Vellore"],
"632013":[459,2013,0.06,"Karugambathur, Vellore"],
"632014":[450,1128,0.0,"Brahmapuram, Vellore"],
"632055":[510,1098,0.01,"Ariyur Spinning Mills, Vellore"],
"632057":[420,-1,0.0,"Munjurpattu, Vellore"],
"632058":[375,666,0.05,"Kattuputhur, Vellore"],
"632059":[500,1243,0.0,"Christianpet, Vellore"],
"632101":[520,1448,0.03,"Appukkal, Vellore"],
"632102":[363,830,0.03,"Nammiyambattu, Tiruvannamalai"],
"632103":[520,1068,0.0,"Nemandapuram, Vellore"],
"632104":[500,1222,0.02,"Erayangadu, Vellore"],
"632105":[500,1181,0.02,"Budur, Vellore"],
"632106":[441,1150,0.0,"Serkadu, Vellore"],
"632107":[475,826,0.0,"Arimalai, Vellore"],
"632113":[400,927,-1,"Tellai, Vellore"],
"632114":[500,1180,0.02,"Poigai Mottur, Vellore"],
"632115":[450,959,0.0,"Thiruvalluvar University, Vellore"],
"632201":[510,1310,0.04,"Perumankuppam, Vellore"],
"632202":[510,1212,0.01,"Panamadangi, Vellore"],
"632203":[520,1090,0.02,"Melmankuppam, Vellore"],
"632204":[500,1279,0.03,"Mudinambattu, Vellore"],
"632209":[520,1161,0.04,"Kanguppam, Vellore"],
"632301":[472,1061,0.02,"Arni, Tiruvannamalai"],
"632311":[408,900,0.03,"Kalasamudram, Tiruvannamalai"],
"632312":[280,657,0.01,"Kilarasampattu, Vellore"],
"632313":[280,657,0.01,"Indiravanam, Tiruvannamalai"],
"632314":[280,657,0.01,"Agraharapalayam, Tiruvannamalai"],
"632315":[412,748,0.02,"Ananthapuram, Tiruvannamalai"],
"632316":[280,657,0.01,"Nesal, Tiruvannamalai"],
"632317":[642,1193,0.07,"Paiyur, Tiruvannamalai"],
"632318":[479,1943,0.03,"Melapudupakkam, Ranipet"],
"632319":[465,1000,0.01,"Varagur Pudur, Vellore"],
"632326":[408,1031,0.03,"Thatchur, Tiruvannamalai"],
"632401":[479,2416,0.01,"Ranipet, Ranipet"],
"632403":[535,2116,0.01,"Ranipet Industrial Estate, Ranipet"],
"632404":[479,2298,0.01,"Manthangal, Ranipet"],
"632405":[479,2127,0.01,"Ekambaranallur, Ranipet"],
"632406":[450,959,0.0,"Bhel Ranipet, Ranipet"],
"632501":[479,2127,0.01,"Kalmelkuppam, Ranipet"],
"632502":[350,720,0.02,"Kattupakkam, Ranipet"],
"632503":[479,1943,0.03,"Muppathuvetti, Ranipet"],
"632504":[479,1943,0.03,"Valayathur, Ranipet"],
"632505":[135,834,0.2,"Palayapalayamottur, Ranipet"],
"632506":[630,1408,0.01,"Agaram, Ranipet"],
"632507":[479,1943,0.03,"Sambasivapuram, Ranipet"],
"632508":[479,2127,0.01,"Seri, Ranipet"],
"632509":[479,2073,0.02,"Federation Buildings, Ranipet"],
"632510":[350,720,0.02,"Paravathur, Ranipet"],
"632511":[685,1884,0.01,"Vadailluppai, Tiruvannamalai"],
"632512":[630,1721,0.01,"Mohamedpet, Ranipet"],
"632513":[479,2059,0.01,"Anandhalai, Ranipet"],
"632514":[275,1328,0.0,"Vasur, Ranipet"],
"632515":[470,1258,0.0,"Gugainallore, Vellore"],
"632516":[440,1591,0.01,"Kuppireddithangal, Vellore"],
"632517":[479,2127,0.01,"Kilminnal, Ranipet"],
"632518":[630,1718,0.01,"Senganavaram, Ranipet"],
"632519":[441,1440,0.01,"Eranthangal, Vellore"],
"632520":[441,1221,0.0,"Kokkeri, Vellore"],
"632521":[479,1918,0.02,"Uppupettai, Ranipet"],
"632531":[410,1337,0.1,"Ayarpadi, Ranipet"],
"632601":[465,1022,0.04,"Kallapadi, Vellore"],
"632602":[410,909,0.02,"Gudiyattam, Vellore"],
"632603":[485,698,0.04,"Viludonpalayam, Vellore"],
"632604":[310,726,0.0,"Mordhana, Vellore"],
"635001":[423,1073,0.0,"Krishnagiri, Krishnagiri"],
"635002":[435,1167,0.0,"Pothinayanapalli, Krishnagiri"],
"635101":[435,1167,0.0,"Kalvehalli, Krishnagiri"],
"635102":[327,557,0.02,"Thagatti, Krishnagiri"],
"635103":[435,618,0.0,"Baliganapalli, Krishnagiri"],
"635104":[423,1050,0.0,"Madepalli, Krishnagiri"],
"635105":[460,958,0.0,"Nandimangalam, Krishnagiri"],
"635106":[435,1167,0.0,"Errasigalahalli, Dharmapuri"],
"635107":[515,1103,0.02,"Bikkanapalli, Krishnagiri"],
"635108":[435,1183,0.0,"Balanayanapalli, Krishnagiri"],
"635109":[410,674,0.0,"Avalapalli, Krishnagiri"],
"635110":[500,877,0.01,"Achettipalli, Krishnagiri"],
"635111":[588,1284,0.02,"Devarmukkulam, Dharmapuri"],
"635112":[435,1167,0.0,"Kadhiripuram, Krishnagiri"],
"635113":[500,986,0.02,"Bairamangalam, Krishnagiri"],
"635114":[435,546,0.0,"Chinnappareddipalayam, Krishnagiri"],
"635115":[345,1010,0.11,"Beerpalli, Krishnagiri"],
"635116":[370,1282,0.02,"Baliganur, Krishnagiri"],
"635117":[435,618,0.0,"Chembarasanapalli, Krishnagiri"],
"635118":[620,899,0.0,"Binnamangalam, Krishnagiri"],
"635119":[420,845,0.02,"Senamavu, Krishnagiri"],
"635120":[435,1167,0.0,"Kammampalli, Krishnagiri"],
"635121":[435,1167,0.0,"Kottur, Krishnagiri"],
"635122":[435,1167,0.0,"Agaram Ittikkal, Krishnagiri"],
"635123":[423,1050,0.0,"Thatrahalli, Krishnagiri"],
"635124":[423,1167,0.0,"Belathur, Krishnagiri"],
"635126":[410,517,0.0,"Begepalli, Krishnagiri"],
"635130":[435,618,0.0,"Bukkasagaram, Krishnagiri"],
"635201":[462,881,0.03,"Thathampatti, Krishnagiri"],
"635202":[536,1016,0.03,"Kelavalli, Dharmapuri"],
"635203":[423,1050,0.0,"Aikondamkothapalli, Krishnagiri"],
"635204":[423,1167,0.0,"Avathavadi, Krishnagiri"],
"635205":[515,966,0.02,"Kannipatti, Dharmapuri"],
"635206":[435,1285,0.0,"Puliampatti, Krishnagiri"],
"635207":[650,1010,0.06,"Mannadapatti, Krishnagiri"],
"635301":[410,971,0.0,"Thippireddihalli, Dharmapuri"],
"635302":[557,1098,0.0,"Kurubarahalli, Dharmapuri"],
"635303":[518,1014,0.02,"Ranimookanur, Dharmapuri"],
"635304":[560,1090,0.06,"Anandur, Krishnagiri"],
"635305":[560,1286,0.04,"Gobichettipalayam, Dharmapuri"],
"635306":[565,1147,0.06,"Anderipatti, Krishnagiri"],
"635307":[490,911,0.04,"Andiyur, Krishnagiri"],
"635601":[690,2486,0.02,"Tirupattur, Tirupathur"],
"635602":[690,2444,0.02,"Karuppanur, Tirupathur"],
"635651":[690,2156,0.01,"Parandapalli, Tirupathur"],
"635652":[607,1780,0.05,"Perambattu, Tirupathur"],
"635653":[620,2611,0.03,"Selandampalli, Tirupathur"],
"635654":[600,1890,0.03,"Kakangarai R.S., Tirupathur"],
"635655":[513,1468,0.04,"Kilur, Tirupathur"],
"635701":[475,1130,0.01,"Narasingapuram, Tirupathur"],
"635702":[620,2395,0.0,"Kurusilapattu, Tirupathur"],
"635703":[404,940,0.01,"Kovilur, Tiruvannamalai"],
"635710":[460,1502,0.01,"Marimanikuppam, Tirupathur"],
"635751":[455,1403,0.03,"Girisamudram, Tirupathur"],
"635752":[475,1654,0.01,"Kothakottai, Tirupathur"],
"635754":[500,1585,0.03,"Ilayanagaram, Tirupathur"],
"635801":[410,1120,0.03,"Thimmampet, Tirupathur"],
"635802":[420,1851,0.02,"Thennambattu, Tirupathur"],
"635803":[520,986,0.03,"Kilalathur, Vellore"],
"635804":[420,947,0.01,"Karungali, Vellore"],
"635805":[430,1027,0.0,"Pallalakuppam, Vellore"],
"635806":[465,967,0.02,"Melmuttukur, Vellore"],
"635807":[500,1811,0.02,"Vinnamangalam, Tirupathur"],
"635808":[500,2104,0.01,"Kottur, Vellore"],
"635809":[520,1141,0.03,"Kandaneri, Vellore"],
"635810":[420,1230,0.0,"Aravatla, Vellore"],
"635811":[500,2169,0.02,"Kadhavalam, Tirupathur"],
"635812":[494,1146,0.0,"Kilmurungai, Tirupathur"],
"635813":[420,988,0.0,"Ulli, Vellore"],
"635814":[465,1672,0.02,"Alankuppam, Tirupathur"],
"635815":[515,1282,0.02,"Athurkuppam, Tirupathur"],
"635851":[515,1786,0.02,"Mandalavadi, Tirupathur"],
"635852":[760,1906,0.0,"Vettapattu, Tirupathur"],
"635853":[548,2071,0.01,"Yelagiri Hills, Tirupathur"],
"635854":[600,1645,0.0,"Velakalnatham, Tirupathur"],
"635901":[585,1947,0.01,"Nariyaneri, Tirupathur"],
"636001":[730,1924,0.15,"Salem, Salem"],
"636002":[730,2085,0.11,"Shevapet, Salem"],
"636003":[600,1698,0.15,"Puthumariamman Koil, Salem"],
"636004":[730,2031,0.12,"Alagapuram, Salem"],
"636005":[730,2187,0.11,"Suramangalam, Salem"],
"636006":[730,2106,0.11,"Karungalpatti, Salem"],
"636007":[670,1652,0.09,"Salem Dt. Court Buildings, Salem"],
"636008":[710,1754,0.11,"Kondappanaickenpatti, Salem"],
"636009":[730,2056,0.11,"Swaminathapuram, Salem"],
"636010":[620,2467,0.1,"Maniyanur, Salem"],
"636011":[710,1918,0.12,"Saminaickenpatti, Salem"],
"636012":[645,1838,0.1,"Vattakadu, Salem"],
"636013":[670,2293,0.1,"Karukkalvadi, Salem"],
"636014":[655,1798,0.12,"Tadampatti, Salem"],
"636015":[710,2053,0.13,"Erumapalayam, Salem"],
"636016":[710,1976,0.12,"Fairlands, Salem"],
"636017":[600,1750,0.1,"Allikuttai, Salem"],
"636030":[750,2321,0.13,"Sarkar Kollapatti, Salem"],
"636101":[440,1109,0.01,"Puliyankurichi, Salem"],
"636102":[490,746,0.07,"Atur, Salem"],
"636103":[600,1464,0.09,"Masinaickenpatti, Salem"],
"636104":[400,1004,1.29,"Aladipatti, Salem"],
"636105":[490,1218,0.01,"Edappadi, Salem"],
"636106":[450,1270,0.28,"Karumapuram, Salem"],
"636107":[400,899,0.65,"Kalarampatti, Salem"],
"636108":[490,823,0.05,"Palaniyapuri, Salem"],
"636109":[445,820,0.99,"Kalpaganur, Salem"],
"636110":[640,1129,0.0,"Palakadu, Salem"],
"636111":[400,929,0.64,"M. Perumapalayam, Salem"],
"636112":[440,1094,0.01,"Varagur, Salem"],
"636113":[600,969,0.0,"Jangammasamudram, Salem"],
"636114":[399,713,1.73,"Pappanaickenpatti, Salem"],
"636115":[515,822,2.5,"Thukkiampalayam, Salem"],
"636116":[660,1316,0.01,"Navalur, Salem"],
"636117":[429,848,1.94,"Kalleripatti, Salem"],
"636118":[550,1369,0.05,"Naraikinar, Namakkal"],
"636119":[445,850,1.28,"Veeragoundanur, Salem"],
"636121":[440,1043,0.03,"Manivilundan, Salem"],
"636122":[525,1375,0.09,"Pallipatti, Salem"],
"636138":[448,822,0.05,"Maniyaragundam, Salem"],
"636139":[370,981,0.66,"Anuppur, Salem"],
"636140":[600,1765,0.1,"Kandashramam, Salem"],
"636141":[565,793,0.07,"Ammampalayam, Salem"],
"636142":[480,1123,0.04,"Unanthangal, Namakkal"],
"636201":[665,2289,0.11,"Nalikalpatti, Salem"],
"636202":[480,961,0.46,"Mathuruttu, Namakkal"],
"636203":[620,2270,0.11,"Ervadi pethampatti, Salem"],
"636204":[620,2047,0.08,"Adikarai, Salem"],
"636301":[665,1921,0.08,"Thottivalasu, Namakkal"],
"636302":[710,2218,0.12,"Mamangam, Salem"],
"636303":[271,619,-1,"Palamalai Hills, Salem"],
"636304":[710,2028,0.13,"Attukaranur, Salem"],
"636305":[645,1815,0.04,"Mattukaranpudur, Salem"],
"636306":[480,1156,0.01,"Puduppalaiyam, Salem"],
"636307":[710,2199,0.1,"Kandampatti, Salem"],
"636308":[665,2893,0.16,"Bairoji Agraharam, Salem"],
"636309":[645,1744,0.07,"Dharapuram, Salem"],
"636351":[620,1807,0.03,"Bommiyampatti, Salem"],
"636352":[585,883,0.01,"Kammampatti, Dharmapuri"],
"636354":[620,1664,0.02,"Kanavaipudur, Salem"],
"636401":[380,679,0.0,"Metturdam, Salem"],
"636402":[411,657,0.0,"Metturdam RS, Salem"],
"636403":[411,701,0.0,"Karumalaikudal, Salem"],
"636404":[411,837,0.0,"Andikarai, Salem"],
"636406":[411,816,0.0,"Mettur Thermal Project, Salem"],
"636451":[531,1492,0.03,"Erakondampatti, Salem"],
"636452":[442,808,0.0,"Masilapalayam, Salem"],
"636453":[380,1129,0.01,"M.Kalipatti, Salem"],
"636454":[380,987,0.0,"Kanakkampatti, Salem"],
"636455":[670,1656,0.1,"Olaipatti, Salem"],
"636456":[411,720,0.0,"Salem Camp, Salem"],
"636457":[411,1039,0.0,"Periavanavasi, Salem"],
"636458":[325,958,0.01,"Koonandiyur, Salem"],
"636501":[461,1262,0.0,"Kuppampatti, Salem"],
"636502":[442,1303,0.04,"Chinnasoragai, Salem"],
"636503":[442,1284,0.04,"Amaragundi, Salem"],
"636601":[300,992,0.04,"Kombuthooki, Salem"],
"636602":[425,1099,0.03,"Asambur, Salem"],
"636701":[572,958,0.03,"Dharmapuri, Dharmapuri"],
"636704":[572,923,0.03,"A.Gollahalli, Dharmapuri"],
"636705":[632,890,0.04,"Ungaranahalli, Dharmapuri"],
"636803":[725,1507,0.02,"Makkanur, Dharmapuri"],
"636804":[630,924,0.04,"Boodanahalli, Dharmapuri"],
"636805":[583,1183,0.01,"M.Maravadi, Dharmapuri"],
"636806":[449,1009,0.01,"Chikkadornabetta, Dharmapuri"],
"636807":[515,1058,0.03,"Ichampatti, Dharmapuri"],
"636808":[583,1183,0.01,"Jertalav, Dharmapuri"],
"636809":[620,1206,0.02,"Padi, Dharmapuri"],
"636810":[620,1206,0.02,"Ajjanahalli, Dharmapuri"],
"636811":[590,969,0.01,"Chinnampalli, Dharmapuri"],
"636812":[583,1183,0.01,"Thumjepalli, Krishnagiri"],
"636813":[780,1575,0.03,"Anjehalli, Dharmapuri"],
"636902":[410,953,0.0,"Hanumantheertham, Krishnagiri"],
"636903":[518,1185,0.04,"Doddampatti, Dharmapuri"],
"636904":[410,970,0.0,"Alapuram, Dharmapuri"],
"636905":[410,968,0.0,"Kokkarapatti, Dharmapuri"],
"636906":[560,1291,0.04,"Gudalur, Dharmapuri"],
"636907":[488,921,0.04,"Avalur, Dharmapuri"],
"637001":[570,1077,0.0,"Namakkal, Namakkal"],
"637002":[570,1038,0.0,"Sanyasikaradu, Namakkal"],
"637003":[570,1567,0.04,"Vallipuram, Namakkal"],
"637013":[355,888,0.0,"Konangipatti, Namakkal"],
"637014":[553,1563,0.08,"Reddipudur, Namakkal"],
"637015":[570,1323,-1,"Ariyur, Namakkal"],
"637017":[512,1335,0.05,"Tolur, Namakkal"],
"637018":[552,1811,0.1,"Dhathathiripuram, Namakkal"],
"637019":[568,1636,0.08,"Kolathupalayam, Namakkal"],
"637020":[462,1014,0.0,"Arasanatham, Namakkal"],
"637021":[428,896,0.01,"Pavithirampudur, Namakkal"],
"637101":[435,1062,0.02,"Alachampalayam, Salem"],
"637102":[480,974,0.02,"Erumaipatti, Salem"],
"637103":[620,1918,0.08,"Irugalur, Salem"],
"637104":[420,890,0.01,"Kaveripatti, Salem"],
"637105":[480,1267,0.02,"Vembaneri, Salem"],
"637107":[480,991,0.02,"Konerippatti, Salem"],
"637201":[582,1788,0.07,"Karichchipalayam, Namakkal"],
"637202":[565,2388,0.01,"Koothampoondi, Namakkal"],
"637203":[565,1602,0.12,"Kavundipalayam, Namakkal"],
"637204":[419,883,0.04,"Irukkur, Namakkal"],
"637205":[582,1536,0.01,"Kuppandapalayam, Namakkal"],
"637206":[530,1588,0.04,"N.Seerapalli, Namakkal"],
"637207":[560,1531,0.06,"M.Rasampalayam, Namakkal"],
"637208":[402,1127,0.03,"Vengarai, Namakkal"],
"637209":[582,1447,0.04,"Chinnathambipalayam, Namakkal"],
"637210":[400,1447,0.18,"Goundampalayam, Namakkal"],
"637211":[547,1387,0.05,"Tiruchengodu, Namakkal"],
"637212":[568,2406,0.05,"Bommanpatti, Namakkal"],
"637213":[496,1136,0.06,"Kurumbalamahadevi, Namakkal"],
"637214":[520,1293,0.11,"Animoor, Namakkal"],
"637215":[510,1251,0.1,"Thokkavadi, Namakkal"],
"637216":[663,2171,0.05,"PERIYAMANALI, Namakkal"],
"637301":[480,1368,0.02,"Kuppanur, Salem"],
"637302":[565,1519,0.01,"Thirumangalam, Namakkal"],
"637303":[435,1136,0.02,"Pallakkapalayam, Namakkal"],
"637304":[415,1138,0.03,"Karuveppampatti, Namakkal"],
"637401":[565,1725,0.09,"Koonavelampatti, Namakkal"],
"637402":[550,1340,0.07,"Kalkurichi, Namakkal"],
"637403":[565,1874,0.09,"Melkallupalayam, Namakkal"],
"637404":[698,922,0.14,"Malaveppankuttai, Namakkal"],
"637405":[360,933,0.05,"Vettambadi, Namakkal"],
"637406":[510,1240,0.05,"Pachudayampalayam, Namakkal"],
"637407":[550,1330,0.03,"Melur, Namakkal"],
"637408":[600,1659,0.07,"Pattanam, Namakkal"],
"637409":[360,883,0.1,"Gandhipuram, Namakkal"],
"637410":[538,1883,0.08,"Thottiapatti, Namakkal"],
"637411":[580,1162,0.08,"Bailnadu, Namakkal"],
"637412":[540,1318,0.06,"Kadiranallur, Namakkal"],
"637415":[510,1088,0.0,"Solakkadu, Namakkal"],
"637501":[610,2035,0.12,"Papparapatti, Salem"],
"637502":[750,1812,0.15,"Kosavapatti, Salem"],
"637503":[592,2154,0.11,"Karumanur, Namakkal"],
"637504":[610,2296,0.13,"Kalparapatty, Salem"],
"637505":[690,2209,0.17,"Alavaipatty, Namakkal"],
"638001":[330,929,0.04,"Erode, Erode"],
"638002":[340,1012,0.04,"Lakkapuram, Erode"],
"638003":[330,980,0.04,"Vairapalayam, Erode"],
"638004":[330,967,0.03,"Peria Semur, Erode"],
"638005":[340,1011,0.01,"Ramanathapuram Pudur, Erode"],
"638006":[345,963,0.04,"Pallipalayam, Namakkal"],
"638007":[405,1157,0.09,"Pappampalayam, Namakkal"],
"638008":[345,958,0.03,"Alampalayam, Namakkal"],
"638009":[315,915,0.03,"Kasipalayam, Erode"],
"638010":[400,1143,0.08,"SPB Colony, Namakkal"],
"638011":[330,937,0.03,"Erode Collectorate, Erode"],
"638012":[330,935,0.02,"Thindal, Erode"],
"638051":[340,844,0.03,"Kandappagoundenvalasu, Erode"],
"638052":[340,935,0.0,"Periyavettuvapalayam, Erode"],
"638053":[350,957,0.0,"Perundurai Sanitorium, Erode"],
"638054":[415,1024,0.05,"Vellankoil, Erode"],
"638055":[500,1027,0.04,"Kuthambi, Erode"],
"638056":[422,1071,0.02,"Nadupatti, Tiruppur"],
"638057":[450,944,0.03,"Nallampatti, Erode"],
"638060":[360,905,0.02,"Thoppupalayam, Erode"],
"638101":[360,762,0.05,"Attavanai Hanumanpalli, Erode"],
"638102":[390,960,0.02,"Perode, Erode"],
"638103":[465,1044,0.06,"Kavuthampalayam, Tiruppur"],
"638104":[350,1145,0.08,"Komarayeevalasu, Erode"],
"638105":[480,1450,0.02,"Vellierichal, Tiruppur"],
"638106":[675,1744,0.06,"Kottaimulanur, Tiruppur"],
"638107":[345,912,0.02,"Mullampatti, Erode"],
"638108":[385,1151,0.03,"Mullipuram, Tiruppur"],
"638109":[450,1022,0.04,"Kagam, Erode"],
"638110":[432,1024,0.06,"Sokkumaripalayam, Erode"],
"638111":[520,1211,0.02,"Nagamanaickenpatti, Tiruppur"],
"638112":[330,945,0.02,"Pungambadi, Erode"],
"638115":[330,1051,0.04,"Kandikattuvalasu, Erode"],
"638116":[420,903,0.03,"Thaneerpandalpalayam, Erode"],
"638151":[375,1043,0.05,"Ayyampalayam, Erode"],
"638152":[440,928,0.02,"Thamaraipalayam, Erode"],
"638153":[440,1479,0.13,"Muthayeepalayam, Erode"],
"638154":[480,1200,0.11,"Kolanalli, Erode"],
"638181":[362,1448,0.05,"Veeranampalayam, Namakkal"],
"638182":[456,1550,0.06,"Nanjai Edaiyar, Namakkal"],
"638183":[390,924,0.01,"Kallankattuvalasu, Namakkal"],
"638301":[390,972,0.03,"Bhavani, Erode"],
"638311":[435,991,0.02,"Chinnapallam, Erode"],
"638312":[450,947,0.02,"Punnam, Erode"],
"638313":[450,839,0.02,"Mevani, Erode"],
"638314":[450,1069,0.01,"Kannadipalayam, Erode"],
"638315":[450,987,0.03,"Perundalaiyur, Erode"],
"638316":[390,979,0.02,"Kalingarayanpalayam Pudur, Erode"],
"638401":[318,915,0.03,"Chikkarasampalayam, Erode"],
"638402":[315,861,0.02,"Konamoolai, Erode"],
"638451":[318,867,0.01,"Pudupeerkadavu, Erode"],
"638452":[420,769,0.02,"Gobichettipalayam, Erode"],
"638453":[403,745,0.0,"Kalingiam, Erode"],
"638454":[312,824,0.02,"Arasur, Erode"],
"638455":[435,957,0.06,"Ayyampalayam, Erode"],
"638456":[395,1022,0.04,"Talguni, Erode"],
"638457":[335,862,0.02,"Karattupalayam, Erode"],
"638458":[335,1182,0.04,"Elathur Chettipalayam, Erode"],
"638459":[348,904,0.0,"Nochikuttai, Erode"],
"638460":[358,918,0.07,"Pulipar, Tiruppur"],
"638461":[323,712,0.0,"Aralavadi, Erode"],
"638462":[318,944,0.0,"AnjanurVemandampalayam, Erode"],
"638476":[420,786,0.02,"Nanjagoundenpalayam, Erode"],
"638501":[540,1477,0.0,"Alampalayam, Erode"],
"638502":[420,856,0.01,"Kuppandampalayam, Erode"],
"638503":[315,857,0.03,"Kalkadambur, Erode"],
"638504":[390,1130,0.01,"Komarayanur, Erode"],
"638505":[385,762,0.0,"Kanakkampalayam, Erode"],
"638506":[350,995,0.01,"Arakkankottai, Erode"],
"638656":[600,1589,0.03,"Dharapuram, Tiruppur"],
"638657":[619,1496,0.02,"Ponnapuram, Tiruppur"],
"638660":[520,1305,0.0,"Kurukkapalayam, Tiruppur"],
"638661":[660,2185,0.02,"Kalipalayam, Tiruppur"],
"638672":[490,1714,0.03,"Selampalayam, Tiruppur"],
"638673":[585,1797,0.03,"Bommanallur, Tiruppur"],
"638701":[580,1395,0.0,"Aratholuvu, Tiruppur"],
"638702":[585,1453,0.02,"Rudravathi, Tiruppur"],
"638703":[640,1615,0.0,"Vengipalayam, Tiruppur"],
"638706":[600,1884,0.01,"Kambiliampatti, Tiruppur"],
"638751":[418,1004,0.03,"Sirukalanji, Erode"],
"638752":[500,1088,0.03,"Morattupalayam, Tiruppur"],
"638812":[465,1073,0.02,"Virumandampalayam, Tiruppur"],
"639001":[540,1166,0.1,"Karur, Karur"],
"639002":[314,1201,0.1,"Mudiganam, Karur"],
"639003":[442,1262,0.09,"Appipalayam, Karur"],
"639004":[540,1359,0.11,"Palaiyur, Karur"],
"639005":[355,1461,0.06,"Kodangipatti, Karur"],
"639006":[540,1338,0.1,"Manmangalam, Karur"],
"639007":[438,1518,0.12,"Kathalapatti, Karur"],
"639008":[378,1270,0.1,"Athur, Karur"],
"639101":[480,1120,0.08,"Mekkudi, Tiruchirappalli"],
"639102":[400,1060,0.18,"Munayanur, Karur"],
"639103":[460,913,0.1,"Mudalaipatti, Karur"],
"639104":[400,979,0.02,"Kulittalai, Karur"],
"639105":[400,1038,0.1,"K.Pudupatti, Karur"],
"639107":[400,933,0.0,"Panickampatti, Karur"],
"639108":[460,1306,0.21,"Karuppur, Karur"],
"639109":[425,1015,0.03,"Varikkapatti, Karur"],
"639110":[470,1197,0.01,"Neidalur, Karur"],
"639111":[386,1118,0.17,"Ariyur, Karur"],
"639112":[460,1075,-1,"Pudukottai, Tiruchirappalli"],
"639113":[355,1418,0.07,"Dalavapalayam, Karur"],
"639114":[520,1433,0.14,"Vedichipalayam, Karur"],
"639115":[460,1040,-1,"Kodiyalam, Tiruchirappalli"],
"639116":[400,1237,0.1,"Kuppachipalayam, Karur"],
"639117":[312,1246,0.06,"Nadayanur, Karur"],
"639118":[422,1452,0.03,"Chellandipatti, Karur"],
"639119":[452,1222,0.09,"Pappakkapatti, Karur"],
"639120":[433,1176,0.03,"Kazhugur, Karur"],
"639136":[355,1253,0.09,"Moolimangalam, Karur"],
"639201":[504,1113,0.04,"Kanakkuvelampatti, Karur"],
"639202":[472,1113,0.06,"Edakkalpadi, Tiruppur"],
"639203":[316,595,0.03,"Ammapatti, Karur"],
"639205":[450,1136,0.04,"Kurikkaranvalasu, Karur"],
"639206":[490,1252,0.07,"Kodanthur, Karur"],
"639207":[570,1199,0.04,"A.Meenakshivalasu, Karur"],
"641001":[450,1074,0.07,"Coimbatore, Coimbatore"],
"641002":[468,1073,0.07,"Rathinasabapathy Puram, Coimbatore"],
"641003":[485,1197,0.07,"Lawley Road, Coimbatore"],
"641004":[520,1333,0.04,"Peelamedu, Coimbatore"],
"641005":[485,1204,0.11,"Singanallur, Coimbatore"],
"641006":[485,1051,0.08,"Krishnarayapuram, Coimbatore"],
"641007":[468,1525,0.06,"Seeranaickenpalayam, Coimbatore"],
"641008":[440,1184,0.04,"Sugunapuram, Coimbatore"],
"641009":[468,983,0.08,"Ramnagar Coimbatore, Coimbatore"],
"641010":[468,1126,0.04,"Madampatti, Coimbatore"],
"641011":[485,1045,0.07,"Saibaba Mission, Coimbatore"],
"641012":[485,1021,0.07,"Gandhipuram SO Coimbatore, Coimbatore"],
"641013":[485,1134,0.06,"GovtCollege Of Technology, Coimbatore"],
"641014":[485,1146,0.11,"Coimbatore Aerodrome, Coimbatore"],
"641015":[485,1184,0.11,"Uppilipalayam, Coimbatore"],
"641016":[468,1173,0.12,"Pappampatti, Coimbatore"],
"641017":[485,1136,0.06,"Pannimadai, Coimbatore"],
"641018":[450,991,0.08,"Coimbatore Collectorate, Coimbatore"],
"641019":[530,1253,0.03,"Bilichi, Coimbatore"],
"641020":[492,1305,0.01,"Naickenpalayam, Coimbatore"],
"641021":[430,1124,0.05,"Eachanari, Coimbatore"],
"641022":[485,1128,0.06,"Sengalipalayam, Coimbatore"],
"641023":[440,1217,0.08,"Konavaikalpalayam, Coimbatore"],
"641024":[440,1191,0.07,"Sundarapuram, Coimbatore"],
"641025":[485,1084,0.06,"Edayarpalayam, Coimbatore"],
"641026":[468,1157,0.07,"Selvapuram, Coimbatore"],
"641027":[485,1006,0.08,"Rathinapuri, Coimbatore"],
"641028":[468,1085,0.1,"Odayampalayam, Coimbatore"],
"641029":[485,1075,0.07,"Vellakinar, Coimbatore"],
"641030":[490,887,0.07,"Kavundampalayam, Coimbatore"],
"641031":[468,1136,0.04,"Rakkipalayam, Coimbatore"],
"641032":[485,1016,0.02,"Elur, Coimbatore"],
"641033":[485,1177,0.11,"Neelikonampalayam, Coimbatore"],
"641034":[485,1125,0.07,"Tudiyalur, Coimbatore"],
"641035":[490,1023,0.11,"Vilankurichi, Coimbatore"],
"641036":[450,1168,0.08,"Nanjundapuram, Coimbatore"],
"641037":[468,947,0.09,"Pappanaickenpalayam, Coimbatore"],
"641038":[485,1035,0.07,"Kuppakonanpudur, Coimbatore"],
"641039":[480,1223,0.0,"Telungupalayam, Coimbatore"],
"641040":[485,953,0.07,"NDC KPColony, Coimbatore"],
"641041":[485,1361,0.05,"Pappanaickenpudur, Coimbatore"],
"641042":[468,1126,0.05,"Kovaipudur, Coimbatore"],
"641043":[485,1057,0.07,"Sahs College, Coimbatore"],
"641044":[468,945,0.09,"Siddhapudur, Coimbatore"],
"641045":[485,1184,0.11,"Krishnaswamy Nagar, Coimbatore"],
"641046":[461,1118,0.01,"Marudamalai, Coimbatore"],
"641047":[508,1220,0.02,"Samichettipalayam, Coimbatore"],
"641048":[485,1125,0.1,"Vellanaipatti, Coimbatore"],
"641049":[485,1099,0.09,"Chinnavedampatti, Coimbatore"],
"641050":[453,1309,0.13,"Malumichampatti, Coimbatore"],
"641051":[490,1143,0.1,"Cheranmaanagar, Coimbatore"],
"641062":[450,1104,0.11,"Mylampatti, Coimbatore"],
"641063":[468,1047,0.08,"NDC Coimbatore, Coimbatore"],
"641101":[510,1211,0.04,"Puluvapatti, Coimbatore"],
"641103":[410,1102,0.12,"Chinthamanipudur, Coimbatore"],
"641104":[470,936,0.07,"Chikkarampalayam, Coimbatore"],
"641105":[450,1047,0.03,"Palathurai, Coimbatore"],
"641107":[508,1242,0.02,"Kuppaipalayam, Coimbatore"],
"641108":[500,1211,0.02,"Nanjundapuramtadagam, Coimbatore"],
"641109":[510,1210,0.04,"Jakkirnaickenpalayam, Coimbatore"],
"641110":[472,1152,0.04,"Athipalayam, Coimbatore"],
"641111":[468,1125,0.1,"Vellalapalayam Podanur, Coimbatore"],
"641112":[492,1015,0.03,"Ettimadai, Coimbatore"],
"641113":[502,1117,0.0,"Vivekanandapuram, Coimbatore"],
"641114":[414,835,0.01,"Siruvani Adivaram, Coimbatore"],
"641201":[580,1309,0.1,"Panapatti, Coimbatore"],
"641202":[550,1350,0.01,"Kondampatti, Coimbatore"],
"641301":[465,738,0.12,"Mettupalayam, Coimbatore"],
"641302":[465,847,0.07,"Bellaipalayam, Coimbatore"],
"641305":[465,675,0.14,"Palapatti, Coimbatore"],
"641401":[330,964,0.07,"Goldenpet, Tiruppur"],
"641402":[410,1350,0.13,"Appanaickenpatti, Coimbatore"],
"641407":[530,1266,0.1,"Arasur, Coimbatore"],
"641601":[552,1049,0.08,"Tirupur, Tiruppur"],
"641602":[552,1029,0.08,"Kallampalayam Road, Tiruppur"],
"641603":[552,944,0.09,"Aingalipalayam, Tiruppur"],
"641604":[552,1126,0.08,"Maruduraiyanvalasu, Tiruppur"],
"641605":[520,1138,0.03,"Karaipudur, Tiruppur"],
"641606":[520,1422,0.0,"Muthanampalayam, Tiruppur"],
"641607":[446,1005,0.07,"Mannarai, Tiruppur"],
"641652":[430,588,0.14,"15 Velampalayam, Tiruppur"],
"641653":[470,1074,0.01,"Komarapalayam, Coimbatore"],
"641654":[305,664,0.11,"Karukkampalayam, Tiruppur"],
"641655":[375,775,0.02,"Pappankulam, Tiruppur"],
"641658":[330,966,0.07,"Kamanaickenpalayam, Tiruppur"],
"641659":[429,1057,0.05,"Chennappachettipudur, Coimbatore"],
"641662":[330,855,0.05,"KAyyampalayam, Tiruppur"],
"641663":[335,808,0.08,"Samalapuram, Tiruppur"],
"641664":[425,937,0.02,"Anuppapatti, Tiruppur"],
"641665":[580,1348,0.0,"Peruntholuvu, Tiruppur"],
"641666":[430,922,0.1,"Pongupalayam, Tiruppur"],
"641667":[501,1161,0.02,"Devanampalayam, Tiruppur"],
"641668":[330,810,0.08,"Subbarayanpudur, Coimbatore"],
"641669":[499,1205,0.02,"Komarapalayam, Coimbatore"],
"641670":[340,630,0.02,"Nambiampalayam, Tiruppur"],
"641671":[440,886,0.02,"JKrishnapuram, Coimbatore"],
"641687":[430,974,0.09,"Iduvoi, Tiruppur"],
"641697":[485,1110,0.01,"Karegoundenpalayam, Coimbatore"],
"642001":[390,843,0.03,"Pollachi, Coimbatore"],
"642002":[412,939,0.04,"Achipatti, Coimbatore"],
"642003":[412,985,0.05,"Kanjampatti, Coimbatore"],
"642004":[354,707,0.06,"Akilandapuram, Coimbatore"],
"642005":[359,750,0.05,"Devambadi, Coimbatore"],
"642006":[390,859,0.05,"Suleeswaran Patti, Coimbatore"],
"642007":[300,870,-1,"Reddiarur, Coimbatore"],
"642101":[287,742,0.41,"Kadamparai Power House, Coimbatore"],
"642102":[284,872,0.9,"Kallapuram, Tiruppur"],
"642103":[354,587,0.1,"Athu Pollachi, Coimbatore"],
"642104":[350,637,0.1,"Chinnappampalayam, Coimbatore"],
"642105":[262,824,-1,"Mount Stuart, Coimbatore"],
"642106":[374,897,0.0,"Periya Kallar, Coimbatore"],
"642107":[410,1247,0.5,"Lakshmapuram, Coimbatore"],
"642108":[300,879,-1,"Paralai, Coimbatore"],
"642109":[535,1290,0.01,"Arasampalayam, Coimbatore"],
"642110":[413,1271,0.01,"Sulakkal, Coimbatore"],
"642111":[336,701,0.33,"Agrahara Kannadiputhur, Tiruppur"],
"642112":[530,1156,0.02,"Jallipatti, Tiruppur"],
"642113":[268,611,0.2,"Saminathapuram, Dindigul"],
"642114":[330,779,0.2,"Malayandipattinam, Coimbatore"],
"642117":[125,376,0.0,"Nallamudi, Coimbatore"],
"642120":[550,1498,0.02,"Chinna Negamam, Coimbatore"],
"642122":[300,897,0.9,"Ganapathipalayam, Tiruppur"],
"642123":[355,713,0.1,"Zamin Kottampatti, Coimbatore"],
"642125":[206,539,0.0,"Murugali Bazaar, Coimbatore"],
"642126":[315,902,0.74,"Udamalpet, Tiruppur"],
"642127":[248,784,-1,"Akkamalai, Coimbatore"],
"642128":[336,788,0.58,"Venkatesa Mills, Tiruppur"],
"642129":[350,647,0.1,"Kaliapuram, Coimbatore"],
"642130":[300,850,-1,"Vellamalai, Coimbatore"],
"642132":[560,1131,0.02,"Deepalapatti, Tiruppur"],
"642133":[350,635,0.1,"Topslip, Coimbatore"],
"642134":[350,692,0.14,"Pethanaickanur, Coimbatore"],
"642154":[336,862,0.73,"Andigoundanur, Tiruppur"],
"642201":[422,775,0.26,"Kondampatti, Tiruppur"],
"642202":[550,1301,0.02,"Dasanaicken Palayam, Coimbatore"],
"642203":[404,776,0.08,"Kadathur, Tiruppur"],
"642204":[225,539,0.07,"Kolumam, Tiruppur"],
"642205":[460,1068,0.33,"Ammapatti, Tiruppur"],
"642206":[512,1052,0.16,"Athukinathupatti, Tiruppur"],
"642207":[284,871,0.9,"Devanurpudur, Tiruppur"],
"643001":[150,344,0.02,"Udagamandalam, The Nilgiris"],
"643002":[150,277,0.07,"Iduhatti, The Nilgiris"],
"643003":[198,345,0.06,"Nunthala, The Nilgiris"],
"643004":[187,332,0.04,"Kuruthukuli, The Nilgiris"],
"643005":[131,262,0.03,"Kalhatti, The Nilgiris"],
"643006":[127,218,0.09,"Finger Post, The Nilgiris"],
"643007":[150,286,0.01,"Dhavani, The Nilgiris"],
"643101":[127,218,0.09,"Coonoor, The Nilgiris"],
"643102":[127,224,0.09,"Hulical, The Nilgiris"],
"643103":[127,210,0.05,"Halakkarai, The Nilgiris"],
"643105":[127,230,0.09,"Ottupattarai, The Nilgiris"],
"643201":[127,235,0.18,"Aravenu, The Nilgiris"],
"643202":[150,259,0.06,"Hubbathalai, The Nilgiris"],
"643203":[209,372,0.05,"Balacola, The Nilgiris"],
"643204":[246,441,0.01,"Bengalmattam, The Nilgiris"],
"643205":[85,201,0.02,"Kayyunni, The Nilgiris"],
"643206":[127,262,0.06,"Kadanad, The Nilgiris"],
"643207":[170,225,0.0,"Mayfield, The Nilgiris"],
"643209":[214,389,0.01,"Bickatti, The Nilgiris"],
"643211":[85,218,0.03,"Cherumulli, The Nilgiris"],
"643212":[105,195,0.04,"Sree Madurai, The Nilgiris"],
"643213":[228,380,0.07,"Koderi, The Nilgiris"],
"643214":[127,220,0.11,"T.Manihatti, The Nilgiris"],
"643215":[191,332,0.06,"Kollimalai Oranalli, The Nilgiris"],
"643216":[265,510,0.13,"Kadinamalai, The Nilgiris"],
"643217":[105,181,0.21,"Gundada, The Nilgiris"],
"643218":[200,486,0.02,"Thuthurmattam, The Nilgiris"],
"643219":[243,436,0.01,"Kinnakorai, The Nilgiris"],
"643220":[150,243,0.1,"Cherambadi Tea Division, The Nilgiris"],
"643221":[223,393,0.06,"Araihatty, The Nilgiris"],
"643223":[195,377,0.05,"Moyarcamp, The Nilgiris"],
"643224":[150,332,0.02,"T R Bazaar, The Nilgiris"],
"643225":[81,174,0.09,"Rockwood Estate, The Nilgiris"],
"643226":[116,204,0.03,"Yellamalai, The Nilgiris"],
"643231":[127,225,0.08,"Berhatti, The Nilgiris"],
"643233":[115,217,0.0,"Pandalur, The Nilgiris"],
"643236":[263,505,0.13,"Hettakal, The Nilgiris"],
"643237":[109,228,0.01,"Pykaradam, The Nilgiris"],
"643238":[175,363,0.07,"Pilloormattam, The Nilgiris"],
"643239":[85,200,0.01,"Munnanad GDS, The Nilgiris"],
"643240":[94,188,0.09,"Ambalamoola, The Nilgiris"],
"643241":[82,187,0.08,"Kunnalady, The Nilgiris"],
"643242":[127,226,0.18,"Kunjapanai, The Nilgiris"],
"643243":[150,291,0.06,"Yellanhalli, The Nilgiris"],
"643253":[127,218,0.09,"Kolapalli, The Nilgiris"],
"643270":[82,187,0.08,"Devala, The Nilgiris"],
"670001":[44,113,0.0,"Kannur, Kannur"],
"670002":[44,96,0.0,"Civil Station Kannur, Kannur"],
"670003":[43,70,0.01,"Katalayi, Kannur"],
"670004":[44,96,0.0,"Pallikunnu, Kannur"],
"670005":[43,71,0.0,"Kottali, Kannur"],
"670006":[43,59,0.01,"Kappad, Kannur"],
"670007":[43,67,0.01,"Kizhunna, Kannur"],
"670008":[44,96,0.0,"Alavil, Kannur"],
"670009":[44,94,0.0,"Azhikode South, Kannur"],
"670010":[44,96,0.0,"Valapattanam, Kannur"],
"670011":[45,69,0.0,"Kattampally, Kannur"],
"670012":[44,131,0.04,"Kannookara, Kannur"],
"670013":[44,96,0.0,"Burnacherry, Kannur"],
"670014":[44,96,0.0,"Chalad, Kannur"],
"670017":[44,96,0.0,"Kannur District Hospital, Kannur"],
"670018":[44,96,0.0,"Thazhe Chovva, Kannur"],
"670051":[44,96,0.0,"Kannur NDC, Kannur"],
"670101":[52,191,0.03,"Thalassery, Kannur"],
"670102":[83,201,0.03,"Kurichiyil, Kannur"],
"670103":[57,175,0.03,"Moozhikkara, Kannur"],
"670104":[52,190,0.03,"Cherakkara, Kannur"],
"670105":[57,160,0.04,"Vadakkumbad, Kannur"],
"670106":[52,190,0.03,"Dharmadam, Kannur"],
"670107":[57,168,0.04,"Perundattil, Kannur"],
"670141":[53,215,0.0,"Taliparamba, Kannur"],
"670142":[57,116,0.01,"Koyyam, Kannur"],
"670143":[52,160,0.0,"Aril, Kannur"],
"670301":[51,103,0.0,"Keezhara, Kannur"],
"670302":[44,96,0.0,"Mattul, Kannur"],
"670303":[48,82,0.0,"Sreestha, Kannur"],
"670304":[44,96,0.0,"Madayi, Kannur"],
"670305":[52,102,0.0,"Palakode, Kannur"],
"670306":[56,173,0.0,"Panapuzha, Kannur"],
"670307":[52,84,0.0,"Annur, Kannur"],
"670308":[52,127,0.0,"Ettikulam, Kannur"],
"670309":[56,113,0.0,"Ezhilode, Kannur"],
"670310":[53,215,0.0,"Ezhimala Naval Academy, Kannur"],
"670325":[44,96,0.0,"Mattul North, Kannur"],
"670327":[53,215,0.0,"Edat, Kannur"],
"670331":[44,96,0.0,"Morazha, Kannur"],
"670334":[53,198,0.0,"Kottila, Kannur"],
"670353":[26,60,0.0,"Padiotchal, Kannur"],
"670358":[44,96,0.0,"Payangadi R S, Kannur"],
"670501":[44,96,0.0,"Mandurkannur, Kannur"],
"670502":[52,178,0.0,"Kuppamtaliparamba, Kannur"],
"670503":[60,125,0.0,"Kannur Government Medical College, Kannur"],
"670504":[51,97,0.0,"Vilayancode, Kannur"],
"670511":[40,127,0.0,"Kozhichal, Kannur"],
"670521":[40,62,0.0,"Kozhummal, Kannur"],
"670561":[46,68,0.0,"Aroli, Kannur"],
"670562":[53,215,0.0,"Kuttikol, Kannur"],
"670563":[52,144,0.0,"Trichambaram, Kannur"],
"670567":[50,68,0.0,"Kannur University Campus, Kannur"],
"670571":[40,277,0.0,"Nellipara, Kannur"],
"670581":[148,225,0.0,"Thimirichepparapadava, Kannur"],
"670582":[62,205,0.14,"Mandalam, Kannur"],
"670591":[43,61,0.01,"Munderi, Kannur"],
"670592":[43,53,0.01,"Chattuvapara, Kannur"],
"670593":[34,82,0.11,"Kalliad, Kannur"],
"670594":[43,67,0.0,"Mundayad, Kannur"],
"670595":[32,66,0.02,"Elampara, Kannur"],
"670601":[46,60,0.0,"Narath, Kannur"],
"670602":[43,62,0.01,"Mullakodi, Kannur"],
"670604":[44,59,0.0,"Cheleri, Kannur"],
"670611":[43,57,0.01,"Muzhappala, Kannur"],
"670612":[34,86,0.02,"Muringeri, Kannur"],
"670613":[43,59,0.01,"Iriveri, Kannur"],
"670621":[44,67,0.01,"Poduvachery, Kannur"],
"670622":[43,82,0.01,"Bavode, Kannur"],
"670631":[42,108,0.16,"Kootumugham, Kannur"],
"670632":[73,129,0.09,"Chundakunnu, Kannur"],
"670633":[99,163,0.12,"Chamathachal, Kannur"],
"670641":[57,169,0.03,"Ponniam, Kannur"],
"670642":[57,162,0.03,"Kizhakke Kadirur, Kannur"],
"670643":[52,176,0.01,"Kottayam Malabar, Kannur"],
"670644":[54,97,0.0,"Tavinhal, Wayanad"],
"670645":[66,423,0.0,"Kellur, Wayanad"],
"670646":[90,156,0.0,"Panavally, Wayanad"],
"670649":[66,183,0.03,"Kavumbhagam, Kannur"],
"670650":[41,73,0.0,"Cheruvancheri, Kannur"],
"670651":[24,54,0.0,"Chunkakunnu, Kannur"],
"670661":[43,104,0.11,"Melurtly, Kannur"],
"670662":[52,190,0.03,"Muzhappilangad, Kannur"],
"670663":[46,99,0.03,"Kadamburkannur, Kannur"],
"670671":[83,201,0.03,"Panniyannur, Kannur"],
"670672":[90,212,0.02,"Aniyaram, Kannur"],
"670673":[38,81,0.0,"Aralam Farm, Kannur"],
"670674":[36,62,0.0,"Chettiamparamba, Kannur"],
"670675":[102,221,0.02,"Kidanhi, Kannur"],
"670676":[52,190,0.03,"Kadavathur, Kannur"],
"670691":[57,168,0.02,"Pukkotkba, Kannur"],
"670692":[83,184,0.02,"Puthurpanoor, Kannur"],
"670693":[90,208,0.0,"Narikkodmala, Kannur"],
"670694":[66,168,0.03,"Koorara, Kannur"],
"670701":[37,114,0.02,"Mallannur, Kannur"],
"670702":[26,95,0.0,"Kayani, Kannur"],
"670703":[24,71,0.0,"Kalluvayal, Kannur"],
"670704":[51,85,0.0,"Keezhpalli, Kannur"],
"670705":[67,106,0.09,"Parikkalam, Kannur"],
"670706":[115,165,0.0,"Charal, Kannur"],
"670708":[42,86,0.02,"Kannur International Airport, Kannur"],
"670721":[120,662,0.0,"Kayakunnu, Wayanad"],
"670731":[33,92,0.0,"Thettamala, Wayanad"],
"670741":[43,87,0.02,"Parapram, Kannur"],
"671121":[50,84,0.0,"Kasaragod, Kasaragod"],
"671122":[55,71,0.0,"Talangara, Kasaragod"],
"671123":[42,97,0.0,"Hidayathnagar, Kasaragod"],
"671124":[46,87,0.0,"Bedradka, Kasaragod"],
"671310":[40,-1,0.0,"Olat, Kasaragod"],
"671311":[52,65,0.0,"Trikarpur South, Kasaragod"],
"671312":[40,40,0.0,"Valiyaparamba, Kasaragod"],
"671313":[40,42,0.0,"Cheemeni, Kasaragod"],
"671314":[30,35,0.0,"Kollampara, Kasaragod"],
"671315":[35,65,0.0,"Kanhangad, Kasaragod"],
"671316":[40,80,0.0,"Chittari, Kasaragod"],
"671317":[50,87,0.0,"Paravanadkam, Kasaragod"],
"671318":[42,69,0.0,"Panayal, Kasaragod"],
"671319":[42,73,0.0,"Mylatti, Kasaragod"],
"671320":[40,78,0.0,"PERIYE, Kasaragod"],
"671321":[47,104,0.0,"Angadimogaru, Kasaragod"],
"671322":[50,112,0.0,"Ammeri, Kasaragod"],
"671323":[72,391,0.0,"Charla, Kasaragod"],
"671324":[43,110,0.0,"Dharmathadka, Kasaragod"],
"671325":[38,77,0.0,"Central University of Kerala Campus, Kasaragod"],
"671326":[31,56,0.0,"Mandapam, Kasaragod"],
"671348":[47,120,0.0,"Bayar, Kasaragod"],
"671351":[32,39,0.0,"Achanthuruthi, Kasaragod"],
"671531":[35,58,0.0,"Balla, Kasaragod"],
"671532":[36,105,0.0,"Kolichal, Kasaragod"],
"671533":[25,57,0.0,"Kinanur, Kasaragod"],
"671534":[30,78,0.0,"Chully, Kasaragod"],
"671541":[38,89,0.01,"Bandadka, Kasaragod"],
"671542":[38,109,0.01,"Karadka, Kasaragod"],
"671543":[40,90,0.03,"Adur, Kasaragod"],
"671551":[43,127,0.01,"Kuntikana, Kasaragod"],
"671552":[43,132,0.01,"Katukukke, Kasaragod"],
"673001":[79,107,0.0,"Calicut, Kozhikode"],
"673002":[79,110,0.0,"Tali, Kozhikode"],
"673003":[79,100,0.0,"Kannancheri, Kozhikode"],
"673004":[82,112,0.0,"Thiruthiyad, Kozhikode"],
"673005":[82,94,0.0,"West Hill Chungam, Kozhikode"],
"673006":[108,113,0.0,"Eranhipalam, Kozhikode"],
"673007":[76,88,0.0,"Kommeri, Kozhikode"],
"673008":[79,123,0.0,"Devagiri College, Kozhikode"],
"673009":[38,133,0.0,"Paropadi, Kozhikode"],
"673010":[82,108,0.0,"Karuvasseri, Kozhikode"],
"673011":[86,110,0.0,"Nadakavu, Kozhikode"],
"673012":[79,129,0.0,"Parambil, Kozhikode"],
"673014":[41,111,0.0,"Iringallur, Kozhikode"],
"673015":[82,119,0.0,"Beypore North, Kozhikode"],
"673016":[72,96,0.0,"Kottuli, Kozhikode"],
"673017":[76,102,0.0,"Chevarambalam, Kozhikode"],
"673018":[79,98,0.0,"Calicut Arts Science College, Kozhikode"],
"673019":[41,111,0.0,"Perumanna, Kozhikode"],
"673020":[108,113,0.0,"Calicut Civil Station, Kozhikode"],
"673021":[76,-1,0.0,"Puthiyangadi, Kozhikode"],
"673027":[76,90,0.0,"Nallalam, Kozhikode"],
"673028":[86,87,0.0,"Arakinar, Kozhikode"],
"673029":[76,93,0.0,"Tiruvannur, Kozhikode"],
"673032":[79,106,0.0,"Calicut Courts, Kozhikode"],
"673051":[79,108,0.0,"KOZHIKODE PARCEL CENTRE, Kozhikode"],
"673101":[102,172,0.0,"Vadakara, Kozhikode"],
"673102":[102,182,0.0,"Rayarangoth, Kozhikode"],
"673103":[48,157,0.0,"Vadakara Beach, Kozhikode"],
"673104":[102,145,0.0,"Kurikkilad, Kozhikode"],
"673105":[42,79,0.0,"Pathiyarakkara, Kozhikode"],
"673106":[102,161,0.0,"Muttungal, Kozhikode"],
"673121":[98,278,0.0,"Kalpetta, Wayanad"],
"673122":[98,341,0.0,"Maniyangode, Wayanad"],
"673123":[58,187,0.0,"Kunnambetta, Wayanad"],
"673124":[110,331,0.0,"Kottathara, Wayanad"],
"673301":[86,128,0.0,"Chaliyam, Kozhikode"],
"673302":[82,102,0.0,"Kadalundi, Kozhikode"],
"673303":[72,109,0.0,"Vengalam, Kozhikode"],
"673304":[72,141,0.0,"Kappad, Kozhikode"],
"673305":[48,212,0.0,"Koyilandi, Kozhikode"],
"673306":[72,153,0.0,"MELUR, Kozhikode"],
"673307":[48,107,0.0,"Mudadi North, Kozhikode"],
"673308":[103,192,0.0,"Onchiyam, Kozhikode"],
"673309":[102,212,0.02,"Korothroad, Kozhikode"],
"673310":[83,239,0.02,"Naluthara, Mahe"],
"673311":[52,190,0.03,"New Mahe, Kannur"],
"673312":[52,190,0.03,"Peringadi, Kannur"],
"673313":[52,190,0.03,"Olavilam, Kannur"],
"673314":[86,105,0.0,"Vallikkunnu, Malappuram"],
"673315":[106,152,0.0,"Kongannur, Kozhikode"],
"673316":[52,190,0.03,"Kariyad South, Kannur"],
"673317":[76,138,0.0,"Annasseri, Kozhikode"],
"673323":[60,147,0.0,"Modakkallur, Kozhikode"],
"673328":[82,123,0.0,"Mannur SO Kozhikode, Kozhikode"],
"673501":[102,173,0.0,"Eramala, Kozhikode"],
"673502":[103,221,0.0,"Katcheri, Kozhikode"],
"673503":[52,179,0.0,"Muthuvadathur, Kozhikode"],
"673504":[52,200,0.0,"Perode, Kozhikode"],
"673505":[102,240,0.0,"Kayappanichi, Kozhikode"],
"673506":[42,165,0.0,"Vilangad, Kozhikode"],
"673507":[47,144,0.0,"Cherapuram, Kozhikode"],
"673508":[42,107,0.0,"Velom Peruvayal, Kozhikode"],
"673509":[71,231,0.0,"Puliyavil, Kozhikode"],
"673513":[32,93,0.0,"Marudonkara, Kozhikode"],
"673517":[32,156,0.0,"Chuzhali, Kozhikode"],
"673521":[42,73,0.0,"Palayad Nada, Kozhikode"],
"673522":[45,60,0.0,"Purakkad, Kozhikode"],
"673523":[48,88,0.0,"Maniyur, Kozhikode"],
"673524":[48,97,0.0,"Kizhpayur, Kozhikode"],
"673525":[42,104,0.0,"Kilinnanyam, Kozhikode"],
"673526":[47,170,0.0,"Thandorapara, Kozhikode"],
"673527":[92,145,0.0,"Mattanode, Kozhikode"],
"673528":[66,130,0.0,"Muthukad, Kozhikode"],
"673529":[48,73,0.0,"Katalur, Kozhikode"],
"673541":[48,82,0.0,"Chaniyankadavu, Kozhikode"],
"673542":[77,147,0.0,"Karthikappally, Kozhikode"],
"673570":[76,137,0.0,"Iim Kozhikode Campus, Kozhikode"],
"673571":[76,140,0.0,"Chelavur, Kozhikode"],
"673572":[35,163,0.0,"Pannikkottur, Kozhikode"],
"673573":[42,145,0.0,"Chamal, Kozhikode"],
"673574":[42,149,0.0,"Iyyad, Kozhikode"],
"673575":[88,172,0.0,"Bibleland, Wayanad"],
"673576":[84,146,0.0,"Sugandhagiri, Wayanad"],
"673577":[84,205,0.08,"Puthumala, Wayanad"],
"673579":[155,562,0.0,"Cheeyambam, Wayanad"],
"673580":[42,147,0.0,"Chembu Kadavu, Kozhikode"],
"673581":[84,166,0.09,"Chellangode, Wayanad"],
"673582":[38,227,0.0,"Santhi Nagar, Kozhikode"],
"673585":[38,133,0.0,"Eravannur, Kozhikode"],
"673586":[48,135,0.0,"Adivaram Pudupadi, Kozhikode"],
"673591":[112,378,0.0,"Mylambadi, Wayanad"],
"673592":[106,267,0.0,"Beenachi, Wayanad"],
"673593":[84,191,0.03,"Cheengeri, Wayanad"],
"673595":[82,218,0.06,"Nambiar Kunnu, Wayanad"],
"673596":[120,426,0.0,"Athirattu Kunnu, Wayanad"],
"673601":[36,152,0.0,"Malayamma, Kozhikode"],
"673602":[40,187,0.0,"Nellika Paramba, Kozhikode"],
"673603":[65,151,0.0,"Pulluram Para, Kozhikode"],
"673604":[60,152,0.0,"Poovaranthod, Kozhikode"],
"673611":[72,95,0.0,"Makkada, Kozhikode"],
"673612":[36,131,0.0,"Eramangalam, Kozhikode"],
"673613":[56,140,0.0,"Pavandur, Kozhikode"],
"673614":[60,176,0.0,"Karuvannur, Kozhikode"],
"673616":[72,134,0.0,"Kannan Kara, Kozhikode"],
"673620":[48,145,0.0,"Naderi, Kozhikode"],
"673631":[76,140,0.0,"Perumukham, Kozhikode"],
"673632":[72,125,0.0,"Karad Paramba, Malappuram"],
"673633":[57,108,0.0,"Vaidyarangadi, Kozhikode"],
"673634":[79,124,0.0,"Pallikkal, Malappuram"],
"673635":[79,120,0.0,"Calicut University, Malappuram"],
"673636":[79,120,0.0,"Chenakkalangadi, Malappuram"],
"673637":[66,107,0.0,"Kannamvettikavu, Malappuram"],
"673638":[54,139,0.0,"Arimbra, Malappuram"],
"673639":[52,197,0.0,"Kavanur, Malappuram"],
"673640":[78,251,0.0,"Karumarakkad, Malappuram"],
"673641":[41,227,0.0,"Trippanachi, Malappuram"],
"673642":[56,269,0.0,"Valluvambram, Malappuram"],
"673645":[54,113,0.0,"Omanur, Malappuram"],
"673647":[40,121,0.0,"Calicut Airport, Malappuram"],
"673655":[79,95,0.0,"Kolathara, Kozhikode"],
"673661":[39,139,0.0,"Cheruvadi, Kozhikode"],
"676101":[78,140,0.0,"TirurKerala, Malappuram"],
"676102":[78,175,0.0,"Alathiyur, Malappuram"],
"676103":[78,132,0.0,"Iringavur, Malappuram"],
"676104":[78,144,0.0,"Trikkandiyur, Malappuram"],
"676105":[78,141,0.0,"Mangattiri, Malappuram"],
"676106":[78,133,0.0,"Cheriyamundam, Malappuram"],
"676107":[69,103,0.0,"Pookayil Bazar, Malappuram"],
"676108":[78,166,0.0,"Codacal, Malappuram"],
"676109":[69,97,0.0,"Niramaruthur, Malappuram"],
"676121":[80,289,0.0,"Manjerikla, Malappuram"],
"676122":[80,267,0.0,"Nellikuth, Malappuram"],
"676123":[80,285,0.0,"Pulpatta, Malappuram"],
"676301":[78,162,0.0,"Ananthavur, Malappuram"],
"676302":[66,110,0.0,"Puthiyakadappuram, Malappuram"],
"676303":[140,238,0.0,"Anjapura, Malappuram"],
"676304":[54,155,0.0,"Iringallur, Malappuram"],
"676305":[41,142,0.0,"Kannamangalam West, Malappuram"],
"676306":[48,130,0.0,"Kooriyad, Malappuram"],
"676307":[78,100,0.0,"Meenadathur, Malappuram"],
"676309":[78,137,0.0,"Kodinhi, Malappuram"],
"676311":[54,140,0.0,"Moonniyur South, Malappuram"],
"676312":[86,-1,0.0,"Ariyallur, Malappuram"],
"676317":[79,139,0.0,"Velimukku South, Malappuram"],
"676319":[108,124,0.0,"Kotakkad, Malappuram"],
"676320":[78,122,0.0,"Nannambra, Malappuram"],
"676501":[66,177,0.0,"Kuttippala, Malappuram"],
"676502":[78,87,0.0,"Vakkad, Malappuram"],
"676503":[54,184,0.0,"Kuttippuramkottakkal, Malappuram"],
"676504":[97,200,0.0,"Chattipparamba, Malappuram"],
"676505":[107,209,0.0,"Malappuram, Malappuram"],
"676506":[82,186,0.0,"Padinhattumuri, Malappuram"],
"676507":[90,187,0.0,"Perinthattiri, Malappuram"],
"676508":[78,142,0.0,"Chullippara, Malappuram"],
"676509":[118,262,0.0,"Anakkayam, Malappuram"],
"676510":[57,169,0.0,"Poovanchina, Malappuram"],
"676517":[92,306,0.0,"Melmuri, Malappuram"],
"676519":[98,221,0.0,"Hajiarpalli, Malappuram"],
"676521":[51,147,0.0,"Valluvangad, Malappuram"],
"676522":[51,130,0.0,"Kolaparamba, Malappuram"],
"676523":[42,117,0.0,"Pulvetta, Malappuram"],
"676525":[57,124,0.0,"Arimanal, Malappuram"],
"676528":[93,240,0.0,"Mattathur, Malappuram"],
"676541":[73,213,0.0,"Pannippara, Malappuram"],
"676542":[38,160,0.0,"Mampad College, Malappuram"],
"676551":[82,159,0.0,"Kanmanam, Malappuram"],
"676552":[76,205,0.0,"Edayur, Malappuram"],
"676553":[66,186,0.0,"Marakkara, Malappuram"],
"676561":[60,207,0.0,"Muttanur, Malappuram"],
"676562":[60,183,0.0,"Padinharekkara, Malappuram"],
"678001":[158,339,0.0,"Palakkad, Palakkad"],
"678002":[120,333,0.0,"Olavakkot, Palakkad"],
"678003":[236,653,0.0,"Newkalpathy, Palakkad"],
"678004":[282,1046,0.0,"Koduntharapully, Palakkad"],
"678005":[120,322,0.0,"Kallepulli, Palakkad"],
"678006":[158,338,0.0,"Kallekkad, Palakkad"],
"678007":[158,356,0.0,"Pallatheri, Palakkad"],
"678008":[158,338,0.0,"Akathethara, Palakkad"],
"678009":[158,338,0.0,"Dhoni, Palakkad"],
"678010":[120,333,0.0,"Sekharipuram, Palakkad"],
"678011":[120,333,0.0,"Ambikapuram SO Palakkad, Palakkad"],
"678012":[120,322,0.0,"Moothanthara, Palakkad"],
"678013":[120,333,0.0,"Kunnathurmedu, Palakkad"],
"678014":[120,333,0.0,"Palakkad City, Palakkad"],
"678051":[96,258,0.0,"PALAKKAD NDC, Palakkad"],
"678101":[233,370,0.0,"Chittur Courts, Palakkad"],
"678102":[233,370,0.0,"Chenthamaranagar, Palakkad"],
"678103":[236,645,0.0,"Vilayodi, Palakkad"],
"678104":[120,333,0.0,"Chittur College, Palakkad"],
"678501":[144,337,0.0,"Koduvayur Agraharam, Palakkad"],
"678502":[144,337,0.0,"Mannalur, Palakkad"],
"678503":[199,325,0.0,"Karippode, Palakkad"],
"678504":[172,407,0.0,"Vadavannur, Palakkad"],
"678505":[172,407,0.0,"Pallassana, Palakkad"],
"678506":[199,382,0.0,"Anamari, Palakkad"],
"678507":[245,509,0.03,"Meenkara Dam, Palakkad"],
"678508":[282,1047,0.0,"Chandramala Estate, Palakkad"],
"678510":[172,356,0.0,"Thiruvaliad, Palakkad"],
"678512":[120,333,0.0,"Kakkayur, Palakkad"],
"678531":[120,333,0.0,"Peruvemba, Palakkad"],
"678532":[199,335,0.0,"Karippali, Palakkad"],
"678533":[120,333,0.0,"Meenakshipuram, Palakkad"],
"678534":[218,476,0.0,"Kannimari, Palakkad"],
"678541":[172,407,0.0,"Alathur Mbr, Palakkad"],
"678542":[120,308,0.0,"Kattusseri, Palakkad"],
"678543":[249,1068,0.0,"Vavulliapuram, Palakkad"],
"678544":[66,202,0.0,"Athipotta, Palakkad"],
"678545":[300,763,0.0,"Pullode, Palakkad"],
"678546":[172,407,0.0,"Erimayur, Palakkad"],
"678551":[165,306,0.0,"Thiruvalathur, Palakkad"],
"678552":[127,640,0.0,"Verkoli, Palakkad"],
"678553":[127,640,0.0,"Thekkedesam, Palakkad"],
"678554":[218,386,0.0,"Athicode, Palakkad"],
"678555":[363,1623,0.0,"Vannamada, Palakkad"],
"678556":[245,533,0.0,"Attempathy, Palakkad"],
"678557":[363,1623,0.0,"Velanthavalam, Palakkad"],
"678571":[408,898,-1,"Mathur Agraharam, Palakkad"],
"678572":[147,331,0.0,"Pulinelly, Palakkad"],
"678573":[172,369,0.0,"Chennangad, Palakkad"],
"678574":[147,331,0.0,"Chulanur, Palakkad"],
"678581":[38,211,0.0,"Chavadiyur, Palakkad"],
"678582":[408,871,0.0,"Kaithachira, Palakkad"],
"678583":[102,229,0.0,"Ariyur, Palakkad"],
"678591":[80,253,0.0,"Palakayam, Palakkad"],
"678592":[408,1367,-1,"Pudanur, Palakkad"],
"678593":[408,1367,-1,"Viyyakurissi, Palakkad"],
"678594":[215,803,0.0,"Vallikkode, Palakkad"],
"678595":[408,1367,-1,"Elambulasseri, Palakkad"],
"678596":[80,259,0.0,"Kanhikulam, Palakkad"],
"678597":[249,698,0.0,"Moonnekkar, Palakkad"],
"678598":[215,597,0.0,"Poonchola, Palakkad"],
"678601":[48,126,0.0,"Karkitamkunnu, Palakkad"],
"678611":[79,281,0.0,"Chandrasekharapuram, Palakkad"],
"678612":[79,271,0.0,"Tenur, Palakkad"],
"678613":[80,261,0.0,"Mankarai RS, Palakkad"],
"678621":[80,262,0.0,"Kanjikode Ind Estate, Palakkad"],
"678622":[249,966,0.0,"Tenari, Palakkad"],
"678623":[215,880,0.0,"Pudusseri, Palakkad"],
"678624":[120,317,0.0,"Chandrapuram, Palakkad"],
"678631":[66,212,0.0,"Elakkad, Palakkad"],
"678632":[61,123,0.0,"Ummanazhi, Palakkad"],
"678633":[86,203,0.0,"Punchapadam, Palakkad"],
"678641":[249,1035,0.0,"Kundalasseri, Palakkad"],
"678642":[66,205,0.0,"Kilakkumbram, Palakkad"],
"678651":[202,289,0.0,"Kadukkamkunnu, Palakkad"],
"678661":[111,702,0.0,"Tunacadavu, Palakkad"],
"678671":[215,880,0.0,"Vilayannur, Palakkad"],
"678681":[172,384,0.0,"Koottala, Palakkad"],
"678682":[172,365,0.0,"Erattakulam Alathur, Palakkad"],
"678683":[172,365,0.0,"Panniankara, Palakkad"],
"678684":[172,365,0.0,"Mulangot, Palakkad"],
"678685":[172,407,0.0,"Mannapra, Palakkad"],
"678686":[306,677,0.0,"Paruvasseri, Palakkad"],
"678687":[172,365,0.0,"Manappadam, Palakkad"],
"678688":[165,239,0.2,"Kudallur, Palakkad"],
"678701":[245,415,0.0,"Yakkara, Palakkad"],
"678702":[65,141,0.0,"Kozhalmannam Agraharam, Palakkad"],
"678703":[146,260,0.13,"Cheramangalam, Palakkad"],
"678704":[172,407,0.0,"Chittilancheri, Palakkad"],
"678705":[172,407,0.0,"Mudappallur, Palakkad"],
"678706":[125,228,0.11,"Mangalam Dam, Palakkad"],
"678721":[146,260,0.13,"Chimbukat, Palakkad"],
"678722":[313,595,-1,"Nechur, Palakkad"],
"678731":[215,1077,0.0,"Palakkad Industrial Estate, Palakkad"],
"678732":[120,333,0.0,"Kottekkad, Palakkad"],
"678762":[55,117,0.0,"Changileri, Palakkad"],
"679101":[72,211,0.11,"Ottapalam, Palakkad"],
"679102":[205,759,-1,"Veetampara, Palakkad"],
"679103":[331,822,0.0,"Sreeramakrishnanagar, Palakkad"],
"679104":[78,222,0.14,"Kanniampuram, Palakkad"],
"679105":[103,237,0.11,"Mayannur, Thrissur"],
"679106":[146,260,0.12,"South Kondazhi, Thrissur"],
"679121":[205,759,-1,"Vadanamkurussi, Palakkad"],
"679122":[78,222,0.12,"Kallipadam, Palakkad"],
"679123":[85,219,0.18,"K A Samajam, Palakkad"],
"679301":[120,251,0.0,"MangalamOPM, Palakkad"],
"679302":[78,196,0.0,"Akalur, Palakkad"],
"679303":[85,222,0.04,"Kolikkottusseri, Palakkad"],
"679304":[78,104,0.0,"Chembra, Palakkad"],
"679305":[78,196,0.0,"Cherukutangad, Palakkad"],
"679306":[368,581,-1,"Maruthur, Palakkad"],
"679307":[78,196,0.0,"Mannengode, Palakkad"],
"679308":[86,111,0.0,"Etapalam, Palakkad"],
"679309":[371,598,-1,"Vilayur West, Palakkad"],
"679313":[57,176,0.0,"Kondurkara, Palakkad"],
"679321":[56,144,0.0,"Kadungapurm, Malappuram"],
"679322":[56,135,0.0,"Pathaikara, Malappuram"],
"679323":[73,214,0.0,"Chemmalasseri, Malappuram"],
"679324":[57,202,0.0,"Koottil, Malappuram"],
"679325":[51,153,0.0,"Thelakkad, Malappuram"],
"679326":[42,131,0.0,"Velliyanchery, Malappuram"],
"679327":[54,118,0.0,"Chembrasseri East, Malappuram"],
"679328":[59,149,0.0,"Naduvath, Malappuram"],
"679329":[99,213,0.0,"Chandakkunnu, Malappuram"],
"679330":[118,267,0.0,"Karulai, Malappuram"],
"679331":[118,358,0.0,"Kunnummalpotti, Malappuram"],
"679332":[99,239,0.0,"Chokkad, Malappuram"],
"679333":[123,299,0.0,"Marutha, Malappuram"],
"679334":[123,489,0.0,"Kurumbalangode, Malappuram"],
"679335":[35,101,0.0,"Marayamangalam South, Palakkad"],
"679336":[62,250,0.0,"Kuruvattur, Palakkad"],
"679337":[314,807,-1,"Mulayankavu, Palakkad"],
"679338":[57,153,0.0,"Moorkkanad, Malappuram"],
"679339":[38,116,0.0,"Karad, Malappuram"],
"679340":[61,173,0.0,"Elad, Malappuram"],
"679341":[54,125,0.0,"Talekode West, Malappuram"],
"679357":[57,150,0.0,"Manalaya, Malappuram"],
"679501":[24,71,0.0,"Ambalavattom, Palakkad"],
"679502":[362,590,-1,"Munnurkode, Palakkad"],
"679503":[39,163,0.0,"Kulakkad, Palakkad"],
"679504":[51,211,0.0,"Karumanamkurissi, Palakkad"],
"679505":[317,758,0.0,"Puliyanamkunnu, Palakkad"],
"679506":[274,779,0.0,"Thekkumuri CPL, Palakkad"],
"679511":[317,806,0.0,"Mulanhur, Palakkad"],
"679512":[61,143,0.0,"Cherumundasseri, Palakkad"],
"679513":[57,124,0.0,"Kottappuram, Palakkad"],
"679514":[57,124,0.0,"Kattukulam South, Palakkad"],
"679515":[61,158,0.0,"Kadambur SO Palakkad, Palakkad"],
"679516":[64,187,0.0,"Vengasseri, Palakkad"],
"679521":[79,216,0.0,"Cherottur, Palakkad"],
"679522":[400,462,-1,"Cherukattupulam, Palakkad"],
"679523":[78,182,0.0,"Koonathara, Palakkad"],
"679531":[146,254,0.44,"Panjal, Thrissur"],
"679532":[165,278,0.15,"Thalassery, Thrissur"],
"679533":[816,1968,-1,"Thirumittakode, Palakkad"],
"679534":[614,1562,-1,"KottapadamTTL, Palakkad"],
"679535":[54,172,0.0,"Chaliyattiri, Palakkad"],
"679536":[426,534,-1,"Perumannur, Palakkad"],
"679551":[69,186,0.0,"Anakkara SO Palakkad, Palakkad"],
"679552":[59,171,0.0,"Kalladathur, Palakkad"],
"679553":[69,182,0.0,"Kumbidi, Palakkad"],
"679554":[58,176,0.0,"Malamalkkavu, Palakkad"],
"679561":[50,138,0.0,"Chammannur, Thrissur"],
"679562":[50,140,0.0,"Punnayur, Thrissur"],
"679563":[51,150,0.0,"Vayilathur, Thrissur"],
"679564":[50,156,0.0,"Andathode, Thrissur"],
"679571":[78,214,0.0,"Perasannur, Malappuram"],
"679572":[73,200,0.0,"Irimbiliyam, Malappuram"],
"679573":[60,183,0.0,"Athalur, Malappuram"],
"679574":[85,244,0.0,"Pidavannur, Malappuram"],
"679575":[55,165,0.0,"Nannamukku South, Malappuram"],
"679576":[60,173,0.0,"Perumparamba, Malappuram"],
"679577":[59,259,0.0,"Ponani, Malappuram"],
"679578":[60,174,0.0,"Mudur, Malappuram"],
"679579":[51,174,0.0,"Palapetty, Malappuram"],
"679580":[59,157,0.0,"Ayirur, Malappuram"],
"679581":[55,161,0.0,"Marancheri, Malappuram"],
"679582":[60,174,0.0,"Trikkanapuram South, Malappuram"],
"679583":[56,317,0.0,"Ponani Nagaram, Malappuram"],
"679584":[41,146,0.0,"Karukathiruthy, Malappuram"],
"679585":[60,168,0.0,"Alankode, Malappuram"],
"679586":[52,221,0.0,"Kadavanad, Malappuram"],
"679587":[51,158,0.0,"Eramangalam, Malappuram"],
"679591":[56,164,0.0,"Othalur West, Malappuram"],
"680001":[52,119,0.0,"Thrissur, Thrissur"],
"680002":[52,169,0.0,"Punkunnu, Thrissur"],
"680003":[54,161,0.0,"Ayyanthole North, Thrissur"],
"680004":[52,155,0.0,"West Fort, Thrissur"],
"680005":[52,153,0.0,"Nellikunnu, Thrissur"],
"680006":[51,100,0.0,"Nehrunagar, Thrissur"],
"680007":[52,102,0.0,"Nedupuzha, Thrissur"],
"680008":[52,197,0.0,"Peringavu, Thrissur"],
"680009":[52,204,0.0,"Thrissur Engg College, Thrissur"],
"680010":[52,196,0.0,"Kolazhi RM, Thrissur"],
"680011":[52,168,0.0,"Kanattukara, Thrissur"],
"680012":[56,159,0.0,"Veluthur, Thrissur"],
"680013":[55,213,0.0,"Kuttur SO Thrissur, Thrissur"],
"680014":[41,100,0.0,"Kuttanellur, Thrissur"],
"680020":[52,155,0.0,"Thrissur City, Thrissur"],
"680021":[52,137,0.0,"Thrissur R S, Thrissur"],
"680022":[52,169,0.0,"Thiruvambady TSR, Thrissur"],
"680026":[51,101,0.0,"Chiyyaram, Thrissur"],
"680027":[52,110,0.0,"Chovvur, Thrissur"],
"680028":[52,206,0.0,"Kattilapoovam, Thrissur"],
"680051":[114,206,0.02,"NODAL DELIVERY CENTER THRISSUR, Thrissur"],
"680101":[64,182,0.0,"Thiruvenkitam, Thrissur"],
"680102":[50,156,0.0,"Kandanassery, Thrissur"],
"680103":[60,197,0.0,"Iringapuram, Thrissur"],
"680104":[64,187,0.0,"Nemmini, Thrissur"],
"680121":[78,152,0.01,"Irinjalakuda, Thrissur"],
"680122":[85,154,0.01,"Edathirinji, Thrissur"],
"680123":[106,191,0.02,"Karumathra, Thrissur"],
"680125":[78,148,0.01,"Porathissery, Thrissur"],
"680301":[40,101,0.0,"Pazhayi, Thrissur"],
"680302":[38,99,0.0,"Vattanathara, Thrissur"],
"680303":[41,99,0.0,"Velupadam, Thrissur"],
"680304":[31,76,0.0,"CHIMMONI DAM, Thrissur"],
"680305":[42,125,0.0,"Anandapuram, Thrissur"],
"680306":[42,96,0.0,"Avanisseri, Thrissur"],
"680307":[32,102,0.0,"Chalakudi, Thrissur"],
"680308":[32,106,0.0,"Mambra, Thrissur"],
"680309":[32,128,0.01,"Kadukutty, Thrissur"],
"680310":[48,119,0.0,"Thottippal, Thrissur"],
"680311":[31,99,0.0,"Koovakkattukunnu, Thrissur"],
"680312":[34,104,0.0,"Inchakundu, Thrissur"],
"680317":[42,96,0.0,"Muttithadi, Thrissur"],
"680501":[65,244,0.0,"Thalakkottukara, Thrissur"],
"680502":[60,214,0.0,"Choondal, Thrissur"],
"680503":[57,192,0.0,"Kunnamkulam, Thrissur"],
"680504":[60,210,0.0,"Koonamoochi, Thrissur"],
"680505":[60,205,0.0,"Kavida, Thrissur"],
"680506":[65,142,0.0,"Palayur, Thrissur"],
"680507":[66,142,0.0,"Maruthayur, Thrissur"],
"680508":[75,156,0.0,"Thirunellur, Thrissur"],
"680509":[75,-1,0.0,"Mullassery, Thrissur"],
"680510":[75,105,0.0,"Enamakkal, Thrissur"],
"680511":[66,165,0.0,"Kakkassery, Thrissur"],
"680512":[64,135,0.0,"Madu, Thrissur"],
"680513":[70,118,0.0,"Toyakkavu, Thrissur"],
"680514":[70,129,0.0,"Kadappuram, Thrissur"],
"680515":[52,139,0.0,"Edakkaliyur, Thrissur"],
"680516":[65,148,0.0,"Tiruvatra, Thrissur"],
"680517":[60,202,0.0,"Chemmannur, Thrissur"],
"680518":[48,130,0.0,"EdakkaraThrissur, Thrissur"],
"680519":[57,187,0.0,"Perumpilavu, Thrissur"],
"680520":[57,187,0.0,"Thozhiyur, Thrissur"],
"680521":[57,198,0.0,"Arthat, Thrissur"],
"680522":[66,166,0.0,"Chakkumkandam, Thrissur"],
"680523":[57,188,0.0,"Chittanjur, Thrissur"],
"680524":[76,120,0.0,"Padoor, Thrissur"],
"680541":[72,223,0.0,"Choolissery, Thrissur"],
"680542":[52,177,0.0,"Mangad, Thrissur"],
"680543":[48,183,0.0,"Korattikkara, Thrissur"],
"680544":[50,165,0.0,"Pengamuck, Thrissur"],
"680545":[70,221,0.0,"Peramangalam, Thrissur"],
"680546":[65,250,0.0,"Kaiparamba, Thrissur"],
"680551":[66,198,0.0,"Chittilapilly, Thrissur"],
"680552":[70,196,0.0,"Pathiyarkulangara, Thrissur"],
"680553":[57,198,0.0,"Puzhakkal, Thrissur"],
"680555":[66,208,0.0,"Amalanagar, Thrissur"],
"680561":[72,127,0.0,"Cherpu Padinjattumuri, Thrissur"],
"680562":[52,113,0.0,"Arattupuzha, Thrissur"],
"680563":[54,100,0.0,"Paralam, Thrissur"],
"680564":[69,109,0.0,"INCHAMUDI, Thrissur"],
"680565":[85,-1,0.0,"Peringottukara, Thrissur"],
"680566":[72,161,0.0,"Nattikabeach, Thrissur"],
"680567":[70,128,0.0,"Triprayar, Thrissur"],
"680568":[120,194,0.0,"Kalimbram, Thrissur"],
"680569":[75,113,0.0,"Thampankadavu, Thrissur"],
"680570":[70,138,0.0,"Vadakkummuri, Thrissur"],
"680571":[69,122,0.0,"Chazhur, Thrissur"],
"680581":[52,252,0.0,"Athani Thrissur, Thrissur"],
"680582":[95,235,0.06,"WadakancheryTC, Thrissur"],
"680583":[146,285,0.17,"Attur, Thrissur"],
"680584":[85,323,0.05,"Kottappuram Wri, Thrissur"],
"680585":[128,280,0.08,"Pulakkad, Thrissur"],
"680586":[146,234,0.13,"Elanad, Thrissur"],
"680587":[166,312,0.0,"Chelakode, Thrissur"],
"680588":[124,262,0.0,"Malavattom, Thrissur"],
"680589":[95,228,0.06,"Karumathra, Thrissur"],
"680590":[95,213,0.06,"Kanjirakode, Thrissur"],
"680591":[146,240,0.17,"Killimangalam, Thrissur"],
"680594":[124,261,0.0,"Kuthampilly, Thrissur"],
"680596":[54,286,0.0,"Thangalur, Thrissur"],
"680601":[72,438,0.0,"Kurumal, Thrissur"],
"680602":[60,192,0.0,"Vaka, Thrissur"],
"680604":[64,226,0.0,"Chiramanangad, Thrissur"],
"680611":[56,156,0.0,"Elthuruth, Thrissur"],
"680612":[72,108,0.0,"Kanjani, Thrissur"],
"680613":[70,109,0.0,"Kandassankadavu, Thrissur"],
"680614":[70,105,0.0,"Vatanapally Beach, Thrissur"],
"680615":[76,141,0.0,"Engandiyur, Thrissur"],
"680616":[76,131,0.0,"Kundaliyur, Thrissur"],
"680617":[68,119,0.0,"Manalur HS, Thrissur"],
"680618":[54,160,0.0,"Aranattukara, Thrissur"],
"680619":[70,116,0.0,"Trithallur West, Thrissur"],
"680620":[64,114,0.0,"Eravu, Thrissur"],
"680623":[78,261,0.06,"Panangattukara, Thrissur"],
"680631":[52,204,0.0,"Ramavarmapuram, Thrissur"],
"680641":[68,100,0.0,"Alapad, Thrissur"],
"680642":[70,107,0.0,"Puthenpeedika, Thrissur"],
"680651":[51,104,0.0,"Nettissery, Thrissur"],
"680652":[51,91,0.0,"Kannara, Thrissur"],
"680653":[42,85,0.0,"Chennaipara, Thrissur"],
"680654":[105,172,0.01,"Vellanikkara, Thrissur"],
"680655":[51,109,0.0,"Ollukkara, Thrissur"],
"680656":[51,87,0.0,"Kerala Agriuniversity, Thrissur"],
"680661":[78,157,0.02,"Nadavaramba, Thrissur"],
"680662":[85,166,0.02,"Kalparamba, Thrissur"],
"680663":[85,205,0.03,"Pullut North, Thrissur"],
"680664":[106,262,0.04,"Lokamaleswaram North, Thrissur"],
"680665":[52,107,0.0,"Panangad SO Thrissur, Thrissur"],
"680666":[109,189,0.04,"Azhikode Jetty, Thrissur"],
"680667":[100,199,0.02,"Anapuzha, Thrissur"],
"680668":[109,192,0.02,"Santhipuram, Thrissur"],
"680669":[95,204,0.03,"Kandamkulam, Thrissur"],
"680670":[106,189,0.02,"Karupadanna, Thrissur"],
"680671":[110,207,0.03,"Padinjare Vemballur, Thrissur"],
"680681":[110,186,0.02,"Chalingad, Thrissur"],
"680682":[78,164,0.02,"Puthenchira Thekkummuri, Thrissur"],
"680683":[55,149,0.01,"Avittathur, Thrissur"],
"680684":[33,101,0.0,"Manakulangara, Thrissur"],
"680685":[110,192,0.02,"Mathilakam, Thrissur"],
"680686":[114,215,0.02,"Perinjanam West, Thrissur"],
"680687":[105,185,0.02,"Kannampallipuram, Thrissur"],
"680688":[105,173,0.02,"Edakulam, Thrissur"],
"680689":[35,103,0.0,"Kanakamala, Thrissur"],
"680691":[110,206,0.02,"Koolimuttam, Thrissur"],
"680697":[54,141,0.01,"Karur, Thrissur"],
"680699":[32,87,0.0,"Chokkana, Thrissur"],
"680701":[69,123,0.0,"Vellani, Thrissur"],
"680702":[69,124,0.0,"Karanchira, Thrissur"],
"680703":[70,127,0.0,"Kuttamangalam, Thrissur"],
"680711":[55,114,0.0,"Panamkulam, Thrissur"],
"680712":[62,126,0.0,"Madayikonam, Thrissur"],
"680721":[29,91,0.0,"Elinjipra, Thrissur"],
"680722":[41,128,0.01,"Vijayaraghavapuram, Thrissur"],
"680724":[28,83,0.0,"Kuttikkad, Thrissur"],
"680731":[66,153,0.02,"Annallur, Thrissur"],
"680732":[66,150,0.02,"Kuruvilassery, Thrissur"],
"680733":[68,155,0.02,"Madathumpady, Thrissur"],
"680734":[74,158,0.02,"Kundur, Thrissur"],
"680741":[38,110,0.0,"Palayamparambu, Thrissur"],
"680751":[51,100,0.0,"Ayyappankavu, Thrissur"],
"682001":[191,293,0.0,"Kochi, Ernakulam"],
"682002":[183,276,0.0,"Mattancherry Jetty, Ernakulam"],
"682003":[164,265,0.0,"Willingdon Island, Ernakulam"],
"682004":[47,173,0.1,"Kochi Naval Base, Ernakulam"],
"682005":[189,296,0.0,"Thoppumpady, Ernakulam"],
"682006":[154,274,0.0,"Palluruthy South, Ernakulam"],
"682007":[146,290,0.0,"Kumbalangi South, Ernakulam"],
"682008":[154,352,0.0,"Andikkadavu, Ernakulam"],
"682009":[183,280,0.0,"North End, Ernakulam"],
"682010":[154,267,0.0,"Edakochi, Ernakulam"],
"682011":[174,276,0.0,"Ernakulam, Ernakulam"],
"682012":[159,244,0.0,"Pachalam, Ernakulam"],
"682013":[164,278,0.0,"Thevara, Ernakulam"],
"682015":[159,264,0.0,"Perumanur, Ernakulam"],
"682016":[174,249,0.0,"Kochi MGRoad, Ernakulam"],
"682017":[159,243,0.0,"Kaloor, Ernakulam"],
"682018":[174,249,0.0,"Ernakulam North, Ernakulam"],
"682019":[159,217,0.0,"Vyttila, Ernakulam"],
"682020":[164,261,0.0,"Kadavanthara, Ernakulam"],
"682021":[145,223,0.0,"Vadacode, Ernakulam"],
"682022":[92,173,0.0,"Kochi University, Ernakulam"],
"682023":[154,235,0.0,"Vaduthala, Ernakulam"],
"682024":[139,241,0.0,"Edapally North, Ernakulam"],
"682025":[154,241,0.0,"Palarivattom, Ernakulam"],
"682026":[156,188,0.0,"Elamakkara, Ernakulam"],
"682027":[139,216,0.0,"Kadamakudi, Ernakulam"],
"682028":[154,232,0.0,"Vennala, Ernakulam"],
"682029":[176,292,0.0,"Matsyapuri, Ernakulam"],
"682030":[145,222,0.0,"Kakkanad West, Ernakulam"],
"682031":[183,276,0.0,"Shanmugham Road, Ernakulam"],
"682032":[159,231,0.0,"Thammanam, Ernakulam"],
"682033":[132,220,0.0,"Changampuzha Nagar, Ernakulam"],
"682034":[139,224,0.0,"Cheranallur, Ernakulam"],
"682035":[183,277,0.0,"Ernakulam College, Ernakulam"],
"682036":[164,264,0.0,"Panampilly Nagar, Ernakulam"],
"682037":[139,224,0.0,"Cochin Special Economic Zone, Ernakulam"],
"682038":[154,260,0.0,"Poonithura, Ernakulam"],
"682039":[61,132,0.0,"Rajagiri Valley, Ernakulam"],
"682040":[150,260,0.0,"Nettoor, Ernakulam"],
"682041":[139,231,0.0,"AIMS Ponekkara, Ernakulam"],
"682042":[174,276,0.0,"InfoparkKochi, Ernakulam"],
"682050":[164,240,0.0,"International Business Centre IBC, Ernakulam"],
"682051":[174,264,0.0,"Kochi Parcel Centre PO, Ernakulam"],
"682052":[132,218,0.0,"Kakkanad NDC, Ernakulam"],
"682053":[159,271,0.0,"Edapally North, Ernakulam"],
"682301":[159,273,0.0,"Kochi Palace, Ernakulam"],
"682302":[116,201,0.0,"Ambalamugal, Ernakulam"],
"682303":[126,216,0.0,"Brahmapuram, Ernakulam"],
"682304":[150,250,0.0,"Maradu, Ernakulam"],
"682305":[96,194,0.0,"Kureekad, Ernakulam"],
"682306":[154,236,0.0,"Eroor South, Ernakulam"],
"682307":[110,199,0.0,"Nadakkavu, Ernakulam"],
"682308":[86,165,0.0,"Meempara, Ernakulam"],
"682309":[61,132,0.0,"Irimbanam, Ernakulam"],
"682310":[95,173,0.0,"Pancode, Ernakulam"],
"682311":[67,110,0.0,"Kinginimattom, Ernakulam"],
"682312":[36,106,0.0,"Kanayannoor, Ernakulam"],
"682313":[84,141,0.0,"Edakkattuvayal, Ernakulam"],
"682314":[96,143,0.0,"Perumpilly, Ernakulam"],
"682315":[95,141,0.0,"Amballur, Ernakulam"],
"682316":[68,125,0.0,"Mekkadambu, Ernakulam"],
"682317":[94,135,0.0,"KULAYATTIKKARA, Ernakulam"],
"682501":[118,164,0.01,"Ayyampilly, Ernakulam"],
"682502":[119,172,0.0,"Edavanakad, Ernakulam"],
"682503":[155,235,0.0,"Elamkunnapuzha, Ernakulam"],
"682504":[164,246,0.0,"Vallarpadam, Ernakulam"],
"682505":[119,186,0.0,"Narakkal, Ernakulam"],
"682506":[150,230,0.0,"Kumbalam, Ernakulam"],
"682507":[176,296,0.0,"Nazreth, Ernakulam"],
"682508":[183,260,0.0,"Azheekal, Ernakulam"],
"682509":[133,182,0.0,"Nedungad, Ernakulam"],
"682511":[61,132,0.0,"Malipuram, Ernakulam"],
"683051":[78,166,0.0,"West Kadungalloor, Ernakulam"],
"683101":[61,133,0.0,"Aluva, Ernakulam"],
"683102":[61,136,0.0,"Desom, Ernakulam"],
"683104":[73,199,0.13,"Kalamassery Development Plot, Ernakulam"],
"683105":[63,125,0.0,"Marampally, Ernakulam"],
"683106":[70,136,0.0,"Thaikkattukara, Ernakulam"],
"683108":[61,136,0.0,"Uliyannoor, Ernakulam"],
"683110":[78,177,0.0,"West Kadungalloor, Ernakulam"],
"683111":[60,113,0.0,"Kochi Airport, Ernakulam"],
"683112":[68,140,0.0,"Erumathala, Ernakulam"],
"683501":[90,233,0.0,"Kuttikkattukara, Ernakulam"],
"683502":[78,247,0.0,"Binanipuram, Ernakulam"],
"683503":[132,211,0.0,"Hmt Colony, Ernakulam"],
"683511":[78,160,0.01,"Karumalloor, Ernakulam"],
"683512":[106,173,0.02,"Chendamangalam, Ernakulam"],
"683513":[109,146,0.01,"Ezhikkara, Ernakulam"],
"683514":[110,168,0.02,"Cherai, Ernakulam"],
"683515":[108,180,0.02,"Palliport, Ernakulam"],
"683516":[105,194,0.02,"Maliankara, Ernakulam"],
"683517":[106,208,0.0,"Varapuzha Landing, Ernakulam"],
"683518":[94,181,0.0,"Kongorpilly, Ernakulam"],
"683519":[114,175,0.01,"Kottuvally, Ernakulam"],
"683520":[90,159,0.01,"Manjaly, Ernakulam"],
"683521":[100,190,0.02,"Vadakkumpuram, Ernakulam"],
"683522":[108,182,0.02,"Kunjithai, Ernakulam"],
"683541":[60,109,0.0,"Airapuram, Ernakulam"],
"683542":[44,95,0.0,"Perumbavoor, Ernakulam"],
"683543":[36,91,0.0,"Rayonpuram, Ernakulam"],
"683544":[29,91,0.0,"Aimurikara, Ernakulam"],
"683545":[28,89,0.0,"Methala, Ernakulam"],
"683546":[28,78,0.0,"Mudakuzha, Ernakulam"],
"683547":[58,105,0.0,"Ponjassery, Ernakulam"],
"683548":[36,93,0.0,"Iringole, Ernakulam"],
"683549":[48,97,0.0,"Vaikkara, Ernakulam"],
"683550":[108,193,0.0,"Okkal, Ernakulam"],
"683556":[54,99,0.0,"Allapra, Ernakulam"],
"683561":[66,157,0.0,"Edathala North, Ernakulam"],
"683562":[82,158,0.0,"Pattimattam, Ernakulam"],
"683563":[74,165,0.0,"Naval Armament Depot Aluva, Ernakulam"],
"683565":[95,190,0.0,"Peringala, Ernakulam"],
"683571":[61,125,0.0,"Chowara, Ernakulam"],
"683572":[313,554,0.0,"Kidangoor, Ernakulam"],
"683573":[54,116,0.0,"Angamally South, Ernakulam"],
"683574":[44,104,0.0,"Yordhanapuram, Ernakulam"],
"683575":[49,107,0.0,"Thuravumkara, Ernakulam"],
"683576":[32,104,0.0,"Paduvapuram, Ernakulam"],
"683577":[32,101,0.0,"Ezhattumugham, Ernakulam"],
"683578":[65,131,0.0,"Kunnukara, Ernakulam"],
"683579":[60,133,0.0,"Parakkadavu, Ernakulam"],
"683580":[60,119,0.0,"Vellarappilly South, Ernakulam"],
"683581":[28,86,0.0,"Kalady Plantation, Ernakulam"],
"683585":[60,123,0.0,"Nedumbassery, Ernakulam"],
"683587":[28,83,0.0,"Malayattoor, Ernakulam"],
"683589":[54,118,0.0,"Mekkad, Ernakulam"],
"683594":[78,155,0.01,"Elanthikara, Ernakulam"],
"685501":[36,92,0.0,"Cheenthalar, Idukki"],
"685503":[40,86,0.0,"Kottamala, Idukki"],
"685505":[65,158,0.0,"Karimkulam Chappath, Idukki"],
"685507":[49,115,0.0,"Kalthotty, Idukki"],
"685508":[70,288,0.0,"Kattappana, Idukki"],
"685509":[98,226,0.0,"Amaravathy, Idukki"],
"685511":[70,227,0.0,"Nariampara, Idukki"],
"685512":[100,463,0.0,"Chellarcoil, Idukki"],
"685514":[54,238,0.0,"Kochuthovala, Idukki"],
"685515":[54,243,0.0,"Anniyartholu, Idukki"],
"685531":[44,134,0.0,"Pambanar, Idukki"],
"685532":[28,88,0.0,"Paloorkavu, Idukki"],
"685533":[44,207,0.0,"Arnakal, Idukki"],
"685535":[86,201,0.0,"Anavilasam, Idukki"],
"685551":[114,418,0.0,"Mali, Idukki"],
"685552":[100,491,0.01,"Karunapuram, Idukki"],
"685553":[86,263,0.0,"Kailasanadu, Idukki"],
"685554":[129,290,0.0,"Chemmannar, Idukki"],
"685561":[30,84,0.0,"Mannamkandam, Idukki"],
"685562":[30,75,0.0,"South Kathipara, Idukki"],
"685563":[30,143,0.0,"Konnathady, Idukki"],
"685565":[30,134,0.0,"Pallivasal, Idukki"],
"685566":[102,232,0.0,"C Kuthumkal, Idukki"],
"685571":[86,229,0.0,"Mullarikudy, Idukki"],
"685581":[43,155,0.11,"Mulappuram, Idukki"],
"685582":[47,179,0.09,"Parapuzha, Idukki"],
"685583":[70,143,0.22,"Kuninji, Idukki"],
"685584":[60,171,0.22,"Thodupuzha, Idukki"],
"685585":[60,179,0.24,"Anchiri, Idukki"],
"685586":[73,151,0.48,"Vadakkummury, Idukki"],
"685587":[52,131,0.35,"Ellumpuram, Idukki"],
"685588":[40,100,0.14,"Elamdesom, Idukki"],
"685589":[39,83,0.08,"Edadidukki, Idukki"],
"685590":[40,101,0.18,"Kanjar, Idukki"],
"685591":[33,71,0.0,"Arakulam, Idukki"],
"685595":[36,82,0.0,"Malayinchi, Idukki"],
"685601":[32,80,0.0,"Karippalangad, Idukki"],
"685602":[32,65,0.0,"Manipara, Idukki"],
"685603":[32,67,0.0,"Idukki Painavu, Idukki"],
"685604":[30,68,0.0,"Padamugham, Idukki"],
"685605":[60,168,0.13,"Ezhumuttom, Idukki"],
"685606":[30,74,0.0,"Keerithode, Idukki"],
"685607":[39,180,0.0,"Mullaringadu, Idukki"],
"685608":[72,166,0.17,"Manakkad, Idukki"],
"685609":[86,223,0.0,"Perumthotty, Idukki"],
"685612":[30,100,0.0,"LETCHMI ESTATE, Idukki"],
"685613":[205,406,0.0,"Panniar Estate, Idukki"],
"685614":[72,172,0.0,"Chattamannar, Idukki"],
"685615":[79,190,0.0,"Kottakomboor, Idukki"],
"685616":[60,150,0.0,"Mattupatty ISP, Idukki"],
"685618":[204,405,0.0,"Chinnakanal, Idukki"],
"685619":[140,300,0.0,"Aruvilanchal, Idukki"],
"685620":[85,193,-1,"Kanthallur, Idukki"],
"686001":[57,181,0.0,"Kottayam, Kottayam"],
"686002":[56,180,0.0,"Kottayam Collectorate, Kottayam"],
"686003":[270,483,0.0,"Veloor, Kottayam"],
"686004":[57,182,0.0,"Devalokam, Kottayam"],
"686005":[58,203,0.0,"Kummanam, Kottayam"],
"686006":[57,189,0.0,"Nattassery S H Mount, Kottayam"],
"686007":[58,152,0.0,"Pallom, Kottayam"],
"686008":[58,240,0.0,"Arpookara, Kottayam"],
"686009":[52,160,0.0,"Rubber Board, Kottayam"],
"686010":[52,165,0.0,"Vadavathoor, Kottayam"],
"686011":[270,432,0.0,"Eravinalloor, Kottayam"],
"686012":[348,1080,-1,"Moolavattom, Kottayam"],
"686013":[56,176,0.0,"Kottayam South, Kottayam"],
"686014":[270,509,0.0,"Parippu, Kottayam"],
"686015":[270,511,0.0,"Pulikkuttissery, Kottayam"],
"686016":[315,560,0.0,"Perumbaikkad, Kottayam"],
"686017":[57,183,0.0,"Mariathuruthu, Kottayam"],
"686018":[54,168,0.0,"Manganam, Kottayam"],
"686019":[56,182,0.0,"Amayannur, Kottayam"],
"686020":[56,178,0.0,"Kanjiram, Kottayam"],
"686021":[54,158,0.0,"Pariyaram SO Kottayam, Kottayam"],
"686022":[68,216,0.0,"Chengalam South, Kottayam"],
"686041":[68,208,0.0,"Malloossery, Kottayam"],
"686101":[64,184,0.0,"Changanacherry, Kottayam"],
"686102":[60,183,0.0,"Kunnamkary, Alappuzha"],
"686103":[90,178,0.0,"Kumarankary, Alappuzha"],
"686104":[61,172,0.0,"Veroor, Kottayam"],
"686105":[53,166,0.0,"Kottamurickal, Kottayam"],
"686106":[57,156,0.0,"Cheeranchira, Kottayam"],
"686121":[371,509,0.0,"Nadackal, Kottayam"],
"686122":[28,65,0.0,"Aruvithura, Kottayam"],
"686123":[28,66,0.0,"Thidanad, Kottayam"],
"686141":[90,227,0.0,"Vaikom, Kottayam"],
"686143":[90,187,0.0,"Akkarapadom, Kottayam"],
"686144":[90,223,0.0,"Ambika Market, Kottayam"],
"686146":[347,622,0.0,"Vaikaprayar, Kottayam"],
"686501":[28,119,0.0,"Areeparampu, Kottayam"],
"686502":[28,83,0.0,"Kooropada, Kottayam"],
"686503":[28,76,0.0,"Anikad East, Kottayam"],
"686504":[28,69,0.0,"Vazhoor East, Kottayam"],
"686505":[28,73,0.0,"Theerthapadapuram, Kottayam"],
"686506":[28,75,0.0,"Chennakunnu, Kottayam"],
"686507":[28,78,0.0,"Kanjirapally, Kottayam"],
"686508":[30,79,0.0,"Kappadu, Kottayam"],
"686509":[32,70,0.0,"Kanakapalam, Kottayam"],
"686510":[44,79,0.0,"Muttappally, Kottayam"],
"686511":[44,78,0.0,"Mannadisala, Pathanamthitta"],
"686512":[28,78,0.0,"Urakkanadu, Kottayam"],
"686513":[33,79,0.0,"Karinilam, Kottayam"],
"686514":[32,83,0.0,"Parathanam, Kottayam"],
"686515":[30,77,0.0,"Kanam, Kottayam"],
"686516":[32,105,0.0,"Vattakunnu, Kottayam"],
"686517":[28,79,0.0,"Chakompathal, Kottayam"],
"686518":[28,77,0.0,"Vizhikithode, Kottayam"],
"686519":[28,80,0.0,"Chirakadavu Centre, Kottayam"],
"686520":[28,82,0.0,"Chenappady, Kottayam"],
"686521":[28,77,0.0,"Poothakuzhy, Kottayam"],
"686522":[28,73,0.0,"Panamattom, Kottayam"],
"686531":[58,155,0.0,"Chingavanam, Kottayam"],
"686532":[61,150,0.0,"Kurichy, Kottayam"],
"686533":[57,160,0.0,"Channanikadu, Kottayam"],
"686534":[78,166,0.0,"Eara North, Alappuzha"],
"686535":[57,155,0.0,"Malakunnam, Kottayam"],
"686536":[48,143,0.0,"Mammoodu, Kottayam"],
"686537":[53,157,0.0,"Pallickachirakavala, Kottayam"],
"686538":[56,155,0.0,"Vakathanam South, Kottayam"],
"686539":[35,109,0.0,"Eravuchira, Kottayam"],
"686540":[32,136,0.0,"Koothrappally, Kottayam"],
"686541":[28,97,0.0,"Kulathoorprayar, Kottayam"],
"686542":[30,95,0.0,"Nedumanny, Kottayam"],
"686543":[28,86,0.0,"Erathuvadakara, Kottayam"],
"686544":[30,80,0.0,"Karikkattoor Centre, Kottayam"],
"686545":[34,143,0.0,"Santhipuram, Kottayam"],
"686546":[48,149,0.0,"Amara, Kottayam"],
"686547":[30,79,0.0,"Kottangal, Pathanamthitta"],
"686548":[56,198,0.0,"Nalukody, Kottayam"],
"686555":[28,80,0.0,"Kanjirappara, Kottayam"],
"686560":[68,246,0.0,"Priyadarsini Hills, Kottayam"],
"686561":[58,193,0.0,"Amalagiri, Kottayam"],
"686562":[270,516,0.0,"Sreekantamangalam, Kottayam"],
"686563":[80,175,0.0,"Kumarakom East, Kottayam"],
"686564":[80,175,0.0,"Kongandoor, Kottayam"],
"686571":[28,140,0.0,"Padinjattinkara, Kottayam"],
"686572":[28,63,-1,"Kattachira, Kottayam"],
"686573":[282,1328,0.0,"Mutholi, Kottayam"],
"686574":[373,696,0.0,"Nechipuzhoor, Kottayam"],
"686575":[28,58,-1,"Pala, Kottayam"],
"686576":[72,133,0.32,"Amanakara, Kottayam"],
"686577":[50,90,0.44,"Meenachil, Kottayam"],
"686578":[28,61,-1,"Ampara Nirappel, Kottayam"],
"686579":[40,88,0.2,"Choondacherry, Kottayam"],
"686580":[379,1582,0.0,"Adukkam, Kottayam"],
"686581":[60,117,0.0,"Chennad, Kottayam"],
"686582":[102,235,0.02,"Cholathadom, Kottayam"],
"686583":[270,522,0.0,"Punnathura, Kottayam"],
"686584":[31,98,0.0,"Chempilavu, Kottayam"],
"686585":[28,77,0.0,"Kanjiramattom, Kottayam"],
"686586":[31,98,0.0,"Chovvur, Kottayam"],
"686587":[31,98,0.0,"Kudalloor, Kottayam"],
"686601":[270,544,0.0,"Moozhikulangara, Kottayam"],
"686602":[270,541,0.0,"Onamthuruthu, Kottayam"],
"686603":[70,159,0.0,"Chamakala, Kottayam"],
"686604":[64,146,0.0,"Arunoottimangalam, Kottayam"],
"686605":[64,135,0.0,"Edavattom, Kottayam"],
"686606":[88,145,0.0,"Pallippurathussery, Kottayam"],
"686607":[90,168,0.0,"Kothavara, Kottayam"],
"686608":[96,155,0.0,"Chempu, Kottayam"],
"686609":[64,99,0.0,"Mevelloor, Kottayam"],
"686610":[60,118,0.0,"Karikode, Kottayam"],
"686611":[335,750,0.0,"Perumthuruth, Kottayam"],
"686612":[60,117,0.0,"Kattampack, Kottayam"],
"686613":[60,117,0.0,"Kappumthala, Kottayam"],
"686616":[64,128,0.0,"Newsprint Nagar, Kottayam"],
"686630":[55,201,0.0,"Thellakom, Kottayam"],
"686631":[315,652,0.0,"Pattithanam, Kottayam"],
"686632":[58,148,0.0,"Kothanallur, Kottayam"],
"686633":[45,128,0.0,"Mannackanad, Kottayam"],
"686634":[300,769,0.0,"Kurichithanam, Kottayam"],
"686635":[300,770,0.0,"Palakkattumala, Kottayam"],
"686636":[406,1147,-1,"Vakad, Kottayam"],
"686637":[32,172,0.0,"Peroor, Kottayam"],
"686651":[60,117,0.0,"Alanad, Kottayam"],
"686652":[40,104,0.27,"Konipad, Kottayam"],
"686653":[50,117,0.45,"Kadanad Meenachil, Kottayam"],
"686661":[67,120,0.0,"Muvattupuzha, Ernakulam"],
"686662":[67,143,0.1,"Thirumarady, Ernakulam"],
"686663":[67,113,0.0,"Kizhmuri, Ernakulam"],
"686664":[64,115,0.0,"Manidu, Ernakulam"],
"686665":[60,120,0.0,"Perumbadavam, Ernakulam"],
"686666":[67,168,0.0,"Kothamangalam College, Ernakulam"],
"686667":[64,120,0.0,"North Piramadom, Ernakulam"],
"686668":[67,178,0.07,"Kaloor, Ernakulam"],
"686669":[67,114,0.0,"Mazhuvannoor, Ernakulam"],
"686670":[68,173,0.1,"Avoly, Ernakulam"],
"686671":[48,183,0.0,"Kadavoor, Ernakulam"],
"686672":[70,128,0.12,"Meenkunnam, Ernakulam"],
"686673":[68,124,0.0,"Nirmala, Ernakulam"],
"686681":[48,180,0.0,"Bhoothathankettu, Ernakulam"],
"686691":[67,166,0.0,"Cheruvattoor, Ernakulam"],
"686692":[48,91,0.0,"Kottappady, Ernakulam"],
"686693":[47,201,0.0,"Neriamangalam, Ernakulam"],
"688001":[84,152,0.0,"Alappuzha, Alappuzha"],
"688002":[119,161,0.0,"Vattayal Ward, Alappuzha"],
"688003":[148,187,0.0,"Vadackal, Alappuzha"],
"688004":[155,175,0.0,"Punnapra, Alappuzha"],
"688005":[143,167,0.0,"Kakkazhom, Alappuzha"],
"688006":[84,103,0.0,"Kottankulangara, Alappuzha"],
"688007":[84,119,0.0,"Kommady Ward, Alappuzha"],
"688008":[83,93,0.0,"Thumpoly, Alappuzha"],
"688009":[142,177,0.0,"Pandarakulam, Alappuzha"],
"688011":[88,117,0.0,"Chungom, Alappuzha"],
"688013":[88,122,0.0,"Thondankulangara, Alappuzha"],
"688014":[148,167,0.0,"Punnapra North, Alappuzha"],
"688051":[119,151,0.0,"Alappuzha, Alappuzha"],
"688501":[140,170,0.0,"Kuttamangalam, Alappuzha"],
"688502":[137,161,0.0,"Chathurthiakary, Alappuzha"],
"688503":[142,180,0.0,"Nedumudy, Alappuzha"],
"688504":[108,166,0.0,"Kayalpuram, Alappuzha"],
"688505":[142,-1,0.0,"Pullangadi, Alappuzha"],
"688506":[108,180,0.0,"Cherukara Kuttanad, Alappuzha"],
"688521":[83,87,0.0,"Pathirappally, Alappuzha"],
"688522":[84,-1,0.0,"Pollethai, Alappuzha"],
"688523":[88,-1,0.0,"PONNITTUSSERY, Alappuzha"],
"688524":[92,139,0.0,"Cherthala, Alappuzha"],
"688525":[90,90,0.0,"Muhamma, Alappuzha"],
"688526":[102,204,0.0,"Manappuram, Alappuzha"],
"688527":[92,102,0.0,"Kannankara, Alappuzha"],
"688528":[102,216,0.0,"Thycattussery, Alappuzha"],
"688529":[96,174,0.0,"Vettackal, Alappuzha"],
"688530":[90,-1,0.0,"Thaickal, Alappuzha"],
"688531":[109,226,0.0,"Andhakaranazhy, Alappuzha"],
"688532":[108,219,0.0,"Valamangalam, Alappuzha"],
"688533":[109,229,0.0,"Kuthiathode, Alappuzha"],
"688534":[119,146,0.0,"Aroor, Alappuzha"],
"688535":[115,225,0.0,"Vaduthala Jetty, Alappuzha"],
"688536":[94,162,0.0,"Vayalar, Alappuzha"],
"688537":[115,248,0.0,"Chandiroor, Alappuzha"],
"688538":[92,-1,0.0,"Aryad North, Alappuzha"],
"688539":[94,109,0.0,"Varanad, Alappuzha"],
"688540":[110,196,0.0,"Parayakad, Alappuzha"],
"688541":[92,173,0.0,"Thirunallur, Alappuzha"],
"688555":[92,101,0.0,"Varanam, Alappuzha"],
"688561":[140,210,0.0,"Karumady, Alappuzha"],
"688562":[137,159,0.0,"Kunnumma Thakazhy, Alappuzha"],
"688563":[136,-1,0.0,"THOTTAPPALLY, Alappuzha"],
"688570":[114,208,0.0,"Perumbalam, Alappuzha"],
"688582":[88,-1,0.0,"Kanichukulangara, Alappuzha"],
"689101":[80,-1,0.0,"Tiruvalla, Pathanamthitta"],
"689102":[28,72,0.0,"Kallumkal, Pathanamthitta"],
"689103":[53,153,0.0,"Chumathra, Pathanamthitta"],
"689104":[103,120,0.0,"Valanjavattom East, Pathanamthitta"],
"689105":[56,130,0.0,"Kattode, Pathanamthitta"],
"689106":[55,117,0.0,"Thengeli, Pathanamthitta"],
"689107":[28,85,0.0,"Perumthuruthy, Pathanamthitta"],
"689108":[154,-1,0.0,"Karakkal, Pathanamthitta"],
"689109":[80,192,0.0,"Eramallikkara, Alappuzha"],
"689110":[104,161,0.0,"Nedumpuram, Pathanamthitta"],
"689111":[56,115,0.0,"Tiruvalla RS, Pathanamthitta"],
"689112":[90,97,0.0,"Amichikary, Pathanamthitta"],
"689113":[64,120,0.0,"Alumthuruthy, Pathanamthitta"],
"689115":[34,81,0.0,"Thirumoolapuram, Pathanamthitta"],
"689121":[33,85,0.0,"Chengannur, Alappuzha"],
"689122":[36,57,0.0,"Neervilakom, Pathanamthitta"],
"689123":[39,74,0.0,"Arattupuzha, Pathanamthitta"],
"689124":[57,68,0.0,"Mundancavu, Alappuzha"],
"689126":[60,-1,0.0,"Perisserry, Alappuzha"],
"689501":[30,74,0.0,"Mannam Sugar Mills, Pathanamthitta"],
"689502":[29,67,0.0,"Keerukuzhy, Pathanamthitta"],
"689503":[31,70,0.0,"Ullannur, Pathanamthitta"],
"689504":[36,71,0.0,"Kotta, Alappuzha"],
"689505":[57,-1,0.0,"Peringalamulakuzha, Alappuzha"],
"689506":[80,-1,0.0,"Pandanad West, Alappuzha"],
"689507":[28,61,-1,"Mezhuveli, Pathanamthitta"],
"689508":[75,-1,0.0,"Mampra, Alappuzha"],
"689509":[46,65,0.0,"Punthala, Alappuzha"],
"689510":[75,-1,0.0,"Bhudhanoor, Alappuzha"],
"689511":[64,70,0.0,"Elanjimel, Alappuzha"],
"689512":[32,142,0.0,"Kudassanad, Alappuzha"],
"689513":[48,184,0.0,"Mammoodu, Pathanamthitta"],
"689514":[30,89,0.0,"Karithotta, Pathanamthitta"],
"689515":[30,74,0.0,"Poozhikkad, Pathanamthitta"],
"689520":[57,-1,0.0,"Poomala, Alappuzha"],
"689521":[52,67,0.0,"Kozhuvallur, Alappuzha"],
"689531":[36,92,0.0,"Poovathoor, Pathanamthitta"],
"689532":[32,76,0.0,"Edayaramula West, Pathanamthitta"],
"689533":[32,80,0.0,"Mallappuzhassery, Pathanamthitta"],
"689541":[36,74,0.0,"Thottabhagom, Pathanamthitta"],
"689542":[53,116,0.0,"Nellimala, Pathanamthitta"],
"689543":[53,127,0.0,"Madathumbhagom North, Pathanamthitta"],
"689544":[34,109,0.0,"Narakathanni, Pathanamthitta"],
"689545":[34,86,0.0,"Kolabhagom, Pathanamthitta"],
"689546":[42,92,0.0,"Kunnathukara HSC, Pathanamthitta"],
"689547":[36,95,0.0,"Muttumon, Pathanamthitta"],
"689548":[38,106,0.0,"Kurunghazhabhagom, Pathanamthitta"],
"689549":[33,81,0.0,"Chirayirambu, Pathanamthitta"],
"689550":[35,82,0.0,"Kuriannoor, Pathanamthitta"],
"689551":[42,97,0.0,"Otherawest, Pathanamthitta"],
"689571":[45,115,0.0,"Karikuzhy, Alappuzha"],
"689572":[108,-1,0.0,"Thalavady South, Alappuzha"],
"689573":[111,-1,0.0,"Thayamkary, Alappuzha"],
"689574":[60,147,0.0,"Muttar, Alappuzha"],
"689581":[42,146,0.0,"Manthanam, Pathanamthitta"],
"689582":[100,156,0.0,"Anjilithanam, Pathanamthitta"],
"689583":[32,121,0.0,"Kadamankulam, Pathanamthitta"],
"689584":[38,139,0.0,"Mallappally East, Pathanamthitta"],
"689585":[42,143,0.0,"Pariyaram, Pathanamthitta"],
"689586":[32,100,0.0,"Chalappally, Pathanamthitta"],
"689587":[32,123,0.0,"Padimon, Pathanamthitta"],
"689588":[430,970,0.01,"Kulathur, Pathanamthitta"],
"689589":[35,161,0.0,"Nooromavu, Pathanamthitta"],
"689590":[44,112,0.0,"Veliyanadu North, Alappuzha"],
"689591":[36,90,0.0,"Mepral, Pathanamthitta"],
"689592":[74,88,0.0,"Perumpatty, Pathanamthitta"],
"689594":[38,139,0.0,"Mallappally North, Pathanamthitta"],
"689595":[28,63,-1,"Mithrakary, Alappuzha"],
"689597":[186,275,0.0,"Thuruthicaud, Pathanamthitta"],
"689602":[74,88,0.0,"Puthusserry South, Pathanamthitta"],
"689611":[44,97,0.0,"Kanjeettukara, Pathanamthitta"],
"689612":[44,97,0.0,"Velliyara, Pathanamthitta"],
"689613":[38,92,0.0,"Vellayil, Pathanamthitta"],
"689614":[617,1717,0.16,"Edappavoor, Pathanamthitta"],
"689615":[32,80,0.0,"Kariamplavu, Pathanamthitta"],
"689621":[94,-1,0.0,"Vadakkumbhagom, Pathanamthitta"],
"689622":[85,-1,0.0,"Eramathoor, Alappuzha"],
"689623":[88,-1,0.0,"Kuttemperur, Alappuzha"],
"689624":[85,-1,0.0,"Peringilipuram, Alappuzha"],
"689625":[30,74,0.0,"Thumpamon North, Pathanamthitta"],
"689626":[137,165,0.0,"Parumala, Pathanamthitta"],
"689627":[95,-1,0.0,"Melpadom, Alappuzha"],
"689641":[34,89,0.0,"Melukara, Pathanamthitta"],
"689642":[34,79,0.0,"Naranganam North, Pathanamthitta"],
"689643":[32,88,0.0,"Elanthur East, Pathanamthitta"],
"689644":[28,76,0.0,"Kuzhikala, Pathanamthitta"],
"689645":[60,195,0.0,"Pathanamthitta, Pathanamthitta"],
"689646":[60,120,0.0,"Vazhamuttom East, Pathanamthitta"],
"689647":[40,89,0.0,"Oonnukal, Pathanamthitta"],
"689648":[60,134,0.0,"Vallicode, Pathanamthitta"],
"689649":[47,101,0.0,"Anthiyalankavu, Pathanamthitta"],
"689650":[50,105,0.0,"Kattoor Kozhencherry, Pathanamthitta"],
"689652":[50,157,0.12,"Punnakkad, Pathanamthitta"],
"689653":[47,108,0.0,"Musaliar College, Pathanamthitta"],
"689654":[52,196,0.03,"Kozhencherry Thekkemala, Pathanamthitta"],
"689656":[60,102,0.0,"Elappupara, Pathanamthitta"],
"689661":[30,73,0.0,"Kumpalampoika, Pathanamthitta"],
"689662":[55,108,0.0,"Pezhumpara, Pathanamthitta"],
"689663":[47,101,0.0,"Neeliplavu, Pathanamthitta"],
"689664":[50,106,0.0,"Thalachira Eram, Pathanamthitta"],
"689666":[50,109,0.0,"Malayalapuzha Thazham, Pathanamthitta"],
"689667":[50,90,0.0,"Kochukoikkal, Pathanamthitta"],
"689668":[28,77,0.0,"Thonniamala, Pathanamthitta"],
"689671":[104,-1,0.0,"Chengalthadom, Pathanamthitta"],
"689672":[50,101,0.0,"Vayalathala, Pathanamthitta"],
"689673":[44,84,0.0,"Karikulam, Pathanamthitta"],
"689674":[38,86,0.0,"Oonnakavu, Pathanamthitta"],
"689675":[28,76,0.0,"Valiyakavu, Pathanamthitta"],
"689676":[36,82,0.0,"Thombikandam, Pathanamthitta"],
"689677":[32,82,0.0,"Chethackal, Pathanamthitta"],
"689678":[50,106,0.0,"Mekozhur, Pathanamthitta"],
"689691":[60,155,0.0,"Kallely, Pathanamthitta"],
"689692":[50,124,0.0,"Attachakkal, Pathanamthitta"],
"689693":[60,190,0.0,"Murinjakal, Pathanamthitta"],
"689694":[52,182,0.04,"Padam, Pathanamthitta"],
"689695":[36,198,0.03,"Maloor College, Kollam"],
"689696":[41,147,0.09,"Kamukumcherry, Kollam"],
"689698":[34,82,0.0,"Muthupezhumkal, Pathanamthitta"],
"689699":[49,102,0.0,"Manneera, Pathanamthitta"],
"689711":[50,92,0.0,"Adichipuzha, Pathanamthitta"],
"690101":[75,85,0.0,"Mavelikara, Alappuzha"],
"690102":[64,65,0.0,"Puthiyacavu, Alappuzha"],
"690103":[88,-1,0.0,"Kandiyoor, Alappuzha"],
"690104":[80,-1,0.0,"Ezhakadavu, Alappuzha"],
"690105":[85,-1,0.0,"Chennithala South, Alappuzha"],
"690106":[80,93,0.0,"Erezha North, Alappuzha"],
"690107":[59,92,0.0,"Varenickal, Alappuzha"],
"690108":[70,75,0.0,"Eravankara, Alappuzha"],
"690110":[80,84,0.0,"Arunoottimangalam, Alappuzha"],
"690112":[36,67,0.0,"Ayranikudy, Alappuzha"],
"690501":[57,168,0.0,"Kaduvinal, Alappuzha"],
"690502":[92,129,0.0,"Kayangulam, Alappuzha"],
"690503":[85,125,0.0,"Illippakulam, Alappuzha"],
"690504":[48,181,0.0,"Athikattukulangara, Alappuzha"],
"690505":[66,151,0.0,"Kannanakuzhy, Alappuzha"],
"690506":[92,-1,0.0,"Muthukulam, Alappuzha"],
"690507":[92,105,0.0,"Evur, Alappuzha"],
"690508":[90,124,0.0,"Pathiyoor, Alappuzha"],
"690509":[64,76,0.0,"Kallimel, Alappuzha"],
"690510":[87,130,0.0,"Olakettiambalam, Alappuzha"],
"690511":[92,-1,0.0,"Muttomalleppey, Alappuzha"],
"690512":[92,-1,0.0,"Naduvattom, Alappuzha"],
"690513":[94,-1,0.0,"Akamkudy, Alappuzha"],
"690514":[97,-1,0.0,"Payipad, Alappuzha"],
"690515":[110,-1,0.0,"Arattupuzha North, Alappuzha"],
"690516":[104,-1,0.0,"Mahadevikadu, Alappuzha"],
"690517":[111,-1,0.0,"Ayaparambu, Alappuzha"],
"690518":[64,190,0.0,"Karunagappally, Kollam"],
"690519":[58,177,0.0,"Kallelibhagom, Kollam"],
"690520":[34,205,0.0,"Ambalathumbhagom, Kollam"],
"690521":[51,148,0.0,"Pallisserickal, Kollam"],
"690522":[44,189,0.0,"Thengamom, Pathanamthitta"],
"690523":[70,144,0.0,"Edakulangara, Kollam"],
"690524":[57,83,0.0,"Padinjattakkara, Kollam"],
"690525":[82,160,0.0,"Clappana, Kollam"],
"690526":[82,135,0.0,"Madathilkaranma, Kollam"],
"690527":[93,129,0.0,"Govindamuttom, Alappuzha"],
"690528":[89,153,0.0,"Varavila, Kollam"],
"690529":[46,79,0.0,"Pattoor, Alappuzha"],
"690530":[40,160,0.0,"Pachakkad, Alappuzha"],
"690531":[92,108,0.0,"Pattolimarket, Alappuzha"],
"690532":[93,-1,0.0,"Chingoli, Alappuzha"],
"690533":[75,134,0.0,"Kappil East, Alappuzha"],
"690534":[52,92,0.0,"Thannikunnu, Alappuzha"],
"690535":[93,112,0.0,"Arattupuzha, Alappuzha"],
"690536":[53,187,0.0,"Kollaka, Kollam"],
"690537":[89,210,0.0,"Pullikanakku, Alappuzha"],
"690538":[52,150,0.0,"Perungalam, Kollam"],
"690539":[117,117,0.0,"S R P Market, Kollam"],
"690540":[44,270,0.0,"Karimthottuva, Kollam"],
"690542":[82,159,0.0,"Kuzhithura, Kollam"],
"690544":[72,153,0.0,"Karunagappally North, Kollam"],
"690546":[89,167,0.0,"Amrithapuri, Kollam"],
"690547":[90,144,0.0,"Azheekkalthura, Kollam"],
"690548":[104,-1,0.0,"Thamallackal North, Alappuzha"],
"690558":[57,86,0.0,"Vettiyar, Alappuzha"],
"690559":[89,130,0.0,"Perungala, Alappuzha"],
"690561":[58,178,0.0,"Anayadi, Kollam"],
"690571":[48,133,0.0,"Nooranad Sanatorium, Alappuzha"],
"690572":[90,121,0.0,"Eruva, Alappuzha"],
"690573":[79,184,0.0,"Cheriyazheekal, Kollam"],
"690574":[64,172,0.0,"Pavumba, Kollam"],
"691001":[94,204,0.0,"Kollam, Kollam"],
"691002":[82,191,0.0,"Asramom, Kollam"],
"691003":[86,234,0.0,"Maruthadi, Kollam"],
"691004":[80,211,0.0,"Kallumthazham, Kollam"],
"691005":[71,196,0.0,"Thattarkonam, Kollam"],
"691006":[94,234,0.0,"Pallithottam, Kollam"],
"691007":[102,217,0.0,"Thangasserry, Kollam"],
"691008":[85,213,0.0,"Kadappakada, Kollam"],
"691009":[82,175,0.0,"Thevally, Kollam"],
"691010":[82,238,0.0,"Mundakkal, Kollam"],
"691011":[85,293,0.0,"Valathungal, Kollam"],
"691012":[80,206,0.0,"Thirumullavaram, Kollam"],
"691013":[82,175,0.0,"Kollam Cutchery, Kollam"],
"691014":[70,205,0.0,"Chandanathope, Kollam"],
"691015":[71,206,0.0,"Kilikollur East, Kollam"],
"691016":[85,268,0.0,"Thekkevila, Kollam"],
"691019":[75,203,0.0,"Uliyakovil, Kollam"],
"691020":[80,338,0.0,"Koottikada, Kollam"],
"691021":[85,249,0.0,"Ayathil, Kollam"],
"691051":[85,193,0.0,"Asramom, Kollam"],
"691301":[76,208,0.0,"Paravur SO Kollam, Kollam"],
"691302":[71,179,0.0,"Kalakode, Kollam"],
"691303":[76,263,0.0,"Kakkotumoola, Kollam"],
"691304":[71,346,0.0,"Pullichira, Kollam"],
"691305":[56,150,0.12,"Punalur, Kollam"],
"691306":[53,165,0.06,"Edamulackal, Kollam"],
"691307":[98,361,0.12,"Urukunnu, Kollam"],
"691308":[103,666,-1,"Kallada Irrigation Project, Kollam"],
"691309":[154,261,0.0,"Edapalayam, Kollam"],
"691310":[91,295,-1,"Chozhiakode, Kollam"],
"691311":[35,203,0.0,"Anakulam, Kollam"],
"691312":[52,398,0.12,"Ayilara, Kollam"],
"691319":[58,185,0.0,"Thekkumbhagom, Kollam"],
"691322":[50,151,0.12,"Narikal, Kollam"],
"691331":[64,165,0.12,"Kakkode, Kollam"],
"691332":[64,155,0.12,"Kariyara, Kollam"],
"691333":[48,176,0.12,"Areeplachy, Kollam"],
"691334":[67,174,0.0,"Polachira, Kollam"],
"691500":[44,146,0.0,"Peruvelikara, Kollam"],
"691501":[53,181,0.0,"Kanjiracode, Kollam"],
"691502":[50,139,0.0,"Koduvila, Kollam"],
"691503":[45,126,0.0,"Padappakara, Kollam"],
"691504":[53,190,0.0,"Perumpuzha, Kollam"],
"691505":[48,171,0.0,"Irumpanangadu, Kollam"],
"691506":[60,177,0.0,"Kottarakara, Kollam"],
"691507":[48,187,0.0,"Iverkala East, Kollam"],
"691508":[48,116,0.05,"Avaneeswaram, Kollam"],
"691509":[58,185,0.0,"Nedumoncavu, Kollam"],
"691510":[53,155,0.0,"Meeyana, Kollam"],
"691511":[63,183,0.0,"Vellimon West, Kollam"],
"691512":[53,102,0.0,"Muttara, Kollam"],
"691515":[58,183,0.0,"Nallila, Kollam"],
"691516":[48,90,0.0,"Akkal, Kollam"],
"691520":[48,106,0.0,"Ummannur, Kollam"],
"691521":[32,258,0.0,"Kulakkadathazham, Kollam"],
"691522":[41,295,0.01,"Thekketheri, Kollam"],
"691523":[32,226,0.0,"Adur Kla, Pathanamthitta"],
"691524":[36,212,0.0,"Marur, Pathanamthitta"],
"691525":[48,231,0.0,"Parakara, Pathanamthitta"],
"691526":[30,317,0.0,"Thazhathuvadakku, Pathanamthitta"],
"691527":[58,168,0.0,"Nellikunnam, Kollam"],
"691530":[55,117,0.0,"Mannady SO Pathanamthitta, Pathanamthitta"],
"691531":[58,175,0.01,"Kizhakketheruvu, Kollam"],
"691532":[53,119,0.03,"Ambalakkara, Kollam"],
"691533":[50,112,0.0,"Cheruvakkal, Kollam"],
"691534":[46,137,0.0,"Elampazhannur, Kollam"],
"691535":[45,138,0.0,"Kaithode, Kollam"],
"691536":[49,163,0.0,"Edathara, Kollam"],
"691537":[53,168,0.0,"Mailode, Kollam"],
"691538":[53,120,0.03,"Kokkad, Kollam"],
"691540":[58,188,0.0,"Veliyam West, Kollam"],
"691541":[52,216,0.0,"Kollayil, Kollam"],
"691543":[44,197,0.0,"Cherupoika, Kollam"],
"691551":[31,228,0.0,"Choorakode, Pathanamthitta"],
"691552":[33,212,0.0,"Thuvayur South, Pathanamthitta"],
"691553":[34,350,0.0,"Puthenambalam, Kollam"],
"691554":[36,248,0.0,"Pazhakulam, Pathanamthitta"],
"691555":[64,173,0.0,"Angadical South, Pathanamthitta"],
"691556":[41,337,0.02,"Chayalode, Pathanamthitta"],
"691557":[50,149,0.02,"Kura, Kollam"],
"691559":[50,229,0.0,"Mancodekadakkal, Kollam"],
"691560":[50,237,0.01,"Thamarakudy, Kollam"],
"691566":[50,169,0.0,"Perumkulam, Kollam"],
"691571":[76,175,0.0,"Mylakkadu, Kollam"],
"691572":[61,145,0.0,"Chathannur, Kollam"],
"691573":[61,168,0.0,"Velichikala, Kollam"],
"691574":[48,113,0.0,"Velamannoor, Kollam"],
"691576":[63,147,0.0,"Nedumpana, Kollam"],
"691577":[67,184,0.0,"Alumoodu, Kollam"],
"691578":[63,129,0.0,"Chirakkara, Kollam"],
"691579":[63,162,0.0,"Uliyanadu, Kollam"],
"691581":[70,232,0.0,"Sakthikulangara, Kollam"],
"691582":[52,178,0.0,"Puthenthura, Kollam"],
"691583":[46,162,0.0,"Edappallycotta, Kollam"],
"691584":[52,139,0.0,"Vadakkumbhagom, Kollam"],
"691585":[46,134,0.0,"Puthukkadukara, Kollam"],
"691589":[71,259,0.0,"Umayanallur I E, Kollam"],
"691590":[58,176,0.0,"Koivila, Kollam"],
"691601":[70,201,0.0,"Kureepuzha, Kollam"],
"691602":[70,179,0.0,"Ashtamudi, Kollam"],
"695001":[112,208,0.0,"Thiruvananthapuram GPO, Thiruvananthapuram"],
"695002":[96,223,0.0,"Karumom, Thiruvananthapuram"],
"695003":[141,227,0.0,"Kaudiar Square, Thiruvananthapuram"],
"695004":[96,187,0.0,"Goureesapattom, Thiruvananthapuram"],
"695005":[161,294,0.0,"Perurkada, Thiruvananthapuram"],
"695006":[65,212,0.0,"Valiavila, Thiruvananthapuram"],
"695007":[128,169,0.0,"Thiruvananthapuram Beach, Thiruvananthapuram"],
"695008":[139,237,0.0,"Beemapally, Thiruvananthapuram"],
"695009":[128,237,0.0,"Attukal, Thiruvananthapuram"],
"695010":[112,203,0.0,"TVM RK Mission, Thiruvananthapuram"],
"695011":[86,191,0.0,"Thuruvikkal, Thiruvananthapuram"],
"695012":[96,213,0.0,"Poojapura, Thiruvananthapuram"],
"695013":[96,212,0.0,"Cheriyakonni, Thiruvananthapuram"],
"695014":[156,280,0.0,"Jagathy, Thiruvananthapuram"],
"695015":[86,182,0.0,"Nalanchira, Thiruvananthapuram"],
"695016":[106,253,0.0,"Thiruvananthapuram Engg College, Thiruvananthapuram"],
"695017":[106,240,0.0,"Sreekaryam, Thiruvananthapuram"],
"695018":[96,222,0.0,"Pappanamcode, Thiruvananthapuram"],
"695019":[80,221,0.0,"Industrial Estate SO Thiruvananthapuram, Thiruvananthapuram"],
"695020":[65,275,0.0,"Ookode, Thiruvananthapuram"],
"695021":[96,110,0.0,"Valiaveli, Thiruvananthapuram"],
"695022":[115,301,0.0,"Thiruvananthapuram ISRO, Thiruvananthapuram"],
"695023":[173,275,0.0,"Attakulangara, Thiruvananthapuram"],
"695024":[128,184,0.0,"Chakkai, Thiruvananthapuram"],
"695025":[96,189,0.0,"Muttada, Thiruvananthapuram"],
"695026":[150,284,0.0,"Ambalathara, Thiruvananthapuram"],
"695027":[123,218,0.0,"Pachallur, Thiruvananthapuram"],
"695028":[50,172,0.0,"Pandalacode, Thiruvananthapuram"],
"695029":[128,174,0.0,"Anayara, Thiruvananthapuram"],
"695030":[112,212,0.0,"Kanjirampara, Thiruvananthapuram"],
"695032":[65,213,0.0,"Aramada, Thiruvananthapuram"],
"695033":[112,205,0.0,"PMG Jn, Thiruvananthapuram"],
"695034":[128,205,0.0,"Thiruvananthapuram University, Thiruvananthapuram"],
"695035":[139,217,0.0,"Vanchiyoor Junction, Thiruvananthapuram"],
"695036":[139,225,0.0,"Thiruvananthapuram Chalai, Thiruvananthapuram"],
"695038":[50,182,0.0,"PTP Nagar, Thiruvananthapuram"],
"695040":[96,221,0.0,"Kaimanam, Thiruvananthapuram"],
"695042":[65,268,0.0,"Kalliyoor, Thiruvananthapuram"],
"695043":[86,186,0.0,"Kallayam, Thiruvananthapuram"],
"695051":[139,223,0.0,"NDC TRIVANDRUM FORT, Thiruvananthapuram"],
"695099":[112,202,0.0,"Kerala Governors Camp, Thiruvananthapuram"],
"695101":[55,183,0.0,"Attingal, Thiruvananthapuram"],
"695102":[45,181,0.0,"Perumkulam, Thiruvananthapuram"],
"695103":[66,200,0.0,"Mudakkal, Thiruvananthapuram"],
"695104":[66,202,0.0,"Kurakkada, Thiruvananthapuram"],
"695121":[62,386,0.01,"Neyyattinkara, Thiruvananthapuram"],
"695122":[70,315,0.01,"Plamootukada, Thiruvananthapuram"],
"695123":[58,251,0.0,"Kodungavila, Thiruvananthapuram"],
"695124":[54,246,0.0,"Anavoor, Thiruvananthapuram"],
"695125":[65,308,0.0,"Dalmughom, Thiruvananthapuram"],
"695126":[65,274,0.0,"Aruvipuram, Thiruvananthapuram"],
"695132":[80,301,0.01,"Vattavila, Thiruvananthapuram"],
"695133":[80,292,0.0,"Olathanni, Thiruvananthapuram"],
"695134":[80,303,0.01,"Vlathankara, Thiruvananthapuram"],
"695141":[55,146,0.0,"Sivagiri mutt, Thiruvananthapuram"],
"695142":[45,190,0.0,"Cherunniyur, Thiruvananthapuram"],
"695143":[58,160,0.0,"Thokkad, Thiruvananthapuram"],
"695144":[44,171,0.0,"Kulamuttam, Thiruvananthapuram"],
"695145":[58,149,0.0,"Muttappalam, Thiruvananthapuram"],
"695146":[58,142,0.0,"Muthana, Thiruvananthapuram"],
"695301":[86,228,0.0,"Channamkara, Thiruvananthapuram"],
"695302":[90,192,0.0,"Murukumpuzhaa, Thiruvananthapuram"],
"695303":[83,301,0.0,"Perumathura, Thiruvananthapuram"],
"695304":[67,202,0.0,"Katakam, Thiruvananthapuram"],
"695305":[76,232,0.0,"Sasthavattom, Thiruvananthapuram"],
"695306":[66,184,0.0,"Anathalavattom, Thiruvananthapuram"],
"695307":[45,171,0.0,"Kaikara, Thiruvananthapuram"],
"695308":[45,150,0.0,"Vakkom, Thiruvananthapuram"],
"695309":[55,188,0.0,"Poothura, Thiruvananthapuram"],
"695310":[68,146,0.0,"Elakamon, Thiruvananthapuram"],
"695311":[58,161,0.0,"Kappil, Thiruvananthapuram"],
"695312":[45,166,0.0,"Vettoor, Thiruvananthapuram"],
"695313":[72,219,0.0,"Manjamala, Thiruvananthapuram"],
"695316":[86,216,0.0,"Pallipuram SO Thiruvananthapuram, Thiruvananthapuram"],
"695317":[90,219,0.0,"Thonnakkal, Thiruvananthapuram"],
"695318":[44,169,0.0,"Vennicode, Thiruvananthapuram"],
"695501":[65,338,0.0,"Chowara, Thiruvananthapuram"],
"695502":[81,256,0.01,"Ayira, Thiruvananthapuram"],
"695503":[65,301,0.01,"Manchavilakom, Thiruvananthapuram"],
"695504":[81,311,0.01,"Cheriakolla, Thiruvananthapuram"],
"695505":[65,328,0.01,"KoothaliTVM, Thiruvananthapuram"],
"695506":[62,267,0.02,"Kakkavila, Thiruvananthapuram"],
"695507":[58,262,0.0,"Ooruttambalam, Thiruvananthapuram"],
"695508":[76,282,0.01,"Parasuvaickal, Thiruvananthapuram"],
"695512":[58,250,0.0,"Kandala, Thiruvananthapuram"],
"695513":[62,532,0.02,"Pozhiyoor, Thiruvananthapuram"],
"695521":[70,316,0.01,"Kottapuram, Thiruvananthapuram"],
"695522":[50,104,0.0,"Cgo Complex Poonkulam, Thiruvananthapuram"],
"695523":[68,311,0.0,"Nellivila, Thiruvananthapuram"],
"695524":[70,285,0.0,"Nellimoodu, Thiruvananthapuram"],
"695525":[70,345,0.01,"Kanjampazhanji, Thiruvananthapuram"],
"695526":[62,345,0.01,"Kazhavur, Thiruvananthapuram"],
"695527":[83,212,0.0,"Kovalam Beach, Thiruvananthapuram"],
"695528":[70,323,0.01,"Naruvamoodu, Thiruvananthapuram"],
"695541":[50,186,0.0,"Anad, Thiruvananthapuram"],
"695542":[33,141,0.0,"Kottakkakom, Thiruvananthapuram"],
"695543":[28,155,0.0,"Kuthirakalamvellanad, Thiruvananthapuram"],
"695547":[50,186,0.0,"Valiamala, Thiruvananthapuram"],
"695551":[52,192,0.0,"Anappara, Thiruvananthapuram"],
"695561":[43,151,0.0,"Irinchayam, Thiruvananthapuram"],
"695562":[50,221,0.0,"Exservicemens Colony, Thiruvananthapuram"],
"695563":[45,276,0.0,"Idinjar, Thiruvananthapuram"],
"695564":[58,184,0.0,"Chekkakonam, Thiruvananthapuram"],
"695568":[45,223,0.0,"Koonanvenga, Thiruvananthapuram"],
"695570":[37,219,0.0,"Machel, Thiruvananthapuram"],
"695571":[50,210,0.0,"Kollode, Thiruvananthapuram"],
"695572":[65,206,0.0,"Kuruthamcode, Thiruvananthapuram"],
"695573":[65,210,0.0,"Perukavu, Thiruvananthapuram"],
"695574":[24,142,0.0,"Paruthipally, Thiruvananthapuram"],
"695575":[29,200,0.0,"Panniyode, Thiruvananthapuram"],
"695581":[86,245,0.0,"Thundathil, Thiruvananthapuram"],
"695582":[86,250,0.0,"Kazhakuttam, Thiruvananthapuram"],
"695583":[115,321,0.0,"Karimanal, Thiruvananthapuram"],
"695584":[76,224,0.0,"Keezhavur, Thiruvananthapuram"],
"695585":[72,232,0.0,"Sainik School SO Thiruvananthapuram, Thiruvananthapuram"],
"695586":[86,256,0.0,"Puthenthope, Thiruvananthapuram"],
"695587":[96,239,0.0,"Chempazhanthy, Thiruvananthapuram"],
"695588":[96,226,0.0,"Powdikonam, Thiruvananthapuram"],
"695589":[76,208,0.0,"Nethajipuram, Thiruvananthapuram"],
"695601":[44,145,0.0,"Kilimanur Palace, Thiruvananthapuram"],
"695602":[45,133,0.0,"Njarayilkonam, Thiruvananthapuram"],
"695603":[58,136,0.0,"Maruthikunnu, Thiruvananthapuram"],
"695604":[46,114,0.0,"Puliyurkonam, Thiruvananthapuram"],
"695605":[58,176,0.0,"Thottakkad, Thiruvananthapuram"],
"695606":[48,194,0.0,"Karimkuttikara, Thiruvananthapuram"],
"695607":[53,201,0.0,"Aliyadu, Thiruvananthapuram"],
"695608":[53,214,0.0,"Kattumpuram, Thiruvananthapuram"],
"695609":[45,229,0.0,"Mylamoodu, Thiruvananthapuram"],
"695610":[52,218,0.0,"Muthuvila, Thiruvananthapuram"],
"695611":[44,168,0.0,"Manambur, Thiruvananthapuram"],
"695612":[44,156,0.0,"Thalikuzhi, Thiruvananthapuram"],
"695614":[39,125,0.0,"Adayamon, Thiruvananthapuram"],
"695615":[76,213,0.0,"Kuthirakulam, Thiruvananthapuram"],
"700001":[258,897,0.45,"KOLKATA GPO, Kolkata"],
"700002":[344,836,1.72,"Cossipore, Kolkata"],
"700003":[344,827,1.49,"Amrita Bazar Patrika, Kolkata"],
"700004":[340,870,1.39,"Shyambazar Mail, Kolkata"],
"700005":[318,845,1.37,"Hatkhola, Kolkata"],
"700006":[340,892,1.34,"Beadon Street, Kolkata"],
"700007":[280,852,1.24,"Barabazar H O, Kolkata"],
"700008":[270,698,0.52,"Barisha, Kolkata"],
"700009":[240,704,0.41,"Parsibagan, Kolkata"],
"700010":[254,795,0.44,"Beleghata, Kolkata"],
"700011":[318,883,1.18,"Narkeldanga, Kolkata"],
"700012":[275,832,1.07,"Bowbazar SO Kolkata, Kolkata"],
"700013":[275,833,1.03,"Dharmatala, Kolkata"],
"700014":[258,825,0.41,"Bamboovila, Kolkata"],
"700015":[245,791,0.46,"Sales Tax Building, Kolkata"],
"700016":[270,805,0.81,"Park Street, Kolkata"],
"700017":[225,686,0.42,"Shakespeare Sarani, Kolkata"],
"700018":[340,741,0.42,"Rabindra Nagar SO Kolkata, Kolkata"],
"700019":[288,795,0.8,"Ballygunge, Kolkata"],
"700020":[275,792,0.76,"Gokhel Road, Kolkata"],
"700021":[210,627,0.57,"Fort William, Kolkata"],
"700022":[280,780,0.84,"Bakery Road, Kolkata"],
"700023":[295,782,0.82,"Khiddirpore, Murshidabad"],
"700024":[344,784,0.71,"Garden Reach, Kolkata"],
"700025":[280,782,0.71,"Lansdowne Market, Kolkata"],
"700026":[280,773,0.6,"Kalimandir, Kolkata"],
"700027":[275,763,0.71,"Alipore, Kolkata"],
"700028":[372,782,1.64,"Kumarpara, 24 Paraganas North"],
"700029":[280,776,0.67,"Rash Behari Avenue, Kolkata"],
"700030":[354,871,2.04,"Ghugudanga, Kolkata"],
"700031":[255,773,0.81,"KPRoy Lane, Kolkata"],
"700032":[264,768,0.77,"Bijoygarh, Kolkata"],
"700033":[255,758,0.66,"Tollygunge, Kolkata"],
"700034":[275,694,0.55,"Jayshree Park, Kolkata"],
"700035":[314,746,1.5,"Alambazar, 24 Paraganas North"],
"700036":[344,792,1.66,"Baranagar, 24 Paraganas North"],
"700037":[340,851,1.56,"Belgachia Road, Kolkata"],
"700038":[288,733,0.62,"Sahapur, Kolkata"],
"700039":[295,799,0.88,"Tiljala Bazar, Kolkata"],
"700040":[267,764,0.55,"Russa, Kolkata"],
"700041":[280,707,0.54,"Paschim Putiari, Kolkata"],
"700042":[270,805,0.77,"Kasba SO Kolkata, Kolkata"],
"700043":[275,737,0.7,"South Eastern Railway, Kolkata"],
"700044":[355,823,0.67,"Badartala, Kolkata"],
"700045":[270,772,0.73,"Lake Gardens, Kolkata"],
"700046":[217,687,0.44,"Abinash Chaowdhury Lane, Kolkata"],
"700047":[245,725,0.55,"Ganguly Bagan, Kolkata"],
"700048":[235,764,0.42,"Patipukur, 24 Paraganas North"],
"700049":[348,745,1.54,"Udaipur, 24 Paraganas North"],
"700050":[344,862,2.17,"South Sinhee, Kolkata"],
"700051":[342,707,1.46,"Sultanpur, 24 Paraganas North"],
"700052":[348,731,1.5,"Kendriya Vihar, 24 Paraganas North"],
"700053":[275,748,0.68,"New Alipore, Kolkata"],
"700054":[254,792,0.44,"Phulbagan, Kolkata"],
"700055":[348,818,1.55,"Dum Dum Park, 24 Paraganas North"],
"700056":[340,719,1.43,"Belgharia, 24 Paraganas North"],
"700057":[270,685,1.34,"Ariadaha, 24 Paraganas North"],
"700058":[248,658,1.38,"Elias Road, 24 Paraganas North"],
"700059":[245,758,0.47,"Raghunathpur, 24 Paraganas North"],
"700060":[280,719,0.44,"Parnasree Pally, Kolkata"],
"700061":[270,697,0.43,"Jairampur SO Kolkata, Kolkata"],
"700062":[254,881,0.36,"West Bengal Governors Camp, Kolkata"],
"700063":[235,619,0.41,"Paschim Barisha, Kolkata"],
"700064":[250,775,0.43,"Labony Estate, 24 Paraganas North"],
"700065":[354,768,1.64,"Health Institute, 24 Paraganas North"],
"700066":[275,811,1.07,"Bidhangarh, Kolkata"],
"700067":[340,950,1.05,"Ultadanga Main Road, Kolkata"],
"700068":[255,772,0.78,"Jodhpur Park, Kolkata"],
"700069":[275,815,1.02,"Esplanade, Kolkata"],
"700070":[220,643,0.41,"Kalibari Temple, 24 Paraganas South"],
"700071":[270,803,0.81,"Middleton Row, Kolkata"],
"700072":[275,823,1.03,"Hindustan Building, Kolkata"],
"700073":[258,891,0.45,"Kolkata University, Kolkata"],
"700074":[372,808,1.68,"Dumdum Road, 24 Paraganas North"],
"700075":[264,768,0.83,"Santoshpur Avenue, Kolkata"],
"700076":[280,710,1.34,"Dakshineswar, 24 Paraganas North"],
"700077":[354,827,1.88,"Bediapara, 24 Paraganas North"],
"700078":[255,775,0.85,"Haltu, Kolkata"],
"700079":[348,730,1.49,"Italghacha, 24 Paraganas North"],
"700080":[318,878,1.37,"Jessore Road, 24 Paraganas North"],
"700081":[346,710,1.4,"Rajbari Colony, 24 Paraganas North"],
"700082":[280,774,0.65,"Haridevpur, Kolkata"],
"700083":[340,719,1.43,"Basudebpur, 24 Paraganas North"],
"700084":[254,799,0.44,"Garia Garden, 24 Paraganas South"],
"700085":[318,869,1.11,"KG Bose Sarani, Kolkata"],
"700086":[252,727,0.66,"Baghajatin, Kolkata"],
"700087":[275,818,0.93,"New Market, Kolkata"],
"700088":[340,719,0.56,"Brace Bridge, Kolkata"],
"700089":[267,709,0.6,"Kalindi Housing Estate, 24 Paraganas North"],
"700090":[275,849,1.04,"Netaji Colony, 24 Paraganas North"],
"700091":[245,757,0.51,"Nabadiganta IT, 24 Paraganas North"],
"700092":[264,753,0.63,"Regent Estate, Kolkata"],
"700093":[268,1245,0.56,"Purba Putiary, 24 Paraganas South"],
"700094":[240,729,0.68,"Baishnab Ghata Patuli Township, Kolkata"],
"700095":[264,766,0.76,"Golf Green, Kolkata"],
"700096":[268,1399,0.59,"Brahmapur, 24 Paraganas South"],
"700097":[344,803,1.19,"Purbachal, 24 Paraganas North"],
"700099":[252,749,0.88,"Kalikapur, Kolkata"],
"700100":[288,789,0.93,"Vip Nagar, Kolkata"],
"700101":[354,763,1.56,"Prafulla Kanan, 24 Paraganas North"],
"700102":[348,729,1.54,"Krishnapur SO North 24 Parganas, 24 Paraganas North"],
"700103":[235,657,0.56,"Bonhooghly, 24 Paraganas South"],
"700104":[217,692,0.44,"Amgachia, 24 Paraganas South"],
"700105":[250,784,0.5,"Chowbaga, Kolkata"],
"700106":[344,798,1.18,"Bidhan Nagar IB Market, 24 Paraganas North"],
"700107":[280,794,0.97,"Madurdaha, Kolkata"],
"700108":[314,745,1.52,"Ashokegarh, 24 Paraganas North"],
"700109":[305,681,1.51,"Agarpara, 24 Paraganas North"],
"700110":[270,653,1.47,"Jugberia, 24 Paraganas North"],
"700111":[250,501,0.0,"Ghola, 24 Paraganas North"],
"700112":[225,599,1.5,"Kalyannagar Cooperative Colony, 24 Paraganas North"],
"700113":[248,622,1.46,"Karnamadhabpur, 24 Paraganas North"],
"700114":[259,644,1.43,"Bangodaya, 24 Paraganas North"],
"700115":[225,600,1.43,"Sukchar SO North 24 Parganas, 24 Paraganas North"],
"700116":[259,644,1.43,"BDSopan, 24 Paraganas North"],
"700117":[215,519,1.44,"Khardah, 24 Paraganas North"],
"700118":[215,530,1.47,"Rahara, 24 Paraganas North"],
"700119":[205,511,1.4,"Bandipur, 24 Paraganas North"],
"700120":[172,443,1.14,"Barrackpore, 24 Paraganas North"],
"700121":[244,483,1.11,"Beraberia, 24 Paraganas North"],
"700122":[225,468,1.15,"Anandapuri, 24 Paraganas North"],
"700123":[198,542,1.38,"Talpukur, 24 Paraganas North"],
"700124":[315,547,1.44,"Barasat, 24 Paraganas North"],
"700125":[315,480,1.21,"Mirhati, 24 Paraganas North"],
"700126":[256,531,1.23,"Malikapur, 24 Paraganas North"],
"700127":[285,554,1.42,"Hridaypur, 24 Paraganas North"],
"700128":[305,562,0.92,"Madanpur Krishnapur, 24 Paraganas North"],
"700129":[285,585,1.38,"East Udayrajpur, 24 Paraganas North"],
"700130":[256,570,1.39,"Taldharia Kapasia, 24 Paraganas North"],
"700131":[256,609,1.45,"Aharampur, 24 Paraganas North"],
"700132":[230,533,2.04,"Ganti, 24 Paraganas North"],
"700133":[205,521,0.77,"Michealnagar, 24 Paraganas North"],
"700134":[188,489,1.38,"Nilachal, 24 Paraganas North"],
"700135":[294,682,0.7,"Akandakeshari, 24 Paraganas North"],
"700136":[345,653,1.26,"Narayanpur, 24 Paraganas North"],
"700137":[230,873,0.51,"Bawali Chandipur, 24 Paraganas South"],
"700138":[385,1009,0.56,"Purba Nischintapur, 24 Paraganas South"],
"700139":[230,764,0.41,"Daulatpur, 24 Paraganas South"],
"700140":[305,729,0.31,"Nungi, 24 Paraganas South"],
"700141":[340,754,0.32,"Boga Noapara, 24 Paraganas South"],
"700142":[284,871,0.46,"Santosh Pur Maheshtalaso, 24 Paraganas South"],
"700143":[254,991,0.51,"Sarkarpool, 24 Paraganas South"],
"700144":[204,576,0.85,"Baruipur, 24 Paraganas South"],
"700145":[220,624,0.64,"Bamangachi, 24 Paraganas South"],
"700146":[278,1234,0.6,"Kodalia, 24 Paraganas South"],
"700147":[278,1260,0.6,"Subhas Gram, 24 Paraganas South"],
"700148":[220,613,0.76,"Harinavi, 24 Paraganas South"],
"700149":[220,633,0.76,"Chowhati, 24 Paraganas South"],
"700150":[237,696,0.65,"RAMKRISHNA PALLY, 24 Paraganas South"],
"700151":[217,695,0.53,"Dingelpota, 24 Paraganas South"],
"700152":[140,706,0.12,"Dhalua, 24 Paraganas South"],
"700153":[235,674,0.62,"Laskar Pur, 24 Paraganas South"],
"700154":[227,733,0.55,"Rania, 24 Paraganas South"],
"700155":[315,586,1.31,"Abdalpur, 24 Paraganas North"],
"700156":[345,778,1.12,"Hatgacha, 24 Paraganas North"],
"700157":[264,757,0.62,"Ghuni, 24 Paraganas North"],
"700158":[332,665,1.45,"Bisharpara, 24 Paraganas North"],
"700159":[267,759,0.54,"Jyangra, 24 Paraganas North"],
"700160":[346,785,1.09,"New Town Action Area III, 24 Paraganas North"],
"700161":[340,709,1.19,"New Town Action Area II, 24 Paraganas North"],
"700162":[342,754,1.25,"Gouranganagar, 24 Paraganas North"],
"700163":[348,780,1.27,"New Town Action Area I, 24 Paraganas North"],
"711101":[275,767,1.04,"Howrah, Howrah"],
"711102":[280,786,0.97,"Sibpur Bazar, Howrah"],
"711103":[280,774,0.9,"BGarden, Howrah"],
"711104":[270,769,0.99,"Dharsa, Howrah"],
"711105":[280,771,1.08,"Belgachia Mansatala, Howrah"],
"711106":[310,789,1.26,"Salkia, Howrah"],
"711107":[275,789,1.44,"Ghusuri, Howrah"],
"711108":[218,461,0.71,"Netajigarh, Howrah"],
"711109":[310,807,0.76,"Podra, Howrah"],
"711110":[340,514,-1,"Baksara, Howrah"],
"711111":[280,808,0.79,"Jagacha, Howrah"],
"711112":[259,825,0.92,"Gip Colony, Howrah"],
"711113":[270,755,1.0,"Balitikuri, Howrah"],
"711114":[248,706,1.14,"Chamrail, Howrah"],
"711115":[225,666,1.06,"Jagadishpurhat, Howrah"],
"711201":[270,738,1.34,"Bally Goswami Rd, Howrah"],
"711202":[280,776,1.49,"Belur Bazar, Howrah"],
"711203":[275,763,1.36,"Bhattanagar, Howrah"],
"711204":[225,480,0.76,"Chakpara, Howrah"],
"711205":[236,663,1.22,"Abhoynagar, Howrah"],
"711206":[225,666,1.06,"Sapuipara, Howrah"],
"711225":[280,780,1.07,"Pancharul, Howrah"],
"711226":[150,567,0.63,"Bairakurchi, Howrah"],
"711227":[250,903,0.6,"Anandanagar, Howrah"],
"711301":[255,740,0.66,"Deoly, Howrah"],
"711302":[160,397,0.57,"Kendua, Howrah"],
"711303":[210,736,0.43,"Bakshi, Howrah"],
"711304":[280,780,1.07,"Banipur SO Howrah, Howrah"],
"711305":[225,1104,0.52,"Bauria, Howrah"],
"711306":[280,780,1.07,"Kulgachia, Howrah"],
"711307":[282,1108,0.49,"Khalisani, Howrah"],
"711308":[280,780,1.07,"Chengail, Howrah"],
"711309":[305,806,0.36,"Sarenga, Howrah"],
"711310":[225,1135,0.56,"Ula, Howrah"],
"711312":[229,1213,0.69,"Bachhri, Howrah"],
"711313":[335,823,0.34,"Chaturbhujkati, Howrah"],
"711314":[252,1320,0.83,"Kharuberia, Howrah"],
"711315":[230,1258,0.67,"Baganda, Howrah"],
"711316":[240,851,0.45,"Fuleswar, Howrah"],
"711317":[280,780,1.07,"Radhadasi, Howrah"],
"711322":[224,1091,0.39,"Banharishpur, Howrah"],
"711331":[258,1207,0.66,"Paniara, Howrah"],
"711401":[282,1132,0.5,"Bagua, Howrah"],
"711403":[275,766,1.0,"Munshidanga, Howrah"],
"711404":[125,602,0.59,"Dakshin Santoshpur, Howrah"],
"711405":[199,601,0.54,"Nonakundu, Howrah"],
"711408":[225,651,0.55,"Mato, Howrah"],
"711409":[259,689,0.79,"Tentulkuli, Howrah"],
"711410":[225,707,0.57,"Debandi, Howrah"],
"711411":[228,753,0.51,"Bhandardaha, Howrah"],
"711412":[218,752,0.54,"Raichak, Howrah"],
"711413":[224,842,0.51,"Khalna, Howrah"],
"711414":[286,894,0.55,"Polgustia, Howrah"],
"712101":[252,536,0.69,"Chinsurah, Hooghly"],
"712102":[252,504,0.8,"Sogandha, Hooghly"],
"712103":[188,462,0.99,"BIKRAMNAGORE BALI, Hooghly"],
"712104":[150,408,1.1,"Keotalatbagan, Hooghly"],
"712105":[225,940,0.91,"KAMARPARABAZAR, Hooghly"],
"712121":[340,769,0.73,"Addconagar, Hooghly"],
"712122":[230,546,0.31,"Tilari, Hooghly"],
"712123":[208,704,0.43,"Debanandapur, Hooghly"],
"712124":[189,484,1.34,"Saradapally, Hooghly"],
"712125":[125,287,0.6,"Telinipara, Hooghly"],
"712134":[220,628,0.69,"Bhonpur, Hooghly"],
"712135":[235,711,0.64,"SIMLAGARH, Hooghly"],
"712136":[252,536,0.69,"Chandannagar RS, Hooghly"],
"712137":[252,536,0.69,"Gondalpara, Hooghly"],
"712138":[252,536,0.69,"Jarura, Hooghly"],
"712139":[188,481,0.67,"Mankundu GovtColony, Hooghly"],
"712146":[230,546,0.31,"Baharkuli, Purba Bardhaman"],
"712147":[230,546,0.31,"Radhanagar, Hooghly"],
"712148":[207,553,0.39,"Akna, Hooghly"],
"712149":[230,546,0.31,"Panchgora, Hooghly"],
"712152":[209,491,0.55,"Dabra, Hooghly"],
"712201":[172,440,1.26,"Serampore, Hooghly"],
"712202":[172,461,1.27,"Masjid Lane, Hooghly"],
"712203":[252,536,0.69,"Bahirserampore, Hooghly"],
"712204":[252,536,0.69,"Chatra SO Hooghly, Hooghly"],
"712221":[188,466,0.93,"Angus, Hooghly"],
"712222":[125,253,0.68,"Baidyabati, Hooghly"],
"712223":[142,400,1.04,"Chandanpur, Hooghly"],
"712232":[252,536,0.69,"Bhadrakali, Hooghly"],
"712233":[236,626,1.23,"Hindmotor, Hooghly"],
"712234":[225,571,1.15,"Kanaipur, Hooghly"],
"712235":[225,592,1.25,"Konnagar, Hooghly"],
"712245":[189,466,1.3,"Mrigala Daspara, Hooghly"],
"712246":[130,932,0.61,"Barabahera, Hooghly"],
"712248":[190,483,1.32,"Bangurpark, Hooghly"],
"712249":[189,437,1.28,"Nutangram, Hooghly"],
"712250":[189,473,1.27,"Mollerberh, Hooghly"],
"712258":[259,696,1.33,"Uttarpara Bazar, Hooghly"],
"712291":[205,519,1.24,"Bangurpark, Hooghly"],
"712301":[120,393,0.75,"Bagnan Chaitanyabati, Hooghly"],
"712302":[120,417,0.9,"Hazipur, Hooghly"],
"712303":[135,434,0.98,"Ghosla, Hooghly"],
"712304":[252,536,0.69,"Baksha, Hooghly"],
"712305":[230,546,0.31,"Ati, Hooghly"],
"712306":[252,536,0.69,"Borai, Hooghly"],
"712308":[252,536,0.69,"Siptai, Purba Bardhaman"],
"712310":[225,592,1.17,"Chakundi, Hooghly"],
"712311":[225,588,1.16,"Mrigala, Hooghly"],
"712401":[125,248,0.73,"Aimapaharpur, Hooghly"],
"712402":[140,341,0.78,"Chenchua, Hooghly"],
"712403":[344,774,0.66,"Dalapatipur, Hooghly"],
"712404":[132,337,0.78,"Krishnanagar, Hooghly"],
"712405":[252,536,0.69,"Brahmanpara, Hooghly"],
"712406":[130,322,0.64,"Nangulpara, Hooghly"],
"712407":[120,268,0.79,"Bandipur, Hooghly"],
"712408":[128,318,0.73,"Rashidpur, Hooghly"],
"712409":[125,326,0.85,"Harishnagar, Hooghly"],
"712410":[125,341,0.72,"Baligori, Hooghly"],
"712412":[150,283,0.8,"Baradigrui, Hooghly"],
"712413":[130,325,0.61,"Bachhanari, Hooghly"],
"712414":[230,546,0.31,"Alati, Hooghly"],
"712415":[130,301,0.74,"Purba Krishnapur, Hooghly"],
"712416":[210,723,0.45,"Harishchak, Hooghly"],
"712417":[224,550,0.46,"Bonhijli, Hooghly"],
"712501":[130,314,0.72,"Jirat, Hooghly"],
"712502":[348,818,1.87,"Chawk Bansberia, Hooghly"],
"712503":[310,767,1.51,"Tribeni, Hooghly"],
"712504":[252,536,0.69,"Chandrahati, Hooghly"],
"712512":[220,628,0.69,"Dhobapara, Hooghly"],
"712513":[265,544,0.45,"Gopalpur, Hooghly"],
"712514":[252,536,0.69,"Sripur Bazar SO Hooghly, Hooghly"],
"712515":[230,546,0.31,"Baneswarpur, Hooghly"],
"712601":[140,322,0.42,"Arambagh, Hooghly"],
"712602":[230,546,0.31,"Bhadur, Hooghly"],
"712611":[230,546,0.31,"Asudkhola, Hooghly"],
"712612":[132,304,0.71,"Mandaran, Hooghly"],
"712613":[125,340,0.57,"Thakuranichak, Hooghly"],
"712614":[230,523,0.6,"Kantali, Hooghly"],
"712615":[230,546,0.31,"Moloypur, Hooghly"],
"712616":[230,546,0.31,"Damodarpur, Hooghly"],
"712617":[230,546,0.31,"Chuadanga, Hooghly"],
"712701":[125,294,0.6,"Bandhpur, Hooghly"],
"712702":[252,536,0.69,"Kumirmorah, Hooghly"],
"712706":[125,326,0.7,"Furfura, Hooghly"],
"713101":[180,522,0.51,"Burdwan, Purba Bardhaman"],
"713102":[212,490,0.45,"Bhita, Purba Bardhaman"],
"713103":[175,461,0.5,"Bontir, Purba Bardhaman"],
"713104":[180,539,0.48,"Rayan, Purba Bardhaman"],
"713121":[225,447,0.39,"Debpur, Purba Bardhaman"],
"713122":[257,617,0.78,"Badla, Purba Bardhaman"],
"713123":[220,366,0.38,"Baharan, Purba Bardhaman"],
"713124":[210,414,0.49,"Deriapur, Purba Bardhaman"],
"713125":[211,462,0.6,"Sunur, Purba Bardhaman"],
"713126":[215,455,1.88,"Berenda, Purba Bardhaman"],
"713127":[150,335,0.38,"Khurul, Purba Bardhaman"],
"713128":[152,461,0.44,"Deasa Aligram, Purba Bardhaman"],
"713129":[220,351,0.52,"Rajoor, Purba Bardhaman"],
"713130":[214,426,0.67,"Katwa, Purba Bardhaman"],
"713131":[160,368,11.16,"Kalanpur, Purba Bardhaman"],
"713132":[224,404,9.48,"Barashyambazar, Purba Bardhaman"],
"713140":[165,424,0.74,"Nabagram, Purba Bardhaman"],
"713141":[170,323,0.31,"Barakashiara, Purba Bardhaman"],
"713142":[155,240,0.79,"Bijpur, Bankura"],
"713143":[198,398,0.59,"Karui, Purba Bardhaman"],
"713144":[152,321,0.29,"Eral, Purba Bardhaman"],
"713145":[182,356,0.81,"Galatun, Purba Bardhaman"],
"713146":[240,580,0.25,"Barwamahesh, Purba Bardhaman"],
"713147":[210,445,18.51,"Mongalkote, Purba Bardhaman"],
"713148":[174,398,0.34,"Bankati, Paschim Bardhaman"],
"713149":[220,533,0.42,"Kharga Karanda, Purba Bardhaman"],
"713150":[180,473,0.55,"Churpuni, Purba Bardhaman"],
"713151":[200,493,0.37,"Maheshdanga, Purba Bardhaman"],
"713152":[215,452,0.78,"Genrai, Purba Bardhaman"],
"713153":[130,363,0.23,"Parisha, Purba Bardhaman"],
"713154":[230,532,0.25,"Amadpur, Purba Bardhaman"],
"713166":[210,492,0.59,"Dhuluk, Purba Bardhaman"],
"713201":[175,443,1.16,"Durgapur, Paschim Bardhaman"],
"713202":[175,438,1.14,"Durgapur Coke Oven Colony, Paschim Bardhaman"],
"713203":[192,477,0.62,"Amrai, Paschim Bardhaman"],
"713204":[206,435,0.55,"Kamalpur, Paschim Bardhaman"],
"713205":[210,390,0.37,"Dhabani, Paschim Bardhaman"],
"713206":[192,423,0.76,"Fuljhore, Paschim Bardhaman"],
"713207":[192,474,1.08,"Durgapur Thermal Power Station, Paschim Bardhaman"],
"713208":[200,457,0.89,"Durgapur ASP SB, Paschim Bardhaman"],
"713209":[200,439,0.59,"Durgapur Mg Avenue, Paschim Bardhaman"],
"713210":[206,462,1.01,"Durgapur Heavy Engg Plant, Paschim Bardhaman"],
"713211":[175,452,1.2,"Nadiha, Paschim Bardhaman"],
"713212":[200,397,0.44,"Burdwan Arrah, Paschim Bardhaman"],
"713213":[206,459,0.49,"Benachity, Paschim Bardhaman"],
"713214":[200,418,0.65,"Durgapur CRPF Camp, Paschim Bardhaman"],
"713215":[192,462,1.22,"Angadpur, Paschim Bardhaman"],
"713216":[212,401,0.54,"City Centre, Paschim Bardhaman"],
"713217":[200,518,0.57,"Oyaria, Paschim Bardhaman"],
"713301":[258,502,0.15,"Asansol, Paschim Bardhaman"],
"713302":[250,540,0.64,"Dakhin Dhadka, Paschim Bardhaman"],
"713303":[258,554,0.36,"SDHospital, Paschim Bardhaman"],
"713304":[155,381,1.11,"Hill View, Paschim Bardhaman"],
"713305":[198,413,0.69,"Ramkrishna Mission, Paschim Bardhaman"],
"713315":[195,428,0.05,"Jamgram, Paschim Bardhaman"],
"713321":[187,541,0.53,"Dakhin Khanda, Paschim Bardhaman"],
"713322":[215,588,1.39,"Siduli, Paschim Bardhaman"],
"713323":[250,705,1.26,"Egara, Paschim Bardhaman"],
"713324":[232,500,0.54,"Ramnagar, Paschim Bardhaman"],
"713325":[245,567,0.2,"Radhanagar, Paschim Bardhaman"],
"713326":[185,483,0.14,"Chotodighari, Paschim Bardhaman"],
"713330":[255,528,0.37,"Majhiara, Paschim Bardhaman"],
"713331":[177,369,0.9,"Chittaranjan, Paschim Bardhaman"],
"713332":[235,579,0.0,"Bogra, Paschim Bardhaman"],
"713333":[240,490,0.54,"Gangutia, Paschim Bardhaman"],
"713334":[245,500,0.37,"Baraboni, Paschim Bardhaman"],
"713335":[198,420,0.72,"Basudevpur Jemari, Paschim Bardhaman"],
"713336":[245,526,0.58,"Taltore, Paschim Bardhaman"],
"713337":[250,583,0.63,"Satgram, Paschim Bardhaman"],
"713338":[215,590,1.27,"Parascole, Paschim Bardhaman"],
"713339":[255,528,0.37,"Chelod, Paschim Bardhaman"],
"713340":[198,413,0.69,"Kalla Central Hospital, Paschim Bardhaman"],
"713341":[210,494,0.38,"Nuni, Paschim Bardhaman"],
"713342":[225,592,1.49,"Kenda, Paschim Bardhaman"],
"713343":[225,451,0.79,"Lalbazar, Paschim Bardhaman"],
"713344":[198,413,0.69,"Nandi SO Bardhaman, Paschim Bardhaman"],
"713346":[185,522,1.83,"Ramnagar Gram, Paschim Bardhaman"],
"713347":[250,911,0.87,"Raniganj, Paschim Bardhaman"],
"713357":[198,413,0.69,"Salanpur, Paschim Bardhaman"],
"713358":[250,695,1.05,"Bansra, Paschim Bardhaman"],
"713359":[232,482,0.37,"Aldihi, Paschim Bardhaman"],
"713360":[199,293,0.39,"Asanboni, Paschim Bardhaman"],
"713361":[198,413,0.69,"Suryanagar SO Bardhaman, Paschim Bardhaman"],
"713362":[245,583,1.74,"Jote Janki, Paschim Bardhaman"],
"713363":[175,585,1.73,"Kumardihi, Paschim Bardhaman"],
"713365":[235,707,1.11,"Chittaranjan TS, Paschim Bardhaman"],
"713369":[247,418,0.35,"Kalyaneshwari, Paschim Bardhaman"],
"713370":[165,319,7.77,"Ningha, Paschim Bardhaman"],
"713371":[260,504,0.36,"Bidyanandapur, Paschim Bardhaman"],
"713372":[198,413,0.69,"Radhanagar Rly Colony, Paschim Bardhaman"],
"713373":[255,528,0.37,"Nischinta, Paschim Bardhaman"],
"713376":[282,705,0.43,"Dhandadihi, Paschim Bardhaman"],
"713378":[225,570,1.57,"Chinchuria, Paschim Bardhaman"],
"713381":[180,453,0.87,"Gogla, Paschim Bardhaman"],
"713384":[225,605,1.38,"Parasea, Paschim Bardhaman"],
"713385":[192,507,0.88,"Jhanjra, Paschim Bardhaman"],
"713386":[198,413,0.69,"Rupnarayanpur Bazar, Paschim Bardhaman"],
"713401":[210,472,0.47,"Sanchra, Purba Bardhaman"],
"713403":[160,295,0.17,"Kasba, Purba Bardhaman"],
"713404":[122,364,0.87,"Runkini Mahalla, Purba Bardhaman"],
"713405":[320,576,0.82,"Astogharia, Purba Bardhaman"],
"713406":[140,302,0.21,"Chakmuria, Purba Bardhaman"],
"713407":[205,493,0.45,"Sonapalashi, Purba Bardhaman"],
"713408":[150,377,0.66,"Paratal, Purba Bardhaman"],
"713409":[257,544,0.68,"Hatbele, Purba Bardhaman"],
"713420":[200,577,1.15,"Rondia, Purba Bardhaman"],
"713421":[125,278,0.57,"Barabainan, Purba Bardhaman"],
"713422":[152,284,0.99,"Ibrahambad Sonadanga, Purba Bardhaman"],
"713423":[160,280,0.91,"Amila, Purba Bardhaman"],
"713424":[152,370,0.62,"Madanagar, Purba Bardhaman"],
"713426":[170,346,0.77,"Bhandardihi, Purba Bardhaman"],
"713427":[120,274,0.68,"Aklokhi, Purba Bardhaman"],
"713428":[158,314,0.33,"Belan, Purba Bardhaman"],
"713502":[210,455,0.77,"Agradwip RS, Purba Bardhaman"],
"713512":[195,389,0.73,"Agradwip, Purba Bardhaman"],
"713513":[235,441,0.76,"Chupi, Purba Bardhaman"],
"713514":[182,469,0.87,"Gourdanga, Purba Bardhaman"],
"713515":[290,565,0.35,"Nowpara, Purba Bardhaman"],
"713519":[230,541,1.15,"Dupsa, Purba Bardhaman"],
"713520":[189,417,0.64,"Balgona Tulshidanga, Purba Bardhaman"],
"721101":[165,295,0.04,"Midnapore, Medinipur West"],
"721102":[165,304,0.05,"Monidaha, Medinipur West"],
"721121":[165,295,0.04,"Agra, Medinipur West"],
"721122":[140,496,0.42,"Kotai, Medinipur West"],
"721124":[165,299,0.03,"Guruganj, Medinipur West"],
"721125":[90,199,0.31,"Dolgram, Jhargram"],
"721126":[146,479,0.28,"Chhota Bhagabanpur, Medinipur West"],
"721127":[105,186,0.32,"Krishnapur, Medinipur West"],
"721128":[197,450,0.86,"Andharia Bandri Sole, Medinipur West"],
"721129":[165,295,0.04,"Gohaldihi, Medinipur West"],
"721131":[130,470,0.06,"Amdan, Medinipur East"],
"721132":[175,308,0.4,"Reserve Bank Nm Ltd, Medinipur West"],
"721133":[105,215,0.32,"Benadiha, Medinipur West"],
"721134":[162,568,0.3,"Kharui, Medinipur East"],
"721135":[90,205,0.36,"Laudaha, Jhargram"],
"721136":[130,382,0.15,"Barati, Medinipur West"],
"721137":[152,310,0.64,"Alinan, Medinipur East"],
"721139":[125,397,0.06,"Goleghat, Medinipur East"],
"721140":[192,439,0.34,"Barageria, Medinipur West"],
"721143":[165,299,0.1,"Baharadari, Jhargram"],
"721144":[128,394,0.06,"Andulia, Medinipur West"],
"721145":[105,234,0.07,"Rangametia, Medinipur West"],
"721146":[125,371,3.86,"Kalara, Medinipur West"],
"721147":[45,195,0.0,"Jatrabishnupur, Medinipur West"],
"721148":[190,404,0.79,"Gochhati, Medinipur West"],
"721149":[177,375,0.19,"Krishnanagar, Medinipur West"],
"721150":[140,496,0.42,"Mugbasan, Medinipur West"],
"721151":[130,476,0.13,"Deriachak, Medinipur East"],
"721152":[155,458,2.09,"Kalukhanra, Medinipur West"],
"721153":[155,458,2.09,"Maguria, Medinipur West"],
"721154":[155,458,2.09,"Chapda, Medinipur East"],
"721155":[190,402,0.14,"Balpai, Medinipur West"],
"721156":[165,295,0.04,"Akalpoush, Medinipur West"],
"721157":[105,531,2.8,"Amjore, Medinipur West"],
"721158":[228,697,0.46,"Sulani, Medinipur East"],
"721159":[91,224,0.13,"Nayagram, Jhargram"],
"721160":[162,384,0.2,"Bansda Palashi, Medinipur West"],
"721161":[205,564,0.39,"Mohar, Medinipur West"],
"721166":[200,474,0.55,"Badalpur, Medinipur West"],
"721171":[242,1149,0.65,"Ktpp TS, Medinipur East"],
"721172":[130,337,0.15,"Demarihat, Medinipur East"],
"721201":[145,207,1.03,"Bhagabantapur, Medinipur West"],
"721211":[138,373,1.76,"Dharampur, Medinipur West"],
"721212":[160,332,0.82,"Bandar, Hooghly"],
"721222":[160,285,0.33,"Agar, Medinipur West"],
"721232":[150,288,0.53,"Chaklachipur, Medinipur West"],
"721242":[140,321,0.48,"Deopur Amdan, Medinipur West"],
"721253":[150,293,0.02,"Dwarigeria, Medinipur West"],
"721260":[152,324,2.32,"Amuria, Medinipur West"],
"721301":[150,290,0.1,"Palshya, Medinipur West"],
"721302":[150,332,0.13,"Kharagpur Technology, Medinipur West"],
"721303":[150,275,0.1,"Kalaikunda A F, Medinipur West"],
"721304":[130,300,0.1,"Dharenda, Medinipur West"],
"721305":[150,343,0.15,"Harishpur, Medinipur West"],
"721306":[150,326,0.12,"Hijli Cooperative, Medinipur West"],
"721401":[180,504,1.79,"Contai, Medinipur East"],
"721402":[170,620,0.2,"Contai Super Market, Medinipur East"],
"721403":[163,460,0.69,"Contai Bazar, Medinipur East"],
"721404":[170,604,1.81,"Karkuli, Medinipur East"],
"721405":[181,444,1.54,"Durmuth, Medinipur East"],
"721406":[168,636,0.2,"Monoharchak, Medinipur East"],
"721420":[175,286,2.55,"Alangiri, Medinipur East"],
"721422":[175,300,1.94,"Astichak, Medinipur East"],
"721423":[200,345,0.24,"Deuli, Medinipur East"],
"721424":[138,265,1.33,"Akanda, Medinipur West"],
"721425":[165,456,1.14,"Purbaradhapur, Medinipur East"],
"721426":[140,265,0.03,"Banjhatia, Medinipur West"],
"721427":[156,609,0.13,"Ghoraghata, Medinipur East"],
"721428":[341,-1,1.37,"Saripur, Medinipur East"],
"721429":[162,294,1.87,"Barida Bazar, Medinipur East"],
"721430":[165,489,0.86,"Bansgora Bazar, Medinipur East"],
"721431":[131,613,-1,"Boga, Medinipur East"],
"721432":[163,681,0.06,"Baharganj, Medinipur East"],
"721433":[200,526,0.24,"Mandarpur, Medinipur East"],
"721434":[165,429,1.03,"Maisali, Medinipur East"],
"721435":[145,280,0.14,"Salikotha, Medinipur West"],
"721436":[175,271,1.75,"Begunia, Medinipur West"],
"721437":[105,226,1.61,"Bahurupa, Medinipur West"],
"721438":[155,321,0.89,"Ghatua Purusottampur, Medinipur East"],
"721439":[162,368,0.25,"Amarpur, Medinipur East"],
"721440":[162,378,0.32,"Srirampur, Medinipur East"],
"721441":[200,347,0.24,"Haldia Patna, Medinipur East"],
"721442":[160,717,-1,"Bankiput, Medinipur East"],
"721443":[150,311,1.01,"Bandhuchak, Medinipur West"],
"721444":[161,443,0.63,"Ichhabari, Medinipur East"],
"721445":[162,409,0.21,"Ekarukhi, Medinipur West"],
"721446":[200,341,0.24,"Sahara, Medinipur East"],
"721447":[165,285,2.31,"Kalyanpur Tentulmuri, Medinipur East"],
"721448":[185,336,1.22,"Barada Bazar, Medinipur East"],
"721449":[160,301,0.37,"Banamalichatta, Medinipur East"],
"721450":[167,640,0.26,"Dakshin Dauki, Medinipur East"],
"721451":[140,284,0.47,"Garhmonoharpur, Medinipur West"],
"721452":[185,381,1.84,"Bhajachauli, Medinipur East"],
"721453":[200,333,0.25,"Uttar Gobindapur, Medinipur East"],
"721454":[165,416,0.56,"Alukaranbarh, Medinipur East"],
"721455":[200,493,0.24,"Kalindi Teghari, Medinipur East"],
"721456":[162,396,0.5,"Arjunnagar, Medinipur East"],
"721457":[154,256,0.21,"Anikola, Medinipur West"],
"721458":[160,442,1.45,"Bibhisanpur, Medinipur East"],
"721463":[398,-1,0.39,"Digha New Township, Medinipur East"],
"721467":[185,427,0.45,"Adasimla, Medinipur West"],
"721501":[285,-1,0.0,"Chakadoba, Jhargram"],
"721503":[165,295,0.04,"Ghutia, Jhargram"],
"721504":[130,232,0.22,"Andharia, Jhargram"],
"721505":[95,182,0.0,"Amlatora, Jhargram"],
"721506":[145,244,0.0,"Janaghati, Jhargram"],
"721507":[110,191,0.62,"Jhargram, Jhargram"],
"721513":[132,252,0.48,"Burimole, Jhargram"],
"721514":[140,-1,0.71,"Pukuria, Jhargram"],
"721515":[190,366,0.0,"Ashakanthi, Jhargram"],
"721516":[110,251,1.13,"Kalaimuri, Jhargram"],
"721517":[190,259,0.0,"Laupara, Jhargram"],
"721601":[212,609,1.18,"Naba Anantapur, Medinipur East"],
"721602":[217,841,0.77,"Khanjanchak, Medinipur East"],
"721604":[314,1405,0.76,"Haldia, Medinipur East"],
"721606":[180,614,0.25,"HIT, Medinipur East"],
"721607":[175,562,0.27,"Haldia Port, Medinipur East"],
"721624":[175,430,0.57,"Rangibasan, Medinipur East"],
"721625":[145,461,0.13,"Nandapur, Medinipur East"],
"721626":[135,327,0.7,"Charabarh, Medinipur East"],
"721628":[249,1202,0.93,"Garhkamalpur, Medinipur East"],
"721631":[302,1376,0.58,"Durgapur, Medinipur East"],
"721632":[175,412,0.49,"Kumarara, Medinipur East"],
"721633":[218,673,0.58,"Atattar, Medinipur East"],
"721634":[130,472,0.14,"Kalagechhia Bara, Medinipur East"],
"721635":[222,757,0.51,"Agadoro, Medinipur East"],
"721636":[242,1142,0.64,"Tamluk, Medinipur East"],
"721637":[242,1153,0.65,"Dhalhara, Medinipur East"],
"721638":[145,480,0.13,"Gopinathpur, Medinipur East"],
"721641":[150,271,0.63,"Jasora, Medinipur East"],
"721642":[270,472,4.37,"Raichak, Medinipur East"],
"721643":[120,253,0.7,"Dhanyaghar, Medinipur East"],
"721644":[125,325,0.59,"Dakshin Changrachak, Medinipur East"],
"721645":[188,700,0.09,"Balughata, Medinipur East"],
"721646":[160,756,0.47,"Gokulnagar, Medinipur East"],
"721647":[125,325,0.59,"Paschimchilka, Medinipur East"],
"721648":[165,359,2.35,"Mirpur, Medinipur East"],
"721649":[240,907,0.47,"Chakjiandighi, Medinipur East"],
"721650":[122,271,0.57,"Bheturia, Medinipur East"],
"721651":[135,325,0.78,"Bargoda, Medinipur East"],
"721652":[205,600,0.28,"Barabhuniakhali, Medinipur East"],
"721653":[177,421,0.29,"Haridaspur, Medinipur East"],
"721654":[205,765,0.54,"Kumarpur, Medinipur East"],
"721656":[220,419,0.48,"Amratala, Medinipur East"],
"721657":[135,325,0.78,"Hatiberia, Medinipur East"],
"721658":[135,325,0.78,"Baroda, Medinipur East"],
"721659":[188,691,0.09,"Brajalalchak, Medinipur East"],
"722101":[203,549,0.99,"Bankura, Bankura"],
"722102":[237,532,1.22,"Bonkati, Bankura"],
"722121":[254,612,1.82,"Bankata, Bankura"],
"722122":[160,434,1.14,"Beliadangarpara, Bankura"],
"722132":[220,601,1.38,"Garhdubrajpur, Bankura"],
"722133":[180,695,1.49,"Durlavpur, Bankura"],
"722134":[260,415,0.36,"Akhuapal, Bankura"],
"722135":[252,502,2.88,"Dabri, Bankura"],
"722136":[259,641,1.87,"Bhatra, Bankura"],
"722137":[220,640,1.59,"Arrah, Bankura"],
"722138":[198,770,0.94,"Hijaldiha, Bankura"],
"722139":[220,640,1.59,"Baidyalokhesole, Bankura"],
"722140":[350,681,1.66,"Dundar, Bankura"],
"722141":[225,409,0.79,"Balitha, Bankura"],
"722142":[188,504,2.28,"Brindabanpur Barsal, Bankura"],
"722143":[245,662,1.0,"Bakulia, Bankura"],
"722144":[155,435,1.13,"Makorkole, Bankura"],
"722146":[220,526,1.13,"Bhagabandh, Bankura"],
"722147":[165,441,0.8,"Patpur, Bankura"],
"722148":[239,516,1.65,"Kadmagarh, Bankura"],
"722149":[125,443,1.67,"Methana, Bankura"],
"722150":[260,461,0.96,"Chingra, Bankura"],
"722151":[190,582,1.72,"Bondubrajpur, Bankura"],
"722152":[200,690,3.16,"Hirapur, Bankura"],
"722153":[283,696,0.91,"Pachhandapur, Bankura"],
"722154":[305,602,1.81,"Karakberia Sadhuadal, Bankura"],
"722155":[260,457,0.93,"Harialgara, Bankura"],
"722156":[240,564,2.52,"Bhutsahar, Bankura"],
"722157":[155,438,1.16,"Chumosina, Bankura"],
"722158":[300,756,1.48,"Bishjore, Bankura"],
"722160":[140,530,1.06,"Moidhara, Bankura"],
"722161":[205,411,0.96,"Anur, Bankura"],
"722162":[165,584,1.84,"Dudhya, Bankura"],
"722164":[160,434,1.14,"Morar, Bankura"],
"722173":[259,641,1.87,"Ahanda, Bankura"],
"722176":[186,409,1.2,"Narrah S.O., Bankura"],
"722183":[200,398,0.43,"Mejia Th Power Station, Bankura"],
"722201":[152,205,1.19,"Mandra, Bankura"],
"722202":[190,560,3.1,"Ghutgoria, Bankura"],
"722203":[192,577,3.03,"Bhattapara, Bankura"],
"722204":[202,631,2.74,"Hatasuria, Bankura"],
"722205":[155,559,2.14,"Sashpur, Bankura"],
"722206":[158,403,2.63,"Akhrasole, Bankura"],
"722207":[200,659,1.05,"Majirdanga, Bankura"],
"722208":[191,715,1.74,"Tajpur Purakona, Bankura"],
"723101":[140,370,0.47,"Purulia, Purulia"],
"723102":[325,693,0.56,"Bhandarpuara, Purulia"],
"723103":[190,649,0.71,"Bhul, Purulia"],
"723104":[275,535,0.49,"Hura Keshabpur, Purulia"],
"723121":[290,797,0.42,"Bhamuria, Purulia"],
"723126":[295,792,0.83,"Chuna, Purulia"],
"723127":[220,725,0.57,"Badaldih, Purulia"],
"723128":[265,515,0.76,"Bansa, Purulia"],
"723129":[225,472,1.09,"Jitan, Purulia"],
"723130":[292,594,0.69,"Mekhyada, Purulia"],
"723131":[226,459,0.48,"Bamni, Purulia"],
"723132":[275,622,0.44,"Bansraya, Purulia"],
"723133":[333,988,0.56,"Gorsika, Purulia"],
"723134":[230,823,0.75,"NILDIH RTPS S.O., Purulia"],
"723142":[270,832,0.67,"Ramkanali, Purulia"],
"723143":[140,253,0.58,"Berada, Purulia"],
"723145":[340,917,0.97,"Barrah, Purulia"],
"723146":[286,651,0.91,"Deoli, Purulia"],
"723147":[385,935,0.6,"Dumdumi, Purulia"],
"723148":[248,579,0.59,"Sindurpur, Purulia"],
"723149":[328,739,0.64,"Belkuri, Purulia"],
"723151":[302,570,1.23,"Kundurka, Purulia"],
"723152":[290,500,0.95,"Ajodhya Hill, Purulia"],
"723153":[210,474,0.51,"Bara Urma, Purulia"],
"723154":[210,513,0.32,"Hensla, Purulia"],
"723155":[268,800,0.86,"Chitra, Purulia"],
"723156":[260,928,0.48,"Talberia, Purulia"],
"723201":[190,506,0.81,"Arsha, Purulia"],
"723202":[318,647,1.17,"Begunkodar, Purulia"],
"723212":[345,570,0.62,"Gagi, Purulia"],
"723213":[271,594,0.81,"Simni, Purulia"],
"723215":[195,545,0.8,"Chitmu, Purulia"],
"731101":[170,449,0.38,"Suri, Birbhum"],
"731102":[216,544,0.38,"Bhurkuna, Birbhum"],
"731103":[165,456,0.24,"Kukhudihi, Birbhum"],
"731104":[207,533,0.33,"Tapaspur, Birbhum"],
"731121":[214,491,4.4,"Kanserhat, Birbhum"],
"731123":[225,488,0.36,"Balijuri, Birbhum"],
"731124":[225,503,0.23,"Janubazar, Birbhum"],
"731125":[185,534,0.43,"Geruapahari, Birbhum"],
"731126":[195,574,0.24,"Madhaipur, Birbhum"],
"731127":[170,487,0.17,"Baidyanathpur, Birbhum"],
"731129":[165,439,3.64,"Damdama, Birbhum"],
"731130":[245,544,0.01,"Aligarh, Birbhum"],
"731132":[165,342,0.82,"Deucha, Birbhum"],
"731133":[185,471,0.46,"Paigora, Birbhum"],
"731201":[205,426,13.87,"Chotosangra, Birbhum"],
"731202":[168,409,0.28,"Kaluha, Birbhum"],
"731204":[210,415,3.28,"Adityapur, Birbhum"],
"731214":[195,356,0.62,"Koyra, Birbhum"],
"731215":[180,316,21.89,"Belai, Birbhum"],
"731216":[141,311,1.46,"Mohula, Birbhum"],
"731218":[161,243,2.95,"Daspalsa, Birbhum"],
"731219":[165,350,2.65,"Kanakpur, Birbhum"],
"731220":[200,588,1.11,"Kaitha, Birbhum"],
"731221":[210,393,1.35,"Bonha, Birbhum"],
"731222":[250,357,1.46,"Bandhaipur, Birbhum"],
"731223":[172,337,0.24,"Barapahari, Birbhum"],
"731224":[175,368,1.26,"Rampurhat, Birbhum"],
"731233":[140,310,0.18,"Majkhanda, Birbhum"],
"731234":[145,306,4.7,"Gadadharpur RS, Birbhum"],
"731235":[210,408,3.84,"Paruldanga, Birbhum"],
"731236":[208,424,4.4,"Belatisultanpur, Birbhum"],
"731237":[125,277,1.13,"Bhadrapur, Birbhum"],
"731238":[188,489,2.11,"Bhadista, Birbhum"],
"731240":[195,401,4.86,"Pafuri, Birbhum"],
"731241":[110,278,0.09,"Dunigram, Birbhum"],
"731242":[165,526,0.77,"Anantapurkanaipur, Birbhum"],
"731243":[189,500,0.31,"Harioka, Birbhum"],
"731244":[200,310,0.15,"Debiparulia, Murshidabad"],
"731245":[158,273,2.87,"Ghoshgram, Birbhum"],
"731301":[208,413,7.06,"Charkolgram, Birbhum"],
"731302":[200,407,2.1,"Brahmandihi, Birbhum"],
"731303":[225,409,4.17,"Bipratikuri, Birbhum"],
"731304":[175,382,1.49,"BHATRA, Birbhum"],
"732101":[318,704,3.95,"Malda, Maldah"],
"732102":[318,704,4.02,"Bairgachi, Maldah"],
"732103":[258,682,0.07,"Kamalabari, Maldah"],
"732121":[318,704,4.02,"Gouramari, Maldah"],
"732122":[318,704,4.02,"Gopalpurhat, Maldah"],
"732123":[318,704,4.02,"Arbora, Maldah"],
"732124":[318,704,4.02,"Akalpur, Maldah"],
"732125":[318,704,4.02,"Hardamnagar, Maldah"],
"732126":[318,704,4.02,"Bheba, Maldah"],
"732127":[258,682,0.07,"Charbabupur, Maldah"],
"732128":[215,391,1.23,"Budhia, Maldah"],
"732138":[290,512,0.4,"Dharmadanga, Maldah"],
"732139":[318,704,4.02,"Jitarpur, Maldah"],
"732140":[318,704,4.02,"Bhatolchandipur, Maldah"],
"732141":[258,682,0.07,"Popra, Maldah"],
"732142":[192,327,2.05,"Bachamari, Maldah"],
"732144":[325,726,3.43,"Kotwali SO Malda, Maldah"],
"732201":[318,704,4.02,"Alinagar, Maldah"],
"732202":[330,591,4.52,"Dharampur, Maldah"],
"732203":[258,682,0.07,"Sukdevtola, Maldah"],
"732204":[328,530,3.3,"Brahmangram, Maldah"],
"732205":[318,704,4.02,"Bilaimari, Maldah"],
"732206":[318,704,4.02,"Baluachara, Maldah"],
"732207":[318,704,4.02,"Panchanandapur, Maldah"],
"732208":[318,704,4.02,"Madapur, Maldah"],
"732209":[318,704,4.02,"Pirpur, Maldah"],
"732210":[318,704,4.02,"Bhgabanpur, Maldah"],
"732215":[140,351,0.09,"Pubarun, Maldah"],
"732216":[258,682,0.07,"Akandabaria, Maldah"],
"733101":[212,434,0.27,"Balurghat, Dinajpur Dakshin"],
"733102":[212,440,0.29,"Jalghar, Dinajpur Dakshin"],
"733103":[212,436,0.3,"Bijoyshree, Dinajpur Dakshin"],
"733121":[212,440,0.29,"Karkha, Dinajpur Dakshin"],
"733123":[212,437,0.28,"Bamangram, Dinajpur Uttar"],
"733124":[178,423,0.27,"Purba Mollapara, Dinajpur Dakshin"],
"733125":[180,335,1.58,"Balihara, Dinajpur Dakshin"],
"733126":[212,440,0.29,"Fatepur, Dinajpur Dakshin"],
"733127":[205,322,0.5,"Ajmatpur, Dinajpur Dakshin"],
"733128":[159,385,2.08,"Baidara, Dinajpur Uttar"],
"733129":[148,266,2.38,"Bhelai, Dinajpur Uttar"],
"733130":[148,387,5.92,"Hemtabad, Dinajpur Uttar"],
"733132":[162,366,0.26,"Berail, Dinajpur Dakshin"],
"733133":[212,434,0.4,"Gobindapur, Dinajpur Dakshin"],
"733134":[157,378,0.09,"Raiganj, Dinajpur Uttar"],
"733139":[210,322,0.3,"Ajmatpur, Dinajpur Dakshin"],
"733140":[212,440,0.29,"Bandighi, Dinajpur Dakshin"],
"733141":[114,268,0.68,"Debipur, Dinajpur Dakshin"],
"733142":[162,371,0.26,"Kardah, Dinajpur Dakshin"],
"733143":[172,440,4.33,"Hatgachhi, Dinajpur Uttar"],
"733145":[138,239,0.85,"Gopalbati, Dinajpur Dakshin"],
"733156":[107,702,-1,"Laxmonia, Dinajpur Uttar"],
"733158":[156,364,0.63,"Baul, Dinajpur Dakshin"],
"733201":[150,587,0.0,"Andharia, Dinajpur Uttar"],
"733202":[212,436,0.3,"Burhijagir, Dinajpur Uttar"],
"733207":[142,312,1.33,"Chandanidanga, Dinajpur Uttar"],
"733208":[160,293,0.4,"Bidyanandapur, Dinajpur Uttar"],
"733209":[111,549,0.1,"Galia, Dinajpur Uttar"],
"733210":[181,238,0.0,"Dehar, Dinajpur Uttar"],
"733215":[212,440,0.29,"Doarin, Dinajpur Uttar"],
"734001":[105,348,0.3,"Siliguri, Darjeeling"],
"734002":[105,358,0.33,"Salbari, Darjeeling"],
"734003":[135,337,0.22,"Champasari Forest, Darjeeling"],
"734004":[135,367,0.3,"Dabgram, Jalpaiguri"],
"734005":[1350,4225,-1,"Jyotinagar, Darjeeling"],
"734006":[135,359,0.32,"Haidarpara, Jalpaiguri"],
"734007":[140,365,0.28,"East Bhaktinagar, Jalpaiguri"],
"734008":[92,147,0.13,"Shelphu, Darjeeling"],
"734009":[104,301,0.18,"Gulma, Darjeeling"],
"734010":[102,303,0.15,"TUMBAJOTE, Darjeeling"],
"734011":[138,521,0.13,"Kadamtala SO Darjiling, Darjeeling"],
"734012":[91,341,0.2,"Ranidanga, Darjeeling"],
"734013":[72,453,0.12,"New Rangia, Darjeeling"],
"734014":[105,438,0.21,"Chowpukuria, Darjeeling"],
"734015":[74,247,0.18,"Satellite Township, Jalpaiguri"],
"734091":[120,329,0.18,"TUMBAJOTE, Darjeeling"],
"734101":[105,166,0.1,"Darjeeling, Darjeeling"],
"734102":[105,166,0.1,"Bloom Field, Darjeeling"],
"734103":[74,136,0.1,"Rajbari, Darjeeling"],
"734104":[105,166,0.1,"Soom, Darjeeling"],
"734105":[105,166,0.1,"Badamtam, Darjeeling"],
"734201":[156,722,0.12,"Jhepi, Darjeeling"],
"734203":[151,692,0.12,"Mahanadi, Darjeeling"],
"734204":[105,166,0.1,"Dowhill, Darjeeling"],
"734209":[40,600,0.13,"Moonda Koti, Darjeeling"],
"734213":[105,166,0.1,"Lamahatta, Darjeeling"],
"734214":[40,622,0.14,"Okaity, Darjeeling"],
"734215":[74,136,0.1,"Dhajea, Darjeeling"],
"734216":[40,593,0.13,"Selimbong, Darjeeling"],
"734217":[84,143,0.15,"Jamdar Vitta, Darjeeling"],
"734218":[82,141,0.15,"Singbulli, Darjeeling"],
"734220":[152,702,0.12,"Deorali, Darjeeling"],
"734221":[73,135,0.1,"Maneybhanjeng, Darjeeling"],
"734222":[105,166,0.1,"Tinchuley, Darjeeling"],
"734223":[131,516,0.15,"Norbung, Darjeeling"],
"734224":[128,484,0.15,"Margarets Hope, Darjeeling"],
"734226":[141,603,0.14,"Geile Banjyang, Darjeeling"],
"734301":[105,166,0.1,"Suruk, Kalimpong"],
"734311":[139,283,0.25,"Sakyong, Kalimpong"],
"734312":[105,166,0.1,"Bar Dara, Darjeeling"],
"734313":[105,166,0.1,"Ranju Valley, Darjeeling"],
"734314":[84,142,0.18,"Pabring Tar, Kalimpong"],
"734315":[135,253,0.34,"Burmeck, Kalimpong"],
"734316":[105,166,0.1,"Rousay Bazar, Kalimpong"],
"734421":[105,419,0.21,"Bagdogra Air Port, Darjeeling"],
"734423":[102,681,0.18,"Nipania, Darjeeling"],
"734424":[135,517,0.21,"Bendubi, Darjeeling"],
"734425":[105,361,0.28,"Bidhannagar, Darjeeling"],
"734426":[102,374,0.22,"Gayanganga, Darjeeling"],
"734427":[100,597,0.2,"Tharjhorabagan, Darjeeling"],
"734429":[100,342,0.25,"Dulaljote, Darjeeling"],
"734434":[105,408,0.18,"Chathat, Darjeeling"],
"734501":[92,137,0.21,"Chanda Company, Jalpaiguri"],
"734503":[162,338,0.19,"Todaygaon, Kalimpong"],
"735101":[78,244,0.18,"Jalpaiguri, Jalpaiguri"],
"735102":[74,247,0.18,"Chaulhati, Jalpaiguri"],
"735121":[74,259,0.19,"Paharpur, Jalpaiguri"],
"735122":[85,305,0.03,"Boalmari, Jalpaiguri"],
"735132":[78,331,0.15,"Kadobarihat, Jalpaiguri"],
"735133":[68,267,0.29,"Milanpally, Jalpaiguri"],
"735134":[78,265,0.36,"Fatapukur, Jalpaiguri"],
"735135":[140,308,0.32,"Kunderdighi, Jalpaiguri"],
"735202":[85,138,0.1,"Angrabhasa, Jalpaiguri"],
"735203":[99,164,0.13,"Binnaguri, Jalpaiguri"],
"735204":[76,154,0.14,"Dimdima, Alipurduar"],
"735205":[65,117,0.12,"Sadhupur Chengmari, Jalpaiguri"],
"735206":[70,288,0.23,"Rango, Kalimpong"],
"735207":[87,138,0.1,"Ambaribagan, Jalpaiguri"],
"735208":[169,267,0.12,"Dalshingpara, Alipurduar"],
"735209":[80,210,0.23,"Damdim, Jalpaiguri"],
"735210":[100,339,0.21,"Bairatiguri, Jalpaiguri"],
"735211":[68,330,0.3,"Atpukuria Nayahat, Coochbehar"],
"735212":[76,150,0.13,"Pradhanpara, Jalpaiguri"],
"735213":[68,189,0.15,"Deogaon, Alipurduar"],
"735214":[185,278,0.13,"Dakshin Latabari, Alipurduar"],
"735215":[200,351,0.1,"Madhubagan, Alipurduar"],
"735216":[85,190,0.2,"Alinagar, Alipurduar"],
"735217":[150,246,0.16,"GANGUTIA TG, Alipurduar"],
"735218":[92,193,0.1,"Kailashpur, Jalpaiguri"],
"735219":[142,309,0.1,"Ramsaihat, Jalpaiguri"],
"735220":[185,306,0.11,"Khowchand Para, Alipurduar"],
"735221":[80,173,0.13,"Mal, Jalpaiguri"],
"735222":[66,115,0.24,"Oodlabari, Jalpaiguri"],
"735223":[65,424,0.28,"Kumai, Kalimpong"],
"735224":[155,374,0.16,"Churabhander, Jalpaiguri"],
"735225":[65,236,0.19,"Sulkapara, Jalpaiguri"],
"735226":[168,405,0.17,"Panabasti, Alipurduar"],
"735227":[74,129,0.15,"Bakshaduar, Alipurduar"],
"735228":[152,231,0.12,"Lankaparahat, Alipurduar"],
"735229":[80,208,0.23,"Rungamatee, Jalpaiguri"],
"735230":[80,192,0.15,"Neora, Jalpaiguri"],
"735231":[140,291,0.25,"Ahlay, Kalimpong"],
"735232":[100,165,0.13,"Binnaguri Cantt, Jalpaiguri"],
"735233":[121,249,0.12,"Garialtari, Jalpaiguri"],
"735234":[76,125,0.25,"Gajoldoba, Jalpaiguri"],
"735301":[100,221,0.2,"Bhotebari, Coochbehar"],
"735302":[170,309,0.13,"Boulbari, Jalpaiguri"],
"735303":[112,317,0.17,"Uchalpukuri, Coochbehar"],
"735304":[85,150,0.14,"Bagdokra, Coochbehar"],
"735305":[143,268,0.2,"Bakali, Jalpaiguri"],
"736101":[135,359,0.17,"Cooch Behar, Coochbehar"],
"736121":[145,317,0.2,"Chaparerpar, Alipurduar"],
"736122":[145,280,0.18,"Ghagra, Alipurduar"],
"736123":[145,270,0.18,"Damanpur, Alipurduar"],
"736131":[119,174,0.17,"Bhanukumari, Coochbehar"],
"736133":[205,299,0.18,"Ambari, Coochbehar"],
"736134":[190,282,0.13,"Borodanga, Coochbehar"],
"736135":[124,241,0.09,"Bhagni Parti, Coochbehar"],
"736145":[110,174,0.08,"Pakhihaga, Coochbehar"],
"736146":[130,245,0.16,"Mahishcharu, Coochbehar"],
"736156":[198,355,0.14,"Chhatoa, Coochbehar"],
"736157":[135,196,0.12,"Chilkirhat, Coochbehar"],
"736158":[110,146,0.11,"Purba Sitalkuchi, Coochbehar"],
"736159":[154,292,0.08,"Andaranfulbari West, Coochbehar"],
"736160":[104,358,0.22,"Andaran Fulbari, Coochbehar"],
"736165":[135,257,0.17,"Madhupur, Coochbehar"],
"736167":[106,157,0.1,"Chorekhata, Coochbehar"],
"736168":[124,234,0.09,"Khatamari, Coochbehar"],
"736169":[124,236,0.1,"Kuchni, Coochbehar"],
"736170":[110,230,0.1,"Dudherkuthi Dewanbash, Coochbehar"],
"736171":[142,218,0.12,"Unishbisha, Coochbehar"],
"736172":[55,161,0.14,"Dewankot Jayduar, Coochbehar"],
"736176":[135,339,0.16,"Kalmati, Coochbehar"],
"736179":[140,295,0.17,"Khagrabari, Coochbehar"],
"736182":[76,154,0.14,"Jaigaon, Alipurduar"],
"736201":[104,163,0.29,"Chuniajhora, Alipurduar"],
"736202":[122,197,0.2,"Marakhata, Alipurduar"],
"736203":[122,210,0.16,"Pukurigram, Alipurduar"],
"736204":[145,236,0.21,"Dakshin Kamsingram, Alipurduar"],
"736205":[145,424,0.2,"New Lands, Alipurduar"],
"736206":[122,217,0.19,"Baniadabri, Alipurduar"],
"736207":[125,295,0.08,"Baruipara, Alipurduar"],
"736208":[145,236,0.14,"Dakshin Dhalkar, Alipurduar"],
"736209":[145,275,0.11,"Chhatoa, Coochbehar"],
"737101":[105,166,0.1,"Gangtok, East District"],
"737102":[237,625,0.0,"Dhajey, East District"],
"737103":[237,625,0.0,"Bhusuk, East District"],
"737106":[140,285,0.25,"Karthok, Pakyong"],
"737107":[237,625,0.0,"Lumlingthyang, East District"],
"737111":[105,166,0.1,"Arithang, West District"],
"737113":[247,726,0.0,"Khechuperi, West District"],
"737121":[128,438,0.14,"Budang, West District"],
"737126":[127,415,0.16,"Mic Khola, South District"],
"737128":[105,166,0.1,"Rateypani, South District"],
"737131":[150,302,0.2,"Chujachen, Pakyong"],
"737132":[146,291,0.2,"Maney Dara, South District"],
"737133":[144,297,0.26,"Rorathang, Pakyong"],
"737134":[187,400,0.26,"Lingzey, East District"],
"737135":[164,337,0.2,"Rumtek, East District"],
"737136":[237,625,0.0,"Majitar, East District"],
"737139":[105,166,0.1,"Barfung, South District"],
"741101":[235,472,1.57,"Krishnanagar, Nadia"],
"741102":[235,471,1.27,"Kalirhat, Nadia"],
"741103":[235,433,1.63,"Gobrapota, Nadia"],
"741121":[230,458,0.93,"Khamarshumulia, Nadia"],
"741122":[298,584,0.69,"Gopalpur Ghat, Nadia"],
"741123":[243,424,2.0,"Talukhuda, Nadia"],
"741124":[243,382,0.88,"Hatisala, Nadia"],
"741125":[235,450,1.58,"Bahadurpur, Nadia"],
"741126":[232,422,1.23,"Bandbelgaon, Nadia"],
"741127":[273,494,0.44,"Byaspur, Nadia"],
"741137":[155,360,1.84,"Arbetai, Nadia"],
"741138":[232,429,0.77,"Tentulberia, Nadia"],
"741139":[235,468,1.65,"Dhubulia, Nadia"],
"741140":[235,420,2.04,"Panditpur, Nadia"],
"741150":[155,403,2.52,"Basarkhola, Nadia"],
"741151":[233,419,1.5,"Chitrasali, Nadia"],
"741152":[298,558,1.87,"Khanpur, Nadia"],
"741153":[210,440,1.24,"Baliadanga Faridpur, Nadia"],
"741154":[235,433,2.02,"Saligram, Nadia"],
"741155":[252,439,1.02,"Bakshipur, Nadia"],
"741156":[245,407,0.45,"Molandi, Nadia"],
"741157":[200,351,2.05,"Bhurulia, Nadia"],
"741158":[298,683,0.52,"Raghunathpur Ramnagar, Nadia"],
"741159":[230,472,0.39,"Taherpur, Nadia"],
"741160":[248,375,0.56,"Hanspukuria, Nadia"],
"741161":[237,408,2.16,"Kulgachi, Nadia"],
"741162":[210,396,0.67,"Chandanpur, Nadia"],
"741163":[252,429,1.52,"Lalbazar, Nadia"],
"741164":[236,412,2.05,"Tilakpur, Nadia"],
"741165":[298,452,2.98,"Barbakpur, Nadia"],
"741166":[235,414,2.36,"Kalinga, Nadia"],
"741167":[220,514,0.49,"Sakdaha, Nadia"],
"741181":[190,343,2.35,"Radhakantapur, Nadia"],
"741201":[221,600,0.05,"Ranaghat, Nadia"],
"741202":[250,602,0.0,"Dhantala, Nadia"],
"741221":[300,507,1.03,"Barajaguli, Nadia"],
"741222":[212,465,0.39,"Dighra, Nadia"],
"741223":[255,442,2.15,"Silinda, Nadia"],
"741232":[230,513,0.45,"Coopers Camp, Nadia"],
"741234":[287,528,0.66,"Gayeshpur, Nadia"],
"741235":[230,511,0.46,"Kalyani, Nadia"],
"741238":[247,466,0.6,"Humaniapota, Nadia"],
"741245":[230,496,0.46,"Chandamari, Nadia"],
"741246":[287,505,0.7,"Haringhat River Research Insti, Nadia"],
"741247":[218,604,0.44,"Pritinagar, Nadia"],
"741248":[218,473,0.55,"Narapatipara, Nadia"],
"741249":[306,496,1.29,"Narayanpur, Nadia"],
"741250":[265,527,0.39,"Bedibhavan, Nadia"],
"741251":[212,512,0.48,"Majerchar, Nadia"],
"741252":[306,502,1.01,"Krishivisyavidyalaya, Nadia"],
"741253":[236,388,1.9,"Eruli, Nadia"],
"741254":[205,502,0.31,"Kamgachi, Nadia"],
"741255":[209,502,0.11,"Noapara, Nadia"],
"741256":[247,480,0.48,"Ranaghat Baidyapur, Nadia"],
"741257":[297,490,4.34,"Kasthadanga, Nadia"],
"741301":[235,514,1.47,"Ushidpur, Nadia"],
"741302":[235,601,0.86,"Nabadwip, Nadia"],
"741313":[235,482,1.51,"Nidaya, Nadia"],
"741315":[235,480,2.21,"Gadigachha, Nadia"],
"741316":[232,601,1.05,"Fakirdanga, Nadia"],
"741317":[235,547,1.24,"Aluipara, Nadia"],
"741319":[230,560,1.11,"Bidyanagar, Purba Bardhaman"],
"741401":[238,489,0.55,"Dignagar, Nadia"],
"741402":[245,534,0.3,"Belemath, Nadia"],
"741404":[257,478,0.55,"Bablagobindapur, Nadia"],
"741501":[250,456,0.53,"Panchberia, Nadia"],
"741502":[237,406,1.47,"Haldipara, Nadia"],
"741503":[251,351,6.57,"Bijoypur, Nadia"],
"741504":[250,429,0.62,"Baranberia, Nadia"],
"741505":[233,331,1.49,"Gobindapur, Nadia"],
"741506":[237,386,2.48,"Swarnakhali, Nadia"],
"741507":[237,380,2.77,"Bhajanghat, Nadia"],
"741508":[258,391,3.46,"Joyghata, Nadia"],
"741509":[236,383,2.65,"Shibnibas, Nadia"],
"742101":[122,367,0.9,"Berhampore WB, Murshidabad"],
"742102":[212,342,0.88,"Bishnupur Kalibari, Murshidabad"],
"742103":[212,342,0.88,"Saidabad, Murshidabad"],
"742104":[212,342,0.88,"Etore, Murshidabad"],
"742113":[288,425,0.5,"Dalelpara, Murshidabad"],
"742121":[118,266,1.51,"Chandpur, Murshidabad"],
"742122":[284,442,0.82,"Ghorshala, Murshidabad"],
"742123":[288,464,1.02,"AMDAHARA, Murshidabad"],
"742132":[180,351,0.39,"Ekghoria Khanqua, Murshidabad"],
"742133":[160,425,0.62,"Bishannagar, Murshidabad"],
"742134":[120,272,1.6,"Jhunka, Murshidabad"],
"742135":[128,318,1.14,"Akheriganj, Murshidabad"],
"742136":[166,393,0.82,"Amritakunda, Murshidabad"],
"742137":[138,299,0.52,"Kandi, Murshidabad"],
"742138":[210,454,0.64,"Brahmanpara, Murshidabad"],
"742140":[165,365,2.46,"Benipur, Murshidabad"],
"742147":[110,257,0.09,"Gurulia, Murshidabad"],
"742148":[210,378,0.85,"Ashariadaha, Murshidabad"],
"742149":[160,293,0.92,"Gopinathpur, Murshidabad"],
"742151":[200,475,0.4,"Laskarpur, Murshidabad"],
"742159":[110,259,0.33,"Kashidanga Mohammadpur, Murshidabad"],
"742160":[285,465,1.5,"Nashipur Rajbati, Murshidabad"],
"742161":[135,299,0.09,"Godda Sighari, Murshidabad"],
"742163":[210,414,0.89,"Lohadaha, Murshidabad"],
"742164":[148,296,0.95,"Roshanbagh, Murshidabad"],
"742165":[210,374,1.33,"Nutanpararaipur, Murshidabad"],
"742166":[214,402,0.86,"Sahazadpur, Murshidabad"],
"742168":[179,469,0.64,"Kharjuna, Murshidabad"],
"742174":[224,834,0.5,"Dakatiapota, Murshidabad"],
"742175":[318,640,2.36,"Beharia, Murshidabad"],
"742184":[189,408,0.72,"Targram, Murshidabad"],
"742187":[250,425,1.13,"BSahazadpur, Murshidabad"],
"742189":[188,557,1.57,"Andulberia, Murshidabad"],
"742201":[180,365,0.39,"Hasanpur, Murshidabad"],
"742202":[216,417,0.4,"Bahagalpur, Murshidabad"],
"742212":[245,521,0.39,"Bagdabra, Murshidabad"],
"742213":[245,456,0.28,"Dayarampur, Murshidabad"],
"742223":[170,430,0.63,"Ahiran, Murshidabad"],
"742224":[218,416,0.44,"Alamsahi, Murshidabad"],
"742225":[242,426,0.32,"Raghunathganj, Murshidabad"],
"742226":[145,522,1.53,"Aheripara, Murshidabad"],
"742227":[120,290,1.1,"Diar Raninagar, Murshidabad"],
"742235":[184,558,0.51,"Jarur, Murshidabad"],
"742236":[265,512,2.2,"Nabarun, Murshidabad"],
"742237":[166,383,0.24,"Balia, Murshidabad"],
"742238":[170,587,0.83,"Palsandamore, Murshidabad"],
"742301":[216,414,0.4,"Amlai, Murshidabad"],
"742302":[162,350,2.16,"BDurlavpur, Murshidabad"],
"742303":[165,362,2.17,"Khairamari, Murshidabad"],
"742304":[160,293,0.94,"Nazirpur, Murshidabad"],
"742305":[210,450,1.05,"Joykrishnapur, Murshidabad"],
"742306":[248,379,0.57,"Kazipara, Murshidabad"],
"742308":[298,617,1.75,"Borderpara, Murshidabad"],
"742401":[194,386,0.58,"Dutta Barutia, Murshidabad"],
"742402":[289,472,1.42,"Talibpur, Murshidabad"],
"742404":[158,245,2.68,"Miyan, Murshidabad"],
"742405":[195,397,1.33,"Gobindapur, Murshidabad"],
"742406":[188,578,2.43,"Juranpur, Murshidabad"],
"742407":[212,332,0.99,"Chaltia, Murshidabad"],
"742408":[212,332,0.99,"Sargachi Ashram, Murshidabad"],
"742409":[212,332,0.99,"Shaikhpara, Murshidabad"],
"742410":[165,570,1.54,"REJINAGAR, Murshidabad"],
"743122":[235,811,0.43,"Bengal Enamel, 24 Paraganas North"],
"743123":[230,511,1.5,"Bhatpara, 24 Paraganas North"],
"743124":[188,454,1.07,"ESD M, 24 Paraganas North"],
"743125":[228,470,0.8,"Jagatdal, 24 Paraganas North"],
"743126":[230,501,0.82,"Keotia, 24 Paraganas North"],
"743127":[188,459,1.04,"Gurdah, 24 Paraganas North"],
"743128":[228,472,0.75,"Athpur, 24 Paraganas North"],
"743129":[230,507,0.84,"Fingapara, 24 Paraganas North"],
"743130":[240,545,0.93,"Dogachia, 24 Paraganas North"],
"743133":[188,460,1.01,"Pinkal, 24 Paraganas North"],
"743134":[240,514,0.31,"Halishahar, 24 Paraganas North"],
"743135":[265,534,0.46,"Malancha, 24 Paraganas North"],
"743136":[265,507,0.35,"Nabanagar, 24 Paraganas North"],
"743144":[172,454,1.12,"Anandamath, 24 Paraganas North"],
"743145":[270,540,0.44,"Palashi, 24 Paraganas North"],
"743165":[265,559,0.78,"Puranandapally, 24 Paraganas North"],
"743166":[265,559,0.78,"Madarpur, 24 Paraganas North"],
"743193":[281,554,0.52,"Kampa, 24 Paraganas North"],
"743194":[228,470,0.8,"Kelabagan, 24 Paraganas North"],
"743221":[282,467,0.92,"Adhata, 24 Paraganas North"],
"743222":[305,484,0.84,"Iswarigacha, 24 Paraganas North"],
"743223":[205,521,0.77,"Haripur SO North 24 Parganas, 24 Paraganas North"],
"743232":[234,445,2.83,"Boyra, 24 Paraganas North"],
"743233":[224,687,1.25,"Jesur Jeoldanga, 24 Paraganas North"],
"743234":[302,460,0.82,"Joypul, 24 Paraganas North"],
"743235":[261,463,1.5,"Kalupur, 24 Paraganas North"],
"743245":[262,435,3.03,"Baikara, 24 Paraganas North"],
"743247":[282,530,1.84,"Kanchdaha, 24 Paraganas North"],
"743248":[325,495,1.04,"Adikashimpur, 24 Paraganas North"],
"743249":[282,484,5.59,"Rampur Bhatpara, 24 Paraganas North"],
"743251":[234,476,1.28,"Bagangram, 24 Paraganas North"],
"743252":[282,487,4.0,"Gobardanga Ichapur, 24 Paraganas North"],
"743262":[260,434,1.83,"Bairampur, 24 Paraganas North"],
"743263":[245,489,2.53,"Akrampur, 24 Paraganas North"],
"743268":[245,493,1.67,"Habra Prafulla Nagar, 24 Paraganas North"],
"743270":[234,442,1.81,"Berbari, 24 Paraganas North"],
"743271":[272,533,1.54,"Kumra Kashipur, 24 Paraganas North"],
"743272":[265,504,0.9,"Kankpul, 24 Paraganas North"],
"743273":[270,493,2.3,"Amudia, 24 Paraganas North"],
"743286":[294,656,0.89,"Banglani, 24 Paraganas North"],
"743287":[267,447,4.91,"Chikanpara, 24 Paraganas North"],
"743289":[270,505,2.88,"Uludanga, 24 Paraganas North"],
"743290":[280,468,3.67,"Ram Shankarpur, 24 Paraganas North"],
"743291":[205,576,1.27,"Rajendrapur, 24 Paraganas North"],
"743292":[210,479,0.78,"Panitor, 24 Paraganas North"],
"743293":[205,511,1.56,"Eojnagar, 24 Paraganas North"],
"743294":[305,512,0.85,"Bohara, 24 Paraganas North"],
"743297":[234,455,1.03,"Nataberia, 24 Paraganas North"],
"743312":[199,596,1.03,"Hironmoypur, 24 Paraganas South"],
"743318":[240,945,0.51,"Chak Kashipur, 24 Paraganas South"],
"743329":[210,591,0.89,"Jogendranagar, 24 Paraganas South"],
"743330":[212,631,0.9,"Tarda Kapasati, 24 Paraganas South"],
"743331":[250,1177,0.57,"Diamond Harbour, 24 Paraganas South"],
"743332":[278,1594,0.57,"Sultanpur, 24 Paraganas South"],
"743336":[238,1065,0.66,"Anwarpur, 24 Paraganas South"],
"743337":[225,695,0.97,"Futigoda, 24 Paraganas South"],
"743338":[217,704,0.5,"Bakultalahat, 24 Paraganas South"],
"743345":[211,896,0.69,"Kashipur, 24 Paraganas South"],
"743347":[225,719,1.12,"Akshoynagar, 24 Paraganas South"],
"743348":[213,813,0.97,"Belpukur, 24 Paraganas South"],
"743349":[195,867,0.53,"Baribhanga Abad, 24 Paraganas South"],
"743351":[215,1053,0.52,"Enayetpur, 24 Paraganas South"],
"743354":[195,814,0.59,"Ghoradah, 24 Paraganas South"],
"743355":[225,700,0.9,"Dhanpota, 24 Paraganas South"],
"743356":[120,404,0.75,"Ghoramara Mandirtala, 24 Paraganas South"],
"743357":[154,756,0.58,"Patibunia, 24 Paraganas South"],
"743363":[202,627,1.06,"Narayanpur, 24 Paraganas South"],
"743368":[254,1199,0.57,"Abdalpur, 24 Paraganas South"],
"743370":[187,835,-1,"Amlamethi, 24 Paraganas South"],
"743371":[205,782,0.75,"Daspur, 24 Paraganas South"],
"743372":[204,694,0.89,"Punpua, 24 Paraganas South"],
"743373":[205,679,0.6,"Dihimathurapur Gobindapur, 24 Paraganas South"],
"743374":[222,739,1.27,"Dakshin Rajnagar, 24 Paraganas South"],
"743375":[258,1149,0.58,"Uttar Kusum, 24 Paraganas South"],
"743376":[200,700,1.1,"Debisabad, 24 Paraganas South"],
"743377":[240,879,0.49,"Aryapara, 24 Paraganas South"],
"743378":[211,670,1.58,"Amtali, 24 Paraganas South"],
"743383":[170,813,0.39,"Achintanagar, 24 Paraganas South"],
"743387":[212,636,1.14,"Begampur, 24 Paraganas South"],
"743395":[242,1112,0.59,"Bazarberia, 24 Paraganas South"],
"743399":[192,828,0.85,"Bhajna Benepara, 24 Paraganas South"],
"743401":[218,561,1.34,"Andharmanik, 24 Paraganas North"],
"743405":[260,459,1.53,"Chhoygharia, 24 Paraganas North"],
"743411":[205,523,0.78,"Basirhat, 24 Paraganas North"],
"743412":[205,519,0.75,"Dhaltitha, 24 Paraganas North"],
"743422":[205,557,0.6,"Kathur, 24 Paraganas North"],
"743423":[265,527,1.35,"Baidyapur, 24 Paraganas North"],
"743424":[224,494,2.36,"Chandpur, 24 Paraganas North"],
"743425":[205,528,1.95,"Kharupala, 24 Paraganas North"],
"743426":[150,654,0.52,"Ichhapur Abad, 24 Paraganas North"],
"743427":[230,508,0.7,"Aturia, 24 Paraganas North"],
"743428":[220,602,0.88,"Raghunathpur, 24 Paraganas North"],
"743429":[205,549,0.78,"Soladana, 24 Paraganas North"],
"743435":[205,597,0.25,"Bankra Dabar, 24 Paraganas North"],
"743437":[218,499,1.74,"Arbelia, 24 Paraganas North"],
"743438":[238,549,1.35,"Atghara, 24 Paraganas North"],
"743439":[185,721,0.0,"Lebukhali, 24 Paraganas North"],
"743442":[180,652,0.4,"Boyermari, 24 Paraganas North"],
"743445":[202,516,2.16,"Gouribhoj, 24 Paraganas North"],
"743446":[167,571,0.2,"Atapur, 24 Paraganas North"],
"743456":[180,618,1.02,"Abadkuliadanga, 24 Paraganas North"],
"743502":[214,717,0.52,"Bamunia, 24 Paraganas South"],
"743503":[235,742,0.59,"Andharmanik, 24 Paraganas South"],
"743504":[250,1083,0.61,"Kalatalahat, 24 Paraganas South"],
"743513":[250,1002,0.5,"Chaluary, 24 Paraganas South"],
"743609":[242,965,0.6,"Jalghara, 24 Paraganas South"],
"743610":[212,572,0.81,"Dhamua, 24 Paraganas South"],
"743611":[186,624,1.58,"Batakhali Chandipur, 24 Paraganas South"],
"743613":[212,633,0.61,"Beniabow, 24 Paraganas South"],
"743701":[262,453,2.13,"Sonekpur, 24 Paraganas North"],
"743702":[247,561,1.28,"Balisa Chowmatha, 24 Paraganas North"],
"743704":[265,473,0.74,"Prithiba, 24 Paraganas North"],
"743710":[247,461,1.03,"Akaipur, 24 Paraganas North"],
"743711":[300,482,0.95,"Beraberi, 24 Paraganas North"],
"744101":[175,361,0.61,"Port Blair, South Andamans"],
"744102":[175,361,0.61,"Radio Colony, South Andamans"],
"744103":[145,269,0.67,"Dollygunj, South Andamans"],
"744104":[175,361,0.61,"Shaheed Dweep, South Andamans"],
"744105":[175,361,0.61,"Sippighat, South Andamans"],
"744106":[175,361,0.61,"Shadipur, South Andamans"],
"744107":[180,342,0.56,"Stewertgunj, South Andamans"],
"744112":[146,224,0.84,"Chakargoan, South Andamans"],
"744201":[232,429,0.17,"Nimbudera, North And Middle Andaman"],
"744202":[190,379,0.21,"Aerial Bay, North And Middle Andaman"],
"744203":[240,463,0.25,"Long Island, North And Middle Andaman"],
"744204":[159,317,0.39,"Rampur, North And Middle Andaman"],
"744205":[240,373,0.19,"Nimbutala, North And Middle Andaman"],
"744206":[102,167,0.94,"Kalatong, South Andamans"],
"744209":[240,352,0.58,"Uttara, North And Middle Andaman"],
"744210":[195,363,0.42,"Kanchangarh, North And Middle Andaman"],
"744211":[205,461,0.57,"Kalapather, South Andamans"],
"751001":[101,207,0.32,"Bhubaneswar G.P.O., Khordha"],
"751002":[95,229,0.34,"Sisupalgarh, Khordha"],
"751003":[97,210,0.38,"Ghatikia, Khordha"],
"751004":[99,204,0.31,"Utkal University, Khordha"],
"751005":[72,197,0.66,"Sainik School S.O (Khorda), Khordha"],
"751006":[97,216,0.3,"Budheswari Colony, Khordha"],
"751007":[101,217,0.31,"Saheed Nagar, Khordha"],
"751008":[99,206,0.31,"Rajbhawan S.O (Khorda), Khordha"],
"751009":[97,208,0.32,"Ashok Nagar S.O (Khorda), Khordha"],
"751010":[118,312,0.3,"Rasulgarh, Khordha"],
"751011":[97,206,0.34,"C R P Lines, Khordha"],
"751012":[97,205,0.32,"Nayapalli, Khordha"],
"751013":[101,192,0.34,"Regional Research Laboratory, Khordha"],
"751014":[96,220,0.31,"Bhubaneswar Court, Khordha"],
"751015":[97,203,0.34,"I R C Village, Khordha"],
"751016":[104,209,0.34,"Chandra Sekhar Pur, Khordha"],
"751017":[102,211,0.3,"Mancheswar, Khordha"],
"751018":[185,322,0.4,"Badagarh Brit Colony, Khordha"],
"751019":[92,215,0.4,"Aiginia, Khordha"],
"751020":[92,216,0.34,"Pokhariput, Khordha"],
"751021":[104,209,0.34,"Sailashree Vihar, Khordha"],
"751022":[101,201,0.34,"Bhoinagar, Khordha"],
"751023":[102,206,0.34,"S.E Rly.Proj. Complex, Khordha"],
"751024":[130,237,0.54,"Gandarpur, Khordha"],
"751025":[72,197,0.66,"G.G.P.Colony, Khordha"],
"751026":[101,219,0.31,"N.M.D Parcel Centre Bhubaneswar, Khordha"],
"751028":[92,210,0.45,"Tamando, Khordha"],
"751029":[95,204,0.37,"Mahalaxmivihar, Khordha"],
"751030":[92,212,0.39,"Khandagiri, Khordha"],
"751031":[117,245,0.5,"Kalyanpur, Khordha"],
"751032":[121,259,0.49,"Banguary, Khordha"],
"751033":[96,211,0.35,"BARAMUNDA NDC, Khordha"],
"751034":[101,217,0.32,"RASULGARH NDC, Khordha"],
"751035":[107,231,0.46,"NAHARAKANTA, Khordha"],
"752001":[253,630,0.55,"Puri, Puri"],
"752002":[252,642,0.6,"Markandeswar Sahi, Puri"],
"752003":[252,641,0.51,"Srivihar, Puri"],
"752004":[230,506,0.77,"Badagaon, Puri"],
"752010":[159,509,0.57,"Bhagabanpur, Puri"],
"752011":[167,557,0.3,"Ambapada, Puri"],
"752012":[250,650,0.58,"Bijayaramachandrapur, Puri"],
"752013":[259,621,0.51,"Ghanapana, Puri"],
"752014":[245,634,0.71,"Biraramachandrapur, Puri"],
"752015":[72,324,0.93,"Jorakani, Puri"],
"752016":[212,567,0.94,"Arisala, Puri"],
"752017":[74,330,0.52,"Garhmatiapada, Puri"],
"752018":[74,120,0.12,"Ramchandi, Khordha"],
"752019":[67,107,0.37,"Lendu, Khordha"],
"752020":[67,99,0.33,"Birakesharpur, Khordha"],
"752021":[59,100,1.03,"Abhimanpur, Khordha"],
"752022":[70,128,0.47,"Jaripada, Khordha"],
"752023":[70,129,0.39,"Chandeswar, Khordha"],
"752024":[83,127,0.38,"Champagarh, Nayagarh"],
"752025":[113,327,0.41,"Badabaramul, Nayagarh"],
"752026":[118,305,1.4,"Brajarajpur, Nayagarh"],
"752027":[90,158,0.08,"Soran, Khordha"],
"752030":[112,231,0.24,"Belapada, Khordha"],
"752031":[113,234,0.24,"Badhantuad, Khordha"],
"752032":[199,483,1.3,"Bajrakote, Puri"],
"752034":[91,202,0.63,"Baulabandha, Khordha"],
"752035":[110,212,0.23,"Harichandanpur, Khordha"],
"752037":[176,376,1.1,"Navalbasechilika, Khordha"],
"752038":[113,292,1.26,"Botalama, Khordha"],
"752045":[157,532,1.13,"Balaramapurgarh, Puri"],
"752046":[191,542,0.71,"Pattanaikia, Puri"],
"752050":[75,202,1.11,"Badatota, Khordha"],
"752054":[90,210,0.63,"Angarpada, Khordha"],
"752055":[72,197,0.66,"Khurda, Khordha"],
"752056":[70,202,0.85,"Dalatola, Khordha"],
"752057":[74,220,1.06,"Gurujanga, Khordha"],
"752060":[70,192,0.62,"Haldiapada, Khordha"],
"752061":[132,345,2.85,"Bhuasunipatna, Khordha"],
"752062":[114,411,1.1,"Barikilo, Khordha"],
"752063":[303,346,4.72,"Golapokhari, Nayagarh"],
"752064":[138,272,3.91,"Arikama, Khordha"],
"752065":[118,293,1.32,"Narendrapur, Nayagarh"],
"752066":[122,305,1.89,"Dighiri, Khordha"],
"752068":[171,515,1.38,"Champatipur, Nayagarh"],
"752069":[197,584,1.76,"Nayagarh, Nayagarh"],
"752070":[198,537,1.46,"Gotisahi, Nayagarh"],
"752077":[217,340,1.25,"Bodas, Nayagarh"],
"752078":[197,671,1.37,"Sidhamula, Nayagarh"],
"752079":[177,499,1.21,"Gambharidihi, Nayagarh"],
"752080":[199,444,0.62,"Hariharpur, Nayagarh"],
"752081":[199,317,0.36,"Banthapur, Nayagarh"],
"752082":[198,353,0.25,"Gumi, Nayagarh"],
"752083":[197,671,1.37,"Dimiripali, Nayagarh"],
"752084":[197,671,1.37,"Ghugudipada, Nayagarh"],
"752085":[200,411,0.68,"Chhamundia, Nayagarh"],
"752089":[147,340,0.29,"Nuagaon, Nayagarh"],
"752090":[242,374,0.25,"Dandor, Nayagarh"],
"752091":[80,206,0.45,"Khamarasahi, Nayagarh"],
"752092":[198,572,1.52,"Baulasahi, Nayagarh"],
"752093":[200,333,1.13,"Adakata, Nayagarh"],
"752094":[178,398,2.08,"Durdura, Nayagarh"],
"752100":[105,258,0.31,"Trahi Achyut Nagar, Khordha"],
"752101":[104,227,0.33,"Benupur, Khordha"],
"752102":[116,285,0.31,"Athantar, Khordha"],
"752103":[154,527,0.17,"Kantapada, Khordha"],
"752104":[116,299,0.58,"Bindha, Puri"],
"752105":[157,469,1.02,"Kumarpada, Puri"],
"752106":[150,506,0.3,"Taradapada, Puri"],
"752107":[158,387,0.26,"Desthali, Puri"],
"752108":[154,425,0.2,"Bhandisahi, Puri"],
"752109":[170,855,0.25,"Nagar, Puri"],
"752110":[113,432,1.37,"Siso, Puri"],
"752111":[124,327,0.68,"Junei, Puri"],
"752113":[146,339,0.15,"Tentuligaon, Puri"],
"752114":[156,525,0.39,"Dhaleswar, Puri"],
"752115":[77,180,0.71,"Bhatpatna, Khordha"],
"752116":[129,376,0.64,"Erbong, Puri"],
"752118":[146,386,0.32,"Jaleswarpada, Puri"],
"752119":[150,508,0.41,"Risol, Puri"],
"752120":[154,415,0.11,"BAHARANA, Puri"],
"752121":[146,553,1.11,"Ohal, Puri"],
"753001":[191,313,0.8,"Cuttack G.P.O., Cuttack"],
"753002":[189,310,0.8,"Chandinchowk, Cuttack"],
"753003":[194,312,1.22,"Jobra, Cuttack"],
"753004":[193,308,1.61,"O M P, Cuttack"],
"753006":[194,320,0.89,"C R R I S.O (Cuttack), Cuttack"],
"753007":[191,312,0.8,"Medical College S.O (Cuttack), Cuttack"],
"753008":[193,318,0.69,"Khatbin Sahi, Cuttack"],
"753009":[187,305,0.89,"Rajabagicha, Cuttack"],
"753010":[191,298,1.48,"O G Press, Cuttack"],
"753011":[162,282,0.77,"Khalarda, Cuttack"],
"753012":[189,298,1.35,"A D Market, Cuttack"],
"753013":[191,305,2.83,"Sri Aurobinda Marg, Cuttack"],
"753014":[191,297,0.7,"Bidanasi, Cuttack"],
"753015":[191,289,0.69,"Sector ll CDA Cuttack, Cuttack"],
"753016":[189,300,1.64,"NDC Cuttack, Cuttack"],
"754001":[122,252,0.58,"Gobabasta, Cuttack"],
"754002":[116,258,0.42,"Kantapada, Cuttack"],
"754003":[138,280,0.46,"G.Nahalpur, Cuttack"],
"754004":[160,474,0.14,"Bagalsahi, Cuttack"],
"754005":[163,257,0.64,"B G P Pur, Cuttack"],
"754006":[162,249,0.67,"Naraj, Cuttack"],
"754007":[108,204,2.33,"Padanpur, Cuttack"],
"754008":[228,369,5.74,"Ghasiput, Cuttack"],
"754009":[343,471,2.67,"Baideswar, Cuttack"],
"754010":[154,375,0.47,"Anlo, Cuttack"],
"754011":[154,420,0.44,"Adaspur, Cuttack"],
"754012":[92,201,0.41,"ASBM UNIVERSITY SOBhola, Khordha"],
"754013":[150,233,0.27,"CISF Mundali, Cuttack"],
"754018":[141,271,0.6,"Patasundarpur, Cuttack"],
"754021":[194,317,0.56,"NIMPUR, Cuttack"],
"754022":[199,319,1.59,"Kairapari, Cuttack"],
"754023":[175,197,8.04,"Bandalo, Jajapur"],
"754024":[164,253,4.16,"Barithengada, Jajapur"],
"754025":[189,333,1.05,"Harianta, Cuttack"],
"754026":[189,309,0.79,"Daulatabad S.O (Cuttack), Cuttack"],
"754027":[189,282,0.69,"Kayalpada, Cuttack"],
"754028":[200,320,0.79,"Chhagaon, Cuttack"],
"754029":[155,-1,1.34,"Athagarh, Cuttack"],
"754030":[205,428,1.48,"Bandalo, Cuttack"],
"754031":[358,541,1.63,"Badakambilo, Cuttack"],
"754032":[228,376,0.6,"Bandhahuda, Cuttack"],
"754034":[315,563,1.54,"Jodumuhan, Cuttack"],
"754035":[280,546,1.37,"Kankadajodi, Cuttack"],
"754037":[344,542,0.61,"Champeswar, Cuttack"],
"754071":[189,309,0.79,"Kapaleswar, Cuttack"],
"754082":[175,266,2.8,"BARUNIA, Jajapur"],
"754100":[189,314,0.84,"Gatiroutpatna, Cuttack"],
"754102":[164,275,0.97,"Tarikund, Jagatsinghapur"],
"754103":[160,272,1.73,"Jagatsinghpur, Jagatsinghapur"],
"754104":[160,244,1.06,"Gopalpur, Jagatsinghapur"],
"754105":[156,311,0.78,"Kulashree, Cuttack"],
"754106":[160,290,1.04,"Katara, Jagatsinghapur"],
"754107":[162,351,0.71,"Jamugaon, Jagatsinghapur"],
"754108":[162,321,0.81,"Alabol, Jagatsinghapur"],
"754109":[162,355,0.56,"Kortal, Jagatsinghapur"],
"754110":[246,540,0.45,"Janakadeipur, Jagatsinghapur"],
"754111":[161,287,0.85,"Hajipur, Jagatsinghapur"],
"754112":[189,303,0.86,"Jhinkiria Berhampur, Cuttack"],
"754113":[154,337,0.48,"Bodal, Jagatsinghapur"],
"754114":[162,279,0.93,"Nabapatna, Jagatsinghapur"],
"754119":[170,575,0.65,"Marichapur, Jagatsinghapur"],
"754120":[160,272,1.73,"Atharbanki Rly Colony, Jagatsinghapur"],
"754130":[175,289,0.67,"PRAHARRAJPUR, Cuttack"],
"754131":[192,311,0.57,"BARDA, Cuttack"],
"754132":[158,272,1.0,"Samanga, Jagatsinghapur"],
"754133":[162,233,0.79,"Patenigaon, Jagatsinghapur"],
"754134":[209,281,1.04,"Babujang, Cuttack"],
"754135":[394,889,0.0,"Kadamchhanda, Kendrapara"],
"754136":[158,262,0.7,"Harisinghpur, Jagatsinghapur"],
"754137":[154,217,0.27,"Narijanga, Jagatsinghapur"],
"754138":[158,519,0.37,"Dhunpur, Jagatsinghapur"],
"754139":[279,553,3.96,"Japabhuan, Jagatsinghapur"],
"754140":[174,381,9.76,"Anolipatna, Jagatsinghapur"],
"754141":[177,377,14.51,"Chatua, Jagatsinghapur"],
"754142":[190,450,6.92,"Barakolikhala, Jagatsinghapur"],
"754145":[202,416,7.53,"Ppl Township, Jagatsinghapur"],
"754153":[179,283,0.69,"Naindipur, Kendrapara"],
"754160":[154,311,0.3,"Gorada, Jagatsinghapur"],
"754162":[130,178,0.19,"P.Srichandanpur, Kendrapara"],
"754200":[197,329,1.42,"Gopinathpur, Cuttack"],
"754201":[182,299,2.5,"Jaripada, Cuttack"],
"754202":[189,330,1.24,"CHHANIPUR, Cuttack"],
"754203":[179,324,0.55,"GOPINATHPUR, Cuttack"],
"754204":[191,300,4.21,"DHARMADASPUR, Cuttack"],
"754205":[238,414,0.98,"Lalitgiri, Cuttack"],
"754206":[214,422,1.15,"CHAMPATIPUR, Cuttack"],
"754207":[204,406,0.99,"GOPALPUR, Cuttack"],
"754208":[219,522,1.55,"Janhimula, Kendrapara"],
"754209":[204,409,0.91,"KUSUNPUR, Cuttack"],
"754210":[217,462,1.42,"Harianka, Kendrapara"],
"754211":[230,528,1.2,"Kendrapara, Kendrapara"],
"754212":[211,509,1.31,"Balipal, Kendrapara"],
"754213":[205,464,5.22,"Ashram Balikuda, Kendrapara"],
"754214":[219,481,1.92,"Alapua, Kendrapara"],
"754215":[215,405,0.28,"Ainipara, Kendrapara"],
"754216":[230,502,2.25,"Sana Jaria, Kendrapara"],
"754217":[209,410,0.18,"Sasan, Kendrapara"],
"754218":[215,442,2.2,"Baluria, Kendrapara"],
"754219":[175,318,0.11,"Nihala, Kendrapara"],
"754220":[179,312,0.15,"Dalikainda, Kendrapara"],
"754221":[189,336,1.73,"BADAGOTHA, Cuttack"],
"754222":[211,492,1.83,"Kora, Kendrapara"],
"754223":[216,491,1.32,"Aitipur, Kendrapara"],
"754224":[190,543,9.24,"Barakanda, Kendrapara"],
"754225":[198,363,0.15,"Badanaukana, Kendrapara"],
"754227":[173,320,0.15,"Bahmanda, Kendrapara"],
"754228":[219,436,1.4,"Pundalo, Kendrapara"],
"754231":[175,330,0.09,"Areikana, Kendrapara"],
"754239":[175,353,0.16,"Kalaspur, Kendrapara"],
"754240":[214,365,1.87,"Taradapal, Kendrapara"],
"754244":[217,466,1.34,"Bandhakata, Kendrapara"],
"754245":[168,461,0.22,"Chakada Gogua, Kendrapara"],
"754246":[174,358,0.15,"Bhatapada [r], Kendrapara"],
"754248":[195,323,0.09,"Talachua, Kendrapara"],
"754250":[230,527,1.41,"Belarpur, Kendrapara"],
"754253":[181,313,1.4,"Padmapur, Kendrapara"],
"754289":[216,488,1.61,"Balia Bibhutipara, Kendrapara"],
"754290":[275,443,0.25,"Bhera, Cuttack"],
"754292":[213,386,0.86,"Chandia, Jajapur"],
"754293":[175,308,0.6,"Charirakaba, Cuttack"],
"754294":[158,281,1.29,"Sitahlo, Jagatsinghapur"],
"754295":[120,140,1.14,"Balarampur, Cuttack"],
"754296":[160,278,3.41,"Barchana, Jajapur"],
"754297":[65,202,1.12,"Oranda, Cuttack"],
"754298":[168,271,0.55,"Sirlonabagram, Cuttack"],
"754299":[177,331,2.79,"Sahangagopalpur, Cuttack"],
"755001":[209,310,0.36,"Jajpur, Jajapur"],
"755003":[275,434,0.25,"Rajapur, Jajapur"],
"755004":[264,361,-1,"Kapila, Jajapur"],
"755005":[212,332,5.22,"Arabal, Jajapur"],
"755006":[165,296,0.5,"Khosalpur, Jajapur"],
"755007":[209,291,0.11,"Khairabad, Jajapur"],
"755008":[186,309,3.85,"Kadampal, Jajapur"],
"755009":[191,332,5.0,"Bahdalpur, Jajapur"],
"755010":[255,431,5.76,"Sherpur, Jajapur"],
"755011":[177,354,0.24,"Dhanipur, Jajapur"],
"755012":[264,367,0.25,"Kalyanpur, Jajapur"],
"755013":[190,285,-1,"Chasakhanda, Jajapur"],
"755014":[240,294,0.7,"Katikata, Jajapur"],
"755015":[130,281,1.5,"Jabara, Jajapur"],
"755016":[175,280,0.06,"Jari, Jajapur"],
"755017":[185,341,2.69,"Bhurunga, Jajapur"],
"755018":[128,240,1.71,"Lembo, Jajapur"],
"755019":[135,325,0.31,"Nachhipura, Jajapur"],
"755020":[209,311,0.36,"Ferro Chrome Project, Jajapur"],
"755022":[135,301,0.32,"Dhaneswar, Jajapur"],
"755023":[125,264,1.05,"Kabatabandha, Jajapur"],
"755024":[180,298,2.75,"Neulpur, Jajapur"],
"755025":[221,420,-1,"Dulakhapatna, Jajapur"],
"755026":[120,279,0.86,"Kalinga Nagar, Jajapur"],
"755027":[240,352,0.11,"Brahamanigaon, Jajapur"],
"755028":[105,205,0.7,"Ransol, Jajapur"],
"755036":[165,375,0.45,"Mallikapur, Jajapur"],
"755043":[178,283,3.33,"Kamagarh, Jajapur"],
"755044":[154,265,2.46,"Darpanigarh, Jajapur"],
"755049":[183,320,4.64,"Khadianga, Jajapur"],
"755050":[186,304,3.88,"Jaraka, Jajapur"],
"755051":[180,330,2.1,"Adampur, Jajapur"],
"755061":[199,415,4.54,"Madhuban, Kendrapara"],
"755062":[228,311,0.11,"KHANDARA, Jajapur"],
"755063":[182,239,6.24,"Rudrapur, Jajapur"],
"756001":[144,478,1.29,"Balasore, Baleshwar"],
"756002":[149,384,1.43,"Puruna Balasore, Baleshwar"],
"756003":[142,456,1.22,"Sahupada, Baleshwar"],
"756019":[145,478,0.86,"Armala, Baleshwar"],
"756020":[171,423,0.84,"Kans, Baleshwar"],
"756021":[140,534,2.25,"Kuanrpur, Baleshwar"],
"756022":[333,961,1.18,"Barada, Baleshwar"],
"756023":[669,-1,0.67,"Debhog, Baleshwar"],
"756024":[583,643,1.57,"Nadbani, Baleshwar"],
"756025":[142,421,1.98,"Srikona, Baleshwar"],
"756026":[655,-1,0.83,"Badasimulia, Baleshwar"],
"756027":[138,484,1.76,"Bahabalpur, Baleshwar"],
"756028":[153,817,2.63,"Bamada, Mayurbhanj"],
"756029":[420,1005,1.59,"Dhobachakurai, Baleshwar"],
"756030":[155,590,0.26,"Chinchlagadia, Mayurbhanj"],
"756032":[120,246,0.12,"Jaleswar, Baleshwar"],
"756033":[125,232,0.11,"Ashabandha, Baleshwar"],
"756034":[197,269,0.56,"Ambadiha, Baleshwar"],
"756035":[166,246,0.73,"Dahunda, Baleshwar"],
"756036":[417,-1,0.5,"Alalbindha, Baleshwar"],
"756037":[585,-1,0.52,"Ausha, Baleshwar"],
"756038":[534,-1,0.62,"Adangapantei, Baleshwar"],
"756039":[403,-1,1.5,"Udayganjapatna, Baleshwar"],
"756040":[182,513,0.99,"Podasul, Baleshwar"],
"756041":[202,462,0.98,"Gopalpur, Baleshwar"],
"756042":[182,333,1.44,"Kochiakoili, Baleshwar"],
"756043":[182,471,2.21,"Boita, Baleshwar"],
"756044":[140,460,2.36,"Jagannathpur, Baleshwar"],
"756045":[150,281,0.71,"Dahisada, Baleshwar"],
"756046":[150,335,0.84,"Jagannathpur Bachhada, Bhadrak"],
"756047":[138,383,0.47,"Asuria, Baleshwar"],
"756048":[185,556,0.37,"Mahatipur, Baleshwar"],
"756049":[166,509,0.44,"Srirampur, Baleshwar"],
"756050":[156,477,0.44,"Gandibed, Baleshwar"],
"756051":[178,378,1.55,"Bishnupur, Baleshwar"],
"756055":[108,253,0.81,"Ghasua, Baleshwar"],
"756056":[145,476,1.41,"Chhanapur, Baleshwar"],
"756058":[208,449,0.63,"Arabandha, Baleshwar"],
"756059":[185,564,0.37,"Pani Chhatra, Baleshwar"],
"756060":[200,526,1.55,"Khan Nagar, Baleshwar"],
"756079":[522,-1,0.6,"Aruhabruti, Baleshwar"],
"756080":[507,887,1.78,"Badhan, Baleshwar"],
"756081":[420,705,0.55,"Putura, Baleshwar"],
"756083":[921,-1,0.78,"Baliapal Narayanpur, Baleshwar"],
"756084":[155,269,0.39,"Sugo, Baleshwar"],
"756085":[474,-1,0.47,"Naskarpur, Baleshwar"],
"756086":[175,241,0.37,"Bartana, Baleshwar"],
"756087":[120,247,0.12,"Malipal, Baleshwar"],
"756088":[163,246,0.66,"Keshpura, Baleshwar"],
"756089":[153,384,1.06,"Dharaganj, Baleshwar"],
"756100":[160,437,0.42,"Bhadrak, Bhadrak"],
"756101":[155,428,0.45,"Bandhagaon, Bhadrak"],
"756111":[160,343,0.46,"Rahanja, Bhadrak"],
"756112":[198,641,0.54,"Jalamandua, Bhadrak"],
"756113":[179,549,0.4,"Nalgira, Bhadrak"],
"756114":[248,886,0.25,"Ganijang, Bhadrak"],
"756115":[185,552,0.3,"Bartana, Baleshwar"],
"756116":[157,455,0.42,"Korkora, Bhadrak"],
"756117":[184,370,0.67,"D.B. Colony, Bhadrak"],
"756118":[186,416,0.37,"Kalyani, Bhadrak"],
"756119":[165,373,0.35,"Pandarbatia, Bhadrak"],
"756120":[202,438,0.78,"Malada, Bhadrak"],
"756121":[176,750,-1,"Babalpur, Bhadrak"],
"756122":[202,367,0.67,"Kumbharia, Bhadrak"],
"756123":[160,325,0.67,"Erada, Bhadrak"],
"756124":[163,396,0.51,"Gopaljew Sugo, Bhadrak"],
"756125":[180,274,0.57,"Adhuan, Bhadrak"],
"756126":[179,251,0.49,"Anandapur, Baleshwar"],
"756127":[186,451,0.39,"Moharampur, Bhadrak"],
"756128":[186,457,0.38,"Keshpur, Bhadrak"],
"756129":[148,307,0.47,"Ghanteswar Baliapal, Bhadrak"],
"756130":[124,368,0.41,"Balichaturi, Bhadrak"],
"756131":[159,356,0.43,"Balimeda, Bhadrak"],
"756132":[155,333,0.22,"Chardia, Bhadrak"],
"756133":[151,322,0.13,"Bouljoda, Bhadrak"],
"756134":[168,437,0.39,"Mirjapur, Baleshwar"],
"756135":[248,686,0.34,"Bodakpatna, Bhadrak"],
"756137":[176,413,0.36,"Kasimpur, Bhadrak"],
"756138":[134,354,0.22,"Nandapur, Bhadrak"],
"756139":[149,402,0.32,"Talapada, Bhadrak"],
"756144":[411,538,0.28,"Apanda, Bhadrak"],
"756162":[128,266,0.8,"Nuagaon, Bhadrak"],
"756163":[134,414,0.34,"Bilana, Bhadrak"],
"756164":[170,283,0.42,"Karanpalli, Bhadrak"],
"756165":[124,219,0.69,"Bachhipur, Bhadrak"],
"756166":[162,363,0.49,"Kalaspur, Baleshwar"],
"756167":[124,413,0.41,"Barunai, Bhadrak"],
"756168":[124,220,0.68,"Chalunigaon, Baleshwar"],
"756171":[168,310,0.17,"Kaithkhola, Bhadrak"],
"756181":[176,489,0.46,"Mouda, Bhadrak"],
"756182":[168,508,0.37,"Arakhpur, Baleshwar"],
"757001":[170,230,0.13,"Baripada, Mayurbhanj"],
"757002":[170,230,0.13,"Bhanjpur, Mayurbhanj"],
"757003":[161,228,0.14,"Damodar Pur, Mayurbhanj"],
"757014":[176,281,0.18,"Bhugudakata, Mayurbhanj"],
"757016":[155,535,0.19,"Kamardiha, Mayurbhanj"],
"757017":[132,271,1.01,"Bijipur, Mayurbhanj"],
"757018":[96,383,0.86,"Gholmuhan, Mayurbhanj"],
"757019":[99,245,0.48,"Atanati, Mayurbhanj"],
"757020":[107,448,0.15,"Baladia, Mayurbhanj"],
"757021":[175,262,0.1,"Nuagaon talakchuin, Mayurbhanj"],
"757022":[131,201,0.17,"Darudihi, Mayurbhanj"],
"757023":[102,247,0.18,"Kandana, Mayurbhanj"],
"757024":[153,264,0.21,"Gudialbandh, Mayurbhanj"],
"757025":[106,293,1.85,"Gobapal, Mayurbhanj"],
"757026":[111,286,0.82,"B. Chhelia, Mayurbhanj"],
"757027":[114,291,0.51,"Sikidia, Mayurbhanj"],
"757028":[149,533,1.26,"Nachhipuria, Mayurbhanj"],
"757029":[119,322,0.94,"Bhalia, Mayurbhanj"],
"757030":[171,241,0.23,"Kalabadia, Mayurbhanj"],
"757031":[153,160,0.37,"Bagjhumpa, Mayurbhanj"],
"757032":[174,262,0.24,"Bedhakudar, Mayurbhanj"],
"757033":[170,230,0.13,"Asana, Mayurbhanj"],
"757034":[98,156,0.31,"Durdura, Mayurbhanj"],
"757035":[160,209,1.27,"Naksara, Mayurbhanj"],
"757036":[95,187,0.3,"Baria, Mayurbhanj"],
"757037":[85,180,1.53,"Bhadubeda, Mayurbhanj"],
"757038":[130,185,0.19,"Mahuldiha, Mayurbhanj"],
"757039":[157,231,1.09,"Bramarposi, Mayurbhanj"],
"757040":[237,548,0.21,"Goudagaon, Mayurbhanj"],
"757041":[201,353,0.24,"Jaida, Mayurbhanj"],
"757042":[153,217,0.47,"Sanpakhana, Mayurbhanj"],
"757043":[153,154,0.35,"Rairangpur, Mayurbhanj"],
"757045":[170,230,0.13,"Halda, Mayurbhanj"],
"757046":[125,207,0.16,"Basingi, Mayurbhanj"],
"757047":[108,170,0.26,"Basilapir, Mayurbhanj"],
"757048":[81,205,0.41,"Ambadiha, Mayurbhanj"],
"757049":[153,246,0.19,"Kendua, Mayurbhanj"],
"757050":[125,201,0.37,"Kusumi, Mayurbhanj"],
"757051":[176,333,0.21,"Mahulbarei, Mayurbhanj"],
"757052":[134,588,1.75,"Khadikapada, Mayurbhanj"],
"757053":[185,312,0.78,"Jirei, Mayurbhanj"],
"757054":[160,261,0.41,"Soroda Jashipur, Mayurbhanj"],
"757055":[120,351,0.2,"Haripur, Mayurbhanj"],
"757056":[138,834,1.04,"ANLA, Mayurbhanj"],
"757073":[102,246,0.16,"Harekrushnapur, Mayurbhanj"],
"757074":[99,262,0.33,"Badfeni, Mayurbhanj"],
"757075":[110,288,0.2,"Chandrapur, Mayurbhanj"],
"757077":[190,434,0.18,"Manikpur, Mayurbhanj"],
"757079":[203,316,0.16,"Gour Chandra Pur, Mayurbhanj"],
"757081":[174,318,0.26,"Budama R.S., Mayurbhanj"],
"757082":[136,416,1.19,"Durgapur, Mayurbhanj"],
"757083":[125,295,0.95,"C.Mangalpur, Mayurbhanj"],
"757084":[136,224,0.26,"Baddhenkia, Mayurbhanj"],
"757085":[180,309,0.26,"Srinathpur, Mayurbhanj"],
"757086":[122,225,0.22,"Jalda, Mayurbhanj"],
"757087":[117,297,0.28,"Ambikadeipur, Mayurbhanj"],
"757091":[109,175,0.68,"Bakla, Mayurbhanj"],
"757092":[223,431,2.77,"Kundulia, Mayurbhanj"],
"757093":[170,230,0.13,"Dumurdiha, Mayurbhanj"],
"757100":[113,352,2.18,"Saria, Mayurbhanj"],
"757101":[180,335,0.19,"Bairatpur, Mayurbhanj"],
"757102":[114,307,0.28,"Pasuda, Mayurbhanj"],
"757103":[113,277,0.42,"Madhopur, Mayurbhanj"],
"757104":[99,263,0.38,"Dengam, Mayurbhanj"],
"757105":[171,249,0.19,"Aniapal, Mayurbhanj"],
"757106":[285,590,0.2,"Mahulpankha, Mayurbhanj"],
"757107":[170,226,0.17,"Patharchakuli, Mayurbhanj"],
"758001":[175,395,0.59,"Keonjhargarh, Kendujhar"],
"758002":[175,378,0.48,"Ranki, Kendujhar"],
"758013":[135,330,0.57,"Gobardhan, Kendujhar"],
"758014":[159,321,0.75,"Haladharpur, Kendujhar"],
"758015":[148,298,0.56,"Kadabahali, Kendujhar"],
"758016":[98,176,0.95,"Tanda, Kendujhar"],
"758017":[115,243,0.61,"Badagambharia, Kendujhar"],
"758018":[70,174,0.39,"Barhagarh, Kendujhar"],
"758019":[130,258,0.27,"Deoladiha, Kendujhar"],
"758020":[150,318,0.49,"Panchupally, Kendujhar"],
"758021":[146,322,0.53,"Badapadana, Kendujhar"],
"758022":[196,313,0.51,"Ambo, Kendujhar"],
"758023":[195,425,0.27,"Balibarei, Kendujhar"],
"758025":[150,293,0.39,"Bangarkota, Jajapur"],
"758026":[121,224,1.33,"Baliparbata, Kendujhar"],
"758027":[98,275,0.25,"Baiganpal, Kendujhar"],
"758028":[151,297,0.27,"Pitapiti, Kendujhar"],
"758029":[119,251,1.5,"Chinamaliposi, Kendujhar"],
"758030":[142,242,0.74,"Brahmanideo, Kendujhar"],
"758031":[126,205,0.68,"Arsala, Kendujhar"],
"758032":[126,214,1.1,"Badaneuli, Kendujhar"],
"758034":[105,190,0.51,"Jajanga, Kendujhar"],
"758035":[110,233,0.6,"Bhadrasahi, Kendujhar"],
"758036":[126,206,0.65,"Kolhabarapada, Kendujhar"],
"758037":[110,261,0.86,"Balagoda, Kendujhar"],
"758038":[148,266,0.49,"Daduan, Kendujhar"],
"758040":[115,241,0.82,"Dhanurjaypur Haramatha, Kendujhar"],
"758041":[135,290,1.01,"Chamakpur, Kendujhar"],
"758043":[150,311,0.47,"Bhaganai, Kendujhar"],
"758044":[135,229,1.85,"Badanai, Kendujhar"],
"758045":[100,193,0.79,"Jamuda, Kendujhar"],
"758046":[150,212,0.76,"Chemana, Kendujhar"],
"758047":[131,259,1.05,"Anseikala, Kendujhar"],
"758076":[97,257,0.26,"Akula, Kendujhar"],
"758078":[185,443,0.27,"Padhiaripally, Kendujhar"],
"758079":[70,304,0.26,"Hunda, Kendujhar"],
"758080":[118,328,0.42,"Billa, Kendujhar"],
"758081":[125,201,0.54,"Damahuda, Kendujhar"],
"758082":[150,270,0.37,"Alutuma, Kendujhar"],
"758083":[200,275,0.38,"Inchola, Kendujhar"],
"758084":[130,271,0.4,"Binjabahal, Kendujhar"],
"758085":[57,161,0.37,"Kadakala, Kendujhar"],
"758086":[97,201,0.74,"Dabuna, Kendujhar"],
"758087":[129,241,1.08,"Patilo, Kendujhar"],
"759001":[138,307,3.48,"Dhenkanal, Dhenkanal"],
"759013":[130,247,3.94,"Gengutia, Dhenkanal"],
"759014":[145,216,0.89,"Banasingh, Dhenkanal"],
"759015":[177,370,2.44,"Ghatipiri, Dhenkanal"],
"759016":[177,316,0.74,"Kalunigoda, Dhenkanal"],
"759017":[126,252,1.19,"Anantapur, Dhenkanal"],
"759018":[158,249,2.48,"Bhagirathipur, Dhenkanal"],
"759019":[224,451,2.23,"Bedapada, Dhenkanal"],
"759020":[245,359,0.43,"Hatura, Dhenkanal"],
"759021":[258,400,0.36,"Gandanali, Dhenkanal"],
"759022":[242,431,0.85,"Maidharpur, Anugul"],
"759023":[121,227,0.53,"Bhairpur, Dhenkanal"],
"759024":[116,198,0.88,"Odisha, Dhenkanal"],
"759025":[142,275,1.69,"Baulpur, Dhenkanal"],
"759026":[130,237,8.81,"Tumusinga, Dhenkanal"],
"759027":[145,187,2.3,"Mahulapada, Dhenkanal"],
"759028":[143,264,0.73,"Tariniposi, Dhenkanal"],
"759029":[187,374,0.41,"Chandapur, Dhenkanal"],
"759037":[256,550,0.94,"Samal Barrage Township, Anugul"],
"759039":[143,247,0.6,"Birasal, Dhenkanal"],
"759040":[256,550,0.94,"Talmul, Anugul"],
"759100":[225,532,0.8,"Gaham, Anugul"],
"759101":[240,610,1.15,"Ballahar Chhak, Anugul"],
"759102":[318,494,0.35,"Deulbera Colliery, Anugul"],
"759103":[240,625,1.12,"Badajarada, Anugul"],
"759105":[390,669,2.87,"Balipasi, Anugul"],
"759106":[240,667,1.17,"Vikrampur, Anugul"],
"759107":[238,683,0.87,"Talcher Town, Anugul"],
"759111":[256,550,0.94,"Jindal Nagar, Anugul"],
"759116":[240,609,0.89,"Balanda, Anugul"],
"759117":[245,927,0.75,"Badagundari, Anugul"],
"759118":[142,253,1.25,"Badasada, Anugul"],
"759119":[127,219,1.55,"Jamardihi, Anugul"],
"759120":[240,539,0.83,"Kankadasoda, Dhenkanal"],
"759121":[214,481,0.77,"Beruanpal, Dhenkanal"],
"759122":[256,557,1.0,"Angul, Dhenkanal"],
"759123":[241,599,1.2,"Natada, Anugul"],
"759124":[273,686,0.91,"Balipatta, Anugul"],
"759125":[185,324,0.79,"Kandhapada, Anugul"],
"759126":[222,346,0.83,"Kalyanpur, Anugul"],
"759127":[252,471,1.09,"Bimalabeda, Anugul"],
"759128":[253,509,0.98,"Arahat, Anugul"],
"759129":[244,570,1.92,"Badakantakul, Anugul"],
"759130":[273,855,0.63,"Brahmanbil, Anugul"],
"759132":[244,531,1.12,"Ankula, Anugul"],
"759141":[370,634,0.55,"Kanaloi, Anugul"],
"759143":[288,535,1.12,"Badkerjang, Anugul"],
"759145":[253,517,1.25,"Kandasar, Anugul"],
"759146":[215,567,0.82,"Gengutia, Dhenkanal"],
"759147":[240,507,0.73,"Gadasila, Anugul"],
"759148":[256,550,0.94,"Nehru Satabdi Nagar(Bharatpu), Anugul"],
"759149":[246,571,1.04,"JARAPADA, Anugul"],
"759150":[273,738,0.72,"Barihapur, Dhenkanal"],
"759151":[159,248,0.73,"Karnapal, Dhenkanal"],
"760001":[245,492,0.42,"Berhampur(GM), Ganjam"],
"760002":[230,546,0.4,"Banthapalli, Ganjam"],
"760003":[224,532,0.57,"Rangipur, Ganjam"],
"760004":[245,550,0.42,"Baidyanathpur, Ganjam"],
"760005":[245,542,0.43,"Hillpatna, Ganjam"],
"760006":[230,572,0.39,"Panigrahipentho, Ganjam"],
"760007":[244,619,0.51,"Badakusasthali, Ganjam"],
"760008":[260,562,0.42,"Industrial Estates, Ganjam"],
"760009":[230,570,0.4,"Nabeen, Ganjam"],
"760010":[260,579,0.42,"Dura, Ganjam"],
"760011":[181,358,0.45,"AMBAPUA, Ganjam"],
"761001":[230,555,0.37,"Palasi, Ganjam"],
"761002":[218,602,0.45,"Boxipalli, Ganjam"],
"761003":[260,575,0.52,"Gondala, Ganjam"],
"761004":[224,518,0.3,"Badabaranga, Ganjam"],
"761005":[172,370,0.5,"Ambapur, Ganjam"],
"761006":[198,474,0.31,"B.Nuagam, Ganjam"],
"761007":[345,909,0.61,"Guhalpur, Ganjam"],
"761008":[216,607,0.6,"Konika, Ganjam"],
"761009":[215,564,0.44,"Jhatipadar, Ganjam"],
"761010":[224,413,0.34,"Kalabada, Ganjam"],
"761011":[244,499,0.38,"Dauni, Ganjam"],
"761012":[250,980,0.56,"Sahaspur, Ganjam"],
"761013":[290,636,0.39,"J.Balabhadrapur, Ganjam"],
"761014":[345,644,0.31,"Chanamari, Ganjam"],
"761015":[168,297,0.56,"Liligada, Gajapati"],
"761016":[179,315,0.51,"Parisola, Gajapati"],
"761017":[147,244,0.84,"Antaraba, Gajapati"],
"761018":[260,537,0.55,"Chingudighai, Ganjam"],
"761019":[273,684,0.91,"Badachakada, Ganjam"],
"761020":[306,743,0.74,"Chatrapur, Ganjam"],
"761025":[251,919,0.8,"Jayashree, Ganjam"],
"761026":[258,775,1.07,"Badamadhapur, Ganjam"],
"761027":[258,1021,1.21,"Haripur Burudi, Ganjam"],
"761028":[273,693,1.87,"Golagandapalli, Ganjam"],
"761029":[226,449,0.79,"Bhejiput, Ganjam"],
"761030":[273,438,0.72,"Badhinuapalli, Ganjam"],
"761031":[271,602,0.63,"Kanchana, Ganjam"],
"761032":[327,503,0.51,"Beruanbadi, Ganjam"],
"761035":[268,490,0.67,"Burujhuri Nuagam, Ganjam"],
"761037":[224,466,0.33,"Tandipur, Ganjam"],
"761041":[306,650,0.37,"Arakhapur, Ganjam"],
"761042":[304,732,0.55,"Badadumbala, Ganjam"],
"761043":[293,746,0.31,"Chatamundali, Ganjam"],
"761045":[288,678,0.7,"Chamakhandi, Ganjam"],
"761052":[262,637,0.46,"Golabandha, Ganjam"],
"761054":[280,608,0.43,"Badiosta, Ganjam"],
"761055":[360,852,0.46,"Baritola, Ganjam"],
"761100":[297,548,0.27,"Ollarigada, Ganjam"],
"761101":[283,560,0.33,"Makarjhola, Ganjam"],
"761102":[285,608,0.34,"Chandulli, Ganjam"],
"761103":[280,603,0.4,"Mahachhai, Ganjam"],
"761104":[280,621,0.38,"Bolosara, Ganjam"],
"761105":[234,484,0.36,"Banthapalli, Ganjam"],
"761106":[246,514,0.39,"Baramundalli, Ganjam"],
"761107":[182,421,0.35,"Baradabilli, Ganjam"],
"761108":[245,393,0.34,"Gopalpursasan, Ganjam"],
"761109":[262,521,0.32,"Borada, Ganjam"],
"761110":[241,476,0.4,"Aska, Ganjam"],
"761111":[241,497,0.36,"Alipur, Ganjam"],
"761114":[210,411,0.23,"Badula, Ganjam"],
"761115":[216,466,0.34,"Debabhumi, Ganjam"],
"761116":[210,392,0.39,"Dhaninja, Ganjam"],
"761117":[193,430,0.45,"Bhatakhali, Ganjam"],
"761118":[234,439,0.32,"Manitara, Ganjam"],
"761119":[166,436,0.38,"Ambapua, Ganjam"],
"761120":[186,541,0.37,"Jhadabhumi, Ganjam"],
"761121":[263,581,0.47,"Kadua, Ganjam"],
"761122":[188,448,0.33,"Benapata, Ganjam"],
"761123":[188,408,0.38,"Bangarada, Ganjam"],
"761124":[175,424,0.36,"Benipalli, Ganjam"],
"761125":[175,309,0.25,"Bahadapadar, Ganjam"],
"761126":[184,281,0.24,"Bhanjanagar, Ganjam"],
"761131":[214,432,0.32,"Dholapita, Ganjam"],
"761132":[230,334,0.27,"G.Rambha, Ganjam"],
"761133":[175,334,0.27,"Gamundi, Ganjam"],
"761140":[168,349,0.28,"Dhumchai, Ganjam"],
"761141":[248,449,0.46,"Badangi, Ganjam"],
"761143":[263,472,0.26,"Takarada, Ganjam"],
"761144":[281,617,0.42,"Kurla, Ganjam"],
"761146":[272,552,0.39,"Thuruburai, Ganjam"],
"761151":[164,281,0.27,"Badagochha, Ganjam"],
"761200":[204,396,0.28,"Parlakhemundi, Gajapati"],
"761201":[202,333,0.31,"B.Sitapur, Gajapati"],
"761206":[184,359,0.67,"Kinigam, Gajapati"],
"761207":[152,291,0.47,"Ambajhari, Gajapati"],
"761208":[208,372,0.82,"Hadubhangi, Gajapati"],
"761209":[224,514,0.4,"Narayanapur, Ganjam"],
"761210":[204,442,0.32,"Gosani, Gajapati"],
"761211":[204,411,0.35,"Patikota, Gajapati"],
"761212":[163,278,0.34,"Jeerango, Gajapati"],
"761213":[163,287,0.33,"Kujasingi, Gajapati"],
"761214":[187,272,0.27,"Gulli, Gajapati"],
"761215":[204,488,0.42,"Adhagam, Gajapati"],
"761217":[102,185,0.24,"Siklama(Sikilima), Gajapati"],
"762001":[165,254,0.15,"Phulbani, Kandhamal"],
"762002":[152,262,0.15,"Sainipadar, Kandhamal"],
"762010":[110,162,0.18,"Beheragaon, Kandhamal"],
"762011":[135,163,0.13,"Dimbiriguda, Kandhamal"],
"762012":[195,262,0.29,"Baringi, Boudh"],
"762013":[300,519,0.39,"Ramgarh, Boudh"],
"762014":[316,469,0.52,"Brahmanpalli, Boudh"],
"762015":[274,392,0.48,"Ambajhari, Boudh"],
"762016":[283,439,0.67,"Padarpada, Boudh"],
"762017":[274,395,0.34,"Srimal, Boudh"],
"762018":[261,418,0.38,"Ambagaon, Boudh"],
"762019":[169,242,0.19,"Kainjhar, Kandhamal"],
"762020":[240,515,4.95,"Arakhapadar, Boudh"],
"762021":[77,166,-1,"Hatimunda, Kandhamal"],
"762022":[180,254,0.16,"Talarimaha, Kandhamal"],
"762023":[282,423,0.47,"Ranipathar, Boudh"],
"762024":[320,549,0.5,"Bilabadi, Boudh"],
"762026":[291,527,0.72,"Baghiapada, Boudh"],
"762027":[185,220,0.22,"Dankuni, Kandhamal"],
"762028":[159,244,0.25,"Bellapadar, Kandhamal"],
"762029":[160,242,0.16,"Keredi, Kandhamal"],
"762100":[125,245,0.12,"Dadapada, Kandhamal"],
"762101":[154,204,0.11,"Kajuri, Kandhamal"],
"762102":[108,178,0.13,"Demisingia, Kandhamal"],
"762103":[111,177,0.14,"Budrukia, Kandhamal"],
"762104":[167,240,0.1,"Badangia, Kandhamal"],
"762105":[113,188,0.14,"Kutiguda, Kandhamal"],
"762106":[123,227,0.15,"Bandaguda, Kandhamal"],
"762107":[115,192,0.15,"Lankagada, Kandhamal"],
"762109":[103,171,0.14,"Dadakangia, Kandhamal"],
"762110":[110,178,0.15,"Balakia, Kandhamal"],
"762112":[118,240,0.16,"Burbinaju, Kandhamal"],
"763001":[68,123,0.11,"Sunabeda 1, Koraput"],
"763002":[68,126,0.13,"R Zone(Sunabeda), Koraput"],
"763003":[68,121,0.11,"D.P.Camp Sunabeda, Koraput"],
"763004":[68,123,0.11,"Nad Sunabeda, Koraput"],
"763008":[103,131,0.13,"Litiguda, Koraput"],
"764001":[131,267,0.11,"Jeypore(K), Koraput"],
"764002":[131,268,0.11,"Bagderi, Koraput"],
"764003":[131,282,0.1,"Dabuguda, Koraput"],
"764004":[131,257,0.11,"Jeypore(K) Irrigation Colony, Koraput"],
"764005":[131,268,0.11,"Anta, Koraput"],
"764006":[279,395,0.71,"Bariniput, Koraput"],
"764011":[162,233,0.12,"Deoghati, Koraput"],
"764014":[245,362,0.1,"Jogipalur, Koraput"],
"764020":[122,203,0.14,"Koraput, Koraput"],
"764021":[100,183,0.14,"Mastiput, Koraput"],
"764027":[269,472,0.05,"Almonda, Koraput"],
"764028":[105,141,0.16,"Girliguma, Koraput"],
"764036":[68,133,0.14,"Hataguda, Koraput"],
"764037":[71,81,0.11,"Kadamguda, Koraput"],
"764038":[92,137,0.09,"Golur, Koraput"],
"764039":[94,143,0.11,"Chendika, Koraput"],
"764040":[235,393,0.98,"Godihanjar, Koraput"],
"764041":[75,92,0.11,"Attanda, Koraput"],
"764042":[81,118,0.49,"Upperdural, Koraput"],
"764043":[81,118,0.49,"Dandabadi, Koraput"],
"764044":[228,331,0.44,"Ambaguda, Malkangiri"],
"764045":[75,100,0.21,"Chalanguda, Malkangiri"],
"764046":[131,265,0.11,"Kadamguda, Malkangiri"],
"764047":[228,331,0.44,"Girikanpalli, Malkangiri"],
"764048":[81,118,0.49,"Malkangiri Colony, Malkangiri"],
"764049":[175,328,0.56,"Amlabhata, Nabarangpur"],
"764051":[228,330,0.44,"Dyke 1, Malkangiri"],
"764052":[77,166,-1,"Boiliguma, Malkangiri"],
"764055":[136,227,0.14,"Kusumi, Koraput"],
"764056":[113,198,0.17,"Benasur, Koraput"],
"764057":[148,172,0.2,"Narigam, Koraput"],
"764058":[95,139,0.11,"Chandili, Koraput"],
"764059":[153,225,0.19,"Jambaguda, Nabarangpur"],
"764061":[163,247,0.1,"Rajoda, Nabarangpur"],
"764062":[187,342,0.94,"Serjholi, Rayagada"],
"764063":[145,175,0.24,"Ambadola, Nabarangpur"],
"764070":[180,322,0.73,"Khuntipadar, Nabarangpur"],
"764071":[215,398,0.25,"Dengaguda, Nabarangpur"],
"764072":[186,270,0.25,"Chatiguda, Nabarangpur"],
"764073":[276,351,0.43,"Badabasini, Nabarangpur"],
"764074":[159,208,0.11,"Mohanda, Nabarangpur"],
"764075":[154,224,0.14,"Badaolama, Nabarangpur"],
"764076":[242,361,0.38,"Belagaon, Nabarangpur"],
"764077":[208,339,0.36,"Dandamunda, Nabarangpur"],
"764078":[160,251,0.36,"Dohona, Nabarangpur"],
"764081":[76,90,0.12,"Tikarpada, Koraput"],
"764085":[180,332,0.89,"Parajadeopalli, Nabarangpur"],
"764086":[164,207,0.33,"Metapoka, Malkangiri"],
"764087":[280,-1,0.02,"Maharajpalli, Malkangiri"],
"764088":[166,285,0.0,"Jodinga, Nabarangpur"],
"765001":[245,341,0.89,"Rayagada(K), Rayagada"],
"765002":[204,334,0.77,"Gajigaon, Rayagada"],
"765010":[118,236,1.07,"Kolnara, Rayagada"],
"765011":[141,354,0.43,"Chandrapur, Rayagada"],
"765013":[143,227,0.13,"Goudaguda, Koraput"],
"765015":[190,338,0.81,"Bankamba, Rayagada"],
"765016":[131,257,0.95,"Narayanpur, Rayagada"],
"765017":[121,264,1.31,"Antamoda, Rayagada"],
"765018":[118,250,0.92,"Dumuriguda, Rayagada"],
"765019":[164,249,0.32,"B.Gotiguda, Rayagada"],
"765020":[161,399,0.45,"Melachua, Rayagada"],
"765021":[161,189,0.21,"Paika Ranipinda, Rayagada"],
"765022":[183,401,0.75,"Taribili, Rayagada"],
"765023":[169,348,0.8,"Buthingi, Rayagada"],
"765024":[161,437,0.49,"Bhamini, Rayagada"],
"765025":[184,528,0.4,"Biripadar, Rayagada"],
"765026":[130,234,0.25,"Dhepaguda, Rayagada"],
"765029":[146,271,0.54,"G.Gulumunda, Rayagada"],
"765033":[184,609,0.42,"Bagusala, Rayagada"],
"765034":[174,298,0.43,"Marma, Rayagada"],
"766001":[250,392,0.47,"Bhawanipatna, Kalahandi"],
"766002":[277,412,0.66,"Bundelguda, Kalahandi"],
"766003":[242,337,0.56,"Nandol, Kalahandi"],
"766011":[277,409,0.95,"Kerokuda, Kalahandi"],
"766012":[241,448,0.74,"Hatikhoj, Kalahandi"],
"766013":[290,323,0.34,"Mingur, Kalahandi"],
"766014":[351,504,0.52,"Banijora, Kalahandi"],
"766015":[275,679,1.13,"Badfurla, Kalahandi"],
"766016":[253,566,1.13,"Sanchergaon, Kalahandi"],
"766017":[285,477,0.51,"Moter, Kalahandi"],
"766018":[300,453,0.41,"Badkutru, Kalahandi"],
"766019":[220,767,0.69,"Cowdola, Kalahandi"],
"766020":[161,260,0.34,"Pokharibandh, Kalahandi"],
"766023":[305,678,0.79,"Baldiamal, Kalahandi"],
"766026":[244,378,0.6,"Hirapur, Kalahandi"],
"766027":[179,243,0.28,"Pahadpadar, Kalahandi"],
"766028":[285,663,0.65,"Siuni, Kalahandi"],
"766029":[296,716,1.3,"Daspur, Kalahandi"],
"766031":[225,334,0.39,"Sargulmalpada, Kalahandi"],
"766032":[245,340,0.49,"Rajpur, Kalahandi"],
"766036":[221,319,0.79,"Artal, Kalahandi"],
"766037":[289,396,0.49,"Badchhatrang, Kalahandi"],
"766100":[304,518,0.54,"Bagpur, Kalahandi"],
"766101":[207,354,0.63,"Gigina, Kalahandi"],
"766102":[146,183,0.64,"Ekatara, Kalahandi"],
"766103":[205,531,0.55,"Chhanchanbahali, Kalahandi"],
"766104":[153,310,0.35,"Amsena, Nuapada"],
"766105":[153,289,0.53,"Amnara, Nuapada"],
"766106":[337,552,0.33,"Poinr, Nuapada"],
"766107":[229,380,0.45,"Goimundi, Nuapada"],
"766108":[206,455,1.4,"Chatiaguda, Nuapada"],
"766110":[304,473,0.59,"Kiding, Kalahandi"],
"766111":[266,347,0.64,"Amguda, Nuapada"],
"766118":[229,398,0.64,"Bargaon, Nuapada"],
"767001":[245,450,3.13,"Balangir, Balangir"],
"767002":[245,440,1.3,"Daspur, Balangir"],
"767016":[266,409,0.5,"Arjunda, Sonepur"],
"767017":[277,436,0.89,"Mayurudan, Sonepur"],
"767018":[260,411,0.4,"Amarpali, Sonepur"],
"767019":[232,461,0.85,"Bausuni, Sonepur"],
"767020":[209,523,0.89,"Badibahal, Balangir"],
"767021":[227,513,1.05,"Bendra, Balangir"],
"767022":[334,603,0.48,"Budula, Balangir"],
"767023":[213,392,1.0,"Bankipali, Sonepur"],
"767024":[229,360,0.56,"Baidipali, Balangir"],
"767025":[153,255,1.1,"Tamia, Balangir"],
"767026":[317,460,1.32,"Khairmal, Balangir"],
"767027":[364,723,1.14,"Barbahal, Balangir"],
"767028":[413,636,1.04,"Maharapadar, Balangir"],
"767029":[254,513,0.73,"Bhutiarbahal, Balangir"],
"767030":[245,436,0.52,"Badangomunda, Balangir"],
"767032":[262,409,0.42,"Belgaon, Balangir"],
"767033":[220,349,0.43,"Binekela, Balangir"],
"767035":[215,335,0.51,"Dedgaon, Balangir"],
"767037":[263,482,0.81,"Chalki, Balangir"],
"767038":[291,548,-1,"Fulkimunda, Balangir"],
"767039":[255,341,0.95,"Chatuanka, Balangir"],
"767040":[214,351,0.58,"Chuliphunka, Balangir"],
"767041":[153,247,1.01,"Ulba, Balangir"],
"767042":[227,416,0.32,"Gulmi, Balangir"],
"767045":[198,315,0.52,"Babupali, Sonepur"],
"767046":[216,387,0.59,"Dhanpur, Balangir"],
"767048":[176,287,1.05,"Bhundimuhan, Balangir"],
"767060":[269,458,0.77,"Mahulbahali, Balangir"],
"767061":[328,591,0.84,"Bharsuja, Balangir"],
"767062":[270,450,0.88,"Harinapali, Sonepur"],
"767065":[237,421,1.41,"Taliudar, Balangir"],
"767066":[220,340,0.48,"Naren, Balangir"],
"767067":[249,498,0.76,"Banjipali, Balangir"],
"767068":[227,408,1.02,"Chahatakhol, Sonepur"],
"767070":[280,408,0.43,"Kamarlaga, Balangir"],
"767071":[245,446,1.31,"Sauntpur, Balangir"],
"768001":[213,448,0.59,"Sambalpur, Sambalpur"],
"768002":[212,447,0.57,"Mudipara, Sambalpur"],
"768003":[206,422,0.51,"Khetrajpur, Sambalpur"],
"768004":[212,415,0.6,"Budharaja, Sambalpur"],
"768005":[218,508,0.67,"Chaurpur, Sambalpur"],
"768006":[206,368,0.49,"A.Katapali, Sambalpur"],
"768007":[213,447,0.6,"SAMBALPUR NDC, Sambalpur"],
"768016":[193,390,0.56,"Hirakud, Sambalpur"],
"768017":[204,419,0.52,"Burla, Sambalpur"],
"768018":[201,391,0.56,"Engineering College Burla, Sambalpur"],
"768019":[195,405,0.47,"Jyoti Vihar Burla, Sambalpur"],
"768020":[195,392,0.52,"Jagruti Vihar Burla, Sambalpur"],
"768024":[195,484,0.47,"Gosala Chowk, Sambalpur"],
"768025":[210,459,0.46,"Basantpur, Sambalpur"],
"768027":[210,328,0.36,"Janged, Bargarh"],
"768028":[198,525,0.51,"Bargarh, Bargarh"],
"768029":[187,347,2.49,"Bagbadi, Bargarh"],
"768030":[180,376,0.32,"Chadeigaon, Bargarh"],
"768031":[202,338,0.4,"DWARI, Bargarh"],
"768032":[208,355,0.95,"Badbausen, Bargarh"],
"768033":[260,676,0.77,"Bausenmura, Bargarh"],
"768034":[412,749,0.66,"Petupali, Bargarh"],
"768035":[340,501,0.56,"Diptipur, Bargarh"],
"768036":[357,572,0.57,"Dahigaon, Bargarh"],
"768037":[385,780,0.93,"Gourenmunda, Bargarh"],
"768038":[201,373,0.4,"Banda, Bargarh"],
"768039":[180,341,0.69,"Bartunda, Bargarh"],
"768040":[198,498,0.5,"Barhaguda, Bargarh"],
"768042":[217,365,0.56,"Guthuguda, Bargarh"],
"768045":[160,321,0.49,"Bara, Bargarh"],
"768048":[323,527,0.62,"Majhipali, Bargarh"],
"768049":[346,561,0.63,"Ganiapali, Bargarh"],
"768050":[176,354,0.55,"Jhitiki, Bargarh"],
"768052":[206,297,0.41,"Lakhanpur, Bargarh"],
"768053":[182,550,0.57,"Renaglipali Canal Colony, Bargarh"],
"768102":[202,348,0.58,"Deshbhatli, Bargarh"],
"768103":[207,422,0.49,"Dekulba, Bargarh"],
"768104":[202,473,0.56,"Areigudi, Bargarh"],
"768105":[223,295,0.58,"Birsinghgarh, Sambalpur"],
"768106":[218,276,0.73,"Jamujori, Sambalpur"],
"768107":[125,240,0.76,"Bamandagarh, Sambalpur"],
"768108":[170,305,0.8,"Dantaribahal, Deogarh"],
"768109":[226,440,0.8,"Aunli, Deogarh"],
"768110":[150,255,0.7,"Balanda, Deogarh"],
"768111":[193,410,0.47,"Lahanda, Bargarh"],
"768112":[223,430,1.15,"Dangarpara, Sambalpur"],
"768113":[224,509,0.45,"Sahaspur, Sambalpur"],
"768115":[244,430,0.61,"Rusuda, Bargarh"],
"768118":[213,448,0.6,"Naktideul, Sambalpur"],
"768119":[176,810,0.84,"Rengalbeda, Deogarh"],
"768121":[311,566,0.71,"Dholpara, Deogarh"],
"768200":[201,399,0.89,"Sangramal B. Camp, Sambalpur"],
"768201":[192,335,0.22,"Jharsuguda, Jharsuguda"],
"768202":[176,312,0.24,"Badmal, Jharsuguda"],
"768203":[192,335,0.22,"Industrial Estate Jharsuguda S, Jharsuguda"],
"768204":[148,265,0.27,"Durlaga, Jharsuguda"],
"768210":[168,434,0.28,"Thelkuli, Sambalpur"],
"768211":[160,376,0.14,"Sarandamal, Jharsuguda"],
"768212":[168,430,0.54,"Ghichamura, Sambalpur"],
"768213":[250,290,0.48,"Bhatlaida, Jharsuguda"],
"768214":[192,304,0.86,"Kenadhipa, Sambalpur"],
"768215":[140,252,1.01,"Sarangloi, Jharsuguda"],
"768216":[176,388,0.15,"Chichinda, Jharsuguda"],
"768217":[174,346,0.16,"Jorabaga, Jharsuguda"],
"768218":[167,346,0.15,"Belpahar, Jharsuguda"],
"768219":[150,256,0.25,"Bhaurkhol, Jharsuguda"],
"768220":[192,279,0.38,"Kirmira, Jharsuguda"],
"768221":[140,345,0.99,"Badumermunda, Sambalpur"],
"768222":[236,290,0.49,"Ardabahal, Sambalpur"],
"768224":[158,230,0.36,"Gardega, Sambalpur"],
"768225":[176,393,0.15,"R. Kudapali, Jharsuguda"],
"768226":[210,360,0.53,"Kandheikela, Jharsuguda"],
"768227":[255,363,0.36,"Salebhadi, Sambalpur"],
"768228":[198,246,0.35,"Lariapali, Sambalpur"],
"768233":[176,400,0.15,"Orient Colliery Brajarajnagar, Jharsuguda"],
"768234":[167,283,0.32,"N. Adhapara, Jharsuguda"],
"769001":[155,282,0.51,"Rourkela, Sundargarh"],
"769002":[154,257,0.43,"Rourkela - 2, Sundargarh"],
"769003":[154,230,0.37,"Kacharu, Sundargarh"],
"769004":[156,291,0.48,"Vedvyas, Sundargarh"],
"769005":[154,241,0.38,"Rourkela - 5, Sundargarh"],
"769006":[154,257,0.43,"Rourkela - 6, Sundargarh"],
"769007":[155,322,0.68,"Fertilizer Township, Sundargarh"],
"769008":[154,258,0.49,"Rourkela - 8, Sundargarh"],
"769009":[154,251,0.51,"Luakera, Sundargarh"],
"769010":[154,269,0.48,"Rourkela - 10, Sundargarh"],
"769011":[155,283,0.53,"Rourkela - 11, Sundargarh"],
"769012":[154,264,0.57,"Uditnagar, Sundargarh"],
"769013":[154,274,0.52,"Rourkela - 13, Sundargarh"],
"769014":[154,247,0.43,"Rourkela - 14, Sundargarh"],
"769015":[155,278,0.55,"Rourkela - 15, Sundargarh"],
"769016":[154,312,0.63,"Rourkela -16, Sundargarh"],
"769017":[154,257,0.42,"Rourkela Parcel NDC, Sundargarh"],
"769042":[153,268,0.68,"Lahanda, Sundargarh"],
"769043":[155,327,0.64,"Asurchapal, Sundargarh"],
"770001":[168,234,0.46,"Sundargarh, Sundargarh"],
"770002":[168,252,0.79,"Meghdega, Sundargarh"],
"770011":[164,264,1.79,"Tangarpali, Sundargarh"],
"770012":[194,286,0.77,"Dandpani, Sundargarh"],
"770013":[263,322,-1,"Durubaga, Sundargarh"],
"770014":[149,318,0.54,"Deogaon, Sundargarh"],
"770015":[139,251,0.52,"Birkaldihi, Sundargarh"],
"770016":[134,197,0.45,"Aludega, Sundargarh"],
"770017":[274,418,0.28,"Garbhana, Sundargarh"],
"770018":[130,206,0.4,"Latalaga, Sundargarh"],
"770019":[128,232,0.23,"Jamtalia, Sundargarh"],
"770020":[168,278,0.32,"Kulba, Sundargarh"],
"770021":[181,314,2.24,"Aunlabahal, Sundargarh"],
"770022":[140,240,1.71,"Birbira, Sundargarh"],
"770023":[158,232,0.36,"R.Kukuda, Sundargarh"],
"770024":[130,427,0.03,"R.Ratansara, Sundargarh"],
"770025":[155,294,3.06,"NTPC Darlipali, Sundargarh"],
"770031":[156,287,0.46,"Chikatmati, Sundargarh"],
"770032":[153,292,0.56,"Loco Colony Bandomunda, Sundargarh"],
"770033":[136,267,0.49,"A.Jambahal, Sundargarh"],
"770034":[179,354,0.42,"Ushra Colony, Sundargarh"],
"770035":[134,232,0.77,"Barilepta, Sundargarh"],
"770036":[137,270,0.52,"Bhalulata, Sundargarh"],
"770037":[230,364,0.42,"Banki Bazar, Sundargarh"],
"770038":[169,238,0.2,"Jakaikela, Sundargarh"],
"770039":[156,278,0.42,"Kumjharia, Sundargarh"],
"770040":[196,286,0.24,"Bimlagarh, Sundargarh"],
"770041":[111,187,0.19,"Sashyakala, Sundargarh"],
"770042":[114,197,0.68,"Tensa, Sundargarh"],
"770043":[213,313,0.24,"Kansar, Sundargarh"],
"770044":[148,253,1.1,"Mahulpada, Sundargarh"],
"770046":[124,283,0.28,"Hatibari, Sundargarh"],
"770048":[113,197,0.68,"Dengula Ashram, Sundargarh"],
"770051":[156,263,0.71,"Kulkuta, Sundargarh"],
"770052":[97,194,0.64,"Kalta, Sundargarh"],
"770070":[146,252,0.34,"Jharbeda, Sundargarh"],
"770072":[159,270,2.11,"Badbonga, Sundargarh"],
"770073":[149,228,0.78,"Bhedabahal, Sundargarh"],
"770074":[135,234,0.44,"Rouldega, Sundargarh"],
"770075":[174,320,0.28,"Ankelbira, Sundargarh"],
"770076":[211,344,0.89,"Duduka, Sundargarh"],
"781001":[111,388,0.54,"Guwahati G.P.O., Kamrup Metro"],
"781002":[111,389,0.54,"IBC Guwahati P.O, Kamrup Metro"],
"781003":[111,423,0.48,"Assam Tribune, Kamrup Metro"],
"781004":[120,401,0.52,"Kharguli, Kamrup Metro"],
"781005":[111,395,0.52,"Japorigog, Kamrup Metro"],
"781006":[111,388,0.54,"Assam Sachivalaya, Kamrup Metro"],
"781007":[120,437,0.47,"Lachitnagar, Kamrup Metro"],
"781008":[111,444,0.48,"Rehabari, Kamrup Metro"],
"781009":[111,402,0.58,"Bharalumukh, Kamrup Metro"],
"781010":[111,357,0.61,"Kamakhya, Kamrup Metro"],
"781011":[111,388,0.54,"GOTANAGAR, Kamrup Metro"],
"781012":[111,344,0.62,"Dehangarigaon, Kamrup Metro"],
"781013":[102,332,0.61,"Jalukbari, Kamrup Metro"],
"781014":[102,334,0.63,"Guwahati University, Kamrup Metro"],
"781015":[72,288,0.63,"Bongra, Kamrup Metro"],
"781016":[120,405,0.55,"Gopinathnagar, Kamrup Metro"],
"781017":[100,354,0.58,"Dharapur, Kamrup Metro"],
"781018":[135,379,0.61,"Binovanagar, Kamrup Metro"],
"781019":[120,409,0.68,"Kahilipara, Kamrup Metro"],
"781021":[136,407,0.38,"Bamunimaidan, Kamrup Metro"],
"781022":[136,457,0.42,"Khanapara, Kamrup Metro"],
"781023":[115,278,0.66,"Amerigog, Kamrup Metro"],
"781024":[120,409,0.42,"Gitanagar, Kamrup Metro"],
"781025":[120,390,0.61,"Dhirenpara, Kamrup Metro"],
"781026":[152,396,0.59,"Panikhaiti, Kamrup Metro"],
"781027":[152,403,0.58,"Amsinggaon E (S 85), Kamrup Metro"],
"781028":[120,409,0.5,"Beltola, Kamrup Metro"],
"781029":[120,415,0.47,"Pillangkata, Ri Bhoi"],
"781030":[120,334,0.64,"Rongmahal, Kamrup"],
"781031":[120,340,0.65,"Collegenagar, Kamrup"],
"781032":[136,418,0.51,"Indrapur, Kamrup Metro"],
"781033":[152,387,0.63,"Jorabat, Kamrup Metro"],
"781034":[120,382,0.65,"Odalbakra, Kamrup Metro"],
"781035":[120,346,0.61,"Garchuk, Kamrup Metro"],
"781036":[136,417,0.47,"Hengrabari, Kamrup Metro"],
"781037":[136,409,0.53,"Panjabari, Kamrup Metro"],
"781038":[120,409,0.58,"Hatigaon Chariali, Kamrup Metro"],
"781039":[102,325,0.66,"I I T, Kamrup"],
"781040":[135,390,0.65,"Sawkuchi, Kamrup Metro"],
"781101":[100,232,0.72,"Baralabari, Kamrup"],
"781102":[64,354,0.47,"Kalitakuchi, Kamrup"],
"781103":[142,280,0.45,"Bongshor, Kamrup"],
"781104":[139,272,0.46,"Bargaon, Kamrup"],
"781120":[115,278,0.66,"Rajapara, Kamrup"],
"781121":[108,403,0.61,"Halda, Kamrup"],
"781122":[150,266,0.91,"Simina, Kamrup"],
"781123":[48,75,0.33,"Durapara, Kamrup"],
"781124":[56,169,0.52,"Champaknagar, Kamrup"],
"781125":[115,288,0.71,"Kulsirange, Kamrup"],
"781126":[115,212,0.17,"Bhangnamari, Nalbari"],
"781127":[79,-1,0.12,"Kalubari, Kamrup"],
"781128":[48,129,0.16,"Agchia, Kamrup Metro"],
"781129":[56,165,0.57,"Nalapara, Kamrup"],
"781131":[111,388,0.54,"Warmawsaw, Ri Bhoi"],
"781132":[111,388,0.54,"Nahira, Kamrup"],
"781133":[102,344,0.61,"Dagaon S.O., Kamrup"],
"781134":[56,155,0.73,"Amtala, Kamrup"],
"781135":[169,278,0.17,"Pachia, Kamrup"],
"781136":[111,295,0.75,"Mahtoli, Kamrup"],
"781137":[138,251,0.43,"Mahimari, Kamrup"],
"781138":[137,381,-1,"Pachim Kajia Gaon, Nalbari"],
"781141":[111,388,0.54,"Choudhurykhat, Kamrup"],
"781150":[152,373,0.61,"Gobardhan, Kamrup Metro"],
"781171":[136,370,0.58,"Patharquerry, Kamrup Metro"],
"781301":[170,305,2.52,"Barpeta, Barpeta"],
"781302":[137,381,-1,"Barghol, Barpeta"],
"781303":[137,381,-1,"Batsar, Nalbari"],
"781304":[137,381,-1,"Dirua, Nalbari"],
"781305":[157,376,6.53,"Makrikuchi, Barpeta"],
"781306":[137,381,-1,"Gamerimuri, Nalbari"],
"781307":[156,310,2.39,"Byaskuchi, Barpeta"],
"781308":[170,305,2.51,"Chakabausi, Barpeta"],
"781309":[160,331,3.42,"Keotkuchi, Barpeta"],
"781310":[134,286,0.15,"Khakharisal, Nalbari"],
"781311":[170,304,2.53,"Bhairaguri, Barpeta"],
"781312":[125,213,0.99,"Raumaripathar, Nalbari"],
"781313":[68,99,0.7,"Guagacha, Barpeta"],
"781314":[170,304,2.53,"Ganakkuchi, Barpeta"],
"781315":[170,304,2.53,"Gobardhana, Barpeta"],
"781316":[187,279,2.31,"Jasihatipara, Barpeta"],
"781317":[177,252,1.25,"Amguri, Barpeta"],
"781318":[167,312,2.56,"Barbhitha Dolarpathar, Barpeta"],
"781319":[80,100,0.74,"Bankubhanga, Barpeta"],
"781320":[167,312,2.56,"Barmazra, Barpeta"],
"781321":[74,103,0.82,"DP Deoldi, Barpeta"],
"781325":[143,240,3.17,"Amdah, Bajali"],
"781326":[154,343,3.39,"Bamunkuchi, Bajali"],
"781327":[171,305,2.95,"Anchali, Baksa"],
"781328":[168,311,2.78,"Kathalmurighat, Bajali"],
"781329":[156,338,3.4,"Akaya, Barpeta"],
"781330":[170,304,2.53,"Barghogra, Baksa"],
"781333":[140,354,0.36,"Thanguri, Baksa"],
"781334":[125,213,0.99,"Niz Bahjani, Nalbari"],
"781335":[140,349,0.36,"Nalbari, Nalbari"],
"781337":[139,326,0.56,"Chengnoi, Nalbari"],
"781338":[137,381,-1,"Bori, Nalbari"],
"781339":[126,238,0.54,"Arikuchi, Nalbari"],
"781340":[140,350,0.36,"Khukhundi, Nalbari"],
"781341":[135,280,0.15,"Burinagar, Nalbari"],
"781343":[140,354,0.36,"Dighaldonga, Baksa"],
"781344":[144,308,0.36,"Angardhowa, Baksa"],
"781346":[149,336,2.35,"Barsimlaguri, Baksa"],
"781347":[127,250,0.54,"Athgharia, Nalbari"],
"781348":[138,274,0.25,"Bagalsroad Chowk, Nalbari"],
"781349":[144,317,0.36,"Balitara, Nalbari"],
"781350":[148,335,0.27,"Barenghati, Nalbari"],
"781351":[137,381,-1,"Baridatara, Nalbari"],
"781352":[170,304,2.53,"Naligaon, Barpeta"],
"781353":[137,381,-1,"Sandheli, Nalbari"],
"781354":[111,388,0.54,"Dhepargaon, Kamrup"],
"781355":[140,350,0.36,"Geruapara, Baksa"],
"781360":[140,349,0.36,"Darangamela, Baksa"],
"781364":[135,181,1.4,"Bangalipara, Baksa"],
"781365":[76,153,3.05,"Bihapara, Baksa"],
"781366":[137,295,0.83,"Baghdoba, Baksa"],
"781367":[152,420,0.2,"Kalakuchi, Baksa"],
"781368":[125,211,1.07,"Bagrikhuti, Baksa"],
"781369":[145,324,0.35,"Nankarbhaira, Nalbari"],
"781370":[137,381,-1,"Gobradal, Nalbari"],
"781371":[123,213,2.32,"Bhaluki, Bajali"],
"781372":[149,336,2.35,"Banbari, Baksa"],
"781373":[141,347,0.36,"Barchakadal, Baksa"],
"781374":[147,265,2.3,"Bhojkuchi, Nalbari"],
"781375":[125,213,0.99,"Golibandha, Bajali"],
"781376":[191,410,0.04,"Tulsibari, Kamrup"],
"781377":[125,213,0.99,"Lafakuchi, Baksa"],
"781378":[137,381,-1,"Bali, Nalbari"],
"781380":[68,193,1.52,"Hinguli, Kamrup"],
"781381":[102,205,0.9,"Pingaleswar, Kamrup"],
"781382":[101,193,2.08,"Japia, Kamrup"],
"782001":[195,375,1.08,"Nagaon, Nagaon"],
"782002":[195,418,1.22,"Aibheti, Nagaon"],
"782003":[195,406,1.22,"Dimaruguri, Nagaon"],
"782101":[95,161,0.1,"Biharigaon, Nagaon"],
"782102":[195,406,1.22,"Nibukali, Nagaon"],
"782103":[148,353,0.45,"Barapujia, Nagaon"],
"782104":[150,270,0.49,"Kachadhara Nakhanda, Marigaon"],
"782105":[150,269,0.48,"Bangalpara, Marigaon"],
"782106":[150,270,0.49,"Chabukdhara, Marigaon"],
"782120":[195,406,1.22,"Borghuli Sapmar, Nagaon"],
"782121":[195,406,1.22,"Haloakanda, Marigaon"],
"782122":[195,406,1.22,"Amlakhi, Nagaon"],
"782123":[154,276,0.47,"Borbheti Dhing, Nagaon"],
"782124":[195,455,1.02,"Mithapukhuripar, Nagaon"],
"782125":[185,396,0.93,"Barghat, Nagaon"],
"782126":[153,437,0.29,"Datialbori, Marigaon"],
"782127":[158,607,0.6,"Katanigaon, Marigaon"],
"782128":[195,375,1.08,"Kaliadinga, Nagaon"],
"782135":[196,398,1.06,"Parkup Pahar, Nagaon"],
"782136":[132,245,1.94,"Burapahar, Nagaon"],
"782137":[159,324,0.57,"Bengenaati, Nagaon"],
"782138":[195,406,1.22,"Amoni, Nagaon"],
"782139":[195,406,1.22,"Barjuri, Nagaon"],
"782140":[196,421,0.92,"Bajiagaon, Nagaon"],
"782141":[196,476,1.02,"Barpanigaon, Nagaon"],
"782142":[160,348,-1,"Barchila, Nagaon"],
"782143":[158,329,0.6,"Bhomoraguri, Nagaon"],
"782144":[185,269,0.75,"Ghahibhatikuri, Nagaon"],
"782401":[80,366,0.62,"Panbari, Kamrup Metro"],
"782402":[115,250,0.62,"Nartap, Kamrup Metro"],
"782403":[111,388,0.54,"Durungpahar, Kamrup Metro"],
"782410":[139,269,0.39,"Dayang Beloguri, Marigaon"],
"782411":[195,406,1.22,"Burgaon, Marigaon"],
"782412":[128,237,0.4,"Ahatguri, Marigaon"],
"782413":[195,406,1.22,"Umpanai, West Karbi Anglong"],
"782425":[150,226,0.28,"Beltola, Nagaon"],
"782426":[154,238,0.64,"Ghilani, Nagaon"],
"782427":[155,303,0.46,"Jumurmur, Nagaon"],
"782428":[135,235,0.45,"Jungle Block, Hojai"],
"782429":[195,406,1.22,"Sibpur, Hojai"],
"782435":[195,375,1.08,"Golaghatiabasti, Hojai"],
"782436":[190,281,0.22,"Rabindranath Tagore University, Karbi Anglong"],
"782439":[195,406,1.22,"Samarail, Hojai"],
"782440":[80,153,0.7,"Changmaji, Hojai"],
"782441":[70,134,0.6,"Baghpani, Karbi Anglong"],
"782442":[196,387,1.07,"Bhalukmari, Hojai"],
"782445":[109,175,0.5,"Joynagar Madrassa, Hojai"],
"782446":[195,375,1.08,"Fultoli Bazar, Hojai"],
"782447":[195,375,1.08,"Harlongpher, Hojai"],
"782448":[40,185,0.34,"Amrang, West Karbi Anglong"],
"782450":[137,240,0.18,"Tikahill, West Karbi Anglong"],
"782460":[82,284,0.37,"Diphu, Karbi Anglong"],
"782461":[82,284,0.37,"Amlakhi Bazar, Karbi Anglong"],
"782462":[82,284,0.37,"Dewanbasti, Karbi Anglong"],
"782470":[71,-1,0.1,"Tengelijan, Karbi Anglong"],
"782480":[125,191,0.17,"Deithor, Karbi Anglong"],
"782481":[82,278,0.38,"Bobilgaon, Karbi Anglong"],
"782482":[82,278,0.38,"Lorenthepi, Karbi Anglong"],
"782485":[133,260,0.15,"Langminso, West Karbi Anglong"],
"782486":[190,231,0.26,"Khanduli, West Karbi Anglong"],
"782490":[142,295,0.31,"Bogijan, Karbi Anglong"],
"783101":[80,-1,0.34,"Goalpara Head Post Office, Goalpara"],
"783120":[55,70,0.55,"Dwarka, Goalpara"],
"783122":[78,132,0.43,"Nishangram, Goalpara"],
"783123":[101,137,0.1,"Chekowary, Goalpara"],
"783124":[78,128,0.43,"Darakh, Goalpara"],
"783125":[66,72,0.3,"Matia Bazar, Goalpara"],
"783126":[25,52,0.38,"Dhaigaon, Goalpara"],
"783127":[76,101,0.24,"Sarkarergaon, South Salmara Mancachar"],
"783128":[69,117,0.47,"Hazirhat, South Salmara Mancachar"],
"783129":[74,105,0.5,"Balarbhita, Goalpara"],
"783130":[78,133,0.43,"Dhanubhanga, Goalpara"],
"783131":[93,172,0.45,"Barkona, South Salmara Mancachar"],
"783132":[75,100,0.3,"Dhumerghat, Dhubri"],
"783133":[54,60,0.43,"Rajapara, Goalpara"],
"783134":[69,117,0.47,"Melopara, Goalpara"],
"783135":[64,96,0.7,"Fekamari, South Salmara Mancachar"],
"783136":[147,309,0.18,"Manullapara, South Salmara Mancachar"],
"783301":[87,139,2.65,"Dhubri, Dhubri"],
"783323":[71,116,0.71,"Dhubri Balurchar, Dhubri"],
"783324":[80,116,0.42,"Howrarpar, Dhubri"],
"783325":[74,117,0.48,"Falimari Pt i, Dhubri"],
"783330":[96,139,1.16,"Airkata Bazar, Dhubri"],
"783331":[83,129,0.67,"Madhusoulmari, Dhubri"],
"783332":[100,130,1.59,"Paglahat, Dhubri"],
"783333":[125,209,0.13,"Grahampur, Kokrajhar"],
"783334":[91,134,0.47,"Kacharihat, Dhubri"],
"783335":[150,229,0.11,"Kaldoba, Dhubri"],
"783336":[193,437,0.07,"Binnyakhata, Kokrajhar"],
"783337":[141,289,1.84,"Bashbari, Dhubri"],
"783339":[100,136,2.92,"Geramari, Dhubri"],
"783345":[100,131,1.74,"Lakhiganj Bazar, Kokrajhar"],
"783346":[190,444,0.9,"Athiabari, Kokrajhar"],
"783347":[190,292,0.07,"Dumeriguri, Kokrajhar"],
"783348":[100,142,1.62,"Chirakuti Pt i, Dhubri"],
"783349":[100,122,3.84,"Sukhanjhora, Dhubri"],
"783350":[157,388,0.37,"JONALIGAON FV, Kokrajhar"],
"783354":[161,333,1.68,"Mainaguri, Kokrajhar"],
"783360":[167,374,0.17,"Anthaibari, Kokrajhar"],
"783361":[141,223,0.17,"Jaraguri, Kokrajhar"],
"783369":[130,203,0.63,"Kalipukhuri, Kokrajhar"],
"783370":[190,277,0.07,"Kokrajhar, Kokrajhar"],
"783371":[79,95,0.31,"Raijhora Bahalpur, Dhubri"],
"783372":[148,276,0.9,"Bilaspur, Chirang"],
"783373":[148,373,0.9,"Champabati Bazar, Chirang"],
"783375":[169,578,0.9,"Deosiri, Chirang"],
"783376":[35,82,1.22,"Dabargaon, Kokrajhar"],
"783380":[148,309,0.09,"Dongaigaon, Bongaigaon"],
"783381":[148,292,0.09,"Simlaguri, Bongaigaon"],
"783382":[66,103,1.32,"Malegarh, Bongaigaon"],
"783383":[90,125,0.87,"Ghilaguri, Bongaigaon"],
"783384":[68,113,0.77,"B.S.Gram, Bongaigaon"],
"783385":[146,311,0.47,"Dhaligaon, Chirang"],
"783386":[148,325,0.9,"Kajalgaon, Chirang"],
"783388":[25,55,0.39,"Chalantapara, Bongaigaon"],
"783389":[239,456,0.03,"Kayetpara, Bongaigaon"],
"783390":[131,224,0.6,"Chatianguri, Chirang"],
"783391":[164,263,0.56,"Monakocha, Chirang"],
"783392":[139,223,0.72,"Adlaguri, Bongaigaon"],
"783393":[175,365,0.61,"Amguri Bazar, Chirang"],
"783394":[204,423,0.9,"Ouguri, Chirang"],
"784001":[116,235,0.16,"Tezpur, Sonitpur"],
"784010":[153,250,0.18,"Tezpur Medical College, Sonitpur"],
"784025":[110,213,1.56,"Singitoli, Sonitpur"],
"784026":[90,186,1.17,"Khalihamari, Sonitpur"],
"784027":[110,191,2.46,"Dolabari, Sonitpur"],
"784028":[96,200,1.32,"Napaam, Sonitpur"],
"784101":[75,185,0.2,"Ameribari, Sonitpur"],
"784102":[92,216,0.16,"Sonaipam, Sonitpur"],
"784103":[75,192,0.18,"Gamani, Sonitpur"],
"784104":[110,218,0.19,"Haleswar, Sonitpur"],
"784105":[92,199,0.17,"Bokajan, Sonitpur"],
"784110":[87,150,1.51,"Chitalmari, Sonitpur"],
"784111":[105,207,0.19,"Gormara, Sonitpur"],
"784112":[83,147,1.36,"Orientoli, Sonitpur"],
"784113":[152,535,2.85,"Dalakati Borobazar, Udalguri"],
"784114":[150,232,0.32,"Dhansiri Bazar, Udalguri"],
"784115":[160,311,1.86,"Kharupetiaghat Bazar, Darrang"],
"784116":[121,237,0.39,"Jangalpara, Darrang"],
"784117":[105,144,2.34,"Balipukhuri Joradia, Sonitpur"],
"784125":[135,260,1.23,"Mangaldoi, Darrang"],
"784144":[152,350,6.69,"Barampur, Darrang"],
"784145":[152,352,4.91,"Byaspara, Darrang"],
"784146":[152,318,3.18,"Minapara, Darrang"],
"784147":[105,153,0.55,"Burhi Nagar, Darrang"],
"784148":[122,225,5.3,"Hengalpara, Darrang"],
"784149":[103,180,0.39,"Kalakuchi, Sonitpur"],
"784150":[113,214,0.71,"Da Besseria, Sonitpur"],
"784153":[110,191,2.46,"Bapubheti, Sonitpur"],
"784154":[116,236,0.16,"Nikamul Satra, Sonitpur"],
"784160":[159,284,0.22,"Joriguri, Lakhimpur"],
"784161":[138,160,1.29,"Laholial, Lakhimpur"],
"784163":[138,214,1.02,"Barbali, Lakhimpur"],
"784164":[60,178,2.08,"Bordeurigaon, Lakhimpur"],
"784165":[160,218,3.6,"Simaluguri, Lakhimpur"],
"784166":[153,250,0.18,"Behali, Biswanath"],
"784167":[75,155,2.02,"Rampur Darrang, Biswanath"],
"784168":[125,257,11.41,"Gobinda Elengisatra, Biswanath"],
"784169":[110,191,2.46,"Kamdewal, Biswanath"],
"784170":[116,235,0.75,"Amlakhi Dalani, Biswanath"],
"784171":[81,150,10.02,"Daflagarh, Biswanath"],
"784172":[84,164,6.62,"Bakori Doloni, Biswanath"],
"784173":[96,213,2.76,"Tinikhuti, Biswanath"],
"784174":[75,171,2.0,"Balichang, Biswanath"],
"784175":[90,176,1.82,"Bokabil, Biswanath"],
"784176":[132,235,0.53,"Burigong, Biswanath"],
"784177":[139,218,0.59,"Solemari No.1, Biswanath"],
"784178":[99,194,0.26,"Alupara, Biswanath"],
"784179":[57,89,6.4,"Janata, Biswanath"],
"784180":[96,173,3.19,"Gameripal, Sonitpur"],
"784182":[89,185,1.33,"Bakola, Sonitpur"],
"784184":[153,259,0.32,"Bharali Juli, Biswanath"],
"784189":[153,250,0.18,"Nagsankar, Biswanath"],
"784190":[94,324,7.39,"Shamtilla, Udalguri"],
"784501":[92,194,0.23,"Rangapukhuri, Sonitpur"],
"784502":[113,237,0.15,"Manijharni, Sonitpur"],
"784504":[90,187,1.21,"Phulaguri, Sonitpur"],
"784505":[92,218,0.16,"Kailajuli, Sonitpur"],
"784506":[94,203,0.26,"Garubandha, Sonitpur"],
"784507":[129,318,3.27,"Batabari, Udalguri"],
"784508":[118,153,3.29,"Bhalukmari, Udalguri"],
"784509":[138,405,1.02,"Garaibari, Udalguri"],
"784510":[119,492,1.66,"No.1 Amjuli, Udalguri"],
"784513":[135,390,7.65,"Bhairakunda, Udalguri"],
"784514":[80,215,8.31,"Padupuri Mazgaon, Darrang"],
"784521":[100,118,3.8,"Mechakapukhuri, Udalguri"],
"784522":[105,129,2.47,"Panishali, Udalguri"],
"784523":[164,629,0.16,"Kachubilhat, Udalguri"],
"784524":[97,204,0.24,"Ghograbazar, Udalguri"],
"784525":[114,249,9.5,"Kabir Ali, Udalguri"],
"784526":[90,106,0.93,"Kalikhola, Udalguri"],
"784527":[134,169,0.52,"Khagrabari, Udalguri"],
"784528":[110,191,2.46,"Dhopguri, Udalguri"],
"784529":[135,375,5.21,"Chamuapara, Darrang"],
"785001":[45,223,0.49,"Jorhat, Jorhat"],
"785004":[84,158,0.63,"Chalihagaon, Jorhat"],
"785006":[45,142,9.58,"Bor Ahom Kathani, Jorhat"],
"785007":[128,284,2.85,"Itakhuli, Jorhat"],
"785008":[56,134,7.06,"Lichubari, Jorhat"],
"785009":[126,310,2.38,"Bajalani Kohar, Jorhat"],
"785010":[140,313,2.26,"Sotai, Jorhat"],
"785013":[45,129,9.58,"Assam Agriculture University, Jorhat"],
"785014":[67,138,1.15,"Bongalpukhuri, Jorhat"],
"785015":[126,285,2.84,"Desoinagar, Jorhat"],
"785101":[130,272,2.57,"Chowkhat, Jorhat"],
"785102":[45,142,9.58,"Chumaimari Missing Gaon, Majuli"],
"785104":[76,170,7.27,"Bargayan, Majuli"],
"785105":[45,142,9.58,"Karki Chuk Missing Gaon, Majuli"],
"785106":[69,172,7.81,"Potiagaon, Majuli"],
"785107":[126,259,2.87,"Kakajan Duliagaon, Jorhat"],
"785108":[140,310,2.31,"Nahatia, Jorhat"],
"785110":[45,142,9.58,"Gayengaon, Majuli"],
"785111":[139,281,2.35,"Purani Gohaingaon, Jorhat"],
"785112":[116,246,3.14,"Bormathauri, Jorhat"],
"785601":[85,347,0.27,"Rajapukhuri, Golaghat"],
"785602":[103,259,0.54,"Dapathar, Golaghat"],
"785603":[120,268,0.7,"Barua Gaon, Golaghat"],
"785609":[68,169,5.15,"Hatikhuli, Golaghat"],
"785610":[118,313,1.04,"Borjan, Golaghat"],
"785611":[70,153,0.71,"Nakkati, Golaghat"],
"785612":[70,99,1.27,"Borjuri, Golaghat"],
"785613":[87,165,1.79,"Bokial, Golaghat"],
"785614":[81,173,6.27,"Dani Chapori, Golaghat"],
"785615":[95,196,3.73,"Karuabahi Satra, Golaghat"],
"785616":[100,240,0.09,"Charaibahi, Jorhat"],
"785618":[95,265,2.06,"Haladhibari, Golaghat"],
"785619":[120,250,2.88,"Mohoramukh, Golaghat"],
"785621":[120,250,2.88,"Golaghat, Golaghat"],
"785622":[67,137,0.59,"Rahdhala, Golaghat"],
"785625":[140,289,2.64,"Salikihaat, Golaghat"],
"785626":[117,252,2.83,"Hatiekhowa, Golaghat"],
"785630":[52,206,2.67,"Baruajan, Jorhat"],
"785631":[66,217,1.27,"Kakodonga Bekajan, Jorhat"],
"785632":[103,272,2.03,"Chakial, Jorhat"],
"785633":[90,170,0.1,"Bahoni, Jorhat"],
"785634":[45,143,9.58,"Nagajanka, Jorhat"],
"785635":[56,152,4.91,"Chungi Lahing, Jorhat"],
"785636":[65,169,5.09,"Gabharu Konwargaon, Jorhat"],
"785640":[285,508,0.86,"Sivasagar, Sivasagar"],
"785661":[146,319,0.09,"Hafaluting, Sivasagar"],
"785662":[123,206,0.84,"Konwar Dihingia, Sivasagar"],
"785663":[169,369,0.19,"Betena, Sivasagar"],
"785664":[68,139,5.78,"Dekhowmukh, Sivasagar"],
"785665":[77,166,4.83,"Rudrasagar, Sivasagar"],
"785666":[77,169,4.72,"Mogorahat, Sivasagar"],
"785667":[148,335,0.27,"Baliaghat, Sivasagar"],
"785669":[81,191,3.5,"Mohkhuti, Sivasagar"],
"785670":[123,156,0.67,"Photikachowa, Charaideo"],
"785671":[115,182,-1,"Dihing Mukh, Sivasagar"],
"785672":[135,198,0.9,"Charagua, Sivasagar"],
"785673":[86,173,0.16,"Dubba, Charaideo"],
"785674":[78,152,0.16,"Bokota Chand Bessa, Sivasagar"],
"785675":[152,171,0.27,"Dihingia Gaon, Dibrugarh"],
"785676":[152,171,0.27,"Erameshlow Gaon, Dibrugarh"],
"785680":[187,382,2.5,"SAMAGURI, Sivasagar"],
"785681":[95,235,0.09,"Dopdhar, Sivasagar"],
"785682":[94,190,4.21,"Amtoll Chintamoni, Jorhat"],
"785683":[102,198,4.16,"Phulpanichiga, Sivasagar"],
"785684":[77,170,4.7,"Chetia Gaon, Sivasagar"],
"785685":[290,523,0.82,"Bamunpukhuri, Sivasagar"],
"785686":[237,374,1.14,"Tengapukhuri, Sivasagar"],
"785687":[300,552,0.75,"Bihubar, Sivasagar"],
"785688":[105,226,-1,"Khaloighogora, Charaideo"],
"785690":[290,523,0.82,"Aideopukhuri, Charaideo"],
"785691":[79,149,0.55,"Borahigaon, Charaideo"],
"785692":[100,109,6.74,"Chotianaguri, Charaideo"],
"785693":[168,350,6.74,"Barpatra Te, Charaideo"],
"785696":[115,182,-1,"Deogharia, Sivasagar"],
"785697":[275,481,0.93,"Amkotia, Sivasagar"],
"785699":[80,159,1.52,"Kanaighat, Golaghat"],
"785700":[133,270,2.6,"Dhekiakhowa, Jorhat"],
"785701":[90,161,0.59,"Daya Chariali, Sivasagar"],
"785702":[112,255,2.76,"Falangani, Golaghat"],
"785703":[120,250,2.88,"Fetagaon, Golaghat"],
"785704":[278,459,1.27,"Murmuria, Jorhat"],
"785705":[131,335,0.97,"Gomariguri, Golaghat"],
"786001":[119,164,0.43,"Dibrugarh, Dibrugarh"],
"786002":[117,190,0.39,"Hiloidhari, Dibrugarh"],
"786003":[128,196,0.36,"Banipur, Dibrugarh"],
"786004":[150,212,0.34,"Bogibil, Dibrugarh"],
"786006":[91,143,0.56,"Lepetkata, Dibrugarh"],
"786007":[173,363,6.74,"Balaibari, Dibrugarh"],
"786008":[129,198,0.35,"Raja Bheta, Dibrugarh"],
"786010":[122,174,0.34,"Konwaripathar, Dibrugarh"],
"786012":[122,177,0.34,"Naga Ghuli Kanaigaon, Dibrugarh"],
"786101":[120,169,0.38,"Alimur, Dibrugarh"],
"786102":[223,415,1.36,"Chabua Air Field, Dibrugarh"],
"786103":[242,482,0.32,"Chenibill Chungipathar, Dibrugarh"],
"786125":[368,827,0.33,"Tinsukia, Tinsukia"],
"786126":[150,251,0.31,"Gellapukhuri, Tinsukia"],
"786145":[366,812,1.65,"Sripuria Bengali Gaon, Tinsukia"],
"786146":[95,264,2.05,"Chalihanagar, Tinsukia"],
"786147":[165,268,0.35,"Limbuguri, Tinsukia"],
"786148":[240,440,0.51,"Khetopathergaon, Tinsukia"],
"786150":[161,269,0.58,"Santipur, Tinsukia"],
"786151":[312,677,0.29,"Dighal Tarrang, Tinsukia"],
"786152":[104,200,1.24,"Tonganabazar, Tinsukia"],
"786153":[323,691,0.36,"Rupaisiding, Tinsukia"],
"786154":[135,229,0.53,"Hahkhati, Tinsukia"],
"786155":[197,322,0.51,"Sadiya, Tinsukia"],
"786156":[206,337,0.55,"Laupati, Tinsukia"],
"786157":[440,1516,-1,"Amarpur, Tinsukia"],
"786158":[440,1516,-1,"Kukuremara, Tinsukia"],
"786159":[145,247,0.7,"Netaji Road, Tinsukia"],
"786160":[92,147,1.11,"Amguri, Tinsukia"],
"786170":[180,288,0.51,"Borgaon, Tinsukia"],
"786171":[113,157,1.01,"Balijan, Tinsukia"],
"786173":[128,284,2.85,"Jubilee Digboi, Tinsukia"],
"786174":[113,157,1.01,"Kathalguri, Tinsukia"],
"786179":[82,136,0.39,"Challet, Tinsukia"],
"786181":[119,210,1.44,"Lamagaon, Tinsukia"],
"786182":[110,191,1.5,"Udai Pur, Tinsukia"],
"786183":[150,246,0.24,"Gahoripam, Tinsukia"],
"786184":[117,153,0.17,"Hatiali Siding, Dibrugarh"],
"786187":[124,220,1.4,"Agbandha Bengali Gaon, Tinsukia"],
"786188":[69,184,1.33,"Rampur, Tinsukia"],
"786189":[113,163,1.16,"Bindhakata, Dibrugarh"],
"786190":[150,254,0.31,"Samdang, Tinsukia"],
"786191":[292,622,0.3,"Kamini Tea Estate, Dibrugarh"],
"786192":[192,617,0.31,"Dihingia Gaon, Tinsukia"],
"786601":[150,262,0.34,"Balijan T.E., Tinsukia"],
"786602":[332,717,0.35,"Jaloni Dibruduar, Dibrugarh"],
"786610":[546,1309,2.43,"Bamunibill, Dibrugarh"],
"786611":[286,577,4.2,"Dangopara Chariali, Dibrugarh"],
"786612":[394,877,4.2,"Garguri, Dibrugarh"],
"786613":[143,157,0.41,"Borpathar, Dibrugarh"],
"786614":[546,1309,2.43,"Jeypore Mobile, Dibrugarh"],
"786621":[243,564,2.03,"Ashabam, Dibrugarh"],
"786622":[91,144,0.56,"Namrup Thermal Power Station, Dibrugarh"],
"786623":[238,553,1.83,"Parbatpur, Dibrugarh"],
"786692":[313,664,0.35,"Anandapara, Dibrugarh"],
"787001":[60,167,2.05,"North Lakhimpur, Lakhimpur"],
"787023":[126,275,2.25,"Doolahat, Lakhimpur"],
"787026":[62,104,0.42,"Salmari No.2, Dhemaji"],
"787031":[60,178,2.08,"Azad, Lakhimpur"],
"787032":[121,172,0.34,"Borkhelia, Lakhimpur"],
"787033":[123,179,0.34,"Deotala, Lakhimpur"],
"787034":[172,345,0.43,"Na Nadi Bhebeli Kahcari Gaon, Dhemaji"],
"787035":[297,617,0.44,"Kayam Borpathar, Dhemaji"],
"787051":[179,419,2.1,"Joyhing Te, Lakhimpur"],
"787052":[82,167,3.62,"Garchiga, Lakhimpur"],
"787053":[56,82,0.42,"Deuliagaon, Lakhimpur"],
"787054":[60,178,2.08,"Bor Alengi Satra, Lakhimpur"],
"787055":[64,104,0.42,"Bokulguri, Lakhimpur"],
"787056":[406,849,0.44,"Katri Chapori, Lakhimpur"],
"787057":[82,159,0.44,"Aradhal, Dhemaji"],
"787058":[64,97,0.41,"Bengenagarah, Dhemaji"],
"787059":[67,107,0.42,"Betanipam, Dhemaji"],
"787060":[118,204,0.28,"Kabu Chapori, Dhemaji"],
"787061":[24,65,0.48,"Somkong Pagar, Dhemaji"],
"787110":[84,141,0.44,"Kerekani Majgaon, Dhemaji"],
"788001":[120,191,1.62,"Silchar, Cachar"],
"788002":[120,191,1.56,"Haticherra Grant PT VII, Cachar"],
"788003":[151,301,1.8,"Topkhana, Cachar"],
"788004":[145,300,1.71,"Sarboday Nagar, Cachar"],
"788005":[120,298,0.18,"Berenga, Cachar"],
"788006":[147,302,1.71,"Kanakpur, Cachar"],
"788007":[120,191,1.62,"R K Mission Road, Cachar"],
"788009":[120,191,1.57,"Cossipur, Cachar"],
"788010":[120,190,1.68,"Ghungoor Kuarpar, Cachar"],
"788011":[150,371,1.54,"Harinetilla, Cachar"],
"788013":[150,218,1.89,"Saidpur, Cachar"],
"788014":[120,191,1.62,"Silchar Medical College, Cachar"],
"788015":[174,319,1.31,"Batertal, Cachar"],
"788025":[134,268,1.82,"Ganirgram PT II, Cachar"],
"788026":[154,308,1.83,"Digar Srikona, Cachar"],
"788030":[122,222,0.46,"Dayapur T E, Cachar"],
"788031":[122,222,0.46,"Dumurghat, Cachar"],
"788098":[169,418,1.05,"Sibpur, Cachar"],
"788099":[150,306,1.63,"Bhuban Valley, Cachar"],
"788101":[160,319,1.08,"Algapur, Cachar"],
"788102":[176,453,1.09,"Laboc T E, Cachar"],
"788103":[120,191,1.62,"Lakhipur S.O (Cachar, Cachar"],
"788104":[123,287,1.44,"Uttar Lalpani, Cachar"],
"788106":[157,303,1.51,"Dilkhush T E, Cachar"],
"788107":[171,312,1.77,"Baladhan T E, Cachar"],
"788108":[140,298,1.75,"Lodikachari, Dima Hasao"],
"788109":[120,191,1.62,"Kumbhirgram Airport, Cachar"],
"788110":[130,413,1.05,"Naraincherra, Cachar"],
"788111":[160,334,1.08,"Subhang, Cachar"],
"788112":[140,298,1.75,"Clever House, Cachar"],
"788113":[191,366,1.78,"Borodukan, Cachar"],
"788114":[152,256,1.86,"Debipur, Cachar"],
"788115":[156,301,1.5,"Boaljur, Cachar"],
"788116":[130,301,1.29,"Kalakhal, Cachar"],
"788117":[177,326,2.2,"Sahapur, Cachar"],
"788118":[120,191,1.62,"Silcuri, Cachar"],
"788119":[150,218,1.89,"Dhakin Mohonpur, Cachar"],
"788120":[130,238,1.69,"Lailapur, Cachar"],
"788121":[191,366,1.78,"Baromuni, Cachar"],
"788123":[164,337,2.09,"Punimukh, Cachar"],
"788126":[108,317,0.67,"Binnakandi, Cachar"],
"788127":[140,311,1.42,"Hiyairbond, Cachar"],
"788150":[189,384,1.76,"Chandipur, Hailakandi"],
"788151":[149,294,1.14,"Hailakandi, Hailakandi"],
"788152":[120,237,0.09,"Chandpur West, Hailakandi"],
"788155":[150,297,1.15,"Paikan, Hailakandi"],
"788156":[86,172,0.6,"Muktaranpur, Karimganj"],
"788160":[122,261,0.62,"Sudarshanpur, Hailakandi"],
"788161":[120,225,0.89,"Appin, Hailakandi"],
"788162":[122,261,0.62,"Sultanicherra, Hailakandi"],
"788163":[124,358,1.09,"Rongpur South, Hailakandi"],
"788164":[148,290,1.23,"Nischintapur, Hailakandi"],
"788165":[104,192,0.92,"Lalpani, Hailakandi"],
"788166":[88,171,0.12,"Kalinagar T E, Karimganj"],
"788168":[150,270,1.17,"Nimaichandpur PT II, Hailakandi"],
"788701":[142,217,2.02,"Lamajuar, Karimganj"],
"788709":[163,370,0.19,"Nayagram, Karimganj"],
"788710":[185,398,1.29,"Sribhumi, Karimganj"],
"788711":[259,538,-1,"Girishganj Bazar, Karimganj"],
"788712":[163,370,0.19,"Aylabari, Karimganj"],
"788713":[163,370,0.19,"Barkatpur, Karimganj"],
"788719":[234,527,0.45,"Mullaganj Bazar, Karimganj"],
"788720":[162,364,1.05,"Gulcherra, Karimganj"],
"788722":[201,454,0.57,"Promodenagar, Karimganj"],
"788723":[154,360,0.38,"Madandighirpar, Karimganj"],
"788724":[96,320,0.52,"Pathar Kandi Bazar, Karimganj"],
"788725":[99,225,2.5,"Kalkalighat, Karimganj"],
"788726":[82,156,0.53,"Lowairpoa, Karimganj"],
"788727":[185,398,1.29,"Bazaricherra Bazar, Karimganj"],
"788728":[77,168,0.13,"Kotamani Bazar, Karimganj"],
"788733":[96,234,0.66,"BAZARGHAT, Karimganj"],
"788734":[86,123,0.95,"Leelachela, Karimganj"],
"788735":[155,306,2.02,"Tongibari, Karimganj"],
"788736":[92,167,0.64,"Chamtilla, Karimganj"],
"788737":[209,480,0.57,"Cheragi, Karimganj"],
"788738":[92,167,0.64,"Damcherra Bagan, Karimganj"],
"788781":[201,491,0.08,"Latu, Karimganj"],
"788801":[130,244,-1,"Burnibrease T E, Hailakandi"],
"788802":[174,340,2.45,"Fulbari, Cachar"],
"788803":[160,325,1.14,"Badarpurghat, Karimganj"],
"788804":[160,331,1.1,"Gangapur, Cachar"],
"788805":[160,314,1.16,"Lathimara, Cachar"],
"788806":[160,298,0.88,"Malua, Karimganj"],
"788815":[160,427,0.4,"Karkori, Cachar"],
"788816":[160,310,0.18,"Purnagar, Cachar"],
"788817":[77,155,0.11,"Chandranathpur, Cachar"],
"788818":[133,297,1.38,"Bandarkhal, Dima Hasao"],
"788819":[153,265,1.8,"Kanabasti, Dima Hasao"],
"788820":[152,258,1.85,"Bagetar, Dima Hasao"],
"788830":[128,313,1.61,"Kholjang, Dima Hasao"],
"788832":[151,284,1.86,"Dezabra, Dima Hasao"],
"788931":[90,184,1.83,"Assam Quary, Dima Hasao"],
"790002":[135,422,2.5,"Balemu, West Kameng"],
"790003":[140,172,-1,"Jigaon, West Kameng"],
"790103":[25,45,6.34,"Khari, Pakke Kessang"],
"790114":[140,172,-1,"Elephant Flat, West Kameng"],
"790116":[152,245,0.04,"Kimi Village, West Kameng"],
"791002":[30,30,0.0,"Palling H.Q., Upper Siang"],
"791004":[30,30,0.0,"Babuk, East Siang"],
"791101":[82,159,0.44,"Bame, Leparada"],
"791102":[93,177,0.16,"Ledum, East Siang"],
"791103":[62,131,0.07,"Komsing(Karo), East Siang"],
"791104":[30,30,0.0,"Silluk, East Siang"],
"791109":[135,220,1.09,"Nirjuli, Papum Pare"],
"791110":[137,230,1.16,"Model Village, Papum Pare"],
"791111":[152,273,4.56,"Itanagar, Papum Pare"],
"791112":[85,170,6.84,"Khyate, Papum Pare"],
"791113":[86,154,4.98,"Bormai, Papum Pare"],
"791114":[86,155,4.81,"De - Dolo, Papum Pare"],
"791119":[95,172,0.12,"Yazali, Lower Subansiri"],
"791120":[178,442,0.12,"Old Ziro, Lower Subansiri"],
"791121":[138,272,0.12,"Hawa Camp, Papum Pare"],
"791123":[67,112,5.05,"Kokila, Papum Pare"],
"791125":[174,345,0.42,"Taramori, Lower Siang"],
"792001":[96,-1,0.25,"Changliang, Lohit"],
"792055":[88,100,0.44,"Two-hat, Changlang"],
"792056":[87,118,1.14,"New Mohang, Changlang"],
"792101":[30,30,0.0,"Aiso, Dibang Valley"],
"792102":[149,339,0.47,"Wakro, Lohit"],
"792103":[68,154,1.81,"Nanam, Namsai"],
"792104":[104,-1,0.26,"Chaglagam, Anjaw"],
"792105":[75,117,1.07,"Podumani, Namsai"],
"792110":[198,640,0.0,"Angrim Valley, Dibang Valley"],
"792111":[147,242,0.7,"Yealing, Lohit"],
"792120":[48,101,0.17,"Khemiyong, Changlang"],
"792121":[87,156,1.72,"Manmao, Changlang"],
"792122":[96,-1,0.22,"Deban, Changlang"],
"792123":[50,100,0.4,"Sangwal Khamlang, Changlang"],
"792124":[122,182,0.34,"KHARSANG, Papum Pare"],
"792129":[75,120,0.27,"Hukanjuri, Tirap"],
"792130":[52,106,1.57,"Kaimai, Tirap"],
"792131":[178,409,2.56,"Tissa, Longding"],
"793001":[65,105,0.48,"Shillong G.P.O., East Khasi Hills"],
"793002":[65,105,0.48,"Iewduh, East Khasi Hills"],
"793003":[67,106,0.46,"Laitumkhrah, East Khasi Hills"],
"793004":[70,108,0.43,"Lawsohtun, East Khasi Hills"],
"793005":[66,105,0.47,"Diengiei, East Khasi Hills"],
"793006":[70,108,0.44,"Umkdait, East Khasi Hills"],
"793007":[72,109,0.42,"Happy Valley, East Khasi Hills"],
"793008":[66,105,0.47,"Mawroh, East Khasi Hills"],
"793009":[66,105,0.47,"Mawklot, East Khasi Hills"],
"793010":[66,105,0.47,"Laitkor, East Khasi Hills"],
"793011":[67,106,0.46,"Assam Rifles, East Khasi Hills"],
"793012":[66,105,0.47,"Diengpasoh, East Khasi Hills"],
"793014":[66,105,0.47,"Nongthymmai, East Khasi Hills"],
"793015":[66,75,0.21,"Lynshing, East Khasi Hills"],
"793016":[66,105,0.47,"Mawiong, East Khasi Hills"],
"793017":[66,105,0.47,"Mawlai, East Khasi Hills"],
"793018":[66,105,0.47,"Neigrihms, East Khasi Hills"],
"793019":[66,105,0.47,"Nongmynsong, East Khasi Hills"],
"793021":[66,105,0.47,"Mawryngkneng, East Khasi Hills"],
"793022":[66,105,0.47,"Kynton Massar, East Khasi Hills"],
"793101":[163,354,0.43,"Killing Centre, Ri Bhoi"],
"793102":[112,283,0.0,"Lailad, Ri Bhoi"],
"793103":[112,271,0.0,"Mawlasnai, Ri Bhoi"],
"793104":[73,110,0.41,"Mawlein Mawkhan, Ri Bhoi"],
"793105":[105,267,0.0,"Mawrong, Ri Bhoi"],
"793106":[197,363,0.1,"Dholai, East Khasi Hills"],
"793107":[66,105,0.47,"Bholaganj Bazar, East Khasi Hills"],
"793108":[140,220,0.54,"Laitryngew, East Khasi Hills"],
"793109":[108,112,0.22,"Naljuri, West Jaintia Hills"],
"793110":[125,169,0.41,"Pamshutia, East Khasi Hills"],
"793111":[96,145,0.36,"Ladmawphlang, East Khasi Hills"],
"793112":[107,148,0.26,"Nongriat, East Khasi Hills"],
"793113":[120,171,0.3,"Phlangwanbroi, East Khasi Hills"],
"793114":[392,745,0.03,"Laitnongrim, South West Khasi Hills"],
"793115":[273,496,0.26,"Krang, East Khasi Hills"],
"793116":[106,266,0.0,"Sohliya Iapngar, Ri Bhoi"],
"793119":[213,397,0.66,"Kyrdum, South West Khasi Hills"],
"793120":[146,273,0.26,"Khlieh Lyngkhoi, East Khasi Hills"],
"793121":[66,105,0.47,"Mawpun, East Khasi Hills"],
"793122":[120,405,0.82,"Ucc, Ri Bhoi"],
"793123":[120,405,0.82,"Umsaw, Ri Bhoi"],
"793126":[97,123,0.17,"Nongma, West Khasi Hills"],
"793150":[46,-1,0.01,"Iawthymmai, West Jaintia Hills"],
"793151":[48,64,0.2,"Nartiang, West Jaintia Hills"],
"793160":[45,-1,0.01,"Rymbai, East Jaintia Hills"],
"793161":[90,91,0.16,"Amlari, West Jaintia Hills"],
"793200":[126,267,0.75,"Sutnga, East Jaintia Hills"],
"793210":[128,245,0.14,"Rata Cherra, East Jaintia Hills"],
"794001":[98,189,0.52,"Tura, West Garo Hills"],
"794002":[94,146,0.3,"Dajongpara, West Garo Hills"],
"794003":[109,180,0.48,"Durigre, West Garo Hills"],
"794004":[113,151,0.78,"Rimrang Bonegre, West Garo Hills"],
"794005":[120,256,0.26,"Jebalgiri, West Garo Hills"],
"794101":[91,172,0.51,"Gambarigre, West Garo Hills"],
"794102":[82,118,0.33,"Balkhalbazar, South Garo Hills"],
"794103":[101,180,0.35,"Chandabhui, West Garo Hills"],
"794104":[150,234,0.2,"Mechanpani, West Garo Hills"],
"794105":[91,166,0.63,"Okkapara, West Garo Hills"],
"794106":[207,305,0.1,"Chapahati, South West Garo Hills"],
"794107":[88,126,0.12,"Jadigitim, South Garo Hills"],
"794108":[60,73,0.16,"Thapa, North Garo Hills"],
"794109":[185,215,1.46,"Kentapara, West Garo Hills"],
"794110":[99,140,0.17,"Dabu, East Garo Hills"],
"794111":[78,94,0.43,"Samanda, East Garo Hills"],
"794112":[77,83,0.74,"Rangga, West Garo Hills"],
"794113":[120,130,1.13,"Gairong, East Garo Hills"],
"794114":[70,96,0.19,"Mohadeo Warima, South Garo Hills"],
"794115":[65,310,0.24,"Kalaichar, South West Garo Hills"],
"794116":[71,103,0.62,"Fekamari, South Salmara Mancachar"],
"795115":[155,348,1.11,"BR Colony, Jiribam"],
"795116":[178,463,1.15,"Bongmun, Jiribam"],
"795121":[137,230,1.75,"PARBUNG, Imphal West"],
"795147":[164,383,1.55,"Sekjang, Noney"],
"795150":[90,247,2.21,"Pudunamei, Senapati"],
"795160":[200,576,-1,"BR Colony, Jiribam"],
"796001":[95,195,-1,"Aizawl, Aizawl"],
"796004":[95,195,-1,"Mizoram University, Aizawl"],
"796007":[95,195,-1,"Edenthar, Aizawl"],
"796008":[95,195,-1,"Armed Veng, Aizawl"],
"796009":[105,189,-1,"Chawlhhmun, Aizawl"],
"796012":[95,195,-1,"Ramhlun, Aizawl"],
"796014":[95,195,-1,"Bawngkawn, Aizawl"],
"796015":[95,195,-1,"Muthi, Aizawl"],
"796070":[114,252,1.09,"Mualvum, Kolasib"],
"796081":[105,226,-1,"Thingdawl, Kolasib"],
"796091":[124,224,1.58,"Phaisen, Kolasib"],
"796101":[125,210,1.71,"Saiphai, Kolasib"],
"796111":[132,244,1.54,"Khawpuar, Aizawl"],
"796410":[118,288,0.98,"Mualkhang, Kolasib"],
"796421":[97,238,0.98,"Hmunpui, Mamit"],
"796431":[116,278,0.98,"Phuldungsei, Mamit"],
"796441":[95,195,-1,"Kawrtethawveng, Aizawl"],
"796470":[168,355,0.04,"Boraibazar, Aizawl"],
"796501":[93,166,-1,"Darlung, Mamit"],
"797001":[100,205,1.42,"Kohima, Kohima"],
"797002":[100,206,1.45,"Khonoma, Kohima"],
"797003":[100,205,1.41,"Chakhabama, Kohima"],
"797004":[100,206,1.41,"Meriema, Kohima"],
"797006":[88,295,2.21,"Kigwema, Kohima"],
"797099":[102,242,2.73,"Liowokha Old, Wokha"],
"797103":[98,202,1.45,"Nihekhu, Dimapur"],
"797105":[112,228,0.82,"Phekerkriema, Kohima"],
"797106":[108,230,1.93,"Jharnapani, Dimapur"],
"797109":[146,363,0.89,"Ghathashi, Zunheboto"],
"797110":[119,229,1.51,"Khelma, Peren"],
"797111":[132,341,1.06,"Sungro, Wokha"],
"797112":[90,196,0.62,"Hening Kunglwa, Peren"],
"797113":[105,189,0.46,"D. C. Complex, Dimapur"],
"797115":[90,231,0.93,"Aoyimti, Dimapur"],
"797116":[90,217,0.89,"Khehekhu, Dimapur"],
"797117":[90,218,0.94,"Pwd Colony, Dimapur"],
"797118":[90,180,1.13,"Thahekhu, Dimapur"],
"797120":[100,205,1.43,"Zubza, Kohima"],
"797121":[100,205,1.42,"Monkhola, Kohima"],
"798601":[112,227,3.91,"Chare, Tuensang"],
"798602":[108,142,2.8,"Tiru Upper, Mon"],
"798604":[63,150,5.52,"Khari, Mokokchung"],
"798607":[99,247,3.67,"Longkhum, Mokokchung"],
"798613":[85,183,4.04,"Yaongyimsen, Mokokchung"],
"798614":[108,222,4.02,"Mongsenyimti, Mokokchung"],
"798615":[87,185,4.02,"Kubulong, Mokokchung"],
"798617":[300,720,0.0,"Pungro, Kohima"],
"798618":[100,215,4.01,"Luyang Valley, Mokokchung"],
"798621":[72,106,6.74,"Longpong Senghe, Mon"],
"798622":[193,325,1.84,"Baranamsang, Mon"],
"798623":[64,163,5.21,"Anaki, Mokokchung"],
"798625":[60,114,6.32,"Yachem, Longleng"],
"798627":[60,114,6.32,"Aizuto, Zunheboto"],
"799001":[104,199,0.3,"Agartala, Nirmal"],
"799002":[104,199,0.3,"AgartalaGuard Post, West Tripura"],
"799003":[103,201,0.31,"Ishanchandranagar, West Tripura"],
"799004":[100,188,0.29,"Aralia, West Tripura"],
"799005":[118,236,0.27,"Abhoynagar, West Tripura"],
"799006":[120,240,0.27,"Bankumari E/SB, West Tripura"],
"799007":[101,187,0.26,"Banamalipur, West Tripura"],
"799008":[119,231,0.26,"Khasnoagaon, West Tripura"],
"799009":[135,276,0.2,"Lankamura, West Tripura"],
"799010":[104,199,0.3,"Agartala Secretariat, West Tripura"],
"799011":[104,199,0.3,"Jampuijala Colony, Sepahijala"],
"799012":[123,249,0.26,"Durgabari, West Tripura"],
"799013":[94,314,0.26,"Dakshin Maharani, Gomati"],
"799014":[100,194,0.29,"Agartala ONGC, West Tripura"],
"799015":[137,282,0.19,"Tebaria, West Tripura"],
"799022":[104,199,0.3,"Tripura University, West Tripura"],
"799035":[85,195,0.3,"Burakha Landless Colony, West Tripura"],
"799045":[88,262,0.46,"Champaknagar, West Tripura"],
"799046":[85,229,0.39,"NIT Agartala, West Tripura"],
"799101":[84,254,0.26,"Gamakubari, Gomati"],
"799102":[105,234,0.24,"Kalkalia, Sepahijala"],
"799103":[132,291,0.17,"Charilam, Sepahijala"],
"799104":[98,286,0.14,"Karbook, Gomati"],
"799105":[75,372,0.6,"Dhuptali, Gomati"],
"799113":[73,297,0.26,"Bagma, Gomati"],
"799114":[73,232,0.26,"Raiyabari, Gomati"],
"799115":[70,289,0.52,"Bagabassa, Sepahijala"],
"799120":[84,254,0.26,"Radhakishorepur, Gomati"],
"799125":[84,254,0.26,"Gangacherra, Gomati"],
"799130":[104,199,0.3,"Kanchanmala, West Tripura"],
"799131":[164,306,1.14,"Durgapur, Sepahijala"],
"799132":[70,311,0.9,"Maheshpur, Sepahijala"],
"799141":[75,151,0.18,"Debdaru Bazar, South Tripura"],
"799142":[84,254,0.26,"Muhuri Ratanpur, South Tripura"],
"799143":[73,325,0.11,"Bhuratali, South Tripura"],
"799144":[85,160,0.89,"Bagafa, South Tripura"],
"799145":[102,169,-1,"Chalitacherra, South Tripura"],
"799150":[84,254,0.26,"Kasari, South Tripura"],
"799153":[104,199,0.3,"Rangamura, South Tripura"],
"799155":[80,278,0.24,"Abhoyganj Bazar, South Tripura"],
"799156":[84,254,0.26,"Nalua, South Tripura"],
"799157":[84,254,0.26,"Puran Rajbari, South Tripura"],
"799201":[110,192,0.88,"Behalabari, Khowai"],
"799202":[104,199,0.3,"Khowai Court, Khowai"],
"799203":[104,199,0.3,"Durgapur, Khowai"],
"799204":[98,321,0.14,"Balarambazar, Dhalai"],
"799205":[105,373,0.58,"Ataromura, Khowai"],
"799207":[86,274,0.65,"Rajnagar Khowai, Khowai"],
"799210":[87,294,0.12,"Chechuria, West Tripura"],
"799211":[104,199,0.3,"Baikunthapur, West Tripura"],
"799212":[104,199,0.3,"Darogamura, West Tripura"],
"799250":[66,171,0.2,"Dharmanagar, North Tripura"],
"799251":[66,171,0.2,"Bakbaki, North Tripura"],
"799253":[66,170,0.17,"Dharmanagar Bazar, North Tripura"],
"799254":[105,509,-1,"Baithangbari, North Tripura"],
"799256":[95,176,0.09,"Kacharicherra, North Tripura"],
"799260":[124,215,1.67,"Agnipassa, North Tripura"],
"799261":[66,171,0.2,"Pearacherra, North Tripura"],
"799262":[77,167,0.15,"Kheranjuri, North Tripura"],
"799263":[66,171,0.2,"Ugalcherra, Unakoti"],
"799264":[100,106,0.08,"East Kanchanbari, Unakoti"],
"799266":[88,110,0.04,"West Nalkata, Dhalai"],
"799269":[98,168,-1,"Hmungchuan, North Tripura"],
"799270":[66,171,0.2,"Sibnagar, North Tripura"],
"799271":[66,171,0.2,"Barhaldi, North Tripura"],
"799273":[146,300,0.53,"Bindulal Karbaripara, Dhalai"],
"799275":[98,321,0.14,"East Masli, Dhalai"],
"799277":[66,131,0.29,"Manuvelly, Unakoti"],
"799278":[98,321,0.14,"Paschim Dalucherra, Dhalai"],
"799279":[66,171,0.2,"Zarultali, Unakoti"],
"799280":[66,171,0.2,"Birchandranagar, Unakoti"],
"799281":[66,171,0.2,"Irani, Unakoti"],
"799282":[66,171,0.2,"Chinibagan, Unakoti"],
"799284":[88,212,-1,"Jagabandhu Para, Dhalai"],
"799285":[98,321,0.14,"Garodtilla, Dhalai"],
"799286":[75,167,0.54,"Durga Chowmuhani, Dhalai"],
"799287":[98,321,0.14,"Nagbangshi, Dhalai"],
"799288":[66,171,0.2,"Ujan Dodhpur, Unakoti"],
"799289":[151,271,0.14,"Harincherra, Dhalai"],
"799290":[90,132,0.32,"Emrapassa, Unakoti"],
"800001":[212,344,-1,"Patna GPO, Patna"],
"800002":[219,360,-1,"PAKRI, Patna"],
"800003":[208,337,-1,"Kadamkuan, Patna"],
"800004":[208,347,-1,"Bankipore, Patna"],
"800005":[208,357,-1,"Patna University, Patna"],
"800006":[196,345,-1,"Mahendru, Patna"],
"800007":[210,353,-1,"Nadghat, Patna"],
"800008":[205,378,-1,"Chaughara, Patna"],
"800009":[212,366,-1,"Kothia, Patna"],
"800010":[192,325,-1,"Sadaquat Ashram, Patna"],
"800011":[314,652,5.3,"Dighaghat, Patna"],
"800012":[192,349,-1,"DIGHA, Patna"],
"800013":[219,354,-1,"Patliputra, Patna"],
"800014":[208,347,-1,"Patna Aerodrome, Patna"],
"800015":[155,307,-1,"Patna Sectt, Patna"],
"800016":[208,340,-1,"Rajendra Nagar SO Patna, Patna"],
"800017":[208,338,-1,"BSEBOARD, Patna"],
"800019":[208,339,-1,"CDA, Patna"],
"800020":[212,333,-1,"LOHIA NAGAR, Patna"],
"800021":[222,405,0.0,"Vidyut Parisad, Patna"],
"800022":[226,368,-1,"RAJ BHAWAN, Patna"],
"800023":[226,358,-1,"PATEL NAGAR, Patna"],
"800024":[101,206,0.32,"Keshari Nagar, Patna"],
"800025":[208,341,-1,"Ashiananagar, Patna"],
"800026":[208,358,-1,"KUMHRAR, Patna"],
"800027":[226,364,-1,"NEW JAGANPURA, Patna"],
"800028":[208,326,-1,"Patna High Court, Patna"],
"800030":[160,419,-1,"PAHARI, Patna"],
"800031":[180,324,-1,"Rupaspur, Patna"],
"800032":[219,369,-1,"Saristabad, Patna"],
"800033":[208,333,-1,"BSEBOARD, Patna"],
"800034":[181,337,-1,"Beur More, Patna"],
"800035":[212,348,-1,"Parsa, Patna"],
"800036":[180,350,-1,"Sadaquat Ashram, Patna"],
"801102":[190,443,-1,"BHARATPURA, Patna"],
"801103":[232,510,-1,"BAHPURA, Patna"],
"801104":[194,499,-1,"ARAP, Patna"],
"801105":[180,325,-1,"MKURJI, Patna"],
"801106":[115,235,-1,"IIT Patna Bihta, Patna"],
"801107":[137,287,-1,"Chiraura Bazar, Patna"],
"801108":[171,317,-1,"MEHDAWAN, Patna"],
"801109":[199,642,-1,"BELA TARARI, Patna"],
"801110":[198,514,-1,"CHANDHOSH, Patna"],
"801111":[101,324,-1,"SRICHANDPUR, Patna"],
"801112":[219,355,-1,"BARAH, Patna"],
"801113":[198,567,-1,"ANDA, Patna"],
"801301":[188,461,-1,"Daniawan Pendapur, Nalanda"],
"801302":[113,356,-1,"Kachiyawan, Nawada"],
"801303":[198,501,-1,"Barai, Nalanda"],
"801304":[101,346,-1,"Daniyawan, Patna"],
"801305":[101,311,-1,"Akair, Patna"],
"801306":[214,533,-1,"Kanhaiya Ganj, Nalanda"],
"801307":[172,394,-1,"Amera, Nalanda"],
"801308":[101,328,-1,"Daniyawan, Nalanda"],
"801503":[212,347,-1,"PURANA PANAPUR B.O., Patna"],
"801505":[219,369,-1,"SORAMPUR, Patna"],
"801506":[180,325,-1,"SAHAYNAGAR, Patna"],
"801507":[162,324,-1,"AIIMS, Patna"],
"802101":[350,627,-1,"Buxar, Buxar"],
"802102":[378,682,-1,"Karhshi, Buxar"],
"802103":[323,605,-1,"Mahdah, Buxar"],
"802111":[221,398,-1,"Diaman, Buxar"],
"802112":[262,420,-1,"Isharapura, Bhojpur"],
"802113":[261,460,-1,"Chhotkarajpur, Buxar"],
"802114":[362,626,-1,"Barka Sikraul, Buxar"],
"802115":[284,465,-1,"Ojha Baraon, Buxar"],
"802116":[323,584,-1,"Ahirauli, Buxar"],
"802117":[396,541,-1,"Gagaura, Buxar"],
"802118":[222,452,-1,"Upadhyapandeypur, Buxar"],
"802119":[222,430,-1,"Lakhandihara, Buxar"],
"802120":[221,407,-1,"Kharahatand, Buxar"],
"802122":[479,711,-1,"Hethua, Buxar"],
"802123":[470,739,-1,"Atrauna, Buxar"],
"802125":[268,460,-1,"Chanawath, Buxar"],
"802126":[297,452,-1,"Amsari, Buxar"],
"802127":[284,456,-1,"Rampur, Buxar"],
"802128":[418,598,-1,"Jamauli, Buxar"],
"802129":[301,461,-1,"Karsar, Buxar"],
"802130":[243,416,-1,"Dallupur, Buxar"],
"802131":[220,406,-1,"Rajpur, Buxar"],
"802132":[510,705,-1,"Akhini, Kaimur (Bhabua)"],
"802133":[221,401,-1,"Chhilhari, Buxar"],
"802134":[268,458,-1,"Bagen, Buxar"],
"802135":[222,434,-1,"Asha Parari, Buxar"],
"802136":[222,431,-1,"Khirauli, Buxar"],
"802152":[197,456,-1,"Dawan, Bhojpur"],
"802154":[206,458,-1,"Amrainawada, Bhojpur"],
"802155":[230,403,-1,"Bambhawar, Bhojpur"],
"802156":[199,452,-1,"Khajuria, Bhojpur"],
"802157":[199,495,-1,"Chhotka Sasaram, Bhojpur"],
"802158":[199,456,-1,"Bairahi, Bhojpur"],
"802159":[218,389,-1,"Rajeyan, Bhojpur"],
"802160":[202,363,-1,"Kulharia, Bhojpur"],
"802161":[195,369,-1,"Allipur, Bhojpur"],
"802162":[219,461,-1,"Masarh, Bhojpur"],
"802163":[212,352,-1,"Pachrukhia Kala, Bhojpur"],
"802164":[308,528,-1,"Baga, Bhojpur"],
"802165":[231,448,-1,"Shahjauli, Bhojpur"],
"802166":[212,477,-1,"Charghat Chanaur, Bhojpur"],
"802183":[239,457,-1,"Banahi, Bhojpur"],
"802201":[190,417,-1,"Baghi, Bhojpur"],
"802202":[205,377,-1,"Kahndani, Bhojpur"],
"802203":[270,486,-1,"Kahen, Bhojpur"],
"802204":[230,413,-1,"Narayanpur, Bhojpur"],
"802205":[270,434,-1,"Chaugain, Rohtas"],
"802206":[308,527,-1,"Dularpur, Bhojpur"],
"802207":[227,382,-1,"Barauli, Bhojpur"],
"802208":[125,305,-1,"Baruhi, Bhojpur"],
"802209":[243,409,-1,"Deo, Bhojpur"],
"802210":[239,482,-1,"Piania, Bhojpur"],
"802211":[238,377,-1,"Mednipur, Rohtas"],
"802212":[315,460,-1,"Durgadi, Rohtas"],
"802213":[280,401,-1,"Basadihan, Rohtas"],
"802214":[246,450,-1,"Gorakh Parasi, Rohtas"],
"802215":[292,708,-1,"Kharari, Rohtas"],
"802216":[248,377,-1,"Bahuara, Rohtas"],
"802217":[234,637,-1,"Manipur, Rohtas"],
"802218":[301,356,-1,"Ganj Bharsara, Rohtas"],
"802219":[159,340,-1,"Siyawak, Rohtas"],
"802220":[267,377,-1,"Sioruan, Rohtas"],
"802221":[269,394,-1,"Imirtha, Rohtas"],
"802222":[208,301,-1,"Andhari, Bhojpur"],
"802223":[221,395,-1,"Lilari, Bhojpur"],
"802224":[227,376,-1,"Sikraul Fatehpur, Bhojpur"],
"802226":[165,572,-1,"A Kala, Rohtas"],
"802301":[230,442,-1,"Arrah, Bhojpur"],
"802302":[212,439,-1,"Anaith, Bhojpur"],
"802311":[230,462,-1,"Bakhorapur, Bhojpur"],
"802312":[207,424,-1,"Bampali, Bhojpur"],
"802313":[221,436,-1,"Saraiyan, Bhojpur"],
"802314":[230,436,-1,"Birampur, Bhojpur"],
"802316":[260,484,-1,"Nathmalpur, Bhojpur"],
"802351":[219,461,-1,"Lachhutola, Bhojpur"],
"802352":[230,442,-1,"Jokta, Bhojpur"],
"803101":[271,607,-1,"Biharsharif, Nalanda"],
"803107":[240,555,-1,"Andi, Nalanda"],
"803108":[101,358,-1,"Badhauna, Nalanda"],
"803109":[277,631,-1,"Gopalpur, Nalanda"],
"803110":[198,444,-1,"Belchi, Patna"],
"803111":[255,550,-1,"Mahuri, Nalanda"],
"803113":[225,520,-1,"Andhana, Nalanda"],
"803114":[200,442,-1,"Ajanaura, Nalanda"],
"803115":[281,634,-1,"Durgapur, Nalanda"],
"803116":[272,723,-1,"Meyar, Nalanda"],
"803117":[272,718,-1,"Karjara, Nalanda"],
"803118":[232,547,-1,"Moratalab, Nalanda"],
"803119":[232,548,-1,"Punha, Nalanda"],
"803120":[225,499,-1,"Dharampur, Nalanda"],
"803121":[281,615,-1,"Ordnance Factory Rajgir, Nalanda"],
"803201":[113,347,-1,"GAURI PUNDO, Patna"],
"803202":[208,340,-1,"BHOJPUR, Nalanda"],
"803203":[210,352,-1,"NANDLALABAD, Patna"],
"803211":[150,409,-1,"Dakshinichak, Patna"],
"803212":[160,398,-1,"Karnauti, Patna"],
"803213":[146,355,-1,"Atnama, Patna"],
"803214":[183,364,-1,"Parsawan, Patna"],
"803215":[147,336,-1,"NTPC Barh, Patna"],
"803216":[272,625,-1,"Dumrawan, Nalanda"],
"803221":[147,327,-1,"Kanhaipur, Patna"],
"803301":[227,371,-1,"Rampur Dumra, Patna"],
"803302":[243,406,-1,"Sahari, Patna"],
"803303":[217,488,-1,"Aunta, Patna"],
"803306":[211,411,-1,"Samiya Kurmichak, Patna"],
"803307":[210,443,-1,"Baruane, Patna"],
"804401":[155,535,-1,"Akbarpur, Arwal"],
"804402":[140,320,-1,"Abgila, Arwal"],
"804403":[310,665,-1,"Sarwan, Arwal"],
"804404":[150,392,-1,"Bara Rahimbigha, Gaya"],
"804405":[196,714,-1,"Uber, Jehanabad"],
"804406":[196,714,-1,"Korra, Jehanabad"],
"804407":[152,386,-1,"Bauri Beldari, Jehanabad"],
"804408":[196,901,-1,"Jehanabad, Jehanabad"],
"804409":[212,398,-1,"Mehandia, Aurangabad"],
"804417":[196,714,-1,"Babhana, Jehanabad"],
"804418":[196,714,-1,"Utarsarthu, Jehanabad"],
"804419":[150,444,-1,"Bansi, Arwal"],
"804420":[195,634,-1,"Barnathu, Arwal"],
"804421":[154,482,-1,"Senari, Arwal"],
"804422":[185,657,-1,"Aira, Jehanabad"],
"804423":[265,665,0.48,"Kodmarai, Arwal"],
"804424":[196,714,-1,"Jagpura, Jehanabad"],
"804425":[196,714,-1,"Amain, Jehanabad"],
"804426":[150,526,-1,"S.P Imamganj, Arwal"],
"804427":[196,714,-1,"Bajitpur, Arwal"],
"804428":[230,418,-1,"Devkund, Arwal"],
"804429":[150,361,-1,"Injore, Arwal"],
"804432":[196,714,-1,"Bharthu, Jehanabad"],
"804435":[172,462,-1,"Turi, Gaya"],
"804451":[210,393,-1,"BARA, Patna"],
"804452":[199,641,-1,"CHARMA, Patna"],
"804453":[101,341,-1,"Akauna, Patna"],
"804454":[195,784,-1,"Jehanabad, Jehanabad"],
"805101":[198,400,-1,"Barasolapur, Nawada"],
"805102":[173,287,-1,"Sarkanda, Nawada"],
"805103":[252,439,-1,"Barat Sarai, Nawada"],
"805104":[213,349,-1,"Dermobara, Nawada"],
"805105":[232,536,-1,"Maira Barich, Nalanda"],
"805106":[156,489,-1,"D Garh Itpakwa, Nawada"],
"805107":[151,318,-1,"Mahrawan, Nawada"],
"805108":[257,550,-1,"Apsai, Nawada"],
"805109":[262,609,-1,"Aranikesopur, Nawada"],
"805110":[198,392,-1,"Nawadha, Nawada"],
"805111":[198,392,-1,"Hasapur, Nawada"],
"805112":[198,392,-1,"Diri, Nawada"],
"805113":[247,650,-1,"Belar, Nawada"],
"805114":[195,454,-1,"G B Kendua Konihar, Nawada"],
"805121":[197,342,-1,"Baksoti, Nawada"],
"805122":[195,454,-1,"Merkuri, Nawada"],
"805123":[290,529,-1,"Akaunabazar, Nawada"],
"805124":[228,395,-1,"Juri, Nawada"],
"805125":[215,394,-1,"Chamotha, Nawada"],
"805126":[195,391,-1,"Kusmuhar, Nawada"],
"805127":[191,338,-1,"Dhiraundh B.O., Nawada"],
"805128":[170,754,-1,"B Makdumpur, Gaya"],
"805129":[252,752,-1,"Arnadi, Nawada"],
"805130":[312,749,-1,"Chackwai, Nawada"],
"805131":[312,749,-1,"Ghariya, Gaya"],
"805132":[228,395,-1,"Baghibardiha, Nawada"],
"805141":[156,489,-1,"Kewaii, Nawada"],
"805142":[286,731,-1,"Chackwai, Nawada"],
"811101":[248,492,-1,"Maldah, Sheikhpura"],
"811102":[248,491,-1,"Mafo, Sheikhpura"],
"811103":[248,492,-1,"Ambari, Sheikhpura"],
"811104":[203,395,-1,"Chero, Nalanda"],
"811105":[211,430,-1,"Afni, Sheikhpura"],
"811106":[277,599,-1,"Kiranpur, Lakhisarai"],
"811107":[236,616,-1,"BBartara, Sheikhpura"],
"811112":[301,609,-1,"Loshghani, Lakhisarai"],
"811201":[250,394,-1,"Munger, Munger"],
"811202":[237,392,-1,"B M Tola, Munger"],
"811211":[270,459,-1,"Kalyanpur, Munger"],
"811212":[270,405,-1,"Amari, Munger"],
"811213":[208,552,-1,"Gobadda, Munger"],
"811214":[270,484,-1,"Safiabad, Munger"],
"811301":[232,569,-1,"Abgil Chaurama, Jamui"],
"811302":[238,601,-1,"Ganga Sarai, Lakhisarai"],
"811303":[232,455,-1,"Kiya Jori, Jamui"],
"811304":[230,655,-1,"Lohan, Sheikhpura"],
"811305":[169,591,-1,"Banpur, Jamui"],
"811306":[146,649,-1,"Baghaur, Lakhisarai"],
"811307":[146,584,-1,"Jamui, Jamui"],
"811308":[194,460,-1,"Tabha, Jamui"],
"811309":[270,388,-1,"Urain, Lakhisarai"],
"811310":[286,749,-1,"Sahoor, Lakhisarai"],
"811311":[271,771,-1,"Belari, Lakhisarai"],
"811312":[173,375,-1,"Gaura, Jamui"],
"811313":[129,551,-1,"Amrath, Jamui"],
"811314":[194,440,-1,"Dumari, Jamui"],
"811315":[169,410,-1,"Karma, Jamui"],
"811316":[150,453,-1,"Mohanpur, Jamui"],
"811317":[169,998,-1,"Baribag, Jamui"],
"812001":[170,347,-1,"Bhagalpur, Bhagalpur"],
"812002":[169,364,-1,"Sujaganj Bazar, Bhagalpur"],
"812003":[170,347,-1,"M M Ashram, Bhagalpur"],
"812004":[268,650,-1,"Fatehpur, Bhagalpur"],
"812005":[160,372,-1,"Baluachak, Bhagalpur"],
"812006":[230,510,-1,"Bhatoria, Bhagalpur"],
"812007":[169,365,-1,"T N B College, Bhagalpur"],
"813101":[170,444,-1,"Bharko, Banka"],
"813102":[321,521,-1,"Banka, Banka"],
"813103":[115,418,-1,"Auria, Banka"],
"813104":[170,445,-1,"Bagduma, Banka"],
"813105":[370,825,-1,"Badluchak, Banka"],
"813106":[170,613,-1,"Barwasini, Banka"],
"813107":[249,510,-1,"Bamdev, Banka"],
"813108":[135,408,-1,"Kapsona, Bhagalpur"],
"813109":[224,446,-1,"Chandadih, Banka"],
"813110":[169,623,-1,"Raugaon, Banka"],
"813201":[180,494,-1,"Chorgaon, Munger"],
"813202":[225,340,-1,"Rajpur, Banka"],
"813203":[198,350,-1,"Mahesh Munda, Bhagalpur"],
"813204":[218,458,-1,"Beijnathpur, Bhagalpur"],
"813205":[213,473,-1,"Batsar, Banka"],
"813206":[172,470,-1,"Itahari, Godda"],
"813207":[115,435,-1,"Bhitia, Banka"],
"813208":[327,758,-1,"Boarijore, Godda"],
"813209":[212,-1,-1,"Parshurampur, Bhagalpur"],
"813210":[180,433,-1,"Alinagear Rajpur, Bhagalpur"],
"813211":[194,411,-1,"Warsabad, Banka"],
"813212":[198,574,-1,"GERUA, Banka"],
"813213":[350,710,-1,"Kathara, Bhagalpur"],
"813214":[170,347,-1,"STP Kahalgaon, Bhagalpur"],
"813221":[205,369,-1,"Launaparsa, Munger"],
"813222":[310,667,-1,"Barani, Bhagalpur"],
"814101":[256,475,-1,"Dumka, Dumka"],
"814102":[205,429,-1,"Bariranbahiyar, Dumka"],
"814103":[233,420,-1,"Astajora, Dumka"],
"814110":[278,496,-1,"Bando Haripur, Dumka"],
"814111":[70,287,-1,"Kushchira, Pakur"],
"814112":[292,336,-1,"BDeoghar, Deoghar"],
"814113":[217,451,-1,"Kusmaha, Deoghar"],
"814114":[292,336,-1,"Gurukul Vidyapith, Deoghar"],
"814115":[292,336,-1,"Hindipith, Deoghar"],
"814116":[292,336,-1,"Satsang, Deoghar"],
"814118":[276,488,-1,"Chamrabahiar, Dumka"],
"814119":[246,443,-1,"K Baskichowk, Dumka"],
"814120":[292,336,-1,"Karma, Dumka"],
"814131":[120,435,-1,"Bank, Banka"],
"814133":[129,453,-1,"Amlo, Godda"],
"814141":[312,484,-1,"Amba Jarowadih, Dumka"],
"814142":[292,336,-1,"Dabar Gram, Deoghar"],
"814143":[292,336,-1,"AK Bad, Deoghar"],
"814144":[195,475,0.0,"Bagnal, Dumka"],
"814145":[261,422,-1,"Amarpur, Dumka"],
"814146":[230,479,-1,"Bansbutia, Deoghar"],
"814147":[227,509,-1,"Barmasiya, Godda"],
"814148":[311,477,-1,"Dumra, Dumka"],
"814149":[333,512,-1,"Bamandiha, Deoghar"],
"814150":[320,423,-1,"Lakhoria, Deoghar"],
"814151":[291,394,-1,"Chandubathan, Dumka"],
"814152":[292,336,-1,"Bhojpur, Deoghar"],
"814153":[164,385,-1,"Chatra, Godda"],
"814154":[292,610,-1,"Bharta Chak, Godda"],
"814155":[182,463,-1,"Kaitha, Godda"],
"814156":[70,287,-1,"China Dhab, Godda"],
"814157":[292,336,-1,"Chulhiya, Deoghar"],
"814158":[249,443,-1,"Amra Nawadih, Dumka"],
"814160":[291,394,-1,"Adamdour, Godda"],
"814165":[292,336,-1,"Gajanda, Godda"],
"814166":[256,489,-1,"Babanbandhi, Jamtara"],
"814167":[229,469,-1,"Bhul, Dumka"],
"814168":[232,471,-1,"Suggapahari, Dumka"],
"814170":[281,483,-1,"Hathiyapathar, Dumka"],
"815117":[303,466,-1,"Surajdih, Pakur"],
"815301":[186,350,-1,"Giridih, Giridih"],
"815302":[169,779,-1,"Baddiha, Giridih"],
"815311":[158,585,-1,"Akdonikala, Giridih"],
"815312":[138,321,-1,"Chhotki Kharagdiha, Giridih"],
"815313":[330,724,-1,"Birney, Giridih"],
"815314":[389,706,-1,"Ghoranji, Giridih"],
"815315":[159,346,-1,"Sankho, Giridih"],
"815316":[165,351,-1,"Berhabad, Giridih"],
"815317":[225,489,-1,"Gumgi, Giridih"],
"815318":[186,343,-1,"Chunglo, Giridih"],
"815351":[191,407,1.66,"Gundali Pahari, Jamtara"],
"815352":[172,343,-1,"Bagrudih, Jamtara"],
"815353":[231,469,-1,"Bamangama, Deoghar"],
"815354":[140,336,-1,"Kewatjali, Jamtara"],
"815355":[298,526,-1,"Krishnapur, Jamtara"],
"815357":[277,525,-1,"Baskupi, Deoghar"],
"815359":[166,444,0.0,"Amba, Jamtara"],
"816101":[305,636,0.42,"Atapur, Sahebganj"],
"816102":[153,451,-1,"BKadma, Sahebganj"],
"816103":[314,485,0.39,"Catupara, Pakur"],
"816104":[108,508,-1,"Dulmidanga, Pakur"],
"816105":[279,635,0.57,"Mayur Kola, Sahebganj"],
"816106":[162,360,1.85,"Bathandanga, Pakur"],
"816107":[215,447,0.36,"Chengadanga, Pakur"],
"816108":[240,650,2.05,"Choukidhab, Sahebganj"],
"816109":[272,537,-1,"Bara Madansahi, Sahebganj"],
"816110":[125,611,-1,"BB Mangladih, Sahebganj"],
"816115":[256,475,-1,"Sakrigali Ghat, Sahebganj"],
"816116":[251,577,2.01,"Jonka, Sahebganj"],
"816117":[230,570,0.39,"Balidih, Pakur"],
"816118":[329,512,0.18,"Dhaka, Dumka"],
"816120":[226,443,-1,"Hatigarah, Sahebganj"],
"816129":[264,664,1.76,"Sarkanda, Sahebganj"],
"818142":[232,627,-1,"Jhinaki, Dhanbad"],
"821015":[262,603,-1,"Khuria, Rohtas"],
"821101":[538,738,-1,"Darauli, Kaimur (Bhabua)"],
"821102":[307,544,-1,"Khajura, Kaimur (Bhabua)"],
"821103":[294,671,-1,"Mudhi, Kaimur (Bhabua)"],
"821104":[305,628,-1,"Sadokhar, Rohtas"],
"821105":[270,394,0.0,"Karari, Kaimur (Bhabua)"],
"821106":[294,600,-1,"Badauha, Kaimur (Bhabua)"],
"821107":[331,587,-1,"Gori, Rohtas"],
"821108":[370,567,-1,"Awarainya, Kaimur (Bhabua)"],
"821109":[428,663,-1,"Dangri, Kaimur (Bhabua)"],
"821110":[294,670,-1,"Kajura, Kaimur (Bhabua)"],
"821111":[248,963,-1,"Baraila, Rohtas"],
"821112":[289,474,-1,"Daidhan, Rohtas"],
"821113":[205,981,-1,"Gotpa, Rohtas"],
"821114":[207,345,0.0,"NEWRAS, Rohtas"],
"821115":[175,531,-1,"Sasaram, Rohtas"],
"821301":[95,298,-1,"Chandi, Rohtas"],
"821302":[315,510,-1,"Kacchuhar, Rohtas"],
"821303":[315,560,-1,"Banjari, Rohtas"],
"821304":[236,515,-1,"Chunhatta, Rohtas"],
"821305":[155,322,-1,"Kanchanpur, Rohtas"],
"821306":[175,373,-1,"Baraon Kala, Rohtas"],
"821307":[169,318,-1,"Dehri R S, Rohtas"],
"821308":[169,332,-1,"Nawadih, Rohtas"],
"821309":[271,464,-1,"Amaura, Rohtas"],
"821310":[271,370,-1,"Dhanaw English, Rohtas"],
"821311":[315,574,-1,"Budhua, Rohtas"],
"821312":[155,737,-1,"A Saraiya, Rohtas"],
"822101":[240,426,-1,"Daltonganj, Palamu"],
"822102":[234,363,-1,"Sua, Palamu"],
"822110":[232,345,-1,"Khura Kalan, Palamu"],
"822111":[270,344,-1,"Betla National Park, Latehar"],
"822112":[220,352,-1,"Chapri, Garhwa"],
"822113":[175,194,0.0,"Babhandih, Palamu"],
"822114":[220,352,-1,"Kalyanpur, Garhwa"],
"822115":[120,330,-1,"Bilashpur, Palamu"],
"822116":[274,689,-1,"Alinagar, Palamu"],
"822117":[217,391,-1,"Japla C F, Palamu"],
"822118":[290,551,0.48,"Bansdih, Palamu"],
"822119":[195,339,1.12,"Adhe, Latehar"],
"822120":[226,520,-1,"Belhath, Garhwa"],
"822121":[234,-1,0.0,"Adhaura, Garhwa"],
"822122":[425,485,-1,"Champi Kala, Palamu"],
"822123":[207,418,-1,"Baidakala, Palamu"],
"822124":[43,115,-1,"Kadhwan, Palamu"],
"822125":[220,352,-1,"Beta, Garhwa"],
"822126":[303,440,-1,"Khamdih, Palamu"],
"822128":[220,353,-1,"Bhagodih, Garhwa"],
"822129":[220,352,-1,"Kailan, Garhwa"],
"822131":[270,409,-1,"Semarwar, Palamu"],
"822132":[220,352,-1,"Kajru Khurd, Palamu"],
"822133":[220,352,-1,"Lagma, Palamu"],
"822134":[220,352,-1,"Chutiya, Garhwa"],
"823001":[170,399,-1,"Gaya, Gaya"],
"823002":[170,407,-1,"Churi, Gaya"],
"823003":[165,455,-1,"Sondhi, Gaya"],
"823004":[170,454,-1,"Bagadaha, Gaya"],
"823005":[170,401,-1,"Asc CentreN Gaya, Gaya"],
"823311":[195,582,-1,"Ayer, Gaya"],
"824101":[197,615,-1,"Aurangabad BH, Aurangabad"],
"824102":[315,723,0.0,"Chauria, Aurangabad"],
"824103":[315,723,0.0,"Gardi, Aurangabad"],
"824111":[315,723,0.0,"CDhongra, Aurangabad"],
"824112":[315,723,0.0,"Jagdishpur, Aurangabad"],
"824113":[315,723,0.0,"Pilchhi, Aurangabad"],
"824114":[315,723,0.0,"Malhara, Aurangabad"],
"824115":[315,723,0.0,"Sonhathoo, Aurangabad"],
"824116":[315,723,0.0,"Kathautia, Gaya"],
"824118":[150,391,-1,"Budhoul, Gaya"],
"824120":[315,723,0.0,"Bantara, Aurangabad"],
"824121":[315,723,0.0,"Deoria Kala, Aurangabad"],
"824122":[315,723,0.0,"Barahi, Aurangabad"],
"824123":[315,723,0.0,"Ankupa, Aurangabad"],
"824124":[315,723,0.0,"Dhangain, Aurangabad"],
"824125":[315,723,0.0,"Ranidih, Aurangabad"],
"824126":[230,534,-1,"Pothu, Aurangabad"],
"824127":[315,723,0.0,"Chauri, Aurangabad"],
"824129":[315,723,0.0,"Baxar, Aurangabad"],
"824143":[148,648,-1,"Agnoor, Aurangabad"],
"824201":[395,622,-1,"Bumuar, Gaya"],
"824202":[265,1088,-1,"Dadhpa, Aurangabad"],
"824203":[315,723,0.0,"Belawarish, Aurangabad"],
"824205":[210,544,-1,"Bharaunda, Gaya"],
"824206":[430,971,-1,"Phulwaria, Gaya"],
"824207":[165,489,-1,"Chechaura, Gaya"],
"824208":[315,723,0.0,"Umga, Aurangabad"],
"824209":[195,582,-1,"Maranchi, Gaya"],
"824210":[430,971,-1,"Salaiya, Gaya"],
"824211":[185,493,-1,"Dariaura, Gaya"],
"824217":[250,688,-1,"B Chaugain, Gaya"],
"824219":[247,647,-1,"Jhari, Gaya"],
"824220":[395,622,-1,"Ghoraghat, Gaya"],
"824221":[318,692,-1,"Pipra, Gaya"],
"824231":[165,455,-1,"Amwan, Gaya"],
"824232":[195,582,-1,"Manjhouli, Gaya"],
"824233":[150,389,-1,"Aima Chouki, Gaya"],
"824234":[165,455,-1,"Sahdeokhap, Gaya"],
"824235":[195,582,-1,"Mahimapur, Gaya"],
"824236":[195,582,-1,"Bhaismara Maksudpur, Gaya"],
"824237":[165,455,-1,"Phurhuriya, Gaya"],
"824301":[315,723,0.0,"ITWAN, Aurangabad"],
"824302":[315,723,0.0,"Khajuri Saraiya, Aurangabad"],
"824303":[315,723,0.0,"Ankora RS, Aurangabad"],
"824304":[221,434,-1,"NPGCL Aditi Nagar, Aurangabad"],
"825101":[125,260,-1,"Gossa, Ramgarh"],
"825102":[242,549,-1,"Palamu, Bokaro"],
"825103":[99,322,-1,"Shila, Chatra"],
"825106":[294,616,-1,"Bharkhar, Giridih"],
"825108":[125,326,-1,"Karipahari, Giridih"],
"825109":[262,584,-1,"Chaubey, Koderma"],
"825132":[173,284,-1,"Kothiar, Koderma"],
"825167":[158,509,-1,"Galagi, Giridih"],
"825301":[248,631,-1,"Hazaribagh, Hazaribagh"],
"825302":[250,580,-1,"Babhanbay, Hazaribagh"],
"825303":[250,609,-1,"Chandwar, Hazaribagh"],
"825311":[332,596,-1,"Chepakala, Hazaribagh"],
"825312":[284,508,-1,"Kharna, Hazaribagh"],
"825313":[349,441,-1,"Banahappa, Hazaribagh"],
"825314":[302,622,-1,"Banji, Ramgarh"],
"825315":[278,569,-1,"Kuruknalo, Bokaro"],
"825316":[215,546,-1,"Hesagarha, Ramgarh"],
"825317":[248,549,-1,"Jagarnath Dham, Hazaribagh"],
"825318":[359,550,-1,"Chopnadih, Koderma"],
"825319":[355,593,-1,"Pabra, Hazaribagh"],
"825320":[197,404,-1,"Koiridih, Giridih"],
"825321":[106,325,-1,"Kasiadih, Chatra"],
"825322":[289,575,-1,"Atkadih, Giridih"],
"825323":[250,625,-1,"Kalhabad, Hazaribagh"],
"825324":[323,592,-1,"Jawaharnagar, Giridih"],
"825325":[199,520,-1,"Laiyo, Ramgarh"],
"825326":[483,887,-1,"Tapin, Ramgarh"],
"825329":[283,677,-1,"Shikherjee, Giridih"],
"825330":[192,542,-1,"Chainpur, Ramgarh"],
"825336":[245,933,-1,"Hendegarha, Hazaribagh"],
"825401":[300,603,-1,"Ghanghari, Chatra"],
"825402":[230,364,-1,"Bhusai, Hazaribagh"],
"825403":[427,680,-1,"Kedlikala, Chatra"],
"825404":[308,768,-1,"Chandrikala, Chatra"],
"825405":[248,631,-1,"Pindarkon, Hazaribagh"],
"825406":[206,517,-1,"Barhmoria, Hazaribagh"],
"825407":[467,847,-1,"Sapahi, Koderma"],
"825408":[230,364,-1,"Berhna, Chatra"],
"825409":[274,602,-1,"Chandwara, Koderma"],
"825410":[470,768,-1,"Lokai, Koderma"],
"825411":[252,497,-1,"Surajpura, Hazaribagh"],
"825412":[288,687,-1,"Argali, Giridih"],
"825413":[250,641,-1,"Gurio, Koderma"],
"825414":[331,653,-1,"Khuntikewal, Chatra"],
"825415":[116,330,-1,"NTPC North Karanpura, Chatra"],
"825418":[453,789,-1,"Galwati, Koderma"],
"825421":[338,580,-1,"Koderma Thermal Power Station, Koderma"],
"826001":[232,628,-1,"Dhanbad, Dhanbad"],
"826003":[232,636,-1,"Jagjivan Nagar, Dhanbad"],
"826004":[232,627,-1,"Kalyanpur, Dhanbad"],
"826005":[240,641,-1,"BCCl Township, Dhanbad"],
"826006":[240,598,-1,"Daludih, Dhanbad"],
"826007":[232,623,-1,"Housing Colony, Dhanbad"],
"826008":[232,627,-1,"KGAshram, Dhanbad"],
"826009":[247,643,-1,"KkPolytechnic, Dhanbad"],
"826010":[232,622,-1,"BARWADDA, Dhanbad"],
"826011":[232,629,-1,"NDC DHANBAD, Dhanbad"],
"826012":[232,635,-1,"99 Koylanchal City, Dhanbad"],
"826013":[232,625,-1,"Baramuri Sub Post Office, Dhanbad"],
"827001":[220,533,-1,"Bokaro Steel City, Bokaro"],
"827003":[220,532,-1,"Sector III, Bokaro"],
"827004":[220,535,-1,"Sector IV, Bokaro"],
"827006":[220,536,-1,"SectorVI, Bokaro"],
"827009":[220,533,-1,"Baidmara, Bokaro"],
"827010":[220,525,-1,"Kunduari, Bokaro"],
"827012":[220,533,-1,"Marafari Colony, Bokaro"],
"827013":[220,534,-1,"BPindragoria, Bokaro"],
"827014":[247,520,-1,"Narkera Punarvas, Bokaro"],
"827015":[288,489,-1,"Chira Chas, Bokaro"],
"827016":[220,532,-1,"NDC B.S.CITY, Bokaro"],
"827302":[220,540,-1,"Durgapur, Bokaro"],
"828101":[232,623,-1,"Kankanee, Dhanbad"],
"828103":[224,551,-1,"Bhelatand, Dhanbad"],
"828104":[232,619,-1,"Bowakalan, Dhanbad"],
"828105":[232,609,-1,"Shramik Nagar, Dhanbad"],
"828106":[232,621,-1,"Bastacola, Dhanbad"],
"828107":[340,793,1.01,"Domgarh, Dhanbad"],
"828108":[240,573,0.93,"Fri, Dhanbad"],
"828109":[232,627,-1,"Bhitia, Dhanbad"],
"828110":[240,602,-1,"Bagdigi, Dhanbad"],
"828111":[232,616,-1,"Amtal, Dhanbad"],
"828112":[239,554,-1,"Kalimela, Dhanbad"],
"828113":[224,554,-1,"Kankomath, Dhanbad"],
"828114":[240,602,-1,"Matari, Dhanbad"],
"828115":[232,572,0.93,"Suranga, Dhanbad"],
"828116":[254,603,-1,"Balihari, Dhanbad"],
"828117":[232,603,-1,"Burragarh, Dhanbad"],
"828119":[240,570,0.93,"Patherdih, Dhanbad"],
"828120":[232,629,-1,"Motinagar SO Dhanbad, Dhanbad"],
"828121":[224,551,-1,"Chandore, Dhanbad"],
"828122":[232,560,0.93,"Sindri, Dhanbad"],
"828123":[282,753,1.01,"SIT, Dhanbad"],
"828124":[255,735,1.02,"ACC Colony, Dhanbad"],
"828125":[283,630,-1,"Jhagrahi, Dhanbad"],
"828126":[255,538,0.91,"Sudamdih, Dhanbad"],
"828127":[232,634,-1,"Saraidhela, Dhanbad"],
"828128":[283,632,-1,"Tundoo, Dhanbad"],
"828129":[232,627,-1,"Lalpur, Dhanbad"],
"828130":[232,621,-1,"BPolytechnic, Dhanbad"],
"828131":[240,592,-1,"Madhuban, Dhanbad"],
"828132":[240,569,0.93,"Patherdih Coal Washery, Dhanbad"],
"828133":[240,573,0.93,"Bhulan Bararee, Dhanbad"],
"828134":[288,542,-1,"Amdiha, Bokaro"],
"828135":[232,589,0.91,"Chasnalla, Dhanbad"],
"828142":[232,627,-1,"Ludharia, Dhanbad"],
"828201":[232,627,-1,"Baghmara, Dhanbad"],
"828202":[232,627,-1,"Merrah, Dhanbad"],
"828203":[225,482,0.79,"Rajpura, Dhanbad"],
"828204":[232,482,1.09,"Benagoria, Dhanbad"],
"828205":[232,627,-1,"Benagoria, Dhanbad"],
"828206":[210,468,0.66,"Panchet Dam, Dhanbad"],
"828207":[198,450,1.11,"Maithon Dam, Dhanbad"],
"828301":[232,627,-1,"Bhutgoria, Dhanbad"],
"828302":[240,576,0.93,"Amlabad Colliery, Dhanbad"],
"828303":[286,695,0.71,"Deogram, Bokaro"],
"828304":[240,603,-1,"Rampur, Dhanbad"],
"828305":[253,602,-1,"Pathergoria, Dhanbad"],
"828306":[232,627,-1,"Baghmara Bazar, Dhanbad"],
"828307":[283,551,-1,"MADHUBAN, Dhanbad"],
"828309":[232,619,-1,"Jitpur, Dhanbad"],
"828401":[300,631,-1,"Hariharpur, Dhanbad"],
"828402":[232,625,-1,"Dumdumi, Dhanbad"],
"828403":[259,622,-1,"Telo, Bokaro"],
"828404":[253,619,-1,"Karmatanr, Bokaro"],
"829101":[195,520,-1,"Barka Chumba, Ramgarh"],
"829102":[192,476,-1,"Teliyatu, Ramgarh"],
"829103":[195,502,-1,"Baridih, Ramgarh"],
"829104":[470,873,-1,"Amlo, Bokaro"],
"829105":[195,461,-1,"Pali, Ramgarh"],
"829106":[192,487,-1,"Deoria Bargaon, Ramgarh"],
"829107":[205,666,-1,"Guniato, Bokaro"],
"829108":[205,590,-1,"Giddi A, Ramgarh"],
"829109":[263,535,-1,"Dari, Ramgarh"],
"829110":[192,487,-1,"Banda, Ramgarh"],
"829111":[172,391,-1,"Saram, Bokaro"],
"829112":[192,498,-1,"Nerki, Bokaro"],
"829113":[255,511,-1,"Khetko, Bokaro"],
"829114":[263,501,-1,"Chalkari, Bokaro"],
"829115":[255,592,0.72,"Garri, Bokaro"],
"829116":[205,652,-1,"Kathara, Bokaro"],
"829117":[195,490,-1,"RATWE, Bokaro"],
"829118":[205,529,-1,"Patratu Diesel Colony ND, Ramgarh"],
"829119":[245,563,-1,"Shah Colony, Ramgarh"],
"829121":[90,312,-1,"Chargi, Bokaro"],
"829122":[192,487,-1,"Ramgarh Cantt, Ramgarh"],
"829123":[190,581,-1,"Champi, Bokaro"],
"829125":[210,509,-1,"Sayal, Ramgarh"],
"829126":[205,557,-1,"Sounda C, Ramgarh"],
"829127":[205,649,-1,"Bedkaro, Bokaro"],
"829128":[215,392,-1,"Hazari, Bokaro"],
"829129":[179,526,-1,"Tenughat Dam, Bokaro"],
"829130":[192,482,-1,"RAMGARH COURT, Ramgarh"],
"829131":[192,477,-1,"Src, Ramgarh"],
"829132":[88,347,-1,"Turio, Bokaro"],
"829133":[205,552,-1,"Souda Basti, Ramgarh"],
"829134":[170,521,-1,"Tirla, Ramgarh"],
"829135":[205,566,-1,"Bhurkunda, Ramgarh"],
"829143":[192,539,-1,"Bicha, Ramgarh"],
"829144":[195,559,0.86,"Birni, Bokaro"],
"829149":[211,563,-1,"TTPSLalpania, Bokaro"],
"829150":[195,516,-1,"Honhey, Ramgarh"],
"829201":[271,506,-1,"Bachra North, Chatra"],
"829202":[168,356,-1,"Amarwadih, Latehar"],
"829203":[35,138,-1,"Bari, Latehar"],
"829204":[254,410,-1,"Kerh, Latehar"],
"829205":[300,554,-1,"Chama, Ranchi"],
"829206":[215,492,-1,"Balu, Latehar"],
"829207":[215,492,-1,"Nawagarh, Latehar"],
"829208":[229,469,-1,"Lapra, Ranchi"],
"829209":[293,524,-1,"Bamne, Ranchi"],
"829210":[35,138,-1,"Churi Madhay, Ranchi"],
"829301":[288,542,-1,"Baroo, Bokaro"],
"831001":[275,458,-1,"Jamshedpur, East Singhbum"],
"831002":[275,459,-1,"Bagbera, East Singhbum"],
"831003":[275,486,-1,"Golmuri, East Singhbum"],
"831004":[275,494,-1,"Hurlung, East Singhbum"],
"831005":[283,412,-1,"Kadma, East Singhbum"],
"831006":[275,449,-1,"Jugsalai, East Singhbum"],
"831007":[275,463,-1,"Burma Mines, East Singhbum"],
"831009":[275,476,-1,"Agrico, East Singhbum"],
"831011":[283,433,-1,"Sonari SO East Singhbhum, East Singhbum"],
"831012":[275,469,-1,"Bhilaipahari, East Singhbum"],
"831013":[283,430,-1,"Adityapur, Saraikela Kharsawan"],
"831014":[283,431,-1,"NIT, Saraikela Kharsawan"],
"831015":[275,480,-1,"Gobindpur Housing Colony, East Singhbum"],
"831016":[275,477,-1,"Rahargora, East Singhbum"],
"831017":[275,496,-1,"Baridih Colony, East Singhbum"],
"831019":[275,511,-1,"Birsanagar, East Singhbum"],
"831020":[283,447,-1,"Pardih, East Singhbum"],
"831021":[275,462,-1,"Nodal Delivery Centre Jamshedpur, East Singhbum"],
"832101":[169,447,0.15,"Baragaria, East Singhbum"],
"832102":[232,508,-1,"Bengo, East Singhbum"],
"832103":[150,364,-1,"Moubhandar, East Singhbum"],
"832104":[145,348,0.25,"Parulia, East Singhbum"],
"832105":[305,549,1.14,"Sisda, East Singhbum"],
"832106":[235,498,-1,"Rakha Mines, East Singhbum"],
"832107":[275,480,-1,"Kendamundi, Saraikela Kharsawan"],
"832108":[283,410,-1,"Rapcha, Saraikela Kharsawan"],
"832109":[283,427,-1,"Adityapur Industrial Area, Saraikela Kharsawan"],
"832111":[239,501,-1,"Hartopa, East Singhbum"],
"832112":[275,589,0.18,"Beldih, East Singhbum"],
"832113":[194,520,3.7,"Jumal, East Singhbum"],
"832301":[56,141,-1,"Banasoli, East Singhbum"],
"832302":[124,251,0.21,"Bhalki, East Singhbum"],
"832303":[147,354,-1,"Asna, East Singhbum"],
"832304":[184,442,-1,"Kesharpur, East Singhbum"],
"832401":[271,414,1.3,"Otadiri, Saraikela Kharsawan"],
"832402":[291,389,-1,"Hudu, Saraikela Kharsawan"],
"832403":[313,522,0.92,"Choura, Saraikela Kharsawan"],
"832404":[196,448,-1,"Bansa, Saraikela Kharsawan"],
"833101":[279,498,-1,"Galudih, Saraikela Kharsawan"],
"833102":[156,476,-1,"Baipee, West Singhbhum"],
"833103":[150,378,-1,"Bara, West Singhbhum"],
"833104":[173,336,1.62,"Barakenduda, West Singhbhum"],
"833105":[120,482,-1,"Bhalurungi, West Singhbhum"],
"833106":[199,363,1.66,"Ghatkuri, West Singhbhum"],
"833201":[166,724,-1,"Chaibasa, West Singhbhum"],
"833202":[220,636,-1,"Asura, West Singhbhum"],
"833203":[176,338,0.22,"Barananda, West Singhbhum"],
"833204":[220,522,-1,"Barachiru, West Singhbhum"],
"833212":[144,351,0.23,"Danguaposi, West Singhbhum"],
"833213":[181,344,1.66,"Gua, West Singhbhum"],
"833214":[257,481,-1,"Barajamni, West Singhbhum"],
"833215":[244,602,-1,"Barajhinkpani, West Singhbhum"],
"833216":[196,514,-1,"Haribhanj, Saraikela Kharsawan"],
"833217":[181,332,1.66,"Jojo Camp, West Singhbhum"],
"833218":[181,315,-1,"Joteya, West Singhbhum"],
"833219":[196,667,-1,"Pathermara, Saraikela Kharsawan"],
"833220":[196,579,-1,"Dugni, Saraikela Kharsawan"],
"833221":[181,339,1.66,"DIRIBURU, West Singhbhum"],
"833222":[115,241,0.82,"Bhangaon, West Singhbhum"],
"833223":[115,259,0.88,"Meghahatuburu, West Singhbhum"],
"834001":[192,408,-1,"Ranchi GPO, Ranchi"],
"834002":[192,365,-1,"Doranda, Ranchi"],
"834003":[192,351,-1,"Hundru, Ranchi"],
"834004":[192,370,-1,"Lodhma, Ranchi"],
"834005":[211,417,-1,"Hehal, Ranchi"],
"834006":[211,463,-1,"Ichapiri, Ranchi"],
"834007":[200,383,-1,"Sail City, Ranchi"],
"834008":[211,429,-1,"Ranchi University, Ranchi"],
"834009":[120,360,-1,"Bariatu, Ranchi"],
"834010":[177,403,-1,"Tetri, Ranchi"],
"834011":[192,409,-1,"Krishnapuri S O, Ranchi"],
"834012":[165,402,-1,"Hotwar, Ranchi"],
"834013":[192,378,-1,"Nodal Delivery Centre Ranchi, Ranchi"],
"834014":[200,373,-1,"SEMBO, Ranchi"],
"835101":[200,497,-1,"Hakedag, Ranchi"],
"835102":[200,532,0.91,"Ajaygarh, Ranchi"],
"835103":[145,358,-1,"Angara, Ranchi"],
"835201":[101,152,-1,"Genmer, Simdega"],
"835202":[211,404,-1,"Dolaicha, Ranchi"],
"835203":[102,313,-1,"Asro, Ranchi"],
"835204":[132,288,-1,"Edramhatu, Ranchi"],
"835205":[285,700,-1,"Ginjothakurgaon, Ranchi"],
"835206":[227,505,0.0,"Hesag, Gumla"],
"835207":[90,496,-1,"Gumla, Gumla"],
"835208":[189,423,-1,"Icha, Gumla"],
"835209":[30,100,-1,"Sungi, Khunti"],
"835210":[60,132,-1,"Belwadag, Khunti"],
"835211":[103,167,-1,"Sahpur, Simdega"],
"835212":[68,120,-1,"Ch Munda, Simdega"],
"835213":[60,168,-1,"Chiri, Lohardaga"],
"835214":[175,522,-1,"Chakma, Ranchi"],
"835215":[170,401,-1,"Mesra, Ranchi"],
"835216":[125,166,-1,"Bandgaon, West Singhbhum"],
"835217":[185,419,-1,"Chandwe, Ranchi"],
"835218":[197,347,-1,"Dumarapath, Gumla"],
"835219":[108,335,-1,"Baredih, Ranchi"],
"835220":[67,242,-1,"Bilingbira, Gumla"],
"835221":[145,329,-1,"Dundigara, Khunti"],
"835222":[222,548,-1,"Bijjulia, Ranchi"],
"835223":[70,133,-1,"Gutbahar, Simdega"],
"835224":[150,419,-1,"Khora, Gumla"],
"835225":[185,334,-1,"Amlesha, Ranchi"],
"835226":[91,147,0.41,"Kundurmunda, Simdega"],
"835227":[50,192,-1,"Ambapakhna, Khunti"],
"835228":[57,124,-1,"Bhelwadih, Simdega"],
"835229":[88,282,-1,"Banai, Gumla"],
"835230":[147,259,0.53,"Khetli, Gumla"],
"835231":[189,375,-1,"Jamti, Gumla"],
"835232":[126,286,0.0,"Sursang, Gumla"],
"835233":[249,629,-1,"Basua, Gumla"],
"835234":[41,156,-1,"Bikwadag, Khunti"],
"835235":[70,139,-1,"Rengari, Simdega"],
"835301":[120,431,-1,"Balsota, Lohardaga"],
"835302":[107,194,-1,"Arya, Lohardaga"],
"835303":[118,346,-1,"Chinarpurio, Ranchi"],
"835325":[117,270,-1,"Akashi, Lohardaga"],
"841101":[192,449,-1,"Bharpura, Saran"],
"841201":[215,412,-1,"Jamanpura, Saran"],
"841202":[219,397,-1,"Rahampur, Saran"],
"841203":[182,253,-1,"Bakhari, Siwan"],
"841204":[255,410,-1,"Atarsan, Saran"],
"841205":[420,1666,0.57,"Bangra, Saran"],
"841206":[260,533,0.03,"Puchitikala, Saran"],
"841207":[140,412,-1,"Haraji, Saran"],
"841208":[210,364,-1,"Ekma Nautan, Saran"],
"841209":[225,416,-1,"Dumaigarh, Saran"],
"841210":[225,508,-1,"Kachnar, Siwan"],
"841211":[265,483,-1,"JBishunpura, Saran"],
"841212":[255,400,-1,"Banpura, Saran"],
"841213":[278,609,-1,"Chatra, Saran"],
"841214":[245,528,-1,"Bhatwalia, Saran"],
"841215":[265,407,-1,"Baghakol, Saran"],
"841216":[224,469,-1,"Saidpur, Saran"],
"841217":[265,368,-1,"Dumari Bujurg, Saran"],
"841218":[225,463,-1,"Pakri Mohammadpur, Saran"],
"841219":[140,410,-1,"Bhagwanpur, Saran"],
"841220":[228,377,-1,"Hussepur, Saran"],
"841221":[140,397,-1,"Basti Jalal, Saran"],
"841222":[244,408,-1,"Fursatpur, Saran"],
"841223":[220,416,-1,"Baghauna, Siwan"],
"841224":[278,676,-1,"Badar Zamin, Saran"],
"841225":[161,414,-1,"Bodha Chapra, Saran"],
"841226":[182,249,-1,"Siwan, Siwan"],
"841227":[182,245,-1,"Chanaur, Siwan"],
"841228":[182,264,-1,"Barheya, Siwan"],
"841231":[312,-1,-1,"Gaighat, Siwan"],
"841232":[242,584,-1,"BHALUAN, Siwan"],
"841233":[275,438,-1,"Jalalpur, Siwan"],
"841234":[185,352,-1,"Keotalia, Siwan"],
"841235":[182,253,-1,"Harnatar, Siwan"],
"841236":[280,429,-1,"Rampur Ke Tola, Siwan"],
"841237":[213,413,-1,"Hathura, Siwan"],
"841238":[182,253,-1,"Gohpur Bajrahia, Siwan"],
"841239":[245,748,-1,"Bargaon, Siwan"],
"841240":[210,443,-1,"Chandparsa, Siwan"],
"841241":[240,371,-1,"Badram, Siwan"],
"841242":[275,451,-1,"Choiapali, Siwan"],
"841243":[215,607,-1,"Khalwa, Siwan"],
"841244":[182,247,-1,"Siktia, Siwan"],
"841245":[250,475,-1,"Banthu Sriram, Siwan"],
"841286":[182,253,-1,"Rafipur, Siwan"],
"841287":[310,472,-1,"Pihuli, Siwan"],
"841301":[278,743,-1,"Chapra, Saran"],
"841302":[240,439,-1,"Tari, Saran"],
"841305":[269,588,-1,"Jigna Parsa, Saran"],
"841311":[272,449,-1,"Madarpur, Saran"],
"841312":[175,298,-1,"Sitabdiara, Saran"],
"841313":[245,460,-1,"GDurgapur, Saran"],
"841316":[245,566,-1,"Magaidih, Saran"],
"841401":[282,545,-1,"Jhakhra, Saran"],
"841402":[265,516,-1,"Bheldi, Saran"],
"841403":[190,416,-1,"Kamta, Saran"],
"841404":[177,433,-1,"KTBharauli, Siwan"],
"841405":[232,774,-1,"Kamalpur, Gopalganj"],
"841406":[182,253,-1,"Basaowan, Siwan"],
"841407":[260,384,-1,"Reotith, Gopalganj"],
"841408":[200,330,-1,"Barhipurgop, Siwan"],
"841409":[260,384,-1,"Baikunthpur, Gopalganj"],
"841410":[235,401,-1,"Satjora Bazar, Saran"],
"841411":[255,504,-1,"Agauthar Nanda, Saran"],
"841412":[243,548,-1,"Kahi, Saran"],
"841413":[227,673,-1,"Jogapur Kothi, Siwan"],
"841414":[270,590,-1,"Kanar Hariharpur, Saran"],
"841415":[290,580,-1,"Madhopur, Saran"],
"841416":[270,431,-1,"Chimanpura, Siwan"],
"841417":[260,441,-1,"Arna, Saran"],
"841418":[282,561,-1,"Marhowrah, Saran"],
"841419":[204,482,-1,"Bardahiya, Saran"],
"841420":[235,400,-1,"Faizullahpur, Gopalganj"],
"841421":[225,475,-1,"Gamahria, Saran"],
"841422":[210,430,-1,"Bankat, Saran"],
"841423":[150,580,-1,"Amarpura, Gopalganj"],
"841424":[242,442,-1,"Bhagwatpur, Saran"],
"841425":[185,459,-1,"Kalyanpur, Gopalganj"],
"841426":[245,405,-1,"Hussepur, Gopalganj"],
"841427":[252,484,-1,"Mungarha, Gopalganj"],
"841428":[185,488,-1,"Gopalganj, Gopalganj"],
"841434":[185,514,-1,"Bhithi, Siwan"],
"841435":[155,390,-1,"Srikalpur, Siwan"],
"841436":[215,534,-1,"Jamsar, Gopalganj"],
"841437":[238,444,-1,"Mahuwan, Gopalganj"],
"841438":[215,545,-1,"Kailgarh, Gopalganj"],
"841439":[245,714,-1,"Purandarpur, Siwan"],
"841440":[248,527,-1,"Jhirwa, Gopalganj"],
"841441":[210,435,-1,"Bhathwa, Gopalganj"],
"841442":[290,623,-1,"Deo Bahuara, Saran"],
"841443":[268,528,-1,"Narharpur, Saran"],
"841446":[155,257,-1,"Gaziapur, Siwan"],
"841447":[182,247,-1,"Lakari, Siwan"],
"841460":[265,503,-1,"Serampur, Saran"],
"841501":[202,486,-1,"Baliwan sagar, Gopalganj"],
"841502":[335,466,-1,"Santhi, Siwan"],
"841503":[220,560,-1,"Bodhachhapar, Gopalganj"],
"841504":[182,253,-1,"Admapur, Siwan"],
"841505":[185,461,-1,"Maniyara, Gopalganj"],
"841506":[210,401,-1,"Babhanbara, Siwan"],
"841507":[182,247,-1,"Bithuna, Siwan"],
"841508":[170,429,-1,"Jagdishpur, Gopalganj"],
"841509":[310,623,-1,"Panjwar, Siwan"],
"842001":[225,407,-1,"Muzaffarpur, Muzaffarpur"],
"842002":[225,409,-1,"Mushahari Farm, Muzaffarpur"],
"842003":[232,414,-1,"Maripur, Muzaffarpur"],
"842004":[240,419,-1,"Jhapaha, Muzaffarpur"],
"842005":[225,409,-1,"MIC, Muzaffarpur"],
"842006":[240,424,-1,"Dhamauli, Muzaffarpur"],
"843101":[265,496,-1,"Bashantpur Patti, Muzaffarpur"],
"843102":[310,524,-1,"Sahbajpur Puraina, Muzaffarpur"],
"843103":[240,432,-1,"Baghakhal, Muzaffarpur"],
"843104":[325,451,-1,"Bhartipur, Vaishali"],
"843105":[240,474,-1,"BBaghnagari, Muzaffarpur"],
"843106":[250,589,-1,"Rupauli, Muzaffarpur"],
"843107":[175,258,-1,"Daudpur, Muzaffarpur"],
"843108":[185,468,-1,"Dadar kolhua, Muzaffarpur"],
"843109":[225,410,-1,"BPandey, Muzaffarpur"],
"843110":[260,506,-1,"Ajijpur Chande, Vaishali"],
"843111":[240,390,-1,"BBajitpur, Muzaffarpur"],
"843112":[258,571,-1,"Bahdinpur, Muzaffarpur"],
"843113":[232,415,-1,"Bishundatpur, Muzaffarpur"],
"843114":[172,297,-1,"Baligaon Chandpura, Vaishali"],
"843115":[225,409,-1,"Mutlupur, Muzaffarpur"],
"843116":[195,368,-1,"Bhadai, Muzaffarpur"],
"843117":[195,368,-1,"Chak Shambhu, Sitamarhi"],
"843118":[225,409,-1,"Adigopalpur, Muzaffarpur"],
"843119":[240,489,-1,"Madhopur, Muzaffarpur"],
"843120":[238,424,-1,"BMuza, Muzaffarpur"],
"843121":[240,474,-1,"BBakhari, Muzaffarpur"],
"843122":[238,515,-1,"Chochahi Chapra, Muzaffarpur"],
"843123":[258,687,-1,"Amaitha, Muzaffarpur"],
"843124":[250,551,-1,"Fateha, Muzaffarpur"],
"843125":[240,422,-1,"BNijamat, Muzaffarpur"],
"843126":[238,472,-1,"Gopalpur Neora, Muzaffarpur"],
"843127":[192,590,-1,"Parsauni Nath, Muzaffarpur"],
"843128":[230,408,-1,"Chatursi, Muzaffarpur"],
"843129":[127,261,-1,"Barhad, Muzaffarpur"],
"843130":[258,542,-1,"Kanti TPS, Muzaffarpur"],
"843131":[127,204,-1,"Subhaigarh, Sitamarhi"],
"843132":[240,489,-1,"Dumari, Muzaffarpur"],
"843301":[110,274,-1,"Sitamarhi, Sitamarhi"],
"843302":[115,269,-1,"Harnahiya, Sitamarhi"],
"843311":[110,288,-1,"Partapur, Sitamarhi"],
"843312":[105,207,-1,"Rajkhand, Muzaffarpur"],
"843313":[187,383,-1,"Ashogi Purshottam, Sitamarhi"],
"843314":[104,244,-1,"BPhulwariya, Sitamarhi"],
"843315":[137,336,-1,"Bokhtha, Sitamarhi"],
"843316":[152,442,-1,"Chandauli Timha, Sitamarhi"],
"843317":[145,246,-1,"Haribela, Sitamarhi"],
"843318":[110,306,-1,"Bokhra, Sitamarhi"],
"843319":[97,289,-1,"Sujatpur, Sitamarhi"],
"843320":[65,214,-1,"BBajitpur, Sitamarhi"],
"843321":[182,266,-1,"Baraitha, Muzaffarpur"],
"843322":[115,267,-1,"Dighi, Sitamarhi"],
"843323":[132,296,-1,"Baghari, Sitamarhi"],
"843324":[110,244,-1,"Jagdar, Sitamarhi"],
"843325":[152,453,-1,"Bhulli, Sitamarhi"],
"843326":[132,335,-1,"Gaura, Sitamarhi"],
"843327":[150,290,-1,"Babhangama, Sitamarhi"],
"843328":[110,281,-1,"Baligarh, Sitamarhi"],
"843329":[235,415,-1,"S Katsari, Sheohar"],
"843330":[145,246,-1,"Kohbarawa, Sitamarhi"],
"843331":[105,224,-1,"Hanumannagar, Sitamarhi"],
"843332":[164,299,-1,"MMalinia, Sitamarhi"],
"843333":[95,253,-1,"Dhadhi, Sitamarhi"],
"843334":[187,383,-1,"Mahuawa, Sheohar"],
"843335":[187,383,-1,"Adauri, Sheohar"],
"843360":[225,409,-1,"Angoa, Muzaffarpur"],
"844101":[180,341,-1,"Hajipur, Vaishali"],
"844102":[192,343,-1,"Panapur Dharampur, Vaishali"],
"844103":[192,342,-1,"Harauli, Vaishali"],
"844111":[178,448,-1,"Bahilwara Roopnath, Muzaffarpur"],
"844112":[225,409,-1,"Mathna Mallik, Vaishali"],
"844113":[175,238,-1,"Madhopur Ram, Vaishali"],
"844114":[270,578,-1,"Bithauli, Vaishali"],
"844115":[175,238,-1,"Bishanpur Said Urf Bakarpur, Vaishali"],
"844116":[175,238,-1,"Rampur Ratnakar, Vaishali"],
"844117":[180,382,-1,"Gurmia, Vaishali"],
"844118":[175,238,-1,"Bhuwalpur Bahadurpur, Vaishali"],
"844119":[172,193,-1,"Kartahan, Vaishali"],
"844120":[260,500,-1,"Azizpur, Muzaffarpur"],
"844121":[136,287,-1,"Jalalpur, Vaishali"],
"844122":[285,625,-1,"Bakhri Dua, Vaishali"],
"844123":[208,515,-1,"Abbul Hasanpur, Vaishali"],
"844124":[130,225,-1,"Senduari, Vaishali"],
"844125":[205,309,-1,"Akhtiyarpur Paterha, Vaishali"],
"844126":[260,563,-1,"Chitrauli, Vaishali"],
"844127":[280,486,-1,"KMohan, Muzaffarpur"],
"844128":[175,238,-1,"Chakramdas, Vaishali"],
"844501":[175,238,-1,"Hargovindpur, Vaishali"],
"844502":[208,334,-1,"Bahuara, Vaishali"],
"844503":[218,298,-1,"Chakgarho Daudnagar, Vaishali"],
"844504":[215,309,-1,"Bhataulia, Vaishali"],
"844505":[285,466,-1,"Loma, Vaishali"],
"844506":[225,380,-1,"Alipur Hatta, Vaishali"],
"844507":[225,383,-1,"Rampur Bhaghel, Vaishali"],
"844508":[212,319,-1,"Chandpura Idrak, Vaishali"],
"844509":[215,396,-1,"Bajitpur Kasturi, Vaishali"],
"845101":[293,401,-1,"Manpur, Pashchim Champaran"],
"845103":[268,518,-1,"Bargo, Pashchim Champaran"],
"845104":[332,497,-1,"Dhanaha, Pashchim Champaran"],
"845105":[242,388,-1,"Bakuli, Pashchim Champaran"],
"845106":[255,419,-1,"Gobarahia Done, Pashchim Champaran"],
"845107":[305,415,-1,"Champapur Gonauli, Pashchim Champaran"],
"845301":[161,379,-1,"Auraia, Purbi Champaran"],
"845302":[210,528,-1,"Chanari, Purbi Champaran"],
"845303":[145,311,-1,"Jamunia Koraiya, Purbi Champaran"],
"845304":[145,350,-1,"Balua Tola, Purbi Champaran"],
"845305":[217,412,-1,"Jokiyari, Purbi Champaran"],
"845306":[197,356,-1,"Bhaluahia, Pashchim Champaran"],
"845307":[210,400,-1,"Behari Bankatwa, Pashchim Champaran"],
"845315":[160,310,-1,"Champapur Koiria, Purbi Champaran"],
"845401":[160,291,-1,"Motihari, Purbi Champaran"],
"845402":[145,285,-1,"Hardia, Purbi Champaran"],
"845404":[227,384,-1,"Balua Thori Bazar, Pashchim Champaran"],
"845405":[260,454,-1,"Nankardewa, Purbi Champaran"],
"845406":[212,503,-1,"Bhurkurwa, Purbi Champaran"],
"845411":[232,760,-1,"Chandrahia, Purbi Champaran"],
"845412":[170,821,-1,"Kuawa, Purbi Champaran"],
"845413":[155,488,-1,"Parsauni Wajit, Purbi Champaran"],
"845414":[212,350,-1,"Dulama, Purbi Champaran"],
"845415":[205,410,-1,"Baidnathpur, Purbi Champaran"],
"845416":[120,326,-1,"Chintamanpur, Purbi Champaran"],
"845417":[267,464,-1,"Bhada Murli, Purbi Champaran"],
"845418":[160,319,-1,"Bahlolpur, Purbi Champaran"],
"845419":[255,494,-1,"Salaha, Purbi Champaran"],
"845420":[205,407,-1,"Krishna Nagara, Purbi Champaran"],
"845422":[215,386,-1,"Kanchhedwa, Purbi Champaran"],
"845423":[272,306,-1,"Mangalpur, Purbi Champaran"],
"845424":[160,307,-1,"Naya Gaon, Purbi Champaran"],
"845425":[215,385,-1,"Bharwalia, Purbi Champaran"],
"845426":[228,598,-1,"Gawandra, Purbi Champaran"],
"845427":[235,408,-1,"Padmuker, Purbi Champaran"],
"845428":[272,330,-1,"Ajgarwa, Purbi Champaran"],
"845429":[225,359,-1,"Jhakhara, Purbi Champaran"],
"845430":[205,381,-1,"Deokulia, Purbi Champaran"],
"845431":[170,331,-1,"Kukurjari, Purbi Champaran"],
"845432":[160,320,-1,"Jasauli Jamunia, Purbi Champaran"],
"845433":[284,471,-1,"Laxmipur Pokhariya, Purbi Champaran"],
"845434":[295,393,-1,"Sikandarpur, Purbi Champaran"],
"845435":[205,390,-1,"BRTNariarwa, Purbi Champaran"],
"845436":[208,493,-1,"Madhuwahan Brit, Purbi Champaran"],
"845437":[190,386,-1,"Jaishingpur, Purbi Champaran"],
"845438":[265,431,-1,"Bettiah, Pashchim Champaran"],
"845439":[242,422,-1,"Dhum Nagar, Pashchim Champaran"],
"845440":[209,372,-1,"ParsaunaTapasi, Purbi Champaran"],
"845441":[225,332,-1,"Kotwa, Purbi Champaran"],
"845449":[215,474,-1,"Ghogha, Pashchim Champaran"],
"845450":[225,470,-1,"Gurwalia, Pashchim Champaran"],
"845451":[227,344,-1,"Gokhula, Pashchim Champaran"],
"845452":[258,479,-1,"Dumari Bazar, Pashchim Champaran"],
"845453":[250,501,-1,"Bariarwa, Pashchim Champaran"],
"845454":[225,408,-1,"Chailabhar, Pashchim Champaran"],
"845455":[227,392,-1,"Belsandi, Pashchim Champaran"],
"845456":[213,369,-1,"Chhapawa Phulwaria, Purbi Champaran"],
"845457":[195,347,-1,"Bakhari, Purbi Champaran"],
"845458":[200,363,-1,"Paharpur, Purbi Champaran"],
"845459":[225,367,-1,"Ramnagar Bankat, Pashchim Champaran"],
"846001":[124,359,-1,"Laheriasarai, Darbhanga"],
"846002":[215,283,-1,"Bahadurpur, Darbhanga"],
"846003":[228,310,-1,"MSinuara, Darbhanga"],
"846004":[169,347,-1,"Darbhanga, Darbhanga"],
"846005":[124,371,-1,"Sonhaun, Darbhanga"],
"846006":[169,353,-1,"Subhankarpur, Darbhanga"],
"846007":[124,327,-1,"Atihar, Darbhanga"],
"846008":[142,347,-1,"K D S U, Darbhanga"],
"846009":[96,303,-1,"Dhoi, Darbhanga"],
"846010":[124,327,-1,"ROHAR, Darbhanga"],
"847101":[51,113,-1,"Bhacchi, Darbhanga"],
"847102":[110,424,-1,"Barri, Madhubani"],
"847103":[126,262,-1,"Bhawanipur, Darbhanga"],
"847104":[169,199,-1,"Ashthua, Darbhanga"],
"847105":[140,349,-1,"Arga, Darbhanga"],
"847106":[111,271,-1,"Moro, Darbhanga"],
"847107":[310,500,-1,"Benibad, Darbhanga"],
"847108":[101,372,-1,"Auraha, Madhubani"],
"847109":[101,311,-1,"Mahindwar Navtoli, Madhubani"],
"847115":[118,439,-1,"Loam, Darbhanga"],
"847121":[223,413,-1,"Darima, Darbhanga"],
"847122":[130,213,-1,"Parohi, Madhubani"],
"847123":[126,308,-1,"Kathalia, Darbhanga"],
"847201":[128,307,-1,"Baigani, Darbhanga"],
"847202":[132,299,-1,"Baskatti, Darbhanga"],
"847203":[123,255,-1,"Ahilwara, Darbhanga"],
"847204":[178,333,-1,"Sherpur, Darbhanga"],
"847211":[107,279,-1,"Madhubani, Madhubani"],
"847212":[99,417,-1,"Basuara, Madhubani"],
"847213":[103,375,-1,"Shubhankarpur, Madhubani"],
"847214":[103,398,-1,"Raghunidehat, Madhubani"],
"847215":[99,418,-1,"Jitwarpur, Madhubani"],
"847222":[110,385,-1,"Nahas Rupauli, Madhubani"],
"847223":[101,308,-1,"Barhampura, Madhubani"],
"847224":[110,444,-1,"Bela, Madhubani"],
"847225":[132,365,-1,"Birpur, Madhubani"],
"847226":[110,418,-1,"Baira, Madhubani"],
"847227":[110,438,-1,"Barhmotra, Madhubani"],
"847228":[103,398,-1,"Chatra, Madhubani"],
"847229":[90,402,-1,"Dhanga, Madhubani"],
"847230":[90,419,-1,"Akaur, Madhubani"],
"847231":[101,352,-1,"Udaypur Bithwar, Madhubani"],
"847232":[103,399,-1,"Jhaloun, Madhubani"],
"847233":[128,305,-1,"Fardaha, Darbhanga"],
"847234":[88,347,-1,"Bhawanipur, Madhubani"],
"847235":[103,409,-1,"Korahiyabalha, Madhubani"],
"847236":[101,343,-1,"Bathne, Madhubani"],
"847238":[107,424,-1,"Kharaua, Madhubani"],
"847239":[110,421,-1,"Najramahmda, Madhubani"],
"847240":[101,294,-1,"Bishoul, Madhubani"],
"847301":[178,346,-1,"MSajhouti, Darbhanga"],
"847302":[110,332,-1,"Reorha, Darbhanga"],
"847303":[101,487,-1,"Garri, Darbhanga"],
"847304":[120,238,-1,"Bherwa, Madhubani"],
"847305":[200,418,-1,"Basuki Bihari, Madhubani"],
"847306":[112,332,-1,"Hariharpur, Darbhanga"],
"847307":[101,364,-1,"Katka, Darbhanga"],
"847308":[101,294,-1,"Uttra, Madhubani"],
"847337":[229,471,-1,"BParsa, Darbhanga"],
"847401":[103,341,-1,"Kulharia, Madhubani"],
"847402":[101,321,-1,"Amahi, Madhubani"],
"847403":[103,361,-1,"Behat Goth, Madhubani"],
"847404":[101,373,-1,"Harna, Madhubani"],
"847405":[123,440,-1,"Dhamsain, Darbhanga"],
"847407":[178,398,-1,"Naruar, Madhubani"],
"847408":[110,422,-1,"Belauncha, Madhubani"],
"847409":[101,308,-1,"Siswabazar, Madhubani"],
"847410":[105,413,-1,"Berma, Madhubani"],
"847411":[101,296,-1,"Barsam, Madhubani"],
"847412":[132,366,-1,"Gahuma Beria, Madhubani"],
"847421":[137,423,-1,"Basania, Madhubani"],
"847422":[134,301,-1,"Tatuar, Darbhanga"],
"847423":[107,495,-1,"Lahatta, Darbhanga"],
"847424":[105,404,-1,"Lohna, Madhubani"],
"847427":[153,318,-1,"Haripur, Darbhanga"],
"847428":[240,426,-1,"Basatwara, Darbhanga"],
"847429":[132,273,1.28,"Sinuar Gopal, Darbhanga"],
"847451":[150,265,-1,"KUNAULI, Supaul"],
"847452":[107,275,-1,"BELHA, Supaul"],
"848101":[124,248,-1,"Samastipur, Samastipur"],
"848102":[124,249,-1,"Basudeopur, Samastipur"],
"848103":[124,249,-1,"BRBCollege, Samastipur"],
"848104":[124,249,-1,"Begampur, Samastipur"],
"848113":[124,249,-1,"Singhiakhurd, Samastipur"],
"848114":[124,249,-1,"Bahadurpur, Samastipur"],
"848115":[124,249,-1,"Chandauli, Samastipur"],
"848117":[124,249,-1,"Bhataura, Samastipur"],
"848121":[124,249,-1,"Ramapur Maheshpur, Samastipur"],
"848122":[124,249,-1,"Chakpahar, Samastipur"],
"848125":[124,249,-1,"Harpur Mahmada, Samastipur"],
"848127":[124,249,-1,"Bhagwatpur, Samastipur"],
"848129":[124,249,-1,"Karpoorigram, Samastipur"],
"848130":[124,249,-1,"Motipur, Samastipur"],
"848131":[124,249,-1,"Mohiuddinpur Rajwa, Samastipur"],
"848132":[124,249,-1,"Bhagwarpur Kamla, Samastipur"],
"848133":[124,249,-1,"Sadipur, Samastipur"],
"848134":[124,249,-1,"Birnamatula, Samastipur"],
"848160":[124,249,-1,"Bajitpur Bombaiya, Samastipur"],
"848201":[290,482,-1,"Bagras, Begusarai"],
"848202":[290,482,-1,"Amaridih, Begusarai"],
"848203":[225,427,-1,"Bahadurpur, Khagaria"],
"848204":[290,482,-1,"Lakhanpatti, Begusarai"],
"848205":[124,249,-1,"Sasan, Samastipur"],
"848206":[124,249,-1,"Barra, Darbhanga"],
"848207":[124,249,-1,"Jagmohra, Samastipur"],
"848208":[124,249,-1,"Bharwari, Samastipur"],
"848209":[124,249,-1,"Harinagar, Darbhanga"],
"848210":[124,249,-1,"Arout, Samastipur"],
"848211":[124,249,-1,"Bhuswar, Samastipur"],
"848213":[124,249,-1,"Bargaon, Darbhanga"],
"848216":[124,249,-1,"Jhakhar, Samastipur"],
"848236":[124,249,-1,"Belsandi Dih, Samastipur"],
"848301":[124,249,-1,"Paroria, Samastipur"],
"848302":[124,249,-1,"Belsandi, Samastipur"],
"848501":[124,249,-1,"Chapar, Samastipur"],
"848502":[124,249,-1,"Barhauna, Samastipur"],
"848503":[124,249,-1,"Harpur Bochaha, Samastipur"],
"848504":[124,249,-1,"Chaksaho, Samastipur"],
"848505":[124,249,-1,"Ahmadpur, Samastipur"],
"848506":[124,249,-1,"Hardaspur Diara, Samastipur"],
"851101":[290,482,-1,"Begusarai, Begusarai"],
"851110":[245,398,-1,"Khamhar PO, Begusarai"],
"851111":[290,482,-1,"Lodiyahi, Begusarai"],
"851112":[240,451,-1,"MBabhangama, Begusarai"],
"851113":[290,482,-1,"Gaura, Begusarai"],
"851114":[290,482,-1,"Barauni Oil Refinery, Begusarai"],
"851115":[290,482,-1,"Barauni Urvark Nagar, Begusarai"],
"851116":[290,482,-1,"MALHIPUR, Begusarai"],
"851117":[290,482,-1,"Dumri, Begusarai"],
"851118":[290,482,-1,"Amarpur, Begusarai"],
"851120":[290,482,-1,"Tajpur, Begusarai"],
"851121":[198,439,-1,"Barkhunt, Begusarai"],
"851126":[290,482,-1,"Simaria, Begusarai"],
"851127":[290,482,-1,"Birpur, Begusarai"],
"851128":[290,482,-1,"Agapur, Begusarai"],
"851129":[290,482,-1,"Badalpura, Begusarai"],
"851130":[290,482,-1,"Rajakpur, Begusarai"],
"851131":[290,482,-1,"Chhapki, Begusarai"],
"851132":[290,482,-1,"Mehdasahpur, Begusarai"],
"851133":[290,482,-1,"Banwaripur, Begusarai"],
"851134":[290,481,-1,"Kamruddinpur, Begusarai"],
"851135":[290,482,-1,"Bihat, Begusarai"],
"851201":[225,427,-1,"Borney, Khagaria"],
"851202":[225,427,-1,"Borna, Khagaria"],
"851203":[225,427,-1,"Araria Balha, Khagaria"],
"851204":[225,427,-1,"Bachauta, Khagaria"],
"851205":[225,427,-1,"Marar, Khagaria"],
"851206":[264,442,-1,"Jogia B.O (Alauli S.O), Khagaria"],
"851210":[290,482,-1,"Noorpur, Begusarai"],
"851211":[290,482,-1,"Bishanpur, Begusarai"],
"851212":[225,427,-1,"Bandehra, Khagaria"],
"851213":[225,427,-1,"Pakrail, Khagaria"],
"851214":[225,427,-1,"Amni, Khagaria"],
"851215":[225,427,-1,"Dumaria Khurd, Khagaria"],
"851216":[225,427,-1,"Lagar, Khagaria"],
"851217":[290,482,-1,"Panchbir, Begusarai"],
"851218":[290,482,-1,"Laruara, Begusarai"],
"852101":[280,401,-1,"Fatehpur, Madhepura"],
"852105":[150,476,-1,"Phulwaria, Supaul"],
"852106":[225,402,-1,"Balwahat, Saharsa"],
"852107":[215,386,-1,"MKahra, Saharsa"],
"852108":[175,263,-1,"Herdi, Supaul"],
"852109":[150,476,-1,"Mahadeo Asthan, Supaul"],
"852110":[150,476,-1,"Ekma, Supaul"],
"852111":[150,476,-1,"Sahpur Prithbi Patti, Supaul"],
"852112":[280,401,-1,"Bhatni, Madhepura"],
"852113":[280,401,-1,"Bhagwanpur, Madhepura"],
"852114":[280,401,-1,"Belari, Madhepura"],
"852115":[280,401,-1,"Peernagar, Madhepura"],
"852116":[280,401,-1,"Durgapur, Madhepura"],
"852121":[280,401,-1,"Arraha, Madhepura"],
"852122":[280,401,-1,"Hareshwari Dighi, Madhepura"],
"852123":[225,402,-1,"Mohanpur, Saharsa"],
"852124":[225,402,-1,"Aran, Saharsa"],
"852125":[150,476,-1,"Gonaha, Supaul"],
"852126":[225,402,-1,"Alani, Saharsa"],
"852127":[225,402,-1,"Ghordaur, Saharsa"],
"852128":[280,401,-1,"Barahi Hasanpur, Madhepura"],
"852129":[225,403,-1,"Dehad, Saharsa"],
"852130":[150,476,-1,"Balha, Supaul"],
"852131":[152,426,-1,"Supaul, Supaul"],
"852132":[280,401,-1,"Jirwa, Madhepura"],
"852133":[280,384,-1,"Ganaura, Supaul"],
"852134":[208,386,-1,"Ghuran, Supaul"],
"852137":[155,237,-1,"Chunnimal, Supaul"],
"852138":[129,448,-1,"Bauraha, Supaul"],
"852139":[150,476,-1,"Latauna, Supaul"],
"852161":[225,427,-1,"Pansalwa, Khagaria"],
"852201":[225,418,-1,"Saharsa, Saharsa"],
"852202":[225,402,-1,"Dhamsena, Saharsa"],
"852212":[225,403,-1,"Chainpur, Saharsa"],
"852213":[280,401,-1,"Bansgopal, Madhepura"],
"852214":[150,476,-1,"Bishanpur, Supaul"],
"852215":[150,239,-1,"Dumari, Supaul"],
"852216":[250,470,-1,"Telwa, Saharsa"],
"852217":[225,402,-1,"Jalsima, Saharsa"],
"852218":[175,263,-1,"Dinapatti, Supaul"],
"852219":[280,401,-1,"Bajraha, Madhepura"],
"852220":[212,390,-1,"Naya Nagar, Madhepura"],
"852221":[225,402,-1,"Garhia Vijaypur, Saharsa"],
"853201":[542,779,-1,"Milki, Bhagalpur"],
"853202":[280,429,-1,"Kaluchak Bispuria, Bhagalpur"],
"853203":[190,308,-1,"Bharatkhand dyorhi, Bhagalpur"],
"853204":[175,298,-1,"Abhiya bazar, Bhagalpur"],
"853205":[311,653,-1,"Kamlakund, Bhagalpur"],
"854101":[220,387,-1,"Chandpur, Katihar"],
"854102":[170,306,-1,"Ekraha, Purnia"],
"854103":[175,324,-1,"SIRNEA, Katihar"],
"854104":[122,406,-1,"BISHANPUR, Katihar"],
"854105":[175,319,-1,"Katihar, Katihar"],
"854106":[220,712,-1,"B SIMARIA, Katihar"],
"854107":[200,690,1.52,"BUDH NAGAR, Katihar"],
"854108":[175,381,-1,"SISIYA, Katihar"],
"854109":[205,454,-1,"Katihar Court, Katihar"],
"854110":[130,330,-1,"Morsanda, Katihar"],
"854112":[231,390,-1,"Gopalpur Diara, Katihar"],
"854113":[175,341,-1,"Dilarpur, Katihar"],
"854114":[229,353,-1,"Pirmokam, Katihar"],
"854115":[122,414,-1,"Binjee, Katihar"],
"854116":[175,316,-1,"Gauripur, Katihar"],
"854117":[258,562,-1,"Neema, Katihar"],
"854201":[197,327,-1,"Balua Kachahari, Purnia"],
"854202":[80,407,-1,"Dharhara Millik, Purnia"],
"854203":[122,418,-1,"Bhatsara, Purnia"],
"854204":[138,327,-1,"Bardela, Purnia"],
"854205":[165,323,-1,"Banshi Purandaha, Purnia"],
"854301":[75,415,-1,"Purnea, Purnia"],
"854302":[75,459,-1,"Purnea City, Purnia"],
"854303":[70,386,-1,"BKAsthan, Purnia"],
"854304":[122,404,-1,"Farkia, Araria"],
"854305":[75,504,-1,"Khuskibagh, Purnia"],
"854306":[80,407,-1,"Zianganj, Purnia"],
"854311":[283,427,-1,"Araria Bairgachhi, Araria"],
"854312":[238,361,-1,"Karankia, Araria"],
"854315":[157,336,-1,"Amour, Purnia"],
"854316":[105,186,-1,"Bhadeshwar, Araria"],
"854317":[175,324,-1,"B BALRAMPUR, Katihar"],
"854318":[170,287,-1,"B Rampur, Araria"],
"854325":[202,348,-1,"Chainpur, Purnia"],
"854326":[75,500,-1,"Mahalbari, Purnia"],
"854327":[155,309,-1,"Tarauna, Purnia"],
"854328":[229,353,-1,"Maheshwari, Araria"],
"854329":[216,428,-1,"Dalmalpur, Araria"],
"854330":[165,380,-1,"Bara Idagah, Purnia"],
"854331":[156,264,-1,"Jamua, Araria"],
"854332":[250,380,-1,"Amgachhi, Araria"],
"854333":[292,475,-1,"Balua kaliaganj, Araria"],
"854334":[202,317,-1,"Mirjapur Kothi, Araria"],
"854335":[185,297,-1,"Pithoura, Araria"],
"854336":[178,325,-1,"Basmatia, Araria"],
"854337":[75,343,-1,"Hasanganj, Purnia"],
"854338":[207,469,-1,"Saheban, Supaul"],
"854339":[150,476,-1,"Bhimpur, Supaul"],
"854340":[150,476,-1,"Basantpur, Supaul"],
"855101":[145,301,-1,"Bangama, Kishanganj"],
"855102":[175,324,-1,"KHIDIRPUR, Katihar"],
"855105":[190,343,-1,"CHANDPUR, Katihar"],
"855106":[212,387,-1,"Galgalia, Kishanganj"],
"855107":[145,301,-1,"BELWA, Kishanganj"],
"855108":[170,224,0.0,"SARAIKURI, Kishanganj"],
"855113":[212,263,-1,"Azamnagar, Katihar"],
"855114":[175,324,-1,"Bijaili, Katihar"],
"855115":[122,422,-1,"Dohar B.O., Kishanganj"],
"855116":[175,746,0.14,"Piprithan, Kishanganj"],
"855117":[212,387,-1,"Chanamana, Kishanganj"],
"900056":[265,1100,0.25,"1CBPO, Kushi Nagar"],
"900099":[275,811,1.07,"2CBPO, Kolkata"]
};
